(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[92888],{

/***/ 8678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ makePublicApi; },
/* harmony export */   "y": function() { return /* binding */ defineGlobal; }
/* harmony export */ });
/* harmony import */ var _tools_catchUserErrors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40812);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64933);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);



function makePublicApi(stub) {
    var publicApi = (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)({
        version: "5.4.0",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return _tools_monitor__WEBPACK_IMPORTED_MODULE_1__/* .setDebugMode */ .yD;
        },
        enumerable: false,
    });
    return publicApi;
}
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return (0,_tools_catchUserErrors__WEBPACK_IMPORTED_MODULE_2__/* .catchUserErrors */ .Z)(fn, 'onReady callback threw an error:')(); });
    }
}
//# sourceMappingURL=init.js.map

/***/ }),

/***/ 83206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EZ": function() { return /* binding */ DOM_EVENT; },
/* harmony export */   "Oo": function() { return /* binding */ addEventListener; },
/* harmony export */   "yw": function() { return /* binding */ addEventListeners; }
/* harmony export */ });
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64933);
/* harmony import */ var _tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);


// We want to use a real enum (i.e. not a const enum) here, to be able to iterate over it to automatically add _ddIsTrusted in e2e tests
// eslint-disable-next-line no-restricted-syntax
var DOM_EVENT;
(function (DOM_EVENT) {
    DOM_EVENT["BEFORE_UNLOAD"] = "beforeunload";
    DOM_EVENT["CLICK"] = "click";
    DOM_EVENT["DBL_CLICK"] = "dblclick";
    DOM_EVENT["KEY_DOWN"] = "keydown";
    DOM_EVENT["LOAD"] = "load";
    DOM_EVENT["POP_STATE"] = "popstate";
    DOM_EVENT["SCROLL"] = "scroll";
    DOM_EVENT["TOUCH_START"] = "touchstart";
    DOM_EVENT["TOUCH_END"] = "touchend";
    DOM_EVENT["TOUCH_MOVE"] = "touchmove";
    DOM_EVENT["VISIBILITY_CHANGE"] = "visibilitychange";
    DOM_EVENT["PAGE_SHOW"] = "pageshow";
    DOM_EVENT["FREEZE"] = "freeze";
    DOM_EVENT["RESUME"] = "resume";
    DOM_EVENT["DOM_CONTENT_LOADED"] = "DOMContentLoaded";
    DOM_EVENT["POINTER_DOWN"] = "pointerdown";
    DOM_EVENT["POINTER_UP"] = "pointerup";
    DOM_EVENT["POINTER_CANCEL"] = "pointercancel";
    DOM_EVENT["HASH_CHANGE"] = "hashchange";
    DOM_EVENT["PAGE_HIDE"] = "pagehide";
    DOM_EVENT["MOUSE_DOWN"] = "mousedown";
    DOM_EVENT["MOUSE_UP"] = "mouseup";
    DOM_EVENT["MOUSE_MOVE"] = "mousemove";
    DOM_EVENT["FOCUS"] = "focus";
    DOM_EVENT["BLUR"] = "blur";
    DOM_EVENT["CONTEXT_MENU"] = "contextmenu";
    DOM_EVENT["RESIZE"] = "resize";
    DOM_EVENT["CHANGE"] = "change";
    DOM_EVENT["INPUT"] = "input";
    DOM_EVENT["PLAY"] = "play";
    DOM_EVENT["PAUSE"] = "pause";
    DOM_EVENT["SECURITY_POLICY_VIOLATION"] = "securitypolicyviolation";
    DOM_EVENT["SELECTION_CHANGE"] = "selectionchange";
    DOM_EVENT["STORAGE"] = "storage";
})(DOM_EVENT || (DOM_EVENT = {}));
/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(configuration, eventTarget, eventName, listener, options) {
    return addEventListeners(configuration, eventTarget, [eventName], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(configuration, eventTarget, eventNames, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var listenerWithMonitor = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(function (event) {
        if (!event.isTrusted && !event.__ddIsTrusted && !configuration.allowUntrustedEvents) {
            return;
        }
        if (once) {
            stop();
        }
        listener(event);
    });
    var options = passive ? { capture: capture, passive: passive } : capture;
    var add = (0,_tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__/* .getZoneJsOriginalValue */ .I)(eventTarget, 'addEventListener');
    eventNames.forEach(function (eventName) { return add.call(eventTarget, eventName, listenerWithMonitor, options); });
    function stop() {
        var remove = (0,_tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__/* .getZoneJsOriginalValue */ .I)(eventTarget, 'removeEventListener');
        eventNames.forEach(function (eventName) { return remove.call(eventTarget, eventName, listenerWithMonitor, options); });
    }
    return {
        stop: stop,
    };
}
//# sourceMappingURL=addEventListener.js.map

/***/ }),

/***/ 49647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; },
/* harmony export */   "OC": function() { return /* binding */ getInitCookie; },
/* harmony export */   "kT": function() { return /* binding */ deleteCookie; },
/* harmony export */   "oX": function() { return /* binding */ areCookiesAuthorized; },
/* harmony export */   "WQ": function() { return /* binding */ getCurrentSite; }
/* harmony export */ });
/* unused harmony export resetInitCookies */
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13842);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25026);
/* harmony import */ var _tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88129);



function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure);
}
function getCookie(name) {
    return (0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .findCommaSeparatedValue */ .MY)(document.cookie, name);
}
var initCookieParsed;
/**
 * Returns a cached value of the cookie. Use this during SDK initialization (and whenever possible)
 * to avoid accessing document.cookie multiple times.
 */
function getInitCookie(name) {
    if (!initCookieParsed) {
        initCookieParsed = (0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .findCommaSeparatedValues */ .kq)(document.cookie);
    }
    return initCookieParsed.get(name);
}
function resetInitCookies() {
    initCookieParsed = undefined;
}
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat((0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .generateUUID */ .DO)());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .ONE_MINUTE */ .yR, options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        _tools_display__WEBPACK_IMPORTED_MODULE_2__/* .display.error */ .jf.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat((0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .generateUUID */ .DO)());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .ONE_SECOND */ .WT, { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
//# sourceMappingURL=cookie.js.map

/***/ }),

/***/ 18679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ initFetchObservable; }
/* harmony export */ });
/* harmony import */ var _tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55801);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64933);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73473);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25026);
/* harmony import */ var _tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70170);





var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
function createFetchObservable() {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function () {
        if (!window.fetch) {
            return;
        }
        var stop = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethod */ .Su)(window, 'fetch', function (originalFetch) {
            return function (input, init) {
                var responsePromise;
                var context = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .callMonitored */ .L6)(beforeSend, null, [observable, input, init]);
                if (context) {
                    // casting should be `RequestInfo` but node types are ahead of DOM types, making `typecheck test/e2e` fail.
                    // it should be resolved with https://github.com/microsoft/TypeScript-DOM-lib-generator/issues/1483
                    responsePromise = originalFetch.call(this, context.input, context.init);
                    (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .callMonitored */ .L6)(afterSend, null, [observable, responsePromise, context]);
                }
                else {
                    responsePromise = originalFetch.call(this, input, init);
                }
                return responsePromise;
            };
        }).stop;
        return stop;
    });
    return observable;
}
function beforeSend(observable, input, init) {
    var methodFromParams = (init && init.method) || (input instanceof Request && input.method);
    var method = methodFromParams ? methodFromParams.toUpperCase() : 'GET';
    var url = input instanceof Request ? input.url : (0,_tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_3__/* .normalizeUrl */ .D5)(String(input));
    var startClocks = (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_4__/* .clocksNow */ .$I)();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    return context;
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'resolve';
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
        }
        observable.notify(context);
    };
    responsePromise.then((0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(reportFetch), (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(reportFetch));
}
//# sourceMappingURL=fetchObservable.js.map

/***/ }),

/***/ 9024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k$": function() { return /* binding */ PageExitReason; },
/* harmony export */   "Pd": function() { return /* binding */ createPageExitObservable; },
/* harmony export */   "PT": function() { return /* binding */ isPageExitReason; }
/* harmony export */ });
/* harmony import */ var _tools_experimentalFeatures__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57549);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73473);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94776);
/* harmony import */ var _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(251);
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83206);





var PageExitReason = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    PAGEHIDE: 'page_hide',
    FROZEN: 'page_frozen',
};
function createPageExitObservable(configuration) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function () {
        var pagehideEnabled = (0,_tools_experimentalFeatures__WEBPACK_IMPORTED_MODULE_1__/* .isExperimentalFeatureEnabled */ .W_)(_tools_experimentalFeatures__WEBPACK_IMPORTED_MODULE_1__/* .ExperimentalFeature.PAGEHIDE */ .uh.PAGEHIDE);
        var stopListeners = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .addEventListeners */ .yw)(configuration, window, [_addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.VISIBILITY_CHANGE */ .EZ.VISIBILITY_CHANGE, _addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.FREEZE */ .EZ.FREEZE, _addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.PAGE_HIDE */ .EZ.PAGE_HIDE], function (event) {
            if (event.type === _addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.PAGE_HIDE */ .EZ.PAGE_HIDE && pagehideEnabled) {
                /**
                 * Only event that detect page unload events while being compatible with the back/forward cache (bfcache)
                 */
                observable.notify({ reason: PageExitReason.PAGEHIDE });
            }
            else if (event.type === _addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.VISIBILITY_CHANGE */ .EZ.VISIBILITY_CHANGE && document.visibilityState === 'hidden') {
                /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */
                observable.notify({ reason: PageExitReason.HIDDEN });
            }
            else if (event.type === _addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.FREEZE */ .EZ.FREEZE) {
                /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */
                observable.notify({ reason: PageExitReason.FROZEN });
            }
        }, { capture: true }).stop;
        var stopBeforeUnloadListener = _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_3__/* .noop */ .Z;
        if (!pagehideEnabled) {
            stopBeforeUnloadListener = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .addEventListener */ .Oo)(configuration, window, _addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.BEFORE_UNLOAD */ .EZ.BEFORE_UNLOAD, function () {
                observable.notify({ reason: PageExitReason.UNLOADING });
            }).stop;
        }
        return function () {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
    return observable;
}
function isPageExitReason(reason) {
    return (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__/* .includes */ .q9)((0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__/* .objectValues */ .TT)(PageExitReason), reason);
}
//# sourceMappingURL=pageExitObservable.js.map

/***/ }),

/***/ 5343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ initXhrObservable; }
/* harmony export */ });
/* harmony import */ var _tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55801);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73473);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25026);
/* harmony import */ var _tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70170);
/* harmony import */ var _tools_utils_objectUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94162);
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83206);






var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable(configuration) {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable(configuration);
    }
    return xhrObservable;
}
function createXhrObservable(configuration) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function () {
        var stopInstrumentingStart = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethodAndCallOriginal */ .Lm)(XMLHttpRequest.prototype, 'open', {
            before: openXhr,
        }).stop;
        var stopInstrumentingSend = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethodAndCallOriginal */ .Lm)(XMLHttpRequest.prototype, 'send', {
            before: function () {
                sendXhr.call(this, configuration, observable);
            },
        }).stop;
        var stopInstrumentingAbort = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethodAndCallOriginal */ .Lm)(XMLHttpRequest.prototype, 'abort', {
            before: abortXhr,
        }).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
    return observable;
}
function openXhr(method, url) {
    xhrContexts.set(this, {
        state: 'open',
        method: method.toUpperCase(),
        url: (0,_tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_2__/* .normalizeUrl */ .D5)(String(url)),
    });
}
function sendXhr(configuration, observable) {
    var _this = this;
    var context = xhrContexts.get(this);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startClocks = (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .clocksNow */ .$I)();
    startContext.isAborted = false;
    startContext.xhr = this;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethodAndCallOriginal */ .Lm)(this, 'onreadystatechange', {
        before: function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                // Try to report the XHR as soon as possible, because the XHR may be mutated by the
                // application during a future event. For example, Angular is calling .abort() on
                // completed requests during an onreadystatechange event, so the status becomes '0'
                // before the request is collected.
                onEnd();
            }
        },
    }).stop;
    var onEnd = function () {
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .elapsed */ ._J)(startContext.startClocks.timeStamp, (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .timeStampNow */ .n$)());
        completeContext.status = _this.status;
        observable.notify((0,_tools_utils_objectUtils__WEBPACK_IMPORTED_MODULE_4__/* .shallowClone */ .mv)(completeContext));
    };
    var unsubscribeLoadEndListener = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_5__/* .addEventListener */ .Oo)(configuration, this, 'loadend', onEnd).stop;
    observable.notify(startContext);
}
function abortXhr() {
    var context = xhrContexts.get(this);
    if (context) {
        context.isAborted = true;
    }
}
//# sourceMappingURL=xhrObservable.js.map

/***/ }),

/***/ 59665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jj": function() { return /* binding */ DefaultPrivacyLevel; },
  "JZ": function() { return /* binding */ serializeConfiguration; },
  "fP": function() { return /* binding */ validateAndBuildConfiguration; }
});

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/catchUserErrors.js
var catchUserErrors = __webpack_require__(40812);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(57549);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(73603);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(51962);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(94162);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(94776);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js + 6 modules
var sessionStore = __webpack_require__(43691);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/urlPolyfill.js
var urlPolyfill = __webpack_require__(70170);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
var stringUtils = __webpack_require__(88129);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var intakeSites = __webpack_require__(11095);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/endpointBuilder.js





function createEndpointBuilder(initConfiguration, trackType, configurationTags) {
    var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
    return {
        build: function (api, payload) {
            var parameters = buildEndpointParameters(initConfiguration, trackType, configurationTags, api, payload);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(''),
        trackType: trackType,
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
    var path = "/api/v2/".concat(trackType);
    var proxy = initConfiguration.proxy;
    if (typeof proxy === 'string') {
        var normalizedProxyUrl_1 = (0,urlPolyfill/* normalizeUrl */.D5)(proxy);
        return function (parameters) { return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters))); };
    }
    if (typeof proxy === 'function') {
        return function (parameters) { return proxy({ path: path, parameters: parameters }); };
    }
    var host = buildEndpointHost(initConfiguration);
    return function (parameters) { return "https://".concat(host).concat(path, "?").concat(parameters); };
}
function buildEndpointHost(initConfiguration) {
    var _a = initConfiguration.site, site = _a === void 0 ? intakeSites/* INTAKE_SITE_US1 */.D_ : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (internalAnalyticsSubdomain && site === intakeSites/* INTAKE_SITE_US1 */.D_) {
        return "".concat(internalAnalyticsSubdomain, ".").concat(intakeSites/* INTAKE_SITE_US1 */.D_);
    }
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    return "browser-intake-".concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_a, trackType, configurationTags, api, _b) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var retry = _b.retry, flushReason = _b.flushReason, encoding = _b.encoding;
    var tags = ["sdk_version:".concat("5.4.0"), "api:".concat(api)].concat(configurationTags);
    if (flushReason && (0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.COLLECT_FLUSH_REASON */.uh.COLLECT_FLUSH_REASON)) {
        tags.push("flush_reason:".concat(flushReason));
    }
    if (retry) {
        tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    }
    var parameters = [
        'ddsource=browser',
        "ddtags=".concat(encodeURIComponent(tags.join(','))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("5.4.0")),
        'dd-evp-origin=browser',
        "dd-request-id=".concat((0,stringUtils/* generateUUID */.DO)()),
    ];
    if (encoding) {
        parameters.push("dd-evp-encoding=".concat(encoding));
    }
    if (trackType === 'rum') {
        parameters.push("batch_time=".concat((0,timeUtils/* timeStampNow */.n$)()));
    }
    if (internalAnalyticsSubdomain) {
        parameters.reverse();
    }
    return parameters.join('&');
}
//# sourceMappingURL=endpointBuilder.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/tags.js

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        display/* display.warn */.jf.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
//# sourceMappingURL=tags.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/transportConfiguration.js




function computeTransportConfiguration(initConfiguration) {
    var tags = buildTags(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeUrlPrefixes = (0,polyfills/* objectValues */.TT)(endpointBuilders).map(function (builder) { return builder.urlPrefix; });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
    return (0,polyfills/* assign */.f0)({
        isIntakeUrl: function (url) { return intakeUrlPrefixes.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
        site: initConfiguration.site || intakeSites/* INTAKE_SITE_US1 */.D_,
    }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'replay', tags),
    };
}
function computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = (0,polyfills/* assign */.f0)({}, initConfiguration, {
        site: intakeSites/* INTAKE_SITE_US1 */.D_,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum', tags),
    };
    intakeUrlPrefixes.push.apply(intakeUrlPrefixes, (0,polyfills/* objectValues */.TT)(replicaEndpointBuilders).map(function (builder) { return builder.urlPrefix; }));
    return (0,polyfills/* assign */.f0)({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}
//# sourceMappingURL=transportConfiguration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js










var DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
function validateAndBuildConfiguration(initConfiguration) {
    var _a, _b, _c;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display/* display.error */.jf.error('Client Token is not configured, we will not send any data.');
        return;
    }
    if (initConfiguration.sessionSampleRate !== undefined && !(0,numberUtils/* isPercentage */.zz)(initConfiguration.sessionSampleRate)) {
        display/* display.error */.jf.error('Session Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !(0,numberUtils/* isPercentage */.zz)(initConfiguration.telemetrySampleRate)) {
        display/* display.error */.jf.error('Telemetry Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetryConfigurationSampleRate !== undefined &&
        !(0,numberUtils/* isPercentage */.zz)(initConfiguration.telemetryConfigurationSampleRate)) {
        display/* display.error */.jf.error('Telemetry Configuration Sample Rate should be a number between 0 and 100');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    if (Array.isArray(initConfiguration.enableExperimentalFeatures)) {
        (0,experimentalFeatures/* addExperimentalFeatures */.vn)(initConfiguration.enableExperimentalFeatures.filter(function (flag) {
            return (0,objectUtils/* objectHasValue */.E5)(experimentalFeatures/* ExperimentalFeature */.uh, flag);
        }));
    }
    return (0,polyfills/* assign */.f0)({
        beforeSend: initConfiguration.beforeSend && (0,catchUserErrors/* catchUserErrors */.Z)(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        sessionStoreStrategyType: (0,sessionStore/* selectSessionStoreStrategyType */.hB)(initConfiguration),
        sessionSampleRate: (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        allowUntrustedEvents: !!initConfiguration.allowUntrustedEvents,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * byteUtils/* ONE_KIBI_BYTE */.Hi,
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: (30 * timeUtils/* ONE_SECOND */.WT),
        /**
         * Logs intake limit
         */
        batchMessagesLimit: 50,
        messageBytesLimit: 256 * byteUtils/* ONE_KIBI_BYTE */.Hi,
    }, computeTransportConfiguration(initConfiguration));
}
function serializeConfiguration(initConfiguration) {
    return {
        session_sample_rate: initConfiguration.sessionSampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: !!initConfiguration.proxy,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
        allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
    };
}
//# sourceMappingURL=configuration.js.map

/***/ }),

/***/ 11095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": function() { return /* binding */ INTAKE_SITE_STAGING; },
/* harmony export */   "D_": function() { return /* binding */ INTAKE_SITE_US1; },
/* harmony export */   "Ds": function() { return /* binding */ INTAKE_SITE_EU1; },
/* harmony export */   "y7": function() { return /* binding */ INTAKE_SITE_US1_FED; }
/* harmony export */ });
var INTAKE_SITE_STAGING = 'datad0g.com';
var INTAKE_SITE_US1 = 'datadoghq.com';
var INTAKE_SITE_EU1 = 'datadoghq.eu';
var INTAKE_SITE_US1_FED = 'ddog-gov.com';
//# sourceMappingURL=intakeSites.js.map

/***/ }),

/***/ 86296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ initConsoleObservable; }
/* harmony export */ });
/* unused harmony export resetConsoleObservable */
/* harmony import */ var _error_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45242);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73473);
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13842);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64933);
/* harmony import */ var _tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68566);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94776);
/* harmony import */ var _tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19012);
/* harmony import */ var _error_computeStackTrace__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70340);








var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .mergeObservables.apply */ .$.apply(void 0, consoleObservables);
}
function resetConsoleObservable() {
    consoleObservablesByApi = {};
}
function createConsoleObservable(api) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function () {
        var originalConsoleApi = _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .globalConsole */ .jG[api];
        _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .globalConsole */ .jG[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .createHandlingStack */ .Xp)();
            (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_3__/* .callMonitored */ .L6)(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .globalConsole */ .jG[api] = originalConsoleApi;
        };
    });
    return observable;
}
function buildConsoleLog(params, api, handlingStack) {
    var message = params.map(function (param) { return formatConsoleParameters(param); }).join(' ');
    var stack;
    var fingerprint;
    if (api === _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .ConsoleApiName.error */ .vA.error) {
        var firstErrorParam = (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__/* .find */ .sE)(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .toStackTraceString */ .P3)((0,_error_computeStackTrace__WEBPACK_IMPORTED_MODULE_5__/* .computeStackTrace */ ._)(firstErrorParam)) : undefined;
        fingerprint = (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .tryToGetFingerprint */ .un)(firstErrorParam);
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
        fingerprint: fingerprint,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return (0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_6__/* .sanitize */ .N)(param);
    }
    if (param instanceof Error) {
        return (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .formatErrorMessage */ .jN)((0,_error_computeStackTrace__WEBPACK_IMPORTED_MODULE_5__/* .computeStackTrace */ ._)(param));
    }
    return (0,_tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_7__/* .jsonStringify */ .l)((0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_6__/* .sanitize */ .N)(param), undefined, 2);
}
//# sourceMappingURL=consoleObservable.js.map

/***/ }),

/***/ 6129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ createContextManager; }
/* harmony export */ });
/* unused harmony export BYTES_COMPUTATION_THROTTLING_DELAY */
/* harmony import */ var _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51962);
/* harmony import */ var _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(251);
/* harmony import */ var _tools_mergeInto__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92904);
/* harmony import */ var _tools_utils_typeUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33234);
/* harmony import */ var _tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19012);
/* harmony import */ var _tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68566);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73473);
/* harmony import */ var _heavyCustomerDataWarning__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4326);








var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
function createContextManager(customerDataType, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .computeBytesCount */ .qt; }
    var context = {};
    var bytesCountCache;
    var alreadyWarned = false;
    var changeObservable = new _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y();
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call context APIs synchronously multiple times in a row
    var computeBytesCountThrottled = (0,_tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_2__/* .throttle */ .P)(function (context) {
        bytesCountCache = computeBytesCountImpl((0,_tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_3__/* .jsonStringify */ .l)(context));
        if (!alreadyWarned) {
            alreadyWarned = (0,_heavyCustomerDataWarning__WEBPACK_IMPORTED_MODULE_4__/* .warnIfCustomerDataLimitReached */ .H)(bytesCountCache, customerDataType);
        }
    }, BYTES_COMPUTATION_THROTTLING_DELAY).throttled;
    var contextManager = {
        getBytesCount: function () { return bytesCountCache; },
        getContext: function () { return (0,_tools_mergeInto__WEBPACK_IMPORTED_MODULE_5__/* .deepClone */ .I8)(context); },
        setContext: function (newContext) {
            if ((0,_tools_utils_typeUtils__WEBPACK_IMPORTED_MODULE_6__/* .getType */ .o)(newContext) === 'object') {
                context = (0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_7__/* .sanitize */ .N)(newContext);
                computeBytesCountThrottled(context);
            }
            else {
                contextManager.clearContext();
            }
            changeObservable.notify();
        },
        setContextProperty: function (key, property) {
            context[key] = (0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_7__/* .sanitize */ .N)(property);
            computeBytesCountThrottled(context);
            changeObservable.notify();
        },
        removeContextProperty: function (key) {
            delete context[key];
            computeBytesCountThrottled(context);
            changeObservable.notify();
        },
        clearContext: function () {
            context = {};
            bytesCountCache = 0;
            changeObservable.notify();
        },
        changeObservable: changeObservable,
    };
    return contextManager;
}
//# sourceMappingURL=contextManager.js.map

/***/ }),

/***/ 4326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ warnIfCustomerDataLimitReached; }
/* harmony export */ });
/* unused harmony export CUSTOMER_DATA_BYTES_LIMIT */
/* harmony import */ var _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51962);
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13842);
var _a;


// RUM and logs batch bytes limit is 16KB
// ensure that we leave room for other event attributes and maintain a decent amount of event per batch
// (3KB (customer data) + 1KB (other attributes)) * 4 (events per batch) = 16KB
var CUSTOMER_DATA_BYTES_LIMIT = 3 * _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi;
var CustomerDataLabel = (_a = {},
    _a[0 /* CustomerDataType.FeatureFlag */] = 'feature flag evaluation',
    _a[1 /* CustomerDataType.User */] = 'user',
    _a[2 /* CustomerDataType.GlobalContext */] = 'global context',
    _a[3 /* CustomerDataType.LoggerContext */] = 'logger context',
    _a);
function warnIfCustomerDataLimitReached(bytesCount, customerDataType) {
    if (bytesCount > CUSTOMER_DATA_BYTES_LIMIT) {
        _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .display.warn */ .jf.warn("The ".concat(CustomerDataLabel[customerDataType], " data exceeds the recommended ").concat(CUSTOMER_DATA_BYTES_LIMIT / _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi, "KiB threshold. More details: https://docs.datadoghq.com/real_user_monitoring/browser/troubleshooting/#customer-data-exceeds-the-recommended-3kib-warning"));
        return true;
    }
    return false;
}
//# sourceMappingURL=heavyCustomerDataWarning.js.map

/***/ }),

/***/ 10311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PI": function() { return /* binding */ createStoredContextManager; }
/* harmony export */ });
/* unused harmony exports buildStorageKey, removeStorageListeners */
/* harmony import */ var _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51962);
/* harmony import */ var _browser_addEventListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83206);
/* harmony import */ var _contextManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6129);



var CONTEXT_STORE_KEY_PREFIX = '_dd_c';
var storageListeners = [];
function createStoredContextManager(configuration, productKey, customerDataType, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .computeBytesCount */ .qt; }
    var storageKey = buildStorageKey(productKey, customerDataType);
    var contextManager = (0,_contextManager__WEBPACK_IMPORTED_MODULE_1__/* .createContextManager */ .W)(customerDataType, computeBytesCountImpl);
    synchronizeWithStorage();
    storageListeners.push((0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .addEventListener */ .Oo)(configuration, window, _browser_addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .DOM_EVENT.STORAGE */ .EZ.STORAGE, function (_a) {
        var key = _a.key;
        if (storageKey === key) {
            synchronizeWithStorage();
        }
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    return contextManager;
    function synchronizeWithStorage() {
        var rawContext = localStorage.getItem(storageKey);
        var context = rawContext !== null ? JSON.parse(rawContext) : {};
        contextManager.setContext(context);
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
}
function buildStorageKey(productKey, customerDataType) {
    return "".concat(CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}
function removeStorageListeners() {
    storageListeners.map(function (listener) { return listener.stop(); });
}
//# sourceMappingURL=storedContextManager.js.map

/***/ }),

/***/ 70340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ computeStackTrace; },
/* harmony export */   "f": function() { return /* binding */ computeStackTraceFromOnErrorMessage; }
/* harmony export */ });
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/**
 * Cross-browser stack trace computation.
 *
 * Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
 */

var UNKNOWN_FUNCTION = '?';
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    var exString = String(ex);
    if (stackProperty && (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .startsWith */ .Ny)(stackProperty, exString)) {
        stackProperty = stackProperty.slice(exString.length);
    }
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
    var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1],
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
function computeStackTraceFromOnErrorMessage(messageObj, url, line, column) {
    var stack = [{ url: url, column: column, line: line }];
    var _a = tryToParseMessage(messageObj), name = _a.name, message = _a.message;
    return {
        name: name,
        message: message,
        stack: stack,
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function tryToParseMessage(messageObj) {
    var _a;
    var name;
    var message;
    if ({}.toString.call(messageObj) === '[object String]') {
        ;
        _a = ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
    }
    return { name: name, message: message };
}
//# sourceMappingURL=computeStackTrace.js.map

/***/ }),

/***/ 45242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K$": function() { return /* binding */ NO_ERROR_STACK_PRESENT_MESSAGE; },
/* harmony export */   "AP": function() { return /* binding */ computeRawError; },
/* harmony export */   "un": function() { return /* binding */ tryToGetFingerprint; },
/* harmony export */   "P3": function() { return /* binding */ toStackTraceString; },
/* harmony export */   "u5": function() { return /* binding */ getFileFromStackTraceString; },
/* harmony export */   "jN": function() { return /* binding */ formatErrorMessage; },
/* harmony export */   "Xp": function() { return /* binding */ createHandlingStack; }
/* harmony export */ });
/* unused harmony export flattenErrorCauses */
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64933);
/* harmony import */ var _tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68566);
/* harmony import */ var _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(251);
/* harmony import */ var _tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19012);
/* harmony import */ var _computeStackTrace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70340);





var NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeRawError(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    var isErrorInstance = originalError instanceof Error;
    var message = computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
    var stack = hasUsableStack(isErrorInstance, stackTrace)
        ? toStackTraceString(stackTrace)
        : NO_ERROR_STACK_PRESENT_MESSAGE;
    var causes = isErrorInstance ? flattenErrorCauses(originalError, source) : undefined;
    var type = stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name;
    var fingerprint = tryToGetFingerprint(originalError);
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        handlingStack: handlingStack,
        originalError: originalError,
        type: type,
        message: message,
        stack: stack,
        causes: causes,
        fingerprint: fingerprint,
    };
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name)
        ? stackTrace.message
        : !isErrorInstance
            ? "".concat(nonErrorPrefix, " ").concat((0,_tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_0__/* .jsonStringify */ .l)((0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_1__/* .sanitize */ .N)(originalError)))
            : 'Empty message';
}
function hasUsableStack(isErrorInstance, stackTrace) {
    if (stackTrace === undefined) {
        return false;
    }
    if (isErrorInstance) {
        return true;
    }
    // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
    // TODO rework tracekit integration to avoid generating those unusable stack
    return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function tryToGetFingerprint(originalError) {
    return originalError instanceof Error && 'dd_fingerprint' in originalError
        ? String(originalError.dd_fingerprint)
        : undefined;
}
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            (0,_tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_2__/* .noop */ .Z)();
        }
    }
    (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_3__/* .callMonitored */ .L6)(function () {
        var stackTrace = (0,_computeStackTrace__WEBPACK_IMPORTED_MODULE_4__/* .computeStackTrace */ ._)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
function flattenErrorCauses(error, parentSource) {
    var currentError = error;
    var causes = [];
    while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
        var stackTrace = (0,_computeStackTrace__WEBPACK_IMPORTED_MODULE_4__/* .computeStackTrace */ ._)(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && toStackTraceString(stackTrace),
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}
//# sourceMappingURL=error.js.map

/***/ }),

/***/ 42419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ErrorSource; }
/* harmony export */ });
var ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
//# sourceMappingURL=error.types.js.map

/***/ }),

/***/ 21315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lp": function() { return /* binding */ trackRuntimeError; }
/* harmony export */ });
/* unused harmony exports instrumentOnError, instrumentUnhandledRejection */
/* harmony import */ var _tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55801);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25026);
/* harmony import */ var _computeStackTrace__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70340);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45242);
/* harmony import */ var _error_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42419);





function trackRuntimeError(errorObservable) {
    var handleRuntimeError = function (stackTrace, originalError) {
        var test = (0,_error__WEBPACK_IMPORTED_MODULE_0__/* .computeRawError */ .AP)({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .clocksNow */ .$I)(),
            nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
            source: _error_types__WEBPACK_IMPORTED_MODULE_2__/* .ErrorSource.SOURCE */ .z.SOURCE,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        });
        errorObservable.notify(test);
    };
    var stopInstrumentingOnError = instrumentOnError(handleRuntimeError).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(handleRuntimeError).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
function instrumentOnError(callback) {
    return (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_3__/* .instrumentMethodAndCallOriginal */ .Lm)(window, 'onerror', {
        before: function (messageObj, url, line, column, errorObj) {
            var stackTrace;
            if (errorObj instanceof Error) {
                stackTrace = (0,_computeStackTrace__WEBPACK_IMPORTED_MODULE_4__/* .computeStackTrace */ ._)(errorObj);
            }
            else {
                stackTrace = (0,_computeStackTrace__WEBPACK_IMPORTED_MODULE_4__/* .computeStackTraceFromOnErrorMessage */ .f)(messageObj, url, line, column);
            }
            callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
        },
    });
}
function instrumentUnhandledRejection(callback) {
    return (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_3__/* .instrumentMethodAndCallOriginal */ .Lm)(window, 'onunhandledrejection', {
        before: function (e) {
            var reason = e.reason || 'Empty reason';
            var stack = (0,_computeStackTrace__WEBPACK_IMPORTED_MODULE_4__/* .computeStackTrace */ ._)(reason);
            callback(stack, reason);
        },
    });
}
//# sourceMappingURL=trackRuntimeError.js.map

/***/ }),

/***/ 15123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ createEventRateLimiter; }
/* harmony export */ });
/* harmony import */ var _tools_timer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65483);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25026);
/* harmony import */ var _error_error_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42419);



function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                (0,_tools_timer__WEBPACK_IMPORTED_MODULE_0__/* .setTimeout */ .iK)(function () {
                    eventCount = 0;
                }, _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .ONE_MINUTE */ .yR);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: _error_error_types__WEBPACK_IMPORTED_MODULE_2__/* .ErrorSource.AGENT */ .z.AGENT,
                        startClocks: (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .clocksNow */ .$I)(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
//# sourceMappingURL=createEventRateLimiter.js.map

/***/ }),

/***/ 73670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ RawReportType; },
/* harmony export */   "v": function() { return /* binding */ initReportObservable; }
/* harmony export */ });
/* harmony import */ var _error_error__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45242);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64933);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73473);
/* harmony import */ var _browser_addEventListener__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83206);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88129);






var RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(configuration, apis) {
    var observables = [];
    if ((0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .includes */ .q9)(apis, RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable(configuration));
    }
    var reportTypes = apis.filter(function (api) { return api !== RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .mergeObservables.apply */ .$.apply(void 0, observables);
}
function createReportObservable(reportTypes) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y(function () {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(function (reports, _) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
    return observable;
}
function createCspViolationReportObservable(configuration) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y(function () {
        var stop = (0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_3__/* .addEventListener */ .Oo)(configuration, document, _browser_addEventListener__WEBPACK_IMPORTED_MODULE_3__/* .DOM_EVENT.SECURITY_POLICY_VIOLATION */ .EZ.SECURITY_POLICY_VIOLATION, function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        }).stop;
        return stop;
    });
    return observable;
}
function buildRawReportFromReport(_a) {
    var type = _a.type, body = _a.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, event.originalPolicy
            ? "".concat(message, " of the policy \"").concat((0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_4__/* .safeTruncate */ ._z)(event.originalPolicy, 100, '...'), "\"")
            : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile
        ? (0,_error_error__WEBPACK_IMPORTED_MODULE_5__/* .toStackTraceString */ .P3)({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                    column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined,
                },
            ],
        })
        : undefined;
}
//# sourceMappingURL=reportObservable.js.map

/***/ }),

/***/ 78981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ SESSION_TIME_OUT_DELAY; },
/* harmony export */   "s": function() { return /* binding */ SESSION_EXPIRATION_DELAY; }
/* harmony export */ });
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25026);

var SESSION_TIME_OUT_DELAY = 4 * _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_HOUR */ .dV;
var SESSION_EXPIRATION_DELAY = 15 * _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
//# sourceMappingURL=sessionConstants.js.map

/***/ }),

/***/ 5135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HX": function() { return /* binding */ startSessionManager; }
/* harmony export */ });
/* unused harmony exports VISIBILITY_CHECK_DELAY, stopSessionManager */
/* harmony import */ var _tools_valueHistory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69029);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25026);
/* harmony import */ var _browser_addEventListener__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83206);
/* harmony import */ var _tools_timer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65483);
/* harmony import */ var _sessionConstants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78981);
/* harmony import */ var _sessionStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43691);






var VISIBILITY_CHECK_DELAY = _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
var SESSION_CONTEXT_TIMEOUT_DELAY = _sessionConstants__WEBPACK_IMPORTED_MODULE_1__/* .SESSION_TIME_OUT_DELAY */ .T;
var stopCallbacks = [];
function startSessionManager(configuration, productKey, computeSessionState) {
    // TODO - Improve configuration type and remove assertion
    var sessionStore = (0,_sessionStore__WEBPACK_IMPORTED_MODULE_2__/* .startSessionStore */ .vH)(configuration.sessionStoreStrategyType, productKey, computeSessionState);
    stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = new _tools_valueHistory__WEBPACK_IMPORTED_MODULE_3__/* .ValueHistory */ .P(SESSION_CONTEXT_TIMEOUT_DELAY);
    stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .relativeNow */ ._q)());
    });
    sessionStore.expireObservable.subscribe(function () {
        sessionContextHistory.closeActive((0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .relativeNow */ ._q)());
    });
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .clocksOrigin */ .cQ)().relative);
    trackActivity(configuration, function () { return sessionStore.expandOrRenewSession(); });
    trackVisibility(configuration, function () { return sessionStore.expandSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
        };
    }
    return {
        findActiveSession: function (startTime) { return sessionContextHistory.find(startTime); },
        renewObservable: sessionStore.renewObservable,
        expireObservable: sessionStore.expireObservable,
        expire: sessionStore.expire,
    };
}
function stopSessionManager() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
function trackActivity(configuration, expandOrRenewSession) {
    var stop = (0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_4__/* .addEventListeners */ .yw)(configuration, window, [_browser_addEventListener__WEBPACK_IMPORTED_MODULE_4__/* .DOM_EVENT.CLICK */ .EZ.CLICK, _browser_addEventListener__WEBPACK_IMPORTED_MODULE_4__/* .DOM_EVENT.TOUCH_START */ .EZ.TOUCH_START, _browser_addEventListener__WEBPACK_IMPORTED_MODULE_4__/* .DOM_EVENT.KEY_DOWN */ .EZ.KEY_DOWN, _browser_addEventListener__WEBPACK_IMPORTED_MODULE_4__/* .DOM_EVENT.SCROLL */ .EZ.SCROLL], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(configuration, expandSession) {
    var expandSessionWhenVisible = function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    };
    var stop = (0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_4__/* .addEventListener */ .Oo)(configuration, document, _browser_addEventListener__WEBPACK_IMPORTED_MODULE_4__/* .DOM_EVENT.VISIBILITY_CHANGE */ .EZ.VISIBILITY_CHANGE, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = (0,_tools_timer__WEBPACK_IMPORTED_MODULE_5__/* .setInterval */ .Zi)(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        (0,_tools_timer__WEBPACK_IMPORTED_MODULE_5__/* .clearInterval */ .cv)(visibilityCheckInterval);
    });
}
//# sourceMappingURL=sessionManager.js.map

/***/ }),

/***/ 43691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hB": function() { return /* binding */ selectSessionStoreStrategyType; },
  "vH": function() { return /* binding */ startSessionStore; }
});

// UNUSED EXPORTS: STORAGE_POLL_DELAY

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(65483);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(73473);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(251);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
var stringUtils = __webpack_require__(88129);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var sessionConstants = __webpack_require__(78981);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
var browserDetection = __webpack_require__(12172);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/cookie.js
var cookie = __webpack_require__(49647);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionStoreStrategy.js
var SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(94162);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(94776);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionState.js




var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
function isSessionInExpiredState(session) {
    return (0,objectUtils/* isEmptyObject */.Qr)(session);
}
function expandSessionState(session) {
    session.expire = String((0,timeUtils/* dateNow */.m6)() + sessionConstants/* SESSION_EXPIRATION_DELAY */.s);
}
function toSessionString(session) {
    return (0,polyfills/* objectEntries */.qP)(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
function toSessionState(sessionString) {
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
function isValidSessionString(sessionString) {
    return (!!sessionString &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
//# sourceMappingURL=sessionState.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/oldCookiesMigration.js



var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(cookieStoreStrategy) {
    var sessionString = (0,cookie/* getInitCookie */.OC)(SESSION_STORE_KEY);
    if (!sessionString) {
        var oldSessionId = (0,cookie/* getInitCookie */.OC)(OLD_SESSION_COOKIE_NAME);
        var oldRumType = (0,cookie/* getInitCookie */.OC)(OLD_RUM_COOKIE_NAME);
        var oldLogsType = (0,cookie/* getInitCookie */.OC)(OLD_LOGS_COOKIE_NAME);
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[RUM_SESSION_KEY] = oldRumType;
        }
        if (!isSessionInExpiredState(session)) {
            expandSessionState(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}
//# sourceMappingURL=oldCookiesMigration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInCookie.js






function selectCookieStrategy(initConfiguration) {
    var cookieOptions = buildCookieOptions(initConfiguration);
    return (0,cookie/* areCookiesAuthorized */.oX)(cookieOptions) ? { type: 'Cookie', cookieOptions: cookieOptions } : undefined;
}
function initCookieStrategy(cookieOptions) {
    var cookieStore = {
        /**
         * Lock strategy allows mitigating issues due to concurrent access to cookie.
         * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
         */
        isLockEnabled: (0,browserDetection/* isChromium */.mJ)(),
        persistSession: persistSessionCookie(cookieOptions),
        retrieveSession: retrieveSessionCookie,
        clearSession: deleteSessionCookie(cookieOptions),
    };
    tryOldCookiesMigration(cookieStore);
    return cookieStore;
}
function persistSessionCookie(options) {
    return function (session) {
        (0,cookie/* setCookie */.d8)(SESSION_STORE_KEY, toSessionString(session), sessionConstants/* SESSION_EXPIRATION_DELAY */.s, options);
    };
}
function retrieveSessionCookie() {
    var sessionString = (0,cookie/* getCookie */.ej)(SESSION_STORE_KEY);
    return toSessionState(sessionString);
}
function deleteSessionCookie(options) {
    return function () {
        (0,cookie/* deleteCookie */.kT)(SESSION_STORE_KEY, options);
    };
}
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.crossSite = !!initConfiguration.useCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = (0,cookie/* getCurrentSite */.WQ)();
    }
    return cookieOptions;
}
//# sourceMappingURL=sessionInCookie.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInLocalStorage.js



var LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function selectLocalStorageStrategy() {
    try {
        var id = (0,stringUtils/* generateUUID */.DO)();
        var testKey = "".concat(LOCAL_STORAGE_TEST_KEY).concat(id);
        localStorage.setItem(testKey, id);
        var retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? { type: 'LocalStorage' } : undefined;
    }
    catch (e) {
        return undefined;
    }
}
function initLocalStorageStrategy() {
    return {
        isLockEnabled: false,
        persistSession: persistInLocalStorage,
        retrieveSession: retrieveSessionFromLocalStorage,
        clearSession: clearSessionFromLocalStorage,
    };
}
function persistInLocalStorage(sessionState) {
    localStorage.setItem(SESSION_STORE_KEY, toSessionString(sessionState));
}
function retrieveSessionFromLocalStorage() {
    var sessionString = localStorage.getItem(SESSION_STORE_KEY);
    return toSessionState(sessionString);
}
function clearSessionFromLocalStorage() {
    localStorage.removeItem(SESSION_STORE_KEY);
}
//# sourceMappingURL=sessionInLocalStorage.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStoreOperations.js



var LOCK_RETRY_DELAY = 10;
var LOCK_MAX_TRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function processSessionStoreOperations(operations, sessionStoreStrategy, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    var isLockEnabled = sessionStoreStrategy.isLockEnabled, retrieveSession = sessionStoreStrategy.retrieveSession, persistSession = sessionStoreStrategy.persistSession, clearSession = sessionStoreStrategy.clearSession;
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (isLockEnabled && numberOfRetries >= LOCK_MAX_TRIES) {
        next(sessionStoreStrategy);
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (isLockEnabled) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = (0,stringUtils/* generateUUID */.DO)();
        currentSession.lock = currentLock;
        persistSession(currentSession);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (isLockEnabled) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if (isSessionInExpiredState(processedSession)) {
            clearSession();
        }
        else {
            expandSessionState(processedSession);
            persistSession(processedSession);
        }
    }
    if (isLockEnabled) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && isSessionInExpiredState(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            persistSession(currentSession);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
    next(sessionStoreStrategy);
}
function retryLater(operations, sessionStore, currentNumberOfRetries) {
    (0,timer/* setTimeout */.iK)(function () {
        processSessionStoreOperations(operations, sessionStore, currentNumberOfRetries + 1);
    }, LOCK_RETRY_DELAY);
}
function next(sessionStore) {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        processSessionStoreOperations(nextOperations, sessionStore);
    }
}
//# sourceMappingURL=sessionStoreOperations.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js









/**
 * Every second, the storage will be polled to check for any change that can occur
 * to the session state in another browser tab, or another window.
 * This value has been determined from our previous cookie-only implementation.
 */
var STORAGE_POLL_DELAY = timeUtils/* ONE_SECOND */.WT;
/**
 * Checks if cookies are available as the preferred storage
 * Else, checks if LocalStorage is allowed and available
 */
function selectSessionStoreStrategyType(initConfiguration) {
    var sessionStoreStrategyType = selectCookieStrategy(initConfiguration);
    if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) {
        sessionStoreStrategyType = selectLocalStorageStrategy();
    }
    return sessionStoreStrategyType;
}
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(sessionStoreStrategyType, productKey, computeSessionState) {
    var renewObservable = new observable/* Observable */.y();
    var expireObservable = new observable/* Observable */.y();
    var sessionStoreStrategy = sessionStoreStrategyType.type === 'Cookie'
        ? initCookieStrategy(sessionStoreStrategyType.cookieOptions)
        : initLocalStorageStrategy();
    var clearSession = sessionStoreStrategy.clearSession, retrieveSession = sessionStoreStrategy.retrieveSession;
    var watchSessionTimeoutId = (0,timer/* setInterval */.Zi)(watchSession, STORAGE_POLL_DELAY);
    var sessionCache = retrieveActiveSession();
    function expandOrRenewSession() {
        var isTracked;
        processSessionStoreOperations({
            process: function (sessionState) {
                var synchronizedSession = synchronizeSession(sessionState);
                isTracked = expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: function (sessionState) {
                if (isTracked && !hasSessionInCache()) {
                    renewSessionInCache(sessionState);
                }
                sessionCache = sessionState;
            },
        }, sessionStoreStrategy);
    }
    function expandSession() {
        processSessionStoreOperations({
            process: function (sessionState) { return (hasSessionInCache() ? synchronizeSession(sessionState) : undefined); },
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */
    function watchSession() {
        processSessionStoreOperations({
            process: function (sessionState) { return (!isActiveSession(sessionState) ? {} : undefined); },
            after: synchronizeSession,
        }, sessionStoreStrategy);
    }
    function synchronizeSession(sessionState) {
        if (!isActiveSession(sessionState)) {
            sessionState = {};
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) {
                expireSessionInCache();
            }
            else {
                sessionCache = sessionState;
            }
        }
        return sessionState;
    }
    function expandOrRenewSessionState(sessionState) {
        var _a = computeSessionState(sessionState[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        sessionState[productKey] = trackingType;
        if (isTracked && !sessionState.id) {
            sessionState.id = (0,stringUtils/* generateUUID */.DO)();
            sessionState.created = String((0,timeUtils/* dateNow */.m6)());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = retrieveSession();
        if (isActiveSession(session)) {
            return session;
        }
        return {};
    }
    function isActiveSession(sessionState) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return ((sessionState.created === undefined || (0,timeUtils/* dateNow */.m6)() - Number(sessionState.created) < sessionConstants/* SESSION_TIME_OUT_DELAY */.T) &&
            (sessionState.expire === undefined || (0,timeUtils/* dateNow */.m6)() < Number(sessionState.expire)));
    }
    return {
        expandOrRenewSession: (0,functionUtils/* throttle */.P)(expandOrRenewSession, STORAGE_POLL_DELAY).throttled,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        expire: function () {
            clearSession();
            synchronizeSession({});
        },
        stop: function () {
            (0,timer/* clearInterval */.cv)(watchSessionTimeoutId);
        },
    };
}
//# sourceMappingURL=sessionStore.js.map

/***/ }),

/***/ 99262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y9": function() { return /* binding */ willSyntheticsInjectRum; },
/* harmony export */   "L7": function() { return /* binding */ getSyntheticsTestId; },
/* harmony export */   "QB": function() { return /* binding */ getSyntheticsResultId; }
/* harmony export */ });
/* unused harmony exports SYNTHETICS_TEST_ID_COOKIE_NAME, SYNTHETICS_RESULT_ID_COOKIE_NAME, SYNTHETICS_INJECTS_RUM_COOKIE_NAME */
/* harmony import */ var _browser_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49647);

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || (0,_browser_cookie__WEBPACK_IMPORTED_MODULE_0__/* .getInitCookie */ .OC)(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function getSyntheticsTestId() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0,_browser_cookie__WEBPACK_IMPORTED_MODULE_0__/* .getInitCookie */ .OC)(SYNTHETICS_TEST_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
function getSyntheticsResultId() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || (0,_browser_cookie__WEBPACK_IMPORTED_MODULE_0__/* .getInitCookie */ .OC)(SYNTHETICS_RESULT_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=syntheticsWorkerValues.js.map

/***/ }),

/***/ 18797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Uo": function() { return /* binding */ addTelemetryConfiguration; },
  "eJ": function() { return /* binding */ addTelemetryDebug; },
  "Sz": function() { return /* binding */ addTelemetryError; },
  "VG": function() { return /* binding */ isTelemetryReplicationAllowed; },
  "VL": function() { return /* binding */ startTelemetry; }
});

// UNUSED EXPORTS: formatError, resetTelemetry, scrubCustomerFrames, startFakeTelemetry

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.js
var error = __webpack_require__(45242);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(57549);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var intakeSites = __webpack_require__(11095);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js
var tools_observable = __webpack_require__(73473);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(38971);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(94776);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(73603);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js
var jsonStringify = __webpack_require__(19012);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/mergeInto.js
var mergeInto = __webpack_require__(92904);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/computeStackTrace.js
var computeStackTrace = __webpack_require__(70340);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/rawTelemetryEvent.types.js
var TelemetryType = {
    log: 'log',
    configuration: 'configuration',
};
//# sourceMappingURL=rawTelemetryEvent.types.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js














var ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'https://d3uc069fcn7uxw.cloudfront.net',
    'https://d20xtzwzcl0ceb.cloudfront.net',
    'http://localhost',
    '<anonymous>',
];
var TELEMETRY_EXCLUDED_SITES = [intakeSites/* INTAKE_SITE_US1_FED */.y7];
var telemetryConfiguration = { maxEventsPerPage: 0, sentEventCount: 0, telemetryEnabled: false, telemetryConfigurationEnabled: false };
var onRawTelemetryEventCollected;
function startTelemetry(telemetryService, configuration) {
    var contextProvider;
    var observable = new tools_observable/* Observable */.y();
    telemetryConfiguration.telemetryEnabled =
        !(0,polyfills/* includes */.q9)(TELEMETRY_EXCLUDED_SITES, configuration.site) && (0,numberUtils/* performDraw */.y7)(configuration.telemetrySampleRate);
    telemetryConfiguration.telemetryConfigurationEnabled =
        telemetryConfiguration.telemetryEnabled && (0,numberUtils/* performDraw */.y7)(configuration.telemetryConfigurationSampleRate);
    var runtimeEnvInfo = getRuntimeEnvInfo();
    onRawTelemetryEventCollected = function (rawEvent) {
        if (telemetryConfiguration.telemetryEnabled) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
            observable.notify(event_1);
            (0,sendToExtension/* sendToExtension */.j)('telemetry', event_1);
        }
    };
    (0,monitor/* startMonitorErrorCollection */.P_)(addTelemetryError);
    (0,polyfills/* assign */.f0)(telemetryConfiguration, {
        maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
        sentEventCount: 0,
    });
    function toTelemetryEvent(telemetryService, event, runtimeEnvInfo) {
        return (0,mergeInto/* combine */.$e)({
            type: 'telemetry',
            date: (0,timeUtils/* timeStampNow */.n$)(),
            service: telemetryService,
            version: "5.4.0",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: (0,mergeInto/* combine */.$e)(event, {
                runtime_env: runtimeEnvInfo,
            }),
            experimental_features: (0,polyfills/* arrayFrom */.Oc)((0,experimentalFeatures/* getExperimentalFeatures */.u0)()),
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function (provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: telemetryConfiguration.telemetryEnabled,
    };
}
function getRuntimeEnvInfo() {
    return {
        is_local_file: window.location.protocol === 'file:',
        is_worker: 'WorkerGlobalScope' in self,
    };
}
function startFakeTelemetry() {
    var events = [];
    assign(telemetryConfiguration, {
        maxEventsPerPage: Infinity,
        sentEventCount: 0,
    });
    onRawTelemetryEventCollected = function (event) {
        events.push(event);
    };
    return events;
}
function resetTelemetry() {
    onRawTelemetryEventCollected = undefined;
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
    return configuration.site === intakeSites/* INTAKE_SITE_STAGING */.DZ;
}
function addTelemetryDebug(message, context) {
    (0,monitor/* displayIfDebugEnabled */.DV)(display/* ConsoleApiName.debug */.vA.debug, message, context);
    addTelemetry((0,polyfills/* assign */.f0)({
        type: TelemetryType.log,
        message: message,
        status: "debug" /* StatusType.debug */,
    }, context));
}
function addTelemetryError(e, context) {
    addTelemetry((0,polyfills/* assign */.f0)({
        type: TelemetryType.log,
        status: "error" /* StatusType.error */,
    }, formatError(e), context));
}
function addTelemetryConfiguration(configuration) {
    if (telemetryConfiguration.telemetryConfigurationEnabled) {
        addTelemetry({
            type: TelemetryType.configuration,
            configuration: configuration,
        });
    }
}
function addTelemetry(event) {
    if (onRawTelemetryEventCollected && telemetryConfiguration.sentEventCount < telemetryConfiguration.maxEventsPerPage) {
        telemetryConfiguration.sentEventCount += 1;
        onRawTelemetryEventCollected(event);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = (0,computeStackTrace/* computeStackTrace */._)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0,error/* toStackTraceString */.P3)(scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: error/* NO_ERROR_STACK_PRESENT_MESSAGE */.K$,
        },
        message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */, " ").concat((0,jsonStringify/* jsonStringify */.l)(e)),
    };
}
function scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function (frame) { return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) { return (0,polyfills/* startsWith */.Ny)(frame.url, allowedFrameUrl); }); });
    return stackTrace;
}
//# sourceMappingURL=telemetry.js.map

/***/ }),

/***/ 54910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ sanitizeUser; },
/* harmony export */   "z": function() { return /* binding */ checkUser; }
/* harmony export */ });
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13842);
/* harmony import */ var _tools_utils_typeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33234);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);



/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)({}, newUser);
    var keys = ['id', 'name', 'email'];
    keys.forEach(function (key) {
        if (key in user) {
            user[key] = String(user[key]);
        }
    });
    return user;
}
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
    var isValid = (0,_tools_utils_typeUtils__WEBPACK_IMPORTED_MODULE_1__/* .getType */ .o)(newUser) === 'object';
    if (!isValid) {
        _tools_display__WEBPACK_IMPORTED_MODULE_2__/* .display.error */ .jf.error('Unsupported user:', newUser);
    }
    return isValid;
}
//# sourceMappingURL=user.js.map

/***/ }),

/***/ 29307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ AbstractLifeCycle; }
/* harmony export */ });
var AbstractLifeCycle = /** @class */ (function () {
    function AbstractLifeCycle() {
        this.callbacks = {};
    }
    AbstractLifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    AbstractLifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return AbstractLifeCycle;
}());

//# sourceMappingURL=abstractLifeCycle.js.map

/***/ }),

/***/ 68783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ BoundedBuffer; }
/* harmony export */ });
var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (callback) {
        var length = this.buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.drain = function () {
        this.buffer.forEach(function (callback) { return callback(); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());

//# sourceMappingURL=boundedBuffer.js.map

/***/ }),

/***/ 40812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ catchUserErrors; }
/* harmony export */ });
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13842);

function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            _display__WEBPACK_IMPORTED_MODULE_0__/* .display.error */ .jf.error(errorMsg, err);
        }
    };
}
//# sourceMappingURL=catchUserErrors.js.map

/***/ }),

/***/ 13842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vA": function() { return /* binding */ ConsoleApiName; },
/* harmony export */   "jG": function() { return /* binding */ globalConsole; },
/* harmony export */   "LD": function() { return /* binding */ originalConsoleMethods; },
/* harmony export */   "jf": function() { return /* binding */ display; }
/* harmony export */ });
/* eslint-disable local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
/**
 * When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
 * "console.*" references. This causes some issue as we expect `console.*` to be defined.
 * As a workaround, let's use a variable alias, so those expressions won't be taken into account by
 * simple static analysis.
 *
 * [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
 * [2]: https://github.com/terser/terser#compress-options (look for drop_console)
 */
var globalConsole = console;
var originalConsoleMethods = {};
Object.keys(ConsoleApiName).forEach(function (name) {
    originalConsoleMethods[name] = globalConsole[name];
});
var PREFIX = 'Datadog Browser SDK:';
var display = {
    debug: originalConsoleMethods.debug.bind(globalConsole, PREFIX),
    log: originalConsoleMethods.log.bind(globalConsole, PREFIX),
    info: originalConsoleMethods.info.bind(globalConsole, PREFIX),
    warn: originalConsoleMethods.warn.bind(globalConsole, PREFIX),
    error: originalConsoleMethods.error.bind(globalConsole, PREFIX),
};
//# sourceMappingURL=display.js.map

/***/ }),

/***/ 83895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ createIdentityEncoder; }
/* harmony export */ });
/* harmony import */ var _utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51962);

function createIdentityEncoder() {
    var output = '';
    var outputBytesCount = 0;
    return {
        isAsync: false,
        get isEmpty() {
            return !output;
        },
        write: function (data, callback) {
            var additionalEncodedBytesCount = (0,_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .computeBytesCount */ .qt)(data);
            outputBytesCount += additionalEncodedBytesCount;
            output += data;
            if (callback) {
                callback(additionalEncodedBytesCount);
            }
        },
        finish: function (callback) {
            callback(this.finishSync());
        },
        finishSync: function () {
            var result = {
                output: output,
                outputBytesCount: outputBytesCount,
                rawBytesCount: outputBytesCount,
                pendingData: '',
            };
            output = '';
            outputBytesCount = 0;
            return result;
        },
        estimateEncodedBytesCount: function (data) {
            return data.length;
        },
    };
}
//# sourceMappingURL=encoder.js.map

/***/ }),

/***/ 57549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uh": function() { return /* binding */ ExperimentalFeature; },
/* harmony export */   "vn": function() { return /* binding */ addExperimentalFeatures; },
/* harmony export */   "W_": function() { return /* binding */ isExperimentalFeatureEnabled; },
/* harmony export */   "u0": function() { return /* binding */ getExperimentalFeatures; }
/* harmony export */ });
/* unused harmony export resetExperimentalFeatures */
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag
// eslint-disable-next-line no-restricted-syntax
var ExperimentalFeature;
(function (ExperimentalFeature) {
    ExperimentalFeature["PAGEHIDE"] = "pagehide";
    ExperimentalFeature["FEATURE_FLAGS"] = "feature_flags";
    ExperimentalFeature["RESOURCE_PAGE_STATES"] = "resource_page_states";
    ExperimentalFeature["COLLECT_FLUSH_REASON"] = "collect_flush_reason";
    ExperimentalFeature["SCROLLMAP"] = "scrollmap";
    ExperimentalFeature["DISABLE_REPLAY_INLINE_CSS"] = "disable_replay_inline_css";
})(ExperimentalFeature || (ExperimentalFeature = {}));
var enabledExperimentalFeatures = new Set();
function addExperimentalFeatures(enabledFeatures) {
    enabledFeatures.forEach(function (flag) {
        enabledExperimentalFeatures.add(flag);
    });
}
function isExperimentalFeatureEnabled(featureName) {
    return enabledExperimentalFeatures.has(featureName);
}
function resetExperimentalFeatures() {
    enabledExperimentalFeatures.clear();
}
function getExperimentalFeatures() {
    return enabledExperimentalFeatures;
}
//# sourceMappingURL=experimentalFeatures.js.map

/***/ }),

/***/ 49271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobalObject; }
/* harmony export */ });
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
//# sourceMappingURL=getGlobalObject.js.map

/***/ }),

/***/ 59693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getZoneJsOriginalValue; }
/* harmony export */ });
/* harmony import */ var _getGlobalObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49271);

/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
    var browserWindow = (0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
        original = target[browserWindow.Zone.__symbol__(name)];
    }
    if (!original) {
        original = target[name];
    }
    return original;
}
//# sourceMappingURL=getZoneJsOriginalValue.js.map

/***/ }),

/***/ 55801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Su": function() { return /* binding */ instrumentMethod; },
/* harmony export */   "Lm": function() { return /* binding */ instrumentMethodAndCallOriginal; },
/* harmony export */   "Xk": function() { return /* binding */ instrumentSetter; }
/* harmony export */ });
/* harmony import */ var _timer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65483);
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64933);
/* harmony import */ var _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(251);



function instrumentMethod(object, method, instrumentationFactory) {
    var original = object[method];
    var instrumentation = instrumentationFactory(original);
    var instrumentationWrapper = function () {
        if (typeof instrumentation !== 'function') {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return instrumentation.apply(this, arguments);
    };
    object[method] = instrumentationWrapper;
    return {
        stop: function () {
            if (object[method] === instrumentationWrapper) {
                object[method] = original;
            }
            else {
                instrumentation = original;
            }
        },
    };
}
function instrumentMethodAndCallOriginal(object, method, _a) {
    var before = _a.before, after = _a.after;
    return instrumentMethod(object, method, function (original) {
        return function () {
            var args = arguments;
            var result;
            if (before) {
                (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .callMonitored */ .L6)(before, this, args);
            }
            if (typeof original === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                result = original.apply(this, args);
            }
            if (after) {
                (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .callMonitored */ .L6)(after, this, args);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return result;
        };
    });
}
function instrumentSetter(object, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(object, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .Z };
    }
    var instrumentation = function (thisObject, value) {
        // put hooked setter into event loop to avoid of set latency
        (0,_timer__WEBPACK_IMPORTED_MODULE_2__/* .setTimeout */ .iK)(function () {
            after(thisObject, value);
        }, 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(object, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(object, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(object, property, originalDescriptor);
            }
            else {
                instrumentation = _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .Z;
            }
        },
    };
}
//# sourceMappingURL=instrumentMethod.js.map

/***/ }),

/***/ 92904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I8": function() { return /* binding */ deepClone; },
/* harmony export */   "$e": function() { return /* binding */ combine; }
/* harmony export */ });
/* unused harmony export mergeInto */
/* harmony import */ var _utils_typeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33234);

/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = (0,_utils_typeUtils__WEBPACK_IMPORTED_MODULE_0__/* .getType */ .o)(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
//# sourceMappingURL=mergeInto.js.map

/***/ }),

/***/ 64933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P_": function() { return /* binding */ startMonitorErrorCollection; },
/* harmony export */   "yD": function() { return /* binding */ setDebugMode; },
/* harmony export */   "Th": function() { return /* binding */ monitored; },
/* harmony export */   "zk": function() { return /* binding */ monitor; },
/* harmony export */   "L6": function() { return /* binding */ callMonitored; },
/* harmony export */   "DV": function() { return /* binding */ displayIfDebugEnabled; }
/* harmony export */ });
/* unused harmony export resetMonitor */
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13842);
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
    onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function setDebugMode(newDebugMode) {
    debugMode = newDebugMode;
}
function resetMonitor() {
    onMonitorErrorCollected = undefined;
    debugMode = false;
}
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        displayIfDebugEnabled(e);
        if (onMonitorErrorCollected) {
            try {
                onMonitorErrorCollected(e);
            }
            catch (e) {
                displayIfDebugEnabled(e);
            }
        }
    }
}
function displayIfDebugEnabled() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (debugMode) {
        _display__WEBPACK_IMPORTED_MODULE_0__/* .display.error.apply */ .jf.error.apply(_display__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jf, __spreadArray(['[MONITOR]'], args, false));
    }
}
//# sourceMappingURL=monitor.js.map

/***/ }),

/***/ 73473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ Observable; },
/* harmony export */   "$": function() { return /* binding */ mergeObservables; }
/* harmony export */ });
var Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe() || undefined;
        }
        this.observers.push(f);
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());

function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var globalObservable = new Observable(function () {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
    return globalObservable;
}
//# sourceMappingURL=observable.js.map

/***/ }),

/***/ 18057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ readBytesFromStream; }
/* harmony export */ });
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64933);
/* harmony import */ var _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(251);


/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then((0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(function (result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) {
                chunks.push(result.value);
            }
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) {
                onDone();
            }
            else {
                readMore();
            }
        }), (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(function (error) { return callback(error); }));
    }
    function onDone() {
        reader.cancel().catch(
        // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .Z);
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) {
                // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
                // use it directly.
                completeBuffer_1 = chunks[0];
            }
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function (chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}
//# sourceMappingURL=readBytesFromStream.js.map

/***/ }),

/***/ 38971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ sendToExtension; }
/* harmony export */ });
function sendToExtension(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type: type, payload: payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map

/***/ }),

/***/ 19012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ jsonStringify; },
/* harmony export */   "y": function() { return /* binding */ detachToJsonMethod; }
/* harmony export */ });
/* harmony import */ var _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(251);

/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
    if (typeof value !== 'object' || value === null) {
        return JSON.stringify(value);
    }
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
    var restoreValueToJson = detachToJsonMethod(value);
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        return '<error: unable to serialize object>';
    }
    finally {
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function detachToJsonMethod(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function () {
            object.toJSON = objectToJson;
        };
    }
    return _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z;
}
//# sourceMappingURL=jsonStringify.js.map

/***/ }),

/***/ 68566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ sanitize; }
/* harmony export */ });
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13842);
/* harmony import */ var _utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51962);
/* harmony import */ var _jsonStringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19012);



// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * _utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi;
// Symbol for the root element of the JSONPath used for visited objects
var JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var KEY_DECORATION_LENGTH = 3;
function sanitize(source, maxCharacterCount) {
    var _a;
    if (maxCharacterCount === void 0) { maxCharacterCount = SANITIZE_DEFAULT_MAX_CHARACTER_COUNT; }
    // Unbind any toJSON function we may have on [] or {} prototypes
    var restoreObjectPrototypeToJson = (0,_jsonStringify__WEBPACK_IMPORTED_MODULE_1__/* .detachToJsonMethod */ .y)(Object.prototype);
    var restoreArrayPrototypeToJson = (0,_jsonStringify__WEBPACK_IMPORTED_MODULE_1__/* .detachToJsonMethod */ .y)(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    var containerQueue = [];
    var visitedObjectsWithPath = new WeakMap();
    var sanitizedData = sanitizeProcessor(source, JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    var accumulatedCharacterCount = ((_a = JSON.stringify(sanitizedData)) === null || _a === void 0 ? void 0 : _a.length) || 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
        return undefined;
    }
    while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
        var containerToProcess = containerQueue.shift();
        var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) {
            for (var key = 0; key < containerToProcess.source.length; key++) {
                var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length;
                }
                else {
                    // When an element of an Array (targetData) is undefined, it is serialized as null:
                    // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
                    accumulatedCharacterCount += 4;
                }
                accumulatedCharacterCount += separatorLength;
                separatorLength = 1;
                if (accumulatedCharacterCount > maxCharacterCount) {
                    warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                    break;
                }
                ;
                containerToProcess.target[key] = targetData;
            }
        }
        else {
            for (var key in containerToProcess.source) {
                if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                    var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                    // When a property of an object has an undefined value, it will be dropped during serialization:
                    // JSON.stringify({a:undefined}) => '{}'
                    if (targetData !== undefined) {
                        accumulatedCharacterCount +=
                            JSON.stringify(targetData).length + separatorLength + key.length + KEY_DECORATION_LENGTH;
                        separatorLength = 1;
                    }
                    if (accumulatedCharacterCount > maxCharacterCount) {
                        warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                        break;
                    }
                    ;
                    containerToProcess.target[key] = targetData;
                }
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */
function sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    var sourceToSanitize = tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== 'object') {
        return sanitizePrimitivesAndFunctions(sourceToSanitize);
    }
    var sanitizedSource = sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') {
        return sanitizedSource;
    }
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    var sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) {
        return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
    }
    // Add processed source to queue
    var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
    var target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({ source: sourceToSanitize, target: target, path: currentPath });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */
function sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === 'bigint') {
        return "[BigInt] ".concat(value.toString());
    }
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === 'function') {
        return "[Function] ".concat(value.name || 'unknown');
    }
    // JSON.stringify() does not serialize symbols.
    if (typeof value === 'symbol') {
        return "[Symbol] ".concat(value.description || value.toString());
    }
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */
function sanitizeObjects(value) {
    try {
        // Handle events - Keep a simple implementation to avoid breaking changes
        if (value instanceof Event) {
            return {
                isTrusted: value.isTrusted,
            };
        }
        // Handle all remaining object types in a generic way
        var result = Object.prototype.toString.call(value);
        var match = result.match(/\[object (.*)\]/);
        if (match && match[1]) {
            return "[".concat(match[1], "]");
        }
    }
    catch (_a) {
        // If the previous serialization attempts failed, and we cannot convert using
        // Object.prototype.toString, declare the value unserializable
    }
    return '[Unserializable]';
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */
function tryToApplyToJSON(value) {
    var object = value;
    if (object && typeof object.toJSON === 'function') {
        try {
            return object.toJSON();
        }
        catch (_a) {
            // If toJSON fails, we continue by trying to serialize the value manually
        }
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */
function warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    _display__WEBPACK_IMPORTED_MODULE_2__/* .display.warn */ .jf.warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}
//# sourceMappingURL=sanitize.js.map

/***/ }),

/***/ 65483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iK": function() { return /* binding */ setTimeout; },
/* harmony export */   "gr": function() { return /* binding */ clearTimeout; },
/* harmony export */   "Zi": function() { return /* binding */ setInterval; },
/* harmony export */   "cv": function() { return /* binding */ clearInterval; }
/* harmony export */ });
/* harmony import */ var _getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59693);
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64933);
/* harmony import */ var _getGlobalObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49271);



function setTimeout(callback, delay) {
    return (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)(), 'setTimeout')((0,_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(callback), delay);
}
function clearTimeout(timeoutId) {
    (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)(), 'clearTimeout')(timeoutId);
}
function setInterval(callback, delay) {
    return (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)(), 'setInterval')((0,_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(callback), delay);
}
function clearInterval(timeoutId) {
    (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)(), 'clearInterval')(timeoutId);
}
//# sourceMappingURL=timer.js.map

/***/ }),

/***/ 12172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w1": function() { return /* binding */ isIE; },
/* harmony export */   "mJ": function() { return /* binding */ isChromium; },
/* harmony export */   "G6": function() { return /* binding */ isSafari; }
/* harmony export */ });
/* unused harmony export detectBrowser */
function isIE() {
    return detectBrowserCached() === 0 /* Browser.IE */;
}
function isChromium() {
    return detectBrowserCached() === 1 /* Browser.CHROMIUM */;
}
function isSafari() {
    return detectBrowserCached() === 2 /* Browser.SAFARI */;
}
var browserCache;
function detectBrowserCached() {
    return browserCache !== null && browserCache !== void 0 ? browserCache : (browserCache = detectBrowser());
}
// Exported only for tests
function detectBrowser(browserWindow) {
    var _a;
    if (browserWindow === void 0) { browserWindow = window; }
    var userAgent = browserWindow.navigator.userAgent;
    if (browserWindow.chrome || /HeadlessChrome/.test(userAgent)) {
        return 1 /* Browser.CHROMIUM */;
    }
    if (
    // navigator.vendor is deprecated, but it is the most resilient way we found to detect
    // "Apple maintained browsers" (AKA Safari). If one day it gets removed, we still have the
    // useragent test as a semi-working fallback.
    ((_a = browserWindow.navigator.vendor) === null || _a === void 0 ? void 0 : _a.indexOf('Apple')) === 0 ||
        (/safari/i.test(userAgent) && !/chrome|android/i.test(userAgent))) {
        return 2 /* Browser.SAFARI */;
    }
    if (browserWindow.document.documentMode) {
        return 0 /* Browser.IE */;
    }
    return 3 /* Browser.OTHER */;
}
//# sourceMappingURL=browserDetection.js.map

/***/ }),

/***/ 51962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hi": function() { return /* binding */ ONE_KIBI_BYTE; },
/* harmony export */   "X9": function() { return /* binding */ ONE_MEBI_BYTE; },
/* harmony export */   "qt": function() { return /* binding */ computeBytesCount; },
/* harmony export */   "Kb": function() { return /* binding */ concatBuffers; }
/* harmony export */ });
var ONE_KIBI_BYTE = 1024;
var ONE_MEBI_BYTE = 1024 * ONE_KIBI_BYTE;
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
        return candidate.length;
    }
    if (window.TextEncoder !== undefined) {
        return new TextEncoder().encode(candidate).length;
    }
    return new Blob([candidate]).size;
}
function concatBuffers(buffers) {
    var length = buffers.reduce(function (total, buffer) { return total + buffer.length; }, 0);
    var result = new Uint8Array(length);
    var offset = 0;
    for (var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++) {
        var buffer = buffers_1[_i];
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}
//# sourceMappingURL=byteUtils.js.map

/***/ }),

/***/ 251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ throttle; },
/* harmony export */   "Z": function() { return /* binding */ noop; }
/* harmony export */ });
/* harmony import */ var _timer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65483);

// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = (0,_timer__WEBPACK_IMPORTED_MODULE_0__/* .setTimeout */ .iK)(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            (0,_timer__WEBPACK_IMPORTED_MODULE_0__/* .clearTimeout */ .gr)(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
//# sourceMappingURL=functionUtils.js.map

/***/ }),

/***/ 73603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y7": function() { return /* binding */ performDraw; },
/* harmony export */   "NM": function() { return /* binding */ round; },
/* harmony export */   "zz": function() { return /* binding */ isPercentage; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; }
/* harmony export */ });
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
    return +num.toFixed(decimals);
}
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
    return typeof value === 'number';
}
//# sourceMappingURL=numberUtils.js.map

/***/ }),

/***/ 94162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mv": function() { return /* binding */ shallowClone; },
/* harmony export */   "E5": function() { return /* binding */ objectHasValue; },
/* harmony export */   "Qr": function() { return /* binding */ isEmptyObject; },
/* harmony export */   "Q8": function() { return /* binding */ mapValues; }
/* harmony export */ });
/* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);

function shallowClone(object) {
    return (0,_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)({}, object);
}
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
//# sourceMappingURL=objectUtils.js.map

/***/ }),

/***/ 94776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q9": function() { return /* binding */ includes; },
/* harmony export */   "Oc": function() { return /* binding */ arrayFrom; },
/* harmony export */   "sE": function() { return /* binding */ find; },
/* harmony export */   "dF": function() { return /* binding */ findLast; },
/* harmony export */   "Ed": function() { return /* binding */ forEach; },
/* harmony export */   "TT": function() { return /* binding */ objectValues; },
/* harmony export */   "qP": function() { return /* binding */ objectEntries; },
/* harmony export */   "Ny": function() { return /* binding */ startsWith; },
/* harmony export */   "pn": function() { return /* binding */ endsWith; },
/* harmony export */   "Ap": function() { return /* binding */ elementMatches; },
/* harmony export */   "QA": function() { return /* binding */ cssEscape; },
/* harmony export */   "f0": function() { return /* binding */ assign; }
/* harmony export */ });
function includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function arrayFrom(arrayLike) {
    if (Array.from) {
        return Array.from(arrayLike);
    }
    var array = [];
    if (arrayLike instanceof Set) {
        arrayLike.forEach(function (item) { return array.push(item); });
    }
    else {
        for (var i = 0; i < arrayLike.length; i++) {
            array.push(arrayLike[i]);
        }
    }
    return array;
}
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i)) {
            return item;
        }
    }
    return undefined;
}
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
function startsWith(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
function endsWith(candidate, search) {
    return candidate.slice(-search.length) === search;
}
function elementMatches(element, selector) {
    if (element.matches) {
        return element.matches(selector);
    }
    // IE11 support
    if (element.msMatchesSelector) {
        return element.msMatchesSelector(selector);
    }
    return false;
}
// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
    if (window.CSS && window.CSS.escape) {
        return window.CSS.escape(str);
    }
    // eslint-disable-next-line no-control-regex
    return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === '\0') {
                return '\uFFFD';
            }
            // Control characters and (dependent upon position) numbers get escaped as code points
            return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\".concat(ch);
    });
}
function assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
//# sourceMappingURL=polyfills.js.map

/***/ }),

/***/ 29100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isServerError; },
/* harmony export */   "u": function() { return /* binding */ tryToClone; }
/* harmony export */ });
function isServerError(status) {
    return status >= 500;
}
function tryToClone(response) {
    try {
        return response.clone();
    }
    catch (e) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}
//# sourceMappingURL=responseUtils.js.map

/***/ }),

/***/ 88129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ generateUUID; },
/* harmony export */   "MY": function() { return /* binding */ findCommaSeparatedValue; },
/* harmony export */   "kq": function() { return /* binding */ findCommaSeparatedValues; },
/* harmony export */   "_z": function() { return /* binding */ safeTruncate; }
/* harmony export */ });
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
var COMMA_SEPARATED_KEY_VALUE = /([\w-]+)\s*=\s*([^;]+)/g;
function findCommaSeparatedValue(rawString, name) {
    COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            if (match[1] === name) {
                return match[2];
            }
        }
        else {
            break;
        }
    }
}
function findCommaSeparatedValues(rawString) {
    var result = new Map();
    COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
        if (match) {
            result.set(match[1], match[2]);
        }
        else {
            break;
        }
    }
    return result;
}
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) {
        return candidate;
    }
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
//# sourceMappingURL=stringUtils.js.map

/***/ }),

/***/ 25026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WT": function() { return /* binding */ ONE_SECOND; },
/* harmony export */   "yR": function() { return /* binding */ ONE_MINUTE; },
/* harmony export */   "dV": function() { return /* binding */ ONE_HOUR; },
/* harmony export */   "DY": function() { return /* binding */ relativeToClocks; },
/* harmony export */   "QA": function() { return /* binding */ currentDrift; },
/* harmony export */   "c0": function() { return /* binding */ toServerDuration; },
/* harmony export */   "m6": function() { return /* binding */ dateNow; },
/* harmony export */   "n$": function() { return /* binding */ timeStampNow; },
/* harmony export */   "_q": function() { return /* binding */ relativeNow; },
/* harmony export */   "$I": function() { return /* binding */ clocksNow; },
/* harmony export */   "cQ": function() { return /* binding */ clocksOrigin; },
/* harmony export */   "_J": function() { return /* binding */ elapsed; },
/* harmony export */   "WK": function() { return /* binding */ addDuration; },
/* harmony export */   "ni": function() { return /* binding */ getRelativeTime; },
/* harmony export */   "Cn": function() { return /* binding */ looksLikeRelativeTime; }
/* harmony export */ });
/* unused harmony exports ONE_DAY, ONE_YEAR, getTimeStamp, resetNavigationStart */
/* harmony import */ var _numberUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73603);

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = (dateNow() - performance.now());
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        return Math.round(addDuration(correctedOrigin, relativeTime));
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
function toServerDuration(duration) {
    if (!(0,_numberUtils__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj)(duration)) {
        return duration;
    }
    return (0,_numberUtils__WEBPACK_IMPORTED_MODULE_0__/* .round */ .NM)(duration * 1e6, 0);
}
function dateNow() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function timeStampNow() {
    return dateNow();
}
function relativeNow() {
    return performance.now();
}
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
function elapsed(start, end) {
    return (end - start);
}
function addDuration(a, b) {
    return a + b;
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
function getTimeStamp(relativeTime) {
    return Math.round(addDuration(getNavigationStart(), relativeTime));
}
function looksLikeRelativeTime(time) {
    return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function resetNavigationStart() {
    navigationStart = undefined;
}
//# sourceMappingURL=timeUtils.js.map

/***/ }),

/***/ 33234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getType; }
/* harmony export */ });
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
//# sourceMappingURL=typeUtils.js.map

/***/ }),

/***/ 70170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D5": function() { return /* binding */ normalizeUrl; },
/* harmony export */   "jv": function() { return /* binding */ isValidUrl; },
/* harmony export */   "ye": function() { return /* binding */ getPathName; },
/* harmony export */   "Q2": function() { return /* binding */ buildUrl; }
/* harmony export */ });
/* unused harmony exports getOrigin, getSearch, getHash, getLocationOrigin, getLinkElementOrigin */
/* harmony import */ var _serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19012);

function normalizeUrl(url) {
    return buildUrl(url, getLocationOrigin()).href;
}
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function getOrigin(url) {
    return getLinkElementOrigin(buildUrl(url));
}
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function getSearch(url) {
    return buildUrl(url).search;
}
function getHash(url) {
    return buildUrl(url).hash;
}
function buildUrl(url, base) {
    var supportedURL = getSupportedUrl();
    if (supportedURL) {
        try {
            return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
        }
        catch (error) {
            throw new Error("Failed to construct URL: ".concat(String(error), " ").concat((0,_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_0__/* .jsonStringify */ .l)({ url: url, base: base })));
        }
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var originalURL = URL;
var isURLSupported;
function getSupportedUrl() {
    if (isURLSupported === undefined) {
        try {
            var url = new originalURL('http://test/path');
            isURLSupported = url.href === 'http://test/path';
        }
        catch (_a) {
            isURLSupported = false;
        }
    }
    return isURLSupported ? originalURL : undefined;
}
function getLocationOrigin() {
    return getLinkElementOrigin(window.location);
}
/**
 * Fallback
 * On IE HTMLAnchorElement origin is not supported: https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 * On Firefox window.location.origin is "null" for file: URIs: https://bugzilla.mozilla.org/show_bug.cgi?id=878297
 */
function getLinkElementOrigin(element) {
    if (element.origin && element.origin !== 'null') {
        return element.origin;
    }
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return "".concat(element.protocol, "//").concat(sanitizedHost);
}
//# sourceMappingURL=urlPolyfill.js.map

/***/ }),

/***/ 69029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ ValueHistory; }
/* harmony export */ });
/* unused harmony export CLEAR_OLD_VALUES_INTERVAL */
/* harmony import */ var _timer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65483);
/* harmony import */ var _utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25026);


var END_OF_TIMES = Infinity;
var CLEAR_OLD_VALUES_INTERVAL = _utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
/**
 * Store and keep track of values spans. This whole class assumes that values are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ValueHistory = /** @class */ (function () {
    function ValueHistory(expireDelay, maxEntries) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.maxEntries = maxEntries;
        this.entries = [];
        this.clearOldValuesInterval = (0,_timer__WEBPACK_IMPORTED_MODULE_1__/* .setInterval */ .Zi)(function () { return _this.clearOldValues(); }, CLEAR_OLD_VALUES_INTERVAL);
    }
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    ValueHistory.prototype.add = function (value, startTime) {
        var _this = this;
        var entry = {
            value: value,
            startTime: startTime,
            endTime: END_OF_TIMES,
            remove: function () {
                var index = _this.entries.indexOf(entry);
                if (index >= 0) {
                    _this.entries.splice(index, 1);
                }
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        if (this.maxEntries && this.entries.length >= this.maxEntries) {
            this.entries.pop();
        }
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */
    ValueHistory.prototype.find = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) {
                    return entry.value;
                }
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */
    ValueHistory.prototype.closeActive = function (endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    };
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */
    ValueHistory.prototype.findAll = function (startTime, duration) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        if (duration === void 0) { duration = 0; }
        var endTime = (0,_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .addDuration */ .WK)(startTime, duration);
        return this.entries
            .filter(function (entry) { return entry.startTime <= endTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.value; });
    };
    /**
     * Remove all entries from this collection.
     */
    ValueHistory.prototype.reset = function () {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */
    ValueHistory.prototype.stop = function () {
        (0,_timer__WEBPACK_IMPORTED_MODULE_1__/* .clearInterval */ .cv)(this.clearOldValuesInterval);
    };
    ValueHistory.prototype.clearOldValues = function () {
        var oldTimeThreshold = (0,_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .relativeNow */ ._q)() - this.expireDelay;
        while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
            this.entries.pop();
        }
    };
    return ValueHistory;
}());

//# sourceMappingURL=valueHistory.js.map

/***/ }),

/***/ 76876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getEventBridge; },
/* harmony export */   "x": function() { return /* binding */ canUseEventBridge; }
/* harmony export */ });
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94776);
/* harmony import */ var _tools_getGlobalObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49271);


function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
function canUseEventBridge(currentHost) {
    var _a;
    if (currentHost === void 0) { currentHost = (_a = (0,_tools_getGlobalObject__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some(function (allowedHost) { return currentHost === allowedHost || (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_1__/* .endsWith */ .pn)(currentHost, ".".concat(allowedHost)); }));
}
function getEventBridgeGlobal() {
    return (0,_tools_getGlobalObject__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map

/***/ }),

/***/ 30481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UF": function() { return /* binding */ createHttpRequest; }
});

// UNUSED EXPORTS: fetchKeepAliveStrategy, sendXHR

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry = __webpack_require__(18797);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/addEventListener.js
var addEventListener = __webpack_require__(83206);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(65483);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(51962);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
var responseUtils = __webpack_require__(29100);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(42419);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/sendWithRetryStrategy.js





var MAX_ONGOING_BYTES_COUNT = 80 * byteUtils/* ONE_KIBI_BYTE */.Hi;
var MAX_ONGOING_REQUESTS = 32;
var MAX_QUEUE_BYTES_COUNT = 3 * byteUtils/* ONE_MEBI_BYTE */.X9;
var MAX_BACKOFF_TIME = timeUtils/* ONE_MINUTE */.yR;
var INITIAL_BACKOFF_TIME = timeUtils/* ONE_SECOND */.WT;
function sendWithRetryStrategy(payload, state, sendStrategy, trackType, reportError) {
    if (state.transportStatus === 0 /* TransportStatus.UP */ &&
        state.queuedPayloads.size() === 0 &&
        state.bandwidthMonitor.canHandle(payload)) {
        send(payload, state, sendStrategy, {
            onSuccess: function () { return retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */, state, sendStrategy, trackType, reportError); },
            onFailure: function () {
                state.queuedPayloads.enqueue(payload);
                scheduleRetry(state, sendStrategy, trackType, reportError);
            },
        });
    }
    else {
        state.queuedPayloads.enqueue(payload);
    }
}
function scheduleRetry(state, sendStrategy, trackType, reportError) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */) {
        return;
    }
    (0,timer/* setTimeout */.iK)(function () {
        var payload = state.queuedPayloads.first();
        send(payload, state, sendStrategy, {
            onSuccess: function () {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = INITIAL_BACKOFF_TIME;
                retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */, state, sendStrategy, trackType, reportError);
            },
            onFailure: function () {
                state.currentBackoffTime = Math.min(MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
                scheduleRetry(state, sendStrategy, trackType, reportError);
            },
        });
    }, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function (response) {
        state.bandwidthMonitor.remove(payload);
        if (!shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */;
            onSuccess();
        }
        else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus =
                state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */ : 2 /* TransportStatus.DOWN */;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status,
            };
            onFailure();
        }
    });
}
function retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(trackType, " events size queued for upload: ").concat(MAX_QUEUE_BYTES_COUNT / byteUtils/* ONE_MEBI_BYTE */.X9, "MiB"),
            source: error_types/* ErrorSource.AGENT */.z.AGENT,
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = newPayloadQueue();
    while (previousQueue.size() > 0) {
        sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, trackType, reportError);
    }
}
function shouldRetryRequest(response) {
    return (response.type !== 'opaque' &&
        ((response.status === 0 && !navigator.onLine) ||
            response.status === 408 ||
            response.status === 429 ||
            (0,responseUtils/* isServerError */.o)(response.status)));
}
function newRetryState() {
    return {
        transportStatus: 0 /* TransportStatus.UP */,
        currentBackoffTime: INITIAL_BACKOFF_TIME,
        bandwidthMonitor: newBandwidthMonitor(),
        queuedPayloads: newPayloadQueue(),
        queueFullReported: false,
    };
}
function newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function (payload) {
            if (this.isFull()) {
                return;
            }
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function () {
            return queue[0];
        },
        dequeue: function () {
            var payload = queue.shift();
            if (payload) {
                this.bytesCount -= payload.bytesCount;
            }
            return payload;
        },
        size: function () {
            return queue.length;
        },
        isFull: function () {
            return this.bytesCount >= MAX_QUEUE_BYTES_COUNT;
        },
    };
}
function newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function (payload) {
            return (this.ongoingRequestCount === 0 ||
                (this.ongoingByteCount + payload.bytesCount <= MAX_ONGOING_BYTES_COUNT &&
                    this.ongoingRequestCount < MAX_ONGOING_REQUESTS));
        },
        add: function (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
    };
}
//# sourceMappingURL=sendWithRetryStrategy.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.js




function createHttpRequest(configuration, endpointBuilder, bytesLimit, reportError) {
    var retryState = newRetryState();
    var sendStrategyForRetry = function (payload, onResponse) {
        return fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function (payload) {
            sendWithRetryStrategy(payload, retryState, sendStrategyForRetry, endpointBuilder.trackType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: function (payload) {
            sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload);
        },
    };
}
function sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload) {
    var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            var beaconUrl = endpointBuilder.build('beacon', payload);
            var isQueued = navigator.sendBeacon(beaconUrl, payload.data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            reportBeaconError(e);
        }
    }
    var xhrUrl = endpointBuilder.build('xhr', payload);
    sendXHR(configuration, xhrUrl, payload.data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        (0,telemetry/* addTelemetryError */.Sz)(e);
    }
}
function fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse) {
    var canUseKeepAlive = isKeepAliveSupported() && payload.bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build('fetch', payload);
        fetch(fetchUrl, { method: 'POST', body: payload.data, keepalive: true, mode: 'cors' }).then((0,monitor/* monitor */.zk)(function (response) { return onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status, type: response.type }); }), (0,monitor/* monitor */.zk)(function () {
            var xhrUrl = endpointBuilder.build('xhr', payload);
            // failed to queue the request
            sendXHR(configuration, xhrUrl, payload.data, onResponse);
        }));
    }
    else {
        var xhrUrl = endpointBuilder.build('xhr', payload);
        sendXHR(configuration, xhrUrl, payload.data, onResponse);
    }
}
function isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
function sendXHR(configuration, url, data, onResponse) {
    var request = new XMLHttpRequest();
    request.open('POST', url, true);
    if (data instanceof Blob) {
        // When using a Blob instance, IE does not use its 'type' to define the 'Content-Type' header
        // automatically, so the intake request ends up being rejected with an HTTP status 415
        // Defining the header manually fixes this issue.
        request.setRequestHeader('Content-Type', data.type);
    }
    (0,addEventListener/* addEventListener */.Oo)(configuration, request, 'loadend', function () {
        onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: request.status });
    }, {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        once: true,
    });
    request.send(data);
}
//# sourceMappingURL=httpRequest.js.map

/***/ }),

/***/ 21022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ startBatchWithReplica; }
});

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(94776);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var pageExitObservable = __webpack_require__(9024);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js
var jsonStringify = __webpack_require__(19012);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(51962);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/batch.js





var Batch = /** @class */ (function () {
    function Batch(encoder, request, flushController, messageBytesLimit) {
        var _this = this;
        this.encoder = encoder;
        this.request = request;
        this.flushController = flushController;
        this.messageBytesLimit = messageBytesLimit;
        this.upsertBuffer = {};
        this.flushSubscription = this.flushController.flushObservable.subscribe(function (event) { return _this.flush(event); });
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.stop = function () {
        this.flushSubscription.unsubscribe();
    };
    Batch.prototype.flush = function (event) {
        var upsertMessages = (0,polyfills/* objectValues */.TT)(this.upsertBuffer).join('\n');
        this.upsertBuffer = {};
        var isPageExit = (0,pageExitObservable/* isPageExitReason */.PT)(event.reason);
        var send = isPageExit ? this.request.sendOnExit : this.request.send;
        if (isPageExit &&
            // Note: checking that the encoder is async is not strictly needed, but it's an optimization:
            // if the encoder is async we need to send two requests in some cases (one for encoded data
            // and the other for non-encoded data). But if it's not async, we don't have to worry about
            // it and always send a single request.
            this.encoder.isAsync) {
            var encoderResult = this.encoder.finishSync();
            // Send encoded messages
            if (encoderResult.outputBytesCount) {
                send(formatPayloadFromEncoder(encoderResult, event));
            }
            // Send messages that are not yet encoded at this point
            var pendingMessages = [encoderResult.pendingData, upsertMessages].filter(Boolean).join('\n');
            if (pendingMessages) {
                send({
                    data: pendingMessages,
                    bytesCount: (0,byteUtils/* computeBytesCount */.qt)(pendingMessages),
                    flushReason: event.reason,
                });
            }
        }
        else {
            if (upsertMessages) {
                this.encoder.write(this.encoder.isEmpty ? upsertMessages : "\n".concat(upsertMessages));
            }
            this.encoder.finish(function (encoderResult) {
                send(formatPayloadFromEncoder(encoderResult, event));
            });
        }
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var serializedMessage = (0,jsonStringify/* jsonStringify */.l)(message);
        var estimatedMessageBytesCount = this.encoder.estimateEncodedBytesCount(serializedMessage);
        if (estimatedMessageBytesCount >= this.messageBytesLimit) {
            display/* display.warn */.jf.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        this.push(serializedMessage, estimatedMessageBytesCount, key);
    };
    Batch.prototype.push = function (serializedMessage, estimatedMessageBytesCount, key) {
        var _this = this;
        this.flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
        if (key !== undefined) {
            this.upsertBuffer[key] = serializedMessage;
            this.flushController.notifyAfterAddMessage();
        }
        else {
            this.encoder.write(this.encoder.isEmpty ? serializedMessage : "\n".concat(serializedMessage), function (realMessageBytesCount) {
                _this.flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
            });
        }
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesCount = this.encoder.estimateEncodedBytesCount(removedMessage);
        this.flushController.notifyAfterRemoveMessage(messageBytesCount);
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    return Batch;
}());

function formatPayloadFromEncoder(encoderResult, flushEvent) {
    var data;
    if (typeof encoderResult.output === 'string') {
        data = encoderResult.output;
    }
    else {
        data = new Blob([encoderResult.output], {
            // This will set the 'Content-Type: text/plain' header. Reasoning:
            // * The intake rejects the request if there is no content type.
            // * The browser will issue CORS preflight requests if we set it to 'application/json', which
            // could induce higher intake load (and maybe has other impacts).
            // * Also it's not quite JSON, since we are concatenating multiple JSON objects separated by
            // new lines.
            type: 'text/plain',
        });
    }
    return {
        data: data,
        bytesCount: encoderResult.outputBytesCount,
        encoding: encoderResult.encoding,
        flushReason: flushEvent.reason,
    };
}
//# sourceMappingURL=batch.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.js + 1 modules
var httpRequest = __webpack_require__(30481);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(73473);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(65483);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/flushController.js


/**
 * Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
 * to happen. The implementation is designed to support both synchronous and asynchronous usages,
 * but relies on invariants described in each method documentation to keep a coherent state.
 */
function createFlushController(_a) {
    var messagesLimit = _a.messagesLimit, bytesLimit = _a.bytesLimit, durationLimit = _a.durationLimit, pageExitObservable = _a.pageExitObservable, sessionExpireObservable = _a.sessionExpireObservable;
    var pageExitSubscription = pageExitObservable.subscribe(function (event) { return flush(event.reason); });
    var sessionExpireSubscription = sessionExpireObservable.subscribe(function () { return flush('session_expire'); });
    var flushObservable = new observable/* Observable */.y(function () { return function () {
        pageExitSubscription.unsubscribe();
        sessionExpireSubscription.unsubscribe();
    }; });
    var currentBytesCount = 0;
    var currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) {
            return;
        }
        var messagesCount = currentMessagesCount;
        var bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount,
        });
    }
    var durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) {
            durationLimitTimeoutId = (0,timer/* setTimeout */.iK)(function () {
                flush('duration_limit');
            }, durationLimit);
        }
    }
    function cancelDurationLimitTimeout() {
        (0,timer/* clearTimeout */.gr)(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        get messagesCount() {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         *
         * @param estimatedMessageBytesCount: an estimation of the message bytes count once it is
         * actually added.
         */
        notifyBeforeAddMessage: function (estimatedMessageBytesCount) {
            if (currentBytesCount + estimatedMessageBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += estimatedMessageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         *
         * @param messageBytesCountDiff: the difference between the estimated message bytes count and
         * its actual bytes count once added to the pool.
         */
        notifyAfterAddMessage: function (messageBytesCountDiff) {
            if (messageBytesCountDiff === void 0) { messageBytesCountDiff = 0; }
            currentBytesCount += messageBytesCountDiff;
            if (currentMessagesCount >= messagesLimit) {
                flush('messages_limit');
            }
            else if (currentBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         *
         * @param messageBytesCount: the message bytes count that was added to the pool. Should
         * correspond to the sum of bytes counts passed to `notifyBeforeAddMessage` and
         * `notifyAfterAddMessage`.
         */
        notifyAfterRemoveMessage: function (messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) {
                cancelDurationLimitTimeout();
            }
        },
    };
}
//# sourceMappingURL=flushController.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js



function startBatchWithReplica(configuration, primary, replica, reportError, pageExitObservable, sessionExpireObservable) {
    var primaryBatch = createBatch(configuration, primary);
    var replicaBatch = replica && createBatch(configuration, replica);
    function createBatch(configuration, _a) {
        var endpoint = _a.endpoint, encoder = _a.encoder;
        return new Batch(encoder, (0,httpRequest/* createHttpRequest */.UF)(configuration, endpoint, configuration.batchBytesLimit, reportError), createFlushController({
            messagesLimit: configuration.batchMessagesLimit,
            bytesLimit: configuration.batchBytesLimit,
            durationLimit: configuration.flushTimeout,
            pageExitObservable: pageExitObservable,
            sessionExpireObservable: sessionExpireObservable,
        }), configuration.messageBytesLimit);
    }
    return {
        flushObservable: primaryBatch.flushController.flushObservable,
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(replica.transformMessage ? replica.transformMessage(message) : message);
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(replica.transformMessage ? replica.transformMessage(message) : message, key);
            }
        },
        stop: function () {
            primaryBatch.stop();
            replicaBatch === null || replicaBatch === void 0 ? void 0 : replicaBatch.stop();
        },
    };
}
//# sourceMappingURL=startBatchWithReplica.js.map

/***/ }),

/***/ 67020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fy": function() { return /* binding */ datadogLogs; }
});

// UNUSED EXPORTS: HandlerType, Logger, StatusType

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/boot/init.js
var init = __webpack_require__(8678);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/getGlobalObject.js
var getGlobalObject = __webpack_require__(49271);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/contextManager.js
var contextManager = __webpack_require__(6129);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var boundedBuffer = __webpack_require__(68783);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/mergeInto.js
var mergeInto = __webpack_require__(92904);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(76876);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/storedContextManager.js
var storedContextManager = __webpack_require__(10311);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.js
var sanitize = __webpack_require__(68566);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/user/user.js
var user = __webpack_require__(54910);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(94776);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(51962);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js + 3 modules
var configuration_configuration = __webpack_require__(59665);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js
var reportObservable = __webpack_require__(73670);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/arrayUtils.js

function removeDuplicates(array) {
    var set = new Set();
    array.forEach(function (item) { return set.add(item); });
    return (0,polyfills/* arrayFrom */.Oc)(set);
}
//# sourceMappingURL=arrayUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/configuration.js

/**
 * arbitrary value, byte precision not needed
 */
var DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT = 32 * byteUtils/* ONE_KIBI_BYTE */.Hi;
function validateAndBuildLogsConfiguration(initConfiguration) {
    var baseConfiguration = (0,configuration_configuration/* validateAndBuildConfiguration */.fP)(initConfiguration);
    var forwardConsoleLogs = validateAndBuildForwardOption(initConfiguration.forwardConsoleLogs, (0,polyfills/* objectValues */.TT)(display/* ConsoleApiName */.vA), 'Forward Console Logs');
    var forwardReports = validateAndBuildForwardOption(initConfiguration.forwardReports, (0,polyfills/* objectValues */.TT)(reportObservable/* RawReportType */._), 'Forward Reports');
    if (!baseConfiguration || !forwardConsoleLogs || !forwardReports) {
        return;
    }
    if (initConfiguration.forwardErrorsToLogs && !(0,polyfills/* includes */.q9)(forwardConsoleLogs, display/* ConsoleApiName.error */.vA.error)) {
        forwardConsoleLogs.push(display/* ConsoleApiName.error */.vA.error);
    }
    return (0,polyfills/* assign */.f0)({
        forwardErrorsToLogs: initConfiguration.forwardErrorsToLogs !== false,
        forwardConsoleLogs: forwardConsoleLogs,
        forwardReports: forwardReports,
        requestErrorResponseLengthLimit: DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT,
    }, baseConfiguration);
}
function validateAndBuildForwardOption(option, allowedValues, label) {
    if (option === undefined) {
        return [];
    }
    if (!(option === 'all' || (Array.isArray(option) && option.every(function (api) { return (0,polyfills/* includes */.q9)(allowedValues, api); })))) {
        display/* display.error */.jf.error("".concat(label, " should be \"all\" or an array with allowed values \"").concat(allowedValues.join('", "'), "\""));
        return;
    }
    return option === 'all' ? allowedValues : removeDuplicates(option);
}
function serializeLogsConfiguration(configuration) {
    var baseSerializedInitConfiguration = (0,configuration_configuration/* serializeConfiguration */.JZ)(configuration);
    return (0,polyfills/* assign */.f0)({
        forward_errors_to_logs: configuration.forwardErrorsToLogs,
        forward_console_logs: configuration.forwardConsoleLogs,
        forward_reports: configuration.forwardReports,
    }, baseSerializedInitConfiguration);
}
//# sourceMappingURL=configuration.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/computeStackTrace.js
var computeStackTrace = __webpack_require__(70340);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.js
var error_error = __webpack_require__(45242);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(42419);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/logger.js
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var StatusType = {
    debug: 'debug',
    error: 'error',
    info: 'info',
    warn: 'warn',
};
var HandlerType = {
    console: 'console',
    http: 'http',
    silent: 'silent',
};
var STATUSES = Object.keys(StatusType);
var Logger = /** @class */ (function () {
    function Logger(handleLogStrategy, name, handlerType, level, loggerContext) {
        if (handlerType === void 0) { handlerType = HandlerType.http; }
        if (level === void 0) { level = StatusType.debug; }
        if (loggerContext === void 0) { loggerContext = {}; }
        this.handleLogStrategy = handleLogStrategy;
        this.handlerType = handlerType;
        this.level = level;
        this.contextManager = (0,contextManager/* createContextManager */.W)(3 /* CustomerDataType.LoggerContext */);
        this.contextManager.setContext(loggerContext);
        if (name) {
            this.contextManager.setContextProperty('logger', { name: name });
        }
    }
    Logger.prototype.log = function (message, messageContext, status, error) {
        if (status === void 0) { status = StatusType.info; }
        var errorContext;
        if (error !== undefined && error !== null) {
            var stackTrace = error instanceof Error ? (0,computeStackTrace/* computeStackTrace */._)(error) : undefined;
            var rawError = (0,error_error/* computeRawError */.AP)({
                stackTrace: stackTrace,
                originalError: error,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: error_types/* ErrorSource.LOGGER */.z.LOGGER,
                handling: "handled" /* ErrorHandling.HANDLED */,
                startClocks: (0,timeUtils/* clocksNow */.$I)(),
            });
            errorContext = {
                stack: rawError.stack,
                kind: rawError.type,
                message: rawError.message,
            };
        }
        var sanitizedMessageContext = (0,sanitize/* sanitize */.N)(messageContext);
        var context = errorContext
            ? (0,mergeInto/* combine */.$e)({ error: errorContext }, sanitizedMessageContext)
            : sanitizedMessageContext;
        this.handleLogStrategy({
            message: (0,sanitize/* sanitize */.N)(message),
            context: context,
            status: status,
        }, this);
    };
    Logger.prototype.debug = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.debug, error);
    };
    Logger.prototype.info = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.info, error);
    };
    Logger.prototype.warn = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.warn, error);
    };
    Logger.prototype.error = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.error, error);
    };
    Logger.prototype.setContext = function (context) {
        this.contextManager.setContext(context);
    };
    Logger.prototype.getContext = function () {
        return this.contextManager.getContext();
    };
    Logger.prototype.setContextProperty = function (key, value) {
        this.contextManager.setContextProperty(key, value);
    };
    Logger.prototype.removeContextProperty = function (key) {
        this.contextManager.removeContextProperty(key);
    };
    Logger.prototype.clearContext = function () {
        this.contextManager.clearContext();
    };
    Logger.prototype.setHandler = function (handler) {
        this.handlerType = handler;
    };
    Logger.prototype.getHandler = function () {
        return this.handlerType;
    };
    Logger.prototype.setLevel = function (level) {
        this.level = level;
    };
    Logger.prototype.getLevel = function () {
        return this.level;
    };
    __decorate([
        monitor/* monitored */.Th
    ], Logger.prototype, "log", null);
    return Logger;
}());

//# sourceMappingURL=logger.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/boot/logsPublicApi.js



var LOGS_STORAGE_KEY = 'logs';
function makeLogsPublicApi(startLogsImpl) {
    var isAlreadyInitialized = false;
    var globalContextManager = (0,contextManager/* createContextManager */.W)(2 /* CustomerDataType.GlobalContext */);
    var userContextManager = (0,contextManager/* createContextManager */.W)(1 /* CustomerDataType.User */);
    var customLoggers = {};
    var getInternalContextStrategy = function () { return undefined; };
    var beforeInitLoggerLog = new boundedBuffer/* BoundedBuffer */.S();
    var handleLogStrategy = function (logsMessage, logger, savedCommonContext, date) {
        if (savedCommonContext === void 0) { savedCommonContext = (0,mergeInto/* deepClone */.I8)(buildCommonContext()); }
        if (date === void 0) { date = (0,timeUtils/* timeStampNow */.n$)(); }
        beforeInitLoggerLog.add(function () { return handleLogStrategy(logsMessage, logger, savedCommonContext, date); });
    };
    var getInitConfigurationStrategy = function () { return undefined; };
    var mainLogger = new Logger(function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return handleLogStrategy.apply(void 0, params);
    });
    function buildCommonContext() {
        return {
            view: {
                referrer: document.referrer,
                url: window.location.href,
            },
            context: globalContextManager.getContext(),
            user: userContextManager.getContext(),
        };
    }
    return (0,init/* makePublicApi */.r)({
        logger: mainLogger,
        init: (0,monitor/* monitor */.zk)(function (initConfiguration) {
            var _a;
            if (!initConfiguration) {
                display/* display.error */.jf.error('Missing configuration');
                return;
            }
            // This function should be available, regardless of initialization success.
            getInitConfigurationStrategy = function () { return (0,mergeInto/* deepClone */.I8)(initConfiguration); };
            if ((0,eventBridge/* canUseEventBridge */.x)()) {
                initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
            }
            if (!canInitLogs(initConfiguration)) {
                return;
            }
            var configuration = validateAndBuildLogsConfiguration(initConfiguration);
            if (!configuration) {
                return;
            }
            if (initConfiguration.storeContextsAcrossPages) {
                var beforeInitGlobalContext = globalContextManager.getContext();
                globalContextManager = (0,storedContextManager/* createStoredContextManager */.PI)(configuration, LOGS_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
                globalContextManager.setContext((0,mergeInto/* combine */.$e)(globalContextManager.getContext(), beforeInitGlobalContext));
                var beforeInitUserContext = userContextManager.getContext();
                userContextManager = (0,storedContextManager/* createStoredContextManager */.PI)(configuration, LOGS_STORAGE_KEY, 1 /* CustomerDataType.User */);
                userContextManager.setContext((0,mergeInto/* combine */.$e)(userContextManager.getContext(), beforeInitUserContext));
            }
            ;
            (_a = startLogsImpl(initConfiguration, configuration, buildCommonContext), handleLogStrategy = _a.handleLog, getInternalContextStrategy = _a.getInternalContext);
            beforeInitLoggerLog.drain();
            isAlreadyInitialized = true;
        }),
        getGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.getContext(); }),
        setGlobalContext: (0,monitor/* monitor */.zk)(function (context) { return globalContextManager.setContext(context); }),
        setGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key, value) { return globalContextManager.setContextProperty(key, value); }),
        removeGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key) { return globalContextManager.removeContextProperty(key); }),
        clearGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.clearContext(); }),
        createLogger: (0,monitor/* monitor */.zk)(function (name, conf) {
            if (conf === void 0) { conf = {}; }
            customLoggers[name] = new Logger(function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                return handleLogStrategy.apply(void 0, params);
            }, (0,sanitize/* sanitize */.N)(name), conf.handler, conf.level, (0,sanitize/* sanitize */.N)(conf.context));
            return customLoggers[name];
        }),
        getLogger: (0,monitor/* monitor */.zk)(function (name) { return customLoggers[name]; }),
        getInitConfiguration: (0,monitor/* monitor */.zk)(function () { return getInitConfigurationStrategy(); }),
        getInternalContext: (0,monitor/* monitor */.zk)(function (startTime) { return getInternalContextStrategy(startTime); }),
        setUser: (0,monitor/* monitor */.zk)(function (newUser) {
            if ((0,user/* checkUser */.z)(newUser)) {
                userContextManager.setContext((0,user/* sanitizeUser */.I)(newUser));
            }
        }),
        getUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.getContext(); }),
        setUserProperty: (0,monitor/* monitor */.zk)(function (key, property) {
            var _a;
            var sanitizedProperty = (0,user/* sanitizeUser */.I)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0,monitor/* monitor */.zk)(function (key) { return userContextManager.removeContextProperty(key); }),
        clearUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.clearContext(); }),
    });
    function overrideInitConfigurationForBridge(initConfiguration) {
        return (0,polyfills/* assign */.f0)({}, initConfiguration, { clientToken: 'empty' });
    }
    function canInitLogs(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                display/* display.error */.jf.error('DD_LOGS is already initialized.');
            }
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=logsPublicApi.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(38971);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry_telemetry = __webpack_require__(18797);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var browser_pageExitObservable = __webpack_require__(9024);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js
var syntheticsWorkerValues = __webpack_require__(99262);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js + 2 modules
var startBatchWithReplica = __webpack_require__(21022);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/encoder.js
var encoder = __webpack_require__(83895);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js
var session_sessionManager = __webpack_require__(5135);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(73473);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(73603);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/logsSessionManager.js

var LOGS_SESSION_KEY = 'logs';
function startLogsSessionManager(configuration) {
    var sessionManager = (0,session_sessionManager/* startSessionManager */.HX)(configuration, LOGS_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            return session && session.trackingType === "1" /* LoggerTrackingType.TRACKED */
                ? {
                    id: session.id,
                }
                : undefined;
        },
        expireObservable: sessionManager.expireObservable,
    };
}
function startLogsSessionManagerStub(configuration) {
    var isTracked = computeTrackingType(configuration) === "1" /* LoggerTrackingType.TRACKED */;
    var session = isTracked ? {} : undefined;
    return {
        findTrackedSession: function () { return session; },
        expireObservable: new observable/* Observable */.y(),
    };
}
function computeTrackingType(configuration) {
    if (!(0,numberUtils/* performDraw */.y7)(configuration.sessionSampleRate)) {
        return "0" /* LoggerTrackingType.NOT_TRACKED */;
    }
    return "1" /* LoggerTrackingType.TRACKED */;
}
function computeSessionState(configuration, rawSessionType) {
    var trackingType = hasValidLoggerSession(rawSessionType) ? rawSessionType : computeTrackingType(configuration);
    return {
        trackingType: trackingType,
        isTracked: trackingType === "1" /* LoggerTrackingType.TRACKED */,
    };
}
function hasValidLoggerSession(trackingType) {
    return trackingType === "0" /* LoggerTrackingType.NOT_TRACKED */ || trackingType === "1" /* LoggerTrackingType.TRACKED */;
}
//# sourceMappingURL=logsSessionManager.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.js
var createEventRateLimiter = __webpack_require__(15123);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(94162);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/assembly.js


function startLogsAssembly(sessionManager, configuration, lifeCycle, buildCommonContext, reportError) {
    var statusWithCustom = STATUSES.concat(['custom']);
    var logRateLimiters = {};
    statusWithCustom.forEach(function (status) {
        logRateLimiters[status] = (0,createEventRateLimiter/* createEventRateLimiter */.K)(status, configuration.eventRateLimiterThreshold, reportError);
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, function (_a) {
        var _b, _c;
        var rawLogsEvent = _a.rawLogsEvent, _d = _a.messageContext, messageContext = _d === void 0 ? undefined : _d, _e = _a.savedCommonContext, savedCommonContext = _e === void 0 ? undefined : _e;
        var startTime = (0,timeUtils/* getRelativeTime */.ni)(rawLogsEvent.date);
        var session = sessionManager.findTrackedSession(startTime);
        if (!session) {
            return;
        }
        var commonContext = savedCommonContext || buildCommonContext();
        var log = (0,mergeInto/* combine */.$e)({
            service: configuration.service,
            session_id: session.id,
            // Insert user first to allow overrides from global context
            usr: !(0,objectUtils/* isEmptyObject */.Qr)(commonContext.user) ? commonContext.user : undefined,
            view: commonContext.view,
        }, commonContext.context, getRUMInternalContext(startTime), rawLogsEvent, messageContext);
        if (((_b = configuration.beforeSend) === null || _b === void 0 ? void 0 : _b.call(configuration, log)) === false ||
            (log.origin !== error_types/* ErrorSource.AGENT */.z.AGENT &&
                ((_c = logRateLimiters[log.status]) !== null && _c !== void 0 ? _c : logRateLimiters['custom']).isLimitReached())) {
            return;
        }
        lifeCycle.notify(1 /* LifeCycleEventType.LOG_COLLECTED */, log);
    });
}
var logsSentBeforeRumInjectionTelemetryAdded = false;
function getRUMInternalContext(startTime) {
    var browserWindow = window;
    if ((0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()) {
        var context = getInternalContextFromRumGlobal(browserWindow.DD_RUM_SYNTHETICS);
        if (!context && !logsSentBeforeRumInjectionTelemetryAdded) {
            logsSentBeforeRumInjectionTelemetryAdded = true;
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Logs sent before RUM is injected by the synthetics worker', {
                testId: (0,syntheticsWorkerValues/* getSyntheticsTestId */.L7)(),
                resultId: (0,syntheticsWorkerValues/* getSyntheticsResultId */.QB)(),
            });
        }
        return context;
    }
    return getInternalContextFromRumGlobal(browserWindow.DD_RUM);
    function getInternalContextFromRumGlobal(rumGlobal) {
        if (rumGlobal && rumGlobal.getInternalContext) {
            return rumGlobal.getInternalContext(startTime);
        }
    }
}
function resetRUMInternalContext() {
    logsSentBeforeRumInjectionTelemetryAdded = false;
}
//# sourceMappingURL=assembly.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js
var consoleObservable = __webpack_require__(86296);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/console/consoleCollection.js
var _a;


var LogStatusForApi = (_a = {},
    _a[display/* ConsoleApiName.log */.vA.log] = StatusType.info,
    _a[display/* ConsoleApiName.debug */.vA.debug] = StatusType.debug,
    _a[display/* ConsoleApiName.info */.vA.info] = StatusType.info,
    _a[display/* ConsoleApiName.warn */.vA.warn] = StatusType.warn,
    _a[display/* ConsoleApiName.error */.vA.error] = StatusType.error,
    _a);
function startConsoleCollection(configuration, lifeCycle) {
    var consoleSubscription = (0,consoleObservable/* initConsoleObservable */.a)(configuration.forwardConsoleLogs).subscribe(function (log) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: (0,timeUtils/* timeStampNow */.n$)(),
                message: log.message,
                origin: error_types/* ErrorSource.CONSOLE */.z.CONSOLE,
                error: log.api === display/* ConsoleApiName.error */.vA.error
                    ? {
                        stack: log.stack,
                        fingerprint: log.fingerprint,
                    }
                    : undefined,
                status: LogStatusForApi[log.api],
            },
        });
    });
    return {
        stop: function () {
            consoleSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=consoleCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/report/reportCollection.js
var reportCollection_a;


var LogStatusForReport = (reportCollection_a = {},
    reportCollection_a[reportObservable/* RawReportType.cspViolation */._.cspViolation] = StatusType.error,
    reportCollection_a[reportObservable/* RawReportType.intervention */._.intervention] = StatusType.error,
    reportCollection_a[reportObservable/* RawReportType.deprecation */._.deprecation] = StatusType.warn,
    reportCollection_a);
function startReportCollection(configuration, lifeCycle) {
    var reportSubscription = (0,reportObservable/* initReportObservable */.v)(configuration, configuration.forwardReports).subscribe(function (report) {
        var message = report.message;
        var status = LogStatusForReport[report.type];
        var error;
        if (status === StatusType.error) {
            error = {
                kind: report.subtype,
                stack: report.stack,
            };
        }
        else if (report.stack) {
            message += " Found in ".concat((0,error_error/* getFileFromStackTraceString */.u5)(report.stack));
        }
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: (0,timeUtils/* timeStampNow */.n$)(),
                message: message,
                origin: error_types/* ErrorSource.REPORT */.z.REPORT,
                error: error,
                status: status,
            },
        });
    });
    return {
        stop: function () {
            reportSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=reportCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(251);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/xhrObservable.js
var xhrObservable = __webpack_require__(5343);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/fetchObservable.js
var fetchObservable = __webpack_require__(18679);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
var responseUtils = __webpack_require__(29100);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js
var readBytesFromStream = __webpack_require__(18057);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/networkError/networkErrorCollection.js


function startNetworkErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: functionUtils/* noop */.Z };
    }
    var xhrSubscription = (0,xhrObservable/* initXhrObservable */.S)(configuration).subscribe(function (context) {
        if (context.state === 'complete') {
            handleResponse("xhr" /* RequestType.XHR */, context);
        }
    });
    var fetchSubscription = (0,fetchObservable/* initFetchObservable */.y)().subscribe(function (context) {
        if (context.state === 'resolve') {
            handleResponse("fetch" /* RequestType.FETCH */, context);
        }
    });
    function handleResponse(type, request) {
        if (!configuration.isIntakeUrl(request.url) && (isRejected(request) || (0,responseUtils/* isServerError */.o)(request.status))) {
            if ('xhr' in request) {
                computeXhrResponseData(request.xhr, configuration, onResponseDataAvailable);
            }
            else if (request.response) {
                computeFetchResponseText(request.response, configuration, onResponseDataAvailable);
            }
            else if (request.error) {
                computeFetchErrorText(request.error, configuration, onResponseDataAvailable);
            }
        }
        function onResponseDataAvailable(responseData) {
            lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
                rawLogsEvent: {
                    message: "".concat(format(type), " error ").concat(request.method, " ").concat(request.url),
                    date: request.startClocks.timeStamp,
                    error: {
                        stack: responseData || 'Failed to load',
                    },
                    http: {
                        method: request.method,
                        status_code: request.status,
                        url: request.url,
                    },
                    status: StatusType.error,
                    origin: error_types/* ErrorSource.NETWORK */.z.NETWORK,
                },
            });
        }
    }
    return {
        stop: function () {
            xhrSubscription.unsubscribe();
            fetchSubscription.unsubscribe();
        },
    };
}
// TODO: ideally, computeXhrResponseData should always call the callback with a string instead of
// `unknown`. But to keep backward compatibility, in the case of XHR with a `responseType` different
// than "text", the response data should be whatever `xhr.response` is. This is a bit confusing as
// Logs event 'stack' is expected to be a string. This should be changed in a future major version
// as it could be a breaking change.
function computeXhrResponseData(xhr, configuration, callback) {
    if (typeof xhr.response === 'string') {
        callback(truncateResponseText(xhr.response, configuration));
    }
    else {
        callback(xhr.response);
    }
}
function computeFetchErrorText(error, configuration, callback) {
    callback(truncateResponseText((0,error_error/* toStackTraceString */.P3)((0,computeStackTrace/* computeStackTrace */._)(error)), configuration));
}
function computeFetchResponseText(response, configuration, callback) {
    var clonedResponse = (0,responseUtils/* tryToClone */.u)(response);
    if (!clonedResponse || !clonedResponse.body) {
        // if the clone failed or if the body is null, let's not try to read it.
        callback();
    }
    else if (!window.TextDecoder) {
        // If the browser doesn't support TextDecoder, let's read the whole response then truncate it.
        //
        // This should only be the case on early versions of Edge (before they migrated to Chromium).
        // Even if it could be possible to implement a workaround for the missing TextDecoder API (using
        // a Blob and FileReader), we found another issue preventing us from reading only the first
        // bytes from the response: contrary to other browsers, when reading from the cloned response,
        // if the original response gets canceled, the cloned response is also canceled and we can't
        // know about it.  In the following illustration, the promise returned by `reader.read()` may
        // never be fulfilled:
        //
        // fetch('/').then((response) => {
        //   const reader = response.clone().body.getReader()
        //   readMore()
        //   function readMore() {
        //     reader.read().then(
        //       (result) => {
        //         if (result.done) {
        //           console.log('done')
        //         } else {
        //           readMore()
        //         }
        //       },
        //       () => console.log('error')
        //     )
        //   }
        //   response.body.getReader().cancel()
        // })
        clonedResponse.text().then((0,monitor/* monitor */.zk)(function (text) { return callback(truncateResponseText(text, configuration)); }), (0,monitor/* monitor */.zk)(function (error) { return callback("Unable to retrieve response: ".concat(error)); }));
    }
    else {
        truncateResponseStream(clonedResponse.body, configuration.requestErrorResponseLengthLimit, function (error, responseText) {
            if (error) {
                callback("Unable to retrieve response: ".concat(error));
            }
            else {
                callback(responseText);
            }
        });
    }
}
function isRejected(request) {
    return request.status === 0 && request.responseType !== 'opaque';
}
function truncateResponseText(responseText, configuration) {
    if (responseText.length > configuration.requestErrorResponseLengthLimit) {
        return "".concat(responseText.substring(0, configuration.requestErrorResponseLengthLimit), "...");
    }
    return responseText;
}
function format(type) {
    if ("xhr" /* RequestType.XHR */ === type) {
        return 'XHR';
    }
    return 'Fetch';
}
function truncateResponseStream(stream, bytesLimit, callback) {
    (0,readBytesFromStream/* readBytesFromStream */.n)(stream, function (error, bytes, limitExceeded) {
        if (error) {
            callback(error);
        }
        else {
            var responseText = new TextDecoder().decode(bytes);
            if (limitExceeded) {
                responseText += '...';
            }
            callback(undefined, responseText);
        }
    }, {
        bytesLimit: bytesLimit,
        collectStreamBody: true,
    });
}
//# sourceMappingURL=networkErrorCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js
var trackRuntimeError = __webpack_require__(21315);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/runtimeError/runtimeErrorCollection.js


function startRuntimeErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: functionUtils/* noop */.Z };
    }
    var rawErrorObservable = new observable/* Observable */.y();
    var stopRuntimeErrorTracking = (0,trackRuntimeError/* trackRuntimeError */.Lp)(rawErrorObservable).stop;
    var rawErrorSubscription = rawErrorObservable.subscribe(function (rawError) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: rawError.message,
                date: rawError.startClocks.timeStamp,
                error: {
                    kind: rawError.type,
                    stack: rawError.stack,
                },
                origin: error_types/* ErrorSource.SOURCE */.z.SOURCE,
                status: StatusType.error,
            },
        });
    });
    return {
        stop: function () {
            stopRuntimeErrorTracking();
            rawErrorSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=runtimeErrorCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.js
var abstractLifeCycle = __webpack_require__(29307);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/lifeCycle.js

var LifeCycle = (abstractLifeCycle/* AbstractLifeCycle */.l);
//# sourceMappingURL=lifeCycle.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/logger/loggerCollection.js
var loggerCollection_a;


var STATUS_PRIORITIES = (loggerCollection_a = {},
    loggerCollection_a[StatusType.debug] = 0,
    loggerCollection_a[StatusType.info] = 1,
    loggerCollection_a[StatusType.warn] = 2,
    loggerCollection_a[StatusType.error] = 3,
    loggerCollection_a);
function startLoggerCollection(lifeCycle) {
    function handleLog(logsMessage, logger, savedCommonContext, savedDate) {
        var messageContext = (0,mergeInto/* combine */.$e)(logger.getContext(), logsMessage.context);
        if (isAuthorized(logsMessage.status, HandlerType.console, logger)) {
            displayInConsole(logsMessage, messageContext);
        }
        if (isAuthorized(logsMessage.status, HandlerType.http, logger)) {
            lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
                rawLogsEvent: {
                    date: savedDate || (0,timeUtils/* timeStampNow */.n$)(),
                    message: logsMessage.message,
                    status: logsMessage.status,
                    origin: error_types/* ErrorSource.LOGGER */.z.LOGGER,
                },
                messageContext: messageContext,
                savedCommonContext: savedCommonContext,
            });
        }
    }
    return {
        handleLog: handleLog,
    };
}
function isAuthorized(status, handlerType, logger) {
    var loggerHandler = logger.getHandler();
    var sanitizedHandlerType = Array.isArray(loggerHandler) ? loggerHandler : [loggerHandler];
    return (STATUS_PRIORITIES[status] >= STATUS_PRIORITIES[logger.getLevel()] && (0,polyfills/* includes */.q9)(sanitizedHandlerType, handlerType));
}
function displayInConsole(logsMessage, messageContext) {
    display/* originalConsoleMethods */.LD[logsMessage.status].call(display/* globalConsole */.jG, logsMessage.message, messageContext);
}
//# sourceMappingURL=loggerCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/transport/startLogsBatch.js

function startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable, sessionExpireObservable) {
    var batch = (0,startBatchWithReplica/* startBatchWithReplica */.W)(configuration, {
        endpoint: configuration.logsEndpointBuilder,
        encoder: (0,encoder/* createIdentityEncoder */.G)(),
    }, configuration.replica && {
        endpoint: configuration.replica.logsEndpointBuilder,
        encoder: (0,encoder/* createIdentityEncoder */.G)(),
    }, reportError, pageExitObservable, sessionExpireObservable);
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (serverLogsEvent) {
        batch.add(serverLogsEvent);
    });
    return batch;
}
//# sourceMappingURL=startLogsBatch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/transport/startLogsBridge.js

function startLogsBridge(lifeCycle) {
    var bridge = (0,eventBridge/* getEventBridge */.A)();
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (serverLogsEvent) {
        bridge.send('log', serverLogsEvent);
    });
}
//# sourceMappingURL=startLogsBridge.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/internalContext.js
function startInternalContext(sessionManager) {
    return {
        get: function (startTime) {
            var trackedSession = sessionManager.findTrackedSession(startTime);
            if (trackedSession) {
                return {
                    session_id: trackedSession.id,
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/boot/startLogs.js














function startLogs(initConfiguration, configuration, buildCommonContext) {
    var lifeCycle = new LifeCycle();
    var cleanupTasks = [];
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (log) { return (0,sendToExtension/* sendToExtension */.j)('logs', log); });
    var reportError = function (error) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: error.message,
                date: error.startClocks.timeStamp,
                origin: error_types/* ErrorSource.AGENT */.z.AGENT,
                status: StatusType.error,
            },
        });
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
    var pageExitObservable = (0,browser_pageExitObservable/* createPageExitObservable */.Pd)(configuration);
    var session = configuration.sessionStoreStrategyType && !(0,eventBridge/* canUseEventBridge */.x)() && !(0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()
        ? startLogsSessionManager(configuration)
        : startLogsSessionManagerStub(configuration);
    var _a = startLogsTelemetry(configuration, reportError, pageExitObservable, session.expireObservable), telemetry = _a.telemetry, stopLogsTelemetry = _a.stop;
    cleanupTasks.push(function () { return stopLogsTelemetry(); });
    telemetry.setContextProvider(function () {
        var _a, _b, _c, _d, _e, _f;
        return ({
            application: {
                id: (_a = getRUMInternalContext()) === null || _a === void 0 ? void 0 : _a.application_id,
            },
            session: {
                id: (_b = session.findTrackedSession()) === null || _b === void 0 ? void 0 : _b.id,
            },
            view: {
                id: (_d = (_c = getRUMInternalContext()) === null || _c === void 0 ? void 0 : _c.view) === null || _d === void 0 ? void 0 : _d.id,
            },
            action: {
                id: (_f = (_e = getRUMInternalContext()) === null || _e === void 0 ? void 0 : _e.user_action) === null || _f === void 0 ? void 0 : _f.id,
            },
        });
    });
    startNetworkErrorCollection(configuration, lifeCycle);
    startRuntimeErrorCollection(configuration, lifeCycle);
    startConsoleCollection(configuration, lifeCycle);
    startReportCollection(configuration, lifeCycle);
    var handleLog = startLoggerCollection(lifeCycle).handleLog;
    startLogsAssembly(session, configuration, lifeCycle, buildCommonContext, reportError);
    if (!(0,eventBridge/* canUseEventBridge */.x)()) {
        var stopLogsBatch_1 = startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable, session.expireObservable).stop;
        cleanupTasks.push(function () { return stopLogsBatch_1(); });
    }
    else {
        startLogsBridge(lifeCycle);
    }
    (0,telemetry_telemetry/* addTelemetryConfiguration */.Uo)(serializeLogsConfiguration(initConfiguration));
    var internalContext = startInternalContext(session);
    return {
        handleLog: handleLog,
        getInternalContext: internalContext.get,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
function startLogsTelemetry(configuration, reportError, pageExitObservable, sessionExpireObservable) {
    var telemetry = (0,telemetry_telemetry/* startTelemetry */.VL)("browser-logs-sdk" /* TelemetryService.LOGS */, configuration);
    var cleanupTasks = [];
    if ((0,eventBridge/* canUseEventBridge */.x)()) {
        var bridge_1 = (0,eventBridge/* getEventBridge */.A)();
        var telemetrySubscription_1 = telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
        cleanupTasks.push(function () { return telemetrySubscription_1.unsubscribe(); });
    }
    else {
        var telemetryBatch_1 = (0,startBatchWithReplica/* startBatchWithReplica */.W)(configuration, {
            endpoint: configuration.rumEndpointBuilder,
            encoder: (0,encoder/* createIdentityEncoder */.G)(),
        }, configuration.replica && {
            endpoint: configuration.replica.rumEndpointBuilder,
            encoder: (0,encoder/* createIdentityEncoder */.G)(),
        }, reportError, pageExitObservable, sessionExpireObservable);
        cleanupTasks.push(function () { return telemetryBatch_1.stop(); });
        var telemetrySubscription_2 = telemetry.observable.subscribe(function (event) {
            return telemetryBatch_1.add(event, (0,telemetry_telemetry/* isTelemetryReplicationAllowed */.VG)(configuration));
        });
        cleanupTasks.push(function () { return telemetrySubscription_2.unsubscribe(); });
    }
    return {
        telemetry: telemetry,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
//# sourceMappingURL=startLogs.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/entries/main.js




var datadogLogs = makeLogsPublicApi(startLogs);
(0,init/* defineGlobal */.y)((0,getGlobalObject/* getGlobalObject */.R)(), 'DD_LOGS', datadogLogs);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 60507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ datadogRum; }
});

// UNUSED EXPORTS: DefaultPrivacyLevel

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/boot/init.js
var init = __webpack_require__(8678);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/getGlobalObject.js
var getGlobalObject = __webpack_require__(49271);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/contextManager.js
var contextManager = __webpack_require__(6129);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(251);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var boundedBuffer = __webpack_require__(68783);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(25026);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/mergeInto.js
var mergeInto = __webpack_require__(92904);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js
var syntheticsWorkerValues = __webpack_require__(99262);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(76876);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/storedContextManager.js
var storedContextManager = __webpack_require__(10311);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/encoder.js
var encoder = __webpack_require__(83895);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.js
var sanitize = __webpack_require__(68566);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.js
var error_error = __webpack_require__(45242);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/user/user.js
var user = __webpack_require__(54910);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(94776);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(73603);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js + 3 modules
var configuration_configuration = __webpack_require__(59665);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(94162);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/typeUtils.js
var typeUtils = __webpack_require__(33234);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/matchOption.js



function isMatchOption(item) {
    var itemType = (0,typeUtils/* getType */.o)(item);
    return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith) {
    if (useStartsWith === void 0) { useStartsWith = false; }
    return list.some(function (item) {
        try {
            if (typeof item === 'function') {
                return item(value);
            }
            else if (item instanceof RegExp) {
                return item.test(value);
            }
            else if (typeof item === 'string') {
                return useStartsWith ? (0,polyfills/* startsWith */.Ny)(value, item) : item === value;
            }
        }
        catch (e) {
            display/* display.error */.jf.error(e);
        }
        return false;
    });
}
//# sourceMappingURL=matchOption.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/tracer.js

function isTracingOption(item) {
    var expectedItem = item;
    return ((0,typeUtils/* getType */.o)(expectedItem) === 'object' &&
        isMatchOption(expectedItem.match) &&
        Array.isArray(expectedItem.propagatorTypes));
}
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function startTracer(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: clearTracingIfNeeded,
        traceFetch: function (context) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function (key) {
                        ;
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                }
                else {
                    context.init = (0,objectUtils/* shallowClone */.mv)(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) {
                        context.init.headers.forEach(function (value, key) {
                            headers_1.push([key, value]);
                        });
                    }
                    else if (Array.isArray(context.init.headers)) {
                        context.init.headers.forEach(function (header) {
                            headers_1.push(header);
                        });
                    }
                    else if (context.init.headers) {
                        Object.keys(context.init.headers).forEach(function (key) {
                            headers_1.push([key, context.init.headers[key]]);
                        });
                    }
                    context.init.headers = headers_1.concat((0,polyfills/* objectEntries */.qP)(tracingHeaders));
                }
            });
        },
        traceXhr: function (context, xhr) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function (name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        },
    };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!isTracingSupported() || !sessionManager.findTrackedSession()) {
        return;
    }
    var tracingOption = (0,polyfills/* find */.sE)(configuration.allowedTracingUrls, function (tracingOption) {
        return matchList([tracingOption.match], context.url, true);
    });
    if (!tracingOption) {
        return;
    }
    context.traceId = new TraceIdentifier();
    context.spanId = new TraceIdentifier();
    context.traceSampled = !(0,numberUtils/* isNumber */.hj)(configuration.traceSampleRate) || (0,numberUtils/* performDraw */.y7)(configuration.traceSampleRate);
    inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function isTracingSupported() {
    return getCrypto() !== undefined;
}
function getCrypto() {
    return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
    var tracingHeaders = {};
    propagatorTypes.forEach(function (propagatorType) {
        switch (propagatorType) {
            case 'datadog': {
                (0,polyfills/* assign */.f0)(tracingHeaders, {
                    'x-datadog-origin': 'rum',
                    'x-datadog-parent-id': spanId.toDecimalString(),
                    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
                    'x-datadog-trace-id': traceId.toDecimalString(),
                });
                break;
            }
            // https://www.w3.org/TR/trace-context/
            case 'tracecontext': {
                (0,polyfills/* assign */.f0)(tracingHeaders, {
                    traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            // https://github.com/openzipkin/b3-propagation
            case 'b3': {
                (0,polyfills/* assign */.f0)(tracingHeaders, {
                    b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            case 'b3multi': {
                (0,polyfills/* assign */.f0)(tracingHeaders, {
                    'X-B3-TraceId': traceId.toPaddedHexadecimalString(),
                    'X-B3-SpanId': spanId.toPaddedHexadecimalString(),
                    'X-B3-Sampled': traceSampled ? '1' : '0',
                });
                break;
            }
        }
    });
    return tracingHeaders;
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */ (function () {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function (radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = '';
        do {
            var mod = (high % radix) * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        } while (high || low);
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */
    TraceIdentifier.prototype.toDecimalString = function () {
        return this.toString(10);
    };
    /**
     * Format used by OTel headers
     */
    TraceIdentifier.prototype.toPaddedHexadecimalString = function () {
        var traceId = this.toString(16);
        return Array(17 - traceId.length).join('0') + traceId;
    };
    TraceIdentifier.prototype.readInt32 = function (offset) {
        return (this.buffer[offset] * 16777216 +
            (this.buffer[offset + 1] << 16) +
            (this.buffer[offset + 2] << 8) +
            this.buffer[offset + 3]);
    };
    return TraceIdentifier;
}());

/* eslint-enable no-bitwise */
//# sourceMappingURL=tracer.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration.js


var DEFAULT_PROPAGATOR_TYPES = ['tracecontext', 'datadog'];
function validateAndBuildRumConfiguration(initConfiguration) {
    var _a, _b;
    if (!initConfiguration.applicationId) {
        display/* display.error */.jf.error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (initConfiguration.sessionReplaySampleRate !== undefined &&
        !(0,numberUtils/* isPercentage */.zz)(initConfiguration.sessionReplaySampleRate)) {
        display/* display.error */.jf.error('Session Replay Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.traceSampleRate !== undefined && !(0,numberUtils/* isPercentage */.zz)(initConfiguration.traceSampleRate)) {
        display/* display.error */.jf.error('Trace Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        display/* display.error */.jf.error('Excluded Activity Urls should be an array');
        return;
    }
    var allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) {
        return;
    }
    var baseConfiguration = (0,configuration_configuration/* validateAndBuildConfiguration */.fP)(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    return (0,polyfills/* assign */.f0)({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        sessionReplaySampleRate: (_a = initConfiguration.sessionReplaySampleRate) !== null && _a !== void 0 ? _a : 0,
        startSessionReplayRecordingManually: !!initConfiguration.startSessionReplayRecordingManually,
        traceSampleRate: initConfiguration.traceSampleRate,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_b = initConfiguration.excludedActivityUrls) !== null && _b !== void 0 ? _b : [],
        workerUrl: initConfiguration.workerUrl,
        compressIntakeRequests: !!initConfiguration.compressIntakeRequests,
        trackUserInteractions: !!initConfiguration.trackUserInteractions,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: !!initConfiguration.trackResources,
        trackLongTasks: !!initConfiguration.trackLongTasks,
        subdomain: initConfiguration.subdomain,
        defaultPrivacyLevel: (0,objectUtils/* objectHasValue */.E5)(configuration_configuration/* DefaultPrivacyLevel */.Jj, initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : configuration_configuration/* DefaultPrivacyLevel.MASK */.Jj.MASK,
        customerDataTelemetrySampleRate: 1,
    }, baseConfiguration);
}
/**
 * Validates allowedTracingUrls and converts match options to tracing options
 */
function validateAndBuildTracingOptions(initConfiguration) {
    if (initConfiguration.allowedTracingUrls !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
            display/* display.error */.jf.error('Allowed Tracing URLs should be an array');
            return;
        }
        if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
            display/* display.error */.jf.error('Service needs to be configured when tracing is enabled');
            return;
        }
        // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
        var tracingOptions_1 = [];
        initConfiguration.allowedTracingUrls.forEach(function (option) {
            if (isMatchOption(option)) {
                tracingOptions_1.push({ match: option, propagatorTypes: DEFAULT_PROPAGATOR_TYPES });
            }
            else if (isTracingOption(option)) {
                tracingOptions_1.push(option);
            }
            else {
                display/* display.warn */.jf.warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
            }
        });
        return tracingOptions_1;
    }
    return [];
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls
 */
function getSelectedTracingPropagators(configuration) {
    var usedTracingPropagators = new Set();
    if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) {
        configuration.allowedTracingUrls.forEach(function (option) {
            if (isMatchOption(option)) {
                DEFAULT_PROPAGATOR_TYPES.forEach(function (propagatorType) { return usedTracingPropagators.add(propagatorType); });
            }
            else if ((0,typeUtils/* getType */.o)(option) === 'object' && Array.isArray(option.propagatorTypes)) {
                // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
                option.propagatorTypes.forEach(function (propagatorType) { return usedTracingPropagators.add(propagatorType); });
            }
        });
    }
    return (0,polyfills/* arrayFrom */.Oc)(usedTracingPropagators);
}
function serializeRumConfiguration(configuration) {
    var baseSerializedConfiguration = (0,configuration_configuration/* serializeConfiguration */.JZ)(configuration);
    return (0,polyfills/* assign */.f0)({
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
        trace_sample_rate: configuration.traceSampleRate,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
        selected_tracing_propagators: getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        use_excluded_activity_urls: Array.isArray(configuration.excludedActivityUrls) && configuration.excludedActivityUrls.length > 0,
        use_worker_url: !!configuration.workerUrl,
        compress_intake_requests: configuration.compressIntakeRequests,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: configuration.trackUserInteractions,
        track_resources: configuration.trackResources,
        track_long_task: configuration.trackLongTasks,
    }, baseSerializedConfiguration);
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/commonContext.js
function buildCommonContext(globalContextManager, userContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined,
    };
}
//# sourceMappingURL=commonContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/rumPublicApi.js



var RUM_STORAGE_KEY = 'rum';
function makeRumPublicApi(startRumImpl, recorderApi, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.ignoreInitIfSyntheticsWillInjectRum, ignoreInitIfSyntheticsWillInjectRum = _c === void 0 ? true : _c, startDeflateWorker = _b.startDeflateWorker, createDeflateEncoder = _b.createDeflateEncoder;
    var isAlreadyInitialized = false;
    var globalContextManager = (0,contextManager/* createContextManager */.W)(2 /* CustomerDataType.GlobalContext */);
    var userContextManager = (0,contextManager/* createContextManager */.W)(1 /* CustomerDataType.User */);
    var getInternalContextStrategy = function () { return undefined; };
    var getInitConfigurationStrategy = function () { return undefined; };
    var stopSessionStrategy = functionUtils/* noop */.Z;
    var getSessionReplayLinkStrategy = function () { return undefined; };
    var bufferApiCalls = new boundedBuffer/* BoundedBuffer */.S();
    var addTimingStrategy = function (name, time) {
        if (time === void 0) { time = (0,timeUtils/* timeStampNow */.n$)(); }
        bufferApiCalls.add(function () { return addTimingStrategy(name, time); });
    };
    var startViewStrategy = function (options, startClocks) {
        if (startClocks === void 0) { startClocks = (0,timeUtils/* clocksNow */.$I)(); }
        bufferApiCalls.add(function () { return startViewStrategy(options, startClocks); });
    };
    var addActionStrategy = function (action, commonContext) {
        if (commonContext === void 0) { commonContext = buildCommonContext(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addActionStrategy(action, commonContext); });
    };
    var addErrorStrategy = function (providedError, commonContext) {
        if (commonContext === void 0) { commonContext = buildCommonContext(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addErrorStrategy(providedError, commonContext); });
    };
    var recorderStartStrategy = function () {
        bufferApiCalls.add(function () { return recorderStartStrategy(); });
    };
    var recorderStopStrategy = function () {
        bufferApiCalls.add(function () { return recorderStopStrategy(); });
    };
    var addFeatureFlagEvaluationStrategy = function (key, value) {
        bufferApiCalls.add(function () { return addFeatureFlagEvaluationStrategy(key, value); });
    };
    var deflateWorker;
    function initRum(initConfiguration) {
        if (!initConfiguration) {
            display/* display.error */.jf.error('Missing configuration');
            return;
        }
        // This function should be available, regardless of initialization success.
        getInitConfigurationStrategy = function () { return (0,mergeInto/* deepClone */.I8)(initConfiguration); };
        // If we are in a Synthetics test configured to automatically inject a RUM instance, we want to
        // completely discard the customer application RUM instance by ignoring their init() call.  But,
        // we should not ignore the init() call from the Synthetics-injected RUM instance, so the
        // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
        if (ignoreInitIfSyntheticsWillInjectRum && (0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()) {
            return;
        }
        var eventBridgeAvailable = (0,eventBridge/* canUseEventBridge */.x)();
        if (eventBridgeAvailable) {
            initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
        }
        if (!canInitRum(initConfiguration)) {
            return;
        }
        var configuration = validateAndBuildRumConfiguration(initConfiguration);
        if (!configuration) {
            return;
        }
        if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
            display/* display.warn */.jf.warn('No storage available for session. We will not send any data.');
            return;
        }
        if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
            deflateWorker = startDeflateWorker(configuration, 'Datadog RUM', 
            // Worker initialization can fail asynchronously, especially in Firefox where even CSP
            // issues are reported asynchronously. For now, the SDK will continue its execution even if
            // data won't be sent to Datadog. We could improve this behavior in the future.
            functionUtils/* noop */.Z);
            if (!deflateWorker) {
                // `startDeflateWorker` should have logged an error message explaining the issue
                return;
            }
        }
        if (!configuration.trackViewsManually) {
            doStartRum(initConfiguration, configuration);
        }
        else {
            // drain beforeInitCalls by buffering them until we start RUM
            // if we get a startView, drain re-buffered calls before continuing to drain beforeInitCalls
            // in order to ensure that calls are processed in order
            var beforeInitCalls = bufferApiCalls;
            bufferApiCalls = new boundedBuffer/* BoundedBuffer */.S();
            startViewStrategy = function (options) {
                doStartRum(initConfiguration, configuration, options);
            };
            beforeInitCalls.drain();
        }
        isAlreadyInitialized = true;
    }
    function doStartRum(initConfiguration, configuration, initialViewOptions) {
        if (initConfiguration.storeContextsAcrossPages) {
            var beforeInitGlobalContext = globalContextManager.getContext();
            globalContextManager = (0,storedContextManager/* createStoredContextManager */.PI)(configuration, RUM_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
            globalContextManager.setContext((0,mergeInto/* combine */.$e)(globalContextManager.getContext(), beforeInitGlobalContext));
            var beforeInitUserContext = userContextManager.getContext();
            userContextManager = (0,storedContextManager/* createStoredContextManager */.PI)(configuration, RUM_STORAGE_KEY, 1 /* CustomerDataType.User */);
            userContextManager.setContext((0,mergeInto/* combine */.$e)(userContextManager.getContext(), beforeInitUserContext));
        }
        var startRumResults = startRumImpl(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions, deflateWorker && createDeflateEncoder
            ? function (streamId) { return createDeflateEncoder(configuration, deflateWorker, streamId); }
            : encoder/* createIdentityEncoder */.G);
        getSessionReplayLinkStrategy = function () {
            return recorderApi.getSessionReplayLink(configuration, startRumResults.session, startRumResults.viewContexts);
        };
        recorderStartStrategy = recorderApi.start;
        recorderStopStrategy = recorderApi.stop;
        (startViewStrategy = startRumResults.startView, addActionStrategy = startRumResults.addAction, addErrorStrategy = startRumResults.addError, addTimingStrategy = startRumResults.addTiming, addFeatureFlagEvaluationStrategy = startRumResults.addFeatureFlagEvaluation, getInternalContextStrategy = startRumResults.getInternalContext, stopSessionStrategy = startRumResults.stopSession);
        recorderApi.onRumStart(startRumResults.lifeCycle, configuration, startRumResults.session, startRumResults.viewContexts, deflateWorker);
        bufferApiCalls.drain();
    }
    var startView = (0,monitor/* monitor */.zk)(function (options) {
        var sanitizedOptions = typeof options === 'object' ? options : { name: options };
        startViewStrategy(sanitizedOptions);
    });
    var rumPublicApi = (0,init/* makePublicApi */.r)({
        init: (0,monitor/* monitor */.zk)(initRum),
        setGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key, value) { return globalContextManager.setContextProperty(key, value); }),
        removeGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key) { return globalContextManager.removeContextProperty(key); }),
        getGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.getContext(); }),
        setGlobalContext: (0,monitor/* monitor */.zk)(function (context) { return globalContextManager.setContext(context); }),
        clearGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.clearContext(); }),
        getInternalContext: (0,monitor/* monitor */.zk)(function (startTime) { return getInternalContextStrategy(startTime); }),
        getInitConfiguration: (0,monitor/* monitor */.zk)(function () { return getInitConfigurationStrategy(); }),
        addAction: (0,monitor/* monitor */.zk)(function (name, context) {
            addActionStrategy({
                name: (0,sanitize/* sanitize */.N)(name),
                context: (0,sanitize/* sanitize */.N)(context),
                startClocks: (0,timeUtils/* clocksNow */.$I)(),
                type: "custom" /* ActionType.CUSTOM */,
            });
        }),
        addError: function (error, context) {
            var handlingStack = (0,error_error/* createHandlingStack */.Xp)();
            (0,monitor/* callMonitored */.L6)(function () {
                addErrorStrategy({
                    error: error,
                    handlingStack: handlingStack,
                    context: (0,sanitize/* sanitize */.N)(context),
                    startClocks: (0,timeUtils/* clocksNow */.$I)(),
                });
            });
        },
        addTiming: (0,monitor/* monitor */.zk)(function (name, time) {
            addTimingStrategy((0,sanitize/* sanitize */.N)(name), time);
        }),
        setUser: (0,monitor/* monitor */.zk)(function (newUser) {
            if ((0,user/* checkUser */.z)(newUser)) {
                userContextManager.setContext((0,user/* sanitizeUser */.I)(newUser));
            }
        }),
        getUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.getContext(); }),
        setUserProperty: (0,monitor/* monitor */.zk)(function (key, property) {
            var _a;
            var sanitizedProperty = (0,user/* sanitizeUser */.I)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0,monitor/* monitor */.zk)(function (key) { return userContextManager.removeContextProperty(key); }),
        clearUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.clearContext(); }),
        startView: startView,
        stopSession: (0,monitor/* monitor */.zk)(function () {
            stopSessionStrategy();
        }),
        startSessionReplayRecording: (0,monitor/* monitor */.zk)(function () { return recorderStartStrategy(); }),
        stopSessionReplayRecording: (0,monitor/* monitor */.zk)(function () { return recorderStopStrategy(); }),
        /**
         * This feature is currently in beta. For more information see the full [feature flag tracking guide](https://docs.datadoghq.com/real_user_monitoring/feature_flag_tracking/).
         */
        addFeatureFlagEvaluation: (0,monitor/* monitor */.zk)(function (key, value) {
            addFeatureFlagEvaluationStrategy((0,sanitize/* sanitize */.N)(key), (0,sanitize/* sanitize */.N)(value));
        }),
        getSessionReplayLink: (0,monitor/* monitor */.zk)(function () { return getSessionReplayLinkStrategy(); }),
    });
    return rumPublicApi;
    function canInitRum(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                display/* display.error */.jf.error('DD_RUM is already initialized.');
            }
            return false;
        }
        return true;
    }
    function overrideInitConfigurationForBridge(initConfiguration) {
        return (0,polyfills/* assign */.f0)({}, initConfiguration, {
            applicationId: '00000000-aaaa-0000-aaaa-000000000000',
            clientToken: 'empty',
            sessionSampleRate: 100,
        });
    }
}
//# sourceMappingURL=rumPublicApi.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(38971);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry_telemetry = __webpack_require__(18797);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var browser_pageExitObservable = __webpack_require__(9024);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js
var tools_observable = __webpack_require__(73473);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/getZoneJsOriginalValue.js
var getZoneJsOriginalValue = __webpack_require__(59693);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/domMutationObservable.js

function createDOMMutationObservable() {
    var MutationObserver = getMutationObserverConstructor();
    var observable = new tools_observable/* Observable */.y(function () {
        if (!MutationObserver) {
            return;
        }
        var observer = new MutationObserver((0,monitor/* monitor */.zk)(function () { return observable.notify(); }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return function () { return observer.disconnect(); };
    });
    return observable;
}
function getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = (0,getZoneJsOriginalValue/* getZoneJsOriginalValue */.I)(browserWindow, 'MutationObserver');
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            var patchedInstance = new browserWindow.MutationObserver(functionUtils/* noop */.Z);
            var originalInstance = (0,getZoneJsOriginalValue/* getZoneJsOriginalValue */.I)(patchedInstance, 'originalInstance');
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}
//# sourceMappingURL=domMutationObservable.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(65483);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/addEventListener.js
var addEventListener = __webpack_require__(83206);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/runOnReadyState.js

function runOnReadyState(configuration, expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? addEventListener/* DOM_EVENT.LOAD */.EZ.LOAD : addEventListener/* DOM_EVENT.DOM_CONTENT_LOADED */.EZ.DOM_CONTENT_LOADED;
        (0,addEventListener/* addEventListener */.Oo)(configuration, window, eventName, callback, { once: true });
    }
}
//# sourceMappingURL=runOnReadyState.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/urlPolyfill.js
var urlPolyfill = __webpack_require__(70170);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/resourceUtils.js

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [
    ["document" /* ResourceType.DOCUMENT */, function (initiatorType) { return FAKE_INITIAL_DOCUMENT === initiatorType; }],
    ["xhr" /* ResourceType.XHR */, function (initiatorType) { return 'xmlhttprequest' === initiatorType; }],
    ["fetch" /* ResourceType.FETCH */, function (initiatorType) { return 'fetch' === initiatorType; }],
    ["beacon" /* ResourceType.BEACON */, function (initiatorType) { return 'beacon' === initiatorType; }],
    ["css" /* ResourceType.CSS */, function (_, path) { return /\.css$/i.test(path); }],
    ["js" /* ResourceType.JS */, function (_, path) { return /\.js$/i.test(path); }],
    [
        "image" /* ResourceType.IMAGE */,
        function (initiatorType, path) {
            return (0,polyfills/* includes */.q9)(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        },
    ],
    ["font" /* ResourceType.FONT */, function (_, path) { return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null; }],
    [
        "media" /* ResourceType.MEDIA */,
        function (initiatorType, path) {
            return (0,polyfills/* includes */.q9)(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        },
    ],
];
function computeResourceKind(timing) {
    var url = timing.name;
    if (!(0,urlPolyfill/* isValidUrl */.jv)(url)) {
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)("Failed to construct URL for \"".concat(timing.name, "\""));
        return "other" /* ResourceType.OTHER */;
    }
    var path = (0,urlPolyfill/* getPathName */.ye)(url);
    for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) {
            return type;
        }
    }
    return "other" /* ResourceType.OTHER */;
}
function areInOrder() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    for (var i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isRequestKind(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(startTime, responseEnd));
    }
    return (0,timeUtils/* toServerDuration */.c0)(duration);
}
function computePerformanceResourceDetails(entry) {
    var validEntry = toValidEntry(entry);
    if (!validEntry) {
        return undefined;
    }
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (areInOrder(connectStart, secureConnectionStart, connectEnd)) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    if (hasRedirection(entry)) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
function toValidEntry(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    if (!areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) {
        return undefined;
    }
    if (!hasRedirection(entry)) {
        return entry;
    }
    var redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd;
    // Firefox doesn't provide redirect timings on cross origin requests.
    // Provide a default for those.
    if (redirectStart < entry.startTime) {
        redirectStart = entry.startTime;
    }
    if (redirectEnd < entry.startTime) {
        redirectEnd = entry.fetchStart;
    }
    // Make sure redirect timings are in order
    if (!areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) {
        return undefined;
    }
    return (0,polyfills/* assign */.f0)({}, entry, {
        redirectEnd: redirectEnd,
        redirectStart: redirectStart,
    });
}
function hasRedirection(entry) {
    // The only time fetchStart is different than startTime is if a redirection occurred.
    return entry.fetchStart !== entry.startTime;
}
function formatTiming(origin, start, end) {
    return {
        duration: (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(start, end)),
        start: (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(origin, start)),
    };
}
function computeSize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        return entry.decodedBodySize;
    }
    return undefined;
}
function isAllowedRequestUrl(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}
//# sourceMappingURL=resourceUtils.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
var stringUtils = __webpack_require__(88129);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/htmlDomUtils.js
function isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function isCommentNode(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function isNodeShadowHost(node) {
    return isElementNode(node) && Boolean(node.shadowRoot);
}
function isNodeShadowRoot(node) {
    var shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
function hasChildNodes(node) {
    return node.childNodes.length > 0 || isNodeShadowHost(node);
}
function forEachChildNodes(node, callback) {
    node.childNodes.forEach(callback);
    if (isNodeShadowHost(node)) {
        callback(node.shadowRoot);
    }
}
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
    return isNodeShadowRoot(node) ? node.host : node.parentNode;
}
//# sourceMappingURL=htmlDomUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/getDocumentTraceId.js


var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * timeUtils/* ONE_MINUTE */.yR;
function getDocumentTraceId(document) {
    var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= (0,timeUtils/* dateNow */.m6)() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
    var comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData((0,stringUtils/* findCommaSeparatedValue */.MY)(comment, 'trace-id'), (0,stringUtils/* findCommaSeparatedValue */.MY)(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId: traceId,
        traceTime: traceTime,
    };
}
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for (var i = 0; i < document.childNodes.length; i += 1) {
        var comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            var node = document.body.childNodes[i];
            var comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!isTextNode(node)) {
                break;
            }
        }
    }
}
function getTraceCommentFromNode(node) {
    if (node && isCommentNode(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}
//# sourceMappingURL=getDocumentTraceId.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/performanceCollection.js



// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected performance entry
// eslint-disable-next-line no-restricted-syntax
var RumPerformanceEntryType;
(function (RumPerformanceEntryType) {
    RumPerformanceEntryType["EVENT"] = "event";
    RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
    RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
    RumPerformanceEntryType["LONG_TASK"] = "longtask";
    RumPerformanceEntryType["NAVIGATION"] = "navigation";
    RumPerformanceEntryType["PAINT"] = "paint";
    RumPerformanceEntryType["RESOURCE"] = "resource";
})(RumPerformanceEntryType || (RumPerformanceEntryType = {}));
function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
function startPerformanceCollection(lifeCycle, configuration) {
    retrieveInitialDocumentResourceTiming(configuration, function (timing) {
        handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
    if (supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        (0,timer/* setTimeout */.iK)(function () { return handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1); });
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = (0,monitor/* monitor */.zk)(function (entries) {
            return handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
        });
        var mainEntries = [
            RumPerformanceEntryType.RESOURCE,
            RumPerformanceEntryType.NAVIGATION,
            RumPerformanceEntryType.LONG_TASK,
            RumPerformanceEntryType.PAINT,
        ];
        var experimentalEntries = [
            RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT,
            RumPerformanceEntryType.FIRST_INPUT,
            RumPerformanceEntryType.LAYOUT_SHIFT,
            RumPerformanceEntryType.EVENT,
        ];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function (type) {
                var observer = new window.PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({
                    type: type,
                    buffered: true,
                    // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
                    // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L209
                    durationThreshold: 40,
                });
            });
        }
        catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver = new PerformanceObserver(handlePerformanceEntryList_1);
        mainObserver.observe({ entryTypes: mainEntries });
        if (supportPerformanceObject() && 'addEventListener' in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            (0,addEventListener/* addEventListener */.Oo)(configuration, performance, 'resourcetimingbufferfull', function () {
                performance.clearResourceTimings();
            });
        }
    }
    if (!supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION)) {
        retrieveNavigationTiming(configuration, function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
    if (!supportPerformanceTimingEvent(RumPerformanceEntryType.FIRST_INPUT)) {
        retrieveFirstInputTiming(configuration, function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
}
function retrieveInitialDocumentResourceTiming(configuration, callback) {
    runOnReadyState(configuration, 'interactive', function () {
        var timing;
        var forcedAttributes = {
            entryType: RumPerformanceEntryType.RESOURCE,
            initiatorType: FAKE_INITIAL_DOCUMENT,
            traceId: getDocumentTraceId(document),
            toJSON: function () { return (0,polyfills/* assign */.f0)({}, timing, { toJSON: undefined }); },
        };
        if (supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION) &&
            performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION).length > 0) {
            var navigationEntry = performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION)[0];
            timing = (0,polyfills/* assign */.f0)(navigationEntry.toJSON(), forcedAttributes);
        }
        else {
            var relativePerformanceTiming = computeRelativePerformanceTiming();
            timing = (0,polyfills/* assign */.f0)(relativePerformanceTiming, {
                decodedBodySize: 0,
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0,
            }, forcedAttributes);
        }
        callback(timing);
    });
}
function retrieveNavigationTiming(configuration, callback) {
    function sendFakeTiming() {
        callback((0,polyfills/* assign */.f0)(computeRelativePerformanceTiming(), {
            entryType: RumPerformanceEntryType.NAVIGATION,
        }));
    }
    runOnReadyState(configuration, 'complete', function () {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        (0,timer/* setTimeout */.iK)(sendFakeTiming);
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(configuration, callback) {
    var startTimeStamp = (0,timeUtils/* dateNow */.m6)();
    var timingSent = false;
    var removeEventListeners = (0,addEventListener/* addEventListeners */.yw)(configuration, window, [addEventListener/* DOM_EVENT.CLICK */.EZ.CLICK, addEventListener/* DOM_EVENT.MOUSE_DOWN */.EZ.MOUSE_DOWN, addEventListener/* DOM_EVENT.KEY_DOWN */.EZ.KEY_DOWN, addEventListener/* DOM_EVENT.TOUCH_START */.EZ.TOUCH_START, addEventListener/* DOM_EVENT.POINTER_DOWN */.EZ.POINTER_DOWN], function (evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: RumPerformanceEntryType.FIRST_INPUT,
            processingStart: (0,timeUtils/* relativeNow */._q)(),
            processingEnd: (0,timeUtils/* relativeNow */._q)(),
            startTime: evt.timeStamp,
            duration: 0,
            name: '',
        };
        if (evt.type === addEventListener/* DOM_EVENT.POINTER_DOWN */.EZ.POINTER_DOWN) {
            sendTimingIfPointerIsNotCancelled(configuration, timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true }).stop;
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(configuration, timing) {
        (0,addEventListener/* addEventListeners */.yw)(configuration, window, [addEventListener/* DOM_EVENT.POINTER_UP */.EZ.POINTER_UP, addEventListener/* DOM_EVENT.POINTER_CANCEL */.EZ.POINTER_CANCEL], function (event) {
            if (event.type === addEventListener/* DOM_EVENT.POINTER_UP */.EZ.POINTER_UP) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < (0,timeUtils/* dateNow */.m6)() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
function computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for (var key in timing) {
        if ((0,numberUtils/* isNumber */.hj)(timing[key])) {
            var numberKey = key;
            var timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : (0,timeUtils/* getRelativeTime */.ni)(timingElement);
        }
    }
    return result;
}
function handleRumPerformanceEntries(lifeCycle, configuration, entries) {
    var rumPerformanceEntries = entries.filter(function (entry) {
        return (0,objectUtils/* objectHasValue */.E5)(RumPerformanceEntryType, entry.entryType);
    });
    var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) { return !isIncompleteNavigation(entry) && !isForbiddenResource(configuration, entry); });
    if (rumAllowedPerformanceEntries.length) {
        lifeCycle.notify(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
    }
}
function isIncompleteNavigation(entry) {
    return entry.entryType === RumPerformanceEntryType.NAVIGATION && entry.loadEventEnd <= 0;
}
function isForbiddenResource(configuration, entry) {
    return entry.entryType === RumPerformanceEntryType.RESOURCE && !isAllowedRequestUrl(configuration, entry.name);
}
//# sourceMappingURL=performanceCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.js
var createEventRateLimiter = __webpack_require__(15123);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/syntheticsContext.js

function getSyntheticsContext() {
    var testId = (0,syntheticsWorkerValues/* getSyntheticsTestId */.L7)();
    var resultId = (0,syntheticsWorkerValues/* getSyntheticsResultId */.QB)();
    if (testId && resultId) {
        return {
            test_id: testId,
            result_id: resultId,
            injected: (0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)(),
        };
    }
}
//# sourceMappingURL=syntheticsContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/ciTestContext.js
function getCiTestContext() {
    var _a;
    var testExecutionId = (_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId');
    if (typeof testExecutionId === 'string') {
        return {
            test_execution_id: testExecutionId,
        };
    }
}
//# sourceMappingURL=ciTestContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/limitModification.js

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = (0,mergeInto/* deepClone */.I8)(object);
    var result = modifier(clone);
    (0,polyfills/* objectEntries */.qP)(modifiableFieldPaths).forEach(function (_a) {
        var fieldPath = _a[0], fieldType = _a[1];
        var newValue = get(clone, fieldPath);
        var newType = (0,typeUtils/* getType */.o)(newValue);
        if (newType === fieldType) {
            set(object, fieldPath, (0,sanitize/* sanitize */.N)(newValue));
        }
        else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, fieldPath, {});
        }
    });
    return result;
}
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObject(current)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObject(object) {
    return (0,typeUtils/* getType */.o)(object) === 'object';
}
function isValidObjectContaining(object, field) {
    return isValidObject(object) && Object.prototype.hasOwnProperty.call(object, field);
}
//# sourceMappingURL=limitModification.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/assembly.js




var VIEW_MODIFIABLE_FIELD_PATHS = {
    'view.name': 'string',
    'view.url': 'string',
    'view.referrer': 'string',
};
var USER_CUSTOMIZABLE_FIELD_PATHS = {
    context: 'object',
};
var modifiableFieldPathsByEvent;
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, buildCommonContext, reportError) {
    var _a, _b;
    modifiableFieldPathsByEvent = (_a = {},
        _a["view" /* RumEventType.VIEW */] = VIEW_MODIFIABLE_FIELD_PATHS,
        _a["error" /* RumEventType.ERROR */] = (0,polyfills/* assign */.f0)({
            'error.message': 'string',
            'error.stack': 'string',
            'error.resource.url': 'string',
            'error.fingerprint': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["resource" /* RumEventType.RESOURCE */] = (0,polyfills/* assign */.f0)({
            'resource.url': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["action" /* RumEventType.ACTION */] = (0,polyfills/* assign */.f0)({
            'action.target.name': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["long_task" /* RumEventType.LONG_TASK */] = (0,polyfills/* assign */.f0)({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a);
    var eventRateLimiters = (_b = {},
        _b["error" /* RumEventType.ERROR */] = (0,createEventRateLimiter/* createEventRateLimiter */.K)("error" /* RumEventType.ERROR */, configuration.eventRateLimiterThreshold, reportError),
        _b["action" /* RumEventType.ACTION */] = (0,createEventRateLimiter/* createEventRateLimiter */.K)("action" /* RumEventType.ACTION */, configuration.eventRateLimiterThreshold, reportError),
        _b);
    var syntheticsContext = getSyntheticsContext();
    var ciTestContext = getCiTestContext();
    lifeCycle.subscribe(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = viewContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        var session = sessionManager.findTrackedSession(startTime);
        if (session && viewContext && urlContext) {
            var commonContext = savedCommonContext || buildCommonContext();
            var actionId = actionContexts.findActionId(startTime);
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: (0,timeUtils/* currentDrift */.QA)(),
                    configuration: {
                        session_sample_rate: (0,numberUtils/* round */.NM)(configuration.sessionSampleRate, 3),
                        session_replay_sample_rate: (0,numberUtils/* round */.NM)(configuration.sessionReplaySampleRate, 3),
                    },
                    browser_sdk_version: (0,eventBridge/* canUseEventBridge */.x)() ? "5.4.0" : undefined,
                },
                application: {
                    id: configuration.applicationId,
                },
                date: (0,timeUtils/* timeStampNow */.n$)(),
                service: viewContext.service || configuration.service,
                version: viewContext.version || configuration.version,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SessionType.SYNTHETICS */ : ciTestContext ? "ci_test" /* SessionType.CI_TEST */ : "user" /* SessionType.USER */,
                },
                view: {
                    id: viewContext.id,
                    name: viewContext.name,
                    url: urlContext.url,
                    referrer: urlContext.referrer,
                },
                action: needToAssembleWithAction(rawRumEvent) && actionId ? { id: actionId } : undefined,
                synthetics: syntheticsContext,
                ci_test: ciTestContext,
                display: displayContext.get(),
            };
            var serverRumEvent = (0,mergeInto/* combine */.$e)(rumContext, rawRumEvent);
            serverRumEvent.context = (0,mergeInto/* combine */.$e)(commonContext.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) {
                ;
                serverRumEvent.session.has_replay = commonContext.hasReplay;
            }
            if (serverRumEvent.type === 'view') {
                ;
                serverRumEvent.session.sampled_for_replay = session.sessionReplayAllowed;
            }
            if (!(0,objectUtils/* isEmptyObject */.Qr)(commonContext.user)) {
                ;
                serverRumEvent.usr = commonContext.user;
            }
            if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if ((0,objectUtils/* isEmptyObject */.Qr)(serverRumEvent.context)) {
                    delete serverRumEvent.context;
                }
                lifeCycle.notify(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent);
            }
        }
    });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = limitModification(event, modifiableFieldPathsByEvent[event.type], function (event) {
            return beforeSend(event, domainContext);
        });
        if (result === false && event.type !== "view" /* RumEventType.VIEW */) {
            return false;
        }
        if (result === false) {
            display/* display.warn */.jf.warn("Can't dismiss view events using beforeSend!");
        }
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function needToAssembleWithAction(event) {
    return ["error" /* RumEventType.ERROR */, "resource" /* RumEventType.RESOURCE */, "long_task" /* RumEventType.LONG_TASK */].indexOf(event.type) !== -1;
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/internalContext.js
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = viewContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? { id: actionId } : undefined,
                    view: { id: viewContext.id, name: viewContext.name, referrer: urlContext.referrer, url: urlContext.url },
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.js
var abstractLifeCycle = __webpack_require__(29307);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/lifeCycle.js

var LifeCycle = (abstractLifeCycle/* AbstractLifeCycle */.l);
//# sourceMappingURL=lifeCycle.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var sessionConstants = __webpack_require__(78981);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/valueHistory.js
var valueHistory = __webpack_require__(69029);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/viewContexts.js

var VIEW_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
function startViewContexts(lifeCycle) {
    var viewContextHistory = new valueHistory/* ValueHistory */.P(VIEW_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
        viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        viewContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            service: view.service,
            version: view.version,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks,
        };
    }
    return {
        findView: function (startTime) { return viewContextHistory.find(startTime); },
        stop: function () {
            viewContextHistory.stop();
        },
    };
}
//# sourceMappingURL=viewContexts.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/xhrObservable.js
var xhrObservable = __webpack_require__(5343);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/fetchObservable.js
var fetchObservable = __webpack_require__(18679);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
var responseUtils = __webpack_require__(29100);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js
var readBytesFromStream = __webpack_require__(18057);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/requestCollection.js



var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
    var tracer = startTracer(configuration, sessionManager);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
    var subscription = (0,xhrObservable/* initXhrObservable */.S)(configuration).subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(6 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "xhr" /* RequestType.XHR */,
                    url: context.url,
                    xhr: context.xhr,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function trackFetch(lifeCycle, configuration, tracer) {
    var subscription = (0,fetchObservable/* initFetchObservable */.y)().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'resolve':
                waitForResponseToComplete(context, function (duration) {
                    tracer.clearTracingIfNeeded(context);
                    lifeCycle.notify(6 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                        duration: duration,
                        method: context.method,
                        requestIndex: context.requestIndex,
                        responseType: context.responseType,
                        spanId: context.spanId,
                        startClocks: context.startClocks,
                        status: context.status,
                        traceId: context.traceId,
                        traceSampled: context.traceSampled,
                        type: "fetch" /* RequestType.FETCH */,
                        url: context.url,
                        response: context.response,
                        init: context.init,
                        input: context.input,
                    });
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
function waitForResponseToComplete(context, callback) {
    var clonedResponse = context.response && (0,responseUtils/* tryToClone */.u)(context.response);
    if (!clonedResponse || !clonedResponse.body) {
        // do not try to wait for the response if the clone failed, fetch error or null body
        callback((0,timeUtils/* elapsed */._J)(context.startClocks.timeStamp, (0,timeUtils/* timeStampNow */.n$)()));
    }
    else {
        (0,readBytesFromStream/* readBytesFromStream */.n)(clonedResponse.body, function () {
            callback((0,timeUtils/* elapsed */._J)(context.startClocks.timeStamp, (0,timeUtils/* timeStampNow */.n$)()));
        }, {
            bytesLimit: Number.POSITIVE_INFINITY,
            collectStreamBody: false,
        });
    }
}
//# sourceMappingURL=requestCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/trackEventCounts.js

function trackEventCounts(_a) {
    var lifeCycle = _a.lifeCycle, isChildEvent = _a.isChildEvent, _b = _a.onChange, callback = _b === void 0 ? functionUtils/* noop */.Z : _b;
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0,
    };
    var subscription = lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        var _a;
        if (event.type === 'view' || !isChildEvent(event)) {
            return;
        }
        switch (event.type) {
            case "error" /* RumEventType.ERROR */:
                eventCounts.errorCount += 1;
                callback();
                break;
            case "action" /* RumEventType.ACTION */:
                eventCounts.actionCount += 1;
                if (event.action.frustration) {
                    eventCounts.frustrationCount += event.action.frustration.type.length;
                }
                callback();
                break;
            case "long_task" /* RumEventType.LONG_TASK */:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case "resource" /* RumEventType.RESOURCE */:
                if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
                    eventCounts.resourceCount += 1;
                    callback();
                }
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackEventCounts.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js
var instrumentMethod = __webpack_require__(55801);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/waitPageActivityEnd.js


// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
    var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
    return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    var pageActivityEndTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(function () { return complete({ hadActivity: false }); }), PAGE_ACTIVITY_VALIDATION_DELAY);
    var maxDurationTimeoutId = maxDuration !== undefined
        ? (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(function () { return complete({ hadActivity: true, end: (0,timeUtils/* timeStampNow */.n$)() }); }), maxDuration)
        : undefined;
    var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
        var isBusy = _a.isBusy;
        (0,timer/* clearTimeout */.gr)(validationTimeoutId);
        (0,timer/* clearTimeout */.gr)(pageActivityEndTimeoutId);
        var lastChangeTime = (0,timeUtils/* timeStampNow */.n$)();
        if (!isBusy) {
            pageActivityEndTimeoutId = (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(function () { return complete({ hadActivity: true, end: lastChangeTime }); }), PAGE_ACTIVITY_END_DELAY);
        }
    });
    var stop = function () {
        hasCompleted = true;
        (0,timer/* clearTimeout */.gr)(validationTimeoutId);
        (0,timer/* clearTimeout */.gr)(pageActivityEndTimeoutId);
        (0,timer/* clearTimeout */.gr)(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        pageActivityEndCallback(event);
    }
    return { stop: stop };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
    var observable = new tools_observable/* Observable */.y(function () {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
            if (entries.some(function (entry) { return entry.entryType === RumPerformanceEntryType.RESOURCE && !isExcludedUrl(configuration, entry.name); })) {
                notifyPageActivity();
            }
        }), lifeCycle.subscribe(5 /* LifeCycleEventType.REQUEST_STARTED */, function (startEvent) {
            if (isExcludedUrl(configuration, startEvent.url)) {
                return;
            }
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(6 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
            if (isExcludedUrl(configuration, request.url) ||
                firstRequestIndex === undefined ||
                // If the request started before the tracking start, ignore it
                request.requestIndex < firstRequestIndex) {
                return;
            }
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
        return function () {
            stopTrackingWindowOpen();
            subscriptions.forEach(function (s) { return s.unsubscribe(); });
        };
        function notifyPageActivity() {
            observable.notify({ isBusy: pendingRequestsCount > 0 });
        }
    });
    return observable;
}
function isExcludedUrl(configuration, requestUrl) {
    return matchList(configuration.excludedActivityUrls, requestUrl);
}
function trackWindowOpen(callback) {
    return (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(window, 'open', { before: callback });
}
//# sourceMappingURL=waitPageActivityEnd.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
var browserDetection = __webpack_require__(12172);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/getActionNameFromElement.js

/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
function getActionNameFromElement(element, userProgrammaticAttribute) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return (getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute)) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies) ||
        '');
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if (supportsElementClosest()) {
        elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    }
    else {
        var element = targetElement;
        while (element) {
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = element.parentElement;
        }
    }
    if (!elementWithAttribute) {
        return;
    }
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
    // associated LABEL text
    function (element, userProgrammaticAttribute) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if (supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) {
                return getTextualContent(element.labels[0], userProgrammaticAttribute);
            }
        }
        else if (element.id) {
            var label = element.ownerDocument &&
                (0,polyfills/* find */.sE)(element.ownerDocument.querySelectorAll('label'), function (label) { return label.htmlFor === element.id; });
            return label && getTextualContent(label, userProgrammaticAttribute);
        }
    },
    // INPUT button (and associated) value
    function (element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return input.value;
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    function (element, userProgrammaticAttribute) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getTextualContent(element, userProgrammaticAttribute);
        }
    },
    function (element) { return element.getAttribute('aria-label'); },
    // associated element text designated by the aria-labelledby attribute
    function (element, userProgrammaticAttribute) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return labelledByAttribute
                .split(/\s+/)
                .map(function (id) { return getElementById(element, id); })
                .filter(function (label) { return Boolean(label); })
                .map(function (element) { return getTextualContent(element, userProgrammaticAttribute); })
                .join(' ');
        }
    },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('name'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
    // SELECT first OPTION text
    function (element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) {
            return getTextualContent(element.options[0], userProgrammaticAttribute);
        }
    },
];
var fallbackStrategies = [
    function (element, userProgrammaticAttribute) { return getTextualContent(element, userProgrammaticAttribute); },
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) {
                    return truncate(normalizeWhitespace(trimmedName));
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? "".concat((0,stringUtils/* safeTruncate */._z)(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute) {
    if (element.isContentEditable) {
        return;
    }
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function (query) {
            var list = element.querySelectorAll(query);
            for (var index = 0; index < list.length; index += 1) {
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text_1 = text_1.replace(textToReplace, '');
                    }
                }
            }
        };
        if (!supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            removeTextFromElements('script, style');
        }
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));
        if (userProgrammaticAttribute) {
            removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        }
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
    return !(0,browserDetection/* isIE */.w1)();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
    if (supportsLabelPropertyResult === undefined) {
        supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    }
    return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
    if (supportsElementClosestResult === undefined) {
        supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    }
    return supportsElementClosestResult;
}
//# sourceMappingURL=getActionNameFromElement.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/getSelectorFromElement.js


/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
var STABLE_ATTRIBUTES = [
    DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
    // Common test attributes (list provided by google recorder)
    'data-testid',
    'data-test',
    'data-qa',
    'data-cy',
    'data-test-id',
    'data-qa-id',
    'data-testing',
    // FullStory decorator attributes:
    'data-component',
    'data-element',
    'data-source-file',
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    getStableAttributeSelector,
    getClassSelector,
    getTagNameSelector,
];
function getSelectorFromElement(targetElement, actionNameAttribute) {
    var targetElementSelector = '';
    var element = targetElement;
    while (element && element.nodeName !== 'HTML') {
        var globallyUniqueSelector = findSelector(element, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) {
            return globallyUniqueSelector;
        }
        var uniqueSelectorAmongChildren = findSelector(element, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
        targetElementSelector =
            uniqueSelectorAmongChildren || combineSelector(getPositionSelector(element), targetElementSelector);
        element = element.parentElement;
    }
    return targetElementSelector;
}
function isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if a the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time. We might want to allow customers to
    // provide their own `isGeneratedValue` at some point.
    return /[0-9]/.test(value);
}
function getIDSelector(element) {
    if (element.id && !isGeneratedValue(element.id)) {
        return "#".concat((0,polyfills/* cssEscape */.QA)(element.id));
    }
}
function getClassSelector(element) {
    if (element.tagName === 'BODY') {
        return;
    }
    if (element.classList.length > 0) {
        for (var i = 0; i < element.classList.length; i += 1) {
            var className = element.classList[i];
            if (isGeneratedValue(className)) {
                continue;
            }
            return "".concat((0,polyfills/* cssEscape */.QA)(element.tagName), ".").concat((0,polyfills/* cssEscape */.QA)(className));
        }
    }
}
function getTagNameSelector(element) {
    return (0,polyfills/* cssEscape */.QA)(element.tagName);
}
function getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        var selector = getAttributeSelector(actionNameAttribute);
        if (selector) {
            return selector;
        }
    }
    for (var _i = 0, STABLE_ATTRIBUTES_1 = STABLE_ATTRIBUTES; _i < STABLE_ATTRIBUTES_1.length; _i++) {
        var attributeName = STABLE_ATTRIBUTES_1[_i];
        var selector = getAttributeSelector(attributeName);
        if (selector) {
            return selector;
        }
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) {
            return "".concat((0,polyfills/* cssEscape */.QA)(element.tagName), "[").concat(attributeName, "=\"").concat((0,polyfills/* cssEscape */.QA)(element.getAttribute(attributeName)), "\"]");
        }
    }
}
function getPositionSelector(element) {
    var sibling = element.parentElement.firstElementChild;
    var elementIndex = 1;
    while (sibling && sibling !== element) {
        if (sibling.tagName === element.tagName) {
            elementIndex += 1;
        }
        sibling = sibling.nextElementSibling;
    }
    return "".concat((0,polyfills/* cssEscape */.QA)(element.tagName), ":nth-of-type(").concat(elementIndex, ")");
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
        var selectorGetter = selectorGetters_1[_i];
        var elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) {
            continue;
        }
        var fullSelector = combineSelector(elementSelector, childSelector);
        if (predicate(element, fullSelector)) {
            return fullSelector;
        }
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, selector) {
    return element.ownerDocument.querySelectorAll(selector).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > SELECTOR" returns a single element.
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT SELECTOR" returns a single element), regardless of whether the selector is a
 * direct descendent of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 */
function isSelectorUniqueAmongSiblings(element, selector) {
    return (element.parentElement.querySelectorAll(supportScopeSelector() ? combineSelector(':scope', selector) : selector)
        .length === 1);
}
function combineSelector(parent, child) {
    return child ? "".concat(parent, ">").concat(child) : parent;
}
var supportScopeSelectorCache;
function supportScopeSelector() {
    if (supportScopeSelectorCache === undefined) {
        try {
            document.querySelector(':scope');
            supportScopeSelectorCache = true;
        }
        catch (_a) {
            supportScopeSelectorCache = false;
        }
    }
    return supportScopeSelectorCache;
}
//# sourceMappingURL=getSelectorFromElement.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/clickChain.js

var MAX_DURATION_BETWEEN_CLICKS = timeUtils/* ONE_SECOND */.WT;
var MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
    var bufferedClicks = [];
    var status = 0 /* ClickChainStatus.WaitingForMoreClicks */;
    var maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        (0,timer/* clearTimeout */.gr)(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = (0,timer/* setTimeout */.iK)(dontAcceptMoreClick, MAX_DURATION_BETWEEN_CLICKS);
    }
    function tryFinalize() {
        if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */ && bufferedClicks.every(function (click) { return click.isStopped(); })) {
            status = 2 /* ClickChainStatus.Finalized */;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        (0,timer/* clearTimeout */.gr)(maxDurationBetweenClicksTimeoutId);
        if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */) {
            status = 1 /* ClickChainStatus.WaitingForClicksToStop */;
            tryFinalize();
        }
    }
    return {
        tryAppend: function (click) {
            if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */) {
                return false;
            }
            if (bufferedClicks.length > 0 &&
                !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: function () {
            dontAcceptMoreClick();
        },
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
    return (first.target === second.target &&
        mouseEventDistance(first, second) <= MAX_DISTANCE_BETWEEN_CLICKS &&
        first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS);
}
function mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}
//# sourceMappingURL=clickChain.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/listenActionEvents.js

function listenActionEvents(configuration, _a) {
    var onPointerDown = _a.onPointerDown, onPointerUp = _a.onPointerUp;
    var selectionEmptyAtPointerDown;
    var userActivity = {
        selection: false,
        input: false,
    };
    var clickContext;
    var listeners = [
        (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.POINTER_DOWN */.EZ.POINTER_DOWN, function (event) {
            if (isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                };
                clickContext = onPointerDown(event);
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.SELECTION_CHANGE */.EZ.SELECTION_CHANGE, function () {
            if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
                userActivity.selection = true;
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.POINTER_UP */.EZ.POINTER_UP, function (event) {
            if (isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                var localUserActivity_1 = userActivity;
                onPointerUp(clickContext, event, function () { return localUserActivity_1; });
                clickContext = undefined;
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.INPUT */.EZ.INPUT, function () {
            userActivity.input = true;
        }, { capture: true }),
    ];
    return {
        stop: function () {
            listeners.forEach(function (listener) { return listener.stop(); });
        },
    };
}
function isSelectionEmpty() {
    var selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
    return (event.target instanceof Element &&
        // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
        // the future.
        event.isPrimary !== false);
}
//# sourceMappingURL=listenActionEvents.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/computeFrustration.js

var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
    if (isRage(clicks)) {
        rageClick.addFrustration("rage_click" /* FrustrationType.RAGE_CLICK */);
        if (clicks.some(isDead)) {
            rageClick.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
        if (rageClick.hasError) {
            rageClick.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        return { isRage: true };
    }
    var hasSelectionChanged = clicks.some(function (click) { return click.getUserActivity().selection; });
    clicks.forEach(function (click) {
        if (click.hasError) {
            click.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        if (isDead(click) &&
            // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
            !hasSelectionChanged) {
            click.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
    });
    return { isRage: false };
}
function isRage(clicks) {
    if (clicks.some(function (click) { return click.getUserActivity().selection; })) {
        return false;
    }
    for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
        if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <=
            timeUtils/* ONE_SECOND */.WT) {
            return true;
        }
    }
    return false;
}
var DEAD_CLICK_EXCLUDE_SELECTOR = 
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' +
    'textarea,' +
    'select,' +
    // contenteditable and their descendants don't always trigger meaningful changes when manipulated
    '[contenteditable],' +
    '[contenteditable] *,' +
    // canvas, as there is no good way to detect activity occurring on them
    'canvas,' +
    // links that are interactive (have an href attribute) or any of their descendants, as they can
    // open a new tab or navigate to a hash without triggering a meaningful event
    'a[href],' +
    'a[href] *';
function isDead(click) {
    if (click.hasPageActivity || click.getUserActivity().input) {
        return false;
    }
    return !(0,polyfills/* elementMatches */.Ap)(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}
//# sourceMappingURL=computeFrustration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/trackClickActions.js








// Maximum duration for click actions
var CLICK_ACTION_MAX_DURATION = 10 * timeUtils/* ONE_SECOND */.WT;
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * timeUtils/* ONE_MINUTE */.yR; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
    var history = new valueHistory/* ValueHistory */.P(ACTION_CONTEXT_TIME_OUT_DELAY);
    var stopObservable = new tools_observable/* Observable */.y();
    var currentClickChain;
    lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        history.reset();
    });
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, stopClickChain);
    var stopActionEventsListener = listenActionEvents(configuration, {
        onPointerDown: function (pointerDownEvent) {
            return processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent);
        },
        onPointerUp: function (_a, startEvent, getUserActivity) {
            var clickActionBase = _a.clickActionBase, hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
            return startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        },
    }).stop;
    var actionContexts = {
        findActionId: function (startTime) { return history.findAll(startTime); },
    };
    return {
        stop: function () {
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        },
        actionContexts: actionContexts,
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            var rageClick_1 = click.clone();
            currentClickChain = createClickChain(click, function (clicks) {
                finalizeClicks(clicks, rageClick_1);
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) {
            currentClickChain.stop();
        }
    }
}
function processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent) {
    var clickActionBase = computeClickActionBase(pointerDownEvent, configuration.actionNameAttribute);
    var hadActivityOnPointerDown = false;
    waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, 
    // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    PAGE_ACTIVITY_VALIDATION_DELAY);
    return { clickActionBase: clickActionBase, hadActivityOnPointerDown: function () { return hadActivityOnPointerDown; } };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    appendClickToClickChain(click);
    var stopWaitPageActivityEnd = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
            // If the clock is looking weird, just discard the click
            click.discard();
        }
        else {
            if (pageActivityEndEvent.hadActivity) {
                click.stop(pageActivityEndEvent.end);
            }
            else if (hadActivityOnPointerDown()) {
                click.stop(
                // using the click start as activity end, so the click will have some activity but its
                // duration will be 0 (as the activity started before the click start)
                click.startClocks.timeStamp);
            }
            else {
                click.stop();
            }
        }
    }, CLICK_ACTION_MAX_DURATION).stop;
    var viewEndedSubscription = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        click.stop(endClocks.timeStamp);
    });
    var stopSubscription = stopObservable.subscribe(function () {
        click.stop();
    });
    click.stopObservable.subscribe(function () {
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function computeClickActionBase(event, actionNameAttribute) {
    var rect = event.target.getBoundingClientRect();
    return {
        type: "click" /* ActionType.CLICK */,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: getSelectorFromElement(event.target, actionNameAttribute),
        },
        position: {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top),
        },
        name: getActionNameFromElement(event.target, actionNameAttribute),
    };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
    var id = (0,stringUtils/* generateUUID */.DO)();
    var startClocks = (0,timeUtils/* clocksNow */.$I)();
    var historyEntry = history.add(id, startClocks.relative);
    var eventCountsSubscription = trackEventCounts({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) {
            return event.action !== undefined &&
                (Array.isArray(event.action.id) ? (0,polyfills/* includes */.q9)(event.action.id, id) : event.action.id === id);
        },
    });
    var status = 0 /* ClickStatus.ONGOING */;
    var activityEndTime;
    var frustrationTypes = [];
    var stopObservable = new tools_observable/* Observable */.y();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ClickStatus.ONGOING */) {
            return;
        }
        activityEndTime = newActivityEndTime;
        status = 1 /* ClickStatus.STOPPED */;
        if (activityEndTime) {
            historyEntry.close((0,timeUtils/* getRelativeTime */.ni)(activityEndTime));
        }
        else {
            historyEntry.remove();
        }
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError() {
            return eventCountsSubscription.eventCounts.errorCount > 0;
        },
        get hasPageActivity() {
            return activityEndTime !== undefined;
        },
        getUserActivity: getUserActivity,
        addFrustration: function (frustrationType) {
            frustrationTypes.push(frustrationType);
        },
        startClocks: startClocks,
        isStopped: function () { return status === 1 /* ClickStatus.STOPPED */ || status === 2 /* ClickStatus.FINALIZED */; },
        clone: function () { return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent); },
        validate: function (domEvents) {
            stop();
            if (status !== 1 /* ClickStatus.STOPPED */) {
                return;
            }
            var _a = eventCountsSubscription.eventCounts, resourceCount = _a.resourceCount, errorCount = _a.errorCount, longTaskCount = _a.longTaskCount;
            var clickAction = (0,polyfills/* assign */.f0)({
                type: "click" /* ActionType.CLICK */,
                duration: activityEndTime && (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, activityEndTime),
                startClocks: startClocks,
                id: id,
                frustrationTypes: frustrationTypes,
                counts: {
                    resourceCount: resourceCount,
                    errorCount: errorCount,
                    longTaskCount: longTaskCount,
                },
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
                event: startEvent,
            }, clickActionBase);
            lifeCycle.notify(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, clickAction);
            status = 2 /* ClickStatus.FINALIZED */;
        },
        discard: function () {
            stop();
            status = 2 /* ClickStatus.FINALIZED */;
        },
    };
}
function finalizeClicks(clicks, rageClick) {
    var isRage = computeFrustration(clicks, rageClick).isRage;
    if (isRage) {
        clicks.forEach(function (click) { return click.discard(); });
        rageClick.stop((0,timeUtils/* timeStampNow */.n$)());
        rageClick.validate(clicks.map(function (click) { return click.event; }));
    }
    else {
        rageClick.discard();
        clicks.forEach(function (click) { return click.validate(); });
    }
}
//# sourceMappingURL=trackClickActions.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/actionCollection.js


function startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory) {
    lifeCycle.subscribe(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, function (action) {
        return lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action, pageStateHistory));
    });
    var actionContexts = { findActionId: functionUtils/* noop */.Z };
    if (configuration.trackUserInteractions) {
        actionContexts = trackClickActions(lifeCycle, domMutationObservable, configuration).actionContexts;
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, (0,polyfills/* assign */.f0)({
                savedCommonContext: savedCommonContext,
            }, processAction(action, pageStateHistory)));
        },
        actionContexts: actionContexts,
    };
}
function processAction(action, pageStateHistory) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                id: action.id,
                loading_time: (0,timeUtils/* toServerDuration */.c0)(action.duration),
                frustration: {
                    type: action.frustrationTypes,
                },
                error: {
                    count: action.counts.errorCount,
                },
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
            _dd: {
                action: {
                    target: action.target,
                    position: action.position,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = (0,mergeInto/* combine */.$e)({
        action: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: action.startClocks.timeStamp,
        type: "action" /* RumEventType.ACTION */,
        view: { in_foreground: pageStateHistory.isInActivePageStateAt(action.startClocks.relative) },
    }, autoActionProperties);
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: isAutoAction(action) ? { events: action.events } : {},
    };
}
function isAutoAction(action) {
    return action.type !== "custom" /* ActionType.CUSTOM */;
}
//# sourceMappingURL=actionCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js
var trackRuntimeError = __webpack_require__(21315);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/computeStackTrace.js
var computeStackTrace = __webpack_require__(70340);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(42419);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js
var consoleObservable = __webpack_require__(86296);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/error/trackConsoleError.js

function trackConsoleError(errorObservable) {
    var subscription = (0,consoleObservable/* initConsoleObservable */.a)([display/* ConsoleApiName.error */.vA.error]).subscribe(function (consoleError) {
        return errorObservable.notify({
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
            message: consoleError.message,
            stack: consoleError.stack,
            fingerprint: consoleError.fingerprint,
            source: error_types/* ErrorSource.CONSOLE */.z.CONSOLE,
            handling: "handled" /* ErrorHandling.HANDLED */,
            handlingStack: consoleError.handlingStack,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackConsoleError.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js
var reportObservable = __webpack_require__(73670);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/error/trackReportError.js

function trackReportError(configuration, errorObservable) {
    var subscription = (0,reportObservable/* initReportObservable */.v)(configuration, [
        reportObservable/* RawReportType.cspViolation */._.cspViolation,
        reportObservable/* RawReportType.intervention */._.intervention,
    ]).subscribe(function (reportError) {
        return errorObservable.notify({
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: error_types/* ErrorSource.REPORT */.z.REPORT,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackReportError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/error/errorCollection.js



function startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts) {
    var errorObservable = new tools_observable/* Observable */.y();
    trackConsoleError(errorObservable);
    (0,trackRuntimeError/* trackRuntimeError */.Lp)(errorObservable);
    trackReportError(configuration, errorObservable);
    errorObservable.subscribe(function (error) { return lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error }); });
    return doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts);
}
function doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts) {
    lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, (0,polyfills/* assign */.f0)({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext,
        }, processError(error, pageStateHistory, featureFlagContexts)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var stackTrace = error instanceof Error ? (0,computeStackTrace/* computeStackTrace */._)(error) : undefined;
            var rawError = (0,error_error/* computeRawError */.AP)({
                stackTrace: stackTrace,
                originalError: error,
                handlingStack: handlingStack,
                startClocks: startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: error_types/* ErrorSource.CUSTOM */.z.CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */,
            });
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
function processError(error, pageStateHistory, featureFlagContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
            fingerprint: error.fingerprint,
        },
        type: "error" /* RumEventType.ERROR */,
        view: { in_foreground: pageStateHistory.isInActivePageStateAt(error.startClocks.relative) },
    };
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
    if (featureFlagContext && !(0,objectUtils/* isEmptyObject */.Qr)(featureFlagContext)) {
        rawRumEvent.feature_flags = featureFlagContext;
    }
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: {
            error: error.originalError,
        },
    };
}
//# sourceMappingURL=errorCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/longTask/longTaskCollection.js


function startLongTaskCollection(lifeCycle, configuration, sessionManager) {
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType !== RumPerformanceEntryType.LONG_TASK) {
                break;
            }
            var session = sessionManager.findTrackedSession(entry.startTime);
            if (!session || !configuration.trackLongTasks) {
                break;
            }
            var startClocks = (0,timeUtils/* relativeToClocks */.DY)(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: (0,stringUtils/* generateUUID */.DO)(),
                    duration: (0,timeUtils/* toServerDuration */.c0)(entry.duration),
                },
                type: "long_task" /* RumEventType.LONG_TASK */,
                _dd: {
                    discarded: false,
                },
            };
            lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: { performanceEntry: entry },
            });
        }
    });
}
//# sourceMappingURL=longTaskCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(57549);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/matchRequestTiming.js


/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    var candidates = sameNameEntries
        .map(function (entry) { return entry.toJSON(); })
        .filter(toValidEntry)
        .filter(function (entry) {
        return isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration }));
    });
    if (candidates.length === 1) {
        return candidates[0];
    }
    return;
}
function endTime(timing) {
    return (0,timeUtils/* addDuration */.WK)(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
    var errorMargin = 1;
    return timing.startTime >= start - errorMargin && endTime(timing) <= (0,timeUtils/* addDuration */.WK)(end, errorMargin);
}
//# sourceMappingURL=matchRequestTiming.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/resourceCollection.js




function startResourceCollection(lifeCycle, configuration, sessionManager, pageStateHistory) {
    lifeCycle.subscribe(6 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
        var rawEvent = processRequest(request, configuration, sessionManager, pageStateHistory);
        if (rawEvent) {
            lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
        }
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === RumPerformanceEntryType.RESOURCE && !isRequestKind(entry)) {
                var rawEvent = processResourceEntry(entry, configuration, sessionManager, pageStateHistory);
                if (rawEvent) {
                    lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, rawEvent);
                }
            }
        }
    });
}
function processRequest(request, configuration, sessionManager, pageStateHistory) {
    var _a;
    var matchingTiming = matchRequestTiming(request);
    var startClocks = matchingTiming ? (0,timeUtils/* relativeToClocks */.DY)(matchingTiming.startTime) : request.startClocks;
    var shouldIndex = shouldIndexResource(configuration, sessionManager, startClocks);
    var tracingInfo = computeRequestTracingInfo(request, configuration);
    if (!shouldIndex && !tracingInfo) {
        return;
    }
    var type = request.type === "xhr" /* RequestType.XHR */ ? "xhr" /* ResourceType.XHR */ : "fetch" /* ResourceType.FETCH */;
    var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
    var duration = computeRequestDuration(pageStateHistory, startClocks, request.duration);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, (_a = matchingTiming === null || matchingTiming === void 0 ? void 0 : matchingTiming.duration) !== null && _a !== void 0 ? _a : request.duration);
    var resourceEvent = (0,mergeInto/* combine */.$e)({
        date: startClocks.timeStamp,
        resource: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            type: type,
            duration: duration,
            method: request.method,
            status_code: request.status,
            url: request.url,
        },
        type: "resource" /* RumEventType.RESOURCE */,
        _dd: {
            discarded: !shouldIndex,
        },
    }, tracingInfo, correspondingTimingOverrides, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming,
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
        },
    };
}
function processResourceEntry(entry, configuration, sessionManager, pageStateHistory) {
    var startClocks = (0,timeUtils/* relativeToClocks */.DY)(entry.startTime);
    var shouldIndex = shouldIndexResource(configuration, sessionManager, startClocks);
    var tracingInfo = computeEntryTracingInfo(entry, configuration);
    if (!shouldIndex && !tracingInfo) {
        return;
    }
    var type = computeResourceKind(entry);
    var entryMetrics = computePerformanceEntryMetrics(entry);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, entry.duration);
    var resourceEvent = (0,mergeInto/* combine */.$e)({
        date: startClocks.timeStamp,
        resource: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            type: type,
            url: entry.name,
        },
        type: "resource" /* RumEventType.RESOURCE */,
        _dd: {
            discarded: !shouldIndex,
        },
    }, tracingInfo, entryMetrics, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: entry,
        },
    };
}
function shouldIndexResource(configuration, sessionManager, resourceStart) {
    return configuration.trackResources && sessionManager.findTrackedSession(resourceStart.relative);
}
function computePerformanceEntryMetrics(timing) {
    return {
        resource: (0,polyfills/* assign */.f0)({
            duration: computePerformanceResourceDuration(timing),
            size: computeSize(timing),
        }, computePerformanceResourceDetails(timing)),
    };
}
function computeRequestTracingInfo(request, configuration) {
    var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
            rule_psr: getRulePsr(configuration),
        },
    };
}
function computeEntryTracingInfo(entry, configuration) {
    var hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            trace_id: entry.traceId,
            rule_psr: getRulePsr(configuration),
        },
    };
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */
function getRulePsr(configuration) {
    return (0,numberUtils/* isNumber */.hj)(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function computePageStateInfo(pageStateHistory, startClocks, duration) {
    if (!(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.RESOURCE_PAGE_STATES */.uh.RESOURCE_PAGE_STATES)) {
        return;
    }
    return {
        _dd: {
            page_states: pageStateHistory.findAll(startClocks.relative, duration),
            page_was_discarded: String(document.wasDiscarded),
        },
    };
}
function computeRequestDuration(pageStateHistory, startClocks, duration) {
    var _a;
    var requestCrossedFrozenState = (_a = pageStateHistory
        .findAll(startClocks.relative, duration)) === null || _a === void 0 ? void 0 : _a.some(function (pageState) { return pageState.state === "frozen" /* PageState.FROZEN */; });
    return !requestCrossedFrozenState ? (0,timeUtils/* toServerDuration */.c0)(duration) : undefined;
}
//# sourceMappingURL=resourceCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/trackViewEventCounts.js

function trackViewEventCounts(lifeCycle, viewId, onChange) {
    var _a = trackEventCounts({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) { return event.view.id === viewId; },
        onChange: onChange,
    }), stop = _a.stop, eventCounts = _a.eventCounts;
    return {
        stop: stop,
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackViewEventCounts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstContentfulPaint.js


// Discard FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var FCP_MAXIMUM_DELAY = 10 * timeUtils/* ONE_MINUTE */.yR;
function trackFirstContentfulPaint(lifeCycle, firstHidden, callback) {
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var fcpEntry = (0,polyfills/* find */.sE)(entries, function (entry) {
            return entry.entryType === RumPerformanceEntryType.PAINT &&
                entry.name === 'first-contentful-paint' &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < FCP_MAXIMUM_DELAY;
        });
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    }).unsubscribe;
    return {
        stop: unsubscribeLifeCycle,
    };
}
//# sourceMappingURL=trackFirstContentfulPaint.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstInput.js




/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInput(lifeCycle, configuration, firstHidden, callback) {
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var firstInputEntry = (0,polyfills/* find */.sE)(entries, function (entry) {
            return entry.entryType === RumPerformanceEntryType.FIRST_INPUT && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = (0,timeUtils/* elapsed */._J)(firstInputEntry.startTime, firstInputEntry.processingStart);
            var firstInputTargetSelector = void 0;
            if (firstInputEntry.target && isElementNode(firstInputEntry.target)) {
                firstInputTargetSelector = getSelectorFromElement(firstInputEntry.target, configuration.actionNameAttribute);
            }
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                delay: firstInputDelay >= 0 ? firstInputDelay : 0,
                time: firstInputEntry.startTime,
                targetSelector: firstInputTargetSelector,
            });
        }
    }).unsubscribe;
    return {
        stop: unsubscribeLifeCycle,
    };
}
//# sourceMappingURL=trackFirstInput.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackNavigationTimings.js


function trackNavigationTimings(lifeCycle, callback) {
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === RumPerformanceEntryType.NAVIGATION) {
                callback({
                    domComplete: entry.domComplete,
                    domContentLoaded: entry.domContentLoadedEventEnd,
                    domInteractive: entry.domInteractive,
                    loadEvent: entry.loadEventEnd,
                    // In some cases the value reported is negative or is larger
                    // than the current page time. Ignore these cases:
                    // https://github.com/GoogleChrome/web-vitals/issues/137
                    // https://github.com/GoogleChrome/web-vitals/issues/162
                    firstByte: entry.responseStart >= 0 && entry.responseStart <= (0,timeUtils/* relativeNow */._q)() ? entry.responseStart : undefined,
                });
            }
        }
    }).unsubscribe;
    return { stop: stop };
}
//# sourceMappingURL=trackNavigationTimings.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackLargestContentfulPaint.js



// Discard LCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var LCP_MAXIMUM_DELAY = 10 * timeUtils/* ONE_MINUTE */.yR;
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/onLCP.ts
 */
function trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, eventTarget, callback) {
    // Ignore entries that come after the first user interaction.  According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = (0,addEventListener/* addEventListeners */.yw)(configuration, eventTarget, [addEventListener/* DOM_EVENT.POINTER_DOWN */.EZ.POINTER_DOWN, addEventListener/* DOM_EVENT.KEY_DOWN */.EZ.KEY_DOWN], function (event) {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true }).stop;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var lcpEntry = (0,polyfills/* findLast */.dF)(entries, function (entry) {
            return entry.entryType === RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT &&
                entry.startTime < firstInteractionTimestamp &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < LCP_MAXIMUM_DELAY;
        });
        if (lcpEntry) {
            var lcpTargetSelector = void 0;
            if (lcpEntry.element) {
                lcpTargetSelector = getSelectorFromElement(lcpEntry.element, configuration.actionNameAttribute);
            }
            callback({
                value: lcpEntry.startTime,
                targetSelector: lcpTargetSelector,
            });
        }
    }).unsubscribe;
    return {
        stop: function () {
            stopEventListener();
            unsubscribeLifeCycle();
        },
    };
}
//# sourceMappingURL=trackLargestContentfulPaint.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstHidden.js

function trackFirstHidden(configuration, eventTarget) {
    if (eventTarget === void 0) { eventTarget = window; }
    var timeStamp;
    var stopListeners;
    if (document.visibilityState === 'hidden') {
        timeStamp = 0;
    }
    else {
        timeStamp = Infinity;
        (stopListeners = (0,addEventListener/* addEventListeners */.yw)(configuration, eventTarget, [addEventListener/* DOM_EVENT.PAGE_HIDE */.EZ.PAGE_HIDE, addEventListener/* DOM_EVENT.VISIBILITY_CHANGE */.EZ.VISIBILITY_CHANGE], function (event) {
            if (event.type === addEventListener/* DOM_EVENT.PAGE_HIDE */.EZ.PAGE_HIDE || document.visibilityState === 'hidden') {
                timeStamp = event.timeStamp;
                stopListeners();
            }
        }, { capture: true }).stop);
    }
    return {
        get timeStamp() {
            return timeStamp;
        },
        stop: function () {
            stopListeners === null || stopListeners === void 0 ? void 0 : stopListeners();
        },
    };
}
//# sourceMappingURL=trackFirstHidden.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackInitialViewMetrics.js





function trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) {
    var initialViewMetrics = {};
    var stopNavigationTracking = trackNavigationTimings(lifeCycle, function (navigationTimings) {
        setLoadEvent(navigationTimings.loadEvent);
        initialViewMetrics.navigationTimings = navigationTimings;
        scheduleViewUpdate();
    }).stop;
    var firstHidden = trackFirstHidden(configuration);
    var stopFCPTracking = trackFirstContentfulPaint(lifeCycle, firstHidden, function (firstContentfulPaint) {
        initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopLCPTracking = trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, window, function (largestContentfulPaint) {
        initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopFIDTracking = trackFirstInput(lifeCycle, configuration, firstHidden, function (firstInput) {
        initialViewMetrics.firstInput = firstInput;
        scheduleViewUpdate();
    }).stop;
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
        firstHidden.stop();
    }
    return {
        stop: stop,
        initialViewMetrics: initialViewMetrics,
    };
}
//# sourceMappingURL=trackInitialViewMetrics.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackCumulativeLayoutShift.js




/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(configuration, lifeCycle, callback) {
    if (!isLayoutShiftSupported()) {
        return {
            stop: functionUtils/* noop */.Z,
        };
    }
    var maxClsValue = 0;
    // if no layout shift happen the value should be reported as 0
    callback({
        value: 0,
    });
    var window = slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === RumPerformanceEntryType.LAYOUT_SHIFT && !entry.hadRecentInput) {
                window.update(entry);
                if (window.value() > maxClsValue) {
                    maxClsValue = window.value();
                    var cls = (0,numberUtils/* round */.NM)(maxClsValue, 4);
                    var clsTarget = window.largestLayoutShiftTarget();
                    var cslTargetSelector = void 0;
                    if (clsTarget &&
                        // Check if the CLS target have been removed from the DOM between the time we collect the target reference and when we compute the selector
                        clsTarget.isConnected) {
                        cslTargetSelector = getSelectorFromElement(clsTarget, configuration.actionNameAttribute);
                    }
                    callback({
                        value: cls,
                        targetSelector: cslTargetSelector,
                    });
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
function slidingSessionWindow() {
    var value = 0;
    var startTime;
    var endTime;
    var largestLayoutShift = 0;
    var largestLayoutShiftTarget;
    var largestLayoutShiftTime;
    return {
        update: function (entry) {
            var _a, _b;
            var shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= timeUtils/* ONE_SECOND */.WT ||
                entry.startTime - startTime >= 5 * timeUtils/* ONE_SECOND */.WT;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                value = entry.value;
                largestLayoutShift = 0;
                largestLayoutShiftTarget = undefined;
            }
            else {
                value += entry.value;
                endTime = entry.startTime;
            }
            if (entry.value > largestLayoutShift) {
                largestLayoutShift = entry.value;
                largestLayoutShiftTime = entry.startTime;
                if ((_a = entry.sources) === null || _a === void 0 ? void 0 : _a.length) {
                    largestLayoutShiftTarget = (_b = (0,polyfills/* find */.sE)(entry.sources, function (s) { return !!s.node && isElementNode(s.node); })) === null || _b === void 0 ? void 0 : _b.node;
                }
                else {
                    largestLayoutShiftTarget = undefined;
                }
            }
        },
        value: function () { return value; },
        largestLayoutShiftTarget: function () { return largestLayoutShiftTarget; },
        largestLayoutShiftTime: function () { return largestLayoutShiftTime; },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return supportPerformanceTimingEvent(RumPerformanceEntryType.LAYOUT_SHIFT);
}
//# sourceMappingURL=trackCumulativeLayoutShift.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/interactionCountPolyfill.js
/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */

var observer;
var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
function initInteractionCountPolyfill() {
    if ('interactionCount' in performance || observer) {
        return;
    }
    observer = new window.PerformanceObserver((0,monitor/* monitor */.zk)(function (entries) {
        entries.getEntries().forEach(function (e) {
            var entry = e;
            if (entry.interactionId) {
                minKnownInteractionId = Math.min(minKnownInteractionId, entry.interactionId);
                maxKnownInteractionId = Math.max(maxKnownInteractionId, entry.interactionId);
                interactionCountEstimate = (maxKnownInteractionId - minKnownInteractionId) / 7 + 1;
            }
        });
    }));
    observer.observe({ type: 'event', buffered: true, durationThreshold: 0 });
}
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
var getInteractionCount = function () {
    return observer ? interactionCountEstimate : window.performance.interactionCount || 0;
};
//# sourceMappingURL=interactionCountPolyfill.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackInteractionToNextPaint.js





// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
var MAX_INTERACTION_ENTRIES = 10;
// Arbitrary value to cap INP outliers
var MAX_INP_VALUE = (1 * timeUtils/* ONE_MINUTE */.yR);
/**
 * Track the interaction to next paint (INP).
 * To avoid outliers, return the p98 worst interaction of the view.
 * Documentation: https://web.dev/inp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/onINP.ts
 */
function trackInteractionToNextPaint(configuration, viewStart, viewLoadingType, lifeCycle) {
    if (!isInteractionToNextPaintSupported()) {
        return {
            getInteractionToNextPaint: function () { return undefined; },
            setViewEnd: functionUtils/* noop */.Z,
            stop: functionUtils/* noop */.Z,
        };
    }
    var _a = trackViewInteractionCount(viewLoadingType), getViewInteractionCount = _a.getViewInteractionCount, stopViewInteractionCount = _a.stopViewInteractionCount;
    var viewEnd = Infinity;
    var longestInteractions = trackLongestInteractions(getViewInteractionCount);
    var interactionToNextPaint = -1;
    var interactionToNextPaintTargetSelector;
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if ((entry.entryType === RumPerformanceEntryType.EVENT ||
                entry.entryType === RumPerformanceEntryType.FIRST_INPUT) &&
                entry.interactionId &&
                // Check the entry start time is inside the view bounds because some view interactions can be reported after the view end (if long duration).
                entry.startTime >= viewStart &&
                entry.startTime <= viewEnd) {
                longestInteractions.process(entry);
            }
        }
        var newInteraction = longestInteractions.estimateP98Interaction();
        if (newInteraction) {
            interactionToNextPaint = newInteraction.duration;
            if (newInteraction.target && isElementNode(newInteraction.target)) {
                interactionToNextPaintTargetSelector = getSelectorFromElement(newInteraction.target, configuration.actionNameAttribute);
            }
            else {
                interactionToNextPaintTargetSelector = undefined;
            }
        }
    }).unsubscribe;
    return {
        getInteractionToNextPaint: function () {
            // If no INP duration where captured because of the performanceObserver 40ms threshold
            // but the view interaction count > 0 then report 0
            if (interactionToNextPaint >= 0) {
                return {
                    value: Math.min(interactionToNextPaint, MAX_INP_VALUE),
                    targetSelector: interactionToNextPaintTargetSelector,
                };
            }
            else if (getViewInteractionCount()) {
                return {
                    value: 0,
                };
            }
        },
        setViewEnd: function (viewEndTime) {
            viewEnd = viewEndTime;
            stopViewInteractionCount();
        },
        stop: stop,
    };
}
function trackLongestInteractions(getViewInteractionCount) {
    var longestInteractions = [];
    function sortAndTrimLongestInteractions() {
        longestInteractions.sort(function (a, b) { return b.duration - a.duration; }).splice(MAX_INTERACTION_ENTRIES);
    }
    return {
        /**
         * Process the performance entry:
         * - if its duration is long enough, add the performance entry to the list of worst interactions
         * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
         */
        process: function (entry) {
            var interactionIndex = longestInteractions.findIndex(function (interaction) { return entry.interactionId === interaction.interactionId; });
            var minLongestInteraction = longestInteractions[longestInteractions.length - 1];
            if (interactionIndex !== -1) {
                if (entry.duration > longestInteractions[interactionIndex].duration) {
                    longestInteractions[interactionIndex] = entry;
                    sortAndTrimLongestInteractions();
                }
            }
            else if (longestInteractions.length < MAX_INTERACTION_ENTRIES ||
                entry.duration > minLongestInteraction.duration) {
                longestInteractions.push(entry);
                sortAndTrimLongestInteractions();
            }
        },
        /**
         * Compute the p98 longest interaction.
         * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
         */
        estimateP98Interaction: function () {
            var interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
            return longestInteractions[interactionIndex];
        },
    };
}
function trackViewInteractionCount(viewLoadingType) {
    initInteractionCountPolyfill();
    var previousInteractionCount = viewLoadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ? 0 : getInteractionCount();
    var state = { stopped: false };
    function computeViewInteractionCount() {
        return getInteractionCount() - previousInteractionCount;
    }
    return {
        getViewInteractionCount: function () {
            if (state.stopped) {
                return state.interactionCount;
            }
            return computeViewInteractionCount();
        },
        stopViewInteractionCount: function () {
            state = { stopped: true, interactionCount: computeViewInteractionCount() };
        },
    };
}
function isInteractionToNextPaintSupported() {
    return (supportPerformanceTimingEvent(RumPerformanceEntryType.EVENT) &&
        window.PerformanceEventTiming &&
        'interactionId' in PerformanceEventTiming.prototype);
}
//# sourceMappingURL=trackInteractionToNextPaint.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackLoadingTime.js


function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            callback(Math.max.apply(Math, loadingTimeCandidates));
        }
    }
    var stop = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push((0,timeUtils/* elapsed */._J)(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function (loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
//# sourceMappingURL=trackLoadingTime.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/scroll.js
function getScrollX() {
    var scrollX;
    var visual = window.visualViewport;
    if (visual) {
        scrollX = visual.pageLeft - visual.offsetLeft;
    }
    else if (window.scrollX !== undefined) {
        scrollX = window.scrollX;
    }
    else {
        scrollX = window.pageXOffset || 0;
    }
    return Math.round(scrollX);
}
function getScrollY() {
    var scrollY;
    var visual = window.visualViewport;
    if (visual) {
        scrollY = visual.pageTop - visual.offsetTop;
    }
    else if (window.scrollY !== undefined) {
        scrollY = window.scrollY;
    }
    else {
        scrollY = window.pageYOffset || 0;
    }
    return Math.round(scrollY);
}
//# sourceMappingURL=scroll.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/viewportObservable.js

var viewportObservable;
function initViewportObservable(configuration) {
    if (!viewportObservable) {
        viewportObservable = createViewportObservable(configuration);
    }
    return viewportObservable;
}
function createViewportObservable(configuration) {
    var observable = new tools_observable/* Observable */.y(function () {
        var updateDimension = (0,functionUtils/* throttle */.P)(function () {
            observable.notify(getViewportDimension());
        }, 200).throttled;
        return (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.RESIZE */.EZ.RESIZE, updateDimension, { capture: true, passive: true })
            .stop;
    });
    return observable;
}
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
    var visual = window.visualViewport;
    if (visual) {
        return {
            width: Number(visual.width * visual.scale),
            height: Number(visual.height * visual.scale),
        };
    }
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0),
    };
}
//# sourceMappingURL=viewportObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackScrollMetrics.js



/** Arbitrary scroll throttle duration */
var THROTTLE_SCROLL_DURATION = timeUtils/* ONE_SECOND */.WT;
function trackScrollMetrics(configuration, viewStart, callback, scrollValues) {
    if (scrollValues === void 0) { scrollValues = createScrollValuesObservable(configuration); }
    var maxScrollDepth = 0;
    var maxScrollHeight = 0;
    var maxScrollHeightTime = 0;
    var subscription = scrollValues.subscribe(function (_a) {
        var scrollDepth = _a.scrollDepth, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight;
        var shouldUpdate = false;
        if (scrollDepth > maxScrollDepth) {
            maxScrollDepth = scrollDepth;
            shouldUpdate = true;
        }
        if (scrollHeight > maxScrollHeight) {
            maxScrollHeight = scrollHeight;
            var now = (0,timeUtils/* relativeNow */._q)();
            maxScrollHeightTime = (0,timeUtils/* elapsed */._J)(viewStart.relative, now);
            shouldUpdate = true;
        }
        if (shouldUpdate) {
            callback({
                maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
                maxDepthScrollTop: scrollTop,
                maxScrollHeight: maxScrollHeight,
                maxScrollHeightTime: maxScrollHeightTime,
            });
        }
    });
    return {
        stop: function () { return subscription.unsubscribe(); },
    };
}
function computeScrollValues() {
    var scrollTop = getScrollY();
    var height = getViewportDimension().height;
    var scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
    var scrollDepth = Math.round(height + scrollTop);
    return {
        scrollHeight: scrollHeight,
        scrollDepth: scrollDepth,
        scrollTop: scrollTop,
    };
}
function createScrollValuesObservable(configuration, throttleDuration) {
    if (throttleDuration === void 0) { throttleDuration = THROTTLE_SCROLL_DURATION; }
    var observable = new tools_observable/* Observable */.y(function () {
        function notify() {
            observable.notify(computeScrollValues());
        }
        if (window.ResizeObserver) {
            var throttledNotify_1 = (0,functionUtils/* throttle */.P)(notify, throttleDuration, {
                leading: false,
                trailing: true,
            });
            var observerTarget_1 = document.scrollingElement || document.documentElement;
            var resizeObserver_1 = new ResizeObserver((0,monitor/* monitor */.zk)(throttledNotify_1.throttled));
            resizeObserver_1.observe(observerTarget_1);
            var eventListener_1 = (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.SCROLL */.EZ.SCROLL, throttledNotify_1.throttled, {
                passive: true,
            });
            return function () {
                throttledNotify_1.cancel();
                resizeObserver_1.unobserve(observerTarget_1);
                eventListener_1.stop();
            };
        }
    });
    return observable;
}
//# sourceMappingURL=trackScrollMetrics.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackCommonViewMetrics.js




function trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    var commonViewMetrics = {};
    var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
        commonViewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopScrollMetricsTracking = trackScrollMetrics(configuration, viewStart, function (newScrollMetrics) {
        commonViewMetrics.scroll = newScrollMetrics;
    }).stop;
    var stopCLSTracking = trackCumulativeLayoutShift(configuration, lifeCycle, function (cumulativeLayoutShift) {
        commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
        scheduleViewUpdate();
    }).stop;
    var _b = trackInteractionToNextPaint(configuration, viewStart.relative, loadingType, lifeCycle), stopINPTracking = _b.stop, getInteractionToNextPaint = _b.getInteractionToNextPaint, setViewEnd = _b.setViewEnd;
    return {
        stop: function () {
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
        },
        stopINPTracking: stopINPTracking,
        setLoadEvent: setLoadEvent,
        setViewEnd: setViewEnd,
        getCommonViewMetrics: function () {
            commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
            return commonViewMetrics;
        },
    };
}
//# sourceMappingURL=trackCommonViewMetrics.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/trackViews.js




var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * timeUtils/* ONE_MINUTE */.yR;
// Some events or metrics can be captured after the end of the view. To avoid missing those;
// an arbitrary delay is added for stopping their tracking after the view ends.
//
// Ideally, we would not stop and keep tracking events or metrics until the end of the session.
// But this might have a small performance impact if there are many many views.
// So let's have a fairly short delay improving the situation in most cases and avoid impacting performances too much.
var KEEP_TRACKING_AFTER_VIEW_DELAY = 5 * timeUtils/* ONE_MINUTE */.yR;
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var activeViews = new Set();
    var currentView = startNewView("initial_load" /* ViewLoadingType.INITIAL_LOAD */, (0,timeUtils/* clocksOrigin */.cQ)(), initialViewOptions);
    startViewLifeCycle();
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    }
    function startNewView(loadingType, startClocks, viewOptions) {
        var newlyCreatedView = newView(lifeCycle, domMutationObservable, configuration, location, loadingType, startClocks, viewOptions);
        activeViews.add(newlyCreatedView);
        newlyCreatedView.stopObservable.subscribe(function () {
            activeViews.delete(newlyCreatedView);
        });
        return newlyCreatedView;
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
            // Renew view on session renewal
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
            });
        });
        lifeCycle.subscribe(7 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
            currentView.end({ sessionIsActive: false });
        });
        // End the current view on page unload
        lifeCycle.subscribe(9 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
            if (pageExitEvent.reason === browser_pageExitObservable/* PageExitReason.UNLOADING */.k$.UNLOADING || pageExitEvent.reason === browser_pageExitObservable/* PageExitReason.PAGEHIDE */.k$.PAGEHIDE) {
                currentView.end();
            }
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function (_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */);
            }
        });
    }
    return {
        addTiming: function (name, time) {
            if (time === void 0) { time = (0,timeUtils/* timeStampNow */.n$)(); }
            currentView.addTiming(name, time);
        },
        startView: function (options, startClocks) {
            currentView.end({ endClocks: startClocks });
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, startClocks, options);
        },
        stop: function () {
            locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
            currentView.end();
            activeViews.forEach(function (view) { return view.stop(); });
        },
    };
}
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) { startClocks = (0,timeUtils/* clocksNow */.$I)(); }
    // Setup initial values
    var id = (0,stringUtils/* generateUUID */.DO)();
    var stopObservable = new tools_observable/* Observable */.y();
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = (0,objectUtils/* shallowClone */.mv)(initialLocation);
    var sessionIsActive = true;
    var name;
    var service;
    var version;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service;
        version = viewOptions.version;
    }
    lifeCycle.notify(2 /* LifeCycleEventType.VIEW_CREATED */, {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
    });
    // Update the view every time the measures are changing
    var _a = (0,functionUtils/* throttle */.P)(triggerViewUpdate, THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, setViewEnd = _b.setViewEnd, stopCommonViewMetricsTracking = _b.stop, stopINPTracking = _b.stopINPTracking, getCommonViewMetrics = _b.getCommonViewMetrics;
    var _c = loadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */
        ? trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate)
        : { stop: functionUtils/* noop */.Z, initialViewMetrics: {} }, stopInitialViewMetricsTracking = _c.stop, initialViewMetrics = _c.initialViewMetrics;
    var _d = trackViewEventCounts(lifeCycle, id, scheduleViewUpdate), stopEventCountsTracking = _d.stop, eventCounts = _d.eventCounts;
    // Session keep alive
    var keepAliveIntervalId = (0,timer/* setInterval */.Zi)(triggerViewUpdate, SESSION_KEEP_ALIVE_INTERVAL);
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? (0,timeUtils/* timeStampNow */.n$)() : endClocks.timeStamp;
        lifeCycle.notify(3 /* LifeCycleEventType.VIEW_UPDATED */, {
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            commonViewMetrics: getCommonViewMetrics(),
            initialViewMetrics: initialViewMetrics,
            duration: (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            sessionIsActive: sessionIsActive,
            eventCounts: eventCounts,
        });
    }
    return {
        name: name,
        service: service,
        version: version,
        stopObservable: stopObservable,
        end: function (options) {
            var _this = this;
            var _a, _b;
            if (options === void 0) { options = {}; }
            if (endClocks) {
                // view already ended
                return;
            }
            endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : (0,timeUtils/* clocksNow */.$I)();
            sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
            lifeCycle.notify(4 /* LifeCycleEventType.VIEW_ENDED */, { endClocks: endClocks });
            (0,timer/* clearInterval */.cv)(keepAliveIntervalId);
            setViewEnd(endClocks.relative);
            stopCommonViewMetricsTracking();
            triggerViewUpdate();
            (0,timer/* setTimeout */.iK)(function () {
                _this.stop();
            }, KEEP_TRACKING_AFTER_VIEW_DELAY);
        },
        stop: function () {
            stopInitialViewMetricsTracking();
            stopEventCountsTracking();
            stopINPTracking();
            stopObservable.notify();
        },
        addTiming: function (name, time) {
            if (endClocks) {
                return;
            }
            var relativeTime = (0,timeUtils/* looksLikeRelativeTime */.Cn)(time) ? time : (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        display/* display.warn */.jf.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    var correspondingId = hash.substring(1);
    // check if the correspondingId is empty because on Firefox an empty string passed to getElementById() prints a consol warning
    return correspondingId !== '' && !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}
//# sourceMappingURL=trackViews.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewCollection.js


function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_UPDATED */, function (view) {
        return lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory));
    });
    return trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var replayStats = recorderApi.getReplayStats(view.id);
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
    var pageStates = pageStateHistory.findAll(view.startClocks.relative, view.duration);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            page_states: pageStates,
            configuration: {
                start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
            },
        },
        date: view.startClocks.timeStamp,
        type: "view" /* RumEventType.VIEW */,
        view: {
            action: {
                count: view.eventCounts.actionCount,
            },
            frustration: {
                count: view.eventCounts.frustrationCount,
            },
            cumulative_layout_shift: (_a = view.commonViewMetrics.cumulativeLayoutShift) === null || _a === void 0 ? void 0 : _a.value,
            cumulative_layout_shift_target_selector: (_b = view.commonViewMetrics.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.targetSelector,
            first_byte: (0,timeUtils/* toServerDuration */.c0)((_c = view.initialViewMetrics.navigationTimings) === null || _c === void 0 ? void 0 : _c.firstByte),
            dom_complete: (0,timeUtils/* toServerDuration */.c0)((_d = view.initialViewMetrics.navigationTimings) === null || _d === void 0 ? void 0 : _d.domComplete),
            dom_content_loaded: (0,timeUtils/* toServerDuration */.c0)((_e = view.initialViewMetrics.navigationTimings) === null || _e === void 0 ? void 0 : _e.domContentLoaded),
            dom_interactive: (0,timeUtils/* toServerDuration */.c0)((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: (0,timeUtils/* toServerDuration */.c0)(view.initialViewMetrics.firstContentfulPaint),
            first_input_delay: (0,timeUtils/* toServerDuration */.c0)((_g = view.initialViewMetrics.firstInput) === null || _g === void 0 ? void 0 : _g.delay),
            first_input_time: (0,timeUtils/* toServerDuration */.c0)((_h = view.initialViewMetrics.firstInput) === null || _h === void 0 ? void 0 : _h.time),
            first_input_target_selector: (_j = view.initialViewMetrics.firstInput) === null || _j === void 0 ? void 0 : _j.targetSelector,
            interaction_to_next_paint: (0,timeUtils/* toServerDuration */.c0)((_k = view.commonViewMetrics.interactionToNextPaint) === null || _k === void 0 ? void 0 : _k.value),
            interaction_to_next_paint_target_selector: (_l = view.commonViewMetrics.interactionToNextPaint) === null || _l === void 0 ? void 0 : _l.targetSelector,
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: (0,timeUtils/* toServerDuration */.c0)((_m = view.initialViewMetrics.largestContentfulPaint) === null || _m === void 0 ? void 0 : _m.value),
            largest_contentful_paint_target_selector: (_o = view.initialViewMetrics.largestContentfulPaint) === null || _o === void 0 ? void 0 : _o.targetSelector,
            load_event: (0,timeUtils/* toServerDuration */.c0)((_p = view.initialViewMetrics.navigationTimings) === null || _p === void 0 ? void 0 : _p.loadEvent),
            loading_time: discardNegativeDuration((0,timeUtils/* toServerDuration */.c0)(view.commonViewMetrics.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: (0,timeUtils/* toServerDuration */.c0)(view.duration),
        },
        feature_flags: featureFlagContext && !(0,objectUtils/* isEmptyObject */.Qr)(featureFlagContext) ? featureFlagContext : undefined,
        display: view.commonViewMetrics.scroll
            ? {
                scroll: {
                    max_depth: view.commonViewMetrics.scroll.maxDepth,
                    max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
                    max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
                    max_scroll_height_time: (0,timeUtils/* toServerDuration */.c0)(view.commonViewMetrics.scroll.maxScrollHeightTime),
                },
            }
            : undefined,
        session: {
            has_replay: replayStats ? true : undefined,
            is_active: view.sessionIsActive ? undefined : false,
        },
        privacy: {
            replay_level: configuration.defaultPrivacyLevel,
        },
    };
    if (!(0,objectUtils/* isEmptyObject */.Qr)(view.customTimings)) {
        viewEvent.view.custom_timings = (0,objectUtils/* mapValues */.Q8)(view.customTimings, timeUtils/* toServerDuration */.c0);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location,
        },
    };
}
function discardNegativeDuration(duration) {
    return (0,numberUtils/* isNumber */.hj)(duration) && duration < 0 ? undefined : duration;
}
//# sourceMappingURL=viewCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js
var session_sessionManager = __webpack_require__(5135);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumSessionManager.js

var RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle) {
    var sessionManager = (0,session_sessionManager/* startSessionManager */.HX)(configuration, RUM_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    sessionManager.expireObservable.subscribe(function () {
        lifeCycle.notify(7 /* LifeCycleEventType.SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(function () {
        lifeCycle.notify(8 /* LifeCycleEventType.SESSION_RENEWED */);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            if (!session || !isTypeTracked(session.trackingType)) {
                return;
            }
            return {
                id: session.id,
                sessionReplayAllowed: session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */,
            };
        },
        expire: sessionManager.expire,
        expireObservable: sessionManager.expireObservable,
    };
}
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        sessionReplayAllowed: false,
    };
    return {
        findTrackedSession: function () { return session; },
        expire: functionUtils/* noop */.Z,
        expireObservable: new tools_observable/* Observable */.y(),
    };
}
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!(0,numberUtils/* performDraw */.y7)(configuration.sessionSampleRate)) {
        trackingType = "0" /* RumTrackingType.NOT_TRACKED */;
    }
    else if (!(0,numberUtils/* performDraw */.y7)(configuration.sessionReplaySampleRate)) {
        trackingType = "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
    }
    else {
        trackingType = "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* RumTrackingType.NOT_TRACKED */ ||
        trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ||
        trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */);
}
function isTypeTracked(rumSessionType) {
    return (rumSessionType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ||
        rumSessionType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */);
}
//# sourceMappingURL=rumSessionManager.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js + 2 modules
var startBatchWithReplica = __webpack_require__(21022);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/startRumBatch.js

function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable, sessionExpireObservable, createEncoder) {
    var replica = configuration.replica;
    var batch = (0,startBatchWithReplica/* startBatchWithReplica */.W)(configuration, {
        endpoint: configuration.rumEndpointBuilder,
        encoder: createEncoder(2 /* DeflateEncoderStreamId.RUM */),
    }, replica && {
        endpoint: replica.rumEndpointBuilder,
        transformMessage: function (message) { return (0,mergeInto/* combine */.$e)(message, { application: { id: replica.applicationId } }); },
        encoder: createEncoder(3 /* DeflateEncoderStreamId.RUM_REPLICA */),
    }, reportError, pageExitObservable, sessionExpireObservable);
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        if (serverRumEvent.type === "view" /* RumEventType.VIEW */) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    telemetryEventObservable.subscribe(function (event) { return batch.add(event, (0,telemetry_telemetry/* isTelemetryReplicationAllowed */.VG)(configuration)); });
    return batch;
}
//# sourceMappingURL=startRumBatch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/startRumEventBridge.js

function startRumEventBridge(lifeCycle) {
    var bridge = (0,eventBridge/* getEventBridge */.A)();
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}
//# sourceMappingURL=startRumEventBridge.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/urlContexts.js

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = new valueHistory/* ValueHistory */.P(URL_CONTEXT_TIME_OUT_DELAY);
    var previousViewUrl;
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = (0,timeUtils/* relativeNow */._q)();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            url: url,
            referrer: referrer,
        };
    }
    return {
        findUrl: function (startTime) { return urlContextHistory.find(startTime); },
        stop: function () {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}
//# sourceMappingURL=urlContexts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/locationChangeObservable.js

function createLocationChangeObservable(configuration, location) {
    var currentLocation = (0,objectUtils/* shallowClone */.mv)(location);
    var observable = new tools_observable/* Observable */.y(function () {
        var stopHistoryTracking = trackHistory(configuration, onLocationChange).stop;
        var stopHashTracking = trackHash(configuration, onLocationChange).stop;
        return function () {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
    function onLocationChange() {
        if (currentLocation.href === location.href) {
            return;
        }
        var newLocation = (0,objectUtils/* shallowClone */.mv)(location);
        observable.notify({
            newLocation: newLocation,
            oldLocation: currentLocation,
        });
        currentLocation = newLocation;
    }
    return observable;
}
function trackHistory(configuration, onHistoryChange) {
    var stopInstrumentingPushState = (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(history, 'pushState', {
        after: onHistoryChange,
    }).stop;
    var stopInstrumentingReplaceState = (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(history, 'replaceState', {
        after: onHistoryChange,
    }).stop;
    var removeListener = (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.POP_STATE */.EZ.POP_STATE, onHistoryChange).stop;
    return {
        stop: function () {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(configuration, onHashChange) {
    return (0,addEventListener/* addEventListener */.Oo)(configuration, window, addEventListener/* DOM_EVENT.HASH_CHANGE */.EZ.HASH_CHANGE, onHashChange);
}
//# sourceMappingURL=locationChangeObservable.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(51962);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js
var jsonStringify = __webpack_require__(19012);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/heavyCustomerDataWarning.js
var heavyCustomerDataWarning = __webpack_require__(4326);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/featureFlagContext.js

var FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = byteUtils/* computeBytesCount */.qt; }
    if (!(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.FEATURE_FLAGS */.uh.FEATURE_FLAGS)) {
        return {
            findFeatureFlagEvaluations: function () { return undefined; },
            getFeatureFlagBytesCount: function () { return 0; },
            addFeatureFlagEvaluation: functionUtils/* noop */.Z,
            stop: functionUtils/* noop */.Z,
        };
    }
    var featureFlagContexts = new valueHistory/* ValueHistory */.P(FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY);
    var bytesCountCache = 0;
    var alreadyWarned = false;
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        featureFlagContexts.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        featureFlagContexts.add({}, startClocks.relative);
        bytesCountCache = 0;
    });
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call addFeatureFlagEvaluation API synchronously multiple times in a row
    var _a = (0,functionUtils/* throttle */.P)(function (context) {
        bytesCountCache = computeBytesCountImpl((0,jsonStringify/* jsonStringify */.l)(context));
        if (!alreadyWarned) {
            alreadyWarned = (0,heavyCustomerDataWarning/* warnIfCustomerDataLimitReached */.H)(bytesCountCache, 0 /* CustomerDataType.FeatureFlag */);
        }
    }, BYTES_COMPUTATION_THROTTLING_DELAY), computeBytesCountThrottled = _a.throttled, cancelPendingComputation = _a.cancel;
    return {
        findFeatureFlagEvaluations: function (startTime) { return featureFlagContexts.find(startTime); },
        getFeatureFlagBytesCount: function () {
            var currentContext = featureFlagContexts.find();
            if (!currentContext) {
                return 0;
            }
            return bytesCountCache;
        },
        addFeatureFlagEvaluation: function (key, value) {
            var currentContext = featureFlagContexts.find();
            if (currentContext) {
                currentContext[key] = value;
                computeBytesCountThrottled(currentContext);
            }
        },
        stop: cancelPendingComputation,
    };
}
//# sourceMappingURL=featureFlagContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/startCustomerDataTelemetry.js

var MEASURES_PERIOD_DURATION = 10 * timeUtils/* ONE_SECOND */.WT;
var currentPeriodMeasures;
var currentBatchMeasures;
var batchHasRumEvent;
function startCustomerDataTelemetry(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batchFlushObservable) {
    var customerDataTelemetryEnabled = telemetry.enabled && (0,numberUtils/* performDraw */.y7)(configuration.customerDataTelemetrySampleRate);
    if (!customerDataTelemetryEnabled) {
        return;
    }
    initCurrentPeriodMeasures();
    initCurrentBatchMeasures();
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        batchHasRumEvent = true;
        updateMeasure(currentBatchMeasures.globalContextBytes, !(0,objectUtils/* isEmptyObject */.Qr)(globalContextManager.getContext()) ? globalContextManager.getBytesCount() : 0);
        updateMeasure(currentBatchMeasures.userContextBytes, !(0,objectUtils/* isEmptyObject */.Qr)(userContextManager.getContext()) ? userContextManager.getBytesCount() : 0);
        var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations();
        var hasFeatureFlagContext = (0,polyfills/* includes */.q9)(["view" /* RumEventType.VIEW */, "error" /* RumEventType.ERROR */], event.type) &&
            featureFlagContext &&
            !(0,objectUtils/* isEmptyObject */.Qr)(featureFlagContext);
        updateMeasure(currentBatchMeasures.featureFlagBytes, hasFeatureFlagContext ? featureFlagContexts.getFeatureFlagBytesCount() : 0);
    });
    batchFlushObservable.subscribe(function (_a) {
        var bytesCount = _a.bytesCount, messagesCount = _a.messagesCount;
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!batchHasRumEvent) {
            return;
        }
        currentPeriodMeasures.batchCount += 1;
        updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
        updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
        mergeMeasure(currentPeriodMeasures.globalContextBytes, currentBatchMeasures.globalContextBytes);
        mergeMeasure(currentPeriodMeasures.userContextBytes, currentBatchMeasures.userContextBytes);
        mergeMeasure(currentPeriodMeasures.featureFlagBytes, currentBatchMeasures.featureFlagBytes);
        initCurrentBatchMeasures();
    });
    (0,timer/* setInterval */.Zi)(sendCurrentPeriodMeasures, MEASURES_PERIOD_DURATION);
}
function sendCurrentPeriodMeasures() {
    if (currentPeriodMeasures.batchCount === 0) {
        return;
    }
    (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Customer data measures', currentPeriodMeasures);
    initCurrentPeriodMeasures();
}
function createMeasure() {
    return { min: Infinity, max: 0, sum: 0 };
}
function updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function mergeMeasure(target, source) {
    target.sum += source.sum;
    target.min = Math.min(target.min, source.min);
    target.max = Math.max(target.max, source.max);
}
function initCurrentPeriodMeasures() {
    currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: createMeasure(),
        batchMessagesCount: createMeasure(),
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
function initCurrentBatchMeasures() {
    batchHasRumEvent = false;
    currentBatchMeasures = {
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
//# sourceMappingURL=startCustomerDataTelemetry.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/pageStateHistory.js

// Arbitrary value to cap number of element for memory consumption in the browser
var MAX_PAGE_STATE_ENTRIES = 4000;
// Arbitrary value to cap number of element for backend & to save bandwidth
var MAX_PAGE_STATE_ENTRIES_SELECTABLE = 500;
var PAGE_STATE_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
function startPageStateHistory(configuration, maxPageStateEntriesSelectable) {
    if (maxPageStateEntriesSelectable === void 0) { maxPageStateEntriesSelectable = MAX_PAGE_STATE_ENTRIES_SELECTABLE; }
    var pageStateHistory = new valueHistory/* ValueHistory */.P(PAGE_STATE_CONTEXT_TIME_OUT_DELAY, MAX_PAGE_STATE_ENTRIES);
    var currentPageState;
    addPageState(getPageState(), (0,timeUtils/* relativeNow */._q)());
    var stopEventListeners = (0,addEventListener/* addEventListeners */.yw)(configuration, window, [
        addEventListener/* DOM_EVENT.PAGE_SHOW */.EZ.PAGE_SHOW,
        addEventListener/* DOM_EVENT.FOCUS */.EZ.FOCUS,
        addEventListener/* DOM_EVENT.BLUR */.EZ.BLUR,
        addEventListener/* DOM_EVENT.VISIBILITY_CHANGE */.EZ.VISIBILITY_CHANGE,
        addEventListener/* DOM_EVENT.RESUME */.EZ.RESUME,
        addEventListener/* DOM_EVENT.FREEZE */.EZ.FREEZE,
        addEventListener/* DOM_EVENT.PAGE_HIDE */.EZ.PAGE_HIDE,
    ], function (event) {
        addPageState(computePageState(event), event.timeStamp);
    }, { capture: true }).stop;
    function addPageState(nextPageState, startTime) {
        if (startTime === void 0) { startTime = (0,timeUtils/* relativeNow */._q)(); }
        if (nextPageState === currentPageState) {
            return;
        }
        currentPageState = nextPageState;
        pageStateHistory.closeActive(startTime);
        pageStateHistory.add({ state: currentPageState, startTime: startTime }, startTime);
    }
    return {
        findAll: function (eventStartTime, duration) {
            var pageStateEntries = pageStateHistory.findAll(eventStartTime, duration);
            if (pageStateEntries.length === 0) {
                return;
            }
            var pageStateServerEntries = [];
            // limit the number of entries to return
            var limit = Math.max(0, pageStateEntries.length - maxPageStateEntriesSelectable);
            // loop page state entries backward to return the selected ones in desc order
            for (var index = pageStateEntries.length - 1; index >= limit; index--) {
                var pageState = pageStateEntries[index];
                // compute the start time relative to the event start time (ex: to be relative to the view start time)
                var relativeStartTime = (0,timeUtils/* elapsed */._J)(eventStartTime, pageState.startTime);
                pageStateServerEntries.push({
                    state: pageState.state,
                    start: (0,timeUtils/* toServerDuration */.c0)(relativeStartTime),
                });
            }
            return pageStateServerEntries;
        },
        isInActivePageStateAt: function (startTime) {
            var pageStateEntry = pageStateHistory.find(startTime);
            return pageStateEntry !== undefined && pageStateEntry.state === "active" /* PageState.ACTIVE */;
        },
        addPageState: addPageState,
        stop: function () {
            stopEventListeners();
            pageStateHistory.stop();
        },
    };
}
function computePageState(event) {
    if (event.type === addEventListener/* DOM_EVENT.FREEZE */.EZ.FREEZE) {
        return "frozen" /* PageState.FROZEN */;
    }
    else if (event.type === addEventListener/* DOM_EVENT.PAGE_HIDE */.EZ.PAGE_HIDE) {
        return event.persisted ? "frozen" /* PageState.FROZEN */ : "terminated" /* PageState.TERMINATED */;
    }
    return getPageState();
}
function getPageState() {
    if (document.visibilityState === 'hidden') {
        return "hidden" /* PageState.HIDDEN */;
    }
    if (document.hasFocus()) {
        return "active" /* PageState.ACTIVE */;
    }
    return "passive" /* PageState.PASSIVE */;
}
//# sourceMappingURL=pageStateHistory.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/displayContext.js

function startDisplayContext(configuration) {
    var viewport = getViewportDimension();
    var unsubscribeViewport = initViewportObservable(configuration).subscribe(function (viewportDimension) {
        viewport = viewportDimension;
    }).unsubscribe;
    return {
        get: function () { return ({ viewport: viewport }); },
        stop: unsubscribeViewport,
    };
}
//# sourceMappingURL=displayContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/startRum.js
























function startRum(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions, createEncoder) {
    var cleanupTasks = [];
    var lifeCycle = new LifeCycle();
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) { return (0,sendToExtension/* sendToExtension */.j)('rum', event); });
    var telemetry = startRumTelemetry(configuration);
    telemetry.setContextProvider(function () {
        var _a, _b;
        return ({
            application: {
                id: configuration.applicationId,
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
            view: {
                id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id,
            },
            action: {
                id: actionContexts.findActionId(),
            },
        });
    });
    var reportError = function (error) {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
    var featureFlagContexts = startFeatureFlagContexts(lifeCycle);
    var pageExitObservable = (0,browser_pageExitObservable/* createPageExitObservable */.Pd)(configuration);
    var pageExitSubscription = pageExitObservable.subscribe(function (event) {
        lifeCycle.notify(9 /* LifeCycleEventType.PAGE_EXITED */, event);
    });
    cleanupTasks.push(function () { return pageExitSubscription.unsubscribe(); });
    var session = !(0,eventBridge/* canUseEventBridge */.x)() ? startRumSessionManager(configuration, lifeCycle) : startRumSessionManagerStub();
    if (!(0,eventBridge/* canUseEventBridge */.x)()) {
        var batch_1 = startRumBatch(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable, session.expireObservable, createEncoder);
        cleanupTasks.push(function () { return batch_1.stop(); });
        startCustomerDataTelemetry(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batch_1.flushObservable);
    }
    else {
        startRumEventBridge(lifeCycle);
    }
    var domMutationObservable = createDOMMutationObservable();
    var locationChangeObservable = createLocationChangeObservable(configuration, location);
    var _a = startRumEventCollection(lifeCycle, configuration, location, session, locationChangeObservable, domMutationObservable, function () { return buildCommonContext(globalContextManager, userContextManager, recorderApi); }, reportError), viewContexts = _a.viewContexts, pageStateHistory = _a.pageStateHistory, urlContexts = _a.urlContexts, actionContexts = _a.actionContexts, addAction = _a.addAction, stopRumEventCollection = _a.stop;
    cleanupTasks.push(stopRumEventCollection);
    (0,telemetry_telemetry/* addTelemetryConfiguration */.Uo)(serializeRumConfiguration(initConfiguration));
    startLongTaskCollection(lifeCycle, configuration, session);
    startResourceCollection(lifeCycle, configuration, session, pageStateHistory);
    var _b = startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions), addTiming = _b.addTiming, startView = _b.startView, stopViewCollection = _b.stop;
    cleanupTasks.push(stopViewCollection);
    var addError = startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts).addError;
    startRequestCollection(lifeCycle, configuration, session);
    startPerformanceCollection(lifeCycle, configuration);
    var internalContext = startInternalContext(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
        session: session,
        stopSession: function () { return session.expire(); },
        getInternalContext: internalContext.get,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
function startRumTelemetry(configuration) {
    var telemetry = (0,telemetry_telemetry/* startTelemetry */.VL)("browser-rum-sdk" /* TelemetryService.RUM */, configuration);
    if ((0,eventBridge/* canUseEventBridge */.x)()) {
        var bridge_1 = (0,eventBridge/* getEventBridge */.A)();
        telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
    }
    return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, locationChangeObservable, domMutationObservable, buildCommonContext, reportError) {
    var viewContexts = startViewContexts(lifeCycle);
    var urlContexts = startUrlContexts(lifeCycle, locationChangeObservable, location);
    var pageStateHistory = startPageStateHistory(configuration);
    var _a = startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory), addAction = _a.addAction, actionContexts = _a.actionContexts;
    var displayContext = startDisplayContext(configuration);
    startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, buildCommonContext, reportError);
    return {
        viewContexts: viewContexts,
        pageStateHistory: pageStateHistory,
        urlContexts: urlContexts,
        addAction: addAction,
        actionContexts: actionContexts,
        stop: function () {
            displayContext.stop();
            pageStateHistory.stop();
            urlContexts.stop();
            viewContexts.stop();
            pageStateHistory.stop();
        },
    };
}
//# sourceMappingURL=startRum.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var intakeSites = __webpack_require__(11095);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/getSessionReplayUrl.js

function getSessionReplayUrl(configuration, _a) {
    var session = _a.session, viewContext = _a.viewContext, errorType = _a.errorType;
    var sessionId = session ? session.id : 'no-session-id';
    var parameters = [];
    if (errorType !== undefined) {
        parameters.push("error-type=".concat(errorType));
    }
    if (viewContext) {
        parameters.push("seed=".concat(viewContext.id));
        parameters.push("from=".concat(viewContext.startClocks.timeStamp));
    }
    var origin = getDatadogSiteUrl(configuration);
    var path = "/rum/replay/sessions/".concat(sessionId);
    return "".concat(origin).concat(path, "?").concat(parameters.join('&'));
}
function getDatadogSiteUrl(rumConfiguration) {
    var site = rumConfiguration.site;
    var subdomain = rumConfiguration.subdomain || getSiteDefaultSubdomain(rumConfiguration);
    return "https://".concat(subdomain ? "".concat(subdomain, ".") : '').concat(site);
}
function getSiteDefaultSubdomain(configuration) {
    switch (configuration.site) {
        case intakeSites/* INTAKE_SITE_US1 */.D_:
        case intakeSites/* INTAKE_SITE_EU1 */.Ds:
            return 'app';
        case intakeSites/* INTAKE_SITE_STAGING */.DZ:
            return 'dd';
        default:
            return undefined;
    }
}
//# sourceMappingURL=getSessionReplayUrl.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/index.js










//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.js + 1 modules
var transport_httpRequest = __webpack_require__(30481);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/types/sessionReplayConstants.js
var RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9,
};
var NodeType = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11,
};
var IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
var MouseInteractionType = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
var MediaInteractionType = {
    Play: 0,
    Pause: 1,
};
//# sourceMappingURL=sessionReplayConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/types/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/assembly.js


function assembleIncrementalSnapshot(source, data) {
    return {
        data: (0,polyfills/* assign */.f0)({
            source: source,
        }, data),
        type: RecordType.IncrementalSnapshot,
        timestamp: (0,timeUtils/* timeStampNow */.n$)(),
    };
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/constants.js

var NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: configuration_configuration/* DefaultPrivacyLevel.ALLOW */.Jj.ALLOW,
    MASK: configuration_configuration/* DefaultPrivacyLevel.MASK */.Jj.MASK,
    MASK_USER_INPUT: configuration_configuration/* DefaultPrivacyLevel.MASK_USER_INPUT */.Jj.MASK_USER_INPUT,
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
var PRIVACY_ATTR_VALUE_ALLOW = 'allow';
var PRIVACY_ATTR_VALUE_MASK = 'mask';
var PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
var PRIVACY_CLASS_MASK = 'dd-privacy-mask';
var PRIVACY_CLASS_MASK_USER_INPUT = 'dd-privacy-mask-user-input';
var PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/privacy.js


var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 100000;
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel) {
    var parentNode = getParentNode(node);
    var parentNodePrivacyLevel = parentNode ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel) : defaultPrivacyLevel;
    var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    return reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case NodePrivacyLevel.ALLOW:
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.MASK_USER_INPUT:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!isElementNode(node)) {
        return;
    }
    var privAttr = node.getAttribute(PRIVACY_ATTR_NAME);
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return NodePrivacyLevel.ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return NodePrivacyLevel.MASK;
        }
        if (inputElement.type === 'hidden') {
            return NodePrivacyLevel.MASK;
        }
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf('cc-') === 0) {
            return NodePrivacyLevel.MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (privAttr === PRIVACY_ATTR_VALUE_HIDDEN || node.classList.contains(PRIVACY_CLASS_HIDDEN)) {
        return NodePrivacyLevel.HIDDEN;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK || node.classList.contains(PRIVACY_CLASS_MASK)) {
        return NodePrivacyLevel.MASK;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK_USER_INPUT || node.classList.contains(PRIVACY_CLASS_MASK_USER_INPUT)) {
        return NodePrivacyLevel.MASK_USER_INPUT;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_ALLOW || node.classList.contains(PRIVACY_CLASS_ALLOW)) {
        return NodePrivacyLevel.ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return NodePrivacyLevel.IGNORE;
    }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return true;
        case NodePrivacyLevel.MASK_USER_INPUT:
            return isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    var element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) { return text.replace(/\S/g, TEXT_MASKING_CHAR); };
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) {
        return;
    }
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = CENSORED_STRING_MARK;
    }
    else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = CENSORED_STRING_MARK;
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel)) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = CENSORED_STRING_MARK;
        }
        else {
            textContent = censorText(textContent);
        }
    }
    return textContent;
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return (
        // Link as script - Ignore only when rel=preload, modulepreload or prefetch
        (/preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
//# sourceMappingURL=privacy.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializationUtils.js




var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
    var current = node;
    while (current) {
        if (!hasSerializedNode(current) && !isNodeShadowRoot(current)) {
            return false;
        }
        current = getParentNode(current);
    }
    return true;
}
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    var tagName = element.tagName;
    var value = element.value;
    if (shouldMaskNode(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return CENSORED_STRING_MARK;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
var ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
var DATA_URI = /^data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
    return cssText.replace(URL_IN_CSS_REF, function (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
        var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || ABSOLUTE_URL.test(url) || DATA_URI.test(url)) {
            return matchingSubstring;
        }
        var quote = singleQuote || doubleQuote || '';
        return "url(".concat(quote).concat(makeUrlAbsolute(url, cssHref)).concat(quote, ")");
    });
}
function makeUrlAbsolute(url, baseUrl) {
    try {
        return (0,urlPolyfill/* buildUrl */.Q2)(url, baseUrl).href;
    }
    catch (_) {
        return url;
    }
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
//# sourceMappingURL=serializationUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeStyleSheets.js
function serializeStyleSheets(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
        return undefined;
    }
    return cssStyleSheets.map(function (cssStyleSheet) {
        var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        var cssRules = Array.from(rules, function (cssRule) { return cssRule.cssText; });
        var styleSheet = {
            cssRules: cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined,
        };
        return styleSheet;
    });
}
//# sourceMappingURL=serializeStyleSheets.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeAttribute.js




function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === NodePrivacyLevel.MASK &&
        attributeName !== PRIVACY_ATTR_NAME &&
        !STABLE_ATTRIBUTES.includes(attributeName) &&
        attributeName !== configuration.actionNameAttribute) {
        var tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
            case 'placeholder':
                return CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === 'IMG' || tagName === 'SOURCE') {
            if (attributeName === 'src' || attributeName === 'srcset') {
                return CENSORED_IMG_MARK;
            }
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return CENSORED_STRING_MARK;
        }
        // mask data-* attributes
        if (attributeValue && (0,polyfills/* startsWith */.Ny)(attributeName, 'data-')) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return CENSORED_STRING_MARK;
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    // Minimum Fix for customer.
    if (attributeValue.length > MAX_ATTRIBUTE_VALUE_CHAR_LENGTH && attributeValue.slice(0, 5) === 'data:') {
        return 'data:truncated';
    }
    return attributeValue;
}
//# sourceMappingURL=serializeAttribute.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeAttributes.js





function serializeAttributes(element, nodePrivacyLevel, options) {
    var _a;
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        return {};
    }
    var safeAttrs = {};
    var tagName = getValidTagName(element.tagName);
    var doc = element.ownerDocument;
    for (var i = 0; i < element.attributes.length; i += 1) {
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = getElementInputValue(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function (s) { return s.href === element.href; });
        var cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet && !(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.DISABLE_REPLAY_INLINE_CSS */.uh.DISABLE_REPLAY_INLINE_CSS)) {
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' && element.sheet) {
        var cssText = getCssRulesString(element.sheet);
        if (cssText) {
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if (shouldMaskNode(inputElement, nodePrivacyLevel)) {
            delete safeAttrs.checked;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */
    var scrollTop;
    var scrollLeft;
    var serializationContext = options.serializationContext;
    switch (serializationContext.status) {
        case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */:
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) {
                serializationContext.elementsScrollPositions.set(element, { scrollTop: scrollTop, scrollLeft: scrollLeft });
            }
            break;
        case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */:
            if (serializationContext.elementsScrollPositions.has(element)) {
                ;
                (_a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft);
            }
            break;
    }
    if (scrollLeft) {
        safeAttrs.rr_scrollLeft = scrollLeft;
    }
    if (scrollTop) {
        safeAttrs.rr_scrollTop = scrollTop;
    }
    return safeAttrs;
}
function getCssRulesString(cssStyleSheet) {
    if (!cssStyleSheet) {
        return null;
    }
    var rules;
    try {
        rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
    }
    catch (_a) {
        // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
    }
    if (!rules) {
        return null;
    }
    var styleSheetCssText = Array.from(rules, (0,browserDetection/* isSafari */.G6)() ? getCssRuleStringForSafari : getCssRuleString).join('');
    return switchToAbsoluteUrl(styleSheetCssText, cssStyleSheet.href);
}
function getCssRuleStringForSafari(rule) {
    // Safari does not escape attribute selectors containing : properly
    // https://bugs.webkit.org/show_bug.cgi?id=184604
    if (isCSSStyleRule(rule) && rule.selectorText.includes(':')) {
        // This regex replaces [foo:bar] by [foo\\:bar]
        var escapeColon = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
        return rule.cssText.replace(escapeColon, '$1\\$2');
    }
    return getCssRuleString(rule);
}
function getCssRuleString(rule) {
    // If it's an @import rule, try to inline sub-rules recursively with `getCssRulesString`. This
    // operation can fail if the imported stylesheet is protected by CORS, in which case we fallback
    // to the @import rule CSS text.
    return (isCSSImportRule(rule) && getCssRulesString(rule.styleSheet)) || rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
//# sourceMappingURL=serializeAttributes.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeNode.js








function serializeNodeWithId(node, options) {
    var serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    var id = getSerializedNodeId(node) || generateNextId();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    setSerializedNodeId(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
var _nextId = 1;
function generateNextId() {
    return _nextId++;
}
function serializeChildNodes(node, options) {
    var result = [];
    forEachChildNodes(node, function (childNode) {
        var serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: NodeType.Document,
        childNodes: serializeChildNodes(document, options),
        adoptedStyleSheets: serializeStyleSheets(document.adoptedStyleSheets),
    };
}
function serializeDocumentFragmentNode(element, options) {
    var isShadowRoot = isNodeShadowRoot(element);
    if (isShadowRoot) {
        options.serializationContext.shadowRootsController.addShadowRoot(element);
    }
    return {
        type: NodeType.DocumentFragment,
        childNodes: serializeChildNodes(element, options),
        isShadowRoot: isShadowRoot,
        adoptedStyleSheets: isShadowRoot ? serializeStyleSheets(element.adoptedStyleSheets) : undefined,
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: NodeType.DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    var _a;
    var tagName = getValidTagName(element.tagName);
    var isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: NodeType.Element,
            tagName: tagName,
            attributes: (_a = {
                    rr_width: "".concat(width, "px"),
                    rr_height: "".concat(height, "px")
                },
                _a[PRIVACY_ATTR_NAME] = PRIVACY_ATTR_VALUE_HIDDEN,
                _a),
            childNodes: [],
            isSVG: isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === NodePrivacyLevel.IGNORE) {
        return;
    }
    var attributes = serializeAttributes(element, nodePrivacyLevel, options);
    var childNodes = [];
    if (hasChildNodes(element) &&
        // Do not serialize style children as the css rules are already in the _cssText attribute
        tagName !== 'style') {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = (0,polyfills/* assign */.f0)({}, options, {
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            });
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    return {
        type: NodeType.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG,
    };
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    var textContent = getTextContent(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (textContent === undefined) {
        return;
    }
    return {
        type: NodeType.Text,
        textContent: textContent,
    };
}
function serializeCDataNode() {
    return {
        type: NodeType.CDATA,
        textContent: '',
    };
}
//# sourceMappingURL=serializeNode.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeDocument.js

function serializeDocument(document, configuration, serializationContext) {
    // We are sure that Documents are never ignored, so this function never returns null
    return serializeNodeWithId(document, {
        serializationContext: serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration: configuration,
    });
}
//# sourceMappingURL=serializeDocument.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialization/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/eventsUtils.js

function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function getEventTarget(event) {
    if (event.composed === true && isNodeShadowHost(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
//# sourceMappingURL=eventsUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/viewports.js
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn(visualViewport) {
    return (Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > TOLERANCE);
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
    var visualViewport = window.visualViewport;
    var normalized = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visualViewport) {
        // On old browsers, we cannot normalize, so fallback to clientX/Y
        return normalized;
    }
    else if (isVisualViewportFactoredIn(visualViewport)) {
        // Typically Mobile Devices
        normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
        normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
        normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
    }
    return normalized;
};
var getVisualViewport = function (visualViewport) { return ({
    scale: visualViewport.scale,
    offsetLeft: visualViewport.offsetLeft,
    offsetTop: visualViewport.offsetTop,
    pageLeft: visualViewport.pageLeft,
    pageTop: visualViewport.pageTop,
    height: visualViewport.height,
    width: visualViewport.width,
}); };
//# sourceMappingURL=viewports.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/moveObserver.js





var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function initMoveObserver(configuration, cb) {
    var updatePosition = (0,functionUtils/* throttle */.P)(function (event) {
        var target = getEventTarget(event);
        if (hasSerializedNode(target)) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            var position = {
                id: getSerializedNodeId(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y,
            };
            cb([position], isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove);
        }
    }, MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    }).throttled;
    return (0,addEventListener/* addEventListeners */.yw)(configuration, document, [addEventListener/* DOM_EVENT.MOUSE_MOVE */.EZ.MOUSE_MOVE, addEventListener/* DOM_EVENT.TOUCH_MOVE */.EZ.TOUCH_MOVE], updatePosition, {
        capture: true,
        passive: true,
    }).stop;
}
function tryToComputeCoordinates(event) {
    var _a = isTouchEvent(event) ? event.changedTouches[0] : event, x = _a.clientX, y = _a.clientY;
    if (window.visualViewport) {
        var _b = convertMouseEventToLayoutCoordinates(x, y), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) {
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('mouse/touch event without x/y');
        }
        return undefined;
    }
    return { x: x, y: y };
}
//# sourceMappingURL=moveObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/scrollObserver.js






var SCROLL_OBSERVER_THRESHOLD = 100;
function initScrollObserver(configuration, cb, defaultPrivacyLevel, elementsScrollPositions) {
    var updatePosition = (0,functionUtils/* throttle */.P)(function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var scrollPositions = target === document
            ? {
                scrollTop: getScrollY(),
                scrollLeft: getScrollX(),
            }
            : {
                scrollTop: Math.round(target.scrollTop),
                scrollLeft: Math.round(target.scrollLeft),
            };
        elementsScrollPositions.set(target, scrollPositions);
        cb({
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop,
        });
    }, SCROLL_OBSERVER_THRESHOLD).throttled;
    return (0,addEventListener/* addEventListener */.Oo)(configuration, document, addEventListener/* DOM_EVENT.SCROLL */.EZ.SCROLL, updatePosition, { capture: true, passive: true })
        .stop;
}
//# sourceMappingURL=scrollObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/mouseInteractionObserver.js
var _a;








var eventTypeToMouseInteraction = (_a = {},
    // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
    // allows to reference such records from Frustration records.
    //
    // In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
    // used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
    // `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
    // convey such interaction. This would cleanly solve the issue since we would have
    // `PointerInteraction/Up` records that we could reference from `Frustration` records.
    _a[addEventListener/* DOM_EVENT.POINTER_UP */.EZ.POINTER_UP] = MouseInteractionType.MouseUp,
    _a[addEventListener/* DOM_EVENT.MOUSE_DOWN */.EZ.MOUSE_DOWN] = MouseInteractionType.MouseDown,
    _a[addEventListener/* DOM_EVENT.CLICK */.EZ.CLICK] = MouseInteractionType.Click,
    _a[addEventListener/* DOM_EVENT.CONTEXT_MENU */.EZ.CONTEXT_MENU] = MouseInteractionType.ContextMenu,
    _a[addEventListener/* DOM_EVENT.DBL_CLICK */.EZ.DBL_CLICK] = MouseInteractionType.DblClick,
    _a[addEventListener/* DOM_EVENT.FOCUS */.EZ.FOCUS] = MouseInteractionType.Focus,
    _a[addEventListener/* DOM_EVENT.BLUR */.EZ.BLUR] = MouseInteractionType.Blur,
    _a[addEventListener/* DOM_EVENT.TOUCH_START */.EZ.TOUCH_START] = MouseInteractionType.TouchStart,
    _a[addEventListener/* DOM_EVENT.TOUCH_END */.EZ.TOUCH_END] = MouseInteractionType.TouchEnd,
    _a);
function initMouseInteractionObserver(configuration, cb, recordIds) {
    var handler = function (event) {
        var target = getEventTarget(event);
        if (getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var type = eventTypeToMouseInteraction[event.type];
        var interaction;
        if (type !== MouseInteractionType.Blur && type !== MouseInteractionType.Focus) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            interaction = { id: id, type: type, x: coordinates.x, y: coordinates.y };
        }
        else {
            interaction = { id: id, type: type };
        }
        var record = (0,polyfills/* assign */.f0)({ id: recordIds.getIdForEvent(event) }, assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, interaction));
        cb(record);
    };
    return (0,addEventListener/* addEventListeners */.yw)(configuration, document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    }).stop;
}
//# sourceMappingURL=mouseInteractionObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/inputObserver.js





function initInputObserver(configuration, cb, target) {
    if (target === void 0) { target = document; }
    var defaultPrivacyLevel = configuration.defaultPrivacyLevel;
    var lastInputStateMap = new WeakMap();
    var isShadowRoot = target !== document;
    var stopEventListeners = (0,addEventListener/* addEventListeners */.yw)(configuration, target, 
    // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    isShadowRoot ? [addEventListener/* DOM_EVENT.CHANGE */.EZ.CHANGE] : [addEventListener/* DOM_EVENT.INPUT */.EZ.INPUT, addEventListener/* DOM_EVENT.CHANGE */.EZ.CHANGE], function (event) {
        var target = getEventTarget(event);
        if (target instanceof HTMLInputElement ||
            target instanceof HTMLTextAreaElement ||
            target instanceof HTMLSelectElement) {
            onElementChange(target);
        }
    }, {
        capture: true,
        passive: true,
    }).stop;
    var stopPropertySetterInstrumentation;
    if (!isShadowRoot) {
        var instrumentationStoppers_1 = [
            (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLInputElement.prototype, 'value', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLInputElement.prototype, 'checked', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLSelectElement.prototype, 'value', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLTextAreaElement.prototype, 'value', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLSelectElement.prototype, 'selectedIndex', onElementChange),
        ];
        stopPropertySetterInstrumentation = function () {
            instrumentationStoppers_1.forEach(function (stopper) { return stopper.stop(); });
        };
    }
    else {
        stopPropertySetterInstrumentation = functionUtils/* noop */.Z;
    }
    return function () {
        stopPropertySetterInstrumentation();
        stopEventListeners();
    };
    function onElementChange(target) {
        var nodePrivacyLevel = getNodePrivacyLevel(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
            return;
        }
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if (shouldMaskNode(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            var value = getElementInputValue(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) {
            (0,polyfills/* forEach */.Ed)(document.querySelectorAll("input[type=\"radio\"][name=\"".concat((0,polyfills/* cssEscape */.QA)(name), "\"]")), function (el) {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!hasSerializedNode(target)) {
            return;
        }
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            cb((0,polyfills/* assign */.f0)({
                id: getSerializedNodeId(target),
            }, inputState));
        }
    }
}
//# sourceMappingURL=inputObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/styleSheetObserver.js


function initStyleSheetObserver(cb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && hasSerializedNode(styleSheet.ownerNode)) {
            callback(getSerializedNodeId(styleSheet.ownerNode));
        }
    }
    var instrumentationStoppers = [
        (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(CSSStyleSheet.prototype, 'insertRule', {
            before: function (rule, index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, adds: [{ rule: rule, index: index }] }); });
            },
        }),
        (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(CSSStyleSheet.prototype, 'deleteRule', {
            before: function (index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, removes: [{ index: index }] }); });
            },
        }),
    ];
    if (typeof CSSGroupingRule !== 'undefined') {
        instrumentGroupingCSSRuleClass(CSSGroupingRule);
    }
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push((0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(cls.prototype, 'insertRule', {
            before: function (rule, index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = getPathToNestedCSSRule(_this);
                    if (path) {
                        path.push(index || 0);
                        cb({ id: id, adds: [{ rule: rule, index: path }] });
                    }
                });
            },
        }), (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(cls.prototype, 'deleteRule', {
            before: function (index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = getPathToNestedCSSRule(_this);
                    if (path) {
                        path.push(index);
                        cb({ id: id, removes: [{ index: path }] });
                    }
                });
            },
        }));
    }
    return function () { return instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); }); };
}
function getPathToNestedCSSRule(rule) {
    var path = [];
    var currentRule = rule;
    while (currentRule.parentRule) {
        var rules_1 = Array.from(currentRule.parentRule.cssRules);
        var index_1 = rules_1.indexOf(currentRule);
        path.unshift(index_1);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) {
        return;
    }
    var rules = Array.from(currentRule.parentStyleSheet.cssRules);
    var index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}
//# sourceMappingURL=styleSheetObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/mediaInteractionObserver.js






function initMediaInteractionObserver(configuration, mediaInteractionCb, defaultPrivacyLevel) {
    return (0,addEventListener/* addEventListeners */.yw)(configuration, document, [addEventListener/* DOM_EVENT.PLAY */.EZ.PLAY, addEventListener/* DOM_EVENT.PAUSE */.EZ.PAUSE], function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        mediaInteractionCb({
            id: getSerializedNodeId(target),
            type: event.type === addEventListener/* DOM_EVENT.PLAY */.EZ.PLAY ? MediaInteractionType.Play : MediaInteractionType.Pause,
        });
    }, {
        capture: true,
        passive: true,
    }).stop;
}
//# sourceMappingURL=mediaInteractionObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/frustrationObserver.js

function initFrustrationObserver(lifeCycle, frustrationCb, recordIds) {
    return lifeCycle.subscribe(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (data) {
        var _a, _b, _c;
        if (data.rawRumEvent.type === "action" /* RumEventType.ACTION */ &&
            data.rawRumEvent.action.type === "click" /* ActionType.CLICK */ &&
            ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) &&
            'events' in data.domainContext &&
            ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) {
            frustrationCb({
                timestamp: data.rawRumEvent.date,
                type: RecordType.FrustrationRecord,
                data: {
                    frustrationTypes: data.rawRumEvent.action.frustration.type,
                    recordIds: data.domainContext.events.map(function (e) { return recordIds.getIdForEvent(e); }),
                },
            });
        }
    }).unsubscribe;
}
//# sourceMappingURL=frustrationObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/viewportResizeObserver.js



var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function initViewportResizeObserver(configuration, cb) {
    return initViewportObservable(configuration).subscribe(cb).unsubscribe;
}
function initVisualViewportResizeObserver(configuration, cb) {
    var visualViewport = window.visualViewport;
    if (!visualViewport) {
        return functionUtils/* noop */.Z;
    }
    var _a = (0,functionUtils/* throttle */.P)(function () {
        cb(getVisualViewport(visualViewport));
    }, VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0,addEventListener/* addEventListeners */.yw)(configuration, visualViewport, [addEventListener/* DOM_EVENT.RESIZE */.EZ.RESIZE, addEventListener/* DOM_EVENT.SCROLL */.EZ.SCROLL], updateDimension, {
        capture: true,
        passive: true,
    }).stop;
    return function stop() {
        removeListener();
        cancelThrottle();
    };
}
//# sourceMappingURL=viewportResizeObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/mutationBatch.js

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
function createMutationBatch(processMutationBatch) {
    var cancelScheduledFlush = functionUtils/* noop */.Z;
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    return {
        addMutations: function (mutations) {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = requestIdleCallback(flush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function () {
            cancelScheduledFlush();
        },
    };
}
/**
 * Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
 * browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
 * fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
 * browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes efficiently.
 *
 * Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
 */
function requestIdleCallback(callback, opts) {
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        var id_1 = window.requestIdleCallback((0,monitor/* monitor */.zk)(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame((0,monitor/* monitor */.zk)(callback));
    return function () { return window.cancelAnimationFrame(id); };
}
//# sourceMappingURL=mutationBatch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/mutationObserver.js






/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function initMutationObserver(mutationCallback, configuration, shadowRootsController, target) {
    var MutationObserver = getMutationObserverConstructor();
    if (!MutationObserver) {
        return { stop: functionUtils/* noop */.Z, flush: functionUtils/* noop */.Z };
    }
    var mutationBatch = createMutationBatch(function (mutations) {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController);
    });
    var observer = new MutationObserver((0,monitor/* monitor */.zk)(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return {
        stop: function () {
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: function () {
            mutationBatch.flush();
        },
    };
}
function processMutations(mutations, mutationCallback, configuration, shadowRootsController) {
    mutations
        .filter(function (mutation) { return mutation.type === 'childList'; })
        .forEach(function (mutation) {
        mutation.removedNodes.forEach(function (removedNode) {
            traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function (mutation) {
        return mutation.target.isConnected &&
            nodeAndAncestorsHaveSerializedNode(mutation.target) &&
            getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel) !== NodePrivacyLevel.HIDDEN;
    });
    var _a = processChildListMutations(filteredMutations.filter(function (mutation) { return mutation.type === 'childList'; }), configuration, shadowRootsController), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), configuration);
    var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), configuration);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback({
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes,
    });
}
function processChildListMutations(mutations, configuration, shadowRootsController) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function (mutation) {
        mutation.addedNodes.forEach(function (node) {
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach(function (node) {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    };
    for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(node.parentNode, configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        var serializedNode = serializeNodeWithId(node, {
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
            serializationContext: { status: 2 /* SerializationContextStatus.MUTATION */, shadowRootsController: shadowRootsController },
            configuration: configuration,
        });
        if (!serializedNode) {
            continue;
        }
        var parentNode = getParentNode(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: getSerializedNodeId(parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function (parent, node) {
        if (hasSerializedNode(node)) {
            removedNodeMutations.push({
                parentId: getSerializedNodeId(parent),
                id: getSerializedNodeId(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized: hasBeenSerialized };
    function hasBeenSerialized(node) {
        return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while (nextSibling) {
            if (hasSerializedNode(nextSibling)) {
                return getSerializedNodeId(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, configuration) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function (mutation) {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(getParentNode(mutation.target), configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        textMutations.push({
            id: getSerializedNodeId(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = getTextContent(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, configuration) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function (mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        var privacyLevel = getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel);
        var attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName, configuration);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = getElementInputValue(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: getSerializedNodeId(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort(function (a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if (isNodeShadowHost(removedNode)) {
        shadowDomRemovedCallback(removedNode.shadowRoot);
    }
    forEachChildNodes(removedNode, function (childNode) { return traverseRemovedShadowDom(childNode, shadowDomRemovedCallback); });
}
//# sourceMappingURL=mutationObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/focusObserver.js

function initFocusObserver(configuration, focusCb) {
    return (0,addEventListener/* addEventListeners */.yw)(configuration, window, [addEventListener/* DOM_EVENT.FOCUS */.EZ.FOCUS, addEventListener/* DOM_EVENT.BLUR */.EZ.BLUR], function () {
        focusCb({ has_focus: document.hasFocus() });
    }).stop;
}
//# sourceMappingURL=focusObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/recordIds.js
function initRecordIds() {
    var recordIds = new WeakMap();
    var nextId = 1;
    return {
        getIdForEvent: function (event) {
            if (!recordIds.has(event)) {
                recordIds.set(event, nextId++);
            }
            return recordIds.get(event);
        },
    };
}
//# sourceMappingURL=recordIds.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/observers.js











function initObservers(configuration, o) {
    var recordIds = initRecordIds();
    var mutationHandler = initMutationObserver(o.mutationCb, o.configuration, o.shadowRootsController, document);
    var mousemoveHandler = initMoveObserver(configuration, o.mousemoveCb);
    var mouseInteractionHandler = initMouseInteractionObserver(configuration, o.mouseInteractionCb, recordIds);
    var scrollHandler = initScrollObserver(configuration, o.scrollCb, o.configuration.defaultPrivacyLevel, o.elementsScrollPositions);
    var viewportResizeHandler = initViewportResizeObserver(configuration, o.viewportResizeCb);
    var inputHandler = initInputObserver(configuration, o.inputCb);
    var mediaInteractionHandler = initMediaInteractionObserver(configuration, o.mediaInteractionCb, o.configuration.defaultPrivacyLevel);
    var styleSheetObserver = initStyleSheetObserver(o.styleSheetCb);
    var focusHandler = initFocusObserver(configuration, o.focusCb);
    var visualViewportResizeHandler = initVisualViewportResizeObserver(configuration, o.visualViewportResizeCb);
    var frustrationHandler = initFrustrationObserver(o.lifeCycle, o.frustrationCb, recordIds);
    return {
        flush: function () {
            mutationHandler.flush();
        },
        stop: function () {
            mutationHandler.stop();
            mousemoveHandler();
            mouseInteractionHandler();
            scrollHandler();
            viewportResizeHandler();
            inputHandler();
            mediaInteractionHandler();
            styleSheetObserver();
            focusHandler();
            visualViewportResizeHandler();
            frustrationHandler();
        },
    };
}
//# sourceMappingURL=observers.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/elementsScrollPositions.js
function createElementsScrollPositions() {
    var scrollPositionsByElement = new WeakMap();
    return {
        set: function (element, scrollPositions) {
            if (element === document && !document.scrollingElement) {
                // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
                // in some cases scrolling elements can not be defined, we don't support those for now
                return;
            }
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get: function (element) {
            return scrollPositionsByElement.get(element);
        },
        has: function (element) {
            return scrollPositionsByElement.has(element);
        },
    };
}
//# sourceMappingURL=elementsScrollPositions.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/shadowRootsController.js

var initShadowRootsController = function (configuration, _a) {
    var mutationCb = _a.mutationCb, inputCb = _a.inputCb;
    var controllerByShadowRoot = new Map();
    var shadowRootsController = {
        addShadowRoot: function (shadowRoot) {
            var _a = initMutationObserver(mutationCb, configuration, shadowRootsController, shadowRoot), stopMutationObserver = _a.stop, flush = _a.flush;
            // the change event no do bubble up across the shadow root, we have to listen on the shadow root
            var stopInputObserver = initInputObserver(configuration, inputCb, shadowRoot);
            controllerByShadowRoot.set(shadowRoot, {
                flush: flush,
                stop: function () {
                    stopMutationObserver();
                    stopInputObserver();
                },
            });
        },
        removeShadowRoot: function (shadowRoot) {
            var entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) {
                // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
                return;
            }
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var stop = _a.stop;
                return stop();
            });
        },
        flush: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var flush = _a.flush;
                return flush();
            });
        },
    };
    return shadowRootsController;
};
//# sourceMappingURL=shadowRootsController.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/record.js









function record(options) {
    var emit = options.emit, configuration = options.configuration;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    var elementsScrollPositions = createElementsScrollPositions();
    var mutationCb = function (mutation) {
        emit(assembleIncrementalSnapshot(IncrementalSource.Mutation, mutation));
    };
    var inputCb = function (s) { return emit(assembleIncrementalSnapshot(IncrementalSource.Input, s)); };
    var shadowRootsController = initShadowRootsController(configuration, { mutationCb: mutationCb, inputCb: inputCb });
    var takeFullSnapshot = function (timestamp, serializationContext) {
        if (timestamp === void 0) { timestamp = (0,timeUtils/* timeStampNow */.n$)(); }
        if (serializationContext === void 0) { serializationContext = {
            status: 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */,
            elementsScrollPositions: elementsScrollPositions,
            shadowRootsController: shadowRootsController,
        }; }
        var _a = getViewportDimension(), width = _a.width, height = _a.height;
        emit({
            data: {
                height: height,
                href: window.location.href,
                width: width,
            },
            type: RecordType.Meta,
            timestamp: timestamp,
        });
        emit({
            data: {
                has_focus: document.hasFocus(),
            },
            type: RecordType.Focus,
            timestamp: timestamp,
        });
        emit({
            data: {
                node: serializeDocument(document, configuration, serializationContext),
                initialOffset: {
                    left: getScrollX(),
                    top: getScrollY(),
                },
            },
            type: RecordType.FullSnapshot,
            timestamp: timestamp,
        });
        if (window.visualViewport) {
            emit({
                data: getVisualViewport(window.visualViewport),
                type: RecordType.VisualViewport,
                timestamp: timestamp,
            });
        }
    };
    takeFullSnapshot();
    var _a = initObservers(configuration, {
        lifeCycle: options.lifeCycle,
        configuration: configuration,
        elementsScrollPositions: elementsScrollPositions,
        inputCb: inputCb,
        mediaInteractionCb: function (p) {
            return emit(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, p));
        },
        mouseInteractionCb: function (mouseInteractionRecord) { return emit(mouseInteractionRecord); },
        mousemoveCb: function (positions, source) { return emit(assembleIncrementalSnapshot(source, { positions: positions })); },
        mutationCb: mutationCb,
        scrollCb: function (p) { return emit(assembleIncrementalSnapshot(IncrementalSource.Scroll, p)); },
        styleSheetCb: function (r) { return emit(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, r)); },
        viewportResizeCb: function (d) { return emit(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, d)); },
        frustrationCb: function (frustrationRecord) { return emit(frustrationRecord); },
        focusCb: function (data) {
            return emit({
                data: data,
                type: RecordType.Focus,
                timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            });
        },
        visualViewportResizeCb: function (data) {
            emit({
                data: data,
                type: RecordType.VisualViewport,
                timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            });
        },
        shadowRootsController: shadowRootsController,
    }), stopObservers = _a.stop, flushMutationsFromObservers = _a.flush;
    function flushMutations() {
        shadowRootsController.flush();
        flushMutationsFromObservers();
    }
    return {
        stop: function () {
            shadowRootsController.stop();
            stopObservers();
        },
        takeSubsequentFullSnapshot: function (timestamp) {
            flushMutations();
            takeFullSnapshot(timestamp, {
                shadowRootsController: shadowRootsController,
                status: 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */,
                elementsScrollPositions: elementsScrollPositions,
            });
        },
        flushMutations: flushMutations,
        shadowRootsController: shadowRootsController,
    };
}
//# sourceMappingURL=record.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/buildReplayPayload.js

function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
    var formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    var metadataAndSegmentSizes = (0,polyfills/* assign */.f0)({
        raw_segment_size: rawSegmentBytesCount,
        compressed_segment_size: data.byteLength,
    }, metadata);
    var serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
    formData.append('event', new Blob([serializedMetadataAndSegmentSizes], { type: 'application/json' }));
    return { data: formData, bytesCount: data.byteLength };
}
//# sourceMappingURL=buildReplayPayload.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/replayStats.js
var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function resetReplayStats() {
    statsPerView = undefined;
}
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    var replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    if (statsPerView.keys) {
        statsPerView.delete(statsPerView.keys().next().value);
    }
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        statsPerView.forEach(function (_value, key) {
            if (isFirst_1) {
                statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}
//# sourceMappingURL=replayStats.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segment.js



var Segment = /** @class */ (function () {
    function Segment(encoder, context, creationReason) {
        this.encoder = encoder;
        this.encodedBytesCount = 0;
        var viewId = context.view.id;
        this.metadata = (0,polyfills/* assign */.f0)({
            start: Infinity,
            end: -Infinity,
            creation_reason: creationReason,
            records_count: 0,
            has_full_snapshot: false,
            index_in_view: getSegmentsCount(viewId),
            source: 'browser',
        }, context);
        addSegment(viewId);
    }
    Segment.prototype.addRecord = function (record, callback) {
        var _this = this;
        var _a;
        this.metadata.start = Math.min(this.metadata.start, record.timestamp);
        this.metadata.end = Math.max(this.metadata.end, record.timestamp);
        this.metadata.records_count += 1;
        (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === RecordType.FullSnapshot);
        (0,sendToExtension/* sendToExtension */.j)('record', { record: record, segment: this.metadata });
        addRecord(this.metadata.view.id);
        var prefix = this.encoder.isEmpty ? '{"records":[' : ',';
        this.encoder.write(prefix + JSON.stringify(record), function (additionalEncodedBytesCount) {
            _this.encodedBytesCount += additionalEncodedBytesCount;
            callback(_this.encodedBytesCount);
        });
    };
    Segment.prototype.flush = function (callback) {
        var _this = this;
        if (this.encoder.isEmpty) {
            throw new Error('Empty segment flushed');
        }
        this.encoder.write("],".concat(JSON.stringify(this.metadata).slice(1), "\n"));
        this.encoder.finish(function (encoderResult) {
            addWroteData(_this.metadata.view.id, encoderResult.rawBytesCount);
            callback(_this.metadata, encoderResult);
        });
    };
    return Segment;
}());

//# sourceMappingURL=segment.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segmentCollection.js



var SEGMENT_DURATION_LIMIT = 30 * timeUtils/* ONE_SECOND */.WT;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
var SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, httpRequest, encoder) {
    return doStartSegmentCollection(lifeCycle, function () { return computeSegmentContext(configuration.applicationId, sessionManager, viewContexts); }, httpRequest, encoder);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, encoder) {
    var state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function () {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribePageExited = lifeCycle.subscribe(9 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
        flushSegment(pageExitEvent.reason);
    }).unsubscribe;
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */) {
            state.segment.flush(function (metadata, encoderResult) {
                var payload = buildReplayPayload(encoderResult.output, metadata, encoderResult.rawBytesCount);
                if ((0,browser_pageExitObservable/* isPageExitReason */.PT)(flushReason)) {
                    httpRequest.sendOnExit(payload);
                }
                else {
                    httpRequest.send(payload);
                }
            });
            (0,timer/* clearTimeout */.gr)(state.expirationTimeoutId);
        }
        if (flushReason !== 'stop') {
            state = {
                status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
                nextSegmentCreationReason: flushReason,
            };
        }
        else {
            state = {
                status: 2 /* SegmentCollectionStatus.Stopped */,
            };
        }
    }
    return {
        addRecord: function (record) {
            if (state.status === 2 /* SegmentCollectionStatus.Stopped */) {
                return;
            }
            if (state.status === 0 /* SegmentCollectionStatus.WaitingForInitialRecord */) {
                var context = getSegmentContext();
                if (!context) {
                    return;
                }
                state = {
                    status: 1 /* SegmentCollectionStatus.SegmentPending */,
                    segment: new Segment(encoder, context, state.nextSegmentCreationReason),
                    expirationTimeoutId: (0,timer/* setTimeout */.iK)(function () {
                        flushSegment('segment_duration_limit');
                    }, SEGMENT_DURATION_LIMIT),
                };
            }
            state.segment.addRecord(record, function (encodedBytesCount) {
                if (encodedBytesCount > SEGMENT_BYTES_LIMIT) {
                    flushSegment('segment_bytes_limit');
                }
            });
        },
        stop: function () {
            flushSegment('stop');
            unsubscribeViewCreated();
            unsubscribePageExited();
        },
    };
}
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewContexts.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.id,
        },
    };
}
function setSegmentBytesLimit(newSegmentBytesLimit) {
    if (newSegmentBytesLimit === void 0) { newSegmentBytesLimit = 60000; }
    SEGMENT_BYTES_LIMIT = newSegmentBytesLimit;
}
//# sourceMappingURL=segmentCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/startRecording.js




function startRecording(lifeCycle, configuration, sessionManager, viewContexts, encoder, httpRequest) {
    var reportError = function (error) {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
    var replayRequest = httpRequest ||
        (0,transport_httpRequest/* createHttpRequest */.UF)(configuration, configuration.sessionReplayEndpointBuilder, SEGMENT_BYTES_LIMIT, reportError);
    var _a = startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, replayRequest, encoder), addRecord = _a.addRecord, stopSegmentCollection = _a.stop;
    var _b = record({
        emit: addRecord,
        configuration: configuration,
        lifeCycle: lifeCycle,
    }), stopRecording = _b.stop, takeSubsequentFullSnapshot = _b.takeSubsequentFullSnapshot, flushMutations = _b.flushMutations;
    var unsubscribeViewEnded = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function () {
        flushMutations();
        addRecord({
            timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            type: RecordType.ViewEnd,
        });
    }).unsubscribe;
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
        takeSubsequentFullSnapshot(view.startClocks.timeStamp);
    }).unsubscribe;
    return {
        stop: function () {
            unsubscribeViewEnded();
            unsubscribeViewCreated();
            stopRecording();
            stopSegmentCollection();
        },
    };
}
//# sourceMappingURL=startRecording.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/isBrowserSupported.js
/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
    return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' &&
        typeof CSSSupportsRule === 'function' &&
        typeof URL.createObjectURL === 'function' &&
        'forEach' in NodeList.prototype);
}
//# sourceMappingURL=isBrowserSupported.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/getSessionReplayLink.js


function getSessionReplayLink(configuration, sessionManager, viewContexts, isRecordingStarted) {
    var session = sessionManager.findTrackedSession();
    var errorType = getErrorType(session, isRecordingStarted);
    var viewContext = viewContexts.findView();
    return getSessionReplayUrl(configuration, {
        viewContext: viewContext,
        errorType: errorType,
        session: session,
    });
}
function getErrorType(session, isRecordingStarted) {
    if (!isBrowserSupported()) {
        return 'browser-not-supported';
    }
    if (!session) {
        // possibilities:
        // - rum sampled out
        // - session expired (edge case)
        return 'rum-not-tracked';
    }
    if (!session.sessionReplayAllowed) {
        // possibilities
        // - replay sampled out
        return 'incorrect-session-plan';
    }
    if (!isRecordingStarted) {
        return 'replay-not-started';
    }
}
//# sourceMappingURL=getSessionReplayLink.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/deflate/deflateEncoder.js

function createDeflateEncoder(configuration, worker, streamId) {
    var rawBytesCount = 0;
    var compressedData = [];
    var compressedDataTrailer;
    var nextWriteActionId = 0;
    var pendingWriteActions = [];
    var removeMessageListener = (0,addEventListener/* addEventListener */.Oo)(configuration, worker, 'message', function (_a) {
        var workerResponse = _a.data;
        if (workerResponse.type !== 'wrote' || workerResponse.streamId !== streamId) {
            return;
        }
        rawBytesCount += workerResponse.additionalBytesCount;
        compressedData.push(workerResponse.result);
        compressedDataTrailer = workerResponse.trailer;
        var nextPendingAction = pendingWriteActions.shift();
        if (nextPendingAction && nextPendingAction.id === workerResponse.id) {
            if (nextPendingAction.writeCallback) {
                nextPendingAction.writeCallback(workerResponse.result.byteLength);
            }
            else if (nextPendingAction.finishCallback) {
                nextPendingAction.finishCallback();
            }
        }
        else {
            removeMessageListener();
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Worker responses received out of order.');
        }
    }).stop;
    function consumeResult() {
        var output = compressedData.length === 0 ? new Uint8Array(0) : (0,byteUtils/* concatBuffers */.Kb)(compressedData.concat(compressedDataTrailer));
        var result = {
            rawBytesCount: rawBytesCount,
            output: output,
            outputBytesCount: output.byteLength,
            encoding: 'deflate',
        };
        rawBytesCount = 0;
        compressedData = [];
        return result;
    }
    function sendResetIfNeeded() {
        if (nextWriteActionId > 0) {
            worker.postMessage({
                action: 'reset',
                streamId: streamId,
            });
            nextWriteActionId = 0;
        }
    }
    return {
        isAsync: true,
        get isEmpty() {
            return nextWriteActionId === 0;
        },
        write: function (data, callback) {
            worker.postMessage({
                action: 'write',
                id: nextWriteActionId,
                data: data,
                streamId: streamId,
            });
            pendingWriteActions.push({
                id: nextWriteActionId,
                writeCallback: callback,
                data: data,
            });
            nextWriteActionId += 1;
        },
        finish: function (callback) {
            sendResetIfNeeded();
            if (!pendingWriteActions.length) {
                callback(consumeResult());
            }
            else {
                // Make sure we do not call any write callback
                pendingWriteActions.forEach(function (pendingWriteAction) {
                    delete pendingWriteAction.writeCallback;
                });
                // Wait for the last action to finish before calling the finish callback
                pendingWriteActions[pendingWriteActions.length - 1].finishCallback = function () { return callback(consumeResult()); };
            }
        },
        finishSync: function () {
            sendResetIfNeeded();
            var pendingData = pendingWriteActions
                .map(function (pendingWriteAction) {
                // Make sure we do not call any write or finish callback
                delete pendingWriteAction.writeCallback;
                delete pendingWriteAction.finishCallback;
                return pendingWriteAction.data;
            })
                .join('');
            return (0,polyfills/* assign */.f0)(consumeResult(), {
                pendingData: pendingData,
            });
        },
        estimateEncodedBytesCount: function (data) {
            // This is a rough estimation of the data size once it'll be encoded by deflate. We observed
            // that if it's the first chunk of data pushed to the stream, the ratio is lower (3-4), but
            // after that the ratio is greater (10+). We chose 8 here, which (on average) seems to produce
            // requests of the expected size.
            return data.length / 8;
        },
        stop: function () {
            removeMessageListener();
        },
    };
}
//# sourceMappingURL=deflateEncoder.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/deflate/deflateWorker.js

var INITIALIZATION_TIME_OUT_DELAY = 10 * timeUtils/* ONE_SECOND */.WT;
function createDeflateWorker(configuration) {
    return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob(["!function(){\"use strict\";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),_=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),h=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),l=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},E=function(t,e,a){var n,r,s=new Array(16),_=0;for(n=1;n<=i;n++)s[n]=_=_+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=A(s[h]++,h))}},Z=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},U=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},S=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},R=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&S(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!S(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},L=function(t,e,n){var r,i,h,l,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(h=f[i],x(t,h+a+1,e),0!==(l=s[h])&&(i-=c[h],z(t,i,l)),r--,h=y(r),x(t,h,n),0!==(l=_[h])&&(r-=v[h],z(t,r,l)))}while(o<t.last_lit);x(t,256,e)},F=function(t,e){var a,n,r,s=e.dyn_tree,_=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=_[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)R(t,s,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,R(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,_,h,l=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=l[2*l[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),l[2*n+1]=s,n>o||(t.bl_count[s]++,_=0,n>=c&&(_=f[n-c]),h=l[2*n],t.opt_len+=h*(s+_),u&&(t.static_len+=h*(d[2*n+1]+_)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(l[2*r+1]!==s&&(t.opt_len+=(s-l[2*r+1])*l[2*r],l[2*r+1]=s),n--)}}(t,e),E(s,o,t.bl_count)},T=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++_<h&&r===s||(_<l?t.bl_tree[2*r]+=_:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):_<=10?t.bl_tree[34]++:t.bl_tree[36]++,_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4))},I=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++_<h&&r===s)){if(_<l)do{x(t,r,t.bl_tree)}while(0!=--_);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),_--),x(t,16,t.bl_tree),z(t,_-3,2)):_<=10?(x(t,17,t.bl_tree),z(t,_-3,3)):(x(t,18,t.bl_tree),z(t,_-11,7));_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4)}},N=!1,O=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){U(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},D=function(t,e,n,r){var i,s,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),F(t,t.l_desc),F(t,t.d_desc),_=function(t){var e;for(T(t,t.dyn_ltree,t.l_desc.max_code),T(t,t.dyn_dtree,t.d_desc.max_code),F(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*l[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?O(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),L(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*l[r]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),L(t,t.dyn_ltree,t.dyn_dtree)),Z(t),r&&U(t)},B={_tr_init:function(t){N||(!function(){var t,e,a,l,m,y=new Array(16);for(a=0,l=0;l<28;l++)for(c[l]=a,t=0;t<1<<s[l];t++)f[a++]=l;for(f[a-1]=l,m=0,l=0;l<16;l++)for(v[l]=m,t=0;t<1<<_[l];t++)u[m++]=l;for(m>>=7;l<r;l++)for(v[l]=m<<7,t=0;t<1<<_[l]-7;t++)u[256+m++]=l;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(E(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,_,0,r,i),w=new b(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,Z(t)},_tr_stored_block:O,_tr_flush_block:D,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},C=function(t,e,a,n){for(var r=65535&t|0,i=t>>>16&65535|0,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16|0},H=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),M=function(t,e,a,n){var r=H,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},Y={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},K={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8},P=B._tr_init,j=B._tr_stored_block,G=B._tr_flush_block,X=B._tr_tally,W=B._tr_align,q=K.Z_NO_FLUSH,J=K.Z_PARTIAL_FLUSH,Q=K.Z_FULL_FLUSH,V=K.Z_FINISH,$=K.Z_BLOCK,tt=K.Z_OK,et=K.Z_STREAM_END,at=K.Z_STREAM_ERROR,nt=K.Z_DATA_ERROR,rt=K.Z_BUF_ERROR,it=K.Z_DEFAULT_COMPRESSION,st=K.Z_FILTERED,_t=K.Z_HUFFMAN_ONLY,ht=K.Z_RLE,lt=K.Z_FIXED,ot=K.Z_DEFAULT_STRATEGY,dt=K.Z_UNKNOWN,ut=K.Z_DEFLATED,ft=258,ct=262,pt=103,gt=113,wt=666,vt=function(t,e){return t.msg=Y[e],e},bt=function(t){return(t<<1)-(t>4?9:0)},mt=function(t){for(var e=t.length;--e>=0;)t[e]=0},yt=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},kt=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},zt=function(t,e){G(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,kt(t.strm)},xt=function(t,e){t.pending_buf[t.pending++]=e},At=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,_=t.nice_match,h=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,l=t.window,o=t.w_mask,d=t.prev,u=t.strstart+ft,f=l[i+s-1],c=l[i+s];t.prev_length>=t.good_match&&(r>>=2),_>t.lookahead&&(_=t.lookahead);do{if(l[(a=e)+s]===c&&l[a+s-1]===f&&l[a]===l[i]&&l[++a]===l[i+1]){i+=2,a++;do{}while(l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&i<u);if(n=ft-(u-i),i=u-ft,n>s){if(t.match_start=e,s=n,n>=_)break;f=l[i+s-1],c=l[i+s]}}}while((e=d[e&o])>h&&0!=--r);return s<=t.lookahead?s:t.lookahead},Zt=function(t){var e,a,n,r,i,s,_,h,l,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-ct)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,_=t.window,h=t.strstart+t.lookahead,l=r,o=void 0,(o=s.avail_in)>l&&(o=l),a=0===o?0:(s.avail_in-=o,_.set(s.input.subarray(s.next_in,s.next_in+o),h),1===s.state.wrap?s.adler=C(s.adler,_,o,h):2===s.state.wrap&&(s.adler=M(s.adler,_,o,h)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=yt(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=yt(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Ut=function(t,e){for(var a,n;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(n=X(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=yt(t,t.ins_h,t.window[t.strstart+1]);else n=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2},St=function(t,e){for(var a,n,r;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=X(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(zt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=X(t,0,t.window[t.strstart-1]))&&zt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=X(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Lt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Zt(t),0===t.lookahead&&e===q)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,zt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(zt(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Ut),new Rt(4,5,16,8,Ut),new Rt(4,6,32,32,Ut),new Rt(4,4,16,16,St),new Rt(8,16,32,32,St),new Rt(8,16,128,128,St),new Rt(8,32,128,256,St),new Rt(32,128,258,1024,St),new Rt(32,258,258,4096,St)];function Ft(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ut,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Tt=function(t){if(!t||!t.state)return vt(t,at);t.total_in=t.total_out=0,t.data_type=dt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:gt,t.adler=2===e.wrap?0:1,e.last_flush=q,P(e),tt},It=function(t){var e,a=Tt(t);return a===tt&&((e=t.state).window_size=2*e.w_size,mt(e.head),e.max_lazy_match=Lt[e.level].max_lazy,e.good_match=Lt[e.level].good_length,e.nice_match=Lt[e.level].nice_length,e.max_chain_length=Lt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Nt=function(t,e,a,n,r,i){if(!t)return at;var s=1;if(e===it&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==ut||n<8||n>15||e<0||e>9||i<0||i>lt)return vt(t,at);8===n&&(n=9);var _=new Ft;return t.state=_,_.strm=t,_.wrap=s,_.gzhead=null,_.w_bits=n,_.w_size=1<<_.w_bits,_.w_mask=_.w_size-1,_.hash_bits=r+7,_.hash_size=1<<_.hash_bits,_.hash_mask=_.hash_size-1,_.hash_shift=~~((_.hash_bits+3-1)/3),_.window=new Uint8Array(2*_.w_size),_.head=new Uint16Array(_.hash_size),_.prev=new Uint16Array(_.w_size),_.lit_bufsize=1<<r+6,_.pending_buf_size=4*_.lit_bufsize,_.pending_buf=new Uint8Array(_.pending_buf_size),_.d_buf=1*_.lit_bufsize,_.l_buf=3*_.lit_bufsize,_.level=e,_.strategy=i,_.method=a,It(t)},Ot={deflateInit:function(t,e){return Nt(t,e,ut,15,8,ot)},deflateInit2:Nt,deflateReset:It,deflateResetKeep:Tt,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?at:(t.state.gzhead=e,tt):at},deflate:function(t,e){var a,n;if(!t||!t.state||e>$||e<0)return t?vt(t,at):at;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===wt&&e!==V)return vt(t,0===t.avail_out?rt:at);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,xt(r,31),xt(r,139),xt(r,8),r.gzhead?(xt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),xt(r,255&r.gzhead.time),xt(r,r.gzhead.time>>8&255),xt(r,r.gzhead.time>>16&255),xt(r,r.gzhead.time>>24&255),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(xt(r,255&r.gzhead.extra.length),xt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=M(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,3),r.status=gt);else{var s=ut+(r.w_bits-8<<4)<<8;s|=(r.strategy>=_t||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=gt,At(r,s),0!==r.strstart&&(At(r,t.adler>>>16),At(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending!==r.pending_buf_size));)xt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=pt)}else r.status=pt;if(r.status===pt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&kt(t),r.pending+2<=r.pending_buf_size&&(xt(r,255&t.adler),xt(r,t.adler>>8&255),t.adler=0,r.status=gt)):r.status=gt),0!==r.pending){if(kt(t),0===t.avail_out)return r.last_flush=-1,tt}else if(0===t.avail_in&&bt(e)<=bt(i)&&e!==V)return vt(t,rt);if(r.status===wt&&0!==t.avail_in)return vt(t,rt);if(0!==t.avail_in||0!==r.lookahead||e!==q&&r.status!==wt){var _=r.strategy===_t?function(t,e){for(var a;;){if(0===t.lookahead&&(Zt(t),0===t.lookahead)){if(e===q)return 1;break}if(t.match_length=0,a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===ht?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=ft){if(Zt(t),t.lookahead<=ft&&e===q)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+ft;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=ft-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=X(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):Lt[r.level].func(r,e);if(3!==_&&4!==_||(r.status=wt),1===_||3===_)return 0===t.avail_out&&(r.last_flush=-1),tt;if(2===_&&(e===J?W(r):e!==$&&(j(r,0,0,!1),e===Q&&(mt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),kt(t),0===t.avail_out))return r.last_flush=-1,tt}return e!==V?tt:r.wrap<=0?et:(2===r.wrap?(xt(r,255&t.adler),xt(r,t.adler>>8&255),xt(r,t.adler>>16&255),xt(r,t.adler>>24&255),xt(r,255&t.total_in),xt(r,t.total_in>>8&255),xt(r,t.total_in>>16&255),xt(r,t.total_in>>24&255)):(At(r,t.adler>>>16),At(r,65535&t.adler)),kt(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?tt:et)},deflateEnd:function(t){if(!t||!t.state)return at;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==pt&&e!==gt&&e!==wt?vt(t,at):(t.state=null,e===gt?vt(t,nt):tt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return at;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return at;if(1===r&&(t.adler=C(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(mt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,_=t.next_in,h=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Zt(n);n.lookahead>=3;){var l=n.strstart,o=n.lookahead-2;do{n.ins_h=yt(n,n.ins_h,n.window[l+3-1]),n.prev[l&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=l,l++}while(--o);n.strstart=l,n.lookahead=2,Zt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=_,t.input=h,t.avail_in=s,n.wrap=r,tt},deflateInfo:\"pako deflate (from Nodeca project)\"};for(var Dt=new Uint8Array(256),Bt=0;Bt<256;Bt++)Dt[Bt]=Bt>=252?6:Bt>=248?5:Bt>=240?4:Bt>=224?3:Bt>=192?2:1;Dt[254]=Dt[254]=1;var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},Ht=Object.prototype.toString,Mt=K.Z_NO_FLUSH,Yt=K.Z_SYNC_FLUSH,Kt=K.Z_FULL_FLUSH,Pt=K.Z_FINISH,jt=K.Z_OK,Gt=K.Z_STREAM_END,Xt=K.Z_DEFAULT_COMPRESSION,Wt=K.Z_DEFAULT_STRATEGY,qt=K.Z_DEFLATED;function Jt(){this.options={level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;var e=Ot.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==jt)throw new Error(Y[e]);if(t.header&&Ot.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a=\"[object ArrayBuffer]\"===Ht.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Ot.deflateSetDictionary(this.strm,a))!==jt)throw new Error(Y[e]);this._dict_set=!0}}function Qt(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch(n){t.postMessage({type:\"errored\",error:String(e),streamId:a})}}function Vt(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}Jt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Pt:Mt,\"[object ArrayBuffer]\"===Ht.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Yt||n===Kt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Ot.deflate(r,n))===Gt)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Ot.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===jt;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===jt&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,_=t.length;i<_;i++){var h=t[i];r.set(h,s),s+=h.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener(\"message\",(function(n){try{var r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"5.4.0\"};case\"write\":var n=e.get(a.streamId);n||(n=new Jt,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if(\"function\"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,_=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),_+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(_),i=0,r=0;i<_;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,K.Z_SYNC_FLUSH),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:Vt(n),additionalBytesCount:i.length};case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){Qt(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}}))}catch(t){Qt(e,t)}}()}();"])));
}
var state = { status: 0 /* DeflateWorkerStatus.Nil */ };
function startDeflateWorker(configuration, source, onInitializationFailure, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    if (state.status === 0 /* DeflateWorkerStatus.Nil */) {
        // doStartDeflateWorker updates the state to "loading" or "error"
        doStartDeflateWorker(configuration, source, createDeflateWorkerImpl);
    }
    switch (state.status) {
        case 1 /* DeflateWorkerStatus.Loading */:
            state.initializationFailureCallbacks.push(onInitializationFailure);
            return state.worker;
        case 3 /* DeflateWorkerStatus.Initialized */:
            return state.worker;
    }
}
function resetDeflateWorkerState() {
    if (state.status === 3 /* DeflateWorkerStatus.Initialized */ || state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state.stop();
    }
    state = { status: 0 /* DeflateWorkerStatus.Nil */ };
}
function getDeflateWorkerStatus() {
    return state.status;
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(configuration, source, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    try {
        var worker = createDeflateWorkerImpl(configuration);
        var removeErrorListener_1 = (0,addEventListener/* addEventListener */.Oo)(configuration, worker, 'error', function (error) {
            onError(configuration, source, error);
        }).stop;
        var removeMessageListener_1 = (0,addEventListener/* addEventListener */.Oo)(configuration, worker, 'message', function (_a) {
            var data = _a.data;
            if (data.type === 'errored') {
                onError(configuration, source, data.error, data.streamId);
            }
            else if (data.type === 'initialized') {
                onInitialized(data.version);
            }
        }).stop;
        worker.postMessage({ action: 'init' });
        (0,timer/* setTimeout */.iK)(function () { return onTimeout(source); }, INITIALIZATION_TIME_OUT_DELAY);
        var stop_1 = function () {
            removeErrorListener_1();
            removeMessageListener_1();
        };
        state = { status: 1 /* DeflateWorkerStatus.Loading */, worker: worker, stop: stop_1, initializationFailureCallbacks: [] };
    }
    catch (error) {
        onError(configuration, source, error);
    }
}
function onTimeout(source) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        display/* display.error */.jf.error("".concat(source, " failed to start: a timeout occurred while initializing the Worker"));
        state.initializationFailureCallbacks.forEach(function (callback) { return callback(); });
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
}
function onInitialized(version) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state = { status: 3 /* DeflateWorkerStatus.Initialized */, worker: state.worker, stop: state.stop, version: version };
    }
}
function onError(configuration, source, error, streamId) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */ || state.status === 0 /* DeflateWorkerStatus.Nil */) {
        display/* display.error */.jf.error("".concat(source, " failed to start: an error occurred while creating the Worker:"), error);
        if (error instanceof Event || (error instanceof Error && isMessageCspRelated(error.message))) {
            var baseMessage = void 0;
            if (configuration.workerUrl) {
                baseMessage = "Please make sure the Worker URL ".concat(configuration.workerUrl, " is correct and CSP is correctly configured.");
            }
            else {
                baseMessage = 'Please make sure CSP is correctly configured.';
            }
            display/* display.error */.jf.error("".concat(baseMessage, " See documentation at https://docs.datadoghq.com/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
        }
        else {
            (0,telemetry_telemetry/* addTelemetryError */.Sz)(error);
        }
        if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
            state.initializationFailureCallbacks.forEach(function (callback) { return callback(); });
        }
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
    else {
        (0,telemetry_telemetry/* addTelemetryError */.Sz)(error, {
            worker_version: state.status === 3 /* DeflateWorkerStatus.Initialized */ && state.version,
            stream_id: streamId,
        });
    }
}
function isMessageCspRelated(message) {
    return ((0,polyfills/* includes */.q9)(message, 'Content Security Policy') ||
        // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
        (0,polyfills/* includes */.q9)(message, "requires 'TrustedScriptURL'"));
}
//# sourceMappingURL=deflateWorker.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/deflate/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/recorderApi.js





function makeRecorderApi(startRecordingImpl, createDeflateWorkerImpl) {
    if ((0,eventBridge/* canUseEventBridge */.x)() || !isBrowserSupported()) {
        return {
            start: functionUtils/* noop */.Z,
            stop: functionUtils/* noop */.Z,
            getReplayStats: function () { return undefined; },
            onRumStart: functionUtils/* noop */.Z,
            isRecording: function () { return false; },
            getSessionReplayLink: function () { return undefined; },
        };
    }
    var state = {
        status: 1 /* RecorderStatus.IntentToStart */,
    };
    var startStrategy = function () {
        state = { status: 1 /* RecorderStatus.IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* RecorderStatus.Stopped */ };
    };
    return {
        start: function () { return startStrategy(); },
        stop: function () { return stopStrategy(); },
        getSessionReplayLink: function (configuration, sessionManager, viewContexts) {
            return getSessionReplayLink(configuration, sessionManager, viewContexts, state.status !== 0 /* RecorderStatus.Stopped */);
        },
        onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts, worker) {
            if (configuration.startSessionReplayRecordingManually) {
                state = { status: 0 /* RecorderStatus.Stopped */ };
            }
            lifeCycle.subscribe(7 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    stopStrategy();
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                }
            });
            lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
                if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                    startStrategy();
                }
            });
            startStrategy = function () {
                var session = sessionManager.findTrackedSession();
                if (!session || !session.sessionReplayAllowed) {
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    return;
                }
                state = { status: 2 /* RecorderStatus.Starting */ };
                runOnReadyState(configuration, 'interactive', function () {
                    if (state.status !== 2 /* RecorderStatus.Starting */) {
                        return;
                    }
                    if (!worker) {
                        worker = startDeflateWorker(configuration, 'Datadog Session Replay', function () {
                            stopStrategy();
                        }, createDeflateWorkerImpl);
                        if (!worker) {
                            state = {
                                status: 0 /* RecorderStatus.Stopped */,
                            };
                            return;
                        }
                    }
                    var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, createDeflateEncoder(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */)).stop;
                    state = {
                        status: 3 /* RecorderStatus.Started */,
                        stopRecording: stopRecording,
                    };
                });
            };
            stopStrategy = function () {
                if (state.status === 0 /* RecorderStatus.Stopped */) {
                    return;
                }
                if (state.status === 3 /* RecorderStatus.Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* RecorderStatus.Stopped */,
                };
            };
            if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () {
            // The worker is started optimistically, meaning we could have started to record but its
            // initialization fails a bit later. This could happen when:
            // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
            // throw an exception when instantiating the worker, and IE doesn't care about CSP)
            // * the browser fails to load the worker in case the workerUrl is used
            // * an unexpected error occurs in the Worker before initialization, ex:
            //   * a runtime exception collected by monitor()
            //   * a syntax error notified by the browser via an error event
            // * the worker is unresponsive for some reason and timeouts
            //
            // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
            // an important part of the Datadog App:
            // * If we have a false positive (we set has_replay: true even if no replay data is present),
            // we might display broken links to the Session Replay player.
            // * If we have a false negative (we don't set has_replay: true even if replay data is
            // available), it is less noticeable because no link will be displayed.
            //
            // Thus, it is better to have false negative, so let's make sure the worker is correctly
            // initialized before advertizing that we are recording.
            //
            // In the future, when the compression worker will also be used for RUM data, this will be
            // less important since no RUM event will be sent when the worker fails to initialize.
            return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ && state.status === 3 /* RecorderStatus.Started */;
        },
        getReplayStats: function (viewId) {
            return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ ? getReplayStats(viewId) : undefined;
        },
    };
}
//# sourceMappingURL=recorderApi.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.js
// Keep the following in sync with packages/rum-slim/src/entries/main.ts






var recorderApi = makeRecorderApi(startRecording);
var datadogRum = makeRumPublicApi(startRum, recorderApi, { startDeflateWorker: startDeflateWorker, createDeflateEncoder: createDeflateEncoder });
(0,init/* defineGlobal */.y)((0,getGlobalObject/* getGlobalObject */.R)(), 'DD_RUM', datadogRum);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 84336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ instance; }
});

;// CONCATENATED MODULE: ./node_modules/@datapunt/matomo-tracker-js/es/constants.js
// eslint-disable-next-line import/prefer-default-export
const TRACK_TYPES = {
    TRACK_EVENT: 'trackEvent',
    TRACK_LINK: 'trackLink',
    TRACK_SEARCH: 'trackSiteSearch',
    TRACK_VIEW: 'trackPageView',
    TRACK_ECOMMERCE_ORDER: 'trackEcommerceOrder',
    TRACK_ECOMMERCE_CART_UPDATE: 'trackEcommerceCartUpdate',
};
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ./node_modules/@datapunt/matomo-tracker-js/es/MatomoTracker.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};

class MatomoTracker {
    constructor(userOptions) {
        if (!userOptions.urlBase) {
            throw new Error('Matomo urlBase is required.');
        }
        if (!userOptions.siteId) {
            throw new Error('Matomo siteId is required.');
        }
        this.initialize(userOptions);
    }
    initialize({ urlBase, siteId, userId, trackerUrl, srcUrl, disabled, heartBeat, linkTracking = true, configurations = {}, }) {
        var _a;
        const normalizedUrlBase = urlBase[urlBase.length - 1] !== '/' ? `${urlBase}/` : urlBase;
        if (typeof window === 'undefined') {
            return;
        }
        window._paq = window._paq || [];
        if (window._paq.length !== 0) {
            return;
        }
        if (disabled) {
            return;
        }
        this.pushInstruction('setTrackerUrl', trackerUrl !== null && trackerUrl !== void 0 ? trackerUrl : `${normalizedUrlBase}matomo.php`);
        this.pushInstruction('setSiteId', siteId);
        if (userId) {
            this.pushInstruction('setUserId', userId);
        }
        Object.entries(configurations).forEach((entry) => {
            this.pushInstruction(entry[0], entry[1]);
        });
        // accurately measure the time spent on the last pageview of a visit
        if (!heartBeat || (heartBeat && heartBeat.active)) {
            this.enableHeartBeatTimer((_a = (heartBeat && heartBeat.seconds)) !== null && _a !== void 0 ? _a : 15);
        }
        // // measure outbound links and downloads
        // // might not work accurately on SPAs because new links (dom elements) are created dynamically without a server-side page reload.
        this.enableLinkTracking(linkTracking);
        const doc = document;
        const scriptElement = doc.createElement('script');
        const scripts = doc.getElementsByTagName('script')[0];
        scriptElement.type = 'text/javascript';
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.src = srcUrl || `${normalizedUrlBase}matomo.js`;
        if (scripts && scripts.parentNode) {
            scripts.parentNode.insertBefore(scriptElement, scripts);
        }
    }
    enableHeartBeatTimer(seconds) {
        this.pushInstruction('enableHeartBeatTimer', seconds);
    }
    enableLinkTracking(active) {
        this.pushInstruction('enableLinkTracking', active);
    }
    trackEventsForElements(elements) {
        if (elements.length) {
            elements.forEach((element) => {
                element.addEventListener('click', () => {
                    const { matomoCategory, matomoAction, matomoName, matomoValue, } = element.dataset;
                    if (matomoCategory && matomoAction) {
                        this.trackEvent({
                            category: matomoCategory,
                            action: matomoAction,
                            name: matomoName,
                            value: Number(matomoValue),
                        });
                    }
                    else {
                        throw new Error(`Error: data-matomo-category and data-matomo-action are required.`);
                    }
                });
            });
        }
    }
    // Tracks events based on data attributes
    trackEvents() {
        const matchString = '[data-matomo-event="click"]';
        let firstTime = false;
        if (!this.mutationObserver) {
            firstTime = true;
            this.mutationObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        // only track HTML elements
                        if (!(node instanceof HTMLElement))
                            return;
                        // check the inserted element for being a code snippet
                        if (node.matches(matchString)) {
                            this.trackEventsForElements([node]);
                        }
                        const elements = Array.from(node.querySelectorAll(matchString));
                        this.trackEventsForElements(elements);
                    });
                });
            });
        }
        this.mutationObserver.observe(document, { childList: true, subtree: true });
        // Now track all already existing elements
        if (firstTime) {
            const elements = Array.from(document.querySelectorAll(matchString));
            this.trackEventsForElements(elements);
        }
    }
    stopObserving() {
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
        }
    }
    // Tracks events
    // https://matomo.org/docs/event-tracking/#tracking-events
    trackEvent(_a) {
        var { category, action, name, value } = _a, otherParams = __rest(_a, ["category", "action", "name", "value"]);
        if (category && action) {
            this.track(Object.assign({ data: [TRACK_TYPES.TRACK_EVENT, category, action, name, value] }, otherParams));
        }
        else {
            throw new Error(`Error: category and action are required.`);
        }
    }
    // Tracks site search
    // https://developer.matomo.org/guides/tracking-javascript-guide#internal-search-tracking
    trackSiteSearch(_a) {
        var { keyword, category, count } = _a, otherParams = __rest(_a, ["keyword", "category", "count"]);
        if (keyword) {
            this.track(Object.assign({ data: [TRACK_TYPES.TRACK_SEARCH, keyword, category, count] }, otherParams));
        }
        else {
            throw new Error(`Error: keyword is required.`);
        }
    }
    // Tracks outgoing links to other sites and downloads
    // https://developer.matomo.org/guides/tracking-javascript-guide#enabling-download-outlink-tracking
    trackLink({ href, linkType = 'link' }) {
        this.pushInstruction(TRACK_TYPES.TRACK_LINK, href, linkType);
    }
    // Tracks page views
    // https://developer.matomo.org/guides/spa-tracking#tracking-a-new-page-view
    trackPageView(params) {
        this.track(Object.assign({ data: [TRACK_TYPES.TRACK_VIEW] }, params));
    }
    // Adds a product to an Ecommerce order to be tracked via trackEcommerceOrder.
    // https://matomo.org/docs/ecommerce-analytics
    // https://matomo.org/docs/ecommerce-analytics/#1-addecommerceitemproductsku-productname-productcategory-price-quantity
    addEcommerceItem({ sku, productName, productCategory, productPrice = 0.0, productQuantity = 1, }) {
        this.pushInstruction('addEcommerceItem', sku, productName, productCategory, productPrice, productQuantity);
    }
    // Tracks an Ecommerce order containing items added via addEcommerceItem.
    // https://matomo.org/docs/ecommerce-analytics/#2-trackecommerceorderorderid-revenue-subtotal-tax-shipping-discount
    trackEcommerceOrder({ orderId, orderRevenue, orderSubTotal, taxAmount, shippingAmount, discountOffered = false, }) {
        this.track({
            data: [
                TRACK_TYPES.TRACK_ECOMMERCE_ORDER,
                orderId,
                orderRevenue,
                orderSubTotal,
                taxAmount,
                shippingAmount,
                discountOffered,
            ],
        });
    }
    // Tracks updates to an Ecommerce Cart before an actual purchase.
    // This will replace currently tracked information of the cart. Always include all items of the updated cart!
    // https://matomo.org/docs/ecommerce-analytics/#example-tracking-an-ecommerce-cart-update-containing-two-products
    trackEcommerceCartUpdate(amount) {
        this.pushInstruction(TRACK_TYPES.TRACK_ECOMMERCE_CART_UPDATE, amount);
    }
    // Marks the next page view as an Ecommerce product page.
    // https://matomo.org/docs/ecommerce-analytics/#example-tracking-a-product-page-view
    setEcommerceView({ sku, productName, productCategory, productPrice, }) {
        this.pushInstruction('setEcommerceView', sku, productName, productCategory, productPrice);
    }
    // Marks the next tracked page view as an Ecommerce category page.
    // https://matomo.org/docs/ecommerce-analytics/#example-tracking-a-category-page-view
    setEcommerceCategoryView(productCategory) {
        this.setEcommerceView({ productCategory, productName: false, sku: false });
    }
    // Sends the tracked page/view/search to Matomo
    track({ data = [], documentTitle = window.document.title, href, customDimensions = false, }) {
        if (data.length) {
            if (customDimensions &&
                Array.isArray(customDimensions) &&
                customDimensions.length) {
                customDimensions.map((customDimension) => this.pushInstruction('setCustomDimension', customDimension.id, customDimension.value));
            }
            this.pushInstruction('setCustomUrl', href !== null && href !== void 0 ? href : window.location.href);
            this.pushInstruction('setDocumentTitle', documentTitle);
            this.pushInstruction(...data);
        }
    }
    /**
     * Pushes an instruction to Matomo for execution, this is equivalent to pushing entries into the `_paq` array.
     *
     * For example:
     *
     * ```ts
     * pushInstruction('setDocumentTitle', document.title)
     * ```
     * Is the equivalent of:
     *
     * ```ts
     * _paq.push(['setDocumentTitle', document.title]);
     * ```
     *
     * @param name The name of the instruction to be executed.
     * @param args The arguments to pass along with the instruction.
     */
    pushInstruction(name, ...args) {
        if (typeof window !== 'undefined') {
            // eslint-disable-next-line
            window._paq.push([name, ...args]);
        }
        return this;
    }
}
/* harmony default export */ var es_MatomoTracker = (MatomoTracker);
//# sourceMappingURL=MatomoTracker.js.map
;// CONCATENATED MODULE: ./node_modules/@datapunt/matomo-tracker-js/es/index.js


/* harmony default export */ var es = (es_MatomoTracker);

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/instance.js

function createInstance(params) {
    return new es(params);
}
/* harmony default export */ var instance = (createInstance);
//# sourceMappingURL=instance.js.map

/***/ }),

/***/ 95477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1591);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93871);








var SIZE = 44;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered

    },

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },

    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    '@keyframes circular-rotate': {
      '0%': {
        // Fix IE 11 wobbly
        transformOrigin: '50% 50%'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className, color !== 'inherit' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(color))], {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      width: size,
      height: size
    }, rootStyle, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.circle, disableShrink && classes.circleDisableShrink, {
      'determinate': classes.circleDeterminate,
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress));

/***/ }),

/***/ 52795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _utils_ownerDocument__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30626);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17294);
/* harmony import */ var _utils_useEventCallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55192);








function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}

function clickedRootScrollbar(event) {
  return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */


function ClickAwayListener(props) {
  var children = props.children,
      _props$disableReactTr = props.disableReactTree,
      disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
      _props$mouseEvent = props.mouseEvent,
      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
      onClickAway = props.onClickAway,
      _props$touchEvent = props.touchEvent,
      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
  var movedRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  var nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var activatedRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  var syntheticEventRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(false);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(function () {
      activatedRef.current = true;
    }, 0);
    return function () {
      activatedRef.current = false;
    };
  }, []); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (instance) {
    // #StrictMode ready
    nodeRef.current = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(instance);
  }, []);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviours like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  var handleClickAway = (0,_utils_useEventCallback__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function (event) {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    var insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!activatedRef.current || !nodeRef.current || clickedRootScrollbar(event)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
      var doc = (0,_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(nodeRef.current);
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }

    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  var createHandleSynthetic = function createHandleSynthetic(handlerName) {
    return function (event) {
      syntheticEventRef.current = true;
      var childrenPropsHandler = children.props[handlerName];

      if (childrenPropsHandler) {
        childrenPropsHandler(event);
      }
    };
  };

  var childrenProps = {
    ref: handleRef
  };

  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (touchEvent !== false) {
      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
      var doc = (0,_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(nodeRef.current);

      var handleTouchMove = function handleTouchMove() {
        movedRef.current = true;
      };

      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return function () {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, touchEvent]);

  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (mouseEvent !== false) {
      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      var doc = (0,_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return function () {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, childrenProps));
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (ClickAwayListener);

/***/ }),

/***/ 66037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97685);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98885);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1591);
/* harmony import */ var _styles_transitions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43366);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5653);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8920);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17294);












var styles = function styles(theme) {
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto',
      overflow: 'visible'
    },

    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
    hidden: {
      visibility: 'hidden'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Collapse = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Collapse(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$collapsedHeigh = props.collapsedHeight,
      collapsedHeightProp = _props$collapsedHeigh === void 0 ? '0px' : _props$collapsedHeigh,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? _styles_transitions__WEBPACK_IMPORTED_MODULE_1__/* .duration.standard */ .x9.standard : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? react_transition_group__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP : _props$TransitionComp,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, ["children", "classes", "className", "collapsedHeight", "component", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  var timer = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  var wrapperRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var autoTransitionDuration = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  var collapsedHeight = typeof collapsedHeightProp === 'number' ? "".concat(collapsedHeightProp, "px") : collapsedHeightProp;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var handleRef = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ref, enableStrictModeCompat ? nodeRef : undefined);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = collapsedHeight;

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = "".concat(wrapperHeight, "px");

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  var handleExit = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    node.style.height = "".concat(wrapperHeight, "px");

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  var handleExiting = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps2 = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = collapsedHeight;

    if (onExiting) {
      onExiting(node);
    }
  });

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
      className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(classes.container, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedHeight === '0px' && classes.hidden
      }[state]),
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        minHeight: collapsedHeight
      }, style),
      ref: handleRef
    }, childProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: classes.wrapper,
      ref: wrapperRef
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: classes.wrapperInner
    }, children)));
  });
});
 false ? 0 : void 0;
Collapse.muiSupportAuto = true;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(styles, {
  name: 'MuiCollapse'
})(Collapse));

/***/ }),

/***/ 79895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1591);







var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(styles, {
  name: 'MuiPaper'
})(Paper));

/***/ }),

/***/ 82285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setTranslateValue */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79437);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98885);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17294);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8920);
/* harmony import */ var _styles_transitions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43366);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5653);











 // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `none`.`

function getTranslateValue(direction, node) {
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = window.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}

function setTranslateValue(direction, node) {
  var transform = getTranslateValue(direction, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
var defaultTimeout = {
  enter: _styles_transitions__WEBPACK_IMPORTED_MODULE_2__/* .duration.enteringScreen */ .x9.enteringScreen,
  exit: _styles_transitions__WEBPACK_IMPORTED_MODULE_2__/* .duration.leavingScreen */ .x9.leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Slide = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Slide(props, ref) {
  var children = props.children,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'down' : _props$direction,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? react_transition_group__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP : _props$TransitionComp,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, ["children", "direction", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
  var childrenRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  /**
   * used in cloneElement(children, { ref: handleRef })
   */

  var handleOwnRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (instance) {
    // #StrictMode ready
    childrenRef.current = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(instance);
  }, []);
  var handleRefIntermediary = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(children.ref, handleOwnRef);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(handleRefIntermediary, ref);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (isAppearing) {
      if (callback) {
        // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
        if (isAppearing === undefined) {
          callback(childrenRef.current);
        } else {
          callback(childrenRef.current, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    setTranslateValue(direction, node);
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .reflow */ .n)(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      timeout: timeout,
      style: style
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.transition = theme.transitions.create('transform', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .C)({
      timeout: timeout,
      style: style
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    node.style.transition = theme.transitions.create('transform', (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    setTranslateValue(direction, node);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(function (node) {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  });
  var updatePosition = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current);
    }
  }, [direction]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }

    var handleResize = (0,_utils_debounce__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function () {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current);
      }
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    appear: true,
    in: inProp,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
      ref: handleRef,
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, style, children.props.style)
    }, childProps));
  });
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Slide);

/***/ }),

/***/ 62087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1591);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93871);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className, color !== 'inherit' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(color))], fontSize !== 'default' && classes["fontSize".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, titleAccess) : null);
});
 false ? 0 : void 0;
SvgIcon.muiName = 'SvgIcon';
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon));

/***/ }),

/***/ 22318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1591);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93871);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(align))], display !== 'initial' && classes["display".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(display))]),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiTypography'
})(Typography));

/***/ }),

/***/ 85160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mi": function() { return /* binding */ getContrastRatio; },
/* harmony export */   "_4": function() { return /* binding */ emphasize; },
/* harmony export */   "U1": function() { return /* binding */ fade; },
/* harmony export */   "_j": function() { return /* binding */ darken; },
/* harmony export */   "$n": function() { return /* binding */ lighten; }
/* harmony export */ });
/* unused harmony exports hexToRgb, rgbToHex, hslToRgb, decomposeColor, recomposeColor, getLuminance */
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60288);


/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (false) {}

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}

function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  return "#".concat(values.map(function (n) {
    return intToHex(n);
  }).join(''));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),

/***/ 1795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styles_createMuiTheme; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35953);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createBreakpoints.js


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0,objectWithoutProperties/* default */.Z)(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0,esm_extends/* default */.Z)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createMixins.js


function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0,esm_extends/* default */.Z)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return (0,esm_extends/* default */.Z)({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, (0,defineProperty/* default */.Z)({}, breakpoints.up('sm'), (0,esm_extends/* default */.Z)({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0,defineProperty/* default */.Z)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0,defineProperty/* default */.Z)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(60288);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/common.js
var common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ var colors_common = (common);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/grey.js
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
/* harmony default export */ var colors_grey = (grey);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/indigo.js
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
/* harmony default export */ var colors_indigo = (indigo);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/pink.js
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
/* harmony default export */ var colors_pink = (pink);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/red.js
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ var colors_red = (red);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/orange.js
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ var colors_orange = (orange);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/blue.js
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ var colors_blue = (blue);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/colors/green.js
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ var colors_green = (green);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(85160);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createPalette.js













var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: colors_common.white,
    default: colors_grey[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: colors_common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: colors_grey[800],
    default: '#303030'
  },
  action: {
    active: colors_common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0,colorManipulator/* lighten */.$n)(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = (0,colorManipulator/* darken */._j)(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: colors_indigo[300],
    main: colors_indigo[500],
    dark: colors_indigo[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: colors_pink.A200,
    main: colors_pink.A400,
    dark: colors_pink.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: colors_red[300],
    main: colors_red[500],
    dark: colors_red[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: colors_orange[300],
    main: colors_orange[500],
    dark: colors_orange[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: colors_blue[300],
    main: colors_blue[500],
    dark: colors_blue[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: colors_green[300],
    main: colors_green[500],
    dark: colors_green[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0,objectWithoutProperties/* default */.Z)(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = (0,colorManipulator/* getContrastRatio */.mi)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) { var contrast; }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = (0,esm_extends/* default */.Z)({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (false) {}

  var paletteOutput = (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    // A collection of common colors.
    common: colors_common,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: colors_grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createTypography.js




function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = (0,objectWithoutProperties/* default */.Z)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (false) {}

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return (0,esm_extends/* default */.Z)({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/shadows.js
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ var styles_shadows = (shadows);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/shape.js
var shape = {
  borderRadius: 4
};
/* harmony default export */ var styles_shape = (shape);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/spacing.js + 1 modules
var esm_spacing = __webpack_require__(27122);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createSpacing.js

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = (0,esm_spacing/* createUnarySpacing */.h)({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (false) {}

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (false) {}

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/transitions.js
var transitions = __webpack_require__(43366);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/zIndex.js
var zIndex = __webpack_require__(92781);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createMuiTheme.js













function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0,objectWithoutProperties/* default */.Z)(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = (0,deepmerge/* default */.Z)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: styles_shadows,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: styles_shape,
    transitions: transitions/* default */.ZP,
    zIndex: zIndex/* default */.Z
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return (0,deepmerge/* default */.Z)(acc, argument);
  }, muiTheme);

  if (false) { var traverse, pseudoClasses; }

  return muiTheme;
}

/* harmony default export */ var styles_createMuiTheme = (createMuiTheme);

/***/ }),

/***/ 75154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createStyles_createStyles; }
});

;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/createStyles/createStyles.js
function createStyles(styles) {
  return styles;
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js
 // let warnOnce = false;
// To remove in v5

function createStyles_createStyles(styles) {
  // warning(
  //   warnOnce,
  //   [
  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
  //     'Please use @material-ui/styles/createStyles',
  //   ].join('\n'),
  // );
  // warnOnce = true;
  return createStyles(styles);
}

/***/ }),

/***/ 99700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createMuiTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1795);

var defaultTheme = (0,_createMuiTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
/* harmony default export */ __webpack_exports__["Z"] = (defaultTheme);

/***/ }),

/***/ 41120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19214);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99700);




function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(stylesOrCreator, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    defaultTheme: _defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
  }, options));
}

/* harmony default export */ __webpack_exports__["Z"] = (makeStyles);

/***/ }),

/***/ 43366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x9": function() { return /* binding */ duration; }
/* harmony export */ });
/* unused harmony export easing */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45987);

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


/* harmony default export */ __webpack_exports__["ZP"] = ({
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(options, ["duration", "easing", "delay"]);

    if (false) { var isNumber, isString; }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
});

/***/ }),

/***/ 8920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(159);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99700);



function useTheme() {
  var theme = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() || _defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;

  if (false) {}

  return theme;
}

/***/ }),

/***/ 1591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styles_withStyles; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/makeStyles.js + 18 modules
var makeStyles = __webpack_require__(19214);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/getThemeProps/getThemeProps.js
var getThemeProps = __webpack_require__(93869);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(159);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/withStyles/withStyles.js








 // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = (0,objectWithoutProperties/* default */.Z)(options, ["defaultTheme", "withTheme", "name"]);

    if (false) {}

    var classNamePrefix = name;

    if (false) { var displayName; }

    var useStyles = (0,makeStyles/* default */.Z)(stylesOrCreator, (0,esm_extends/* default */.Z)({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/react.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles((0,esm_extends/* default */.Z)({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = (0,useTheme/* default */.Z)() || defaultTheme;

        if (name) {
          more = (0,getThemeProps/* default */.Z)({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
     false ? 0 : void 0;

    if (false) {}

    hoist_non_react_statics_cjs_default()(WithStyles, Component);

    if (false) {}

    return WithStyles;
  };
};

/* harmony default export */ var withStyles_withStyles = (withStyles);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/defaultTheme.js
var defaultTheme = __webpack_require__(99700);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js




function styles_withStyles_withStyles(stylesOrCreator, options) {
  return withStyles_withStyles(stylesOrCreator, (0,esm_extends/* default */.Z)({
    defaultTheme: defaultTheme/* default */.Z
  }, options));
}

/* harmony default export */ var styles_withStyles = (styles_withStyles_withStyles);

/***/ }),

/***/ 92781:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ __webpack_exports__["Z"] = (zIndex);

/***/ }),

/***/ 5653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ reflow; },
/* harmony export */   "C": function() { return /* binding */ getTransitionProps; }
/* harmony export */ });
var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

/***/ }),

/***/ 93871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ capitalize; }
/* harmony export */ });
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60288);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? 0 : (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),

/***/ 82568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createChainedFunction; }
/* harmony export */ });
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (false) {}

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),

/***/ 63786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createSvgIcon; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _SvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62087);



/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      ref: ref
    }, props), path);
  };

  if (false) {}

  Component.muiName = _SvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"].muiName */ .Z.muiName;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(Component));
}

/***/ }),

/***/ 79437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ debounce; }
/* harmony export */ });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

/***/ }),

/***/ 44343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "capitalize": function() { return /* reexport */ capitalize/* default */.Z; },
  "createChainedFunction": function() { return /* reexport */ createChainedFunction/* default */.Z; },
  "createSvgIcon": function() { return /* reexport */ createSvgIcon/* default */.Z; },
  "debounce": function() { return /* reexport */ debounce/* default */.Z; },
  "deprecatedPropType": function() { return /* reexport */ deprecatedPropType; },
  "isMuiElement": function() { return /* reexport */ isMuiElement/* default */.Z; },
  "ownerDocument": function() { return /* reexport */ ownerDocument/* default */.Z; },
  "ownerWindow": function() { return /* reexport */ ownerWindow/* default */.Z; },
  "requirePropFactory": function() { return /* reexport */ requirePropFactory; },
  "setRef": function() { return /* reexport */ setRef/* default */.Z; },
  "unstable_useId": function() { return /* reexport */ unstable_useId/* default */.Z; },
  "unsupportedProp": function() { return /* reexport */ unsupportedProp; },
  "useControlled": function() { return /* reexport */ useControlled/* default */.Z; },
  "useEventCallback": function() { return /* reexport */ useEventCallback/* default */.Z; },
  "useForkRef": function() { return /* reexport */ useForkRef/* default */.Z; },
  "useIsFocusVisible": function() { return /* reexport */ useIsFocusVisible/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(82568);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/debounce.js
var debounce = __webpack_require__(79437);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/deprecatedPropType.js
function deprecatedPropType(validator, reason) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(83711);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(30626);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(80713);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/requirePropFactory.js
function requirePropFactory(componentNameInError) {
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/setRef.js
var setRef = __webpack_require__(34236);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/unsupportedProp.js
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(22775);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(55192);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(17294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unstable_useId.js
var unstable_useId = __webpack_require__(95001);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(24896);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/utils/index.js













 // eslint-disable-next-line camelcase




/***/ }),

/***/ 83711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isMuiElement; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

/***/ }),

/***/ 30626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerDocument; }
/* harmony export */ });
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),

/***/ 80713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerWindow; }
/* harmony export */ });
/* harmony import */ var _ownerDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30626);

function ownerWindow(node) {
  var doc = (0,_ownerDocument__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node);
  return doc.defaultView || window;
}

/***/ }),

/***/ 34236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ setRef; }
/* harmony export */ });
// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),

/***/ 95001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

/***/ }),

/***/ 22775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useControlled; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (false) { var _React$useRef2, defaultValue; }

  var setValueIfUncontrolled = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/***/ }),

/***/ 55192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    return (0, ref.current).apply(void 0, arguments);
  }, []);
}

/***/ }),

/***/ 17294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForkRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _setRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34236);


function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(refA, refValue);
      (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(refB, refValue);
    };
  }, [refA, refB]);
}

/***/ }),

/***/ 24896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIsFocusVisible; }
/* harmony export */ });
/* unused harmony export teardown */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js


var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (instance) {
    var node = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (false) {}

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

/***/ }),

/***/ 47298:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

exports.Z = _default;

/***/ }),

/***/ 81395:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');

exports.Z = _default;

/***/ }),

/***/ 21727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');

exports.Z = _default;

/***/ }),

/***/ 2108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
}));

var _utils = __webpack_require__(44343);

/***/ }),

/***/ 17076:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ __webpack_exports__["Z"] = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');

/***/ }),

/***/ 93869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getThemeProps; }
/* harmony export */ });
/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

/***/ }),

/***/ 19214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ makeStyles; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/is-in-browser/dist/module.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ var dist_module = (isBrowser);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
;// CONCATENATED MODULE: ./node_modules/jss/dist/jss.esm.js








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? 0 : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
var toCssValue = function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += '\n';
            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += '\n';
          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += '\n';
      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "\n" + result + "\n";
  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var jss_esm_escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.key = void 0;
    this.isProcessed = false;
    this.style = void 0;
    this.renderer = void 0;
    this.renderable = void 0;
    this.options = void 0;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? 0 : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  (0,inheritsLoose/* default */.Z)(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    _this.selectorText = void 0;
    _this.id = void 0;
    _this.renderable = void 0;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), sheet);
      _this.selectorText = "." + jss_esm_escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? (0,esm_extends/* default */.Z)({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  (0,createClass/* default */.Z)(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(name, style, options) {
    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(name, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.at = void 0;
    this.key = void 0;
    this.query = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList((0,esm_extends/* default */.Z)({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {\n" + children + "\n}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.key = void 0;
    this.name = void 0;
    this.id = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? 0 : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : jss_esm_escape(generateId(this, sheet));
    this.rules = new RuleList((0,esm_extends/* default */.Z)({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], (0,esm_extends/* default */.Z)({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "\n" + children + "\n";
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? 0 : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var jss_esm_plugin = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  (0,inheritsLoose/* default */.Z)(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
    _this.renderable = void 0;
    return _this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? (0,esm_extends/* default */.Z)({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += '\n';
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.key = void 0;
    this.value = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, jss_esm_plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = (0,esm_extends/* default */.Z)({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + jss_esm_escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Get a rule.
   */
  ;

  _proto.get = function get(name) {
    return this.map[name];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.map[name], data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var styleRule = rule;
    var style = styleRule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== styleRule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.

      for (var prop in styleRule.style) {
        var nextValue = styleRule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          styleRule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = styleRule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          styleRule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += '\n';
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.options = void 0;
    this.deployed = void 0;
    this.attached = void 0;
    this.rules = void 0;
    this.renderer = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.queue = void 0;
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = (0,esm_extends/* default */.Z)({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name.
   */
  ;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = void 0;
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      // $FlowFixMe[prop-missing]
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? 0 : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["attached"]);

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += '\n';
      css += sheet.toString(options);
    }

    return css;
  };

  (0,createClass/* default */.Z)(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var registry = new SheetsRegistry();

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis[ns] == null) globalThis[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis[ns]++;

var maxRules = 1e10;

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */
var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;
  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? 0 : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };
};

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};

/**
 * Set a style property.
 */
var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};

/**
 * Remove a style property.
 */
var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? 0 : void 0;
  }
};

/**
 * Set the selector.
 */
var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry$1 = registry.registry;

  if (registry$1.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? 0 : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? 0 : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      var c = container;
      c.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        var _c = container;

        _c.appendRule(rule);
      }
  } catch (err) {
     false ? 0 : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.element = void 0;
    this.sheet = void 0;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) registry.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules[index] = cssRule;
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   *
   * Only used for some old browsers because they can't set a selector.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.5.1";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: dist_module ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = (0,esm_extends/* default */.Z)({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = registry.index === 0 ? 0 : registry.index + 1;
    }

    var sheet = new StyleSheet(styles, (0,esm_extends/* default */.Z)({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    registry.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      // $FlowFixMe[incompatible-call]
      return this.createRule(undefined, name, style);
    } // $FlowFixMe[incompatible-type]


    var ruleOptions = (0,esm_extends/* default */.Z)({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager =
/*#__PURE__*/
(/* unused pure expression or super */ null && (function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    warning(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      warning(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  _createClass(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}()));

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */

/**
 * Export a constant indicating if this browser has CSSTOM support.
 * https://developers.google.com/web/updates/2018/03/cssom
 */
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Creates a new instance of Jss.
 */

var jss_esm_create = function create(options) {
  return new Jss(options);
};
/**
 * A global Jss instance.
 */

var jss = jss_esm_create();

/* harmony default export */ var jss_esm = ((/* unused pure expression or super */ null && (jss)));


// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/mergeClasses/mergeClasses.js
var mergeClasses = __webpack_require__(65835);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/multiKeyStore.js
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
/* harmony default export */ var makeStyles_multiKeyStore = (multiKeyStore);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(159);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/ThemeProvider/nested.js
var nested = __webpack_require__(17076);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/createGenerateClassName/createGenerateClassName.js

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (false) {}

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested/* default */.Z] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (true) {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}
;// CONCATENATED MODULE: ./node_modules/jss-plugin-rule-value-function/dist/jss-plugin-rule-value-function.esm.js



var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      } // $FlowFixMe[prop-missing]


      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule; // $FlowFixMe[prop-missing]

      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (false) { var prop; }
      } // $FlowFixMe[prop-missing]


      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

/* harmony default export */ var jss_plugin_rule_value_function_esm = (functionPlugin);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-global/dist/jss-plugin-global.esm.js



var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.rules = void 0;
    this.options = void 0;
    this.key = void 0;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList((0,esm_extends/* default */.Z)({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString() {
    return this.rules.toString();
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.options = void 0;
    this.rule = void 0;
    this.isProcessed = false;
    this.key = void 0;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, (0,esm_extends/* default */.Z)({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], (0,esm_extends/* default */.Z)({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], (0,esm_extends/* default */.Z)({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ var jss_plugin_global_esm = (jssGlobal);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-nested/dist/jss-plugin-nested.esm.js



var jss_plugin_nested_esm_separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var jss_plugin_nested_esm_refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        rule = rule;
        return rule.selector;
      }

       false ? 0 : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(jss_plugin_nested_esm_separatorRegExp);
    var nestedSelectors = nestedProp.split(jss_plugin_nested_esm_separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return (0,esm_extends/* default */.Z)({}, prevOptions, {
      index: prevOptions.index + 1 // $FlowFixMe[prop-missing]

    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = (0,esm_extends/* default */.Z)({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(jss_plugin_nested_esm_refRegExp, replaceRef);
        container.addRule(selector, style[prop], (0,esm_extends/* default */.Z)({}, options, {
          selector: selector
        }));
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
        // And flow doesn't know this will always be a StyleRule which has the addRule method
        // $FlowFixMe[incompatible-use]
        // $FlowFixMe[prop-missing]
        .addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ var jss_plugin_nested_esm = (jssNested);

;// CONCATENATED MODULE: ./node_modules/hyphenate-style-name/index.js
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ var hyphenate_style_name = (hyphenateStyleName);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-camel-case/dist/jss-plugin-camel-case.esm.js


/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenate_style_name(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenate_style_name(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_camel_case_esm = (camelCase);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-default-unit/dist/jss-plugin-default-unit.esm.js


var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 *
 * @type object
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var _key in obj) {
    newObj[_key] = obj[_key];
    newObj[_key.replace(regExp, replace)] = obj[_key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    }
  } else if (typeof value === 'number' && !Number.isNaN(value)) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_default_unit_esm = (defaultUnit);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(74902);
;// CONCATENATED MODULE: ./node_modules/css-vendor/dist/css-vendor.esm.js



// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = dist_module && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (dist_module) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var css_vendor_esm_plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = css_vendor_esm_plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = css_vendor_esm_plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, (0,toConsumableArray/* default */.Z)(p.noPrefill));
  return a;
}, []);

var el;
var css_vendor_esm_cache = {};

if (dist_module) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) css_vendor_esm_cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete css_vendor_esm_cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ( true && css_vendor_esm_cache[prop] != null) {
    return css_vendor_esm_cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    css_vendor_esm_cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (css_vendor_esm_cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return css_vendor_esm_cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (dist_module) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ( true && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}



;// CONCATENATED MODULE: ./node_modules/jss-plugin-vendor-prefixer/dist/jss-plugin-vendor-prefixer.esm.js



/**
 * Add vendor prefix to a property name when needed.
 *
 * @api public
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ var jss_plugin_vendor_prefixer_esm = (jssVendorPrefixer);

;// CONCATENATED MODULE: ./node_modules/jss-plugin-props-sort/dist/jss-plugin-props-sort.esm.js
/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

/* harmony default export */ var jss_plugin_props_sort_esm = (jssPropsSort);

;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/jssPreset/jssPreset.js






 // Subset of jss-preset-default with only the plugins the Material-UI components are using.

function jssPreset_jssPreset() {
  return {
    plugins: [jss_plugin_rule_value_function_esm(), jss_plugin_global_esm(), jss_plugin_nested_esm(), jss_plugin_camel_case_esm(), jss_plugin_default_unit_esm(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jss_plugin_vendor_prefixer_esm(), jss_plugin_props_sort_esm()]
  };
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/StylesProvider/StylesProvider.js







 // Default JSS instance.

var StylesProvider_jss = jss_esm_create(jssPreset_jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: StylesProvider_jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = react.createContext(defaultOptions);

if (false) {}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = _objectWithoutProperties(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = React.useContext(StylesContext);

  var context = _extends({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (false) {}

  if (false) {}

  if (false) {}

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = create({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/React.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
 false ? 0 : void 0;

if (false) {}
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/indexCounter.js
/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (false) {}

  return indexCounter;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35953);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getStylesCreator/getStylesCreator.js




function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (false) {}

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) {}

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = (0,esm_extends/* default */.Z)({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (false) {}

        stylesWithOverrides[key] = (0,deepmerge/* default */.Z)(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/getStylesCreator/noopTheme.js
// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
/* harmony default export */ var getStylesCreator_noopTheme = (noopTheme);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/makeStyles.js












function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = (0,mergeClasses/* default */.Z)({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    makeStyles_multiKeyStore.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = (0,esm_extends/* default */.Z)({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = makeStyles_multiKeyStore.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0,esm_extends/* default */.Z)({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        makeStyles_multiKeyStore.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0,esm_extends/* default */.Z)({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = (0,mergeClasses/* default */.Z)({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    makeStyles_multiKeyStore["delete"](stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = react.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = react.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  react.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? getStylesCreator_noopTheme : _options$defaultTheme,
      stylesOptions2 = (0,objectWithoutProperties/* default */.Z)(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = (0,useTheme/* default */.Z)() || defaultTheme;

    var stylesOptions = (0,esm_extends/* default */.Z)({}, react.useContext(StylesContext), stylesOptions2);

    var instance = react.useRef();
    var shouldUpdate = react.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    react.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (false) {}

    return classes;
  };

  return useStyles;
}

/***/ }),

/***/ 65835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ mergeClasses; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);


function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, baseClasses);

  if (false) {}

  Object.keys(newClasses).forEach(function (key) {
    if (false) {}

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

/***/ }),

/***/ 83800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);

if (false) {}

/* harmony default export */ __webpack_exports__["Z"] = (ThemeContext);

/***/ }),

/***/ 159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ThemeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83800);


function useTheme() {
  var theme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_ThemeContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);

  if (false) {}

  return theme;
}

/***/ }),

/***/ 71410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ handleBreakpoints; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);




 // The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (false) {}

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function breakpoints(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var base = styleFunction(props);
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(_extends({
          theme: props.theme
        }, props[key]));
      }

      return acc;
    }, null);
    return merge(base, extended);
  };

  newStyleFunction.propTypes =  false ? 0 : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat(_toConsumableArray(styleFunction.filterProps));
  return newStyleFunction;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (breakpoints)));

/***/ }),

/***/ 19668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35953);


function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

/* harmony default export */ __webpack_exports__["Z"] = (merge);

/***/ }),

/***/ 27122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ createUnarySpacing; },
  "Z": function() { return /* binding */ esm_spacing; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(71410);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/merge.js
var merge = __webpack_require__(19668);
;// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/memoize.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/spacing.js





var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = memoize(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = (0,slicedToArray/* default */.Z)(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (false) {}

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (false) {}

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (false) {}

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return (0,breakpoints/* handleBreakpoints */.k)(props, propValue, styleFromPropValue);
  }).reduce(merge/* default */.Z, {});
}

spacing.propTypes =  false ? 0 : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ var esm_spacing = (spacing);

/***/ }),

/***/ 35953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ deepmerge; }
/* harmony export */ });
/* unused harmony export isPlainObject */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);


function isPlainObject(item) {
  return item && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/***/ }),

/***/ 60288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatMuiErrorMessage; }
/* harmony export */ });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://material-ui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),

/***/ 19477:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

'use client';
Object.defineProperty(exports, "__esModule", ({ value: true }));
const jsx_runtime_1 = __webpack_require__(85893);
const react_1 = __webpack_require__(67294);
function ThirdPartyScriptEmbed({ html, height = null, width = null, children, dataNtpc = '', }) {
    (0, react_1.useEffect)(() => {
        if (dataNtpc) {
            // performance.mark is being used as a feature use signal. While it is traditionally used for performance
            // benchmarking it is low overhead and thus considered safe to use in production and it is a widely available
            // existing API.
            performance.mark('mark_feature_usage', {
                detail: {
                    feature: `next-third-parties-${dataNtpc}`,
                },
            });
        }
    }, [dataNtpc]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [children, html ? ((0, jsx_runtime_1.jsx)("div", { style: {
                    height: height != null ? `${height}px` : 'auto',
                    width: width != null ? `${width}px` : 'auto',
                }, "data-ntpc": dataNtpc, dangerouslySetInnerHTML: { __html: html } })) : null] }));
}
exports["default"] = ThirdPartyScriptEmbed;


/***/ }),

/***/ 7834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sendGAEvent = exports.GoogleAnalytics = void 0;
const jsx_runtime_1 = __webpack_require__(85893);
// TODO: Evaluate import 'client only'
const react_1 = __webpack_require__(67294);
const script_1 = __importDefault(__webpack_require__(4298));
let currDataLayerName = undefined;
function GoogleAnalytics(props) {
    const { gaId, dataLayerName = 'dataLayer' } = props;
    if (currDataLayerName === undefined) {
        currDataLayerName = dataLayerName;
    }
    (0, react_1.useEffect)(() => {
        // performance.mark is being used as a feature use signal. While it is traditionally used for performance
        // benchmarking it is low overhead and thus considered safe to use in production and it is a widely available
        // existing API.
        // The performance measurement will be handled by Chrome Aurora
        performance.mark('mark_feature_usage', {
            detail: {
                feature: 'next-third-parties-ga',
            },
        });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-ga-init", dangerouslySetInnerHTML: {
                    __html: `
          window['${dataLayerName}'] = window['${dataLayerName}'] || [];
          function gtag(){window['${dataLayerName}'].push(arguments);}
          gtag('js', new Date());

          gtag('config', '${gaId}');`,
                } }), (0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-ga", src: `https://www.googletagmanager.com/gtag/js?id=${gaId}` })] }));
}
exports.GoogleAnalytics = GoogleAnalytics;
function sendGAEvent(..._args) {
    if (currDataLayerName === undefined) {
        console.warn(`@next/third-parties: GA has not been initialized`);
        return;
    }
    if (window[currDataLayerName]) {
        window[currDataLayerName].push(arguments);
    }
    else {
        console.warn(`@next/third-parties: GA dataLayer ${currDataLayerName} does not exist`);
    }
}
exports.sendGAEvent = sendGAEvent;


/***/ }),

/***/ 83632:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const jsx_runtime_1 = __webpack_require__(85893);
const third_party_capital_1 = __webpack_require__(86257);
const ThirdPartyScriptEmbed_1 = __importDefault(__webpack_require__(19477));
function GoogleMapsEmbed(props) {
    const { apiKey, ...restProps } = props;
    const formattedProps = { ...restProps, key: apiKey };
    const { html } = (0, third_party_capital_1.GoogleMapsEmbed)(formattedProps);
    return ((0, jsx_runtime_1.jsx)(ThirdPartyScriptEmbed_1.default, { height: formattedProps.height || null, width: formattedProps.width || null, html: html, dataNtpc: "GoogleMapsEmbed" }));
}
exports["default"] = GoogleMapsEmbed;


/***/ }),

/***/ 30674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sendGTMEvent = exports.GoogleTagManager = void 0;
const jsx_runtime_1 = __webpack_require__(85893);
// TODO: Evaluate import 'client only'
const react_1 = __webpack_require__(67294);
const script_1 = __importDefault(__webpack_require__(4298));
let currDataLayerName = undefined;
function GoogleTagManager(props) {
    const { gtmId, dataLayerName = 'dataLayer', auth, preview, dataLayer } = props;
    if (currDataLayerName === undefined) {
        currDataLayerName = dataLayerName;
    }
    const gtmLayer = dataLayerName !== 'dataLayer' ? `&l=${dataLayerName}` : '';
    const gtmAuth = auth ? `&gtm_auth=${auth}` : '';
    const gtmPreview = preview ? `&gtm_preview=${preview}&gtm_cookies_win=x` : '';
    (0, react_1.useEffect)(() => {
        // performance.mark is being used as a feature use signal. While it is traditionally used for performance
        // benchmarking it is low overhead and thus considered safe to use in production and it is a widely available
        // existing API.
        // The performance measurement will be handled by Chrome Aurora
        performance.mark('mark_feature_usage', {
            detail: {
                feature: 'next-third-parties-gtm',
            },
        });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-gtm-init", dangerouslySetInnerHTML: {
                    __html: `
      (function(w,l){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        ${dataLayer ? `w[l].push(${JSON.stringify(dataLayer)})` : ''}
      })(window,'${dataLayerName}');`,
                } }), (0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-gtm", "data-ntpc": "GTM", src: `https://www.googletagmanager.com/gtm.js?id=${gtmId}${gtmLayer}${gtmAuth}${gtmPreview}` })] }));
}
exports.GoogleTagManager = GoogleTagManager;
const sendGTMEvent = (data) => {
    if (currDataLayerName === undefined) {
        console.warn(`@next/third-parties: GTM has not been initialized`);
        return;
    }
    if (window[currDataLayerName]) {
        window[currDataLayerName].push(data);
    }
    else {
        console.warn(`@next/third-parties: GTM dataLayer ${currDataLayerName} does not exist`);
    }
};
exports.sendGTMEvent = sendGTMEvent;


/***/ }),

/***/ 19692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sendGAEvent = exports.GoogleAnalytics = exports.sendGTMEvent = exports.GoogleTagManager = exports.YouTubeEmbed = exports.GoogleMapsEmbed = void 0;
var google_maps_embed_1 = __webpack_require__(83632);
Object.defineProperty(exports, "GoogleMapsEmbed", ({ enumerable: true, get: function () { return __importDefault(google_maps_embed_1).default; } }));
var youtube_embed_1 = __webpack_require__(11494);
Object.defineProperty(exports, "YouTubeEmbed", ({ enumerable: true, get: function () { return __importDefault(youtube_embed_1).default; } }));
var gtm_1 = __webpack_require__(30674);
Object.defineProperty(exports, "GoogleTagManager", ({ enumerable: true, get: function () { return gtm_1.GoogleTagManager; } }));
Object.defineProperty(exports, "sendGTMEvent", ({ enumerable: true, get: function () { return gtm_1.sendGTMEvent; } }));
var ga_1 = __webpack_require__(7834);
Object.defineProperty(exports, "GoogleAnalytics", ({ enumerable: true, get: function () { return ga_1.GoogleAnalytics; } }));
Object.defineProperty(exports, "sendGAEvent", ({ enumerable: true, get: function () { return ga_1.sendGAEvent; } }));


/***/ }),

/***/ 11494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const jsx_runtime_1 = __webpack_require__(85893);
const script_1 = __importDefault(__webpack_require__(4298));
const third_party_capital_1 = __webpack_require__(86257);
const ThirdPartyScriptEmbed_1 = __importDefault(__webpack_require__(19477));
const scriptStrategy = {
    server: 'beforeInteractive',
    client: 'afterInteractive',
    idle: 'lazyOnload',
    worker: 'worker',
};
function YouTubeEmbed(props) {
    const { html, scripts, stylesheets } = (0, third_party_capital_1.YouTubeEmbed)(props);
    return ((0, jsx_runtime_1.jsx)(ThirdPartyScriptEmbed_1.default, { height: props.height || null, width: props.width || null, html: html, dataNtpc: "YouTubeEmbed", children: scripts === null || scripts === void 0 ? void 0 : scripts.map((script) => ((0, jsx_runtime_1.jsx)(script_1.default, { src: script.url, strategy: scriptStrategy[script.strategy], stylesheets: stylesheets }, script.url))) }));
}
exports["default"] = YouTubeEmbed;


/***/ }),

/***/ 75021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ch": function() { return /* binding */ PayPalButtons; },
/* harmony export */   "Vv": function() { return /* binding */ PayPalScriptProvider; }
/* harmony export */ });
/* unused harmony exports BraintreePayPalButtons, DISPATCH_ACTION, FUNDING, PAYPAL_HOSTED_FIELDS_TYPES, PayPalCVVField, PayPalCardFieldsContext, PayPalCardFieldsForm, PayPalCardFieldsProvider, PayPalExpiryField, PayPalHostedField, PayPalHostedFieldsProvider, PayPalMarks, PayPalMessages, PayPalNameField, PayPalNumberField, SCRIPT_LOADING_STATE, ScriptContext, destroySDKScript, getScriptID, scriptReducer, usePayPalCardFields, usePayPalHostedFields, usePayPalScriptReducer, useScriptProviderContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/*!
 * react-paypal-js v8.3.0 (2024-04-29T16:01:50.661Z)
 * Copyright 2020-present, PayPal, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Enum for the SDK script resolve status,
 *
 * @enum {string}
 */

var SCRIPT_LOADING_STATE;

(function (SCRIPT_LOADING_STATE) {
  SCRIPT_LOADING_STATE["INITIAL"] = "initial";
  SCRIPT_LOADING_STATE["PENDING"] = "pending";
  SCRIPT_LOADING_STATE["REJECTED"] = "rejected";
  SCRIPT_LOADING_STATE["RESOLVED"] = "resolved";
})(SCRIPT_LOADING_STATE || (SCRIPT_LOADING_STATE = {}));
/**
 * Enum for the PayPalScriptProvider context dispatch actions
 *
 * @enum {string}
 */


var DISPATCH_ACTION;

(function (DISPATCH_ACTION) {
  DISPATCH_ACTION["LOADING_STATUS"] = "setLoadingStatus";
  DISPATCH_ACTION["RESET_OPTIONS"] = "resetOptions";
  DISPATCH_ACTION["SET_BRAINTREE_INSTANCE"] = "braintreeInstance";
})(DISPATCH_ACTION || (DISPATCH_ACTION = {}));
/**
 * Enum for all the available hosted fields
 *
 * @enum {string}
 */


var PAYPAL_HOSTED_FIELDS_TYPES;

(function (PAYPAL_HOSTED_FIELDS_TYPES) {
  PAYPAL_HOSTED_FIELDS_TYPES["NUMBER"] = "number";
  PAYPAL_HOSTED_FIELDS_TYPES["CVV"] = "cvv";
  PAYPAL_HOSTED_FIELDS_TYPES["EXPIRATION_DATE"] = "expirationDate";
  PAYPAL_HOSTED_FIELDS_TYPES["EXPIRATION_MONTH"] = "expirationMonth";
  PAYPAL_HOSTED_FIELDS_TYPES["EXPIRATION_YEAR"] = "expirationYear";
  PAYPAL_HOSTED_FIELDS_TYPES["POSTAL_CODE"] = "postalCode";
})(PAYPAL_HOSTED_FIELDS_TYPES || (PAYPAL_HOSTED_FIELDS_TYPES = {}));

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
/*********************************************
 * Common reference to the script identifier *
 *********************************************/
// keep this script id value in kebab-case format


var SCRIPT_ID = "data-react-paypal-script-id";
var SDK_SETTINGS = {
  DATA_CLIENT_TOKEN: "dataClientToken",
  DATA_JS_SDK_LIBRARY: "dataJsSdkLibrary",
  DATA_LIBRARY_VALUE: "react-paypal-js",
  DATA_NAMESPACE: "dataNamespace",
  DATA_SDK_INTEGRATION_SOURCE: "dataSdkIntegrationSource",
  DATA_USER_ID_TOKEN: "dataUserIdToken"
};
var LOAD_SCRIPT_ERROR = "Failed to load the PayPal JS SDK script.";
/****************************
 * Braintree error messages *
 ****************************/

var EMPTY_BRAINTREE_AUTHORIZATION_ERROR_MESSAGE = "Invalid authorization data. Use dataClientToken or dataUserIdToken to authorize.";
var braintreeVersion = "3.84.0";
var BRAINTREE_SOURCE = "https://js.braintreegateway.com/web/".concat(braintreeVersion, "/js/client.min.js");
var BRAINTREE_PAYPAL_CHECKOUT_SOURCE = "https://js.braintreegateway.com/web/".concat(braintreeVersion, "/js/paypal-checkout.min.js");
/*********************
 * PayPal namespaces *
 *********************/

var DEFAULT_PAYPAL_NAMESPACE = "paypal";
var DEFAULT_BRAINTREE_NAMESPACE = "braintree";
/*****************
 * Hosted Fields *
 *****************/

var HOSTED_FIELDS_CHILDREN_ERROR = "To use HostedFields you must use it with at least 3 children with types: [number, cvv, expirationDate] includes";
var HOSTED_FIELDS_DUPLICATE_CHILDREN_ERROR = "Cannot use duplicate HostedFields as children";
/*******************
 * Script Provider *
 *******************/

var SCRIPT_PROVIDER_REDUCER_ERROR = "usePayPalScriptReducer must be used within a PayPalScriptProvider";
var CARD_FIELDS_DUPLICATE_CHILDREN_ERROR = "Cannot use duplicate CardFields as children";
var CARD_FIELDS_CONTEXT_ERROR = "Individual CardFields must be rendered inside the PayPalCardFieldsProvider";
/**
 * Get the namespace from the window in the browser
 * this is useful to get the paypal object from window
 * after load PayPal SDK script
 *
 * @param namespace the name space to return
 * @returns the namespace if exists or undefined otherwise
 */

function getPayPalWindowNamespace$1(namespace) {
  if (namespace === void 0) {
    namespace = DEFAULT_PAYPAL_NAMESPACE;
  } // eslint-disable-next-line @typescript-eslint/no-explicit-any


  return window[namespace];
}
/**
 * Get a namespace from the window in the browser
 * this is useful to get the braintree from window
 * after load Braintree script
 *
 * @param namespace the name space to return
 * @returns the namespace if exists or undefined otherwise
 */


function getBraintreeWindowNamespace(namespace) {
  if (namespace === void 0) {
    namespace = DEFAULT_BRAINTREE_NAMESPACE;
  } // eslint-disable-next-line @typescript-eslint/no-explicit-any


  return window[namespace];
}
/**
 * Creates a string hash code based on the string argument
 *
 * @param str the source input string to hash
 * @returns string hash code
 */


function hashStr(str) {
  var hash = "";

  for (var i = 0; i < str.length; i++) {
    var total = str[i].charCodeAt(0) * i;

    if (str[i + 1]) {
      total += str[i + 1].charCodeAt(0) * (i - 1);
    }

    hash += String.fromCharCode(97 + Math.abs(total) % 26);
  }

  return hash;
}

function generateErrorMessage(_a) {
  var reactComponentName = _a.reactComponentName,
      sdkComponentKey = _a.sdkComponentKey,
      _b = _a.sdkRequestedComponents,
      sdkRequestedComponents = _b === void 0 ? "" : _b,
      _c = _a.sdkDataNamespace,
      sdkDataNamespace = _c === void 0 ? DEFAULT_PAYPAL_NAMESPACE : _c;
  var requiredOptionCapitalized = sdkComponentKey.charAt(0).toUpperCase().concat(sdkComponentKey.substring(1));
  var errorMessage = "Unable to render <".concat(reactComponentName, " /> because window.").concat(sdkDataNamespace, ".").concat(requiredOptionCapitalized, " is undefined."); // The JS SDK only loads the buttons component by default.
  // All other components like messages and marks must be requested using the "components" query parameter

  var requestedComponents = typeof sdkRequestedComponents === "string" ? sdkRequestedComponents : sdkRequestedComponents.join(",");

  if (!requestedComponents.includes(sdkComponentKey)) {
    var expectedComponents = [requestedComponents, sdkComponentKey].filter(Boolean).join();
    errorMessage += "\nTo fix the issue, add '".concat(sdkComponentKey, "' to the list of components passed to the parent PayPalScriptProvider:") + "\n`<PayPalScriptProvider options={{ components: '".concat(expectedComponents, "'}}>`.");
  }

  return errorMessage;
}
/**
 * Generate a new random identifier for react-paypal-js
 *
 * @returns the {@code string} containing the random library name
 */


function getScriptID(options) {
  // exclude the data-react-paypal-script-id value from the options hash
  var _a = options,
      _b = SCRIPT_ID;
  _a[_b];

  var paypalScriptOptions = __rest(_a, [_b + ""]);

  return "react-paypal-js-".concat(hashStr(JSON.stringify(paypalScriptOptions)));
}
/**
 * Destroy the PayPal SDK from the document page
 *
 * @param reactPayPalScriptID the script identifier
 */


function destroySDKScript(reactPayPalScriptID) {
  var scriptNode = self.document.querySelector("script[".concat(SCRIPT_ID, "=\"").concat(reactPayPalScriptID, "\"]"));

  if (scriptNode === null || scriptNode === void 0 ? void 0 : scriptNode.parentNode) {
    scriptNode.parentNode.removeChild(scriptNode);
  }
}
/**
 * Reducer function to handle complex state changes on the context
 *
 * @param state  the current state on the context object
 * @param action the action to be executed on the previous state
 * @returns a the same state if the action wasn't found, or a new state otherwise
 */


function scriptReducer(state, action) {
  var _a, _b;

  switch (action.type) {
    case DISPATCH_ACTION.LOADING_STATUS:
      if (typeof action.value === "object") {
        return __assign(__assign({}, state), {
          loadingStatus: action.value.state,
          loadingStatusErrorMessage: action.value.message
        });
      }

      return __assign(__assign({}, state), {
        loadingStatus: action.value
      });

    case DISPATCH_ACTION.RESET_OPTIONS:
      // destroy existing script to make sure only one script loads at a time
      destroySDKScript(state.options[SCRIPT_ID]);
      return __assign(__assign({}, state), {
        loadingStatus: SCRIPT_LOADING_STATE.PENDING,
        options: __assign(__assign((_a = {}, _a[SDK_SETTINGS.DATA_SDK_INTEGRATION_SOURCE] = SDK_SETTINGS.DATA_LIBRARY_VALUE, _a), action.value), (_b = {}, _b[SCRIPT_ID] = "".concat(getScriptID(action.value)), _b))
      });

    case DISPATCH_ACTION.SET_BRAINTREE_INSTANCE:
      return __assign(__assign({}, state), {
        braintreePayPalCheckoutInstance: action.value
      });

    default:
      {
        return state;
      }
  }
} // Create the React context to use in the script provider component


var ScriptContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/**
 * Check if the context is valid and ready to dispatch actions.
 *
 * @param scriptContext the result of connecting to the context provider
 * @returns strict context avoiding null values in the type
 */

function validateReducer(scriptContext) {
  if (typeof (scriptContext === null || scriptContext === void 0 ? void 0 : scriptContext.dispatch) === "function" && scriptContext.dispatch.length !== 0) {
    return scriptContext;
  }

  throw new Error(SCRIPT_PROVIDER_REDUCER_ERROR);
}
/**
 * Check if the dataClientToken or the dataUserIdToken are
 * set in the options of the context.
 * @type dataClientToken is use to pass a client token
 * @type dataUserIdToken is use to pass a client tokenization key
 *
 * @param scriptContext the result of connecting to the context provider
 * @throws an {@link Error} if both dataClientToken and the dataUserIdToken keys are null or undefined
 * @returns strict context if one of the keys are defined
 */


var validateBraintreeAuthorizationData = function (scriptContext) {
  var _a, _b;

  if (!((_a = scriptContext === null || scriptContext === void 0 ? void 0 : scriptContext.options) === null || _a === void 0 ? void 0 : _a[SDK_SETTINGS.DATA_CLIENT_TOKEN]) && !((_b = scriptContext === null || scriptContext === void 0 ? void 0 : scriptContext.options) === null || _b === void 0 ? void 0 : _b[SDK_SETTINGS.DATA_USER_ID_TOKEN])) {
    throw new Error(EMPTY_BRAINTREE_AUTHORIZATION_ERROR_MESSAGE);
  }

  return scriptContext;
};
/**
 * Custom hook to get access to the Script context and
 * dispatch actions to modify the state on the {@link ScriptProvider} component
 *
 * @returns a tuple containing the state of the context and
 * a dispatch function to modify the state
 */


function usePayPalScriptReducer() {
  var scriptContext = validateReducer((0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ScriptContext));

  var derivedStatusContext = __assign(__assign({}, scriptContext), {
    isInitial: scriptContext.loadingStatus === SCRIPT_LOADING_STATE.INITIAL,
    isPending: scriptContext.loadingStatus === SCRIPT_LOADING_STATE.PENDING,
    isResolved: scriptContext.loadingStatus === SCRIPT_LOADING_STATE.RESOLVED,
    isRejected: scriptContext.loadingStatus === SCRIPT_LOADING_STATE.REJECTED
  });

  return [derivedStatusContext, scriptContext.dispatch];
}
/**
 * Custom hook to get access to the ScriptProvider context
 *
 * @returns the latest state of the context
 */


function useScriptProviderContext() {
  var scriptContext = validateBraintreeAuthorizationData(validateReducer(useContext(ScriptContext)));
  return [scriptContext, scriptContext.dispatch];
} // Create the React context to use in the PayPal hosted fields provider


var PayPalHostedFieldsContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/**
 * Custom hook to get access to the PayPal Hosted Fields instance.
 * The instance represent the returned object after the render process
 * With this object a user can submit the fields and dynamically modify the cards
 *
 * @returns the hosted fields instance if is available in the component
 */

function usePayPalHostedFields() {
  return useContext(PayPalHostedFieldsContext);
}
/**
This `<PayPalButtons />` component supports rendering [buttons](https://developer.paypal.com/docs/business/javascript-sdk/javascript-sdk-reference/#buttons) for PayPal, Venmo, and alternative payment methods.
It relies on the `<PayPalScriptProvider />` parent component for managing state related to loading the JS SDK script.
*/


var PayPalButtons = function (_a) {
  var _b = _a.className,
      className = _b === void 0 ? "" : _b,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      children = _a.children,
      _d = _a.forceReRender,
      forceReRender = _d === void 0 ? [] : _d,
      buttonProps = __rest(_a, ["className", "disabled", "children", "forceReRender"]);

  var isDisabledStyle = disabled ? {
    opacity: 0.38
  } : {};
  var classNames = "".concat(className, " ").concat(disabled ? "paypal-buttons-disabled" : "").trim();
  var buttonsContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var buttons = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var _e = usePayPalScriptReducer()[0],
      isResolved = _e.isResolved,
      options = _e.options;

  var _f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      initActions = _f[0],
      setInitActions = _f[1];

  var _g = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      isEligible = _g[0],
      setIsEligible = _g[1];

  var _h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      setErrorState = _h[1];

  function closeButtonsComponent() {
    if (buttons.current !== null) {
      buttons.current.close().catch(function () {// ignore errors when closing the component
      });
    }
  } // useEffect hook for rendering the buttons


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // verify the sdk script has successfully loaded
    if (isResolved === false) {
      return closeButtonsComponent;
    }

    var paypalWindowNamespace = getPayPalWindowNamespace$1(options.dataNamespace); // verify dependency on window object

    if (paypalWindowNamespace === undefined || paypalWindowNamespace.Buttons === undefined) {
      setErrorState(function () {
        throw new Error(generateErrorMessage({
          reactComponentName: PayPalButtons.displayName,
          sdkComponentKey: "buttons",
          sdkRequestedComponents: options.components,
          sdkDataNamespace: options[SDK_SETTINGS.DATA_NAMESPACE]
        }));
      });
      return closeButtonsComponent;
    }

    var decoratedOnInit = function (data, actions) {
      setInitActions(actions);

      if (typeof buttonProps.onInit === "function") {
        buttonProps.onInit(data, actions);
      }
    };

    try {
      buttons.current = paypalWindowNamespace.Buttons(__assign(__assign({}, buttonProps), {
        onInit: decoratedOnInit
      }));
    } catch (err) {
      return setErrorState(function () {
        throw new Error("Failed to render <PayPalButtons /> component. Failed to initialize:  ".concat(err));
      });
    } // only render the button when eligible


    if (buttons.current.isEligible() === false) {
      setIsEligible(false);
      return closeButtonsComponent;
    }

    if (!buttonsContainerRef.current) {
      return closeButtonsComponent;
    }

    buttons.current.render(buttonsContainerRef.current).catch(function (err) {
      // component failed to render, possibly because it was closed or destroyed.
      if (buttonsContainerRef.current === null || buttonsContainerRef.current.children.length === 0) {
        // paypal buttons container is no longer in the DOM, we can safely ignore the error
        return;
      } // paypal buttons container is still in the DOM


      setErrorState(function () {
        throw new Error("Failed to render <PayPalButtons /> component. ".concat(err));
      });
    });
    return closeButtonsComponent; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, __spreadArray(__spreadArray([isResolved], forceReRender, true), [buttonProps.fundingSource], false)); // useEffect hook for managing disabled state

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (initActions === null) {
      return;
    }

    if (disabled === true) {
      initActions.disable().catch(function () {// ignore errors when disabling the component
      });
    } else {
      initActions.enable().catch(function () {// ignore errors when enabling the component
      });
    }
  }, [disabled, initActions]);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, isEligible ? react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: buttonsContainerRef,
    style: isDisabledStyle,
    className: classNames
  }) : children);
};

PayPalButtons.displayName = "PayPalButtons";

function findScript(url, attributes) {
  var currentScript = document.querySelector("script[src=\"".concat(url, "\"]"));
  if (currentScript === null) return null;
  var nextScript = createScriptElement(url, attributes);
  var currentScriptClone = currentScript.cloneNode();
  delete currentScriptClone.dataset.uidAuto;

  if (Object.keys(currentScriptClone.dataset).length !== Object.keys(nextScript.dataset).length) {
    return null;
  }

  var isExactMatch = true;
  Object.keys(currentScriptClone.dataset).forEach(function (key) {
    if (currentScriptClone.dataset[key] !== nextScript.dataset[key]) {
      isExactMatch = false;
    }
  });
  return isExactMatch ? currentScript : null;
}

function insertScriptElement(_a) {
  var url = _a.url,
      attributes = _a.attributes,
      onSuccess = _a.onSuccess,
      onError = _a.onError;
  var newScript = createScriptElement(url, attributes);
  newScript.onerror = onError;
  newScript.onload = onSuccess;
  document.head.insertBefore(newScript, document.head.firstElementChild);
}

function processOptions(options) {
  var sdkBaseUrl = "https://www.paypal.com/sdk/js";

  if (options.sdkBaseUrl) {
    sdkBaseUrl = options.sdkBaseUrl;
    delete options.sdkBaseUrl;
  }

  var optionsWithStringIndex = options;

  var _a = Object.keys(optionsWithStringIndex).filter(function (key) {
    return typeof optionsWithStringIndex[key] !== "undefined" && optionsWithStringIndex[key] !== null && optionsWithStringIndex[key] !== "";
  }).reduce(function (accumulator, key) {
    var value = optionsWithStringIndex[key].toString();
    key = camelCaseToKebabCase(key);

    if (key.substring(0, 4) === "data" || key === "crossorigin") {
      accumulator.attributes[key] = value;
    } else {
      accumulator.queryParams[key] = value;
    }

    return accumulator;
  }, {
    queryParams: {},
    attributes: {}
  }),
      queryParams = _a.queryParams,
      attributes = _a.attributes;

  if (queryParams["merchant-id"] && queryParams["merchant-id"].indexOf(",") !== -1) {
    attributes["data-merchant-id"] = queryParams["merchant-id"];
    queryParams["merchant-id"] = "*";
  }

  return {
    url: "".concat(sdkBaseUrl, "?").concat(objectToQueryString(queryParams)),
    attributes: attributes
  };
}

function camelCaseToKebabCase(str) {
  var replacer = function (match, indexOfMatch) {
    return (indexOfMatch ? "-" : "") + match.toLowerCase();
  };

  return str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, replacer);
}

function objectToQueryString(params) {
  var queryString = "";
  Object.keys(params).forEach(function (key) {
    if (queryString.length !== 0) queryString += "&";
    queryString += key + "=" + params[key];
  });
  return queryString;
}

function createScriptElement(url, attributes) {
  if (attributes === void 0) {
    attributes = {};
  }

  var newScript = document.createElement("script");
  newScript.src = url;
  Object.keys(attributes).forEach(function (key) {
    newScript.setAttribute(key, attributes[key]);

    if (key === "data-csp-nonce") {
      newScript.setAttribute("nonce", attributes["data-csp-nonce"]);
    }
  });
  return newScript;
}

function loadScript(options, PromisePonyfill) {
  if (PromisePonyfill === void 0) {
    PromisePonyfill = Promise;
  }

  validateArguments(options, PromisePonyfill);
  if (typeof document === "undefined") return PromisePonyfill.resolve(null);

  var _a = processOptions(options),
      url = _a.url,
      attributes = _a.attributes;

  var namespace = attributes["data-namespace"] || "paypal";
  var existingWindowNamespace = getPayPalWindowNamespace(namespace);

  if (!attributes["data-js-sdk-library"]) {
    attributes["data-js-sdk-library"] = "paypal-js";
  }

  if (findScript(url, attributes) && existingWindowNamespace) {
    return PromisePonyfill.resolve(existingWindowNamespace);
  }

  return loadCustomScript({
    url: url,
    attributes: attributes
  }, PromisePonyfill).then(function () {
    var newWindowNamespace = getPayPalWindowNamespace(namespace);

    if (newWindowNamespace) {
      return newWindowNamespace;
    }

    throw new Error("The window.".concat(namespace, " global variable is not available."));
  });
}

function loadCustomScript(options, PromisePonyfill) {
  if (PromisePonyfill === void 0) {
    PromisePonyfill = Promise;
  }

  validateArguments(options, PromisePonyfill);
  var url = options.url,
      attributes = options.attributes;

  if (typeof url !== "string" || url.length === 0) {
    throw new Error("Invalid url.");
  }

  if (typeof attributes !== "undefined" && typeof attributes !== "object") {
    throw new Error("Expected attributes to be an object.");
  }

  return new PromisePonyfill(function (resolve, reject) {
    if (typeof document === "undefined") return resolve();
    insertScriptElement({
      url: url,
      attributes: attributes,
      onSuccess: function () {
        return resolve();
      },
      onError: function () {
        var defaultError = new Error("The script \"".concat(url, "\" failed to load. Check the HTTP status code and response body in DevTools to learn more."));
        return reject(defaultError);
      }
    });
  });
}

function getPayPalWindowNamespace(namespace) {
  return window[namespace];
}

function validateArguments(options, PromisePonyfill) {
  if (typeof options !== "object" || options === null) {
    throw new Error("Expected an options object.");
  }

  if (typeof PromisePonyfill !== "undefined" && typeof PromisePonyfill !== "function") {
    throw new Error("Expected PromisePonyfill to be a function.");
  }
}
/**
 * Simple check to determine if the Braintree is a valid namespace.
 *
 * @param braintreeSource the source {@link BraintreeNamespace}
 * @returns a boolean representing if the namespace is valid.
 */


var isValidBraintreeNamespace = function (braintreeSource) {
  var _a, _b;

  if (typeof ((_a = braintreeSource === null || braintreeSource === void 0 ? void 0 : braintreeSource.client) === null || _a === void 0 ? void 0 : _a.create) !== "function" && typeof ((_b = braintreeSource === null || braintreeSource === void 0 ? void 0 : braintreeSource.paypalCheckout) === null || _b === void 0 ? void 0 : _b.create) !== "function") {
    throw new Error("The braintreeNamespace property is not a valid BraintreeNamespace type.");
  }

  return true;
};
/**
 * Use `actions.braintree` to provide an interface for the paypalCheckoutInstance
 * through the createOrder, createBillingAgreement and onApprove callbacks
 *
 * @param braintreeButtonProps the component button options
 * @returns a new copy of the component button options casted as {@link PayPalButtonsComponentProps}
 */


var decorateActions = function (buttonProps, payPalCheckoutInstance) {
  var createOrderRef = buttonProps.createOrder;
  var createBillingAgreementRef = buttonProps.createBillingAgreement;
  var onApproveRef = buttonProps.onApprove;

  if (typeof createOrderRef === "function") {
    buttonProps.createOrder = function (data, actions) {
      return createOrderRef(data, __assign(__assign({}, actions), {
        braintree: payPalCheckoutInstance
      }));
    };
  }

  if (typeof createBillingAgreementRef === "function") {
    buttonProps.createBillingAgreement = function (data, actions) {
      return createBillingAgreementRef(data, __assign(__assign({}, actions), {
        braintree: payPalCheckoutInstance
      }));
    };
  }

  if (typeof onApproveRef === "function") {
    buttonProps.onApprove = function (data, actions) {
      return onApproveRef(data, __assign(__assign({}, actions), {
        braintree: payPalCheckoutInstance
      }));
    };
  }

  return __assign({}, buttonProps);
};
/**
 * Get the Braintree namespace from the component props.
 * If the prop `braintreeNamespace` is undefined will try to load it from the CDN.
 * This function allows users to set the braintree manually on the `BraintreePayPalButtons` component.
 *
 * Use case can be for example legacy sites using AMD/UMD modules,
 * trying to integrate the `BraintreePayPalButtons` component.
 * If we attempt to load the Braintree from the CDN won't define the braintree namespace.
 * This happens because the braintree script is an UMD module.
 * After detecting the AMD on the global scope will create an anonymous module using `define`
 * and the `BraintreePayPalButtons` won't be able to get access to the `window.braintree` namespace
 * from the global context.
 *
 * @param braintreeSource the source {@link BraintreeNamespace}
 * @returns the {@link BraintreeNamespace}
 */


var getBraintreeNamespace = function (braintreeSource) {
  if (braintreeSource && isValidBraintreeNamespace(braintreeSource)) {
    return Promise.resolve(braintreeSource);
  }

  return Promise.all([loadCustomScript({
    url: BRAINTREE_SOURCE
  }), loadCustomScript({
    url: BRAINTREE_PAYPAL_CHECKOUT_SOURCE
  })]).then(function () {
    return getBraintreeWindowNamespace();
  });
};
/**
This `<BraintreePayPalButtons />` component renders the [Braintree PayPal Buttons](https://developer.paypal.com/braintree/docs/guides/paypal/overview) for Braintree Merchants.
It relies on the `<PayPalScriptProvider />` parent component for managing state related to loading the JS SDK script.

Note: You are able to make your integration using the client token or using the tokenization key.

- To use the client token integration set the key `dataClientToken` in the `PayPayScriptProvider` component's options.
- To use the tokenization key integration set the key `dataUserIdToken` in the `PayPayScriptProvider` component's options.
*/


var BraintreePayPalButtons = function (_a) {
  var _b = _a.className,
      className = _b === void 0 ? "" : _b,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      children = _a.children,
      _d = _a.forceReRender,
      forceReRender = _d === void 0 ? [] : _d,
      braintreeNamespace = _a.braintreeNamespace,
      merchantAccountId = _a.merchantAccountId,
      buttonProps = __rest(_a, ["className", "disabled", "children", "forceReRender", "braintreeNamespace", "merchantAccountId"]);

  var _e = useState(null),
      setErrorState = _e[1];

  var _f = useScriptProviderContext(),
      providerContext = _f[0],
      dispatch = _f[1];

  useEffect(function () {
    getBraintreeNamespace(braintreeNamespace).then(function (braintree) {
      var clientTokenizationKey = providerContext.options[SDK_SETTINGS.DATA_USER_ID_TOKEN];
      var clientToken = providerContext.options[SDK_SETTINGS.DATA_CLIENT_TOKEN];
      return braintree.client.create({
        authorization: clientTokenizationKey || clientToken
      }).then(function (clientInstance) {
        var merchantProp = merchantAccountId ? {
          merchantAccountId: merchantAccountId
        } : {};
        return braintree.paypalCheckout.create(__assign(__assign({}, merchantProp), {
          client: clientInstance
        }));
      }).then(function (paypalCheckoutInstance) {
        dispatch({
          type: DISPATCH_ACTION.SET_BRAINTREE_INSTANCE,
          value: paypalCheckoutInstance
        });
      });
    }).catch(function (err) {
      setErrorState(function () {
        throw new Error("".concat(LOAD_SCRIPT_ERROR, " ").concat(err));
      });
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [providerContext.options]);
  return React.createElement(React.Fragment, null, providerContext.braintreePayPalCheckoutInstance && React.createElement(PayPalButtons, __assign({
    className: className,
    disabled: disabled,
    forceReRender: forceReRender
  }, decorateActions(buttonProps, providerContext.braintreePayPalCheckoutInstance)), children));
};
/**
The `<PayPalMarks />` component is used for conditionally rendering different payment options using radio buttons.
The [Display PayPal Buttons with other Payment Methods guide](https://developer.paypal.com/docs/business/checkout/add-capabilities/buyer-experience/#display-paypal-buttons-with-other-payment-methods) describes this style of integration in detail.
It relies on the `<PayPalScriptProvider />` parent component for managing state related to loading the JS SDK script.

This component can also be configured to use a single funding source similar to the [standalone buttons](https://developer.paypal.com/docs/business/checkout/configure-payments/standalone-buttons/) approach.
A `FUNDING` object is exported by this library which has a key for every available funding source option.
*/


var PayPalMarks = function (_a) {
  var _b = _a.className,
      className = _b === void 0 ? "" : _b,
      children = _a.children,
      markProps = __rest(_a, ["className", "children"]);

  var _c = usePayPalScriptReducer()[0],
      isResolved = _c.isResolved,
      options = _c.options;
  var markContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _d = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      isEligible = _d[0],
      setIsEligible = _d[1];

  var _e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      setErrorState = _e[1];
  /**
   * Render PayPal Mark into the DOM
   */


  var renderPayPalMark = function (mark) {
    var current = markContainerRef.current; // only render the mark when eligible

    if (!current || !mark.isEligible()) {
      return setIsEligible(false);
    } // Remove any children before render it again


    if (current.firstChild) {
      current.removeChild(current.firstChild);
    }

    mark.render(current).catch(function (err) {
      // component failed to render, possibly because it was closed or destroyed.
      if (current === null || current.children.length === 0) {
        // paypal marks container is no longer in the DOM, we can safely ignore the error
        return;
      } // paypal marks container is still in the DOM


      setErrorState(function () {
        throw new Error("Failed to render <PayPalMarks /> component. ".concat(err));
      });
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // verify the sdk script has successfully loaded
    if (isResolved === false) {
      return;
    }

    var paypalWindowNamespace = getPayPalWindowNamespace$1(options[SDK_SETTINGS.DATA_NAMESPACE]); // verify dependency on window object

    if (paypalWindowNamespace === undefined || paypalWindowNamespace.Marks === undefined) {
      return setErrorState(function () {
        throw new Error(generateErrorMessage({
          reactComponentName: PayPalMarks.displayName,
          sdkComponentKey: "marks",
          sdkRequestedComponents: options.components,
          sdkDataNamespace: options[SDK_SETTINGS.DATA_NAMESPACE]
        }));
      });
    }

    renderPayPalMark(paypalWindowNamespace.Marks(__assign({}, markProps))); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isResolved, markProps.fundingSource]);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, isEligible ? react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: markContainerRef,
    className: className
  }) : children);
};

PayPalMarks.displayName = "PayPalMarks";
/**
This `<PayPalMessages />` messages component renders a credit messaging on upstream merchant sites.
It relies on the `<PayPalScriptProvider />` parent component for managing state related to loading the JS SDK script.
*/

var PayPalMessages = function (_a) {
  var _b = _a.className,
      className = _b === void 0 ? "" : _b,
      _c = _a.forceReRender,
      forceReRender = _c === void 0 ? [] : _c,
      messageProps = __rest(_a, ["className", "forceReRender"]);

  var _d = usePayPalScriptReducer()[0],
      isResolved = _d.isResolved,
      options = _d.options;
  var messagesContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var messages = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      setErrorState = _e[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // verify the sdk script has successfully loaded
    if (isResolved === false) {
      return;
    }

    var paypalWindowNamespace = getPayPalWindowNamespace$1(options[SDK_SETTINGS.DATA_NAMESPACE]); // verify dependency on window object

    if (paypalWindowNamespace === undefined || paypalWindowNamespace.Messages === undefined) {
      return setErrorState(function () {
        throw new Error(generateErrorMessage({
          reactComponentName: PayPalMessages.displayName,
          sdkComponentKey: "messages",
          sdkRequestedComponents: options.components,
          sdkDataNamespace: options[SDK_SETTINGS.DATA_NAMESPACE]
        }));
      });
    }

    messages.current = paypalWindowNamespace.Messages(__assign({}, messageProps));
    messages.current.render(messagesContainerRef.current).catch(function (err) {
      // component failed to render, possibly because it was closed or destroyed.
      if (messagesContainerRef.current === null || messagesContainerRef.current.children.length === 0) {
        // paypal messages container is no longer in the DOM, we can safely ignore the error
        return;
      } // paypal messages container is still in the DOM


      setErrorState(function () {
        throw new Error("Failed to render <PayPalMessages /> component. ".concat(err));
      });
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, __spreadArray([isResolved], forceReRender, true));
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: messagesContainerRef,
    className: className
  });
};

PayPalMessages.displayName = "PayPalMessages";
/**
This `<PayPalScriptProvider />` component takes care of loading the JS SDK `<script>`.
It manages state for script loading so children components like `<PayPalButtons />` know when it's safe to use the `window.paypal` global namespace.

Note: You always should use this component as a wrapper for  `PayPalButtons`, `PayPalMarks`, `PayPalMessages` and `BraintreePayPalButtons` components.
 */

var PayPalScriptProvider = function (_a) {
  var _b;

  var _c = _a.options,
      options = _c === void 0 ? {
    clientId: "test"
  } : _c,
      children = _a.children,
      _d = _a.deferLoading,
      deferLoading = _d === void 0 ? false : _d;

  var _e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(scriptReducer, {
    options: __assign(__assign({}, options), (_b = {}, _b[SDK_SETTINGS.DATA_JS_SDK_LIBRARY] = SDK_SETTINGS.DATA_LIBRARY_VALUE, _b[SDK_SETTINGS.DATA_SDK_INTEGRATION_SOURCE] = SDK_SETTINGS.DATA_LIBRARY_VALUE, _b[SCRIPT_ID] = "".concat(getScriptID(options)), _b)),
    loadingStatus: deferLoading ? SCRIPT_LOADING_STATE.INITIAL : SCRIPT_LOADING_STATE.PENDING
  }),
      state = _e[0],
      dispatch = _e[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (deferLoading === false && state.loadingStatus === SCRIPT_LOADING_STATE.INITIAL) {
      return dispatch({
        type: DISPATCH_ACTION.LOADING_STATUS,
        value: SCRIPT_LOADING_STATE.PENDING
      });
    }

    if (state.loadingStatus !== SCRIPT_LOADING_STATE.PENDING) {
      return;
    }

    var isSubscribed = true;
    loadScript(state.options).then(function () {
      if (isSubscribed) {
        dispatch({
          type: DISPATCH_ACTION.LOADING_STATUS,
          value: SCRIPT_LOADING_STATE.RESOLVED
        });
      }
    }).catch(function (err) {
      console.error("".concat(LOAD_SCRIPT_ERROR, " ").concat(err));

      if (isSubscribed) {
        dispatch({
          type: DISPATCH_ACTION.LOADING_STATUS,
          value: {
            state: SCRIPT_LOADING_STATE.REJECTED,
            message: String(err)
          }
        });
      }
    });
    return function () {
      isSubscribed = false;
    };
  }, [state.options, deferLoading, state.loadingStatus]);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ScriptContext.Provider, {
    value: __assign(__assign({}, state), {
      dispatch: dispatch
    })
  }, children);
};
/**
 * Custom hook to store registered hosted fields children
 * Each `PayPalHostedField` component should be registered on the parent provider
 *
 * @param initialValue the initially registered components
 * @returns at first, an {@link Object} containing the registered hosted fields,
 * and at the second a function handler to register the hosted fields components
 */


var useHostedFieldsRegister = function (initialValue) {
  if (initialValue === void 0) {
    initialValue = {};
  }

  var registeredFields = useRef(initialValue);

  var registerHostedField = function (component) {
    registeredFields.current = __assign(__assign({}, registeredFields.current), component);
  };

  return [registeredFields, registerHostedField];
};
/**
 * Throw an exception if the HostedFields is not found in the paypal namespace
 * Probably cause for this problem is not sending the hosted-fields string
 * as part of the components props in options
 * {@code <PayPalScriptProvider options={{ components: 'hosted-fields'}}>}
 *
 * @param param0 and object containing the components and namespace defined in options
 * @throws {@code Error}
 *
 */


var generateMissingHostedFieldsError = function (_a) {
  var _b = _a.components,
      components = _b === void 0 ? "" : _b,
      _c = SDK_SETTINGS.DATA_NAMESPACE,
      _d = _a[_c],
      dataNamespace = _d === void 0 ? DEFAULT_PAYPAL_NAMESPACE : _d;
  var expectedComponents = components ? "".concat(components, ",hosted-fields") : "hosted-fields";
  var errorMessage = "Unable to render <PayPalHostedFieldsProvider /> because window.".concat(dataNamespace, ".HostedFields is undefined.");

  if (!components.includes("hosted-fields")) {
    errorMessage += "\nTo fix the issue, add 'hosted-fields' to the list of components passed to the parent PayPalScriptProvider: <PayPalScriptProvider options={{ components: '".concat(expectedComponents, "'}}>");
  }

  return errorMessage;
};
/**
 * Validate the expiration date component. Valid combinations are:
 * 1- Only the `expirationDate` field exists.
 * 2- Only the `expirationMonth` and `expirationYear` fields exist. Cannot be used with the `expirationDate` field.
 *
 * @param registerTypes
 * @returns @type {true} when the children are valid
 */


var validateExpirationDate = function (registerTypes) {
  return !registerTypes.includes(PAYPAL_HOSTED_FIELDS_TYPES.EXPIRATION_DATE) && !registerTypes.includes(PAYPAL_HOSTED_FIELDS_TYPES.EXPIRATION_MONTH) && !registerTypes.includes(PAYPAL_HOSTED_FIELDS_TYPES.EXPIRATION_YEAR);
};
/**
 * Check if we find the [number, expiration, cvv] in children
 *
 * @param requiredChildren the list with required children [number, expiration, cvv]
 * @param registerTypes    the list of all the children types pass to the parent
 * @throw an @type {Error} when not find the default children
 */


var hasDefaultChildren = function (registerTypes) {
  if (!registerTypes.includes(PAYPAL_HOSTED_FIELDS_TYPES.NUMBER) || !registerTypes.includes(PAYPAL_HOSTED_FIELDS_TYPES.CVV) || validateExpirationDate(registerTypes)) {
    throw new Error(HOSTED_FIELDS_CHILDREN_ERROR);
  }
};
/**
 * Check if we don't have duplicate children types
 *
 * @param registerTypes the list of all the children types pass to the parent
 * @throw an @type {Error} when duplicate types was found
 */


var noDuplicateChildren = function (registerTypes) {
  if (registerTypes.length !== new Set(registerTypes).size) {
    throw new Error(HOSTED_FIELDS_DUPLICATE_CHILDREN_ERROR);
  }
};
/**
 * Validate the hosted field children in the PayPalHostedFieldsProvider component.
 * These are the rules:
 * 1- We need to find 3 default children for number, expiration, cvv
 * 2- No duplicate children are allowed
 * 3- No invalid combinations of `expirationDate`, `expirationMonth`, and `expirationYear`
 *
 * @param childrenList     the list of children
 * @param requiredChildren the list with required children [number, expiration, cvv]
 */


var validateHostedFieldChildren = function (registeredFields) {
  hasDefaultChildren(registeredFields);
  noDuplicateChildren(registeredFields);
};
/**
This `<PayPalHostedFieldsProvider />` provider component wraps the form field elements and accepts props like `createOrder()`.

This provider component is designed to be used with the `<PayPalHostedField />` component.

Warning: If you don't see anything in the screen probably your client is ineligible.
To handle this problem make sure to use the prop `notEligibleError` and pass a component with a custom message.
Take a look to this link if that is the case: https://developer.paypal.com/docs/checkout/advanced/integrate/
*/


var PayPalHostedFieldsProvider = function (_a) {
  var styles = _a.styles,
      createOrder = _a.createOrder,
      notEligibleError = _a.notEligibleError,
      children = _a.children,
      installments = _a.installments;
  var _b = useScriptProviderContext()[0],
      options = _b.options,
      loadingStatus = _b.loadingStatus;

  var _c = useState(true),
      isEligible = _c[0],
      setIsEligible = _c[1];

  var _d = useState(),
      cardFields = _d[0],
      setCardFields = _d[1];

  var _e = useState(null),
      setErrorState = _e[1];

  var hostedFieldsContainerRef = useRef(null);
  var hostedFields = useRef();

  var _f = useHostedFieldsRegister(),
      registeredFields = _f[0],
      registerHostedField = _f[1];

  useEffect(function () {
    var _a;

    validateHostedFieldChildren(Object.keys(registeredFields.current)); // Only render the hosted fields when script is loaded and hostedFields is eligible

    if (!(loadingStatus === SCRIPT_LOADING_STATE.RESOLVED)) {
      return;
    } // Get the hosted fields from the [window.paypal.HostedFields] SDK


    hostedFields.current = getPayPalWindowNamespace$1(options[SDK_SETTINGS.DATA_NAMESPACE]).HostedFields;

    if (!hostedFields.current) {
      throw new Error(generateMissingHostedFieldsError((_a = {
        components: options.components
      }, _a[SDK_SETTINGS.DATA_NAMESPACE] = options[SDK_SETTINGS.DATA_NAMESPACE], _a)));
    }

    if (!hostedFields.current.isEligible()) {
      return setIsEligible(false);
    } // Clean all the fields before the rerender


    if (cardFields) {
      cardFields.teardown();
    }

    hostedFields.current.render({
      // Call your server to set up the transaction
      createOrder: createOrder,
      fields: registeredFields.current,
      installments: installments,
      styles: styles
    }).then(function (cardFieldsInstance) {
      if (hostedFieldsContainerRef.current) {
        setCardFields(cardFieldsInstance);
      }
    }).catch(function (err) {
      setErrorState(function () {
        throw new Error("Failed to render <PayPalHostedFieldsProvider /> component. ".concat(err));
      });
    });
  }, [loadingStatus, styles]); // eslint-disable-line react-hooks/exhaustive-deps

  return React.createElement("div", {
    ref: hostedFieldsContainerRef
  }, isEligible ? React.createElement(PayPalHostedFieldsContext.Provider, {
    value: {
      cardFields: cardFields,
      registerHostedField: registerHostedField
    }
  }, children) : notEligibleError);
};
/**
This `<PayPalHostedField />` component renders individual fields for [Hosted Fields](https://developer.paypal.com/docs/business/checkout/advanced-card-payments/integrate#3-add-javascript-sdk-and-card-form) integrations.
It relies on the `<PayPalHostedFieldsProvider />` parent component for managing state related to loading the JS SDK script
and execute some validations before the rendering the fields.

To use the PayPal hosted fields you need to define at least three fields:

- A card number field
- The CVV code from the client card
- The expiration date

You can define the expiration date as a single field similar to the example below,
or you are able to define it in [two separate fields](https://paypal.github.io/react-paypal-js//?path=/docs/paypal-paypalhostedfields--expiration-date). One for the month and second for year.

Note: Take care when using multiple instances of the PayPal Hosted Fields on the same page.
The component will fail to render when any of the selectors return more than one element.
*/


var PayPalHostedField = function (_a) {
  var hostedFieldType = _a.hostedFieldType,
      // eslint-disable-line @typescript-eslint/no-unused-vars
  options = _a.options,
      // eslint-disable-line @typescript-eslint/no-unused-vars
  props = __rest(_a, ["hostedFieldType", "options"]);

  var hostedFieldContext = useContext(PayPalHostedFieldsContext);
  useEffect(function () {
    var _a;

    if (!(hostedFieldContext === null || hostedFieldContext === void 0 ? void 0 : hostedFieldContext.registerHostedField)) {
      throw new Error("The HostedField cannot be register in the PayPalHostedFieldsProvider parent component");
    } // Register in the parent provider


    hostedFieldContext.registerHostedField((_a = {}, _a[hostedFieldType] = {
      selector: options.selector,
      placeholder: options.placeholder,
      type: options.type,
      formatInput: options.formatInput,
      maskInput: options.maskInput,
      select: options.select,
      maxlength: options.maxlength,
      minlength: options.minlength,
      prefill: options.prefill,
      rejectUnsupportedCards: options.rejectUnsupportedCards
    }, _a));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return React.createElement("div", __assign({}, props));
};
/**
 * Throw an exception if the CardFields is not found in the paypal namespace
 * Probably cause for this problem is not sending the card-fields string
 * as part of the components props in options
 * {@code <PayPalScriptProvider options={{ components: 'card-fields'}}>}
 *
 * @param param0 and object containing the components and namespace defined in options
 * @throws {@code Error}
 *
 */


var generateMissingCardFieldsError = function (_a) {
  var _b = _a.components,
      components = _b === void 0 ? "" : _b,
      _c = SDK_SETTINGS.DATA_NAMESPACE,
      _d = _a[_c],
      dataNamespace = _d === void 0 ? DEFAULT_PAYPAL_NAMESPACE : _d;
  var expectedComponents = components ? "".concat(components, ",card-fields") : "card-fields";
  var errorMessage = "Unable to render <PayPalCardFieldsProvider /> because window.".concat(dataNamespace, ".CardFields is undefined.");

  if (!components.includes("card-fields")) {
    errorMessage += "\nTo fix the issue, add 'card-fields' to the list of components passed to the parent PayPalScriptProvider: <PayPalScriptProvider options={{ components: '".concat(expectedComponents, "'}}>");
  }

  return errorMessage;
};

function ignore() {
  return;
}

function hasChildren(container) {
  var _a;

  return !!((_a = container.current) === null || _a === void 0 ? void 0 : _a.children.length);
}

var PayPalCardFieldsContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  cardFieldsForm: null,
  fields: {},
  registerField: ignore,
  unregisterField: ignore // implementation is inside hook and passed through the provider

});

var usePayPalCardFields = function () {
  return useContext(PayPalCardFieldsContext);
};

var usePayPalCardFieldsRegistry = function () {
  var _a = useState(null),
      setError = _a[1];

  var registeredFields = useRef({});

  var registerField = function () {
    var props = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      props[_i] = arguments[_i];
    }

    var fieldName = props[0],
        options = props[1],
        cardFields = props[2];

    if (registeredFields.current[fieldName]) {
      setError(function () {
        throw new Error(CARD_FIELDS_DUPLICATE_CHILDREN_ERROR);
      });
    }

    registeredFields.current[fieldName] = cardFields === null || cardFields === void 0 ? void 0 : cardFields[fieldName](options);
    return registeredFields.current[fieldName];
  };

  var unregisterField = function (fieldName) {
    var field = registeredFields.current[fieldName];

    if (field) {
      field.close().catch(ignore);
      delete registeredFields.current[fieldName];
    }
  };

  return {
    fields: registeredFields.current,
    registerField: registerField,
    unregisterField: unregisterField
  };
};

var FullWidthContainer = function (_a) {
  var children = _a.children;
  return React.createElement("div", {
    style: {
      width: "100%"
    }
  }, children);
};

var PayPalCardFieldsProvider = function (_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  var _b = usePayPalScriptReducer()[0],
      isResolved = _b.isResolved,
      options = _b.options;

  var _c = usePayPalCardFieldsRegistry(),
      fields = _c.fields,
      registerField = _c.registerField,
      unregisterField = _c.unregisterField;

  var _d = useState(null),
      cardFieldsForm = _d[0],
      setCardFieldsForm = _d[1];

  var cardFieldsInstance = useRef(null);

  var _e = useState(false),
      isEligible = _e[0],
      setIsEligible = _e[1]; // We set the error inside state so that it can be caught by React's error boundary


  var _f = useState(null),
      setError = _f[1];

  useEffect(function () {
    var _a, _b, _c;

    if (!isResolved) {
      return;
    }

    try {
      cardFieldsInstance.current = (_c = (_b = (_a = getPayPalWindowNamespace$1(options[SDK_SETTINGS.DATA_NAMESPACE])).CardFields) === null || _b === void 0 ? void 0 : _b.call(_a, __assign({}, props))) !== null && _c !== void 0 ? _c : null;
    } catch (error) {
      setError(function () {
        throw new Error("Failed to render <PayPalCardFieldsProvider /> component. Failed to initialize:  ".concat(error));
      });
      return;
    }

    if (!cardFieldsInstance.current) {
      setError(function () {
        var _a;

        throw new Error(generateMissingCardFieldsError((_a = {
          components: options.components
        }, _a[SDK_SETTINGS.DATA_NAMESPACE] = options[SDK_SETTINGS.DATA_NAMESPACE], _a)));
      });
      return;
    }

    setIsEligible(cardFieldsInstance.current.isEligible());
    setCardFieldsForm(cardFieldsInstance.current);
    return function () {
      setCardFieldsForm(null);
      cardFieldsInstance.current = null;
    };
  }, [isResolved]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isEligible) {
    // TODO: What should be returned here?
    return React.createElement("div", null);
  }

  return React.createElement(FullWidthContainer, null, React.createElement(PayPalCardFieldsContext.Provider, {
    value: {
      cardFieldsForm: cardFieldsForm,
      fields: fields,
      registerField: registerField,
      unregisterField: unregisterField
    }
  }, children));
};

var PayPalCardField = function (_a) {
  var className = _a.className,
      fieldName = _a.fieldName,
      options = __rest(_a, ["className", "fieldName"]);

  var _b = usePayPalCardFields(),
      cardFieldsForm = _b.cardFieldsForm,
      registerField = _b.registerField,
      unregisterField = _b.unregisterField;

  var containerRef = useRef(null); // Set errors is state so that they can be caught by React's error boundary

  var _c = useState(null),
      setError = _c[1];

  function closeComponent() {
    unregisterField(fieldName);
  }

  useEffect(function () {
    if (!cardFieldsForm) {
      setError(function () {
        throw new Error(CARD_FIELDS_CONTEXT_ERROR);
      });
      return closeComponent;
    }

    if (!containerRef.current) {
      return closeComponent;
    }

    var registeredField = registerField(fieldName, options, cardFieldsForm);
    registeredField === null || registeredField === void 0 ? void 0 : registeredField.render(containerRef.current).catch(function (err) {
      if (!hasChildren(containerRef)) {
        // Component no longer in the DOM, we can safely ignore the error
        return;
      } // Component is still in the DOM


      setError(function () {
        throw new Error("Failed to render <PayPal".concat(fieldName, " /> component. ").concat(err));
      });
    });
    return closeComponent;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return React.createElement("div", {
    ref: containerRef,
    className: className
  });
};

var PayPalNameField = function (options) {
  return React.createElement(PayPalCardField, __assign({
    fieldName: "NameField"
  }, options));
};

var PayPalNumberField = function (options) {
  return React.createElement(PayPalCardField, __assign({
    fieldName: "NumberField"
  }, options));
};

var PayPalExpiryField = function (options) {
  return React.createElement(PayPalCardField, __assign({
    fieldName: "ExpiryField"
  }, options));
};

var PayPalCVVField = function (options) {
  return React.createElement(PayPalCardField, __assign({
    fieldName: "CVVField"
  }, options));
};

var FlexContainer = function (_a) {
  var children = _a.children;
  return React.createElement("div", {
    style: {
      display: "flex",
      width: "100%"
    }
  }, children);
};

var PayPalCardFieldsForm = function (_a) {
  var className = _a.className,
      options = __rest(_a, ["className"]);

  return React.createElement("div", {
    className: className
  }, React.createElement(PayPalCardField, __assign({
    fieldName: "NameField"
  }, options)), React.createElement(PayPalCardField, __assign({
    fieldName: "NumberField"
  }, options)), React.createElement(FlexContainer, null, React.createElement(FullWidthContainer, null, React.createElement(PayPalCardField, __assign({
    fieldName: "ExpiryField"
  }, options))), React.createElement(FullWidthContainer, null, React.createElement(PayPalCardField, __assign({
    fieldName: "CVVField"
  }, options)))));
};

var FUNDING$1 = {
  PAYPAL: 'paypal',
  VENMO: 'venmo',
  APPLEPAY: 'applepay',
  ITAU: 'itau',
  CREDIT: 'credit',
  PAYLATER: 'paylater',
  CARD: 'card',
  IDEAL: 'ideal',
  SEPA: 'sepa',
  BANCONTACT: 'bancontact',
  GIROPAY: 'giropay',
  SOFORT: 'sofort',
  EPS: 'eps',
  MYBANK: 'mybank',
  P24: 'p24',
  VERKKOPANKKI: 'verkkopankki',
  PAYU: 'payu',
  BLIK: 'blik',
  TRUSTLY: 'trustly',
  ZIMPLER: 'zimpler',
  MAXIMA: 'maxima',
  OXXO: 'oxxo',
  BOLETO: 'boleto',
  BOLETOBANCARIO: 'boletobancario',
  WECHATPAY: 'wechatpay',
  MERCADOPAGO: 'mercadopago',
  MULTIBANCO: 'multibanco'
}; // We do not re-export `FUNDING` from the `sdk-constants` module
// directly because it has no type definitions.
//
// See https://github.com/paypal/react-paypal-js/issues/125

var FUNDING = (/* unused pure expression or super */ null && (FUNDING$1));



/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var transitionalDefaults = __webpack_require__(77874);
var AxiosError = __webpack_require__(82648);
var CanceledError = __webpack_require__(60644);
var parseProtocol = __webpack_require__(90205);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45546);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(60644);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);
axios.VERSION = (__webpack_require__(97288).version);
axios.toFormData = __webpack_require__(47675);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(82648);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(60644);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 60644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);
var utils = __webpack_require__(64867);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var buildFullPath = __webpack_require__(94097);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 82648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45546);
var CanceledError = __webpack_require__(60644);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45546);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var AxiosError = __webpack_require__(82648);
var transitionalDefaults = __webpack_require__(77874);
var toFormData = __webpack_require__(47675);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(91623)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 77874:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 97288:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 91623:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 90205:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 47675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];


var utils = __webpack_require__(64867);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(97288).version);
var AxiosError = __webpack_require__(82648);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(79742)
var ieee754 = __webpack_require__(80645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
}


/***/ }),

/***/ 38966:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(47815);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(42473);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {}

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports["default"] = createReactContext;
module.exports = exports['default'];

/***/ }),

/***/ 53443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(38966);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),

/***/ 84314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getDefaultOptions; },
/* harmony export */   "b": function() { return /* binding */ setDefaultOptions; }
/* harmony export */ });
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 13882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 71213:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./_lib/buildFormatLongFn/index.js": [
		20289,
		7,
		20289
	],
	"./_lib/buildLocalizeFn/index.js": [
		16245,
		7,
		16245
	],
	"./_lib/buildMatchFn/index.js": [
		43421,
		7,
		43421
	],
	"./_lib/buildMatchPatternFn/index.js": [
		78926,
		7,
		78926
	],
	"./af/_lib/formatDistance/index.js": [
		41146,
		7,
		41146
	],
	"./af/_lib/formatLong/index.js": [
		60358,
		7,
		60358
	],
	"./af/_lib/formatRelative/index.js": [
		31310,
		7,
		31310
	],
	"./af/_lib/localize/index.js": [
		82714,
		7,
		82714
	],
	"./af/_lib/match/index.js": [
		33185,
		7,
		33185
	],
	"./af/index.js": [
		74156,
		7,
		74156
	],
	"./ar-DZ/_lib/formatDistance/index.js": [
		10258,
		7,
		10258
	],
	"./ar-DZ/_lib/formatLong/index.js": [
		38384,
		7,
		38384
	],
	"./ar-DZ/_lib/formatRelative/index.js": [
		12923,
		7,
		12923
	],
	"./ar-DZ/_lib/localize/index.js": [
		50996,
		7,
		50996
	],
	"./ar-DZ/_lib/match/index.js": [
		53463,
		7,
		53463
	],
	"./ar-DZ/index.js": [
		79307,
		7,
		79307
	],
	"./ar-EG/_lib/formatDistance/index.js": [
		70405,
		7,
		70405
	],
	"./ar-EG/_lib/formatLong/index.js": [
		59137,
		7,
		59137
	],
	"./ar-EG/_lib/formatRelative/index.js": [
		19798,
		7,
		19798
	],
	"./ar-EG/_lib/localize/index.js": [
		20303,
		7,
		20303
	],
	"./ar-EG/_lib/match/index.js": [
		2527,
		7,
		2527
	],
	"./ar-EG/index.js": [
		56379,
		7,
		56379
	],
	"./ar-MA/_lib/formatDistance/index.js": [
		56716,
		7,
		56716
	],
	"./ar-MA/_lib/formatLong/index.js": [
		92086,
		7,
		92086
	],
	"./ar-MA/_lib/formatRelative/index.js": [
		79302,
		7,
		79302
	],
	"./ar-MA/_lib/localize/index.js": [
		89105,
		7,
		89105
	],
	"./ar-MA/_lib/match/index.js": [
		18092,
		7,
		18092
	],
	"./ar-MA/index.js": [
		22739,
		7,
		22739
	],
	"./ar-SA/_lib/formatDistance/index.js": [
		56224,
		7,
		56224
	],
	"./ar-SA/_lib/formatLong/index.js": [
		22041,
		7,
		22041
	],
	"./ar-SA/_lib/formatRelative/index.js": [
		90046,
		7,
		90046
	],
	"./ar-SA/_lib/localize/index.js": [
		16274,
		7,
		16274
	],
	"./ar-SA/_lib/match/index.js": [
		7161,
		7,
		7161
	],
	"./ar-SA/index.js": [
		51730,
		7,
		51730
	],
	"./ar-TN/_lib/formatDistance/index.js": [
		98818,
		7,
		98818
	],
	"./ar-TN/_lib/formatLong/index.js": [
		19048,
		7,
		19048
	],
	"./ar-TN/_lib/formatRelative/index.js": [
		30005,
		7,
		30005
	],
	"./ar-TN/_lib/localize/index.js": [
		7649,
		7,
		7649
	],
	"./ar-TN/_lib/match/index.js": [
		34357,
		7,
		34357
	],
	"./ar-TN/index.js": [
		37650,
		7,
		37650
	],
	"./ar/_lib/formatDistance/index.js": [
		29226,
		7,
		29226
	],
	"./ar/_lib/formatLong/index.js": [
		45604,
		7,
		45604
	],
	"./ar/_lib/formatRelative/index.js": [
		77237,
		7,
		77237
	],
	"./ar/_lib/localize/index.js": [
		72890,
		7,
		72890
	],
	"./ar/_lib/match/index.js": [
		53372,
		7,
		53372
	],
	"./ar/index.js": [
		18137,
		7,
		18137
	],
	"./az/_lib/formatDistance/index.js": [
		67580,
		7,
		67580
	],
	"./az/_lib/formatLong/index.js": [
		3381,
		7,
		3381
	],
	"./az/_lib/formatRelative/index.js": [
		5895,
		7,
		5895
	],
	"./az/_lib/localize/index.js": [
		79557,
		7,
		79557
	],
	"./az/_lib/match/index.js": [
		74390,
		7,
		74390
	],
	"./az/index.js": [
		77356,
		7,
		77356
	],
	"./be-tarask/_lib/formatDistance/index.js": [
		45515,
		7,
		45515
	],
	"./be-tarask/_lib/formatLong/index.js": [
		49505,
		7,
		49505
	],
	"./be-tarask/_lib/formatRelative/index.js": [
		37233,
		7,
		55827,
		37233
	],
	"./be-tarask/_lib/localize/index.js": [
		22623,
		7,
		22623
	],
	"./be-tarask/_lib/match/index.js": [
		96427,
		7,
		96427
	],
	"./be-tarask/index.js": [
		53336,
		7,
		55827,
		53336
	],
	"./be/_lib/formatDistance/index.js": [
		564,
		7,
		564
	],
	"./be/_lib/formatLong/index.js": [
		87682,
		7,
		87682
	],
	"./be/_lib/formatRelative/index.js": [
		28206,
		7,
		55827,
		28206
	],
	"./be/_lib/localize/index.js": [
		13533,
		7,
		13533
	],
	"./be/_lib/match/index.js": [
		71682,
		7,
		71682
	],
	"./be/index.js": [
		9624,
		7,
		55827,
		9624
	],
	"./bg/_lib/formatDistance/index.js": [
		79681,
		7,
		79681
	],
	"./bg/_lib/formatLong/index.js": [
		45930,
		7,
		45930
	],
	"./bg/_lib/formatRelative/index.js": [
		21185,
		7,
		21185
	],
	"./bg/_lib/localize/index.js": [
		91641,
		7,
		91641
	],
	"./bg/_lib/match/index.js": [
		45152,
		7,
		45152
	],
	"./bg/index.js": [
		94719,
		7,
		94719
	],
	"./bn/_lib/formatDistance/index.js": [
		67835,
		7,
		67835
	],
	"./bn/_lib/formatLong/index.js": [
		32076,
		7,
		32076
	],
	"./bn/_lib/formatRelative/index.js": [
		36520,
		7,
		36520
	],
	"./bn/_lib/localize/index.js": [
		12674,
		9,
		12674
	],
	"./bn/_lib/match/index.js": [
		35920,
		7,
		35920
	],
	"./bn/index.js": [
		82182,
		7,
		82182
	],
	"./bs/_lib/formatDistance/index.js": [
		95963,
		7,
		95963
	],
	"./bs/_lib/formatLong/index.js": [
		25711,
		7,
		25711
	],
	"./bs/_lib/formatRelative/index.js": [
		44374,
		7,
		44374
	],
	"./bs/_lib/localize/index.js": [
		28113,
		7,
		28113
	],
	"./bs/_lib/match/index.js": [
		69866,
		7,
		69866
	],
	"./bs/index.js": [
		32181,
		7,
		32181
	],
	"./ca/_lib/formatDistance/index.js": [
		49280,
		7,
		49280
	],
	"./ca/_lib/formatLong/index.js": [
		16686,
		7,
		16686
	],
	"./ca/_lib/formatRelative/index.js": [
		54470,
		7,
		54470
	],
	"./ca/_lib/localize/index.js": [
		50683,
		7,
		50683
	],
	"./ca/_lib/match/index.js": [
		73146,
		7,
		73146
	],
	"./ca/index.js": [
		44732,
		7,
		44732
	],
	"./cs/_lib/formatDistance/index.js": [
		79434,
		7,
		79434
	],
	"./cs/_lib/formatLong/index.js": [
		18336,
		7,
		18336
	],
	"./cs/_lib/formatRelative/index.js": [
		3003,
		7,
		3003
	],
	"./cs/_lib/localize/index.js": [
		48793,
		7,
		48793
	],
	"./cs/_lib/match/index.js": [
		63626,
		7,
		63626
	],
	"./cs/index.js": [
		76105,
		7,
		76105
	],
	"./cy/_lib/formatDistance/index.js": [
		90305,
		7,
		90305
	],
	"./cy/_lib/formatLong/index.js": [
		32132,
		7,
		32132
	],
	"./cy/_lib/formatRelative/index.js": [
		68527,
		7,
		68527
	],
	"./cy/_lib/localize/index.js": [
		17863,
		7,
		17863
	],
	"./cy/_lib/match/index.js": [
		16605,
		7,
		53494
	],
	"./cy/index.js": [
		96227,
		7,
		96227
	],
	"./da/_lib/formatDistance/index.js": [
		96569,
		7,
		96569
	],
	"./da/_lib/formatLong/index.js": [
		20658,
		7,
		20658
	],
	"./da/_lib/formatRelative/index.js": [
		31002,
		7,
		31002
	],
	"./da/_lib/localize/index.js": [
		55578,
		7,
		55578
	],
	"./da/_lib/match/index.js": [
		3393,
		7,
		3393
	],
	"./da/index.js": [
		80925,
		7,
		80925
	],
	"./de-AT/_lib/localize/index.js": [
		56443,
		7,
		56443
	],
	"./de-AT/index.js": [
		73210,
		7,
		73210
	],
	"./de/_lib/formatDistance/index.js": [
		82376,
		7,
		82376
	],
	"./de/_lib/formatLong/index.js": [
		6749,
		7,
		6749
	],
	"./de/_lib/formatRelative/index.js": [
		91805,
		7,
		91805
	],
	"./de/_lib/localize/index.js": [
		56105,
		7,
		56105
	],
	"./de/_lib/match/index.js": [
		83996,
		7,
		83996
	],
	"./de/index.js": [
		76119,
		7,
		76119
	],
	"./el/_lib/formatDistance/index.js": [
		96170,
		7,
		96170
	],
	"./el/_lib/formatLong/index.js": [
		22761,
		7,
		22761
	],
	"./el/_lib/formatRelative/index.js": [
		5093,
		7,
		5093
	],
	"./el/_lib/localize/index.js": [
		79919,
		7,
		79919
	],
	"./el/_lib/match/index.js": [
		20320,
		7,
		20320
	],
	"./el/index.js": [
		71511,
		7,
		71511
	],
	"./en-AU/_lib/formatLong/index.js": [
		47483,
		7,
		47483
	],
	"./en-AU/index.js": [
		51971,
		7,
		51971
	],
	"./en-CA/_lib/formatDistance/index.js": [
		16925,
		7,
		16925
	],
	"./en-CA/_lib/formatLong/index.js": [
		17156,
		7,
		17156
	],
	"./en-CA/index.js": [
		23654,
		7,
		23654
	],
	"./en-GB/_lib/formatLong/index.js": [
		90125,
		7,
		90125
	],
	"./en-GB/index.js": [
		22709,
		7,
		22709
	],
	"./en-IE/index.js": [
		84511,
		7,
		84511
	],
	"./en-IN/_lib/formatLong/index.js": [
		44649,
		7,
		44649
	],
	"./en-IN/index.js": [
		56635,
		7,
		56635
	],
	"./en-NZ/_lib/formatLong/index.js": [
		88738,
		7,
		88738
	],
	"./en-NZ/index.js": [
		3557,
		7,
		3557
	],
	"./en-US/_lib/formatDistance/index.js": [
		71924,
		7,
		71924
	],
	"./en-US/_lib/formatLong/index.js": [
		95062,
		7,
		95062
	],
	"./en-US/_lib/formatRelative/index.js": [
		5102,
		7,
		5102
	],
	"./en-US/_lib/localize/index.js": [
		87839,
		7,
		87839
	],
	"./en-US/_lib/match/index.js": [
		9796,
		7,
		9796
	],
	"./en-US/index.js": [
		82512,
		7,
		82512
	],
	"./en-ZA/_lib/formatLong/index.js": [
		12820,
		7,
		12820
	],
	"./en-ZA/index.js": [
		55585,
		7,
		55585
	],
	"./eo/_lib/formatDistance/index.js": [
		60509,
		7,
		60509
	],
	"./eo/_lib/formatLong/index.js": [
		61709,
		7,
		61709
	],
	"./eo/_lib/formatRelative/index.js": [
		76297,
		7,
		76297
	],
	"./eo/_lib/localize/index.js": [
		83419,
		7,
		83419
	],
	"./eo/_lib/match/index.js": [
		66460,
		7,
		66460
	],
	"./eo/index.js": [
		46050,
		7,
		46050
	],
	"./es/_lib/formatDistance/index.js": [
		17308,
		7,
		17308
	],
	"./es/_lib/formatLong/index.js": [
		19983,
		7,
		19983
	],
	"./es/_lib/formatRelative/index.js": [
		54011,
		7,
		54011
	],
	"./es/_lib/localize/index.js": [
		389,
		7,
		389
	],
	"./es/_lib/match/index.js": [
		71365,
		7,
		71365
	],
	"./es/index.js": [
		19962,
		7,
		19962
	],
	"./et/_lib/formatDistance/index.js": [
		37961,
		7,
		37961
	],
	"./et/_lib/formatLong/index.js": [
		50363,
		7,
		50363
	],
	"./et/_lib/formatRelative/index.js": [
		87335,
		7,
		87335
	],
	"./et/_lib/localize/index.js": [
		50794,
		7,
		50794
	],
	"./et/_lib/match/index.js": [
		60084,
		7,
		60084
	],
	"./et/index.js": [
		58170,
		7,
		58170
	],
	"./eu/_lib/formatDistance/index.js": [
		85454,
		7,
		85454
	],
	"./eu/_lib/formatLong/index.js": [
		56183,
		7,
		56183
	],
	"./eu/_lib/formatRelative/index.js": [
		94237,
		7,
		94237
	],
	"./eu/_lib/localize/index.js": [
		5966,
		7,
		5966
	],
	"./eu/_lib/match/index.js": [
		64402,
		7,
		64402
	],
	"./eu/index.js": [
		9042,
		7,
		9042
	],
	"./fa-IR/_lib/formatDistance/index.js": [
		87201,
		7,
		87201
	],
	"./fa-IR/_lib/formatLong/index.js": [
		81884,
		7,
		81884
	],
	"./fa-IR/_lib/formatRelative/index.js": [
		91912,
		7,
		91912
	],
	"./fa-IR/_lib/localize/index.js": [
		97188,
		7,
		97188
	],
	"./fa-IR/_lib/match/index.js": [
		43043,
		7,
		43043
	],
	"./fa-IR/index.js": [
		13537,
		7,
		13537
	],
	"./fi/_lib/formatDistance/index.js": [
		67380,
		7,
		67380
	],
	"./fi/_lib/formatLong/index.js": [
		99532,
		7,
		99532
	],
	"./fi/_lib/formatRelative/index.js": [
		15561,
		7,
		15561
	],
	"./fi/_lib/localize/index.js": [
		64354,
		7,
		61622
	],
	"./fi/_lib/match/index.js": [
		27530,
		7,
		27530
	],
	"./fi/index.js": [
		95999,
		7,
		95999
	],
	"./fr-CA/_lib/formatLong/index.js": [
		53860,
		7,
		53860
	],
	"./fr-CA/index.js": [
		82580,
		7,
		82580
	],
	"./fr-CH/_lib/formatLong/index.js": [
		96065,
		7,
		96065
	],
	"./fr-CH/_lib/formatRelative/index.js": [
		51189,
		7,
		16372
	],
	"./fr-CH/index.js": [
		89718,
		7,
		89718
	],
	"./fr/_lib/formatDistance/index.js": [
		66522,
		7,
		66522
	],
	"./fr/_lib/formatLong/index.js": [
		34325,
		7,
		34325
	],
	"./fr/_lib/formatRelative/index.js": [
		22162,
		7,
		22162
	],
	"./fr/_lib/localize/index.js": [
		38803,
		7,
		38803
	],
	"./fr/_lib/match/index.js": [
		58213,
		7,
		58213
	],
	"./fr/index.js": [
		63126,
		7,
		63126
	],
	"./fy/_lib/formatDistance/index.js": [
		36945,
		7,
		36945
	],
	"./fy/_lib/formatLong/index.js": [
		84905,
		7,
		84905
	],
	"./fy/_lib/formatRelative/index.js": [
		50776,
		7,
		50776
	],
	"./fy/_lib/localize/index.js": [
		82930,
		7,
		82930
	],
	"./fy/_lib/match/index.js": [
		98756,
		7,
		98756
	],
	"./fy/index.js": [
		8848,
		7,
		8848
	],
	"./gd/_lib/formatDistance/index.js": [
		52646,
		7,
		52646
	],
	"./gd/_lib/formatLong/index.js": [
		88030,
		7,
		88030
	],
	"./gd/_lib/formatRelative/index.js": [
		11398,
		7,
		11398
	],
	"./gd/_lib/localize/index.js": [
		77390,
		7,
		77390
	],
	"./gd/_lib/match/index.js": [
		34044,
		7,
		34044
	],
	"./gd/index.js": [
		93698,
		7,
		93698
	],
	"./gl/_lib/formatDistance/index.js": [
		22523,
		7,
		22523
	],
	"./gl/_lib/formatLong/index.js": [
		75618,
		7,
		75618
	],
	"./gl/_lib/formatRelative/index.js": [
		2698,
		7,
		2698
	],
	"./gl/_lib/localize/index.js": [
		68154,
		7,
		68154
	],
	"./gl/_lib/match/index.js": [
		27475,
		7,
		27475
	],
	"./gl/index.js": [
		68846,
		7,
		68846
	],
	"./gu/_lib/formatDistance/index.js": [
		22933,
		7,
		22933
	],
	"./gu/_lib/formatLong/index.js": [
		82513,
		7,
		82513
	],
	"./gu/_lib/formatRelative/index.js": [
		46840,
		7,
		46840
	],
	"./gu/_lib/localize/index.js": [
		98528,
		7,
		98528
	],
	"./gu/_lib/match/index.js": [
		18201,
		7,
		73691
	],
	"./gu/index.js": [
		56209,
		7,
		56209
	],
	"./he/_lib/formatDistance/index.js": [
		75736,
		7,
		75736
	],
	"./he/_lib/formatLong/index.js": [
		45218,
		7,
		45218
	],
	"./he/_lib/formatRelative/index.js": [
		64125,
		7,
		64125
	],
	"./he/_lib/localize/index.js": [
		20379,
		7,
		20379
	],
	"./he/_lib/match/index.js": [
		15430,
		7,
		15430
	],
	"./he/index.js": [
		16309,
		7,
		16309
	],
	"./hi/_lib/formatDistance/index.js": [
		51734,
		7,
		51734
	],
	"./hi/_lib/formatLong/index.js": [
		78241,
		7,
		78241
	],
	"./hi/_lib/formatRelative/index.js": [
		56683,
		7,
		56683
	],
	"./hi/_lib/localize/index.js": [
		65282,
		9,
		65282
	],
	"./hi/_lib/match/index.js": [
		50248,
		7,
		50248
	],
	"./hi/index.js": [
		37056,
		7,
		37056
	],
	"./hr/_lib/formatDistance/index.js": [
		7792,
		7,
		57507
	],
	"./hr/_lib/formatLong/index.js": [
		77910,
		7,
		77910
	],
	"./hr/_lib/formatRelative/index.js": [
		45339,
		7,
		45339
	],
	"./hr/_lib/localize/index.js": [
		77677,
		7,
		77677
	],
	"./hr/_lib/match/index.js": [
		16436,
		7,
		16436
	],
	"./hr/index.js": [
		97276,
		7,
		97276
	],
	"./ht/_lib/formatDistance/index.js": [
		61245,
		7,
		61245
	],
	"./ht/_lib/formatLong/index.js": [
		67737,
		7,
		67737
	],
	"./ht/_lib/formatRelative/index.js": [
		39803,
		7,
		39803
	],
	"./ht/_lib/localize/index.js": [
		19400,
		7,
		19400
	],
	"./ht/_lib/match/index.js": [
		97695,
		7,
		97695
	],
	"./ht/index.js": [
		55389,
		7,
		55389
	],
	"./hu/_lib/formatDistance/index.js": [
		91898,
		7,
		91898
	],
	"./hu/_lib/formatLong/index.js": [
		19266,
		7,
		19266
	],
	"./hu/_lib/formatRelative/index.js": [
		41544,
		7,
		41544
	],
	"./hu/_lib/localize/index.js": [
		69353,
		7,
		69353
	],
	"./hu/_lib/match/index.js": [
		85370,
		7,
		85370
	],
	"./hu/index.js": [
		79675,
		7,
		79675
	],
	"./hy/_lib/formatDistance/index.js": [
		41839,
		7,
		41839
	],
	"./hy/_lib/formatLong/index.js": [
		45625,
		7,
		45625
	],
	"./hy/_lib/formatRelative/index.js": [
		80528,
		7,
		80528
	],
	"./hy/_lib/localize/index.js": [
		74391,
		7,
		74391
	],
	"./hy/_lib/match/index.js": [
		1824,
		7,
		1824
	],
	"./hy/index.js": [
		74403,
		7,
		74403
	],
	"./id/_lib/formatDistance/index.js": [
		95223,
		7,
		95223
	],
	"./id/_lib/formatLong/index.js": [
		27166,
		7,
		27166
	],
	"./id/_lib/formatRelative/index.js": [
		65673,
		7,
		65673
	],
	"./id/_lib/localize/index.js": [
		98045,
		7,
		98045
	],
	"./id/_lib/match/index.js": [
		10798,
		7,
		10798
	],
	"./id/index.js": [
		51872,
		7,
		51872
	],
	"./is/_lib/formatDistance/index.js": [
		67527,
		7,
		67527
	],
	"./is/_lib/formatLong/index.js": [
		73003,
		7,
		73003
	],
	"./is/_lib/formatRelative/index.js": [
		75440,
		7,
		75440
	],
	"./is/_lib/localize/index.js": [
		53162,
		7,
		53162
	],
	"./is/_lib/match/index.js": [
		75101,
		7,
		75101
	],
	"./is/index.js": [
		28677,
		7,
		28677
	],
	"./it-CH/_lib/formatLong/index.js": [
		98347,
		7,
		98347
	],
	"./it-CH/index.js": [
		12264,
		7,
		12264
	],
	"./it/_lib/formatDistance/index.js": [
		12642,
		7,
		12642
	],
	"./it/_lib/formatLong/index.js": [
		96714,
		7,
		96714
	],
	"./it/_lib/formatRelative/index.js": [
		74501,
		7,
		74501
	],
	"./it/_lib/localize/index.js": [
		82713,
		7,
		82713
	],
	"./it/_lib/match/index.js": [
		37281,
		7,
		37281
	],
	"./it/index.js": [
		59629,
		7,
		59629
	],
	"./ja-Hira/_lib/formatDistance/index.js": [
		65047,
		7,
		65047
	],
	"./ja-Hira/_lib/formatLong/index.js": [
		44818,
		7,
		44818
	],
	"./ja-Hira/_lib/formatRelative/index.js": [
		20942,
		7,
		20942
	],
	"./ja-Hira/_lib/localize/index.js": [
		97031,
		7,
		97031
	],
	"./ja-Hira/_lib/match/index.js": [
		71636,
		7,
		71636
	],
	"./ja-Hira/index.js": [
		81590,
		7,
		81590
	],
	"./ja/_lib/formatDistance/index.js": [
		15525,
		7,
		15525
	],
	"./ja/_lib/formatLong/index.js": [
		45161,
		7,
		45161
	],
	"./ja/_lib/formatRelative/index.js": [
		85071,
		7,
		85071
	],
	"./ja/_lib/localize/index.js": [
		85598,
		7,
		85598
	],
	"./ja/_lib/match/index.js": [
		93509,
		7,
		93509
	],
	"./ja/index.js": [
		42180,
		7,
		42180
	],
	"./ka/_lib/formatDistance/index.js": [
		87414,
		7,
		87414
	],
	"./ka/_lib/formatLong/index.js": [
		27355,
		7,
		27355
	],
	"./ka/_lib/formatRelative/index.js": [
		91402,
		7,
		91402
	],
	"./ka/_lib/localize/index.js": [
		5552,
		7,
		5552
	],
	"./ka/_lib/match/index.js": [
		75108,
		7,
		75108
	],
	"./ka/index.js": [
		36501,
		7,
		36501
	],
	"./kk/_lib/formatDistance/index.js": [
		52071,
		7,
		52071
	],
	"./kk/_lib/formatLong/index.js": [
		99466,
		7,
		99466
	],
	"./kk/_lib/formatRelative/index.js": [
		52400,
		7,
		52400
	],
	"./kk/_lib/localize/index.js": [
		31814,
		7,
		31814
	],
	"./kk/_lib/match/index.js": [
		5574,
		7,
		5574
	],
	"./kk/index.js": [
		34996,
		7,
		34996
	],
	"./km/_lib/formatDistance/index.js": [
		97263,
		7,
		97263
	],
	"./km/_lib/formatLong/index.js": [
		66355,
		7,
		66355
	],
	"./km/_lib/formatRelative/index.js": [
		34833,
		7,
		34833
	],
	"./km/_lib/localize/index.js": [
		99273,
		7,
		99273
	],
	"./km/_lib/match/index.js": [
		7916,
		7,
		7916
	],
	"./km/index.js": [
		38684,
		7,
		38684
	],
	"./kn/_lib/formatDistance/index.js": [
		56071,
		7,
		56071
	],
	"./kn/_lib/formatLong/index.js": [
		78505,
		7,
		78505
	],
	"./kn/_lib/formatRelative/index.js": [
		8440,
		7,
		8440
	],
	"./kn/_lib/localize/index.js": [
		23283,
		7,
		23283
	],
	"./kn/_lib/match/index.js": [
		27211,
		7,
		27211
	],
	"./kn/index.js": [
		43434,
		7,
		43434
	],
	"./ko/_lib/formatDistance/index.js": [
		36136,
		7,
		36136
	],
	"./ko/_lib/formatLong/index.js": [
		91257,
		7,
		91257
	],
	"./ko/_lib/formatRelative/index.js": [
		52593,
		7,
		52593
	],
	"./ko/_lib/localize/index.js": [
		93558,
		7,
		93558
	],
	"./ko/_lib/match/index.js": [
		97948,
		7,
		97948
	],
	"./ko/index.js": [
		2666,
		7,
		2666
	],
	"./lb/_lib/formatDistance/index.js": [
		40714,
		7,
		40714
	],
	"./lb/_lib/formatLong/index.js": [
		73815,
		7,
		73815
	],
	"./lb/_lib/formatRelative/index.js": [
		1395,
		7,
		1395
	],
	"./lb/_lib/localize/index.js": [
		45973,
		7,
		45973
	],
	"./lb/_lib/match/index.js": [
		34308,
		7,
		34308
	],
	"./lb/index.js": [
		84048,
		7,
		84048
	],
	"./lt/_lib/formatDistance/index.js": [
		42067,
		7,
		42067
	],
	"./lt/_lib/formatLong/index.js": [
		83573,
		7,
		83573
	],
	"./lt/_lib/formatRelative/index.js": [
		63963,
		7,
		63963
	],
	"./lt/_lib/localize/index.js": [
		16687,
		7,
		16687
	],
	"./lt/_lib/match/index.js": [
		79884,
		7,
		79884
	],
	"./lt/index.js": [
		2536,
		7,
		2536
	],
	"./lv/_lib/formatDistance/index.js": [
		41340,
		7,
		41340
	],
	"./lv/_lib/formatLong/index.js": [
		47090,
		7,
		47090
	],
	"./lv/_lib/formatRelative/index.js": [
		54550,
		7,
		54550
	],
	"./lv/_lib/localize/index.js": [
		44306,
		7,
		44306
	],
	"./lv/_lib/match/index.js": [
		94305,
		7,
		94305
	],
	"./lv/index.js": [
		67222,
		7,
		3610
	],
	"./mk/_lib/formatDistance/index.js": [
		83350,
		7,
		83350
	],
	"./mk/_lib/formatLong/index.js": [
		30299,
		7,
		30299
	],
	"./mk/_lib/formatRelative/index.js": [
		21154,
		7,
		21154
	],
	"./mk/_lib/localize/index.js": [
		49324,
		7,
		49324
	],
	"./mk/_lib/match/index.js": [
		45603,
		7,
		45603
	],
	"./mk/index.js": [
		1057,
		7,
		1057
	],
	"./mn/_lib/formatDistance/index.js": [
		64216,
		7,
		64216
	],
	"./mn/_lib/formatLong/index.js": [
		10562,
		7,
		10562
	],
	"./mn/_lib/formatRelative/index.js": [
		62622,
		7,
		69683
	],
	"./mn/_lib/localize/index.js": [
		48637,
		7,
		94476
	],
	"./mn/_lib/match/index.js": [
		64094,
		7,
		64094
	],
	"./mn/index.js": [
		14893,
		7,
		14893
	],
	"./ms/_lib/formatDistance/index.js": [
		79522,
		7,
		79522
	],
	"./ms/_lib/formatLong/index.js": [
		14333,
		7,
		14333
	],
	"./ms/_lib/formatRelative/index.js": [
		51140,
		7,
		51140
	],
	"./ms/_lib/localize/index.js": [
		97118,
		7,
		97118
	],
	"./ms/_lib/match/index.js": [
		14396,
		7,
		14396
	],
	"./ms/index.js": [
		83148,
		7,
		83148
	],
	"./mt/_lib/formatDistance/index.js": [
		92252,
		7,
		92252
	],
	"./mt/_lib/formatLong/index.js": [
		64778,
		7,
		64778
	],
	"./mt/_lib/formatRelative/index.js": [
		69682,
		7,
		69682
	],
	"./mt/_lib/localize/index.js": [
		57669,
		7,
		57669
	],
	"./mt/_lib/match/index.js": [
		7438,
		7,
		7438
	],
	"./mt/index.js": [
		22598,
		7,
		22598
	],
	"./nb/_lib/formatDistance/index.js": [
		5979,
		7,
		5979
	],
	"./nb/_lib/formatLong/index.js": [
		54727,
		7,
		54727
	],
	"./nb/_lib/formatRelative/index.js": [
		91423,
		7,
		91423
	],
	"./nb/_lib/localize/index.js": [
		99726,
		7,
		99726
	],
	"./nb/_lib/match/index.js": [
		38558,
		7,
		38558
	],
	"./nb/index.js": [
		46815,
		7,
		46815
	],
	"./nl-BE/_lib/formatDistance/index.js": [
		70218,
		7,
		70218
	],
	"./nl-BE/_lib/formatLong/index.js": [
		14661,
		7,
		14661
	],
	"./nl-BE/_lib/formatRelative/index.js": [
		51573,
		7,
		51573
	],
	"./nl-BE/_lib/localize/index.js": [
		20174,
		7,
		20174
	],
	"./nl-BE/_lib/match/index.js": [
		87601,
		7,
		87601
	],
	"./nl-BE/index.js": [
		25778,
		7,
		25778
	],
	"./nl/_lib/formatDistance/index.js": [
		98562,
		7,
		98562
	],
	"./nl/_lib/formatLong/index.js": [
		30221,
		7,
		30221
	],
	"./nl/_lib/formatRelative/index.js": [
		96665,
		7,
		96665
	],
	"./nl/_lib/localize/index.js": [
		90384,
		7,
		90384
	],
	"./nl/_lib/match/index.js": [
		15009,
		7,
		15009
	],
	"./nl/index.js": [
		70390,
		7,
		70390
	],
	"./nn/_lib/formatDistance/index.js": [
		49714,
		7,
		49714
	],
	"./nn/_lib/formatLong/index.js": [
		29983,
		7,
		29983
	],
	"./nn/_lib/formatRelative/index.js": [
		35458,
		7,
		35458
	],
	"./nn/_lib/localize/index.js": [
		87563,
		7,
		87563
	],
	"./nn/_lib/match/index.js": [
		12324,
		7,
		12324
	],
	"./nn/index.js": [
		72495,
		7,
		72495
	],
	"./oc/_lib/formatDistance/index.js": [
		77553,
		7,
		77553
	],
	"./oc/_lib/formatLong/index.js": [
		79329,
		7,
		79329
	],
	"./oc/_lib/formatRelative/index.js": [
		10556,
		7,
		10556
	],
	"./oc/_lib/localize/index.js": [
		86354,
		7,
		86354
	],
	"./oc/_lib/match/index.js": [
		23180,
		7,
		23180
	],
	"./oc/index.js": [
		53462,
		7,
		3824
	],
	"./pl/_lib/formatDistance/index.js": [
		7325,
		7,
		7325
	],
	"./pl/_lib/formatLong/index.js": [
		50807,
		7,
		50807
	],
	"./pl/_lib/formatRelative/index.js": [
		66002,
		7,
		66002
	],
	"./pl/_lib/localize/index.js": [
		12885,
		7,
		12885
	],
	"./pl/_lib/match/index.js": [
		84817,
		7,
		84817
	],
	"./pl/index.js": [
		63618,
		7,
		63618
	],
	"./pt-BR/_lib/formatDistance/index.js": [
		38877,
		7,
		38877
	],
	"./pt-BR/_lib/formatLong/index.js": [
		23903,
		7,
		23903
	],
	"./pt-BR/_lib/formatRelative/index.js": [
		41897,
		7,
		41897
	],
	"./pt-BR/_lib/localize/index.js": [
		78076,
		7,
		78076
	],
	"./pt-BR/_lib/match/index.js": [
		13550,
		7,
		13550
	],
	"./pt-BR/index.js": [
		81333,
		7,
		81333
	],
	"./pt/_lib/formatDistance/index.js": [
		1092,
		7,
		48637
	],
	"./pt/_lib/formatLong/index.js": [
		10063,
		7,
		10063
	],
	"./pt/_lib/formatRelative/index.js": [
		29479,
		7,
		29479
	],
	"./pt/_lib/localize/index.js": [
		81235,
		7,
		81235
	],
	"./pt/_lib/match/index.js": [
		51549,
		7,
		51549
	],
	"./pt/index.js": [
		63086,
		7,
		63086
	],
	"./ro/_lib/formatDistance/index.js": [
		6666,
		7,
		6666
	],
	"./ro/_lib/formatLong/index.js": [
		60333,
		7,
		60333
	],
	"./ro/_lib/formatRelative/index.js": [
		67125,
		7,
		67125
	],
	"./ro/_lib/localize/index.js": [
		39408,
		7,
		39408
	],
	"./ro/_lib/match/index.js": [
		9480,
		7,
		9480
	],
	"./ro/index.js": [
		66088,
		7,
		66088
	],
	"./ru/_lib/formatDistance/index.js": [
		88770,
		7,
		88770
	],
	"./ru/_lib/formatLong/index.js": [
		83233,
		7,
		83233
	],
	"./ru/_lib/formatRelative/index.js": [
		53566,
		7,
		53566
	],
	"./ru/_lib/localize/index.js": [
		81348,
		7,
		81348
	],
	"./ru/_lib/match/index.js": [
		45195,
		7,
		45195
	],
	"./ru/index.js": [
		66754,
		7,
		66754
	],
	"./sk/_lib/formatDistance/index.js": [
		46732,
		7,
		46732
	],
	"./sk/_lib/formatLong/index.js": [
		21831,
		7,
		21831
	],
	"./sk/_lib/formatRelative/index.js": [
		50560,
		7,
		50560
	],
	"./sk/_lib/localize/index.js": [
		31044,
		7,
		31044
	],
	"./sk/_lib/match/index.js": [
		58923,
		7,
		58923
	],
	"./sk/index.js": [
		78259,
		7,
		78259
	],
	"./sl/_lib/formatDistance/index.js": [
		76930,
		7,
		76930
	],
	"./sl/_lib/formatLong/index.js": [
		9273,
		7,
		9273
	],
	"./sl/_lib/formatRelative/index.js": [
		83070,
		7,
		83070
	],
	"./sl/_lib/localize/index.js": [
		42958,
		7,
		42958
	],
	"./sl/_lib/match/index.js": [
		83296,
		7,
		83296
	],
	"./sl/index.js": [
		1139,
		7,
		1139
	],
	"./sq/_lib/formatDistance/index.js": [
		36794,
		7,
		36794
	],
	"./sq/_lib/formatLong/index.js": [
		62624,
		7,
		62624
	],
	"./sq/_lib/formatRelative/index.js": [
		19232,
		7,
		19232
	],
	"./sq/_lib/localize/index.js": [
		76880,
		7,
		76880
	],
	"./sq/_lib/match/index.js": [
		57930,
		7,
		57930
	],
	"./sq/index.js": [
		43852,
		7,
		43852
	],
	"./sr-Latn/_lib/formatDistance/index.js": [
		26261,
		7,
		26261
	],
	"./sr-Latn/_lib/formatLong/index.js": [
		40214,
		7,
		40214
	],
	"./sr-Latn/_lib/formatRelative/index.js": [
		619,
		7,
		619
	],
	"./sr-Latn/_lib/localize/index.js": [
		25494,
		7,
		25494
	],
	"./sr-Latn/_lib/match/index.js": [
		70091,
		7,
		70091
	],
	"./sr-Latn/index.js": [
		62394,
		7,
		62394
	],
	"./sr/_lib/formatDistance/index.js": [
		94963,
		7,
		94963
	],
	"./sr/_lib/formatLong/index.js": [
		9572,
		7,
		9572
	],
	"./sr/_lib/formatRelative/index.js": [
		32195,
		7,
		32195
	],
	"./sr/_lib/localize/index.js": [
		63747,
		7,
		63747
	],
	"./sr/_lib/match/index.js": [
		59555,
		7,
		59555
	],
	"./sr/index.js": [
		32397,
		7,
		32397
	],
	"./sv/_lib/formatDistance/index.js": [
		93283,
		7,
		93283
	],
	"./sv/_lib/formatLong/index.js": [
		45853,
		7,
		45853
	],
	"./sv/_lib/formatRelative/index.js": [
		46304,
		7,
		46304
	],
	"./sv/_lib/localize/index.js": [
		62185,
		7,
		62185
	],
	"./sv/_lib/match/index.js": [
		31379,
		7,
		31379
	],
	"./sv/index.js": [
		29779,
		7,
		29779
	],
	"./ta/_lib/formatDistance/index.js": [
		74639,
		7,
		74639
	],
	"./ta/_lib/formatLong/index.js": [
		83101,
		7,
		83101
	],
	"./ta/_lib/formatRelative/index.js": [
		14179,
		7,
		14179
	],
	"./ta/_lib/localize/index.js": [
		88574,
		7,
		88574
	],
	"./ta/_lib/match/index.js": [
		6042,
		7,
		6042
	],
	"./ta/index.js": [
		32718,
		7,
		32718
	],
	"./te/_lib/formatDistance/index.js": [
		15919,
		7,
		15919
	],
	"./te/_lib/formatLong/index.js": [
		23003,
		7,
		23003
	],
	"./te/_lib/formatRelative/index.js": [
		15927,
		7,
		15927
	],
	"./te/_lib/localize/index.js": [
		28739,
		7,
		28739
	],
	"./te/_lib/match/index.js": [
		46028,
		7,
		46028
	],
	"./te/index.js": [
		52275,
		7,
		52275
	],
	"./th/_lib/formatDistance/index.js": [
		73448,
		7,
		73448
	],
	"./th/_lib/formatLong/index.js": [
		29011,
		7,
		29011
	],
	"./th/_lib/formatRelative/index.js": [
		46945,
		7,
		46945
	],
	"./th/_lib/localize/index.js": [
		44017,
		7,
		44017
	],
	"./th/_lib/match/index.js": [
		65534,
		7,
		65534
	],
	"./th/index.js": [
		98492,
		7,
		98492
	],
	"./tr/_lib/formatDistance/index.js": [
		91742,
		7,
		91742
	],
	"./tr/_lib/formatLong/index.js": [
		66075,
		7,
		66075
	],
	"./tr/_lib/formatRelative/index.js": [
		38897,
		7,
		38897
	],
	"./tr/_lib/localize/index.js": [
		81281,
		7,
		81281
	],
	"./tr/_lib/match/index.js": [
		20941,
		7,
		20941
	],
	"./tr/index.js": [
		41062,
		7,
		41062
	],
	"./ug/_lib/formatDistance/index.js": [
		31914,
		7,
		31914
	],
	"./ug/_lib/formatLong/index.js": [
		70065,
		7,
		70065
	],
	"./ug/_lib/formatRelative/index.js": [
		4128,
		7,
		4128
	],
	"./ug/_lib/localize/index.js": [
		19758,
		7,
		19758
	],
	"./ug/_lib/match/index.js": [
		60663,
		7,
		60663
	],
	"./ug/index.js": [
		61505,
		7,
		61505
	],
	"./uk/_lib/formatDistance/index.js": [
		2647,
		7,
		2647
	],
	"./uk/_lib/formatLong/index.js": [
		71831,
		7,
		71831
	],
	"./uk/_lib/formatRelative/index.js": [
		80507,
		7,
		55827,
		80507
	],
	"./uk/_lib/localize/index.js": [
		31882,
		7,
		31882
	],
	"./uk/_lib/match/index.js": [
		88845,
		7,
		88845
	],
	"./uk/index.js": [
		25490,
		7,
		55827,
		25490
	],
	"./uz-Cyrl/_lib/formatDistance/index.js": [
		59074,
		7,
		59074
	],
	"./uz-Cyrl/_lib/formatLong/index.js": [
		16798,
		7,
		16798
	],
	"./uz-Cyrl/_lib/formatRelative/index.js": [
		65283,
		7,
		65283
	],
	"./uz-Cyrl/_lib/localize/index.js": [
		10755,
		7,
		10755
	],
	"./uz-Cyrl/_lib/match/index.js": [
		56523,
		7,
		56523
	],
	"./uz-Cyrl/index.js": [
		93757,
		7,
		93757
	],
	"./uz/_lib/formatDistance/index.js": [
		55965,
		7,
		55965
	],
	"./uz/_lib/formatLong/index.js": [
		59606,
		7,
		59606
	],
	"./uz/_lib/formatRelative/index.js": [
		81632,
		7,
		81632
	],
	"./uz/_lib/localize/index.js": [
		52970,
		7,
		52970
	],
	"./uz/_lib/match/index.js": [
		29633,
		7,
		29633
	],
	"./uz/index.js": [
		26466,
		7,
		26466
	],
	"./vi/_lib/formatDistance/index.js": [
		72198,
		7,
		72198
	],
	"./vi/_lib/formatLong/index.js": [
		32592,
		7,
		32592
	],
	"./vi/_lib/formatRelative/index.js": [
		20022,
		7,
		20022
	],
	"./vi/_lib/localize/index.js": [
		48125,
		7,
		48125
	],
	"./vi/_lib/match/index.js": [
		8624,
		7,
		8624
	],
	"./vi/index.js": [
		52358,
		7,
		52358
	],
	"./zh-CN/_lib/formatDistance/index.js": [
		31526,
		7,
		31526
	],
	"./zh-CN/_lib/formatLong/index.js": [
		87969,
		7,
		87969
	],
	"./zh-CN/_lib/formatRelative/index.js": [
		6915,
		7,
		6915
	],
	"./zh-CN/_lib/localize/index.js": [
		6890,
		7,
		6890
	],
	"./zh-CN/_lib/match/index.js": [
		95454,
		7,
		95454
	],
	"./zh-CN/index.js": [
		24602,
		7,
		24602
	],
	"./zh-HK/_lib/formatDistance/index.js": [
		84231,
		7,
		84231
	],
	"./zh-HK/_lib/formatLong/index.js": [
		47076,
		7,
		47076
	],
	"./zh-HK/_lib/formatRelative/index.js": [
		53082,
		7,
		53082
	],
	"./zh-HK/_lib/localize/index.js": [
		13653,
		7,
		13653
	],
	"./zh-HK/_lib/match/index.js": [
		88357,
		7,
		88357
	],
	"./zh-HK/index.js": [
		96835,
		7,
		96835
	],
	"./zh-TW/_lib/formatDistance/index.js": [
		63106,
		7,
		63106
	],
	"./zh-TW/_lib/formatLong/index.js": [
		27177,
		7,
		27177
	],
	"./zh-TW/_lib/formatRelative/index.js": [
		13238,
		7,
		13238
	],
	"./zh-TW/_lib/localize/index.js": [
		46341,
		7,
		46341
	],
	"./zh-TW/_lib/match/index.js": [
		7768,
		7,
		7768
	],
	"./zh-TW/index.js": [
		68368,
		7,
		18201
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 71213;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 27484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,function(){"use strict";var t="millisecond",e="second",n="minute",r="hour",i="day",s="week",u="month",a="quarter",o="year",f="date",h=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,c=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,d={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},$=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},l={s:$,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+$(r,2,"0")+":"+$(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,u),s=n-i<0,a=e.clone().add(r+(s?-1:1),u);return+(-(r+(n-i)/(s?i-a:a-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(h){return{M:u,y:o,w:s,d:i,D:f,h:r,m:n,s:e,ms:t,Q:a}[h]||String(h||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},y="en",M={};M[y]=d;var m=function(t){return t instanceof S},D=function(t,e,n){var r;if(!t)return y;if("string"==typeof t)M[t]&&(r=t),e&&(M[t]=e,r=t);else{var i=t.name;M[i]=t,r=i}return!n&&r&&(y=r),r||!n&&y},v=function(t,e){if(m(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new S(n)},g=l;g.l=D,g.i=m,g.w=function(t,e){return v(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var S=function(){function d(t){this.$L=D(t.locale,null,!0),this.parse(t)}var $=d.prototype;return $.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(g.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(h);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},$.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},$.$utils=function(){return g},$.isValid=function(){return!("Invalid Date"===this.$d.toString())},$.isSame=function(t,e){var n=v(t);return this.startOf(e)<=n&&n<=this.endOf(e)},$.isAfter=function(t,e){return v(t)<this.startOf(e)},$.isBefore=function(t,e){return this.endOf(e)<v(t)},$.$g=function(t,e,n){return g.u(t)?this[e]:this.set(n,t)},$.unix=function(){return Math.floor(this.valueOf()/1e3)},$.valueOf=function(){return this.$d.getTime()},$.startOf=function(t,a){var h=this,c=!!g.u(a)||a,d=g.p(t),$=function(t,e){var n=g.w(h.$u?Date.UTC(h.$y,e,t):new Date(h.$y,e,t),h);return c?n:n.endOf(i)},l=function(t,e){return g.w(h.toDate()[t].apply(h.toDate("s"),(c?[0,0,0,0]:[23,59,59,999]).slice(e)),h)},y=this.$W,M=this.$M,m=this.$D,D="set"+(this.$u?"UTC":"");switch(d){case o:return c?$(1,0):$(31,11);case u:return c?$(1,M):$(0,M+1);case s:var v=this.$locale().weekStart||0,S=(y<v?y+7:y)-v;return $(c?m-S:m+(6-S),M);case i:case f:return l(D+"Hours",0);case r:return l(D+"Minutes",1);case n:return l(D+"Seconds",2);case e:return l(D+"Milliseconds",3);default:return this.clone()}},$.endOf=function(t){return this.startOf(t,!1)},$.$set=function(s,a){var h,c=g.p(s),d="set"+(this.$u?"UTC":""),$=(h={},h[i]=d+"Date",h[f]=d+"Date",h[u]=d+"Month",h[o]=d+"FullYear",h[r]=d+"Hours",h[n]=d+"Minutes",h[e]=d+"Seconds",h[t]=d+"Milliseconds",h)[c],l=c===i?this.$D+(a-this.$W):a;if(c===u||c===o){var y=this.clone().set(f,1);y.$d[$](l),y.init(),this.$d=y.set(f,Math.min(this.$D,y.daysInMonth())).$d}else $&&this.$d[$](l);return this.init(),this},$.set=function(t,e){return this.clone().$set(t,e)},$.get=function(t){return this[g.p(t)]()},$.add=function(t,a){var f,h=this;t=Number(t);var c=g.p(a),d=function(e){var n=v(h);return g.w(n.date(n.date()+Math.round(e*t)),h)};if(c===u)return this.set(u,this.$M+t);if(c===o)return this.set(o,this.$y+t);if(c===i)return d(1);if(c===s)return d(7);var $=(f={},f[n]=6e4,f[r]=36e5,f[e]=1e3,f)[c]||1,l=this.$d.getTime()+t*$;return g.w(l,this)},$.subtract=function(t,e){return this.add(-1*t,e)},$.format=function(t){var e=this;if(!this.isValid())return"Invalid Date";var n=t||"YYYY-MM-DDTHH:mm:ssZ",r=g.z(this),i=this.$locale(),s=this.$H,u=this.$m,a=this.$M,o=i.weekdays,f=i.months,h=function(t,r,i,s){return t&&(t[r]||t(e,n))||i[r].substr(0,s)},d=function(t){return g.s(s%12||12,t,"0")},$=i.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:g.s(a+1,2,"0"),MMM:h(i.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:g.s(this.$D,2,"0"),d:String(this.$W),dd:h(i.weekdaysMin,this.$W,o,2),ddd:h(i.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:g.s(s,2,"0"),h:d(1),hh:d(2),a:$(s,u,!0),A:$(s,u,!1),m:String(u),mm:g.s(u,2,"0"),s:String(this.$s),ss:g.s(this.$s,2,"0"),SSS:g.s(this.$ms,3,"0"),Z:r};return n.replace(c,function(t,e){return e||l[t]||r.replace(":","")})},$.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},$.diff=function(t,f,h){var c,d=g.p(f),$=v(t),l=6e4*($.utcOffset()-this.utcOffset()),y=this-$,M=g.m(this,$);return M=(c={},c[o]=M/12,c[u]=M,c[a]=M/3,c[s]=(y-l)/6048e5,c[i]=(y-l)/864e5,c[r]=y/36e5,c[n]=y/6e4,c[e]=y/1e3,c)[d]||y,h?M:g.a(M)},$.daysInMonth=function(){return this.endOf(u).$D},$.$locale=function(){return M[this.$L]},$.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=D(t,e,!0);return r&&(n.$L=r),n},$.clone=function(){return g.w(this.$d,this)},$.toDate=function(){return new Date(this.valueOf())},$.toJSON=function(){return this.isValid()?this.toISOString():null},$.toISOString=function(){return this.$d.toISOString()},$.toString=function(){return this.$d.toUTCString()},d}(),p=S.prototype;return v.prototype=p,[["$ms",t],["$s",e],["$m",n],["$H",r],["$W",i],["$M",u],["$y",o],["$D",f]].forEach(function(t){p[t[1]]=function(e){return this.$g(e,t[0],t[1])}}),v.extend=function(t,e){return t.$i||(t(e,S,v),t.$i=!0),v},v.locale=D,v.isDayjs=m,v.unix=function(t){return v(1e3*t)},v.en=M[y],v.Ls=M,v.p={},v});


/***/ }),

/***/ 40408:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./af": [
		15903,
		15903
	],
	"./af.js": [
		15903,
		15903
	],
	"./am": [
		29911,
		29911
	],
	"./am.js": [
		29911,
		29911
	],
	"./ar": [
		63939,
		63939
	],
	"./ar-dz": [
		47200,
		47200
	],
	"./ar-dz.js": [
		47200,
		47200
	],
	"./ar-kw": [
		62376,
		62376
	],
	"./ar-kw.js": [
		62376,
		62376
	],
	"./ar-ly": [
		48540,
		48540
	],
	"./ar-ly.js": [
		48540,
		48540
	],
	"./ar-ma": [
		96817,
		96817
	],
	"./ar-ma.js": [
		96817,
		96817
	],
	"./ar-sa": [
		11573,
		11573
	],
	"./ar-sa.js": [
		11573,
		11573
	],
	"./ar-tn": [
		99339,
		99339
	],
	"./ar-tn.js": [
		99339,
		99339
	],
	"./ar.js": [
		63939,
		63939
	],
	"./az": [
		88092,
		88092
	],
	"./az.js": [
		88092,
		88092
	],
	"./be": [
		60504,
		60504
	],
	"./be.js": [
		60504,
		60504
	],
	"./bg": [
		19091,
		19091
	],
	"./bg.js": [
		19091,
		19091
	],
	"./bi": [
		19149,
		19149
	],
	"./bi.js": [
		19149,
		19149
	],
	"./bm": [
		15287,
		15287
	],
	"./bm.js": [
		15287,
		15287
	],
	"./bn": [
		54914,
		35254
	],
	"./bn.js": [
		54914,
		35254
	],
	"./bo": [
		52502,
		52502
	],
	"./bo.js": [
		52502,
		52502
	],
	"./br": [
		8864,
		8864
	],
	"./br.js": [
		8864,
		8864
	],
	"./bs": [
		4502,
		4502
	],
	"./bs.js": [
		4502,
		4502
	],
	"./ca": [
		33646,
		33646
	],
	"./ca.js": [
		33646,
		33646
	],
	"./cs": [
		98507,
		98507
	],
	"./cs.js": [
		98507,
		98507
	],
	"./cv": [
		16636,
		16636
	],
	"./cv.js": [
		16636,
		16636
	],
	"./cy": [
		28792,
		28792
	],
	"./cy.js": [
		28792,
		28792
	],
	"./da": [
		17427,
		17427
	],
	"./da.js": [
		17427,
		17427
	],
	"./de": [
		80790,
		80790
	],
	"./de-at": [
		73237,
		73237
	],
	"./de-at.js": [
		73237,
		73237
	],
	"./de-ch": [
		16148,
		16148
	],
	"./de-ch.js": [
		16148,
		16148
	],
	"./de.js": [
		80790,
		80790
	],
	"./dv": [
		11794,
		11794
	],
	"./dv.js": [
		11794,
		11794
	],
	"./el": [
		65423,
		65423
	],
	"./el.js": [
		65423,
		65423
	],
	"./en": [
		25054,
		25054
	],
	"./en-au": [
		85109,
		85109
	],
	"./en-au.js": [
		85109,
		85109
	],
	"./en-ca": [
		55105,
		55105
	],
	"./en-ca.js": [
		55105,
		55105
	],
	"./en-gb": [
		99517,
		99517
	],
	"./en-gb.js": [
		99517,
		99517
	],
	"./en-ie": [
		30758,
		30758
	],
	"./en-ie.js": [
		30758,
		30758
	],
	"./en-il": [
		95805,
		95805
	],
	"./en-il.js": [
		95805,
		95805
	],
	"./en-in": [
		88529,
		88529
	],
	"./en-in.js": [
		88529,
		88529
	],
	"./en-nz": [
		50302,
		50302
	],
	"./en-nz.js": [
		50302,
		50302
	],
	"./en-sg": [
		35941,
		35941
	],
	"./en-sg.js": [
		35941,
		35941
	],
	"./en-tt": [
		46183,
		46183
	],
	"./en-tt.js": [
		46183,
		46183
	],
	"./en.js": [
		25054,
		25054
	],
	"./eo": [
		74990,
		74990
	],
	"./eo.js": [
		74990,
		74990
	],
	"./es": [
		67763,
		67763
	],
	"./es-do": [
		3864,
		3864
	],
	"./es-do.js": [
		3864,
		3864
	],
	"./es-pr": [
		23521,
		23521
	],
	"./es-pr.js": [
		23521,
		23521
	],
	"./es-us": [
		36165,
		36165
	],
	"./es-us.js": [
		36165,
		36165
	],
	"./es.js": [
		67763,
		67763
	],
	"./et": [
		99670,
		99670
	],
	"./et.js": [
		99670,
		99670
	],
	"./eu": [
		46629,
		46629
	],
	"./eu.js": [
		46629,
		46629
	],
	"./fa": [
		96953,
		96953
	],
	"./fa.js": [
		96953,
		96953
	],
	"./fi": [
		47822,
		47822
	],
	"./fi.js": [
		47822,
		47822
	],
	"./fo": [
		69197,
		69197
	],
	"./fo.js": [
		69197,
		69197
	],
	"./fr": [
		96023,
		96023
	],
	"./fr-ca": [
		77989,
		77989
	],
	"./fr-ca.js": [
		77989,
		77989
	],
	"./fr-ch": [
		54254,
		54254
	],
	"./fr-ch.js": [
		54254,
		54254
	],
	"./fr.js": [
		96023,
		96023
	],
	"./fy": [
		93220,
		93220
	],
	"./fy.js": [
		93220,
		93220
	],
	"./ga": [
		47467,
		47467
	],
	"./ga.js": [
		47467,
		47467
	],
	"./gd": [
		54855,
		54855
	],
	"./gd.js": [
		54855,
		54855
	],
	"./gl": [
		90229,
		90229
	],
	"./gl.js": [
		90229,
		90229
	],
	"./gom-latn": [
		46312,
		46312
	],
	"./gom-latn.js": [
		46312,
		46312
	],
	"./gu": [
		87632,
		87632
	],
	"./gu.js": [
		87632,
		87632
	],
	"./he": [
		45418,
		45418
	],
	"./he.js": [
		45418,
		45418
	],
	"./hi": [
		77573,
		77573
	],
	"./hi.js": [
		77573,
		77573
	],
	"./hr": [
		96257,
		96257
	],
	"./hr.js": [
		96257,
		96257
	],
	"./ht": [
		98889,
		98889
	],
	"./ht.js": [
		98889,
		98889
	],
	"./hu": [
		68562,
		68562
	],
	"./hu.js": [
		68562,
		68562
	],
	"./hy-am": [
		38242,
		38242
	],
	"./hy-am.js": [
		38242,
		38242
	],
	"./id": [
		83783,
		83783
	],
	"./id.js": [
		83783,
		83783
	],
	"./index.d": [
		52856,
		86326
	],
	"./index.d.ts": [
		52856,
		86326
	],
	"./is": [
		98980,
		98980
	],
	"./is.js": [
		98980,
		98980
	],
	"./it": [
		41929,
		15551
	],
	"./it-ch": [
		83706,
		83706
	],
	"./it-ch.js": [
		83706,
		83706
	],
	"./it.js": [
		41929,
		15551
	],
	"./ja": [
		76831,
		76831
	],
	"./ja.js": [
		76831,
		76831
	],
	"./jv": [
		42641,
		42641
	],
	"./jv.js": [
		42641,
		42641
	],
	"./ka": [
		46622,
		46622
	],
	"./ka.js": [
		46622,
		46622
	],
	"./kk": [
		32921,
		32921
	],
	"./kk.js": [
		32921,
		32921
	],
	"./km": [
		45567,
		45567
	],
	"./km.js": [
		45567,
		45567
	],
	"./kn": [
		21113,
		21113
	],
	"./kn.js": [
		21113,
		21113
	],
	"./ko": [
		19132,
		19132
	],
	"./ko.js": [
		19132,
		19132
	],
	"./ku": [
		94888,
		94888
	],
	"./ku.js": [
		94888,
		94888
	],
	"./ky": [
		60466,
		60466
	],
	"./ky.js": [
		60466,
		60466
	],
	"./lb": [
		91796,
		91796
	],
	"./lb.js": [
		91796,
		91796
	],
	"./lo": [
		68894,
		68894
	],
	"./lo.js": [
		68894,
		68894
	],
	"./lt": [
		78768,
		78768
	],
	"./lt.js": [
		78768,
		78768
	],
	"./lv": [
		30953,
		30953
	],
	"./lv.js": [
		30953,
		30953
	],
	"./me": [
		18066,
		18066
	],
	"./me.js": [
		18066,
		18066
	],
	"./mi": [
		68602,
		68602
	],
	"./mi.js": [
		68602,
		68602
	],
	"./mk": [
		51560,
		51560
	],
	"./mk.js": [
		51560,
		51560
	],
	"./ml": [
		4017,
		4017
	],
	"./ml.js": [
		4017,
		4017
	],
	"./mn": [
		94717,
		94717
	],
	"./mn.js": [
		94717,
		94717
	],
	"./mr": [
		15473,
		15473
	],
	"./mr.js": [
		15473,
		15473
	],
	"./ms": [
		5742,
		5742
	],
	"./ms-my": [
		77387,
		77387
	],
	"./ms-my.js": [
		77387,
		77387
	],
	"./ms.js": [
		5742,
		5742
	],
	"./mt": [
		28477,
		28477
	],
	"./mt.js": [
		28477,
		28477
	],
	"./my": [
		62966,
		62966
	],
	"./my.js": [
		62966,
		62966
	],
	"./nb": [
		19682,
		19682
	],
	"./nb.js": [
		19682,
		19682
	],
	"./ne": [
		14149,
		14149
	],
	"./ne.js": [
		14149,
		14149
	],
	"./nl": [
		99182,
		99182
	],
	"./nl-be": [
		37496,
		37496
	],
	"./nl-be.js": [
		37496,
		37496
	],
	"./nl.js": [
		99182,
		99182
	],
	"./nn": [
		92722,
		92722
	],
	"./nn.js": [
		92722,
		92722
	],
	"./oc-lnc": [
		76159,
		76159
	],
	"./oc-lnc.js": [
		76159,
		76159
	],
	"./pa-in": [
		35914,
		35914
	],
	"./pa-in.js": [
		35914,
		35914
	],
	"./pl": [
		81987,
		81987
	],
	"./pl.js": [
		81987,
		81987
	],
	"./pt": [
		15001,
		15001
	],
	"./pt-br": [
		57548,
		57548
	],
	"./pt-br.js": [
		57548,
		57548
	],
	"./pt.js": [
		15001,
		15001
	],
	"./ro": [
		18146,
		18146
	],
	"./ro.js": [
		18146,
		18146
	],
	"./ru": [
		70600,
		70600
	],
	"./ru.js": [
		70600,
		70600
	],
	"./rw": [
		6509,
		6509
	],
	"./rw.js": [
		6509,
		6509
	],
	"./sd": [
		65437,
		65437
	],
	"./sd.js": [
		65437,
		65437
	],
	"./se": [
		772,
		772
	],
	"./se.js": [
		772,
		772
	],
	"./si": [
		77109,
		77109
	],
	"./si.js": [
		77109,
		77109
	],
	"./sk": [
		35627,
		35627
	],
	"./sk.js": [
		35627,
		35627
	],
	"./sl": [
		82544,
		82544
	],
	"./sl.js": [
		82544,
		82544
	],
	"./sq": [
		88341,
		88341
	],
	"./sq.js": [
		88341,
		88341
	],
	"./sr": [
		50617,
		50617
	],
	"./sr-cyrl": [
		37101,
		37101
	],
	"./sr-cyrl.js": [
		37101,
		37101
	],
	"./sr.js": [
		50617,
		50617
	],
	"./ss": [
		64127,
		64127
	],
	"./ss.js": [
		64127,
		64127
	],
	"./sv": [
		4853,
		91876
	],
	"./sv.js": [
		4853,
		91876
	],
	"./sw": [
		46148,
		46148
	],
	"./sw.js": [
		46148,
		46148
	],
	"./ta": [
		55596,
		55596
	],
	"./ta.js": [
		55596,
		55596
	],
	"./te": [
		45159,
		45159
	],
	"./te.js": [
		45159,
		45159
	],
	"./tet": [
		99157,
		99157
	],
	"./tet.js": [
		99157,
		99157
	],
	"./tg": [
		9928,
		9928
	],
	"./tg.js": [
		9928,
		9928
	],
	"./th": [
		62019,
		62019
	],
	"./th.js": [
		62019,
		62019
	],
	"./tk": [
		75817,
		75817
	],
	"./tk.js": [
		75817,
		75817
	],
	"./tl-ph": [
		46513,
		46513
	],
	"./tl-ph.js": [
		46513,
		46513
	],
	"./tlh": [
		97296,
		97296
	],
	"./tlh.js": [
		97296,
		97296
	],
	"./tr": [
		73035,
		73035
	],
	"./tr.js": [
		73035,
		73035
	],
	"./types.d": [
		57685,
		57685
	],
	"./types.d.ts": [
		57685,
		57685
	],
	"./tzl": [
		57797,
		57797
	],
	"./tzl.js": [
		57797,
		57797
	],
	"./tzm": [
		84722,
		84722
	],
	"./tzm-latn": [
		30261,
		30261
	],
	"./tzm-latn.js": [
		30261,
		30261
	],
	"./tzm.js": [
		84722,
		84722
	],
	"./ug-cn": [
		80313,
		80313
	],
	"./ug-cn.js": [
		80313,
		80313
	],
	"./uk": [
		64144,
		64144
	],
	"./uk.js": [
		64144,
		64144
	],
	"./ur": [
		92957,
		92957
	],
	"./ur.js": [
		92957,
		92957
	],
	"./uz": [
		7486,
		7486
	],
	"./uz-latn": [
		98727,
		98727
	],
	"./uz-latn.js": [
		98727,
		98727
	],
	"./uz.js": [
		7486,
		7486
	],
	"./vi": [
		37553,
		37553
	],
	"./vi.js": [
		37553,
		37553
	],
	"./x-pseudo": [
		55321,
		55321
	],
	"./x-pseudo.js": [
		55321,
		55321
	],
	"./yo": [
		14724,
		14724
	],
	"./yo.js": [
		14724,
		14724
	],
	"./zh": [
		32009,
		32009
	],
	"./zh-cn": [
		33852,
		33852
	],
	"./zh-cn.js": [
		33852,
		33852
	],
	"./zh-hk": [
		2390,
		2390
	],
	"./zh-hk.js": [
		2390,
		2390
	],
	"./zh-tw": [
		43901,
		43901
	],
	"./zh-tw.js": [
		43901,
		43901
	],
	"./zh.js": [
		32009,
		32009
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 40408;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 10285:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,function(){"use strict";var t={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},e=function(e,n){return e.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,function(e,r,i){var o=i&&i.toUpperCase();return r||n[i]||t[i]||n[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,function(t,e,n){return e||n.slice(1)})})},n=/(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,r=/\d\d/,i=/\d\d?/,o=/\d*[^\s\d-_:/()]+/,s={};var a=function(t){return function(e){this[t]=+e}},f=[/[+-]\d\d:?(\d\d)?/,function(t){(this.zone||(this.zone={})).offset=function(t){if(!t)return 0;var e=t.match(/([+-]|\d\d)/g),n=60*e[1]+(+e[2]||0);return 0===n?0:"+"===e[0]?-n:n}(t)}],u=function(t){var e=s[t];return e&&(e.indexOf?e:e.s.concat(e.f))},h=function(t,e){var n,r=s.meridiem;if(r){for(var i=1;i<=24;i+=1)if(t.indexOf(r(i,0,e))>-1){n=i>12;break}}else n=t===(e?"pm":"PM");return n},d={A:[o,function(t){this.afternoon=h(t,!1)}],a:[o,function(t){this.afternoon=h(t,!0)}],S:[/\d/,function(t){this.milliseconds=100*+t}],SS:[r,function(t){this.milliseconds=10*+t}],SSS:[/\d{3}/,function(t){this.milliseconds=+t}],s:[i,a("seconds")],ss:[i,a("seconds")],m:[i,a("minutes")],mm:[i,a("minutes")],H:[i,a("hours")],h:[i,a("hours")],HH:[i,a("hours")],hh:[i,a("hours")],D:[i,a("day")],DD:[r,a("day")],Do:[o,function(t){var e=s.ordinal,n=t.match(/\d+/);if(this.day=n[0],e)for(var r=1;r<=31;r+=1)e(r).replace(/\[|\]/g,"")===t&&(this.day=r)}],M:[i,a("month")],MM:[r,a("month")],MMM:[o,function(t){var e=u("months"),n=(u("monthsShort")||e.map(function(t){return t.substr(0,3)})).indexOf(t)+1;if(n<1)throw new Error;this.month=n%12||n}],MMMM:[o,function(t){var e=u("months").indexOf(t)+1;if(e<1)throw new Error;this.month=e%12||e}],Y:[/[+-]?\d+/,a("year")],YY:[r,function(t){t=+t,this.year=t+(t>68?1900:2e3)}],YYYY:[/\d{4}/,a("year")],Z:f,ZZ:f};var c=function(t,r,i){try{var o=function(t){for(var r=(t=e(t,s&&s.formats)).match(n),i=r.length,o=0;o<i;o+=1){var a=r[o],f=d[a],u=f&&f[0],h=f&&f[1];r[o]=h?{regex:u,parser:h}:a.replace(/^\[|\]$/g,"")}return function(t){for(var e={},n=0,o=0;n<i;n+=1){var s=r[n];if("string"==typeof s)o+=s.length;else{var a=s.regex,f=s.parser,u=t.substr(o),h=a.exec(u)[0];f.call(e,h),t=t.replace(h,"")}}return function(t){var e=t.afternoon;if(void 0!==e){var n=t.hours;e?n<12&&(t.hours+=12):12===n&&(t.hours=0),delete t.afternoon}}(e),e}}(r)(t),a=o.year,f=o.month,u=o.day,h=o.hours,c=o.minutes,m=o.seconds,l=o.milliseconds,M=o.zone,Y=new Date,v=u||(a||f?1:Y.getDate()),p=a||Y.getFullYear(),D=0;a&&!f||(D=f>0?f-1:Y.getMonth());var y=h||0,L=c||0,g=m||0,$=l||0;return M?new Date(Date.UTC(p,D,v,y,L,g,$+60*M.offset*1e3)):i?new Date(Date.UTC(p,D,v,y,L,g,$)):new Date(p,D,v,y,L,g,$)}catch(t){return new Date("")}};return function(t,e,n){n.p.customParseFormat=!0;var r=e.prototype,i=r.parse;r.parse=function(t){var e=t.date,r=t.utc,o=t.args;this.$u=r;var a=o[1];if("string"==typeof a){var f=!0===o[2],u=!0===o[3],h=f||u,d=o[2];u&&(d=o[2]),s=this.$locale(),!f&&d&&(s=n.Ls[d]),this.$d=c(e,a,r),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),h&&e!==this.format(a)&&(this.$d=new Date("")),s={}}else if(a instanceof Array)for(var m=a.length,l=1;l<=m;l+=1){o[1]=a[l-1];var M=n.apply(this,o);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}l===m&&(this.$d=new Date(""))}else i.call(this,t)}}});


/***/ }),

/***/ 56176:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,function(){"use strict";var e={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"};return function(t,n,o){var r=n.prototype,M=r.format;o.en.formats=e,r.format=function(t){void 0===t&&(t="YYYY-MM-DDTHH:mm:ssZ");var n=this.$locale().formats,o=function(t,n){return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,function(t,o,r){var M=r&&r.toUpperCase();return o||n[r]||e[r]||n[M].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,function(e,t,n){return t||n.slice(1)})})}(t,void 0===n?{}:n);return M.call(this,o)}}});


/***/ }),

/***/ 47815:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return __webpack_require__.g[key] = (__webpack_require__.g[key] || 0) + 1;
};


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 3745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_i18next; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread.js

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    });
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
;// CONCATENATED MODULE: ./node_modules/i18next/dist/esm/i18next.js









var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Logger);

    this.init(concreteLogger, options);
  }

  (0,createClass/* default */.Z)(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    (0,classCallCheck/* default */.Z)(this, EventEmitter);

    this.observers = {};
  }

  (0,createClass/* default */.Z)(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

var ResourceStore = function (_EventEmitter) {
  (0,inherits/* default */.Z)(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    (0,classCallCheck/* default */.Z)(this, ResourceStore);

    _this = (0,possibleConstructorReturn/* default */.Z)(this, (0,getPrototypeOf/* default */.Z)(ResourceStore).call(this));

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    return _this;
  }

  (0,createClass/* default */.Z)(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      return getPath(this.data, path);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Translator);

    _this = (0,possibleConstructorReturn/* default */.Z)(this, (0,getPrototypeOf/* default */.Z)(Translator).call(this));

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, (0,assertThisInitialized/* default */.Z)(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  (0,createClass/* default */.Z)(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if ((0,esm_typeof/* default */.Z)(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;

        if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
          usedDefault = true;

          if (options.count !== undefined) {
            var suffix = this.pluralResolver.getSuffix(lng, options.count);
            res = options["defaultValue".concat(suffix)];
          }

          if (!res) res = options.defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread({}, options, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (l) {
                var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

                plurals.forEach(function (p) {
                  return send([l], p);
                });
              });
            } else {
              send(lngs, key);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread({}, options, {
          interpolation: _objectSpread({}, this.options.interpolation, options.interpolation)
        }));
        var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    (0,classCallCheck/* default */.Z)(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.supportedLngs || false;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  (0,createClass/* default */.Z)(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
      return this.isSupportedCode(code);
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  (0,createClass/* default */.Z)(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var _this = this;

      var ret = [];
      var rule = this.getRule(code);
      if (!rule) return ret;
      rule.numbers.forEach(function (n) {
        var suffix = _this.getSuffix(code, n);

        ret.push("".concat(key).concat(suffix));
      });
      return ret;
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        };

        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  (0,createClass/* default */.Z)(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, options);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          value = handleFormat(match[1].trim());

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          str = str.replace(match[0], todo.safeValue(value));
          todo.regex.lastIndex = 0;
          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, options);
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    (0,classCallCheck/* default */.Z)(this, Connector);

    _this = (0,possibleConstructorReturn/* default */.Z)(this, (0,getPrototypeOf/* default */.Z)(Connector).call(this));

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread({}, options, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    whitelist: false,
    nonExplicitWhitelist: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if ((0,esm_typeof/* default */.Z)(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if ((0,esm_typeof/* default */.Z)(args[2]) === 'object' || (0,esm_typeof/* default */.Z)(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: false
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.whitelist) {
    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
      options.whitelist = options.whitelist.concat(['cimode']);
    }

    options.supportedLngs = options.whitelist;
  }

  if (options.nonExplicitWhitelist) {
    options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
  }

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function noop() {}

var I18n = function (_EventEmitter) {
  (0,inherits/* default */.Z)(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    (0,classCallCheck/* default */.Z)(this, I18n);

    _this = (0,possibleConstructorReturn/* default */.Z)(this, (0,getPrototypeOf/* default */.Z)(I18n).call(this));

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return (0,possibleConstructorReturn/* default */.Z)(_this, (0,assertThisInitialized/* default */.Z)(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (options.whitelist && !options.supportedLngs) {
        this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
      }

      if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) {
        this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
      }

      this.options = _objectSpread({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        _this2.changeLanguage(_this2.options.lng, function (err, t) {
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        });
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if ((0,esm_typeof/* default */.Z)(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

/* harmony default export */ var esm_i18next = (i18next);


/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 1742:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(67294)) :
  0;
}(this, (function (exports, React) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function createCommonjsModule(fn, basedir, module) {
  	return module = {
  		path: basedir,
  		exports: {},
  		require: function (path, base) {
  			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
  		}
  	}, fn(module, module.exports), module.exports;
  }

  function commonjsRequire () {
  	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
  }

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  var ReactPropTypesSecret_1 = ReactPropTypesSecret;

  function emptyFunction() {}

  function emptyFunctionWithReset() {}

  emptyFunctionWithReset.resetWarningCache = emptyFunction;

  var factoryWithThrowingShims = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret_1) {
        // It is still safe when called from React.
        return;
      }

      var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
      err.name = 'Invariant Violation';
      throw err;
    }
    shim.isRequired = shim;

    function getShim() {
      return shim;
    }
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };

  var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
  });

  function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$1(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys$1(Object(source), true).forEach(function (key) {
          _defineProperty$1(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$1(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  var version = "1.4.3";
  var errorMessages = {
    MANDATORY_INITIALIZATION_MISSING: {
      message: "Missing urlEndpoint during SDK initialization",
      help: ""
    },
    INVALID_TRANSFORMATION_POSITION: {
      message: "Invalid transformationPosition parameter",
      help: ""
    },
    PRIVATE_KEY_CLIENT_SIDE: {
      message: "privateKey should not be passed on the client side",
      help: ""
    },
    MISSING_UPLOAD_DATA: {
      message: "Missing data for upload",
      help: ""
    },
    MISSING_UPLOAD_FILE_PARAMETER: {
      message: "Missing file parameter for upload",
      help: ""
    },
    MISSING_UPLOAD_FILENAME_PARAMETER: {
      message: "Missing fileName parameter for upload",
      help: ""
    },
    MISSING_AUTHENTICATION_ENDPOINT: {
      message: "Missing authentication endpoint for upload",
      help: ""
    },
    MISSING_PUBLIC_KEY: {
      message: "Missing public key for upload",
      help: ""
    },
    AUTH_ENDPOINT_TIMEOUT: {
      message: "The authenticationEndpoint you provided timed out in 60 seconds",
      help: ""
    },
    AUTH_ENDPOINT_NETWORK_ERROR: {
      message: "Request to authenticationEndpoint failed due to network error",
      help: ""
    },
    UPLOAD_ENDPOINT_NETWORK_ERROR: {
      message: "Request to ImageKit upload endpoint failed due to network error",
      help: ""
    },
    INVALID_UPLOAD_OPTIONS: {
      message: "Invalid uploadOptions parameter",
      help: ""
    }
  };

  function respond(isError, response, callback) {
    if (typeof callback == "function") {
      if (isError) {
        callback(response, null);
      } else {
        callback(null, response);
      }
    }
  }

  var request = function request(formData, options, callback) {
    generateSignatureToken(options, function (err, signaturObj) {
      if (err) {
        return respond(true, err, callback);
      } else {
        formData.append("signature", (signaturObj === null || signaturObj === void 0 ? void 0 : signaturObj.signature) || "");
        formData.append("expire", String((signaturObj === null || signaturObj === void 0 ? void 0 : signaturObj.expire) || 0));
        formData.append("token", (signaturObj === null || signaturObj === void 0 ? void 0 : signaturObj.token) || "");
        uploadFile(formData, function (err, responseSucessText) {
          if (err) {
            return respond(true, err, callback);
          }

          return respond(false, responseSucessText, callback);
        });
      }
    });
  };

  var generateSignatureToken = function generateSignatureToken(options, callback) {
    var xhr = new XMLHttpRequest();
    xhr.timeout = 60000;
    xhr.open('GET', options.authenticationEndpoint);

    xhr.ontimeout = function (e) {
      respond(true, errorMessages.AUTH_ENDPOINT_TIMEOUT, callback);
    };

    xhr.onerror = function () {
      respond(true, errorMessages.AUTH_ENDPOINT_NETWORK_ERROR, callback);
    };

    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          var body = JSON.parse(xhr.responseText);
          var obj = {
            signature: body.signature,
            expire: body.expire,
            token: body.token
          };
          respond(false, obj, callback);
        } catch (ex) {
          respond(true, ex, callback);
        }
      } else {
        try {
          var error = JSON.parse(xhr.responseText);
          respond(true, error, callback);
        } catch (ex) {
          respond(true, ex, callback);
        }
      }
    };

    xhr.send();
    return;
  };

  var uploadFile = function uploadFile(formData, callback) {
    var uploadFileXHR = new XMLHttpRequest();
    uploadFileXHR.open('POST', 'https://upload.imagekit.io/api/v1/files/upload');

    uploadFileXHR.onerror = function () {
      respond(true, errorMessages.UPLOAD_ENDPOINT_NETWORK_ERROR, callback);
      return;
    };

    uploadFileXHR.onload = function () {
      if (uploadFileXHR.status === 200) {
        var uploadResponse = JSON.parse(uploadFileXHR.responseText);
        callback(null, uploadResponse);
      } else if (uploadFileXHR.status !== 200) {
        try {
          callback(JSON.parse(uploadFileXHR.responseText), null);
        } catch (ex) {
          callback(ex, null);
        }
      }
    };

    uploadFileXHR.send(formData);
    return;
  };

  var upload = function upload(uploadOptions, options, callback) {
    if (!uploadOptions) {
      respond(true, errorMessages.INVALID_UPLOAD_OPTIONS, callback);
      return;
    }

    if (!uploadOptions.file) {
      respond(true, errorMessages.MISSING_UPLOAD_FILE_PARAMETER, callback);
      return;
    }

    if (!uploadOptions.fileName) {
      respond(true, errorMessages.MISSING_UPLOAD_FILENAME_PARAMETER, callback);
      return;
    }

    if (!options.authenticationEndpoint) {
      respond(true, errorMessages.MISSING_AUTHENTICATION_ENDPOINT, callback);
      return;
    }

    if (!options.publicKey) {
      respond(true, errorMessages.MISSING_PUBLIC_KEY, callback);
      return;
    }

    if (uploadOptions.tags && Array.isArray(uploadOptions.tags)) {
      uploadOptions.tags = String(uploadOptions.tags);
    }

    var formData = new FormData();
    var i;

    for (i in uploadOptions) {
      var param = uploadOptions[i];

      if (typeof param !== "undefined") {
        if (typeof param === "string" || typeof param === "boolean") {
          formData.append(i, String(param));
        } else if (Array.isArray(param)) {
          formData.append(i, JSON.stringify(param));
        } else {
          formData.append(i, param);
        }
      }
    }

    formData.append("publicKey", options.publicKey);
    request(formData, _objectSpread2$1(_objectSpread2$1({}, options), {}, {
      authenticationEndpoint: options.authenticationEndpoint
    }), callback);
  };

  var supportedTransforms = {
    width: "w",
    height: "h",
    aspectRatio: "ar",
    quality: "q",
    crop: "c",
    cropMode: "cm",
    focus: "fo",
    x: "x",
    y: "y",
    format: "f",
    radius: "r",
    background: "bg",
    border: "b",
    rotation: "rt",
    rotate: "rt",
    blur: "bl",
    named: "n",
    overlayImage: "oi",
    overlayImageAspectRatio: "oiar",
    overlayImageBackground: "oibg",
    overlayImageBorder: "oib",
    overlayImageDPR: "oidpr",
    overlayImageQuality: "oiq",
    overlayImageCropping: "oic",
    overlayImageTrim: "oit",
    overlayX: "ox",
    overlayY: "oy",
    overlayFocus: "ofo",
    overlayHeight: "oh",
    overlayWidth: "ow",
    overlayText: "ot",
    overlayTextFontSize: "ots",
    overlayTextFontFamily: "otf",
    overlayTextColor: "otc",
    overlayTextTransparency: "oa",
    overlayAlpha: "oa",
    overlayTextTypography: "ott",
    overlayBackground: "obg",
    overlayTextEncoded: "ote",
    overlayTextWidth: "otw",
    overlayTextBackground: "otbg",
    overlayTextPadding: "otp",
    overlayTextInnerAlignment: "otia",
    overlayRadius: "or",
    progressive: "pr",
    lossless: "lo",
    trim: "t",
    metadata: "md",
    colorProfile: "cp",
    defaultImage: "di",
    dpr: "dpr",
    effectSharpen: "e-sharpen",
    effectUSM: "e-usm",
    effectContrast: "e-contrast",
    effectGray: "e-grayscale",
    original: "orig"
  };
  var DEFAULT_TRANSFORMATION_POSITION = "path";
  var QUERY_TRANSFORMATION_POSITION = "query";
  var VALID_TRANSFORMATION_POSITIONS = [DEFAULT_TRANSFORMATION_POSITION, QUERY_TRANSFORMATION_POSITION];
  var CHAIN_TRANSFORM_DELIMITER = ":";
  var TRANSFORM_DELIMITER = ",";
  var TRANSFORM_KEY_VALUE_DELIMITER = "-";
  var transformationUtils = {
    getDefault: function getDefault() {
      return DEFAULT_TRANSFORMATION_POSITION;
    },
    addAsQueryParameter: function addAsQueryParameter(options) {
      return options.transformationPosition === QUERY_TRANSFORMATION_POSITION;
    },
    validParameters: function validParameters(options) {
      if (typeof options.transformationPosition == "undefined") return false;
      return VALID_TRANSFORMATION_POSITIONS.indexOf(options.transformationPosition) != -1;
    },
    getTransformKey: function getTransformKey(transform) {
      if (!transform) {
        return "";
      }

      return supportedTransforms[transform] || supportedTransforms[transform.toLowerCase()] || "";
    },
    getChainTransformDelimiter: function getChainTransformDelimiter() {
      return CHAIN_TRANSFORM_DELIMITER;
    },
    getTransformDelimiter: function getTransformDelimiter() {
      return TRANSFORM_DELIMITER;
    },
    getTransformKeyValueDelimiter: function getTransformKeyValueDelimiter() {
      return TRANSFORM_KEY_VALUE_DELIMITER;
    }
  };
  var TRANSFORMATION_PARAMETER = "tr";

  function removeTrailingSlash(str) {
    if (typeof str == "string" && str[str.length - 1] == "/") {
      str = str.substring(0, str.length - 1);
    }

    return str;
  }

  function removeLeadingSlash(str) {
    if (typeof str == "string" && str[0] == "/") {
      str = str.slice(1);
    }

    return str;
  }

  function pathJoin(parts, sep) {
    var separator = sep || "/";
    var replace = new RegExp(separator + "{1,}", "g");
    return parts.join(separator).replace(replace, separator);
  }

  var buildURL = function buildURL(opts) {
    if (!opts.path && !opts.src) {
      return "";
    }

    var urlObj, isSrcParameterUsedForURL, urlEndpointPattern;

    try {
      if (opts.path) {
        urlEndpointPattern = new URL(opts.urlEndpoint).pathname;
        urlObj = new URL(pathJoin([opts.urlEndpoint.replace(urlEndpointPattern, ""), opts.path]));
      } else {
        urlObj = new URL(opts.src);
        isSrcParameterUsedForURL = true;
      }
    } catch (e) {
      console.error(e);
      return "";
    }

    if (opts.sdkVersion && opts.sdkVersion.trim() != "") {
      urlObj.searchParams.append("ik-sdk-version", opts.sdkVersion.trim());
    }

    for (var i in opts.queryParameters) {
      urlObj.searchParams.append(i, String(opts.queryParameters[i]));
    }

    var transformationString = constructTransformationString(opts.transformation);

    if (transformationString && transformationString.length) {
      if (transformationUtils.addAsQueryParameter(opts) || isSrcParameterUsedForURL) {
        urlObj.searchParams.append(TRANSFORMATION_PARAMETER, transformationString);
      } else {
        urlObj.pathname = pathJoin([TRANSFORMATION_PARAMETER + transformationUtils.getChainTransformDelimiter() + transformationString, urlObj.pathname]);
      }
    }

    if (urlEndpointPattern) {
      urlObj.pathname = pathJoin([urlEndpointPattern, urlObj.pathname]);
    } else {
      urlObj.pathname = pathJoin([urlObj.pathname]);
    }

    return urlObj.href;
  };

  function constructTransformationString(transformation) {
    if (!Array.isArray(transformation)) {
      return "";
    }

    var parsedTransforms = [];

    for (var i = 0, l = transformation.length; i < l; i++) {
      var parsedTransformStep = [];

      for (var key in transformation[i]) {
        var transformKey = transformationUtils.getTransformKey(key);

        if (!transformKey) {
          transformKey = key;
        }

        if (transformation[i][key] === "-") {
          parsedTransformStep.push(transformKey);
        } else if (key === "raw") {
          parsedTransformStep.push(transformation[i][key]);
        } else {
          var value = transformation[i][key];

          if (transformKey === "oi" || transformKey === "di") {
            value = removeTrailingSlash(removeLeadingSlash(value || ""));
            value = value.replace(/\//g, "@@");
          }

          parsedTransformStep.push([transformKey, value].join(transformationUtils.getTransformKeyValueDelimiter()));
        }
      }

      parsedTransforms.push(parsedTransformStep.join(transformationUtils.getTransformDelimiter()));
    }

    return parsedTransforms.join(transformationUtils.getChainTransformDelimiter());
  }

  var url = function url(urlOpts, defaultOptions) {
    return buildURL(_objectSpread2$1(_objectSpread2$1({}, defaultOptions), urlOpts));
  };

  function mandatoryParametersAvailable(options) {
    return options.urlEndpoint;
  }

  function privateKeyPassed(options) {
    return typeof options.privateKey != "undefined";
  }

  var ImageKit = function () {
    function ImageKit(opts) {
      _classCallCheck$1(this, ImageKit);

      _defineProperty$1(this, "options", {
        sdkVersion: "javascript-".concat(version),
        publicKey: "",
        urlEndpoint: "",
        transformationPosition: transformationUtils.getDefault()
      });

      this.options = _objectSpread2$1(_objectSpread2$1({}, this.options), opts || {});

      if (!mandatoryParametersAvailable(this.options)) {
        throw errorMessages.MANDATORY_INITIALIZATION_MISSING;
      }

      if (privateKeyPassed(this.options)) {
        throw errorMessages.PRIVATE_KEY_CLIENT_SIDE;
      }

      if (!transformationUtils.validParameters(this.options)) {
        throw errorMessages.INVALID_TRANSFORMATION_POSITION;
      }
    }

    _createClass$1(ImageKit, [{
      key: "url",
      value: function url$1(urlOptions) {
        return url(urlOptions, this.options);
      }
    }, {
      key: "upload",
      value: function upload$1(uploadOptions, callback, options) {
        var mergedOptions = _objectSpread2$1(_objectSpread2$1({}, this.options), options);

        return upload(uploadOptions, mergedOptions, callback);
      }
    }]);

    return ImageKit;
  }();

  var ImageKitContextType = /*#__PURE__*/React.createContext();

  var name = "imagekitio-react";
  var version$1 = "1.1.0";
  var description = "React SDK for ImageKit.io which implements client-side upload and URL generation for use inside a react application.";
  var scripts = {
  	build: "rm -rf dist*;rollup -c",
  	test: "jest",
  	"test:ci": "jest --coverage && codecov",
  	"test:cov": "jest --coverage",
  	"test:e2e": "cypress open",
  	"test:watch": "jest --watch",
  	"serve:test-app": "export SKIP_PREFLIGHT_CHECK=true;npx serve -s tests/test-app/build -p 4000"
  };
  var repository = {
  	type: "git",
  	url: "https://github.com/imagekit-developer/imagekit-react"
  };
  var main = "dist/imagekitio-react.js";
  var module = "dist/imagekitio-react.esm.js";
  var browser = "dist/imagekitio-react.umd.js";
  var files = [
  	"dist",
  	"src"
  ];
  var jest = {
  	verbose: true,
  	setupFilesAfterEnv: [
  		"<rootDir>/tests/jest/setupTests.js"
  	],
  	coveragePathIgnorePatterns: [
  		"<rootDir>/tests/jest/mocks"
  	],
  	modulePathIgnorePatterns: [
  		"<rootDir>/tests/cypress/"
  	]
  };
  var author = "ImageKit";
  var license = "MIT";
  var devDependencies = {
  	"@babel/cli": "^7.7.4",
  	"@babel/core": "^7.7.4",
  	"@babel/plugin-proposal-class-properties": "^7.7.4",
  	"@babel/plugin-proposal-export-default-from": "^7.7.4",
  	"@babel/preset-env": "^7.7.4",
  	"@babel/preset-react": "^7.7.4",
  	"@babel/register": "^7.7.4",
  	"@babel/runtime": "^7.7.6",
  	"@rollup/plugin-babel": "^5.2.1",
  	"@rollup/plugin-commonjs": "^15.1.0",
  	"@rollup/plugin-json": "^4.1.0",
  	"@rollup/plugin-replace": "^2.3.3",
  	"babel-loader": "^8.0.6",
  	codecov: "^3.8.0",
  	cypress: "^5.6.0",
  	enzyme: "^3.11.0",
  	"enzyme-adapter-react-16": "^1.15.5",
  	jest: "^26.5.2",
  	react: "^16.13.1",
  	"react-dom": "^16.13.1",
  	"react-test-renderer": "^16.13.1",
  	"require-context.macro": "^1.2.2",
  	rollup: "^2.28.2",
  	"rollup-plugin-node-resolve": "^5.2.0",
  	"rollup-plugin-peer-deps-external": "^2.2.3",
  	"rollup-plugin-terser": "^7.0.2",
  	sinon: "^9.2.0"
  };
  var dependencies = {
  	"imagekit-javascript": "^1.3.6",
  	"prop-types": "^15.7.2"
  };
  var peerDependencies = {
  	react: "^16.13.1 || ^17.0.0",
  	"react-dom": "^16.13.1 || ^17.0.0"
  };
  var pkg = {
  	name: name,
  	version: version$1,
  	description: description,
  	scripts: scripts,
  	repository: repository,
  	main: main,
  	module: module,
  	browser: browser,
  	"browser:min": "dist/imagekitio-react.umd.min.js",
  	files: files,
  	jest: jest,
  	author: author,
  	license: license,
  	devDependencies: devDependencies,
  	dependencies: dependencies,
  	peerDependencies: peerDependencies
  };

  var ImageKitComponent = /*#__PURE__*/function (_PureComponent) {
    _inherits(ImageKitComponent, _PureComponent);

    var _super = _createSuper(ImageKitComponent);

    function ImageKitComponent(props, context) {
      var _this;

      _classCallCheck(this, ImageKitComponent);

      _this = _super.call(this, props, context);
      _this.getContext = _this.getContext.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(ImageKitComponent, [{
      key: "getVersion",
      value: function getVersion() {
        return pkg.version;
      }
    }, {
      key: "getContext",
      value: function getContext() {
        return this.context || {};
      }
    }, {
      key: "getIKClient",
      value: function getIKClient() {
        var contextOptions = this.getContext();

        if (contextOptions.ikClient) {
          return contextOptions.ikClient;
        }

        var urlEndpoint = this.props.urlEndpoint;
        urlEndpoint = urlEndpoint || contextOptions.urlEndpoint;

        if (!urlEndpoint || urlEndpoint.trim() === "") {
          throw new Error("Missing urlEndpoint during initialization");
        }

        var ikClient = new ImageKit({
          sdkVersion: "react-".concat(this.getVersion()),
          urlEndpoint: urlEndpoint
        });
        return ikClient;
      }
    }, {
      key: "render",
      value: function render() {
        return null;
      }
    }]);

    return ImageKitComponent;
  }(React.PureComponent);

  ImageKitComponent.contextType = ImageKitContextType;

  var COMMON_PROPS = {
    publicKey: propTypes.string,
    urlEndpoint: propTypes.string,
    authenticationEndpoint: propTypes.string
  };

  var IK_IMAGE_PROPS = {
    loading: propTypes.oneOf(['lazy']),
    lqip: propTypes.object,
    path: propTypes.string,
    src: propTypes.string,
    queryParameters: propTypes.object,
    transformation: propTypes.arrayOf(propTypes.object),
    transformationPosition: propTypes.oneOf(['path', 'query'])
  };

  var IK_UPLOAD_PROPS = {
    fileName: propTypes.string,
    tags: propTypes.array,
    useUniqueFileName: propTypes.bool,
    responseFields: propTypes.array,
    isPrivateFile: propTypes.bool,
    folder: propTypes.string,
    customCoordinates: propTypes.string,
    onError: propTypes.func,
    onSuccess: propTypes.func
  };

  var PROP_TYPES = _objectSpread2(_objectSpread2(_objectSpread2({}, COMMON_PROPS), IK_IMAGE_PROPS), IK_UPLOAD_PROPS);
  /**
   * Provides a container for ImageKit components. Any option set in IKContext will be passed to the children.
   *
   * @example
   *<IKContext  publicKey="<public key>" urlEndpoint="url link">
   *    <!-- other tags -->
   *    <Image src={link}/>
   *</IKContext>
   */


  var IKContext = /*#__PURE__*/function (_ImageKitComponent) {
    _inherits(IKContext, _ImageKitComponent);

    var _super = _createSuper(IKContext);

    function IKContext() {
      _classCallCheck(this, IKContext);

      return _super.apply(this, arguments);
    }

    _createClass(IKContext, [{
      key: "extractContextOptions",
      value: function extractContextOptions(mergedOptions) {
        var result = {};
        var propKeys = Object.keys(PROP_TYPES);

        for (var i = 0; i < propKeys.length; i++) {
          var key = propKeys[i];
          var value = mergedOptions[key];
          if (value) result[key] = value;
        }

        return result;
      }
    }, {
      key: "render",
      value: function render() {
        var children = this.props.children;

        var mergedOptions = _objectSpread2(_objectSpread2({}, this.getContext()), this.props);

        var contextOptions = this.extractContextOptions(mergedOptions);

        if (contextOptions.urlEndpoint && contextOptions.urlEndpoint.trim() !== "") {
          contextOptions.ikClient = new ImageKit({
            sdkVersion: "react-".concat(this.getVersion()),
            urlEndpoint: contextOptions.urlEndpoint
          });
        }

        return /*#__PURE__*/React__default['default'].createElement(ImageKitContextType.Provider, {
          value: contextOptions
        }, children);
      }
    }]);

    return IKContext;
  }(ImageKitComponent);

  IKContext.propTypes = PROP_TYPES;
  IKContext.contextType = ImageKitContextType;

  var PROP_TYPES$1 = _objectSpread2(_objectSpread2({}, COMMON_PROPS), IK_IMAGE_PROPS);

  var propsAffectingURL = ["urlEndpoint", "path", "src", "transformation", "transformationPosition", "queryParameters"];

  var IKImage = /*#__PURE__*/function (_ImageKitComponent) {
    _inherits(IKImage, _ImageKitComponent);

    var _super = _createSuper(IKImage);

    function IKImage(props, context) {
      var _this;

      _classCallCheck(this, IKImage);

      _this = _super.call(this, props, context);
      _this.imageRef = /*#__PURE__*/React__default['default'].createRef();

      var _this$getSrc = _this.getSrc(),
          originalSrc = _this$getSrc.originalSrc,
          lqipSrc = _this$getSrc.lqipSrc;

      _this.state = {
        currentUrl: undefined,
        originalSrc: originalSrc,
        lqipSrc: lqipSrc,
        originalSrcLoaded: false,
        intersected: false,
        contextOptions: {}
      };
      return _this;
    }

    _createClass(IKImage, [{
      key: "getSrc",
      value: function getSrc() {
        var result = {};
        var _this$props = this.props,
            lqip = _this$props.lqip,
            src = _this$props.src,
            path = _this$props.path,
            transformation = _this$props.transformation,
            transformationPosition = _this$props.transformationPosition,
            queryParameters = _this$props.queryParameters;
        var ikClient = this.getIKClient();
        var contextOptions = this.getContext();
        var options = {
          urlEndpoint: this.props.urlEndpoint || contextOptions.urlEndpoint,
          src: src || contextOptions.src,
          path: path || contextOptions.path,
          transformation: transformation || contextOptions.transformation,
          transformationPosition: transformationPosition || contextOptions.transformationPosition,
          queryParameters: queryParameters || contextOptions.queryParameters
        };
        result.originalSrc = ikClient.url(options);

        if (lqip && lqip.active) {
          var quality = parseInt(lqip.quality || lqip.threshold, 10) || 20;
          var blur = parseInt(lqip.blur || lqip.blur, 10) || 6;
          var newTransformation = options.transformation ? _toConsumableArray(options.transformation) : [];

          if (lqip.raw && typeof lqip.raw === "string" && lqip.raw.trim() != "") {
            newTransformation.push({
              raw: lqip.raw.trim()
            });
          } else {
            newTransformation.push({
              quality: quality,
              blur: blur
            });
          }

          result.lqipSrc = ikClient.url(_objectSpread2(_objectSpread2({}, options), {}, {
            transformation: newTransformation
          }));
        }

        return result;
      }
    }, {
      key: "getEffectiveConnection",
      value: function getEffectiveConnection() {
        try {
          return navigator.connection.effectiveType;
        } catch (ex) {
          return "4g";
        }
      }
    }, {
      key: "updateImageUrl",
      value: function updateImageUrl() {
        /*
          No lazy loading no lqip
            src=originalImage
          No lazy loading lqip
            src=lqip
            src=originalImage (when loaded)
          lazy loading and no lqip
            src=''
            onIntersect:
            src=originalImage
          lazy loading and lqip
            src=lqip
            onIntersect:
            src=originalImage (when loaded)
        */
        var _this$state = this.state,
            intersected = _this$state.intersected,
            originalSrcLoaded = _this$state.originalSrcLoaded;
        var _this$props2 = this.props,
            _this$props2$lqip = _this$props2.lqip,
            lqip = _this$props2$lqip === void 0 ? null : _this$props2$lqip,
            loading = _this$props2.loading;

        if (loading !== "lazy" && lqip === null) {
          this.setState({
            currentUrl: this.state.originalSrc
          });
        } else if (loading !== "lazy" && lqip && lqip.active) {
          if (originalSrcLoaded) {
            this.setState({
              currentUrl: this.state.originalSrc
            });
          } else {
            this.setState({
              currentUrl: this.state.lqipSrc
            });
          }
        } else if (loading === "lazy" && lqip === null) {
          if (intersected) {
            this.setState({
              currentUrl: this.state.originalSrc
            });
          } else {
            this.setState({
              currentUrl: ""
            });
          }
        } else if (loading === "lazy" && lqip && lqip.active) {
          if (intersected && originalSrcLoaded) {
            this.setState({
              currentUrl: this.state.originalSrc
            });
          } else {
            this.setState({
              currentUrl: this.state.lqipSrc
            });
          }
        }
      }
    }, {
      key: "triggerOriginalImageLoad",
      value: function triggerOriginalImageLoad() {
        var _this2 = this;

        var img = new Image();

        img.onload = function () {
          _this2.setState({
            originalSrcLoaded: true
          }, function () {
            _this2.updateImageUrl();
          });
        };

        img.src = this.state.originalSrc;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this3 = this;

        this.updateImageUrl();
        this.setState({
          contextOptions: this.getContext()
        });
        var image = this.imageRef.current;
        var _this$props3 = this.props,
            lqip = _this$props3.lqip,
            loading = _this$props3.loading;

        if (window && 'IntersectionObserver' in window && loading === "lazy") {
          var connectionType = this.getEffectiveConnection(); // Values based on native lazy loading in Chrome - https://web.dev/native-lazy-loading/#improved-data-savings-and-distance-from-viewport-thresholds

          var rootMargin = "1250px";
          if (connectionType !== "4g") rootMargin = "2500px";
          var imageObserver = new IntersectionObserver(function (entries) {
            var el = entries[0];

            if (el && el.isIntersecting) {
              _this3.setState({
                intersected: true
              }, function () {
                if (lqip && lqip.active) _this3.triggerOriginalImageLoad();
                imageObserver.disconnect();

                _this3.updateImageUrl();
              });
            }
          }, {
            rootMargin: "".concat(rootMargin, " 0px ").concat(rootMargin, " 0px")
          });
          imageObserver.observe(image);
          this.setState({
            observe: imageObserver
          });
        } else {
          // Load original image right away
          this.setState({
            intersected: true
          }, function () {
            if (lqip && lqip.active) _this3.triggerOriginalImageLoad();

            _this3.updateImageUrl();
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var observe = this.state.observe;
        if (observe) observe.disconnect();
      }
    }, {
      key: "areObjectsDifferent",
      value: function areObjectsDifferent(prevProps, newProps) {
        for (var index = 0; index < propsAffectingURL.length; index++) {
          if (prevProps[propsAffectingURL[index]] != newProps[propsAffectingURL[index]]) {
            return true;
          }
        }

        return false;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        var _this4 = this;

        var contextOptions = this.getContext();

        if (this.areObjectsDifferent(prevProps, this.props) || this.areObjectsDifferent(prevState.contextOptions, contextOptions)) {
          var _this$getSrc2 = this.getSrc(),
              originalSrc = _this$getSrc2.originalSrc,
              lqipSrc = _this$getSrc2.lqipSrc;

          this.setState({
            originalSrc: originalSrc,
            lqipSrc: lqipSrc
          }, function () {
            _this4.updateImageUrl();

            _this4.setState({
              contextOptions: _this4.getContext()
            });
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var currentUrl = this.state.currentUrl;

        var _this$props4 = this.props,
            urlEndpoint = _this$props4.urlEndpoint,
            loading = _this$props4.loading,
            lqip = _this$props4.lqip,
            path = _this$props4.path,
            src = _this$props4.src,
            transformation = _this$props4.transformation,
            transformationPosition = _this$props4.transformationPosition,
            queryParameters = _this$props4.queryParameters,
            restProps = _objectWithoutProperties(_this$props4, ["urlEndpoint", "loading", "lqip", "path", "src", "transformation", "transformationPosition", "queryParameters"]);

        return /*#__PURE__*/React__default['default'].createElement("img", _extends({
          alt: this.props.alt || "",
          src: currentUrl,
          ref: this.imageRef
        }, restProps));
      }
    }]);

    return IKImage;
  }(ImageKitComponent);

  IKImage.propTypes = PROP_TYPES$1;

  var PROP_TYPES$2 = _objectSpread2(_objectSpread2({}, COMMON_PROPS), IK_UPLOAD_PROPS);

  var IKUpload = /*#__PURE__*/function (_ImageKitComponent) {
    _inherits(IKUpload, _ImageKitComponent);

    var _super = _createSuper(IKUpload);

    function IKUpload() {
      _classCallCheck(this, IKUpload);

      return _super.apply(this, arguments);
    }

    _createClass(IKUpload, [{
      key: "uploadFile",
      value: function uploadFile(e) {
        var contextOptions = this.getContext();
        var _this$props = this.props,
            fileName = _this$props.fileName,
            useUniqueFileName = _this$props.useUniqueFileName,
            tags = _this$props.tags,
            folder = _this$props.folder,
            isPrivateFile = _this$props.isPrivateFile,
            customCoordinates = _this$props.customCoordinates,
            responseFields = _this$props.responseFields,
            onError = _this$props.onError,
            onSuccess = _this$props.onSuccess;
        var publicKey = this.props.publicKey || contextOptions.publicKey;
        var authenticationEndpoint = this.props.authenticationEndpoint || contextOptions.authenticationEndpoint;
        var urlEndpoint = this.props.urlEndpoint || contextOptions.urlEndpoint;

        if (!publicKey || publicKey.trim() === "") {
          if (onError && typeof onError === "function") {
            onError({
              message: "Missing publicKey"
            });
          }

          return;
        }

        if (!authenticationEndpoint || authenticationEndpoint.trim() === "") {
          if (onError && typeof onError === "function") {
            onError({
              message: "Missing authenticationEndpoint"
            });
          }

          return;
        }

        if (!urlEndpoint || urlEndpoint.trim() === "") {
          if (onError && typeof onError === "function") {
            onError({
              message: "Missing urlEndpoint"
            });
          }

          return;
        }

        var ikClient = this.getIKClient();
        var file = e.target.files[0];
        var params = {
          file: file,
          fileName: fileName || file.name,
          useUniqueFileName: useUniqueFileName,
          tags: tags,
          folder: folder,
          isPrivateFile: isPrivateFile,
          customCoordinates: customCoordinates,
          responseFields: responseFields
        };
        ikClient.upload(params, function (err, result) {
          if (err) {
            if (onError && typeof onError === "function") {
              onError(err);
            }
          } else {
            if (onSuccess && typeof onSuccess === "function") {
              onSuccess(result);
            }
          }
        }, {
          publicKey: publicKey,
          authenticationEndpoint: authenticationEndpoint
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this = this;

        var _this$props2 = this.props,
            publicKey = _this$props2.publicKey,
            urlEndpoint = _this$props2.urlEndpoint,
            authenticationEndpoint = _this$props2.authenticationEndpoint,
            fileName = _this$props2.fileName,
            useUniqueFileName = _this$props2.useUniqueFileName,
            tags = _this$props2.tags,
            folder = _this$props2.folder,
            isPrivateFile = _this$props2.isPrivateFile,
            customCoordinates = _this$props2.customCoordinates,
            responseFields = _this$props2.responseFields,
            onError = _this$props2.onError,
            onSuccess = _this$props2.onSuccess,
            restProps = _objectWithoutProperties(_this$props2, ["publicKey", "urlEndpoint", "authenticationEndpoint", "fileName", "useUniqueFileName", "tags", "folder", "isPrivateFile", "customCoordinates", "responseFields", "onError", "onSuccess"]);

        return /*#__PURE__*/React__default['default'].createElement("input", _extends({
          type: "file"
        }, restProps, {
          onChange: function onChange(e) {
            if (_this.props.onChange && typeof _this.props.onChange === "function") {
              _this.props.onChange(e);
            }

            _this.uploadFile(e);
          }
        }));
      }
    }]);

    return IKUpload;
  }(ImageKitComponent);
  IKUpload.defaultProps = {
    useUniqueFileName: true,
    isPrivateFile: false,
    customCoordinates: "",
    tags: [],
    folder: "/",
    responseFields: []
  };
  IKUpload.propTypes = PROP_TYPES$2;

  exports.IKContext = IKContext;
  exports.IKImage = IKImage;
  exports.IKUpload = IKUpload;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ 29367:
/***/ (function(module) {

"use strict";


const denyList = new Set([
	'ENOTFOUND',
	'ENETUNREACH',

	// SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
	'UNABLE_TO_GET_ISSUER_CERT',
	'UNABLE_TO_GET_CRL',
	'UNABLE_TO_DECRYPT_CERT_SIGNATURE',
	'UNABLE_TO_DECRYPT_CRL_SIGNATURE',
	'UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY',
	'CERT_SIGNATURE_FAILURE',
	'CRL_SIGNATURE_FAILURE',
	'CERT_NOT_YET_VALID',
	'CERT_HAS_EXPIRED',
	'CRL_NOT_YET_VALID',
	'CRL_HAS_EXPIRED',
	'ERROR_IN_CERT_NOT_BEFORE_FIELD',
	'ERROR_IN_CERT_NOT_AFTER_FIELD',
	'ERROR_IN_CRL_LAST_UPDATE_FIELD',
	'ERROR_IN_CRL_NEXT_UPDATE_FIELD',
	'OUT_OF_MEM',
	'DEPTH_ZERO_SELF_SIGNED_CERT',
	'SELF_SIGNED_CERT_IN_CHAIN',
	'UNABLE_TO_GET_ISSUER_CERT_LOCALLY',
	'UNABLE_TO_VERIFY_LEAF_SIGNATURE',
	'CERT_CHAIN_TOO_LONG',
	'CERT_REVOKED',
	'INVALID_CA',
	'PATH_LENGTH_EXCEEDED',
	'INVALID_PURPOSE',
	'CERT_UNTRUSTED',
	'CERT_REJECTED',
	'HOSTNAME_MISMATCH'
]);

// TODO: Use `error?.code` when targeting Node.js 14
module.exports = error => !denyList.has(error && error.code);


/***/ }),

/***/ 33562:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

var _Transition = _interopRequireDefault(__webpack_require__(53991));

var _CSSTransition = _interopRequireDefault(__webpack_require__(80902));

var _PropTypes = __webpack_require__(59306);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function areChildrenDifferent(oldChildren, newChildren) {
  return oldChildren !== newChildren;
}

function differentChildrenNeedAnimation(oldChildren, newChildren) {
  if (!oldChildren || !newChildren) {
    return true;
  }

  if (!_react.default.isValidElement(oldChildren) || !_react.default.isValidElement(newChildren)) {
    // eslint-disable-next-line no-console
    console.warn('[next-page-transitions] PageTransition child is not a valid React component');
    return true;
  }

  if (oldChildren.key == null || newChildren.key == null) {
    // eslint-disable-next-line no-console
    console.warn('[next-page-transitions] PageTransition child does not have a key');
    return true;
  }

  return oldChildren.key !== newChildren.key;
}

function buildClassName(className, state) {
  switch (state) {
    case 'enter':
      return "".concat(className, "-enter");

    case 'entering':
      return "".concat(className, "-enter ").concat(className, "-enter-active");

    case 'entered':
      return "".concat(className, "-enter-done");

    case 'exit':
      return "".concat(className, "-exit");

    case 'exiting':
      return "".concat(className, "-exit ").concat(className, "-exit-active");

    case 'exited':
      return "".concat(className, "-exit-done");

    default:
      return '';
  }
}

function shouldDelayEnter(children) {
  return _react.default.isValidElement(children) && children.type.pageTransitionDelayEnter;
}

function makeStateUpdater(state, otherProps) {
  return function updateState() {
    this.setState(_objectSpread({
      state: state
    }, otherProps));
  };
}

var PageTransition =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PageTransition, _React$Component);

  function PageTransition(props) {
    var _this;

    _classCallCheck(this, PageTransition);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PageTransition).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onEntering", makeStateUpdater('entering').bind(_assertThisInitialized(_this)));

    _defineProperty(_assertThisInitialized(_this), "onEntered", makeStateUpdater('entered').bind(_assertThisInitialized(_this)));

    _defineProperty(_assertThisInitialized(_this), "onExiting", makeStateUpdater('exiting').bind(_assertThisInitialized(_this)));

    _defineProperty(_assertThisInitialized(_this), "onExited", makeStateUpdater('exited', {
      renderedChildren: null
    }).bind(_assertThisInitialized(_this)));

    var children = props.children;
    _this.state = {
      state: props.skipInitialTransition ? 'init' : 'enter',
      isIn: !shouldDelayEnter(children),
      currentChildren: children,
      nextChildren: null,
      renderedChildren: children,
      showLoading: false
    };
    return _this;
  }

  _createClass(PageTransition, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          monkeyPatchScrolling = _this$props.monkeyPatchScrolling;

      if (shouldDelayEnter(children)) {
        this.setState({
          timeoutId: this.startEnterTimer()
        });
      }

      if (monkeyPatchScrolling && typeof window !== 'undefined') {
        // Forgive me for what I'm about to do
        this.originalScrollTo = window.scrollTo;
        this.disableScrolling = false;

        window.scrollTo = function () {
          if (_this2.disableScrolling) return;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this2.originalScrollTo.apply(window, args);
        };
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$state = this.state,
          currentChildren = _this$state.currentChildren,
          renderedChildren = _this$state.renderedChildren,
          nextChildren = _this$state.nextChildren,
          isIn = _this$state.isIn,
          state = _this$state.state;
      var children = this.props.children;
      var _this$state2 = this.state,
          timeoutId = _this$state2.timeoutId,
          showLoading = _this$state2.showLoading;
      var hasNewChildren = areChildrenDifferent(currentChildren, children);
      var needsTransition = areChildrenDifferent(renderedChildren, children);
      var shouldAnimateTransition = needsTransition && differentChildrenNeedAnimation(renderedChildren, children);

      if (isIn && needsTransition && !shouldAnimateTransition) {
        // We need to update our rendered children, but we shouldn't animate them.
        // This will occur when the key prop on our children stays the same but
        // the children themselves change. This can happen in a lot of cases: HMR,
        // a rerender due to a Redux state change, a Router.push to the current page,
        // etc. In this case, we'll just immediately flush the children to be
        // rendered.
        this.setState({
          currentChildren: children,
          renderedChildren: children
        });
      } else if (hasNewChildren) {
        // We got a new set of children while we were transitioning some in
        // Immediately start transitioning out this component and update the next
        // component
        this.setState({
          isIn: false,
          nextChildren: children,
          currentChildren: children
        });

        if (timeoutId) {
          clearTimeout(timeoutId);
        }
      } else if (needsTransition && !isIn && (state === 'enter' || state === 'exited')) {
        if (shouldDelayEnter(nextChildren)) {
          // Wait for the ready callback to actually transition in, but still
          // mount the component to allow it to start loading things
          this.setState({
            renderedChildren: nextChildren,
            nextChildren: null,
            timeoutId: this.startEnterTimer()
          });
        } else {
          // No need to wait, mount immediately
          this.setState({
            isIn: true,
            renderedChildren: nextChildren,
            nextChildren: null
          });
        }
      } else if (prevState.showLoading && !showLoading) {
        // We hid the loading indicator; now that that change has been flushed to
        // the DOM, we can now bring in the next component!
        this.setState({
          isIn: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.originalScrollTo && typeof window !== 'undefined') {
        window.scrollTo = this.originalScrollTo;
      }

      var timeoutId = this.state.timeoutId;
      if (timeoutId) clearTimeout(timeoutId);
    }
  }, {
    key: "onEnter",
    value: function onEnter() {
      // It's safe to reenable scrolling now
      this.disableScrolling = false;
      this.setState({
        state: 'enter',
        showLoading: false
      });
    }
  }, {
    key: "onExit",
    value: function onExit() {
      // Disable scrolling until this component has unmounted
      this.disableScrolling = true;
      this.setState({
        state: 'exit'
      });
    }
  }, {
    key: "onChildLoaded",
    value: function onChildLoaded() {
      var _this$state3 = this.state,
          timeoutId = _this$state3.timeoutId,
          showLoading = _this$state3.showLoading;

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      if (showLoading) {
        // We'll hide the loader first and animate in the page on the next tick
        this.setState({
          showLoading: false
        });
      } else {
        // We can immediately bring in the next page!
        this.setState({
          isIn: true
        });
      }
    }
  }, {
    key: "startEnterTimer",
    value: function startEnterTimer() {
      var _this3 = this;

      var loadingDelay = this.props.loadingDelay;
      return setTimeout(function () {
        _this3.setState({
          showLoading: true
        });
      }, loadingDelay);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          Tag = _this$props2.tag,
          timeout = _this$props2.timeout,
          loadingComponent = _this$props2.loadingComponent,
          loadingCallbackName = _this$props2.loadingCallbackName,
          classNames = _this$props2.classNames,
          loadingClassNames = _this$props2.loadingClassNames,
          loadingTimeout = _this$props2.loadingTimeout,
          skipInitialTransition = _this$props2.skipInitialTransition;
      var _this$state4 = this.state,
          children = _this$state4.renderedChildren,
          state = _this$state4.state,
          isIn = _this$state4.isIn,
          showLoading = _this$state4.showLoading;

      if (['entering', 'exiting', 'exited'].indexOf(state) !== -1) {
        // Need to reflow!
        // eslint-disable-next-line no-unused-expressions
        if (document.body) document.body.scrollTop;
      }

      var hasLoadingComponent = !!loadingComponent;
      var containerClassName = buildClassName(classNames, state);
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_Transition.default, {
        timeout: timeout,
        in: isIn,
        appear: !skipInitialTransition,
        onEnter: function onEnter() {
          return _this4.onEnter();
        },
        onEntering: function onEntering() {
          return _this4.onEntering();
        },
        onEntered: function onEntered() {
          return _this4.onEntered();
        },
        onExit: function onExit() {
          return _this4.onExit();
        },
        onExiting: function onExiting() {
          return _this4.onExiting();
        },
        onExited: function onExited() {
          return _this4.onExited();
        }
      }, _react.default.createElement(Tag, {
        className: containerClassName
      }, children && _react.default.cloneElement(children, _defineProperty({}, loadingCallbackName, function () {
        return _this4.onChildLoaded();
      })))), hasLoadingComponent && _react.default.createElement(_CSSTransition.default, {
        in: showLoading,
        mountOnEnter: true,
        unmountOnExit: true,
        appear: true,
        classNames: loadingClassNames,
        timeout: loadingTimeout
      }, loadingComponent));
    }
  }]);

  return PageTransition;
}(_react.default.Component); // We do weird things with timeoutsShape because these are omitted in some
// environments
// See https://github.com/reactjs/react-transition-group/pull/448


PageTransition.propTypes = {
  tag: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.shape({
    $$typeof: _propTypes.default.symbol,
    render: _propTypes.default.func
  })]),
  children: _propTypes.default.node.isRequired,
  classNames: _propTypes.default.string.isRequired,

  /* eslint-disable react/require-default-props */
  timeout: function timeout(props) {
    if (_PropTypes.timeoutsShape) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return _PropTypes.timeoutsShape.isRequired.apply(_PropTypes.timeoutsShape, [props].concat(args));
    }

    return undefined;
  },
  loadingComponent: _propTypes.default.element,
  loadingDelay: _propTypes.default.number,
  loadingCallbackName: _propTypes.default.string,

  /* eslint-disable react/require-default-props */
  loadingTimeout: function loadingTimeout(props) {
    if (_PropTypes.timeoutsShape && props.loadingComponent) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return _PropTypes.timeoutsShape.isRequired.apply(_PropTypes.timeoutsShape, [props].concat(args));
    }

    return undefined;
  },
  loadingClassNames: function loadingClassNames(props) {
    var pt = _propTypes.default.string;
    if (props.loadingTimeout) pt = pt.isRequired;

    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /* eslint-enable react/require-default-props */
  monkeyPatchScrolling: _propTypes.default.bool,
  skipInitialTransition: _propTypes.default.bool
};
PageTransition.defaultProps = {
  tag: 'div',
  loadingComponent: null,
  loadingCallbackName: 'pageTransitionReadyToEnter',
  loadingDelay: 500,
  monkeyPatchScrolling: false,
  skipInitialTransition: false
};
var _default = PageTransition;
exports["default"] = _default;

/***/ }),

/***/ 93504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _PageTransition = _interopRequireDefault(__webpack_require__(33562));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  PageTransition: _PageTransition.default
};

/***/ }),

/***/ 51889:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(64836);

exports.__esModule = true;
exports["default"] = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(11498));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),

/***/ 11498:
/***/ (function(module, exports) {

"use strict";


exports.__esModule = true;
exports["default"] = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),

/***/ 64799:
/***/ (function(module) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ 80902:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(45697));

var _addClass = _interopRequireDefault(__webpack_require__(51889));

var _removeClass = _interopRequireDefault(__webpack_require__(64799));

var _react = _interopRequireDefault(__webpack_require__(67294));

var _Transition = _interopRequireDefault(__webpack_require__(53991));

var _PropTypes = __webpack_require__(59306);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? 0 : {};
var _default = CSSTransition;
exports["default"] = _default;
module.exports = exports["default"];

/***/ }),

/***/ 53991:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(45697));

var _react = _interopRequireDefault(__webpack_require__(67294));

var _reactDom = _interopRequireDefault(__webpack_require__(73935));

var _reactLifecyclesCompat = __webpack_require__(46871);

var _PropTypes = __webpack_require__(59306);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? 0 : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports["default"] = _default;

/***/ }),

/***/ 59306:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(45697));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? 0 : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? 0 : null;
exports.classNamesShape = classNamesShape;

/***/ }),

/***/ 76363:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(23731);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95477);



var Loader = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        size: "1.5em"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 90638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = noSSR;
exports["default"] = dynamic;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _loadable = _interopRequireDefault(__webpack_require__(14302));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isServerSide = "object" === 'undefined';
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        /*#__PURE__*/ return _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === 'function') {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === 'object') {
        loadableOptions = _objectSpread({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _objectSpread({}, loadableOptions, options);
    var suspenseOptions = loadableOptions;
    if (true) {
        // Error if react root is not enabled and `suspense` option is set to true
        if ( true && suspenseOptions.suspense) {
            // TODO: add error doc when this feature is stable
            throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
        }
    }
    if (suspenseOptions.suspense) {
        return loadableFn(suspenseOptions);
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _objectSpread({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})
    if (typeof loadableOptions.ssr === 'boolean') {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _useSubscription = __webpack_require__(67161);
var _loadableContext = __webpack_require__(16319);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        var state = (0, _useSubscription).useSubscription(subscription);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        return _react.default.createElement(opts.lazy, _objectSpread({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== 'undefined' && !opts.suspense) {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return !opts.suspense && init();
    };
    LoadableComponent.displayName = 'LoadableComponent';
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === 'number') {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            var _this1 = this;
                            this._delay = setTimeout(function() {
                                _this1._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === 'number') {
                        var _this2 = this;
                        this._timeout = setTimeout(function() {
                            _this2._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _objectSpread({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 23731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
;// CONCATENATED MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


/**
 * Quick note on Next.js return types:
 *
 * Page.getInitialProps https://nextjs.org/docs/api-reference/data-fetching/getInitialProps
 * as-is
 *
 * App.getInitialProps: AppInitialProps https://nextjs.org/docs/advanced-features/custom-app
 * {pageProps: any}
 *
 * getStaticProps https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 * {props: any}
 *
 * getServerSideProps https://nextjs.org/docs/basic-features/data-fetching#getserversideprops-server-side-rendering
 * {props: any}
 */
var HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
var getIsServer = function () { return typeof window === 'undefined'; };
var getDeserializedState = function (initialState, _a) {
    var _b = _a === void 0 ? {} : _a, deserializeState = _b.deserializeState;
    return deserializeState ? deserializeState(initialState) : initialState;
};
var getSerializedState = function (state, _a) {
    var _b = _a === void 0 ? {} : _a, serializeState = _b.serializeState;
    return serializeState ? serializeState(state) : state;
};
var store;
var initStore = function (_a) {
    var makeStore = _a.makeStore, context = _a.context;
    var createStore = function () { return makeStore(context); };
    if (getIsServer()) {
        var c = context;
        var req = void 0;
        if (c.req)
            req = c.req;
        if (c.ctx && c.ctx.req)
            req = c.ctx.req;
        if (req) {
            // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
            // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
            if (!req.__nextReduxWrapperStore)
                req.__nextReduxWrapperStore = createStore();
            return req.__nextReduxWrapperStore;
        }
        return createStore();
    }
    // Memoize store if client
    if (!store) {
        store = createStore();
    }
    return store;
};
var createWrapper = function (makeStore, config) {
    if (config === void 0) { config = {}; }
    var makeProps = function (_a) {
        var callback = _a.callback, context = _a.context;
        return __awaiter(void 0, void 0, void 0, function () {
            var store, nextCallback, initialProps, _b, state;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        store = initStore({ context: context, makeStore: makeStore });
                        if (config.debug)
                            console.log("1. getProps created store with state", store.getState());
                        nextCallback = callback && callback(store);
                        _b = nextCallback;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, nextCallback(context)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        initialProps = (_b) || {};
                        if (config.debug)
                            console.log("3. getProps after dispatches has store state", store.getState());
                        state = store.getState();
                        return [2 /*return*/, {
                                initialProps: initialProps,
                                initialState: getIsServer() ? getSerializedState(state, config) : state,
                            }];
                }
            });
        });
    };
    var getInitialPageProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ('getState' in context) {
                return [2 /*return*/, callback && callback(context)];
            }
            return [2 /*return*/, makeProps({ callback: callback, context: context })];
        });
    }); }; };
    var getInitialAppProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { initialState: initialState })];
            }
        });
    }); }; };
    var getStaticProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { props: __assign(__assign({}, initialProps.props), { initialState: initialState }) })];
            }
        });
    }); }; };
    var getServerSideProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getStaticProps(callback)(context)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); }; }; // just not to repeat myself
    var withRedux = function (Component) {
        var _a;
        var displayName = "withRedux(" + (Component.displayName || Component.name || 'Component') + ")";
        var hasInitialProps = 'getInitialProps' in Component;
        //TODO Check if pages/_app was wrapped so there's no need to wrap a page itself
        return _a = /** @class */ (function (_super) {
                __extends(Wrapper, _super);
                function Wrapper(props, context) {
                    var _this = _super.call(this, props, context) || this;
                    _this.store = null;
                    _this.hydrate(props, context);
                    return _this;
                }
                Wrapper.prototype.hydrate = function (_a, context) {
                    var _b;
                    var initialState = _a.initialState, initialProps = _a.initialProps, props = __rest(_a, ["initialState", "initialProps"]);
                    // this happens when App has page with getServerSideProps/getStaticProps, initialState will be dumped twice:
                    // one incomplete and one complete
                    var initialStateFromGSPorGSSR = (_b = props === null || props === void 0 ? void 0 : props.pageProps) === null || _b === void 0 ? void 0 : _b.initialState;
                    if (!this.store) {
                        this.store = initStore({ makeStore: makeStore, context: context });
                        if (config.debug)
                            console.log('4. WrappedApp created new store with', displayName, {
                                initialState: initialState,
                                initialStateFromGSPorGSSR: initialStateFromGSPorGSSR,
                            });
                    }
                    if (initialState)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialState, config),
                        });
                    // ATTENTION! This code assumes that Page's getServerSideProps is executed after App.getInitialProps
                    // so we dispatch in this order
                    if (initialStateFromGSPorGSSR)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialStateFromGSPorGSSR, config),
                        });
                };
                Wrapper.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
                    var _a, _b, _c, _d;
                    if (((_a = nextProps === null || nextProps === void 0 ? void 0 : nextProps.pageProps) === null || _a === void 0 ? void 0 : _a.initialState) !== ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.pageProps) === null || _c === void 0 ? void 0 : _c.initialState) ||
                        (nextProps === null || nextProps === void 0 ? void 0 : nextProps.initialState) !== ((_d = this.props) === null || _d === void 0 ? void 0 : _d.initialState)) {
                        this.hydrate(nextProps, nextContext);
                    }
                    return true;
                };
                Wrapper.prototype.render = function () {
                    var _a, _b;
                    var _c = this.props, initialState = _c.initialState, initialProps = _c.initialProps, props = __rest(_c, ["initialState", "initialProps"]);
                    var resultProps = props;
                    // order is important! Next.js overwrites props from pages/_app with getStaticProps from page
                    // @see https://github.com/zeit/next.js/issues/11648
                    if (initialProps && initialProps.pageProps)
                        resultProps.pageProps = __assign(__assign({}, initialProps.pageProps), props.pageProps);
                    var initialStateFromGSPorGSSR = (_a = props === null || props === void 0 ? void 0 : props.pageProps) === null || _a === void 0 ? void 0 : _a.initialState;
                    // just some cleanup to prevent passing it as props, we need to clone props to safely delete initialState
                    if (initialStateFromGSPorGSSR) {
                        resultProps = __assign(__assign({}, props), { pageProps: __assign({}, props.pageProps) });
                        delete resultProps.pageProps.initialState;
                    }
                    // unwrap getInitialPageProps
                    if ((_b = resultProps === null || resultProps === void 0 ? void 0 : resultProps.pageProps) === null || _b === void 0 ? void 0 : _b.initialProps) {
                        resultProps.pageProps = __assign(__assign({}, resultProps.pageProps), resultProps.pageProps.initialProps);
                        delete resultProps.pageProps.initialProps;
                    }
                    return (react.createElement(es/* Provider */.zt, { store: this.store },
                        react.createElement(Component, __assign({}, initialProps, resultProps))));
                };
                return Wrapper;
            }(react.Component)),
            _a.displayName = displayName,
            _a.getInitialProps = hasInitialProps ? Component.getInitialProps : undefined,
            _a;
    };
    return {
        getServerSideProps: getServerSideProps,
        getStaticProps: getStaticProps,
        getInitialAppProps: getInitialAppProps,
        getInitialPageProps: getInitialPageProps,
        withRedux: withRedux,
    };
};
// Legacy
/* harmony default export */ var es6 = (function (makeStore, config) {
    if (config === void 0) { config = {}; }
    console.warn('/!\\ You are using legacy implementaion. Please update your code: use createWrapper() and wrapper.withRedux().');
    return createWrapper(makeStore, config).withRedux;
});
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/redux-devtools-extension/index.js
var redux_devtools_extension = __webpack_require__(28500);
// EXTERNAL MODULE: ./redux/actions/products.ts
var products = __webpack_require__(86730);
// EXTERNAL MODULE: ./redux/actions/wishList.ts + 1 modules
var wishList = __webpack_require__(94624);
;// CONCATENATED MODULE: ./redux/reducers/productsReducer.ts


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var initialProductsState = {
    loading: true,
    items: {
        items: []
    },
    totalItems: [],
    filters: [],
    latestProducts: [],
    loadingCumulative: false,
    currentSlug: '',
    currentSearch: '',
    likedProducts: [],
    likedProductsSet: new Set(),
    wishList: {
        items: []
    },
    wishListFetchedOnce: false
};
var productsReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case products/* ACTIONS.GET_PRODUCTS_REQUEST */.aO.GET_PRODUCTS_REQUEST:
        case products/* ACTIONS.GET_LATEST_PRODUCTS_REQUEST */.aO.GET_LATEST_PRODUCTS_REQUEST:
            return _objectSpread({}, state, {
                loading: true
            });
        case products/* ACTIONS.GET_CUMULATIVE_PRODUCTS_REQUEST */.aO.GET_CUMULATIVE_PRODUCTS_REQUEST:
        case wishList/* ACTIONS.GET_WISH_LIST_REQUEST */.aO.GET_WISH_LIST_REQUEST:
            return _objectSpread({}, state, {
                loadingCumulative: true,
                loading: true
            });
        case products/* ACTIONS.SET_CURRENT_SHOP_SLUG */.aO.SET_CURRENT_SHOP_SLUG:
            return _objectSpread({}, state, {
                currentSlug: action.slug
            });
        case products/* ACTIONS.SET_CURRENT_SEARCH */.aO.SET_CURRENT_SEARCH:
            return _objectSpread({}, state, {
                currentSearch: action.search,
                currentSlug: ''
            });
        case products/* ACTIONS.EMPTY_PRODUCTS */.aO.EMPTY_PRODUCTS:
            return _objectSpread({}, initialProductsState);
        case products/* ACTIONS.GET_PRODUCTS_SUCCESS */.aO.GET_PRODUCTS_SUCCESS:
            {
                return _objectSpread({}, state, {
                    loading: false,
                    isCumulative: false,
                    items: action.products
                });
            }
        case products/* ACTIONS.GET_CUMULATIVE_PRODUCTS_SUCCESS */.aO.GET_CUMULATIVE_PRODUCTS_SUCCESS:
            {
                var cumulatedStock = _toConsumableArray(state.items.items || []).concat(_toConsumableArray(action.products.items || []));
                var uniqueProductsMap = new Map();
                cumulatedStock.forEach(function(product) {
                    if (product.id) {
                        uniqueProductsMap.set(product.id, product);
                    }
                });
                return _objectSpread({}, state, {
                    loading: false,
                    isCumulative: action.products.page > 1,
                    loadingCumulative: false,
                    items: {
                        limit: action.products.limit,
                        page: action.products.page,
                        pages: action.products.pages,
                        total: action.products.total,
                        items: Array.from(uniqueProductsMap.values())
                    },
                    wishListFetchedOnce: action.type === wishList/* ACTIONS.GET_WISH_LIST_SUCCESS */.aO.GET_WISH_LIST_SUCCESS
                });
            }
        case wishList/* ACTIONS.GET_WISH_LIST_SUCCESS */.aO.GET_WISH_LIST_SUCCESS:
            {
                var likedProducts = action.products.items.map(function(product) {
                    return product.id;
                });
                return _objectSpread({}, state, {
                    loading: false,
                    isCumulative: action.products.page > 1,
                    loadingCumulative: false,
                    wishList: action.products,
                    wishListFetchedOnce: true,
                    likedProductsSet: new Set(likedProducts),
                    likedProducts: likedProducts
                });
            }
        case wishList/* ACTIONS.CHECK_WISH_LIST_EXISTENCE_SUCCESS */.aO.CHECK_WISH_LIST_EXISTENCE_SUCCESS:
            {
                var likedProductsSet = Object.keys(action.productIds).length <= 1 ? new Set(state.likedProductsSet) : new Set();
                var likedProducts1 = _toConsumableArray(state.likedProducts);
                Object.entries(action.productIds).forEach(function(param) {
                    var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                    if (value) {
                        likedProductsSet.add(parseInt(key));
                        likedProducts1.push(parseInt(key));
                    }
                });
                return _objectSpread({}, state, {
                    likedProductsSet: likedProductsSet,
                    likedProducts: likedProducts1
                });
            }
        case products/* ACTIONS.GET_LATEST_PRODUCTS_SUCCESS */.aO.GET_LATEST_PRODUCTS_SUCCESS:
            var ref;
            return _objectSpread({}, state, {
                loading: false,
                latestProducts: (ref = action.product_latest) === null || ref === void 0 ? void 0 : ref.items
            });
        case wishList/* ACTIONS.ADD_TO_WISH_LIST_SUCCESS */.aO.ADD_TO_WISH_LIST_SUCCESS:
            {
                var newLikedProducts = new Set(state.likedProductsSet);
                newLikedProducts.add(action.id);
                return _objectSpread({}, state, {
                    likedProductsSet: newLikedProducts,
                    likedProducts: Array.from(newLikedProducts)
                });
            }
        case wishList/* ACTIONS.REMOVE_FROM_WISH_LIST_SUCCESS */.aO.REMOVE_FROM_WISH_LIST_SUCCESS:
            {
                var newLikedProducts1 = new Set(state.likedProductsSet);
                newLikedProducts1.delete(action.id);
                return _objectSpread({}, state, {
                    likedProductsSet: newLikedProducts1,
                    likedProducts: Array.from(newLikedProducts1),
                    wishList: _objectSpread({}, state.wishList, {
                        items: state.wishList.items.filter(function(product) {
                            return product.id !== action.id;
                        })
                    })
                });
            }
        case products/* ACTIONS.GET_PRODUCTS_FAILURE */.aO.GET_PRODUCTS_FAILURE:
        case products/* ACTIONS.GET_CUMULATIVE_PRODUCTS_FAILURE */.aO.GET_CUMULATIVE_PRODUCTS_FAILURE:
        case products/* ACTIONS.GET_LATEST_PRODUCTS_FAILURE */.aO.GET_LATEST_PRODUCTS_FAILURE:
        case wishList/* ACTIONS.GET_WISH_LIST_FAILURE */.aO.GET_WISH_LIST_FAILURE:
            return _objectSpread({}, state, {
                loading: false,
                loadingCumulative: false,
                error: action.err
            });
        case wishList/* ACTIONS.RESET_WISH_LIST */.aO.RESET_WISH_LIST:
            return _objectSpread({}, state, {
                wishListFetchedOnce: false
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_productsReducer = (productsReducer);

// EXTERNAL MODULE: ./redux/actions/taxons.ts
var taxons = __webpack_require__(44279);
;// CONCATENATED MODULE: ./redux/reducers/taxonsReducer.ts

function taxonsReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function taxonsReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            taxonsReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var taxonsReducer_initialProductsState = {
    loading: false,
    items: [],
    loadingAttribute: false,
    loadingSizes: false,
    locale: '',
    attributeValues: {}
};
var taxonsReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : taxonsReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case taxons/* ACTIONS.GET_TAXONS_REQUEST */.aO.GET_TAXONS_REQUEST:
            return taxonsReducer_objectSpread({}, state, {
                loading: true
            });
        case taxons/* ACTIONS.GET_TAXONS_ATTRIBUTES_REQUEST */.aO.GET_TAXONS_ATTRIBUTES_REQUEST:
            return taxonsReducer_objectSpread({}, state, {
                loadingAttribute: true
            });
        case taxons/* ACTIONS.GET_TAXONS_SIZES_REQUEST */.aO.GET_TAXONS_SIZES_REQUEST:
            return taxonsReducer_objectSpread({}, state, {
                loadingSizes: true
            });
        case taxons/* ACTIONS.GET_TAXONS_SUCCESS */.aO.GET_TAXONS_SUCCESS:
            return taxonsReducer_objectSpread({}, state, {
                items: action.taxons,
                locale: action.locale,
                loading: false
            });
        case taxons/* ACTIONS.GET_TAXONS_ATTRIBUTES_SUCCESS */.aO.GET_TAXONS_ATTRIBUTES_SUCCESS:
            return taxonsReducer_objectSpread({}, state, {
                loadingAttribute: false,
                attributesSlug: action.slug,
                attributes: action.attributes,
                isSecondHand: action === null || action === void 0 ? void 0 : action.isSecondHand
            });
        case taxons/* ACTIONS.GET_TAXONS_SIZES_SUCCESS */.aO.GET_TAXONS_SIZES_SUCCESS:
            var ref;
            return taxonsReducer_objectSpread({}, state, {
                loadingSizes: false,
                sizesCode: action.code,
                sizes: action.sizes,
                sizesNamePositionMap: (ref = action.sizes.find(function(sizeGroup) {
                    return sizeGroup.code === 'size';
                })) === null || ref === void 0 ? void 0 : ref.sizes.reduce(function(acc, size) {
                    acc[size.name] = size.position;
                    return acc;
                }, {})
            });
        case taxons/* ACTIONS.GET_TAXONS_FAILURE */.aO.GET_TAXONS_FAILURE:
            return taxonsReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        case taxons/* ACTIONS.GET_TAXONS_ATTRIBUTES_FAILURE */.aO.GET_TAXONS_ATTRIBUTES_FAILURE:
            return taxonsReducer_objectSpread({}, state, {
                loadingAttribute: false,
                error: action.error
            });
        case taxons/* ACTIONS.GET_TAXONS_SIZES_FAILURE */.aO.GET_TAXONS_SIZES_FAILURE:
            return taxonsReducer_objectSpread({}, state, {
                loadingSizes: false,
                error: action.error
            });
        case taxons/* ACTIONS.GET_ATTRIBUTE_VALUES_REQUEST */.aO.GET_ATTRIBUTE_VALUES_REQUEST:
            var ref1;
            return taxonsReducer_objectSpread({}, state, {
                attributeValues: taxonsReducer_objectSpread({}, state.attributeValues, taxonsReducer_defineProperty({}, action.attributeCode, taxonsReducer_objectSpread({}, (ref1 = state.attributeValues) === null || ref1 === void 0 ? void 0 : ref1[action.attributeCode], {
                    loading: true
                })))
            });
        case taxons/* ACTIONS.GET_ATTRIBUTE_VALUES_SUCCESS */.aO.GET_ATTRIBUTE_VALUES_SUCCESS:
            return taxonsReducer_objectSpread({}, state, {
                attributeValues: taxonsReducer_objectSpread({}, state.attributeValues, taxonsReducer_defineProperty({}, action.attributeCode, {
                    values: action.values.choices,
                    locale: action.locale,
                    loading: false
                }))
            });
        case taxons/* ACTIONS.GET_ATTRIBUTE_VALUES_FAILURE */.aO.GET_ATTRIBUTE_VALUES_FAILURE:
            var ref2;
            return taxonsReducer_objectSpread({}, state, {
                attributeValues: taxonsReducer_objectSpread({}, state.attributeValues, taxonsReducer_defineProperty({}, action.attributeCode, taxonsReducer_objectSpread({}, (ref2 = state.attributeValues) === null || ref2 === void 0 ? void 0 : ref2[action.attributeCode], {
                    loading: false
                }))),
                error: action.err
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_taxonsReducer = (taxonsReducer);

// EXTERNAL MODULE: ./redux/actions/cart.ts
var cart = __webpack_require__(14596);
;// CONCATENATED MODULE: ./redux/reducers/cartReducer.ts

function cartReducer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function cartReducer_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return cartReducer_arrayLikeToArray(arr);
}
function cartReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function cartReducer_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function cartReducer_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function cartReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            cartReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function cartReducer_toConsumableArray(arr) {
    return cartReducer_arrayWithoutHoles(arr) || cartReducer_iterableToArray(arr) || cartReducer_unsupportedIterableToArray(arr) || cartReducer_nonIterableSpread();
}
function cartReducer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return cartReducer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cartReducer_arrayLikeToArray(o, minLen);
}
var cartReducer_initialProductsState = {
    loading: false,
    funnelStep: 0,
    informationSkipped: false
};
var cartReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : cartReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'CREATE_CART_REQUEST':
        case 'DELETE_CART_REQUEST':
        case 'CREATE_SUBSCRIPTION_CART_REQUEST':
        case 'PATCH_CART_DATES_REQUEST':
        case 'ADD_PRODUCT_REQUEST':
        case 'ADD_MULTIPLE_PRODUCT_REQUEST':
        case 'PUT_PRODUCT_REQUEST':
        case 'DELETE_PRODUCT_REQUEST':
        case 'DELETE_PRODUCT_SECONDHAND_REQUEST':
        case 'PUT_CHECKOUT_PAYMENT_REQUEST':
        case 'PUT_CHECKOUT_SHIPPING_REQUEST':
        case 'PUT_CHECKOUT_ADDRESS_REQUEST':
        case 'PUT_CART_COUPON_REQUEST':
        case 'GET_CHECKOUT_SHIPPING_METHODS_REQUEST':
        case 'GET_CHECKOUT_REQUEST':
        case 'UPDATE_CART_SUBSCRIPTION_REQUEST':
        case 'GET_CART_REQUEST':
        case cart/* ACTIONS.GET_LAST_USED_BILLING_ADDRESS_REQUEST */.aO.GET_LAST_USED_BILLING_ADDRESS_REQUEST:
            return cartReducer_objectSpread({}, state, {
                loading: true
            });
        case 'PUT_CHECKOUT_ADDRESS_SUCCESS':
        case 'PUT_CHECKOUT_PAYMENT_SUCCESS':
        case 'PUT_CHECKOUT_SHIPPING_SUCCESS':
            return cartReducer_objectSpread({}, state, {
                loading: false
            });
        case 'ADD_MULTIPLE_PRODUCT_SUCCESS':
        case 'ADD_PRODUCT_SUCCESS':
        case 'CREATE_CART_SUCCESS':
        case 'CREATE_SUBSCRIPTION_CART_SUCCESS':
        case 'PUT_PRODUCT_SUCCESS':
        case 'DELETE_PRODUCT_SUCCESS':
        case 'DELETE_PRODUCT_SECONDHAND_SUCCESS':
        case 'GET_CHECKOUT_SUCCESS':
        case 'PUT_CART_COUPON_SUCCESS':
        case 'GET_CART_SUCCESS':
        case 'PATCH_CART_DATES_SUCCESS':
            return cartReducer_objectSpread({}, state, {
                loading: false,
                item: action.cart,
                blocked_date_range: action === null || action === void 0 ? void 0 : action.blocked_date_range,
                status: 'cart live',
                error: null
            });
        case 'UPDATE_CART_SUBSCRIPTION_SUCCESS':
            var ref;
            return cartReducer_objectSpread({}, state, {
                loading: false,
                item: (ref = action.cart) === null || ref === void 0 ? void 0 : ref.cart,
                status: 'cart live',
                isUpdated: true,
                error: null
            });
        case 'CREATE_CART_FAILURE':
        case 'CREATE_SUBSCRIPTION_CART_FAILURE':
        case 'DELETE_CART_FAILURE':
        case 'ADD_PRODUCT_FAILURE':
        case 'ADD_MULTIPLE_PRODUCT_FAILURE':
        case 'PUT_CHECKOUT_PAYMENT_FAILURE':
        case 'PUT_CHECKOUT_SHIPPING_FAILURE':
        case 'PUT_CART_COUPON_FAILURE':
        case 'PUT_PRODUCT_FAILURE':
        case 'DELETE_PRODUCT_FAILURE':
        case 'DELETE_PRODUCT_SECONDHAND_FAILURE':
        case 'PUT_CHECKOUT_ADDRESS_FAILURE':
        case 'UPDATE_CART_SUBSCRIPTION_FAILURE':
        case 'GET_CHECKOUT_FAILURE':
        case 'PATCH_CART_DATES_FAILURE':
        case 'GET_CART_FAILURE':
        case cart/* ACTIONS.GET_LAST_USED_BILLING_ADDRESS_FAILURE */.aO.GET_LAST_USED_BILLING_ADDRESS_FAILURE:
            return cartReducer_objectSpread({}, state, {
                loading: false,
                error: action.error,
                status: 'error'
            });
        case 'DELETE_CART_SUCCESS':
        case 'POST_CHECKOUT_SUCCESS':
            return cartReducer_objectSpread({}, state, {
                loading: false,
                item: undefined,
                status: 'cart deleted',
                address_type: '',
                error: null,
                parcelId: ''
            });
        case 'DELETE_CART_DP_SUCCESS':
            return cartReducer_objectSpread({}, state, {
                loading: false,
                item: undefined,
                status: 'cart deleted for DP',
                address_type: '',
                error: null,
                parcelId: ''
            });
        case 'GET_CHECKOUT_SHIPPING_METHODS_SUCCESS':
            return cartReducer_objectSpread({}, state, {
                loading: false,
                shipping_methods: action.shippingMethods
            });
        case 'SET_ADDRESS_TYPE_CART':
            return cartReducer_objectSpread({}, state, {
                address_type: action.type_name
            });
        case 'SET_PARCEL_ID_CART':
            return cartReducer_objectSpread({}, state, {
                rmsParcelShopId: action.rmsParcelShopId
            });
        case 'EMPTY_CART':
            return {
                loading: false
            };
        case cart/* ACTIONS.SET_FUNNEL_STEP */.aO.SET_FUNNEL_STEP:
            return cartReducer_objectSpread({}, state, {
                funnelStep: action.step
            });
        case cart/* ACTIONS.SET_INFORMATION_SKIPPED */.aO.SET_INFORMATION_SKIPPED:
            return cartReducer_objectSpread({}, state, {
                informationSkipped: action.skipped
            });
        case cart/* ACTIONS.GET_LAST_USED_BILLING_ADDRESS_SUCCESS */.aO.GET_LAST_USED_BILLING_ADDRESS_SUCCESS:
            return cartReducer_objectSpread({}, state, {
                item: cartReducer_objectSpread({}, state.item, {
                    billingAddress: action.address
                })
            });
        case cart/* ACTIONS.RECHECK_CART_STOCK */.aO.RECHECK_CART_STOCK:
            var ref1;
            return cartReducer_objectSpread({}, state, {
                item: cartReducer_objectSpread({}, state.item, {
                    items: cartReducer_toConsumableArray(((ref1 = state.item) === null || ref1 === void 0 ? void 0 : ref1.items) || [])
                })
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_cartReducer = (cartReducer);

;// CONCATENATED MODULE: ./redux/reducers/singleProductReducer.tsx
function singleProductReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function singleProductReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            singleProductReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var singleProductReducer_initialProductsState = {
    loading: false
};
var productReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : singleProductReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'GET_SINGLE_PRODUCT_REQUEST':
            // Clear the previously fetched product so a stale item is never shown
            // while the new one is loading.
            return singleProductReducer_objectSpread({}, state, {
                loading: true,
                item: undefined,
                error: undefined
            });
        case 'GET_SINGLE_PRODUCT_SUCCESS':
            return singleProductReducer_objectSpread({}, state, {
                loading: false,
                item: action.product
            });
        case 'GET_SINGLE_PRODUCT_FAILURE':
            return singleProductReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        case 'RESET_SINGLE_PRODUCT':
            return singleProductReducer_objectSpread({}, singleProductReducer_initialProductsState);
        default:
            return state;
    }
};
/* harmony default export */ var singleProductReducer = (productReducer);

// EXTERNAL MODULE: ./redux/actions/user.ts
var user = __webpack_require__(76809);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./redux/reducers/userReducer.tsx


function userReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function userReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            userReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var requiresSsoSessionCheck = Boolean(constants/* ssoLogoutRedirectUrl */.rr);
var userReducer_initialProductsState = {
    loading: requiresSsoSessionCheck,
    sessionChecked: !requiresSsoSessionCheck,
    loginInProgress: false,
    isLoggedIn: false
};
var userReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : userReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case user/* ACTIONS.SAVE_USER_REQUEST */.aO.SAVE_USER_REQUEST:
        case user/* ACTIONS.REGISTER_USER_REQUEST */.aO.REGISTER_USER_REQUEST:
        case user/* ACTIONS.GET_USER_ORDERS_REQUEST */.aO.GET_USER_ORDERS_REQUEST:
        case user/* ACTIONS.GET_USER_ORDER_BY_TOKEN_REQUEST */.aO.GET_USER_ORDER_BY_TOKEN_REQUEST:
        case user/* ACTIONS.GET_CONFIRMATION_ORDER_REQUEST */.aO.GET_CONFIRMATION_ORDER_REQUEST:
        case user/* ACTIONS.PUT_USER_REQUEST */.aO.PUT_USER_REQUEST:
        case user/* ACTIONS.PUT_USER_PASSWORD_REQUEST */.aO.PUT_USER_PASSWORD_REQUEST:
        case user/* ACTIONS.FORGET_PASSWORD_REQUEST */.aO.FORGET_PASSWORD_REQUEST:
        case user/* ACTIONS.GET_USER_REQUEST */.aO.GET_USER_REQUEST:
        case user/* ACTIONS.VERIFY_USER_REQUEST */.aO.VERIFY_USER_REQUEST:
        case user/* ACTIONS.RESET_PASSWORD_REQUEST */.aO.RESET_PASSWORD_REQUEST:
        case user/* ACTIONS.PUT_USER_ORDER_REQUEST */.aO.PUT_USER_ORDER_REQUEST:
            return userReducer_objectSpread({}, state, {
                loading: true
            });
        case user/* ACTIONS.LOGIN_USER_REQUEST */.aO.LOGIN_USER_REQUEST:
            return userReducer_objectSpread({}, state, {
                loginInProgress: true
            });
        case user/* ACTIONS.GET_USER_CARDS_REQUEST */.aO.GET_USER_CARDS_REQUEST:
        case user/* ACTIONS.POST_USER_CARD_REQUEST */.aO.POST_USER_CARD_REQUEST:
            return userReducer_objectSpread({}, state, {
                loading: true,
                cardUpdated: false
            });
        case user/* ACTIONS.VERIFY_USER_SUCCESS */.aO.VERIFY_USER_SUCCESS:
            return userReducer_objectSpread({}, state, {
                loading: false,
                userVerified: true
            });
        case user/* ACTIONS.SAVE_USER_SUCCESS */.aO.SAVE_USER_SUCCESS:
            return userReducer_objectSpread({}, state, {
                loading: false,
                email: action.email
            });
        case user/* ACTIONS.REGISTER_USER_SUCCESS */.aO.REGISTER_USER_SUCCESS:
            return userReducer_objectSpread({}, state, {
                loading: false,
                sessionChecked: true,
                user: action.token,
                isLoggedIn: true
            });
        case user/* ACTIONS.LOGIN_USER_SUCCESS */.aO.LOGIN_USER_SUCCESS:
            return userReducer_objectSpread({}, state, {
                loginInProgress: false,
                sessionChecked: true,
                user: action.user,
                isLoggedIn: !!action.user
            });
        case user/* ACTIONS.PUT_USER_SUCCESS */.aO.PUT_USER_SUCCESS:
        case user/* ACTIONS.GET_USER_SUCCESS */.aO.GET_USER_SUCCESS:
            return userReducer_objectSpread({}, state, {
                loading: false,
                sessionChecked: true,
                user: action.user,
                isLoggedIn: !!action.user
            });
        case user/* ACTIONS.FINISH_SESSION_CHECK */.aO.FINISH_SESSION_CHECK:
            return userReducer_objectSpread({}, state, {
                loading: false,
                sessionChecked: true
            });
        case user/* ACTIONS.LOGOUT_USER_SUCCESS */.aO.LOGOUT_USER_SUCCESS:
            return userReducer_objectSpread({}, state, {
                isLoggedIn: false,
                user: null,
                orders: undefined,
                sessionChecked: true
            });
        case user/* ACTIONS.GET_USER_ORDERS_SUCCESS */.aO.GET_USER_ORDERS_SUCCESS:
            return userReducer_objectSpread({}, state, {
                loading: false,
                orders: action.orders
            });
        case user/* ACTIONS.GET_USER_ORDER_BY_TOKEN_SUCCESS */.aO.GET_USER_ORDER_BY_TOKEN_SUCCESS:
            return userReducer_objectSpread({}, state, {
                loading: false,
                order: action.orders
            });
        case user/* ACTIONS.GET_CONFIRMATION_ORDER_SUCCESS */.aO.GET_CONFIRMATION_ORDER_SUCCESS:
            return userReducer_objectSpread({}, state, {
                loading: false,
                confirmationOrder: action.order
            });
        case user/* ACTIONS.GET_USER_CARDS_SUCCESS */.aO.GET_USER_CARDS_SUCCESS:
            return userReducer_objectSpread({}, state, {
                loading: false,
                cardUpdated: false,
                cards: action.cards
            });
        case user/* ACTIONS.GET_USER_BALANCE_SUCCESS */.aO.GET_USER_BALANCE_SUCCESS:
            return userReducer_objectSpread({}, state, {
                balance: action.balance
            });
        case user/* ACTIONS.POST_USER_CARD_SUCCESS */.aO.POST_USER_CARD_SUCCESS:
            return userReducer_objectSpread({}, state, {
                loading: false,
                cardUpdated: true,
                cards: action.cards
            });
        case user/* ACTIONS.SAVE_GHOST_USER */.aO.SAVE_GHOST_USER:
            return userReducer_objectSpread({}, state, {
                loading: false,
                ghostUser: action.ghostUserData
            });
        case user/* ACTIONS.PUT_USER_PASSWORD_SUCCESS */.aO.PUT_USER_PASSWORD_SUCCESS:
        case user/* ACTIONS.RESET_PASSWORD_SUCCESS */.aO.RESET_PASSWORD_SUCCESS:
        case user/* ACTIONS.FORGET_PASSWORD_SUCCESS */.aO.FORGET_PASSWORD_SUCCESS:
        case user/* ACTIONS.PUT_USER_ORDER_SUCCESS */.aO.PUT_USER_ORDER_SUCCESS:
        case user/* ACTIONS.LOGIN_USER_FAILURE */.aO.LOGIN_USER_FAILURE:
        case user/* ACTIONS.REGISTER_USER_FAILURE */.aO.REGISTER_USER_FAILURE:
        case user/* ACTIONS.PUT_USER_FAILURE */.aO.PUT_USER_FAILURE:
        case user/* ACTIONS.GET_USER_ORDERS_FAILURE */.aO.GET_USER_ORDERS_FAILURE:
        case user/* ACTIONS.GET_USER_ORDER_BY_TOKEN_FAILURE */.aO.GET_USER_ORDER_BY_TOKEN_FAILURE:
        case user/* ACTIONS.GET_CONFIRMATION_ORDER_FAILURE */.aO.GET_CONFIRMATION_ORDER_FAILURE:
        case user/* ACTIONS.FORGET_PASSWORD_FAILURE */.aO.FORGET_PASSWORD_FAILURE:
        case user/* ACTIONS.GET_USER_FAILURE */.aO.GET_USER_FAILURE:
            return userReducer_objectSpread({}, state, {
                loading: false,
                sessionChecked: true,
                error: action.err
            });
        case user/* ACTIONS.RESET_PASSWORD_FAILURE */.aO.RESET_PASSWORD_FAILURE:
        case user/* ACTIONS.PUT_USER_ORDER_FAILURE */.aO.PUT_USER_ORDER_FAILURE:
        case user/* ACTIONS.GET_USER_CARDS_FAILURE */.aO.GET_USER_CARDS_FAILURE:
        case user/* ACTIONS.POST_USER_CARD_FAILURE */.aO.POST_USER_CARD_FAILURE:
            return userReducer_objectSpread({}, state, {
                loading: false,
                error: action.err
            });
        case user/* ACTIONS.VERIFY_USER_FAILURE */.aO.VERIFY_USER_FAILURE:
            return userReducer_objectSpread({}, state, {
                loading: false,
                userVerified: false,
                error: action.err
            });
        case user/* ACTIONS.DELETE_USER_SUCCESS */.aO.DELETE_USER_SUCCESS:
        case user/* ACTIONS.DELETE_GHOST_USER */.aO.DELETE_GHOST_USER:
            return {
                loading: false,
                loginInProgress: false,
                sessionChecked: true,
                isLoggedIn: false
            };
        default:
            return state;
    }
};
/* harmony default export */ var reducers_userReducer = (userReducer);

;// CONCATENATED MODULE: ./redux/reducers/checkoutReducer.tsx
function checkoutReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function checkoutReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            checkoutReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var checkoutReducer_initialProductsState = {
    loading: false
};
var checkoutReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : checkoutReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'POST_CHECKOUT_REQUEST':
            return checkoutReducer_objectSpread({}, state, {
                loading: true
            });
        case 'POST_CHECKOUT_SUCCESS':
            return checkoutReducer_objectSpread({}, state, {
                loading: false,
                pdfResponse: action.data
            });
        case 'POST_CHECKOUT_FAILURE':
            return checkoutReducer_objectSpread({}, state, {
                loading: false,
                error: action.err
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_checkoutReducer = (checkoutReducer);

;// CONCATENATED MODULE: ./redux/reducers/pickingPlaceReducer.tsx
function pickingPlaceReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function pickingPlaceReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            pickingPlaceReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var pickingPlaceReducer_initialProductsState = {
    loading: false
};
var pickingplaceReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : pickingPlaceReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'GET_PICKING_PLACE_REQUEST':
            return pickingPlaceReducer_objectSpread({}, state, {
                loading: true
            });
        case 'GET_PICKING_PLACE_SUCCESS':
            return pickingPlaceReducer_objectSpread({}, state, {
                loading: false,
                items: action.pickingPlace
            });
        case 'GET_PICKING_PLACE_FAILURE':
            return pickingPlaceReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        default:
            return state;
    }
};
/* harmony default export */ var pickingPlaceReducer = (pickingplaceReducer);

// EXTERNAL MODULE: ./redux/adapter/packs/packAdapter.tsx + 3 modules
var packAdapter = __webpack_require__(52404);
;// CONCATENATED MODULE: ./redux/reducers/packsReducer.ts

function packsReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function packsReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            packsReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var packsReducer_initialProductsState = {
    loading: false
};
var packsReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : packsReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'GET_PACKS_BY_PACK_TAXON_ID_REQUEST':
            return packsReducer_objectSpread({}, state, {
                loading: true
            });
        case 'GET_PACKS_BY_PACK_TAXON_ID_SUCCESS':
            return packsReducer_objectSpread({}, state, {
                loading: false,
                items: action.packs.map(function(pack) {
                    return (0,packAdapter/* PackAdapter */.O)(pack);
                })
            });
        case 'SAVE_CURRENT_PACK':
            return packsReducer_objectSpread({}, state, {
                loading: false,
                items: action.currentPack.map(function(currentPack) {
                    return (0,packAdapter/* PackAdapter */.O)(currentPack);
                })
            });
        case 'SAVE_PACK_ORIGIN':
            return packsReducer_objectSpread({}, state, {
                loading: false,
                origin: action.origin
            });
        case 'DELETE_PACK_ORIGIN':
            {
                var temp = packsReducer_objectSpread({}, state);
                delete temp['origin'];
                return temp;
            }
        case 'GET_PACKS_BY_PACK_TAXON_ID_FAILURE':
            return packsReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_packsReducer = (packsReducer);

;// CONCATENATED MODULE: ./redux/reducers/taxonPackReducer.ts
function taxonPackReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function taxonPackReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            taxonPackReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var taxonPackReducer_initialProductsState = {
    loading: false
};
var taxonPacksReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : taxonPackReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'GET_PACKS_TAXONS_REQUEST':
            return taxonPackReducer_objectSpread({}, state, {
                loading: true
            });
        case 'GET_PACKS_TAXONS_SUCCESS':
            return taxonPackReducer_objectSpread({}, state, {
                loading: false,
                items: action.taxonPack
            });
        case 'GET_PACKS_TAXONS_FAILURE':
            return taxonPackReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        default:
            return state;
    }
};
/* harmony default export */ var taxonPackReducer = (taxonPacksReducer);

;// CONCATENATED MODULE: ./redux/reducers/addressUserReducer.tsx
function addressUserReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function addressUserReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            addressUserReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var addressUserReducer_initialProductsState = {
    loading: false
};
var addressUserReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : addressUserReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'GET_ADDRESS_USER_REQUEST':
        case 'POST_ADDRESS_USER_REQUEST':
        case 'PUT_ADDRESS_USER_REQUEST':
            return addressUserReducer_objectSpread({}, state, {
                loading: true
            });
        case 'GET_ADDRESS_USER_SUCCESS':
        case 'POST_ADDRESS_USER_SUCCESS':
        case 'PUT_ADDRESS_USER_SUCCESS':
            return addressUserReducer_objectSpread({}, state, {
                loading: false,
                items: action.address
            });
        case 'GET_ADDRESS_USER_FAILURE':
        case 'POST_ADDRESS_USER_FAILURE':
        case 'PUT_ADDRESS_USER_FAILURE':
            return addressUserReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_addressUserReducer = (addressUserReducer);

;// CONCATENATED MODULE: ./redux/reducers/stockReducer.ts

function stockReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function stockReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            stockReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var stockReducer_initialProductsState = {
    loading: true,
    stock: []
};
var stockReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : stockReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case products/* ACTIONS.GET_STOCK_REQUEST */.aO.GET_STOCK_REQUEST:
            return stockReducer_objectSpread({}, state, {
                loading: true
            });
        case products/* ACTIONS.GET_STOCK_BASKET_REQUEST */.aO.GET_STOCK_BASKET_REQUEST:
            return stockReducer_objectSpread({}, state, {
                loadingBasket: true
            });
        case products/* ACTIONS.NO_STOCK_REQUEST */.aO.NO_STOCK_REQUEST:
            return stockReducer_objectSpread({}, state, {
                loading: false
            });
        case products/* ACTIONS.GET_STOCK_SUCCESS */.aO.GET_STOCK_SUCCESS:
            {
                var currentStock = state.stock;
                var incomingStock = action.stock;
                var stockMap = new Map(currentStock.map(function(item) {
                    return [
                        item.lizeeSKU,
                        item
                    ];
                }));
                // mix currentStock and incoming stock answer
                incomingStock.forEach(function(item) {
                    stockMap.set(item.lizeeSKU, item);
                });
                // Remove doublons
                var uniqueStock = Array.from(stockMap.values());
                return stockReducer_objectSpread({}, state, {
                    loading: false,
                    stock: uniqueStock,
                    stockMap: stockMap,
                    error: undefined
                });
            }
        case products/* ACTIONS.GET_STOCK_BASKET_SUCCESS */.aO.GET_STOCK_BASKET_SUCCESS:
            return stockReducer_objectSpread({}, state, {
                loadingBasket: false,
                stockBasket: action.stockBasket,
                error: undefined
            });
        case products/* ACTIONS.GET_STOCK_FAILURE */.aO.GET_STOCK_FAILURE:
        case products/* ACTIONS.GET_STOCK_BASKET_FAILURE */.aO.GET_STOCK_BASKET_FAILURE:
            var ref;
            return stockReducer_objectSpread({}, state, {
                loading: false,
                error: (ref = action.err) === null || ref === void 0 ? void 0 : ref.code
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_stockReducer = (stockReducer);

;// CONCATENATED MODULE: ./redux/reducers/promotionsReducer.tsx
function promotionsReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function promotionsReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            promotionsReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var promotionsReducer_initialProductsState = {
    loading: false,
    items: [],
    fetched: false
};
var promotionsReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : promotionsReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'GET_PROMOTIONS_REQUEST':
            return promotionsReducer_objectSpread({}, state, {
                loading: true
            });
        case 'GET_PROMOTIONS_SUCCESS':
            return promotionsReducer_objectSpread({}, state, {
                loading: false,
                items: action.promotions,
                fetched: true
            });
        case 'SET_FUTUR_PRICE':
            return promotionsReducer_objectSpread({}, state, {
                loading: false,
                futurPrice: action.price
            });
        case 'SET_CURRENT_PROMOTION':
            return promotionsReducer_objectSpread({}, state, {
                loading: false,
                currentPromotion: action.currentPromotion
            });
        case 'GET_PROMOTIONS_FAILURE':
            return promotionsReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_promotionsReducer = (promotionsReducer);

;// CONCATENATED MODULE: ./redux/reducers/inStoreReducer.tsx
function inStoreReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function inStoreReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            inStoreReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var initialState = {
    stores: {}
};
var inStoreReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'SAVE_CHOSEN_STORE':
            return inStoreReducer_objectSpread({}, state, {
                selectedStore: action.selectedStore
            });
        case 'DELETE_CHOSEN_STORE':
            return inStoreReducer_objectSpread({}, state.stores, {
                deleteOrigin: action.deleteOrigin
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_inStoreReducer = (inStoreReducer);

;// CONCATENATED MODULE: ./redux/reducers/orderReducer.tsx
function orderReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function orderReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            orderReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var orderReducer_initialProductsState = {
    loading: false,
    returningReasons: []
};
var orderReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : orderReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'POST_PRODUCT_TO_RETURN_REQUEST':
        case 'GET_ORDER_INVOICE_REQUEST':
        case 'GET_PRODUCT_RETURNING_REASONS_REQUEST':
            return orderReducer_objectSpread({}, state, {
                loading: true
            });
        case 'SAVE_PRODUCT_TO_RETURN_SUCCESS':
            return orderReducer_objectSpread({}, state, {
                loading: false,
                items: action.response
            });
        case 'POST_PRODUCT_TO_RETURN_SUCCESS':
            return orderReducer_objectSpread({}, state, {
                loading: false,
                pdfResponse: action.response,
                hasReturned: true
            });
        case 'GET_ORDER_INVOICE_SUCCESS':
            return orderReducer_objectSpread({}, state, {
                loading: false,
                invoice: action.invoice
            });
        case 'GET_PRODUCT_RETURNING_REASONS_SUCCESS':
            return orderReducer_objectSpread({}, state, {
                loading: false,
                returningReasons: action.response
            });
        case 'POST_PRODUCT_TO_RETURN_FAILURE':
            return orderReducer_objectSpread({}, state, {
                loading: false,
                error: action.error,
                hasReturned: false
            });
        case 'GET_USER_INVOICE_FAILURE':
        case 'GET_PRODUCT_RETURNING_REASONS_FAILURE':
            {
                return orderReducer_objectSpread({}, state, {
                    loading: false,
                    error: action.err
                });
            }
        default:
            return state;
    }
};
/* harmony default export */ var reducers_orderReducer = (orderReducer);

;// CONCATENATED MODULE: ./redux/reducers/reviewsReducer.tsx
function reviewsReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reviewsReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            reviewsReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var reviewsReducer_initialProductsState = {
    loading: false,
    hasReturned: false,
    items: []
};
var reviewsReducer_promotionsReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : reviewsReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    var reviews = reviewsReducer_objectSpread({}, state);
    switch(action.type){
        case 'GET_REVIEWS_USER_REQUEST':
        case 'POST_REVIEWS_USER_REQUEST':
            return reviewsReducer_objectSpread({}, state, {
                loading: true
            });
        case 'GET_REVIEWS_USER_SUCCESS':
            if (action.reviews.length > 0 && !reviews.items.find(function(item) {
                return item.sku === action.reviews[0].sku;
            })) {
                reviews.items.push(action.reviews[0]);
            }
            return reviewsReducer_objectSpread({}, state, {
                loading: false,
                items: reviews.items
            });
        case 'POST_REVIEWS_USER_SUCCESS':
            return reviewsReducer_objectSpread({}, state, {
                loading: false,
                items: action.response,
                hasReturned: true
            });
        case 'GET_REVIEWS_USER_FAILURE':
        case 'POST_REVIEWS_USER_FAILURE':
            return reviewsReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        default:
            return state;
    }
};
/* harmony default export */ var reviewsReducer = (reviewsReducer_promotionsReducer);

;// CONCATENATED MODULE: ./redux/reducers/parametersReducer.tsx
function parametersReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function parametersReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            parametersReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var parametersReducer_initialProductsState = {
    loading: false
};
var parameterReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : parametersReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'GET_PARAMETERS_REQUEST':
        case 'GET_COUNTRIES_REQUEST':
            return parametersReducer_objectSpread({}, state, {
                loading: true
            });
        case 'GET_PARAMETERS_SUCCESS':
            return parametersReducer_objectSpread({}, state, {
                loading: false,
                items: action.parameters
            });
        case 'GET_COUNTRIES_SUCCESS':
            return parametersReducer_objectSpread({}, state, {
                loading: false,
                countries: action.countries
            });
        case 'GET_PARAMETERS_FAILURE':
        case 'GET_COUNTRIES_FAILURE':
            return parametersReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        default:
            return state;
    }
};
/* harmony default export */ var parametersReducer = (parameterReducer);

;// CONCATENATED MODULE: ./redux/reducers/contractReducer.tsx
function contractReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function contractReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            contractReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var initialContractState = {
    loading: false
};
var contractReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialContractState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'GET_IN_PROGRESS_CONTRACT_CSUB_REQUEST':
        case 'GET_IN_PROGRESS_CONTRACT_SUB_REQUEST':
            return contractReducer_objectSpread({}, state, {
                loading: true
            });
        case 'GET_IN_PROGRESS_CONTRACT_CSUB_SUCCESS':
        case 'GET_IN_PROGRESS_CONTRACT_SUB_SUCCESS':
            return contractReducer_objectSpread({}, state, {
                loading: false,
                items: action.currentContract
            });
        case 'GET_IN_PROGRESS_CONTRACT_CSUB_FAILURE':
        case 'GET_IN_PROGRESS_CONTRACT_SUB_FAILURE':
            return contractReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_contractReducer = (contractReducer);

// EXTERNAL MODULE: ./redux/reducers/addressReducer.tsx
var addressReducer = __webpack_require__(63593);
;// CONCATENATED MODULE: ./redux/reducers/SSOreducer.tsx
function SSOreducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SSOreducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SSOreducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SSOreducer_initialProductsState = {
    loading: false,
    items: {
        token_type: '',
        expires_in: '',
        access_token: '',
        scope: '',
        refresh_token: '',
        id_token: ''
    }
};
var SSOReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SSOreducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'GET_TOKEN_REQUEST':
            return SSOreducer_objectSpread({}, state, {
                loading: true
            });
        case 'GET_TOKEN_SUCCESS':
            return SSOreducer_objectSpread({}, state, {
                loading: false,
                items: action.token
            });
        case 'GET_TOKEN_FAILURE':
            return SSOreducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        default:
            return state;
    }
};
/* harmony default export */ var SSOreducer = (SSOReducer);

// EXTERNAL MODULE: ./redux/actions/takeBack.ts + 1 modules
var takeBack = __webpack_require__(42738);
;// CONCATENATED MODULE: ./redux/reducers/takeBackReducer.tsx

function takeBackReducer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function takeBackReducer_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return takeBackReducer_arrayLikeToArray(arr);
}
function takeBackReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function takeBackReducer_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function takeBackReducer_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function takeBackReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            takeBackReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function takeBackReducer_toConsumableArray(arr) {
    return takeBackReducer_arrayWithoutHoles(arr) || takeBackReducer_iterableToArray(arr) || takeBackReducer_unsupportedIterableToArray(arr) || takeBackReducer_nonIterableSpread();
}
function takeBackReducer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return takeBackReducer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return takeBackReducer_arrayLikeToArray(o, minLen);
}
var initialTakeBackState = {
    loading: false
};
var takeBackReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialTakeBackState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case takeBack/* ACTIONS.POST_TAKE_BACK_INFO_REQUEST */.aO.POST_TAKE_BACK_INFO_REQUEST:
        case takeBack/* ACTIONS.GET_TAKE_BACK_REFERENCE_REQUEST */.aO.GET_TAKE_BACK_REFERENCE_REQUEST:
        case takeBack/* ACTIONS.GET_TAKE_BACK_ID_REQUEST */.aO.GET_TAKE_BACK_ID_REQUEST:
        case takeBack/* ACTIONS.GET_TAKE_BACK_STOCK_REQUEST */.aO.GET_TAKE_BACK_STOCK_REQUEST:
        case takeBack/* ACTIONS.GET_USER_TAKE_BACK_PRODUCTS_REQUEST */.aO.GET_USER_TAKE_BACK_PRODUCTS_REQUEST:
        case takeBack/* ACTIONS.GET_RIGHT_OF_WITHDRAWAL_INFO_REQUEST */.aO.GET_RIGHT_OF_WITHDRAWAL_INFO_REQUEST:
            return takeBackReducer_objectSpread({}, state, {
                loading: true
            });
        case takeBack/* ACTIONS.POST_TAKE_BACK_INFO_SUCCESS */.aO.POST_TAKE_BACK_INFO_SUCCESS:
        case takeBack/* ACTIONS.GET_TAKE_BACK_REFERENCE_SUCCESS */.aO.GET_TAKE_BACK_REFERENCE_SUCCESS:
        case takeBack/* ACTIONS.GET_TAKE_BACK_ID_SUCCESS */.aO.GET_TAKE_BACK_ID_SUCCESS:
        case takeBack/* ACTIONS.GET_USER_TAKE_BACK_PRODUCTS_SUCCESS */.aO.GET_USER_TAKE_BACK_PRODUCTS_SUCCESS:
            return takeBackReducer_objectSpread({}, state, {
                loading: false,
                response: action.response
            });
        case takeBack/* ACTIONS.GET_TAKE_BACK_STOCK_SUCCESS */.aO.GET_TAKE_BACK_STOCK_SUCCESS:
            {
                var takeBackStock = state.takeBackStock ? takeBackReducer_toConsumableArray(state.takeBackStock).concat(takeBackReducer_toConsumableArray(action.response)) : action.response;
                var takeBackStockMap = new Map(takeBackStock.map(function(item) {
                    return [
                        item.lizeeSKU,
                        item
                    ];
                }));
                return takeBackReducer_objectSpread({}, state, {
                    loading: false,
                    takeBackStock: takeBackStock,
                    takeBackStockMap: takeBackStockMap
                });
            }
        case takeBack/* ACTIONS.GET_RIGHT_OF_WITHDRAWAL_INFO_SUCCESS */.aO.GET_RIGHT_OF_WITHDRAWAL_INFO_SUCCESS:
            return takeBackReducer_objectSpread({}, state, {
                loading: false,
                withdrawalInfo: action.response
            });
        case takeBack/* ACTIONS.POST_TAKE_BACK_INFO_FAILURE */.aO.POST_TAKE_BACK_INFO_FAILURE:
        case takeBack/* ACTIONS.GET_TAKE_BACK_REFERENCE_FAILURE */.aO.GET_TAKE_BACK_REFERENCE_FAILURE:
        case takeBack/* ACTIONS.GET_TAKE_BACK_ID_FAILURE */.aO.GET_TAKE_BACK_ID_FAILURE:
        case takeBack/* ACTIONS.GET_TAKE_BACK_STOCK_FAILURE */.aO.GET_TAKE_BACK_STOCK_FAILURE:
        case takeBack/* ACTIONS.GET_USER_TAKE_BACK_PRODUCTS_FAILURE */.aO.GET_USER_TAKE_BACK_PRODUCTS_FAILURE:
        case takeBack/* ACTIONS.GET_RIGHT_OF_WITHDRAWAL_INFO_FAILURE */.aO.GET_RIGHT_OF_WITHDRAWAL_INFO_FAILURE:
            return takeBackReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_takeBackReducer = (takeBackReducer);

// EXTERNAL MODULE: ./redux/actions/reservations.ts + 1 modules
var reservations = __webpack_require__(92324);
;// CONCATENATED MODULE: ./redux/reducers/reservationsReducer.ts

function reservationsReducer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function reservationsReducer_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return reservationsReducer_arrayLikeToArray(arr);
}
function reservationsReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reservationsReducer_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function reservationsReducer_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function reservationsReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            reservationsReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function reservationsReducer_toConsumableArray(arr) {
    return reservationsReducer_arrayWithoutHoles(arr) || reservationsReducer_iterableToArray(arr) || reservationsReducer_unsupportedIterableToArray(arr) || reservationsReducer_nonIterableSpread();
}
function reservationsReducer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return reservationsReducer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return reservationsReducer_arrayLikeToArray(o, minLen);
}
var initialReservationsState = {
    items: [],
    loading: false,
    creating: false,
    error: undefined,
    releasingIds: []
};
var reservationsReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialReservationsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case reservations/* ACTIONS.GET_RESERVATIONS_REQUEST */.aO.GET_RESERVATIONS_REQUEST:
            return reservationsReducer_objectSpread({}, state, {
                loading: true,
                error: undefined
            });
        case reservations/* ACTIONS.GET_RESERVATIONS_SUCCESS */.aO.GET_RESERVATIONS_SUCCESS:
            return reservationsReducer_objectSpread({}, state, {
                loading: false,
                items: action.items || []
            });
        case reservations/* ACTIONS.GET_RESERVATIONS_FAILURE */.aO.GET_RESERVATIONS_FAILURE:
            return reservationsReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        case reservations/* ACTIONS.RELEASE_RESERVATION_REQUEST */.aO.RELEASE_RESERVATION_REQUEST:
            return reservationsReducer_objectSpread({}, state, {
                releasingIds: reservationsReducer_toConsumableArray(state.releasingIds).concat([
                    action.id
                ])
            });
        case reservations/* ACTIONS.RELEASE_RESERVATION_SUCCESS */.aO.RELEASE_RESERVATION_SUCCESS:
            return reservationsReducer_objectSpread({}, state, {
                items: state.items.filter(function(item) {
                    return item.id !== action.id;
                }),
                releasingIds: state.releasingIds.filter(function(id) {
                    return id !== action.id;
                })
            });
        case reservations/* ACTIONS.RELEASE_RESERVATION_FAILURE */.aO.RELEASE_RESERVATION_FAILURE:
            return reservationsReducer_objectSpread({}, state, {
                error: action.error,
                releasingIds: state.releasingIds.filter(function(id) {
                    return id !== action.id;
                })
            });
        case reservations/* ACTIONS.CREATE_RESERVATION_REQUEST */.aO.CREATE_RESERVATION_REQUEST:
            return reservationsReducer_objectSpread({}, state, {
                creating: true,
                error: undefined
            });
        case reservations/* ACTIONS.CREATE_RESERVATION_SUCCESS */.aO.CREATE_RESERVATION_SUCCESS:
            return reservationsReducer_objectSpread({}, state, {
                creating: false,
                items: [
                    action.item
                ].concat(reservationsReducer_toConsumableArray(state.items))
            });
        case reservations/* ACTIONS.CREATE_RESERVATION_FAILURE */.aO.CREATE_RESERVATION_FAILURE:
            return reservationsReducer_objectSpread({}, state, {
                creating: false,
                error: action.error
            });
        case reservations/* ACTIONS.RESET_RESERVATIONS */.aO.RESET_RESERVATIONS:
            return reservationsReducer_objectSpread({}, initialReservationsState);
        default:
            return state;
    }
};
/* harmony default export */ var reducers_reservationsReducer = (reservationsReducer);

;// CONCATENATED MODULE: ./redux/reducers/basketReducer.tsx
function basketReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function basketReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            basketReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var basketReducer_initialState = {
    showBasketDetails: false,
    noMixedBasketModalIsOpen: false
};
var basketReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : basketReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'SET_SHOW_BASKET':
            return basketReducer_objectSpread({}, state, {
                showBasketDetails: action.isOpen
            });
        case 'SET_OPEN_NO_MIXED_BASKET_MODAL':
            return basketReducer_objectSpread({}, state, {
                noMixedBasketModalIsOpen: action.isOpen
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_basketReducer = (basketReducer);

;// CONCATENATED MODULE: ./redux/reducers/prismicReducer.tsx
function prismicReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function prismicReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            prismicReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var prismicReducer_initialState = {};
var prismicReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : prismicReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'SAVE_PRISMIC_DOCUMENTS':
            return prismicReducer_objectSpread({}, state, action.data);
        default:
            return state;
    }
};
/* harmony default export */ var reducers_prismicReducer = (prismicReducer);

;// CONCATENATED MODULE: ./redux/reducers/paymentReducer.tsx
function paymentReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function paymentReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            paymentReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var paymentReducer_initialProductsState = {
    loading: false
};
var paymentReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : paymentReducer_initialProductsState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'POST_DAD_PAYMENT_REQUEST':
        case 'POST_SUB_PAYMENT_REQUEST':
            return {
                loading: true
            };
        case 'POST_DAD_PAYMENT_SUCCESS':
        case 'POST_SUB_PAYMENT_SUCCESS':
            return paymentReducer_objectSpread({
                loading: false
            }, action.paymentResult);
        case 'POST_DAD_PAYMENT_FAILURE':
        case 'POST_SUB_PAYMENT_FAILURE':
            return {
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
};
/* harmony default export */ var reducers_paymentReducer = (paymentReducer);

;// CONCATENATED MODULE: ./redux/reducers/shopPageReducer.ts
function shopPageReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function shopPageReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            shopPageReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var shopPageReducer_initialState = {
    items: [],
    loading: false,
    currentSlug: '',
    isCumulative: false,
    savedState: null
};
var shopPageReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : shopPageReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'SAVE_SHOP_STATE':
            return shopPageReducer_objectSpread({}, state, {
                savedState: shopPageReducer_objectSpread({}, action.payload, {
                    timestamp: Date.now()
                })
            });
        case 'RESTORE_SHOP_STATE':
            return shopPageReducer_objectSpread({}, state, {
                savedState: null
            });
        // ... rest of your existing cases
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./redux/actions/swikly.tsx
var swikly = __webpack_require__(64918);
;// CONCATENATED MODULE: ./redux/reducers/swiklyReducer.tsx

function swiklyReducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function swiklyReducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            swiklyReducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var swiklyReducer_initialState = {
    loading: false,
    error: null,
    creationResponse: undefined,
    cautionDetails: undefined
};
/**
 * Reducer for Swikly operations
 * Handles state updates for creating cautions and getting caution status
 * @param state - Current state
 * @param action - Action to process
 * @returns Updated state
 */ var swiklyReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : swiklyReducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case swikly/* ACTIONS.CREATE_SWIKLY_CAUTION_REQUEST */.aO.CREATE_SWIKLY_CAUTION_REQUEST:
            return swiklyReducer_objectSpread({}, state, {
                loading: true,
                error: null
            });
        case swikly/* ACTIONS.CREATE_SWIKLY_CAUTION_SUCCESS */.aO.CREATE_SWIKLY_CAUTION_SUCCESS:
            return swiklyReducer_objectSpread({}, state, {
                loading: false,
                creationResponse: action.payload,
                error: null
            });
        case swikly/* ACTIONS.CREATE_SWIKLY_CAUTION_FAILURE */.aO.CREATE_SWIKLY_CAUTION_FAILURE:
            return swiklyReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        case swikly/* ACTIONS.GET_SWIKLY_CAUTION_STATUS_REQUEST */.aO.GET_SWIKLY_CAUTION_STATUS_REQUEST:
            return swiklyReducer_objectSpread({}, state, {
                loading: true,
                error: null
            });
        case swikly/* ACTIONS.GET_SWIKLY_CAUTION_STATUS_SUCCESS */.aO.GET_SWIKLY_CAUTION_STATUS_SUCCESS:
            return swiklyReducer_objectSpread({}, state, {
                loading: false,
                cautionDetails: action.payload.swik,
                error: null
            });
        case swikly/* ACTIONS.GET_SWIKLY_CAUTION_STATUS_FAILURE */.aO.GET_SWIKLY_CAUTION_STATUS_FAILURE:
            return swiklyReducer_objectSpread({}, state, {
                loading: false,
                error: action.error
            });
        default:
            return state;
    }
};
/* harmony default export */ var reducers_swiklyReducer = (swiklyReducer);

;// CONCATENATED MODULE: ./redux/reducers/rootReducer.tsx



























var rootReducer = (0,redux/* combineReducers */.UY)({
    products: reducers_productsReducer,
    pickingPlace: pickingPlaceReducer,
    taxons: reducers_taxonsReducer,
    stores: reducers_inStoreReducer,
    cart: reducers_cartReducer,
    addressUser: reducers_addressUserReducer,
    product: singleProductReducer,
    stock: reducers_stockReducer,
    contract: reducers_contractReducer,
    parameters: parametersReducer,
    promotions: reducers_promotionsReducer,
    user: reducers_userReducer,
    checkout: reducers_checkoutReducer,
    reviews: reviewsReducer,
    packs: reducers_packsReducer,
    taxonPack: taxonPackReducer,
    returnProducts: reducers_orderReducer,
    inputAddress: addressReducer/* default */.ZP,
    SSOdata: SSOreducer,
    takeBack: reducers_takeBackReducer,
    basket: reducers_basketReducer,
    prismic: reducers_prismicReducer,
    payment: reducers_paymentReducer,
    shopPage: shopPageReducer,
    swikly: reducers_swiklyReducer,
    reservations: reducers_reservationsReducer
});
/* harmony default export */ var reducers_rootReducer = (rootReducer);

;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ var redux_thunk_es = (thunk);
;// CONCATENATED MODULE: ./redux/store.tsx





function store_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function store_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            store_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var reducer = function(state, action) {
    if (action.type === HYDRATE) {
        var nextState = store_objectSpread({}, state, action.payload);
        return nextState;
    } else {
        return reducers_rootReducer(state, action);
    }
};
var initialStore = {};
var makeStore = function() {
    return (0,redux/* createStore */.MT)(reducer, initialStore, (0,redux_devtools_extension/* composeWithDevTools */.Uo)((0,redux/* applyMiddleware */.md)(redux_thunk_es)));
};
var wrapper = createWrapper(makeStore);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/ThemeContext.js
var ThemeContext = __webpack_require__(83800);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(159);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/ThemeProvider/nested.js
var nested = __webpack_require__(17076);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js






 // To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  return (0,esm_extends/* default */.Z)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = (0,useTheme/* default */.Z)();

  if (false) {}

  var theme = react.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[nested/* default */.Z] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/react.createElement(ThemeContext/* default.Provider */.Z.Provider, {
    value: theme
  }, children);
}

 false ? 0 : void 0;

if (false) {}

/* harmony default export */ var ThemeProvider_ThemeProvider = (ThemeProvider);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(18698);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-bundle.min.css
var swiper_bundle_min = __webpack_require__(72821);
// EXTERNAL MODULE: ./node_modules/glider-js/glider.min.css
var glider_min = __webpack_require__(25066);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
;// CONCATENATED MODULE: ./components/Global/Global.style.tsx
/* provided dependency */ var process = __webpack_require__(34155);


function Global_style_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Global_style_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Global_style_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Theme = __webpack_require__(24827);
var useStyles = (0,makeStyles/* default */.Z)(function() {
    return (0,createStyles/* default */.Z)({
        '@global': Global_style_objectSpread({
            // Handled now by CSSBaseLine Component. Keep it for extra customization but be aware, it's GLOBAL
            ':root': {
                '--swiper-theme-color': Theme.default.palette.primary.main
            },
            body: {
                overflowX: 'hidden'
            },
            a: {
                textDecoration: 'none',
                color: Theme.default.palette.primary.main
            },
            '.page-transition': {
                '&-enter': {
                    opacity: 0,
                    '&-active': {
                        opacity: 1,
                        transition: "opacity ".concat(utils/* TRANSITION_TIMEOUT */.HN, "ms")
                    }
                },
                '&-exit': {
                    opacity: 1,
                    transform: 'scale3d(1, 1, 1)',
                    '-active': {
                        opacity: 0,
                        transform: 'scale3d(0.99, 0.99, 1)',
                        transition: "opacity ".concat(utils/* TRANSITION_TIMEOUT */.HN, "ms, transform ").concat(utils/* TRANSITION_TIMEOUT */.HN, "ms")
                    }
                }
            },
            '.loading-indicator-appear, .loading-indicator-enter': {
                '&-appear, &-enter': {
                    opacity: 0,
                    '&-active': {
                        opacity: 1,
                        transition: "opacity ".concat(utils/* TRANSITION_TIMEOUT */.HN, "ms")
                    }
                }
            },
            '.page': {
                marginTop: function(LayoutStyle) {
                    if (LayoutStyle.isHomePage) return 0;
                    var height = Theme.default.sizes.desktopHeaderHeight || Theme.default.sizes.headerHeight;
                    return LayoutStyle.isDisplayedBannerOnAllPages ? height + 40 : height;
                },
                '&--home': {
                    marginTop: 0
                },
                '@media screen and (max-width: 1024px)': {
                    marginTop: function(LayoutStyle) {
                        if (LayoutStyle.isHomePage) return 0;
                        var _sizes = Theme.default.sizes, headerHeight = _sizes.headerHeight, bannerMargin = _sizes.bannerMargin;
                        if (LayoutStyle.isDisplayedBannerOnAllPages) return headerHeight + (bannerMargin !== null && bannerMargin !== void 0 ? bannerMargin : 60);
                        return headerHeight;
                    }
                }
            },
            '.size-card': {
                '&__quantity-selector': {
                    display: 'none'
                },
                '&__quantity-selector-taxon': {
                    display: 'none'
                }
            },
            '#more': {
                zIndex: 1,
                position: 'relative'
            },
            '[data-oembed-type=video]': {
                position: 'relative',
                paddingBottom: '56.25%',
                height: 0,
                '& iframe': {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%'
                }
            },
            '[data-ratio]': {
                display: 'block',
                overflow: 'hidden',
                position: 'relative',
                height: 0,
                '& img, &>.MuiSkeleton-rect': {
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                }
            }
        }, process.env.SHOP_PRODUCT_FULL_IMAGE === 'true' ? {
            '.productCard [data-ratio] img, .product__left [data-ratio] img': {
                objectFit: 'contain !important'
            }
        } : {}, {
            '[data-ratio=ar-1-1]': {
                paddingBottom: '100%'
            },
            '[data-ratio=ar-16-9]': {
                paddingBottom: '56.25%'
            },
            '[data-ratio=ar-4-3]': {
                paddingBottom: '75%'
            },
            '[data-ratio=ar-3-4]': {
                paddingBottom: '133%'
            },
            '[data-ratio=ar-2-3]': {
                paddingBottom: '150%'
            },
            '[data-ratio=ar-9-16]': {
                paddingBottom: '177.78%'
            },
            '.block-img >img': {
                display: 'inline-block',
                maxWidth: '100%',
                height: 'auto',
                margin: '0 auto'
            },
            '@media (prefers-reduced-motion: reduce)': {
                '*': {
                    animationDuration: '0.001ms !important',
                    animationIterationCount: '1 !important',
                    transitionDuration: '0.001ms !important'
                }
            },
            '.responsiveEmbed': {
                pointerEvents: 'none',
                '&__container': {
                    position: 'relative',
                    paddingTop: '100%',
                    '@media (min-aspect-ratio: 375/667)': {
                        paddingTop: '177.87%'
                    },
                    '@media (min-aspect-ratio: 1024/768)': {
                        paddingTop: '75%'
                    },
                    '@media (min-aspect-ratio: 16/9)': {
                        paddingTop: '56.25%'
                    }
                },
                '&__target': {
                    position: 'absolute',
                    top: 0,
                    left: 0
                }
            },
            '.react-datepicker': {
                fontFamily: 'inherit',
                border: 'transparent',
                color: Theme.default.palette.common.black,
                display: 'flex !important',
                borderBottomLeftRadius: Theme.default.shape.borderRadius,
                borderBottomRightRadius: Theme.default.shape.borderRadius,
                borderTopLeftRadius: Theme.default.shape.borderRadius,
                borderTopRightRadius: Theme.default.shape.borderRadius,
                '&--open': {
                    '& .header': {
                        zIndex: 1
                    },
                    '& .hero__home': {
                        overflow: 'initial',
                        '&:after': {
                            zIndex: 0
                        }
                    }
                },
                '&-wrapper': Global_style_defineProperty({
                    width: '40%',
                    '& input': {
                        width: '100%'
                    }
                }, Theme.default.breakpoints.up('md'), {
                    width: 128
                }),
                '&__header': {
                    border: 0,
                    padding: 0,
                    borderTopLeftRadius: Theme.default.shape.borderRadius,
                    borderTopRightRadius: Theme.default.shape.borderRadius,
                    backgroundColor: 'transparent'
                },
                '&__day, &__day-name': {
                    fontSize: 15,
                    width: '2rem',
                    height: '2rem',
                    lineHeight: '2rem',
                    color: Theme.default.palette.common.black,
                    '.react-datepicker__portal &': {
                        width: '2rem',
                        height: '2rem',
                        lineHeight: '2rem'
                    }
                },
                '&__day-name': {
                    fontWeight: 700,
                    fontSize: 14,
                    textTransform: 'capitalize'
                },
                '&__current-month': {
                    height: 44,
                    fontSize: 14,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textTransform: 'capitalize',
                    '.react-datepicker__portal &': {
                        fontSize: 14
                    }
                },
                '&__month': {
                    margin: Theme.default.spacing(1, 3)
                },
                '&__navigation': {
                    top: 0,
                    height: 44,
                    border: 0,
                    width: 40,
                    backgroundColor: Theme.default.palette.secondary.main,
                    '&::before, &::after': {
                        content: '""',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translateX(-50%) translateY(-50%)',
                        width: 12,
                        height: 1,
                        background: Theme.default.palette.common.white
                    },
                    '&::before': {
                        marginTop: -4
                    },
                    '&::after': {
                        marginTop: 4
                    },
                    '&--previous': {
                        left: 0,
                        borderTopLeftRadius: Theme.default.shape.borderRadius,
                        borderBottomRightRadius: Theme.default.shape.borderRadius,
                        '&::before': {
                            transform: 'translateX(-50%) translateY(-50%) rotate(-45deg)'
                        },
                        '&::after': {
                            transform: 'translateX(-50%) translateY(-50%) rotate(45deg)'
                        }
                    },
                    '&--next': {
                        right: 0,
                        borderTopRightRadius: Theme.default.shape.borderRadius,
                        borderBottomLeftRadius: Theme.default.shape.borderRadius,
                        '&::before': {
                            transform: 'translateX(-50%) translateY(-50%) rotate(45deg)'
                        },
                        '&::after': {
                            transform: 'translateX(-50%) translateY(-50%) rotate(-45deg)'
                        }
                    },
                    '&>.react-datepicker__navigation-icon': {
                        display: 'none'
                    }
                }
            },
            '.react-datepicker-popper': {
                top: 0,
                left: 0,
                boxShadow: 'none'
            },
            '.react-datepicker-popper--no-triangle': {
                border: 0,
                '& .react-datepicker__triangle': {
                    display: 'none'
                },
                '&.react-datepicker-popper[data-placement^="top"]': {
                    marginBottom: 0
                },
                '&.react-datepicker-popper[data-placement^="bottom"]': {
                    marginTop: 0
                }
            },
            '.react-datepicker__portal .react-datepicker__navigation': {
                border: 0
            },
            '.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before, .react-datepicker__month-read-view--down-arrow::before, .react-datepicker__month-year-read-view--down-arrow::before': {
                borderBottomColor: 'transparent'
            },
            '.react-datepicker__day, .react-datepicker__month-text, .react-datepicker__quarter-text, .react-datepicker__year-text': {
                borderRadius: '50%',
                '&:hover': {
                    borderRadius: '50%',
                    backgroundColor: Theme.default.extraColors.greyMedium
                },
                '&:focus': {
                    outlineColor: Theme.default.extraColors.greyLight,
                    outlineOffset: 3
                },
                '&--highlighted': {
                    backgroundColor: Theme.default.extraColors.grey,
                    '&:hover': {
                        backgroundColor: Theme.default.extraColors.greyMedium
                    }
                },
                '&--selected, &--in-selecting-range, &--in-range': {
                    backgroundColor: Theme.default.palette.secondary.main,
                    color: Theme.default.palette.common.white,
                    '&:hover': {
                        color: Theme.default.palette.common.black,
                        backgroundColor: Theme.default.extraColors.greyMedium
                    }
                },
                '&--keyboard-selected': {
                    background: 'none'
                },
                '&--today': {
                    color: Theme.default.palette.common.white,
                    backgroundColor: Theme.default.palette.secondary.main
                },
                '&--in-selecting-range:not(&--in-range)': {
                    color: Theme.default.palette.common.black,
                    backgroundColor: Theme.default.extraColors.greyLight
                },
                '&--in-range:not(&--in-selecting-range)': {
                    '.react-datepicker__month--selecting-range & ': {
                        color: Theme.default.palette.common.black,
                        backgroundColor: Theme.default.extraColors.greyLight
                    }
                },
                '&--disabled': {
                    opacity: 0.5,
                    color: Theme.default.extraColors.grey,
                    cursor: 'not-allowed',
                    '&:hover': {
                        backgroundColor: 'transparent',
                        cursor: 'not-allowed'
                    },
                    '&--in-range': {
                        color: Theme.default.palette.common.white,
                        backgroundColor: Theme.default.palette.secondary.main
                    }
                }
            },
            '.swiper-container>.swiper-pagination': {
                bottom: 0,
                '& .swiper-pagination': {
                    '&-bullet': {
                        opacity: 1,
                        backgroundColor: 'transparent',
                        border: "1px solid ".concat(Theme.default.palette.secondary.main),
                        '&-active': {
                            backgroundColor: Theme.default.palette.secondary.main,
                            borderColor: Theme.default.palette.secondary.main
                        }
                    }
                },
                '&.swiper-pagination-active': {
                    backgroundColor: Theme.default.palette.secondary.main
                }
            },
            '.glider': {
                '&-next, &-prev': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    fontSize: '1em',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    boxShadow: Theme.default.shadows[1],
                    backgroundColor: Theme.default.palette.common.white,
                    color: Theme.default.palette.common.black,
                    transitionDuration: Theme.default.transitions.duration.standard,
                    transitionTimingFunction: Theme.default.transitions.easing.sharp,
                    '&:hover, &:focus': {
                        color: 'currentColor'
                    },
                    '&.disabled': {
                        opacity: 0.3,
                        color: 'currentColor'
                    },
                    '@media screen and (min-width: 1024px)': {
                        width: 40,
                        height: 40
                    }
                },
                '&-next': {
                    right: Theme.default.spacing(1)
                },
                '&-prev': {
                    left: Theme.default.spacing(1)
                },
                '&-slide': {
                    minWidth: 0
                }
            },
            '.flexContent': {
                display: 'flex',
                flexDirection: 'column'
            },
            '.fade': {
                transition: 'opacity .25s ease-in'
            },
            '.spck': {
                '&-list': {
                    '.page &': {
                        justifyContent: 'center'
                    }
                },
                '&-watch-button': {
                    '.page &': {
                        cursor: 'pointer',
                        color: "".concat(Theme.default.palette.primary.contrastText, " !important"),
                        backgroundColor: "".concat(Theme.default.palette.primary.main, " !important"),
                        '&:hover, &:focus': {
                            color: "".concat(Theme.default.palette.primary.contrastText, " !important"),
                            backgroundColor: "".concat(Theme.default.palette.primary.dark, " !important")
                        }
                    }
                }
            },
            '.MuiBreadcrumbs-separator': {
                color: Theme.default.palette.common.black,
                fontSize: '1.5em',
                position: 'relative',
                top: -2
            },
            '.MuiButtonBase-root[aria-label="..."]': {
                backgroundColor: 'transparent',
                color: Theme.default.palette.common.black,
                margin: 0,
                borderRadius: 0
            },
            '.MuiSelect': {
                '&-outlined': {
                    overflow: 'hidden !important',
                    borderRadius: '31px !important'
                },
                '&-iconOutlined': {
                    color: "".concat(Theme.default.palette.common.black, " !important")
                },
                '&-input': {
                    padding: '8px 14px !important',
                    color: Theme.default.palette.common.black
                }
            },
            '.MuiOutlinedInput': {
                '&-root': {
                    overflow: 'hidden !important',
                    borderRadius: '31px !important',
                    border: 'none !important',
                    minWidth: '130px !important',
                    '&.Mui-focused': {
                        border: 'none !important',
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '1px !important'
                        }
                    }
                },
                '&-notchedOutline': {
                    borderColor: "".concat(Theme.default.palette.common.black, " !important")
                },
                '&-input': {
                    padding: '8px 14px !important',
                    color: "".concat(Theme.default.palette.common.black, " !important")
                }
            },
            '.take-back-confirmation-modal': {
                '&__container': {
                    maxWidth: '700px !important'
                },
                '&__title': {
                    padding: '2rem 2rem 0.8rem 2rem !important',
                    textAlign: 'center!important',
                    fontWeight: '700!important',
                    fontSize: '.875rem!important',
                    lineHeight: '1.2rem!important',
                    letterSpacing: '1.3125px!important',
                    textTransform: 'uppercase!important',
                    position: 'relative!important'
                },
                '&__closeButton': {
                    position: 'absolute !important',
                    top: '0.4rem!important',
                    right: '0.4rem!important',
                    borderRadius: '2px !important'
                },
                '&__body': {
                    paddingRight: '2rem !important',
                    paddingLeft: '2rem !important',
                    textAlign: 'center!important',
                    lineHeight: '1.4rem!important',
                    fontSize: '.75rem!important',
                    fontWeight: '500!important'
                },
                '&__actions': {
                    paddingRight: '2rem !important',
                    paddingLeft: '2rem !important',
                    paddingBottom: '2rem !important',
                    justifyContent: 'center !important'
                },
                '&__actionButton': {
                    backgroundColor: 'black !important',
                    color: 'white !important',
                    padding: '0.844rem 1.8rem !important',
                    borderRadius: '4px !important',
                    width: '40%!important',
                    maxWidth: '300px!important',
                    textTransform: 'none !important',
                    fontSize: '.75rem!important'
                },
                '@media (max-width: 768px)': {
                    '&__actionButton': {
                        width: '100%!important'
                    }
                }
            },
            '.center': {
                textAlign: 'center'
            },
            '.right': {
                textAlign: 'right'
            },
            '.left': {
                textAlign: 'left'
            }
        })
    });
});
/* harmony default export */ var Global_style = (useStyles);

// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js
var notistack_esm = __webpack_require__(73400);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Card/Card.js







var styles = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  }
};
var Card = /*#__PURE__*/react.forwardRef(function Card(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$raised = props.raised,
      raised = _props$raised === void 0 ? false : _props$raised,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes", "className", "raised"]);

  return /*#__PURE__*/react.createElement(Paper/* default */.Z, (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : 1,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiCard'
})(Card));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckCircle.js
var CheckCircle = __webpack_require__(81395);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Cancel.js
var Cancel = __webpack_require__(47298);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Warning.js
var Warning = __webpack_require__(21727);
;// CONCATENATED MODULE: ./components/InformationChip/InformationChip.tsx







var InformationChip_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        snack: {
            backgroundColor: theme.palette.primary.main,
            borderRadius: theme.shape.borderRadius,
            color: "".concat(theme.palette.primary.contrastText, " !important"),
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            padding: theme.spacing(1),
            '& span, & b': {
                color: "".concat(theme.palette.primary.contrastText, " !important")
            }
        },
        checkIcon: {
            color: theme.palette.primary.contrastText,
            paddingRight: theme.spacing(0.5)
        },
        warningIcon: {
            color: theme.palette.primary.contrastText,
            paddingRight: theme.spacing(0.5)
        },
        cancelIcon: {
            color: theme.palette.primary.contrastText,
            cursor: 'pointer',
            paddingLeft: theme.spacing(0.5)
        },
        underline: {
            //textDecoration: 'underline',
            cursor: 'pointer'
        }
    });
});
var InformationChip = /*#__PURE__*/ react.forwardRef(function(props, ref1) {
    var classes = InformationChip_useStyles();
    var closeSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().closeSnackbar;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Card_Card, {
        ref: ref1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            variant: "body2",
            className: classes.snack,
            children: [
                props.message && props.message.message === 'add' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                            className: classes.checkIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                props.i18n.texts['snackbar_message'].add,
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classes.underline,
                                    onClick: function() {
                                        var ref;
                                        return (ref = document.getElementById('menu-toggler')) === null || ref === void 0 ? void 0 : ref.click();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: props.i18n.texts['snackbar_message'].cart
                                    })
                                }),
                                ' ',
                                "!"
                            ]
                        })
                    ]
                }),
                props.message && props.message.message === 'delete' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                            className: classes.warningIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                props.i18n.texts['snackbar_message'].delete,
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classes.underline,
                                    onClick: function() {
                                        var ref;
                                        return (ref = document.getElementById('menu-toggler')) === null || ref === void 0 ? void 0 : ref.click();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: props.i18n.texts['snackbar_message'].cart
                                    })
                                }),
                                ' ',
                                "!"
                            ]
                        })
                    ]
                }),
                props.message && props.message.message === 'remove' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                            className: classes.checkIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                props.i18n.texts['snackbar_message'].remove,
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classes.underline,
                                    onClick: function() {
                                        var ref;
                                        return (ref = document.getElementById('menu-toggler')) === null || ref === void 0 ? void 0 : ref.click();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: props.i18n.texts['snackbar_message'].cart
                                    })
                                }),
                                ' ',
                                "!"
                            ]
                        })
                    ]
                }),
                props.message && props.message.message === 'add-multiple' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                            className: classes.checkIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                props.i18n.texts['snackbar_message'].add_multiple,
                                "\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classes.underline,
                                    onClick: function() {
                                        var ref;
                                        return (ref = document.getElementById('menu-toggler')) === null || ref === void 0 ? void 0 : ref.click();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: props.i18n.texts['snackbar_message'].cart
                                    })
                                }),
                                ' ',
                                "!"
                            ]
                        })
                    ]
                }),
                props.message && props.message.message === 'limit' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                            className: classes.warningIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                props.i18n.texts['snackbar_message'].limit,
                                "\xa0"
                            ]
                        })
                    ]
                }),
                props.message && props.message.message === 'rental_range_selected_is_blocked' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                            className: classes.warningIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                props.i18n.texts['snackbar_message'].rental_range_selected_is_blocked,
                                "\xa0"
                            ]
                        })
                    ]
                }),
                props.message && props.message.message === 'profil-updated' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                            className: classes.warningIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                props.i18n.texts['snackbar_message'].profilUpdated,
                                "\xa0"
                            ]
                        })
                    ]
                }),
                props.message && props.message.message === 'max' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                            className: classes.warningIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                props.i18n.texts['snackbar_message'].max,
                                "\xa0"
                            ]
                        })
                    ]
                }),
                props.message && props.message.message === 'add tryout' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                            className: classes.checkIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                props.i18n.texts['snackbar_message'].add_tryout,
                                "\xa0"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel/* default */.Z, {
                    className: classes.cancelIcon,
                    onClick: function() {
                        return closeSnackbar(props.id);
                    }
                })
            ]
        })
    }));
});
/* harmony default export */ var InformationChip_InformationChip = (InformationChip);

// EXTERNAL MODULE: ./node_modules/next-page-transitions/lib/index.js
var lib = __webpack_require__(93504);
// EXTERNAL MODULE: ./components/Loader/Loader.tsx
var Loader = __webpack_require__(96149);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 1 modules
var i18next = __webpack_require__(3745);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/context.js + 1 modules
var context = __webpack_require__(57715);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(84314);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(13882);
;// CONCATENATED MODULE: ./node_modules/date-fns/esm/setDefaultOptions/index.js


/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param {Object} newOptions - an object with options.
 * @param {Locale} [newOptions.locale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [newOptions.weekStartsOn] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [newOptions.firstWeekContainsDate] - the day of January, which is always in the first week of the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */
function setDefaultOptions(newOptions) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var result = {};
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  for (var property in defaultOptions) {
    if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) {
      ;
      result[property] = defaultOptions[property];
    }
  }
  for (var _property in newOptions) {
    if (Object.prototype.hasOwnProperty.call(newOptions, _property)) {
      if (newOptions[_property] === undefined) {
        delete result[_property];
      } else {
        ;
        result[_property] = newOptions[_property];
      }
    }
  }
  (0,_lib_defaultOptions/* setDefaultOptions */.b)(result);
}
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/localizedFormat.js
var localizedFormat = __webpack_require__(56176);
var localizedFormat_default = /*#__PURE__*/__webpack_require__.n(localizedFormat);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
;// CONCATENATED MODULE: ./i18n.js
/* provided dependency */ var i18n_process = __webpack_require__(34155);







function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
dayjs_min_default().extend((localizedFormat_default()));
var loadDateFnsLocale = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(locale) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return __webpack_require__(71213)("./".concat(locale, "/index.js"));
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function loadDateFnsLocale(locale) {
        return _ref.apply(this, arguments);
    };
}();
function loadDayjsLocale(lng) {
    var locale = lng === 'en-US' ? 'en' : lng.toLowerCase();
    __webpack_require__(40408)("./".concat(locale)).then(function() {
        dayjs_min_default().locale(locale);
    }).catch(function(err) {
        console.error("Could not load Day.js locale for language: ".concat(locale), err);
    });
}
var i18NextLanguageChange = function(router) {
    return _asyncToGenerator(runtime_default().mark(function _callee() {
        var locale, lang, en_Region, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locale = router.locale;
                    lang = locale;
                    if (locale === 'en') {
                        en_Region = i18n_process.env.NEXT_PUBLIC_EN_REGION;
                        lang = "".concat(locale, "-").concat(en_Region && en_Region !== 'GB' ? en_Region : 'GB');
                    }
                    loadDayjsLocale(lang);
                    _ctx.next = 6;
                    return loadDateFnsLocale(lang);
                case 6:
                    data = _ctx.sent;
                    if (data) {
                        setDefaultOptions({
                            locale: data
                        });
                        (0,react_datepicker_min.registerLocale)(lang, data);
                    } else {
                        console.error("Could not load date-fns locale for language: ".concat(lang));
                    }
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
var i18nextInit = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(router, i18nResources) {
        var translations, namespaces;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (i18nResources) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    translations = i18nResources.translations, namespaces = i18nResources.namespaces;
                    if (!i18next/* default.isInitialized */.Z.isInitialized) {
                        i18next/* default.use */.Z.use(context/* initReactI18next */.Db).init({
                            lng: router.locale,
                            supportedLngs: router.locales,
                            fallbackLng: router.defaultLocale,
                            ns: namespaces,
                            react: {
                                useSuspense: false
                            }
                        });
                    }
                    i18next/* default.setDefaultNamespace */.Z.setDefaultNamespace(namespaces[0]);
                    if (i18next/* default.language */.Z.language !== router.locale || i18n_process.env.NEXT_PUBLIC_EN_REGION) {
                        i18next/* default.changeLanguage */.Z.changeLanguage(router.locale, i18NextLanguageChange(router));
                    }
                    namespaces.forEach(function(ns) {
                        if (!i18next/* default.hasResourceBundle */.Z.hasResourceBundle(router.locale, ns)) {
                            i18next/* default.addResourceBundle */.Z.addResourceBundle(router.locale, ns, translations[ns]);
                        }
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function i18nextInit(router, i18nResources) {
        return _ref.apply(this, arguments);
    };
}();
function getTranslations(locale, namespaces) {
    return _getTranslations.apply(this, arguments);
}
function _getTranslations() {
    _getTranslations = _asyncToGenerator(regeneratorRuntime.mark(function _callee(locale, namespaces) {
        var translations, shortLocale, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, ns, data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    translations = {};
                    shortLocale = locale.substring(0, 2);
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _ctx.prev = 3;
                    for(_iterator = namespaces[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        ns = _step.value;
                        data = __webpack_require__(34001)("./".concat(shortLocale, "/").concat(ns, ".json"));
                        translations[ns] = data;
                    }
                    _ctx.next = 11;
                    break;
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](3);
                    _didIteratorError = true;
                    _iteratorError = _ctx.t0;
                case 11:
                    _ctx.prev = 11;
                    _ctx.prev = 12;
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                case 14:
                    _ctx.prev = 14;
                    if (!_didIteratorError) {
                        _ctx.next = 17;
                        break;
                    }
                    throw _iteratorError;
                case 17:
                    return _ctx.finish(14);
                case 18:
                    return _ctx.finish(11);
                case 19:
                    return _ctx.abrupt("return", {
                        translations: translations,
                        namespaces: namespaces
                    });
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                7,
                11,
                19
            ],
            [
                12,
                ,
                14,
                18
            ]
        ]);
    }));
    return _getTranslations.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/imagekitio-react/dist/imagekitio-react.umd.js
var imagekitio_react_umd = __webpack_require__(1742);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.js + 107 modules
var main = __webpack_require__(60507);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-logs/esm/entries/main.js + 16 modules
var entries_main = __webpack_require__(67020);
// EXTERNAL MODULE: ./utils/gtag.ts
var gtag = __webpack_require__(65809);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
// EXTERNAL MODULE: ./typings/base.ts
var base = __webpack_require__(88039);
// EXTERNAL MODULE: ./node_modules/@prismicio/client/dist/index.js + 3 modules
var dist = __webpack_require__(73897);
;// CONCATENATED MODULE: ./node_modules/@prismicio/next/dist/lib/getPrismicPreviewCookie.js

const readValue = (value) => {
  return value.replace(/%3B/g, ";");
};
const getPrismicPreviewCookie = (cookieJar) => {
  const cookies = cookieJar.split("; ");
  let value;
  for (const cookie of cookies) {
    const parts = cookie.split("=");
    const name = readValue(parts[0]).replace(/%3D/g, "=");
    if (name === dist/* cookie.preview */.pR.preview) {
      value = readValue(parts.slice(1).join("="));
      continue;
    }
  }
  return value;
};

//# sourceMappingURL=getPrismicPreviewCookie.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/next/dist/lib/getPreviewCookieRepositoryName.js
const getPreviewCookieRepositoryName = (previewCookie) => {
  return (decodeURIComponent(previewCookie).match(/"(.+).prismic.io"/) || [])[1];
};

//# sourceMappingURL=getPreviewCookieRepositoryName.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/next/dist/PrismicPreview.js






function PrismicPreview({
  repositoryName,
  children,
  updatePreviewURL = "/api/preview",
  exitPreviewURL = "/api/exit-preview"
}) {
  const router = (0,next_router.useRouter)();
  const resolvedUpdatePreviewURL = router.basePath + updatePreviewURL;
  const resolvedExitPreviewURL = router.basePath + exitPreviewURL;
  react.useEffect(() => {
    const startPreviewMode = async () => {
      const res = await globalThis.fetch(resolvedUpdatePreviewURL);
      if (res.redirected) {
        globalThis.location.reload();
      } else {
        console.error(`[<PrismicPreview>] Failed to start or update Preview Mode using the "${resolvedUpdatePreviewURL}" API endpoint. Does it exist?`);
      }
    };
    const handlePrismicPreviewUpdate = async (event) => {
      event.preventDefault();
      await startPreviewMode();
    };
    const handlePrismicPreviewEnd = async (event) => {
      event.preventDefault();
      const res = await globalThis.fetch(resolvedExitPreviewURL);
      if (res.ok) {
        globalThis.location.reload();
      } else {
        console.error(`[<PrismicPreview>] Failed to exit Preview Mode using the "${resolvedExitPreviewURL}" API endpoint. Does it exist?`);
      }
    };
    if (router.isPreview) {
      window.addEventListener("prismicPreviewUpdate", handlePrismicPreviewUpdate);
      window.addEventListener("prismicPreviewEnd", handlePrismicPreviewEnd);
    } else {
      const prismicPreviewCookie = getPrismicPreviewCookie(globalThis.document.cookie);
      if (prismicPreviewCookie) {
        const locationIsDescendantOfBasePath = window.location.href.startsWith(window.location.origin + router.basePath);
        const prismicPreviewCookieRepositoryName = getPreviewCookieRepositoryName(prismicPreviewCookie);
        if (locationIsDescendantOfBasePath && prismicPreviewCookieRepositoryName === repositoryName) {
          startPreviewMode();
        }
      }
    }
    return () => {
      window.removeEventListener("prismicPreviewUpdate", handlePrismicPreviewUpdate);
      window.removeEventListener("prismicPreviewEnd", handlePrismicPreviewEnd);
    };
  }, [repositoryName, resolvedExitPreviewURL, resolvedUpdatePreviewURL, router.isPreview, router.basePath]);
  return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [children, (0,jsx_runtime.jsx)(script["default"], {
      src: `https://static.cdn.prismic.io/prismic.js?repo=${repositoryName}&new=true`,
      strategy: "lazyOnload"
    })]
  });
}

//# sourceMappingURL=PrismicPreview.js.map

;// CONCATENATED MODULE: ./utils/useCookiebot.tsx
/* provided dependency */ var useCookiebot_process = __webpack_require__(34155);

var useCookiebot = function() {
    (0,react.useEffect)(function() {
        var script = document.createElement('script');
        script.src = "https://consent.cookiebot.com/uc.js?cbid=".concat(useCookiebot_process.env.COOKIEBOT_DOMAIN_ID);
        script.async = true;
        document.head.appendChild(script);
        return function() {
            document.head.removeChild(script);
        };
    }, []);
};
/* harmony default export */ var utils_useCookiebot = (useCookiebot);

// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/instance.js + 3 modules
var instance = __webpack_require__(84336);
// EXTERNAL MODULE: ./node_modules/@next/third-parties/dist/google/index.js
var google = __webpack_require__(19692);
// EXTERNAL MODULE: ./node_modules/@paypal/react-paypal-js/dist/esm/react-paypal-js.js
var react_paypal_js = __webpack_require__(75021);
;// CONCATENATED MODULE: ./components/PreviousUrlProvider.tsx



var PreviousUrlContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var PreviousUrlProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)({
        prevUrl: '',
        slugs: []
    }), prevUrlState = ref[0], setPrevUrlState = ref[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var handleRouteChange = function() {
            if (true) {
                var prevUrl = window.location.href;
                var path = prevUrl.split(window.location.origin)[1];
                var slugs = path.split('/').filter(function(slug) {
                    return slug !== '' && router.locales.includes(slug) === false;
                });
                setPrevUrlState({
                    prevUrl: prevUrl,
                    slugs: slugs
                });
            }
        };
        router.events.on('routeChangeStart', handleRouteChange);
        return function() {
            router.events.off('routeChangeStart', handleRouteChange);
        };
    }, [
        router
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(PreviousUrlContext.Provider, {
        value: prevUrlState,
        children: children
    }));
};

;// CONCATENATED MODULE: ./components/GTMScript.tsx
/* provided dependency */ var GTMScript_process = __webpack_require__(34155);



var GTMId = GTMScript_process.env.NEXT_PUBLIC_GTM_ID;
var GTMScript = function() {
    if (!GTMId) {
        return null;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
        id: "gtm-script",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
            __html: "\n            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','".concat(GTMId, "');\n          ")
        }
    }));
};
var GTMNoscript = function() {
    if (!GTMId) {
        return null;
    }
    return(/*#__PURE__*/ _jsx("noscript", {
        children: /*#__PURE__*/ _jsx("iframe", {
            src: "https://www.googletagmanager.com/ns.html?id=".concat(GTMId),
            height: "0",
            width: "0",
            style: {
                display: 'none',
                visibility: 'hidden'
            }
        })
    }));
};


;// CONCATENATED MODULE: ./components/HotjarScript.tsx
/* provided dependency */ var HotjarScript_process = __webpack_require__(34155);



var HotjarId = HotjarScript_process.env.NEXT_PUBLIC_HOTJAR_ID;
var HotjarScript = function() {
    if (!HotjarId) {
        return null;
    }
    if (false) {}
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
        id: "hotjar-script",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
            __html: "\n            (function(h,o,t,j,a,r){\n                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n                h._hjSettings={hjid:".concat(HotjarId, ",hjsv:6};\n                a=o.getElementsByTagName('head')[0];\n                r=o.createElement('script');r.async=1;\n                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n                a.appendChild(r);\n            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');\n          ")
        }
    }));
};


;// CONCATENATED MODULE: ./pages/_app.tsx
/* provided dependency */ var _app_process = __webpack_require__(34155);

































function _app_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _app_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _app_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var _app_Theme = __webpack_require__(24827);
var customParseFormat = __webpack_require__(10285);
dayjs_min_default().extend(customParseFormat);
var InStoreManager = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(282), __webpack_require__.e(2215), __webpack_require__.e(15350), __webpack_require__.e(68480), __webpack_require__.e(1111), __webpack_require__.e(94108), __webpack_require__.e(230), __webpack_require__.e(19789), __webpack_require__.e(40314)]).then(__webpack_require__.bind(__webpack_require__, 79105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79105)
            ];
        }
    }
});
var CssBaseline = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 1048).then(__webpack_require__.bind(__webpack_require__, 38284));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38284)
            ];
        }
    }
});
var SSO = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 75163).then(__webpack_require__.bind(__webpack_require__, 75163));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75163)
            ];
        }
    }
});
var CartManager = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1111), __webpack_require__.e(19789), __webpack_require__.e(28449)]).then(__webpack_require__.bind(__webpack_require__, 28449));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28449)
            ];
        }
    }
});
var VersionManager = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 52745).then(__webpack_require__.bind(__webpack_require__, 52745));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52745)
            ];
        }
    }
});
var Auth = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(282), __webpack_require__.e(5511)]).then(__webpack_require__.bind(__webpack_require__, 5511));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5511)
            ];
        }
    }
});
var MatomoProvider = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 73735).then(__webpack_require__.bind(__webpack_require__, 73735)).then(function(mod) {
        return mod.MatomoProvider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73735)
            ];
        }
    }
});
var Provider = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 48633).then(__webpack_require__.bind(__webpack_require__, 11675)).then(function(mod) {
        return mod.Provider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11675)
            ];
        }
    }
});
var startDataDogMonitoring = function startDataDogMonitoring() {
    if (window.DD_STARTED) return;
    main/* datadogRum.init */.v.init({
        applicationId: 'fef1c5dc-fc2f-4990-bb0e-63e42d993679',
        clientToken: constants/* DATADOG_KEY */.Iu,
        site: 'datadoghq.eu',
        proxy: 'https://log-collector.lizee.io',
        service: 'rp-' + "millet",
        env: "dev",
        allowedTracingUrls: [
            function(url) {
                return !url.includes('keycloak.') && (url.includes('.lizee.io') || url.includes('http://localhost'));
            }, 
        ],
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 30,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input'
    });
    entries_main/* datadogLogs.init */.fy.init({
        clientToken: constants/* DATADOG_KEY */.Iu,
        site: 'datadoghq.eu',
        proxy: 'https://log-collector.lizee.io',
        forwardErrorsToLogs: true,
        sessionSampleRate: 30,
        env: "dev",
        service: 'rp-' + "millet"
    });
    window.DD_STARTED = true;
};
var WlApp = function(param) {
    var Component = param.Component, pageProps = param.pageProps, router = param.router;
    var ref, ref1;
    var nextRouter = (0,next_router.useRouter)();
    i18nextInit(nextRouter, pageProps.i18nResources);
    var isDisplayedBannerOnAllPages = pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.banner) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.is_displayed_banner_on_all_pages;
    var isHomePage = nextRouter.route === '/';
    var LayoutStyle = {
        isDisplayedBannerOnAllPages: isDisplayedBannerOnAllPages,
        isHomePage: isHomePage
    };
    Global_style(LayoutStyle);
    utils_useCookiebot();
    var ref2 = (0,react.useState)(null), matomoInstance = ref2[0], setMatomoInstance = ref2[1];
    var ref3 = (0,react.useState)(false), shouldAddGAScript = ref3[0], setShouldAddGAScript = ref3[1];
    var ref4 = (0,react.useState)(false), shouldAddGTMScript = ref4[0], setShouldAddGTMScript = ref4[1];
    var ref5 = (0,react.useState)(false), shouldAddMatomoScript = ref5[0], setShouldAddMatomoScript = ref5[1];
    var ref6 = (0,react.useState)(false), shouldAddHotjarScript = ref6[0], setShouldAddHotjarScript = ref6[1];
    var ref7 = (0,react.useState)(false), shouldAddMetaPixel = ref7[0], setShouldAddMetaPixel = ref7[1];
    (0,react.useEffect)(function() {
        var handleRouteChange = function(url) {
            gtag/* tracker */.ap(base/* GAEvent.PAGE_VIEW */.gB.PAGE_VIEW, {
                page_location: url
            });
            (0,gtag/* safeDataLayerPush */.Kx)({
                event: base/* GTMEvent.PAGE_VIEW */.tz.PAGE_VIEW,
                page_location: url
            });
            if ( true && typeof window.fbq === 'function') {
                window.fbq('track', 'PageView');
            }
        };
        router.events.on('routeChangeComplete', handleRouteChange);
        return function() {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [
        router.events
    ]);
    (0,react.useEffect)(function() {
        // only start after first action to save money
        window.addEventListener('mousemove', startDataDogMonitoring);
        window.addEventListener('mousewheel', startDataDogMonitoring);
        window.addEventListener('CookiebotOnAccept', startMatomoAndGA);
        window.addEventListener('CookiebotOnDecline', removeMatomoAndGA);
    });
    (0,react.useEffect)(function() {
        if (_app_process.env.NEXT_PUBLIC_USE_COOKIE_BOT === 'false') {
            startMatomoAndGA();
        }
    }, []);
    var startMatomoAndGA = function() {
        var _mtm = window._mtm = window._mtm || [];
        _mtm.push({
            'mtm.startTime': new Date().getTime(),
            event: 'mtm.Start'
        });
        var matomoTracker = (0,instance/* default */.Z)({
            urlBase:  true ? "https://matomo.lizee.io/" : 0,
            siteId:  true ? +"66" : 0
        });
        setMatomoInstance(matomoTracker);
        setShouldAddMatomoScript(true);
        // If Cookiebot is disabled in env, enable all scripts unconditionally
        if (_app_process.env.NEXT_PUBLIC_USE_COOKIE_BOT === 'false') {
            _mtm.push({
                event: 'cookie_consent_statistics'
            });
            _mtm.push({
                event: 'cookie_consent_marketing'
            });
            _mtm.push({
                event: 'cookie_consent_preferences'
            });
            setShouldAddGAScript(true);
            // setShouldAddGTMScript(true)
            setShouldAddHotjarScript(true);
            setShouldAddMetaPixel(true);
            return;
        }
        if (typeof Cookiebot !== 'undefined') {
            var cookiebot = Cookiebot;
            if (cookiebot.consent.statistics) {
                _mtm.push({
                    event: 'cookie_consent_statistics'
                });
                setShouldAddGAScript(true);
                setShouldAddGTMScript(true);
                setShouldAddHotjarScript(true);
            }
            if (cookiebot.consent.preferences) {
                _mtm.push({
                    event: 'cookie_consent_preferences'
                });
            }
            if (cookiebot.consent.marketing) {
                _mtm.push({
                    event: 'cookie_consent_marketing'
                });
                setShouldAddMetaPixel(true);
            }
        }
    };
    var removeMatomoAndGA = function() {
        setMatomoInstance(null);
        setShouldAddMatomoScript(false);
        setShouldAddGAScript(false);
        setShouldAddHotjarScript(false);
    };
    (0,react.useEffect)(function() {
        // Global redirect check
        if (_app_process.env.REDIRECT === 'true') {
            var currentUrl = window.location.href;
            var maintenanceUrl = 'https://secondemain.maje.com/pages/de-retour-bientot';
            // Avoid infinite redirect loop - don't redirect if already on maintenance page
            if (currentUrl !== maintenanceUrl) {
                window.location.href = maintenanceUrl;
                return;
            }
        }
        // Remove the server-side injected CSS.
        var jssStyles = document.querySelector('#jss-server-side');
        if (jssStyles) {
            jssStyles.parentElement.removeChild(jssStyles);
        }
    }, []);
    var googleAnalyticsId = _app_process.env.NEXT_PUBLIC_GA_ID;
    var metaPixelId = _app_process.env.NEXT_PUBLIC_META_PIXEL_ID;
    var brevoFormId = _app_process.env.NEXT_PUBLIC_BREVO_FORM_ID;
    var prismicURL = _app_process.env.PRISMIC_URL;
    var prismicRepo = prismicURL ? prismicURL.split('https://')[1].split('.cdn.prismic.io/api/v2')[0] : '';
    var enableGTMWithoutConsent = _app_process.env.NEXT_PUBLIC_ENABLE_GTM_WITHOUT_CONSENT;
    var initialPaypalOptions = {
        currency: _app_process.env.PAYPAL_CURRENCY ? _app_process.env.PAYPAL_CURRENCY : 'EUR',
        clientId: _app_process.env.PAYPAL_CLIENT_ID
    };
    var renderAppContent = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(PreviousUrlProvider, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MatomoProvider, {
                value: matomoInstance,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider_ThemeProvider, {
                    theme: _app_Theme.default,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CssBaseline, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.PageTransition, {
                            timeout: utils/* TRANSITION_TIMEOUT */.HN,
                            classNames: "page-transition",
                            loadingComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}),
                            loadingDelay: 500,
                            loadingTimeout: {
                                enter: utils/* TRANSITION_TIMEOUT */.HN,
                                exit: 0
                            },
                            loadingClassNames: "loading-indicator",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(notistack_esm/* SnackbarProvider */.wT, {
                                anchorOrigin: {
                                    vertical: 'top',
                                    horizontal: 'center'
                                },
                                content: function(key, message) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(InformationChip_InformationChip, {
                                        message: message,
                                        i18n: pageProps.i18nResources.translations
                                    }, key);
                                },
                                autoHideDuration: 3000,
                                children: _app_process.env.PAYPAL_CLIENT_ID ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_paypal_js/* PayPalScriptProvider */.Vv, {
                                    options: initialPaypalOptions,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(App, {})
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(App, {})
                            })
                        }, router.asPath)
                    ]
                })
            })
        });
    };
    var App = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Auth, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartManager, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InStoreManager, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SSO, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VersionManager, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(imagekitio_react_umd.IKContext, {
                                urlEndpoint: "https://ik.imagekit.io/lizee/rp-millet-operator-production//",
                                publicKey: "public_aef0VIWua1rRLv6cKwpw+o3ePIg=",
                                transformationPosition: "path" // optional
                                ,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _app_objectSpread({}, pageProps))
                            })
                        })
                    })
                })
            })
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            (Boolean(enableGTMWithoutConsent) || shouldAddGTMScript) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GTMScript, {}),
            shouldAddHotjarScript && /*#__PURE__*/ (0,jsx_runtime.jsx)(HotjarScript, {}),
            shouldAddMatomoScript && /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                async: true,
                type: "text/javascript",
                src: "https://analytics.lizee.io/js/container_".concat("KkFlORBD", ".js")
            }),
            shouldAddGAScript && googleAnalyticsId && /*#__PURE__*/ (0,jsx_runtime.jsx)(google.GoogleAnalytics, {
                gaId: googleAnalyticsId
            }),
            shouldAddMetaPixel && metaPixelId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                        id: "fb-pixel",
                        strategy: "afterInteractive",
                        dangerouslySetInnerHTML: {
                            __html: "\n                !function(f,b,e,v,n,t,s){\n                  if(f.fbq)return; n=f.fbq=function(){n.callMethod?\n                  n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n                  if(!f._fbq)f._fbq=n; n.push=n; n.loaded=!0; n.version='2.0';\n                  n.queue=[]; t=b.createElement(e); t.async=!0;\n                  t.src=v; s=b.getElementsByTagName(e)[0];\n                  s.parentNode.insertBefore(t,s)\n                }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');\n                fbq('init', '".concat(metaPixelId, "');\n                fbq('track', 'PageView');\n              ")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            height: "1",
                            width: "1",
                            style: {
                                display: 'none'
                            },
                            src: "https://www.facebook.com/tr?id=".concat(metaPixelId, "&ev=PageView&noscript=1")
                        })
                    })
                ]
            }),
            brevoFormId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                        src: "https://cdn.brevo.com/js/sdk-loader.js",
                        strategy: "afterInteractive",
                        async: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                        id: "brevo-popup",
                        strategy: "afterInteractive",
                        dangerouslySetInnerHTML: {
                            __html: "\n          window.Brevo = window.Brevo || [];\n          Brevo.push([\n            \"init\",\n            {\n              client_key: \"".concat(_app_process.env.NEXT_PUBLIC_BREVO_FORM_ID, "\"\n            }\n          ]);\n        ")
                        }
                    })
                ]
            }),
            nextRouter.isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicPreview, {
                repositoryName: prismicRepo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
                    session: pageProps.session,
                    children: renderAppContent()
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider, {
                session: pageProps.session,
                children: renderAppContent()
            })
        ]
    }));
};
/* harmony default export */ var _app = (wrapper.withRedux(WlApp));


/***/ }),

/***/ 14596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aO": function() { return /* binding */ ACTIONS; },
/* harmony export */   "yT": function() { return /* binding */ EMPTY_CART; },
/* harmony export */   "SM": function() { return /* binding */ CREATE_CART_REQUEST; },
/* harmony export */   "Yn": function() { return /* binding */ CREATE_CART_SUCCESS; },
/* harmony export */   "UY": function() { return /* binding */ CREATE_CART_FAILURE; },
/* harmony export */   "gv": function() { return /* binding */ CREATE_SUBSCRIPTION_CART_REQUEST; },
/* harmony export */   "Q": function() { return /* binding */ CREATE_SUBSCRIPTION_CART_SUCCESS; },
/* harmony export */   "tY": function() { return /* binding */ CREATE_SUBSCRIPTION_CART_FAILURE; },
/* harmony export */   "vh": function() { return /* binding */ DELETE_CART_REQUEST; },
/* harmony export */   "EK": function() { return /* binding */ DELETE_CART_SUCCESS; },
/* harmony export */   "UQ": function() { return /* binding */ DELETE_CART_FAILURE; },
/* harmony export */   "Vl": function() { return /* binding */ DELETE_CART_DP_REQUEST; },
/* harmony export */   "Kk": function() { return /* binding */ DELETE_CART_DP_SUCCESS; },
/* harmony export */   "Bd": function() { return /* binding */ DELETE_CART_DP_FAILURE; },
/* harmony export */   "Jy": function() { return /* binding */ ADD_PRODUCT_REQUEST; },
/* harmony export */   "s$": function() { return /* binding */ ADD_PRODUCT_SUCCESS; },
/* harmony export */   "Vh": function() { return /* binding */ ADD_PRODUCT_FAILURE; },
/* harmony export */   "dp": function() { return /* binding */ ADD_MULTIPLE_PRODUCT_REQUEST; },
/* harmony export */   "n8": function() { return /* binding */ ADD_MULTIPLE_PRODUCT_SUCCESS; },
/* harmony export */   "pu": function() { return /* binding */ ADD_MULTIPLE_PRODUCT_FAILURE; },
/* harmony export */   "Y_": function() { return /* binding */ PUT_PRODUCT_REQUEST; },
/* harmony export */   "yY": function() { return /* binding */ PUT_PRODUCT_SUCCESS; },
/* harmony export */   "q9": function() { return /* binding */ PUT_PRODUCT_FAILURE; },
/* harmony export */   "Pz": function() { return /* binding */ GET_CART_REQUEST; },
/* harmony export */   "Dg": function() { return /* binding */ GET_CART_SUCCESS; },
/* harmony export */   "E6": function() { return /* binding */ GET_CART_FAILURE; },
/* harmony export */   "bi": function() { return /* binding */ DELETE_PRODUCT_REQUEST; },
/* harmony export */   "cO": function() { return /* binding */ DELETE_PRODUCT_SUCCESS; },
/* harmony export */   "_W": function() { return /* binding */ DELETE_PRODUCT_FAILURE; },
/* harmony export */   "Pc": function() { return /* binding */ DELETE_PRODUCT_SECONDHAND_REQUEST; },
/* harmony export */   "XS": function() { return /* binding */ DELETE_PRODUCT_SECONDHAND_SUCCESS; },
/* harmony export */   "xU": function() { return /* binding */ DELETE_PRODUCT_SECONDHAND_FAILURE; },
/* harmony export */   "eV": function() { return /* binding */ UPDATE_CART_SUBSCRIPTION_REQUEST; },
/* harmony export */   "xr": function() { return /* binding */ UPDATE_CART_SUBSCRIPTION_SUCCESS; },
/* harmony export */   "kW": function() { return /* binding */ UPDATE_CART_SUBSCRIPTION_FAILURE; },
/* harmony export */   "eX": function() { return /* binding */ PATCH_CART_DATES_REQUEST; },
/* harmony export */   "hT": function() { return /* binding */ PATCH_CART_DATES_SUCCESS; },
/* harmony export */   "j5": function() { return /* binding */ PATCH_CART_DATES_FAILURE; },
/* harmony export */   "KW": function() { return /* binding */ PUT_CART_COUPON_REQUEST; },
/* harmony export */   "Vz": function() { return /* binding */ PUT_CART_COUPON_SUCCESS; },
/* harmony export */   "Y1": function() { return /* binding */ PUT_CART_COUPON_FAILURE; },
/* harmony export */   "fS": function() { return /* binding */ SET_ADDRESS_TYPE_CART; },
/* harmony export */   "iU": function() { return /* binding */ setFunnelStep; },
/* harmony export */   "JM": function() { return /* binding */ setInformationSkipped; },
/* harmony export */   "aD": function() { return /* binding */ recheckCartStock; },
/* harmony export */   "PA": function() { return /* binding */ getLastUsedBillingAddress; }
/* harmony export */ });
/* unused harmony exports SET_PARCEL_ID_CART, SET_FUNNEL_STEP, SET_INFORMATION_SKIPPED, GET_LAST_USED_BILLING_ADDRESS_REQUEST, GET_LAST_USED_BILLING_ADDRESS_SUCCESS, GET_LAST_USED_BILLING_ADDRESS_FAILURE, RECHECK_CART_STOCK */
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_checkout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10049);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ACTIONS = {
    CREATE_CART_REQUEST: 'CREATE_CART_REQUEST',
    CREATE_CART_SUCCESS: 'CREATE_CART_SUCCESS',
    CREATE_CART_FAILURE: 'CREATE_CART_FAILURE',
    CREATE_SUBSCRIPTION_CART_REQUEST: 'CREATE_SUBSCRIPTION_CART_REQUEST',
    CREATE_SUBSCRIPTION_CART_SUCCESS: 'CREATE_SUBSCRIPTION_CART_SUCCESS',
    CREATE_SUBSCRIPTION_CART_FAILURE: 'CREATE_SUBSCRIPTION_CART_FAILURE',
    DELETE_CART_REQUEST: 'DELETE_CART_REQUEST',
    DELETE_CART_SUCCESS: 'DELETE_CART_SUCCESS',
    DELETE_CART_FAILURE: 'DELETE_CART_FAILURE',
    DELETE_CART_DP_REQUEST: 'DELETE_CART_DP_REQUEST',
    DELETE_CART_DP_SUCCESS: 'DELETE_CART_DP_SUCCESS',
    DELETE_CART_DP_FAILURE: 'DELETE_CART_DP_FAILURE',
    ADD_PRODUCT_REQUEST: 'ADD_PRODUCT_REQUEST',
    ADD_PRODUCT_SUCCESS: 'ADD_PRODUCT_SUCCESS',
    ADD_PRODUCT_FAILURE: 'ADD_PRODUCT_FAILURE',
    ADD_MULTIPLE_PRODUCT_REQUEST: 'ADD_MULTIPLE_PRODUCT_REQUEST',
    ADD_MULTIPLE_PRODUCT_SUCCESS: 'ADD_MULTIPLE_PRODUCT_SUCCESS',
    ADD_MULTIPLE_PRODUCT_FAILURE: 'ADD_MULTIPLE_PRODUCT_FAILURE',
    UPDATE_CART_SUBSCRIPTION_REQUEST: 'UPDATE_CART_SUBSCRIPTION_REQUEST',
    UPDATE_CART_SUBSCRIPTION_SUCCESS: 'UPDATE_CART_SUBSCRIPTION_SUCCESS',
    UPDATE_CART_SUBSCRIPTION_FAILURE: 'UPDATE_CART_SUBSCRIPTION_FAILURE',
    PUT_PRODUCT_REQUEST: 'PUT_PRODUCT_REQUEST',
    PUT_PRODUCT_SUCCESS: 'PUT_PRODUCT_SUCCESS',
    PUT_PRODUCT_FAILURE: 'PUT_PRODUCT_FAILURE',
    PATCH_CART_DATES_REQUEST: 'PATCH_CART_DATES_REQUEST',
    PATCH_CART_DATES_SUCCESS: 'PATCH_CART_DATES_SUCCESS',
    PATCH_CART_DATES_FAILURE: 'PATCH_CART_DATES_FAILURE',
    DELETE_PRODUCT_REQUEST: 'DELETE_PRODUCT_REQUEST',
    DELETE_PRODUCT_SUCCESS: 'DELETE_PRODUCT_SUCCESS',
    DELETE_PRODUCT_FAILURE: 'DELETE_PRODUCT_FAILURE',
    GET_CART_REQUEST: 'GET_CART_REQUEST',
    GET_CART_SUCCESS: 'GET_CART_SUCCESS',
    GET_CART_FAILURE: 'GET_CART_FAILURE',
    PUT_CART_COUPON_REQUEST: 'PUT_CART_COUPON_REQUEST',
    PUT_CART_COUPON_SUCCESS: 'PUT_CART_COUPON_SUCCESS',
    PUT_CART_COUPON_FAILURE: 'PUT_CART_COUPON_FAILURE',
    SET_ADDRESS_TYPE_CART: 'SET_ADDRESS_TYPE_CART',
    SET_PARCEL_ID_CART: 'SET_PARCEL_ID_CART',
    DELETE_PRODUCT_SECONDHAND_REQUEST: 'DELETE_PRODUCT_SECONDHAND_REQUEST',
    DELETE_PRODUCT_SECONDHAND_SUCCESS: 'DELETE_PRODUCT_SECONDHAND_SUCCESS',
    DELETE_PRODUCT_SECONDHAND_FAILURE: 'DELETE_PRODUCT_SECONDHAND_FAILURE',
    EMPTY_CART: 'EMPTY_CART',
    SET_FUNNEL_STEP: 'SET_FUNNEL_STEP',
    SET_INFORMATION_SKIPPED: 'SET_INFORMATION_SKIPPED',
    GET_LAST_USED_BILLING_ADDRESS_REQUEST: 'GET_LAST_USED_BILLING_ADDRESS_REQUEST',
    GET_LAST_USED_BILLING_ADDRESS_SUCCESS: 'GET_LAST_USED_BILLING_ADDRESS_SUCCESS',
    GET_LAST_USED_BILLING_ADDRESS_FAILURE: 'GET_LAST_USED_BILLING_ADDRESS_FAILURE',
    RECHECK_CART_STOCK: 'RECHECK_CART_STOCK'
};
var EMPTY_CART = function() {
    return {
        type: ACTIONS.EMPTY_CART
    };
};
var CREATE_CART_REQUEST = function() {
    return {
        type: ACTIONS.CREATE_CART_REQUEST
    };
};
var CREATE_CART_SUCCESS = function(cart) {
    return {
        type: ACTIONS.CREATE_CART_SUCCESS,
        cart: cart
    };
};
var CREATE_CART_FAILURE = function(error) {
    return {
        type: ACTIONS.CREATE_CART_FAILURE,
        error: error
    };
};
var CREATE_SUBSCRIPTION_CART_REQUEST = function() {
    return {
        type: ACTIONS.CREATE_SUBSCRIPTION_CART_REQUEST
    };
};
var CREATE_SUBSCRIPTION_CART_SUCCESS = function(cart) {
    return {
        type: ACTIONS.CREATE_SUBSCRIPTION_CART_SUCCESS,
        cart: cart
    };
};
var CREATE_SUBSCRIPTION_CART_FAILURE = function(error) {
    return {
        type: ACTIONS.CREATE_SUBSCRIPTION_CART_FAILURE,
        error: error
    };
};
var DELETE_CART_REQUEST = function() {
    return {
        type: ACTIONS.DELETE_CART_REQUEST
    };
};
var DELETE_CART_SUCCESS = function(cart) {
    return {
        type: ACTIONS.DELETE_CART_SUCCESS,
        cart: cart
    };
};
var DELETE_CART_FAILURE = function(err) {
    return {
        type: ACTIONS.DELETE_CART_FAILURE,
        err: err
    };
};
var DELETE_CART_DP_REQUEST = function() {
    return {
        type: ACTIONS.DELETE_CART_DP_REQUEST
    };
};
var DELETE_CART_DP_SUCCESS = function(cart) {
    return {
        type: ACTIONS.DELETE_CART_DP_SUCCESS,
        cart: cart
    };
};
var DELETE_CART_DP_FAILURE = function(err) {
    return {
        type: ACTIONS.DELETE_CART_DP_FAILURE,
        err: err
    };
};
var ADD_PRODUCT_REQUEST = function() {
    return {
        type: ACTIONS.ADD_PRODUCT_REQUEST
    };
};
var ADD_PRODUCT_SUCCESS = function(cart) {
    return {
        type: ACTIONS.ADD_PRODUCT_SUCCESS,
        cart: cart
    };
};
var ADD_PRODUCT_FAILURE = function(err) {
    return {
        type: ACTIONS.ADD_PRODUCT_FAILURE,
        err: err
    };
};
var ADD_MULTIPLE_PRODUCT_REQUEST = function() {
    return {
        type: ACTIONS.ADD_MULTIPLE_PRODUCT_REQUEST
    };
};
var ADD_MULTIPLE_PRODUCT_SUCCESS = function(cart) {
    return {
        type: ACTIONS.ADD_MULTIPLE_PRODUCT_SUCCESS,
        cart: cart
    };
};
var ADD_MULTIPLE_PRODUCT_FAILURE = function(err) {
    return {
        type: ACTIONS.ADD_MULTIPLE_PRODUCT_FAILURE,
        err: err
    };
};
var PUT_PRODUCT_REQUEST = function() {
    return {
        type: ACTIONS.PUT_PRODUCT_REQUEST
    };
};
var PUT_PRODUCT_SUCCESS = function(cart) {
    return {
        type: ACTIONS.PUT_PRODUCT_SUCCESS,
        cart: cart
    };
};
var PUT_PRODUCT_FAILURE = function(err) {
    return {
        type: ACTIONS.PUT_PRODUCT_FAILURE,
        err: err
    };
};
var GET_CART_REQUEST = function() {
    return {
        type: ACTIONS.GET_CART_REQUEST
    };
};
var GET_CART_SUCCESS = function(cart, blocked_date_range) {
    return {
        type: ACTIONS.GET_CART_SUCCESS,
        cart: cart,
        blocked_date_range: blocked_date_range
    };
};
var GET_CART_FAILURE = function(error) {
    return {
        type: ACTIONS.GET_CART_FAILURE,
        error: error
    };
};
var DELETE_PRODUCT_REQUEST = function() {
    return {
        type: ACTIONS.DELETE_PRODUCT_REQUEST
    };
};
var DELETE_PRODUCT_SUCCESS = function(cart) {
    return {
        type: ACTIONS.DELETE_PRODUCT_SUCCESS,
        cart: cart
    };
};
var DELETE_PRODUCT_FAILURE = function(err) {
    return {
        type: ACTIONS.DELETE_PRODUCT_FAILURE,
        err: err
    };
};
var DELETE_PRODUCT_SECONDHAND_REQUEST = function() {
    return {
        type: ACTIONS.DELETE_PRODUCT_SECONDHAND_REQUEST
    };
};
var DELETE_PRODUCT_SECONDHAND_SUCCESS = function(cart) {
    return {
        type: ACTIONS.DELETE_PRODUCT_SECONDHAND_SUCCESS,
        cart: cart
    };
};
var DELETE_PRODUCT_SECONDHAND_FAILURE = function(err) {
    return {
        type: ACTIONS.DELETE_PRODUCT_SECONDHAND_FAILURE,
        err: err
    };
};
var UPDATE_CART_SUBSCRIPTION_REQUEST = function() {
    return {
        type: ACTIONS.UPDATE_CART_SUBSCRIPTION_REQUEST
    };
};
var UPDATE_CART_SUBSCRIPTION_SUCCESS = function(cart) {
    return {
        type: ACTIONS.UPDATE_CART_SUBSCRIPTION_SUCCESS,
        cart: cart
    };
};
var UPDATE_CART_SUBSCRIPTION_FAILURE = function(err) {
    return {
        type: ACTIONS.UPDATE_CART_SUBSCRIPTION_FAILURE,
        err: err
    };
};
var PATCH_CART_DATES_REQUEST = function() {
    return {
        type: ACTIONS.PATCH_CART_DATES_REQUEST
    };
};
var PATCH_CART_DATES_SUCCESS = function(cart) {
    return {
        type: ACTIONS.PATCH_CART_DATES_SUCCESS,
        cart: cart
    };
};
var PATCH_CART_DATES_FAILURE = function(err) {
    return {
        type: ACTIONS.PATCH_CART_DATES_FAILURE,
        err: err
    };
};
var PUT_CART_COUPON_REQUEST = function() {
    return {
        type: ACTIONS.PUT_CART_COUPON_REQUEST
    };
};
var PUT_CART_COUPON_SUCCESS = function(cart) {
    return {
        type: ACTIONS.PUT_CART_COUPON_SUCCESS,
        cart: cart
    };
};
var PUT_CART_COUPON_FAILURE = function(err) {
    return {
        type: ACTIONS.PUT_CART_COUPON_FAILURE,
        err: err
    };
};
var SET_ADDRESS_TYPE_CART = function(type_name) {
    return {
        type: ACTIONS.SET_ADDRESS_TYPE_CART,
        type_name: type_name
    };
};
var SET_PARCEL_ID_CART = function(rmsParcelShopId) {
    return {
        type: ACTIONS.SET_PARCEL_ID_CART,
        rmsParcelShopId: rmsParcelShopId
    };
};
var SET_FUNNEL_STEP = function(step) {
    return {
        type: ACTIONS.SET_FUNNEL_STEP,
        step: step
    };
};
var setFunnelStep = function(step) {
    return function(dispatch) {
        dispatch(SET_FUNNEL_STEP(step));
    };
};
var SET_INFORMATION_SKIPPED = function(skipped) {
    return {
        type: ACTIONS.SET_INFORMATION_SKIPPED,
        skipped: skipped
    };
};
var setInformationSkipped = function(skipped) {
    return function(dispatch) {
        dispatch(SET_INFORMATION_SKIPPED(skipped));
    };
};
var GET_LAST_USED_BILLING_ADDRESS_REQUEST = function() {
    return {
        type: ACTIONS.GET_LAST_USED_BILLING_ADDRESS_REQUEST
    };
};
var GET_LAST_USED_BILLING_ADDRESS_SUCCESS = function(address) {
    return {
        type: ACTIONS.GET_LAST_USED_BILLING_ADDRESS_SUCCESS,
        address: address
    };
};
var GET_LAST_USED_BILLING_ADDRESS_FAILURE = function(error) {
    return {
        type: ACTIONS.GET_LAST_USED_BILLING_ADDRESS_FAILURE,
        error: error
    };
};
var RECHECK_CART_STOCK = function() {
    return {
        type: ACTIONS.RECHECK_CART_STOCK
    };
};
var recheckCartStock = function() {
    return (function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch(RECHECK_CART_STOCK());
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    })();
};
var getLastUsedBillingAddress = function() {
    return (function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var response;
            return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch(GET_LAST_USED_BILLING_ADDRESS_REQUEST());
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return _services_checkout__WEBPACK_IMPORTED_MODULE_1__/* .getLastUsedBillingAddress */ .PA();
                    case 4:
                        response = _ctx.sent;
                        dispatch(GET_LAST_USED_BILLING_ADDRESS_SUCCESS(response));
                        return _ctx.abrupt("return", response);
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        dispatch(GET_LAST_USED_BILLING_ADDRESS_FAILURE(_ctx.t0));
                        return _ctx.abrupt("return", null);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    })();
};


/***/ }),

/***/ 86730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aO": function() { return /* binding */ ACTIONS; },
/* harmony export */   "R2": function() { return /* binding */ getProductsByTaxonsSlug; },
/* harmony export */   "Or": function() { return /* binding */ getCumulativeProductsByTaxonsSlug; },
/* harmony export */   "bj": function() { return /* binding */ filterProductsAction; },
/* harmony export */   "p1": function() { return /* binding */ filterCumulativeProductsAction; },
/* harmony export */   "Yw": function() { return /* binding */ saveFetchedProduct; },
/* harmony export */   "jP": function() { return /* binding */ resetSingleProduct; },
/* harmony export */   "cs": function() { return /* binding */ getProductsBySlug; },
/* harmony export */   "lO": function() { return /* binding */ getLatestProducts; },
/* harmony export */   "K5": function() { return /* binding */ getStock; },
/* harmony export */   "hh": function() { return /* binding */ noStock; },
/* harmony export */   "Gz": function() { return /* binding */ postStockAlert; },
/* harmony export */   "w_": function() { return /* binding */ getBasketStock; },
/* harmony export */   "eI": function() { return /* binding */ getProductVariantAvailability; },
/* harmony export */   "re": function() { return /* binding */ setCurrentSlug; },
/* harmony export */   "BE": function() { return /* binding */ setCurrentSearch; },
/* harmony export */   "XD": function() { return /* binding */ emptyProductState; }
/* harmony export */ });
/* unused harmony exports GET_PRODUCTS_REQUEST, GET_PRODUCTS_SUCCESS, GET_PRODUCTS_FAILURE, NO_STOCK_REQUEST, GET_CUMULATIVE_PRODUCTS_REQUEST, GET_CUMULATIVE_PRODUCTS_SUCCESS, GET_CUMULATIVE_PRODUCTS_FAILURE, GET_SINGLE_PRODUCT_REQUEST, GET_SINGLE_PRODUCT_SUCCESS, GET_SINGLE_PRODUCT_FAILURE, RESET_SINGLE_PRODUCT, GET_LATEST_PRODUCTS_REQUEST, GET_LATEST_PRODUCTS_SUCCESS, GET_LATEST_PRODUCTS_FAILURE, GET_STOCK_REQUEST, GET_STOCK_SUCCESS, GET_STOCK_FAILURE, POST_STOCK_ALERT_REQUEST, POST_STOCK_ALERT_SUCCESS, POST_STOCK_ALERT_FAILURE, GET_STOCK_BASKET_REQUEST, GET_STOCK_BASKET_SUCCESS, GET_STOCK_BASKET_FAILURE, GET_STOCK_AVAILABILITY_REQUEST, GET_STOCK_AVAILABILITY_SUCCESS, GET_STOCK_AVAILABILITY_FAILURE, SET_CURRENT_SHOP_SLUG, SET_CURRENT_SEARCH, EMPTY_PRODUCTS */
/* harmony import */ var _services_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83260);

var ACTIONS = {
    GET_PRODUCTS_REQUEST: 'GET_PRODUCTS_REQUEST',
    GET_PRODUCTS_SUCCESS: 'GET_PRODUCTS_SUCCESS',
    GET_PRODUCTS_FAILURE: 'GET_PRODUCTS_FAILURE',
    GET_SINGLE_PRODUCT_REQUEST: 'GET_SINGLE_PRODUCT_REQUEST',
    GET_SINGLE_PRODUCT_SUCCESS: 'GET_SINGLE_PRODUCT_SUCCESS',
    GET_SINGLE_PRODUCT_FAILURE: 'GET_SINGLE_PRODUCT_FAILURE',
    RESET_SINGLE_PRODUCT: 'RESET_SINGLE_PRODUCT',
    GET_LATEST_PRODUCTS_REQUEST: 'GET_LATEST_PRODUCTS_REQUEST',
    GET_LATEST_PRODUCTS_SUCCESS: 'GET_LATEST_PRODUCTS_SUCCESS',
    GET_LATEST_PRODUCTS_FAILURE: 'GET_SINGLE_PRODUCT_FAILURE',
    GET_STOCK_REQUEST: 'GET_STOCK_REQUEST',
    GET_STOCK_SUCCESS: 'GET_STOCK_SUCCESS',
    GET_STOCK_FAILURE: 'GET_STOCK_FAILURE',
    NO_STOCK_REQUEST: 'NO_STOCK_REQUEST',
    POST_STOCK_ALERT_REQUEST: 'POST_STOCK_ALERT_REQUEST',
    POST_STOCK_ALERT_SUCCESS: 'POST_STOCK_ALERT_SUCCESS',
    POST_STOCK_ALERT_FAILURE: 'POST_STOCK_ALERT_FAILURE',
    GET_STOCK_BASKET_REQUEST: 'GET_STOCK_BASKET_REQUEST',
    GET_STOCK_BASKET_SUCCESS: 'GET_STOCK_BASKET_SUCCESS',
    GET_STOCK_BASKET_FAILURE: 'GET_STOCK_BASKET_FAILURE',
    GET_STOCK_AVAILABILITY_REQUEST: 'GET_STOCK_AVAILABILITY_REQUEST',
    GET_STOCK_AVAILABILITY_SUCCESS: 'GET_STOCK_AVAILABILITY_SUCCESS',
    GET_STOCK_AVAILABILITY_FAILURE: 'GET_STOCK_AVAILABILITY_FAILURE',
    GET_CUMULATIVE_PRODUCTS_REQUEST: 'GET_CUMULATIVE_PRODUCTS_REQUEST',
    GET_CUMULATIVE_PRODUCTS_SUCCESS: 'GET_CUMULATIVE_PRODUCTS_SUCCESS',
    GET_CUMULATIVE_PRODUCTS_FAILURE: 'GET_CUMULATIVE_PRODUCTS_FAILURE',
    SET_CURRENT_SHOP_SLUG: 'SET_CURRENT_SHOP_SLUG',
    SET_CURRENT_SEARCH: 'SET_CURRENT_SEARCH',
    EMPTY_PRODUCTS: 'EMPTY_PRODUCTS'
};
var GET_PRODUCTS_REQUEST = function() {
    return {
        type: ACTIONS.GET_PRODUCTS_REQUEST
    };
};
var GET_PRODUCTS_SUCCESS = function(products) {
    return {
        type: ACTIONS.GET_PRODUCTS_SUCCESS,
        products: products
    };
};
var GET_PRODUCTS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_PRODUCTS_FAILURE,
        err: err
    };
};
var NO_STOCK_REQUEST = function() {
    return {
        type: ACTIONS.NO_STOCK_REQUEST
    };
};
function getProductsByTaxonsSlug(slug, limit, page, attributes, search, locale, isSecondHand, sort) {
    return function(dispatch) {
        dispatch(GET_PRODUCTS_REQUEST());
        return _services_products__WEBPACK_IMPORTED_MODULE_0__/* .getProductsByTaxonsSlug */ .R2(slug, limit, page, attributes, search, locale, isSecondHand, sort).then(function(response) {
            return dispatch(GET_PRODUCTS_SUCCESS(response));
        }, function(err) {
            dispatch(GET_PRODUCTS_FAILURE(err));
            dispatch(GET_STOCK_FAILURE(err));
        });
    };
}
var GET_CUMULATIVE_PRODUCTS_REQUEST = function() {
    return {
        type: ACTIONS.GET_CUMULATIVE_PRODUCTS_REQUEST
    };
};
var GET_CUMULATIVE_PRODUCTS_SUCCESS = function(products) {
    return {
        type: ACTIONS.GET_CUMULATIVE_PRODUCTS_SUCCESS,
        products: products
    };
};
var GET_CUMULATIVE_PRODUCTS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_CUMULATIVE_PRODUCTS_FAILURE,
        err: err
    };
};
function getCumulativeProductsByTaxonsSlug(slug, limit, page, attributes, search, locale, isSecondHand, sort) {
    return function(dispatch) {
        dispatch(GET_CUMULATIVE_PRODUCTS_REQUEST());
        return _services_products__WEBPACK_IMPORTED_MODULE_0__/* .getProductsByTaxonsSlug */ .R2(slug, limit, page, attributes, search, locale, isSecondHand, sort).then(function(response) {
            return dispatch(GET_CUMULATIVE_PRODUCTS_SUCCESS(response));
        }, function(err) {
            dispatch(GET_CUMULATIVE_PRODUCTS_FAILURE(err));
            dispatch(GET_STOCK_FAILURE(err));
        });
    };
}
var filterProductsAction = function(query, page, limit, locale) {
    return function(dispatch) {
        dispatch(GET_PRODUCTS_REQUEST());
        return _services_products__WEBPACK_IMPORTED_MODULE_0__/* .filterProducts */ .ft(query, page, limit, locale).then(function(response) {
            return dispatch(GET_PRODUCTS_SUCCESS(response));
        }, function(err) {
            dispatch(GET_PRODUCTS_FAILURE(err));
            dispatch(GET_STOCK_FAILURE(err));
        });
    };
};
var filterCumulativeProductsAction = function(query, page, limit, locale) {
    return function(dispatch) {
        dispatch(GET_CUMULATIVE_PRODUCTS_REQUEST());
        return _services_products__WEBPACK_IMPORTED_MODULE_0__/* .filterProducts */ .ft(query, page, limit, locale).then(function(response) {
            return dispatch(GET_CUMULATIVE_PRODUCTS_SUCCESS(response));
        }, function(err) {
            dispatch(GET_CUMULATIVE_PRODUCTS_FAILURE(err));
            dispatch(GET_STOCK_FAILURE(err));
        });
    };
};
var GET_SINGLE_PRODUCT_REQUEST = function() {
    return {
        type: ACTIONS.GET_SINGLE_PRODUCT_REQUEST
    };
};
var GET_SINGLE_PRODUCT_SUCCESS = function(product) {
    return {
        type: ACTIONS.GET_SINGLE_PRODUCT_SUCCESS,
        product: product
    };
};
var GET_SINGLE_PRODUCT_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_SINGLE_PRODUCT_FAILURE,
        err: err
    };
};
function saveFetchedProduct(product) {
    return function(dispatch) {
        dispatch(GET_SINGLE_PRODUCT_SUCCESS(product));
    };
}
var RESET_SINGLE_PRODUCT = function() {
    return {
        type: ACTIONS.RESET_SINGLE_PRODUCT
    };
};
function resetSingleProduct() {
    return function(dispatch) {
        dispatch(RESET_SINGLE_PRODUCT());
    };
}
function getProductsBySlug(slug) {
    return function(dispatch) {
        dispatch(GET_SINGLE_PRODUCT_REQUEST());
        return _services_products__WEBPACK_IMPORTED_MODULE_0__/* .getProductsBySlug */ .cs(slug).then(function(response) {
            return dispatch(GET_SINGLE_PRODUCT_SUCCESS(response));
        }, function(err) {
            dispatch(GET_SINGLE_PRODUCT_FAILURE(err));
            dispatch(GET_STOCK_FAILURE(err));
        });
    };
}
var GET_LATEST_PRODUCTS_REQUEST = function() {
    return {
        type: ACTIONS.GET_LATEST_PRODUCTS_REQUEST
    };
};
var GET_LATEST_PRODUCTS_SUCCESS = function(product_latest) {
    return {
        type: ACTIONS.GET_LATEST_PRODUCTS_SUCCESS,
        product_latest: product_latest
    };
};
var GET_LATEST_PRODUCTS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_LATEST_PRODUCTS_FAILURE,
        err: err
    };
};
function getLatestProducts() {
    return function(dispatch) {
        dispatch(GET_LATEST_PRODUCTS_REQUEST());
        return _services_products__WEBPACK_IMPORTED_MODULE_0__/* .getLatestProducts */ .lO().then(function(response) {
            return dispatch(GET_LATEST_PRODUCTS_SUCCESS(response));
        }, function(err) {
            dispatch(GET_LATEST_PRODUCTS_FAILURE(err));
            dispatch(GET_STOCK_FAILURE(err));
        });
    };
}
var GET_STOCK_REQUEST = function() {
    return {
        type: ACTIONS.GET_STOCK_REQUEST
    };
};
var GET_STOCK_SUCCESS = function(stock) {
    return {
        type: ACTIONS.GET_STOCK_SUCCESS,
        stock: stock
    };
};
var GET_STOCK_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_STOCK_FAILURE,
        err: err
    };
};
function getStock(data, warehouseId) {
    return function(dispatch) {
        dispatch(GET_STOCK_REQUEST());
        return _services_products__WEBPACK_IMPORTED_MODULE_0__/* .getStock */ .K5(data, warehouseId).then(function(response) {
            return dispatch(GET_STOCK_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_STOCK_FAILURE(err));
        });
    };
}
function noStock() {
    return function(dispatch) {
        dispatch(NO_STOCK_REQUEST());
    };
}
var POST_STOCK_ALERT_REQUEST = function() {
    return {
        type: ACTIONS.POST_STOCK_ALERT_REQUEST
    };
};
var POST_STOCK_ALERT_SUCCESS = function(data) {
    return {
        type: ACTIONS.POST_STOCK_ALERT_SUCCESS,
        data: data
    };
};
var POST_STOCK_ALERT_FAILURE = function(err) {
    return {
        type: ACTIONS.POST_STOCK_ALERT_FAILURE,
        err: err
    };
};
function postStockAlert(data1) {
    return function(dispatch) {
        dispatch(POST_STOCK_ALERT_REQUEST());
        return _services_products__WEBPACK_IMPORTED_MODULE_0__/* .postStockAlert */ .Gz(data1).then(function(data) {
            return dispatch(POST_STOCK_ALERT_SUCCESS(data));
        }, function(err) {
            return dispatch(POST_STOCK_ALERT_FAILURE(err));
        });
    };
}
var GET_STOCK_BASKET_REQUEST = function() {
    return {
        type: ACTIONS.GET_STOCK_BASKET_REQUEST
    };
};
var GET_STOCK_BASKET_SUCCESS = function(stockBasket) {
    return {
        type: ACTIONS.GET_STOCK_BASKET_SUCCESS,
        stockBasket: stockBasket
    };
};
var GET_STOCK_BASKET_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_STOCK_BASKET_FAILURE,
        err: err
    };
};
function getBasketStock(data, warehouseId) {
    return function(dispatch) {
        dispatch(GET_STOCK_BASKET_REQUEST());
        return _services_products__WEBPACK_IMPORTED_MODULE_0__/* .getStock */ .K5(data, warehouseId).then(function(response) {
            return dispatch(GET_STOCK_BASKET_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_STOCK_FAILURE(err));
        });
    };
}
var GET_STOCK_AVAILABILITY_REQUEST = function() {
    return {
        type: ACTIONS.GET_STOCK_AVAILABILITY_REQUEST
    };
};
var GET_STOCK_AVAILABILITY_SUCCESS = function(availabilities) {
    return {
        type: ACTIONS.GET_STOCK_AVAILABILITY_SUCCESS,
        availabilities: availabilities
    };
};
var GET_STOCK_AVAILABILITY_FAILURE = function(error) {
    return {
        type: ACTIONS.GET_STOCK_AVAILABILITY_FAILURE,
        error: error
    };
};
function getProductVariantAvailability(data) {
    return function(dispatch) {
        dispatch(GET_STOCK_AVAILABILITY_REQUEST());
        return _services_products__WEBPACK_IMPORTED_MODULE_0__/* .getProductVariantAvailability */ .eI(data).then(function(response) {
            return dispatch(GET_STOCK_AVAILABILITY_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_STOCK_AVAILABILITY_FAILURE(err));
        });
    };
}
var SET_CURRENT_SHOP_SLUG = function(slug) {
    return {
        type: ACTIONS.SET_CURRENT_SHOP_SLUG,
        slug: slug
    };
};
function setCurrentSlug(slug) {
    return function(dispatch) {
        dispatch(SET_CURRENT_SHOP_SLUG(slug));
    };
}
var SET_CURRENT_SEARCH = function(search) {
    return {
        type: ACTIONS.SET_CURRENT_SEARCH,
        search: search
    };
};
function setCurrentSearch(search) {
    return function(dispatch) {
        dispatch(SET_CURRENT_SEARCH(search));
    };
}
var EMPTY_PRODUCTS = function() {
    return {
        type: ACTIONS.EMPTY_PRODUCTS
    };
};
function emptyProductState() {
    return function(dispatch) {
        dispatch(EMPTY_PRODUCTS());
    };
}


/***/ }),

/***/ 92324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aO": function() { return /* binding */ ACTIONS; },
  "Rr": function() { return /* binding */ reservations_createReservation; },
  "IF": function() { return /* binding */ reservations_getReservations; },
  "O$": function() { return /* binding */ releaseReservation; },
  "vE": function() { return /* binding */ resetReservations; }
});

// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./redux/services/reservations.ts




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var authHeaders = function() {
    return _objectSpread({}, (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE)));
};
var getReservations = function() {
    return (0,api/* axiosRMSWrapper */.UZ)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* RMSRequestUrl.reservations */.jo.reservations,
        headers: authHeaders()
    });
};
var createReservation = function(barcodeUid, locale) {
    return (0,api/* axiosRMSWrapper */.UZ)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* RMSRequestUrl.reservations */.jo.reservations,
        headers: authHeaders(),
        data: {
            barcodeUid: barcodeUid,
            locale: locale
        }
    });
};
var cancelReservation = function(id) {
    return (0,api/* axiosRMSWrapper */.UZ)({
        method: requests/* EMethods.delete */.YZ["delete"],
        url: requests/* RMSRequestUrl.reservations */.jo.reservations,
        uid: "".concat(id),
        headers: authHeaders()
    });
};

;// CONCATENATED MODULE: ./redux/actions/reservations.ts

var ACTIONS = {
    GET_RESERVATIONS_REQUEST: 'GET_RESERVATIONS_REQUEST',
    GET_RESERVATIONS_SUCCESS: 'GET_RESERVATIONS_SUCCESS',
    GET_RESERVATIONS_FAILURE: 'GET_RESERVATIONS_FAILURE',
    RELEASE_RESERVATION_REQUEST: 'RELEASE_RESERVATION_REQUEST',
    RELEASE_RESERVATION_SUCCESS: 'RELEASE_RESERVATION_SUCCESS',
    RELEASE_RESERVATION_FAILURE: 'RELEASE_RESERVATION_FAILURE',
    CREATE_RESERVATION_REQUEST: 'CREATE_RESERVATION_REQUEST',
    CREATE_RESERVATION_SUCCESS: 'CREATE_RESERVATION_SUCCESS',
    CREATE_RESERVATION_FAILURE: 'CREATE_RESERVATION_FAILURE',
    RESET_RESERVATIONS: 'RESET_RESERVATIONS'
};
var GET_RESERVATIONS_REQUEST = function() {
    return {
        type: ACTIONS.GET_RESERVATIONS_REQUEST
    };
};
var GET_RESERVATIONS_SUCCESS = function(items) {
    return {
        type: ACTIONS.GET_RESERVATIONS_SUCCESS,
        items: items
    };
};
var GET_RESERVATIONS_FAILURE = function(error) {
    return {
        type: ACTIONS.GET_RESERVATIONS_FAILURE,
        error: error
    };
};
var RELEASE_RESERVATION_REQUEST = function(id) {
    return {
        type: ACTIONS.RELEASE_RESERVATION_REQUEST,
        id: id
    };
};
var RELEASE_RESERVATION_SUCCESS = function(id) {
    return {
        type: ACTIONS.RELEASE_RESERVATION_SUCCESS,
        id: id
    };
};
var RELEASE_RESERVATION_FAILURE = function(error, id) {
    return {
        type: ACTIONS.RELEASE_RESERVATION_FAILURE,
        error: error,
        id: id
    };
};
var CREATE_RESERVATION_REQUEST = function() {
    return {
        type: ACTIONS.CREATE_RESERVATION_REQUEST
    };
};
var CREATE_RESERVATION_SUCCESS = function(item) {
    return {
        type: ACTIONS.CREATE_RESERVATION_SUCCESS,
        item: item
    };
};
var CREATE_RESERVATION_FAILURE = function(error) {
    return {
        type: ACTIONS.CREATE_RESERVATION_FAILURE,
        error: error
    };
};
var RESET_RESERVATIONS = function() {
    return {
        type: ACTIONS.RESET_RESERVATIONS
    };
};
var reservations_getReservations = function() {
    return function(dispatch) {
        dispatch(GET_RESERVATIONS_REQUEST());
        return getReservations().then(function(items) {
            return dispatch(GET_RESERVATIONS_SUCCESS(items));
        }).catch(function(error) {
            return dispatch(GET_RESERVATIONS_FAILURE(error));
        });
    };
};
var releaseReservation = function(reservationId) {
    return function(dispatch) {
        dispatch(RELEASE_RESERVATION_REQUEST(reservationId));
        return cancelReservation(reservationId).then(function() {
            return dispatch(RELEASE_RESERVATION_SUCCESS(reservationId));
        }).catch(function(error) {
            return dispatch(RELEASE_RESERVATION_FAILURE(error, reservationId));
        });
    };
};
var reservations_createReservation = function(barcodeUid, locale) {
    return function(dispatch) {
        dispatch(CREATE_RESERVATION_REQUEST());
        return createReservation(barcodeUid, locale).then(function(item) {
            dispatch(CREATE_RESERVATION_SUCCESS(item));
            return item;
        }).catch(function(error) {
            dispatch(CREATE_RESERVATION_FAILURE(error));
            throw error;
        });
    };
};
var resetReservations = function() {
    return function(dispatch) {
        dispatch(RESET_RESERVATIONS());
    };
};


/***/ }),

/***/ 64918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aO": function() { return /* binding */ ACTIONS; },
/* harmony export */   "Xl": function() { return /* binding */ createSwiklyCaution; },
/* harmony export */   "ZU": function() { return /* binding */ getSwiklyCautionStatus; }
/* harmony export */ });
/* unused harmony exports CREATE_SWIKLY_CAUTION_REQUEST, CREATE_SWIKLY_CAUTION_SUCCESS, CREATE_SWIKLY_CAUTION_FAILURE, GET_SWIKLY_CAUTION_STATUS_REQUEST, GET_SWIKLY_CAUTION_STATUS_SUCCESS, GET_SWIKLY_CAUTION_STATUS_FAILURE */
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_swikly__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71371);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
/**
 * Action types for Swikly operations
 */ var ACTIONS = {
    CREATE_SWIKLY_CAUTION_REQUEST: 'CREATE_SWIKLY_CAUTION_REQUEST',
    CREATE_SWIKLY_CAUTION_SUCCESS: 'CREATE_SWIKLY_CAUTION_SUCCESS',
    CREATE_SWIKLY_CAUTION_FAILURE: 'CREATE_SWIKLY_CAUTION_FAILURE',
    GET_SWIKLY_CAUTION_STATUS_REQUEST: 'GET_SWIKLY_CAUTION_STATUS_REQUEST',
    GET_SWIKLY_CAUTION_STATUS_SUCCESS: 'GET_SWIKLY_CAUTION_STATUS_SUCCESS',
    GET_SWIKLY_CAUTION_STATUS_FAILURE: 'GET_SWIKLY_CAUTION_STATUS_FAILURE'
};
// Create caution actions
/**
 * Action dispatched when creating a Swikly caution request starts
 */ var CREATE_SWIKLY_CAUTION_REQUEST = function() {
    return {
        type: ACTIONS.CREATE_SWIKLY_CAUTION_REQUEST
    };
};
/**
 * Action dispatched when creating a Swikly caution succeeds
 * @param response - The response from the Swikly API
 */ var CREATE_SWIKLY_CAUTION_SUCCESS = function(response) {
    return {
        type: ACTIONS.CREATE_SWIKLY_CAUTION_SUCCESS,
        payload: response
    };
};
/**
 * Action dispatched when creating a Swikly caution fails
 * @param error - The error that occurred
 */ var CREATE_SWIKLY_CAUTION_FAILURE = function(error) {
    return {
        type: ACTIONS.CREATE_SWIKLY_CAUTION_FAILURE,
        error: error
    };
};
// Get caution status actions
/**
 * Action dispatched when getting Swikly caution status starts
 */ var GET_SWIKLY_CAUTION_STATUS_REQUEST = function() {
    return {
        type: ACTIONS.GET_SWIKLY_CAUTION_STATUS_REQUEST
    };
};
/**
 * Action dispatched when getting Swikly caution status succeeds
 * @param response - The response from the Swikly API
 */ var GET_SWIKLY_CAUTION_STATUS_SUCCESS = function(response) {
    return {
        type: ACTIONS.GET_SWIKLY_CAUTION_STATUS_SUCCESS,
        payload: response
    };
};
/**
 * Action dispatched when getting Swikly caution status fails
 * @param error - The error that occurred
 */ var GET_SWIKLY_CAUTION_STATUS_FAILURE = function(error) {
    return {
        type: ACTIONS.GET_SWIKLY_CAUTION_STATUS_FAILURE,
        error: error
    };
};
// Thunk actions
/**
 * Thunk action to create a new Swikly caution
 * @param data - The caution creation payload
 * @returns Promise that resolves with the created request
 */ var createSwiklyCaution = function(data) {
    return (function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var response;
            return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch(CREATE_SWIKLY_CAUTION_REQUEST());
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return _services_swikly__WEBPACK_IMPORTED_MODULE_1__/* .createSwiklyCaution */ .Xl(data);
                    case 4:
                        response = _ctx.sent;
                        dispatch(CREATE_SWIKLY_CAUTION_SUCCESS(response));
                        return _ctx.abrupt("return", response);
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        dispatch(CREATE_SWIKLY_CAUTION_FAILURE(_ctx.t0));
                        throw _ctx.t0;
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    })();
};
/**
 * Thunk action to get the status of a Swikly caution
 * @param swiklyId - The Swikly request ID
 * @returns Promise that resolves with the request details
 */ var getSwiklyCautionStatus = function(swiklyId) {
    return (function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
            var status;
            return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch(GET_SWIKLY_CAUTION_STATUS_REQUEST());
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return _services_swikly__WEBPACK_IMPORTED_MODULE_1__/* .getSwiklyCautionStatus */ .ZU(swiklyId);
                    case 4:
                        status = _ctx.sent;
                        dispatch(GET_SWIKLY_CAUTION_STATUS_SUCCESS(status));
                        return _ctx.abrupt("return", status);
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        dispatch(GET_SWIKLY_CAUTION_STATUS_FAILURE(_ctx.t0));
                        throw _ctx.t0;
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function(dispatch) {
            return _ref.apply(this, arguments);
        };
    })();
};


/***/ }),

/***/ 42738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aO": function() { return /* binding */ ACTIONS; },
  "R2": function() { return /* binding */ takeBack_getRightOfWithdrawalInfo; },
  "vq": function() { return /* binding */ takeBack_getTakeBackProduct; },
  "hY": function() { return /* binding */ takeBack_getTakeBackRef; },
  "Rl": function() { return /* binding */ takeBack_getTakeBackStock; },
  "TW": function() { return /* binding */ takeBack_getUserTakeBackProducts; },
  "cr": function() { return /* binding */ takeBack_postTakeBackInfo; }
});

// UNUSED EXPORTS: GET_RIGHT_OF_WITHDRAWAL_INFO_FAILURE, GET_RIGHT_OF_WITHDRAWAL_INFO_REQUEST, GET_RIGHT_OF_WITHDRAWAL_INFO_SUCCESS, GET_TAKE_BACK_ID_FAILURE, GET_TAKE_BACK_ID_REQUEST, GET_TAKE_BACK_ID_SUCCESS, GET_TAKE_BACK_REFERENCE_FAILURE, GET_TAKE_BACK_REFERENCE_REQUEST, GET_TAKE_BACK_REFERENCE_SUCCESS, GET_TAKE_BACK_STOCK_FAILURE, GET_TAKE_BACK_STOCK_REQUEST, GET_TAKE_BACK_STOCK_SUCCESS, GET_USER_TAKE_BACK_PRODUCTS_FAILURE, GET_USER_TAKE_BACK_PRODUCTS_REQUEST, GET_USER_TAKE_BACK_PRODUCTS_SUCCESS, POST_TAKE_BACK_INFO_FAILURE, POST_TAKE_BACK_INFO_REQUEST, POST_TAKE_BACK_INFO_SUCCESS

// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./redux/services/takeBack.ts




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var authHeaders = function() {
    return _objectSpread({}, (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE)));
};
var postTakeBackInfo = function(data) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.postTakeBackInfo */.KU.postTakeBackInfo,
        data: data
    });
};
var getTakeBackRef = function(data) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.takeBackRef */.KU.takeBackRef,
        uid: data
    });
};
var getTakeBackProduct = function(id) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.takeBackProduct */.KU.takeBackProduct,
        uid: id.toString()
    });
};
var getTakeBackStock = function(data, warehouseId) {
    return (0,api/* axiosRMSWrapper */.UZ)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* RMSRequestUrl.takeBackStock */.jo.takeBackStock,
        headers: authHeaders(),
        params: _objectSpread({}, data, {
            warehouseId: warehouseId
        })
    });
};
var getUserTakeBackProducts = function(data) {
    return (0,api/* axiosRMSWrapper */.UZ)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* RMSRequestUrl.userTakeBackProducts */.jo.userTakeBackProducts,
        params: data
    });
};
var getRightOfWithdrawalInfo = function(id) {
    return (0,api/* axiosRMSWrapper */.UZ)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* RMSRequestUrl.rightOfWithdrawal */.jo.rightOfWithdrawal,
        uid: id + '/right-of-withdrawal'
    });
};

;// CONCATENATED MODULE: ./redux/actions/takeBack.ts

var ACTIONS = {
    POST_TAKE_BACK_INFO_REQUEST: 'POST_TAKE_BACK_INFO_REQUEST',
    POST_TAKE_BACK_INFO_SUCCESS: 'POST_TAKE_BACK_INFO_SUCCESS',
    POST_TAKE_BACK_INFO_FAILURE: 'POST_TAKE_BACK_INFO_FAILURE',
    GET_TAKE_BACK_REFERENCE_REQUEST: 'GET_TAKE_BACK_REFERENCE_REQUEST',
    GET_TAKE_BACK_REFERENCE_SUCCESS: 'GET_TAKE_BACK_REFERENCE_SUCCESS',
    GET_TAKE_BACK_REFERENCE_FAILURE: 'GET_TAKE_BACK_REFERENCE_FAILURE',
    GET_TAKE_BACK_ID_REQUEST: 'GET_TAKE_BACK_ID_REQUEST',
    GET_TAKE_BACK_ID_SUCCESS: 'GET_TAKE_BACK_ID_SUCCESS',
    GET_TAKE_BACK_ID_FAILURE: 'GET_TAKE_BACK_ID_FAILURE',
    GET_TAKE_BACK_STOCK_REQUEST: 'GET_TAKE_BACK_STOCK_REQUEST',
    GET_TAKE_BACK_STOCK_SUCCESS: 'GET_TAKE_BACK_STOCK_SUCCESS',
    GET_TAKE_BACK_STOCK_FAILURE: 'GET_TAKE_BACK_STOCK_FAILURE',
    GET_USER_TAKE_BACK_PRODUCTS_REQUEST: 'GET_USER_TAKE_BACK_PRODUCTS_REQUEST',
    GET_USER_TAKE_BACK_PRODUCTS_SUCCESS: 'GET_USER_TAKE_BACK_PRODUCTS_SUCCESS',
    GET_USER_TAKE_BACK_PRODUCTS_FAILURE: 'GET_USER_TAKE_BACK_PRODUCTS_FAILURE',
    GET_RIGHT_OF_WITHDRAWAL_INFO_REQUEST: 'GET_RIGHT_OF_WITHDRAWAL_INFO_REQUEST',
    GET_RIGHT_OF_WITHDRAWAL_INFO_SUCCESS: 'GET_RIGHT_OF_WITHDRAWAL_INFO_SUCCESS',
    GET_RIGHT_OF_WITHDRAWAL_INFO_FAILURE: 'GET_RIGHT_OF_WITHDRAWAL_INFO_FAILURE'
};
var POST_TAKE_BACK_INFO_REQUEST = function() {
    return {
        type: ACTIONS.POST_TAKE_BACK_INFO_REQUEST
    };
};
var POST_TAKE_BACK_INFO_SUCCESS = function(response) {
    return {
        type: ACTIONS.POST_TAKE_BACK_INFO_SUCCESS,
        response: response
    };
};
var POST_TAKE_BACK_INFO_FAILURE = function(err) {
    return {
        type: ACTIONS.POST_TAKE_BACK_INFO_FAILURE,
        err: err
    };
};
function takeBack_postTakeBackInfo(data) {
    return function(dispatch) {
        dispatch(POST_TAKE_BACK_INFO_REQUEST());
        return postTakeBackInfo(data).then(function(response) {
            return dispatch(POST_TAKE_BACK_INFO_SUCCESS(response));
        }, function(err) {
            return dispatch(POST_TAKE_BACK_INFO_FAILURE(err));
        });
    };
}
var GET_TAKE_BACK_REFERENCE_REQUEST = function() {
    return {
        type: ACTIONS.GET_TAKE_BACK_REFERENCE_REQUEST
    };
};
var GET_TAKE_BACK_REFERENCE_SUCCESS = function(response) {
    return {
        type: ACTIONS.GET_TAKE_BACK_REFERENCE_SUCCESS,
        response: response
    };
};
var GET_TAKE_BACK_REFERENCE_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_TAKE_BACK_REFERENCE_FAILURE,
        err: err
    };
};
function takeBack_getTakeBackRef(data) {
    return function(dispatch) {
        dispatch(GET_TAKE_BACK_REFERENCE_REQUEST());
        return getTakeBackRef(data).then(function(response) {
            return dispatch(GET_TAKE_BACK_REFERENCE_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_TAKE_BACK_REFERENCE_FAILURE(err));
        });
    };
}
var GET_TAKE_BACK_ID_REQUEST = function() {
    return {
        type: ACTIONS.GET_TAKE_BACK_ID_REQUEST
    };
};
var GET_TAKE_BACK_ID_SUCCESS = function(response) {
    return {
        type: ACTIONS.GET_TAKE_BACK_ID_SUCCESS,
        response: response
    };
};
var GET_TAKE_BACK_ID_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_TAKE_BACK_ID_FAILURE,
        err: err
    };
};
function takeBack_getTakeBackProduct(id) {
    return function(dispatch) {
        dispatch(GET_TAKE_BACK_ID_REQUEST());
        return getTakeBackProduct(id).then(function(response) {
            return dispatch(GET_TAKE_BACK_ID_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_TAKE_BACK_ID_FAILURE(err));
        });
    };
}
var GET_TAKE_BACK_STOCK_REQUEST = function() {
    return {
        type: ACTIONS.GET_TAKE_BACK_STOCK_REQUEST
    };
};
var GET_TAKE_BACK_STOCK_SUCCESS = function(response) {
    return {
        type: ACTIONS.GET_TAKE_BACK_STOCK_SUCCESS,
        response: response
    };
};
var GET_TAKE_BACK_STOCK_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_TAKE_BACK_STOCK_FAILURE,
        err: err
    };
};
function takeBack_getTakeBackStock(data, warehouseId) {
    return function(dispatch) {
        dispatch(GET_TAKE_BACK_STOCK_REQUEST());
        return getTakeBackStock(data, warehouseId).then(function(response) {
            return dispatch(GET_TAKE_BACK_STOCK_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_TAKE_BACK_STOCK_FAILURE(err));
        });
    };
}
var GET_USER_TAKE_BACK_PRODUCTS_REQUEST = function() {
    return {
        type: ACTIONS.GET_USER_TAKE_BACK_PRODUCTS_REQUEST
    };
};
var GET_USER_TAKE_BACK_PRODUCTS_SUCCESS = function(response) {
    return {
        type: ACTIONS.GET_USER_TAKE_BACK_PRODUCTS_SUCCESS,
        response: response
    };
};
var GET_USER_TAKE_BACK_PRODUCTS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_USER_TAKE_BACK_PRODUCTS_FAILURE,
        err: err
    };
};
function takeBack_getUserTakeBackProducts(data) {
    return function(dispatch) {
        dispatch(GET_USER_TAKE_BACK_PRODUCTS_REQUEST());
        return getUserTakeBackProducts(data).then(function(response) {
            return dispatch(GET_USER_TAKE_BACK_PRODUCTS_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_USER_TAKE_BACK_PRODUCTS_FAILURE(err));
        });
    };
}
var GET_RIGHT_OF_WITHDRAWAL_INFO_REQUEST = function() {
    return {
        type: ACTIONS.GET_RIGHT_OF_WITHDRAWAL_INFO_REQUEST
    };
};
var GET_RIGHT_OF_WITHDRAWAL_INFO_SUCCESS = function(response) {
    return {
        type: ACTIONS.GET_RIGHT_OF_WITHDRAWAL_INFO_SUCCESS,
        response: response
    };
};
var GET_RIGHT_OF_WITHDRAWAL_INFO_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_RIGHT_OF_WITHDRAWAL_INFO_FAILURE,
        err: err
    };
};
function takeBack_getRightOfWithdrawalInfo(id) {
    return function(dispatch) {
        dispatch(GET_RIGHT_OF_WITHDRAWAL_INFO_REQUEST());
        return getRightOfWithdrawalInfo(id).then(function(response) {
            return dispatch(GET_RIGHT_OF_WITHDRAWAL_INFO_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_RIGHT_OF_WITHDRAWAL_INFO_FAILURE(err));
        });
    };
}


/***/ }),

/***/ 44279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aO": function() { return /* binding */ ACTIONS; },
/* harmony export */   "xI": function() { return /* binding */ getTaxons; },
/* harmony export */   "xY": function() { return /* binding */ getTaxonsAttributes; },
/* harmony export */   "JG": function() { return /* binding */ getTaxonsSizes; },
/* harmony export */   "dH": function() { return /* binding */ getAttributeValues; }
/* harmony export */ });
/* unused harmony exports GET_TAXONS_REQUEST, GET_TAXONS_SUCCESS, GET_TAXONS_FAILURE, GET_TAXONS_ATTRIBUTES_REQUEST, GET_TAXONS_ATTRIBUTES_SUCCESS, GET_TAXONS_ATTRIBUTES_FAILURE, GET_TAXONS_SIZES_REQUEST, GET_TAXONS_SIZES_SUCCESS, GET_TAXONS_SIZES_FAILURE, GET_ATTRIBUTE_VALUES_REQUEST, GET_ATTRIBUTE_VALUES_SUCCESS, GET_ATTRIBUTE_VALUES_FAILURE */
/* harmony import */ var _services_taxons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50173);
/* harmony import */ var _helpers_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12664);


var ACTIONS = {
    GET_TAXONS_REQUEST: 'GET_TAXONS_REQUEST',
    GET_TAXONS_SUCCESS: 'GET_TAXONS_SUCCESS',
    GET_TAXONS_FAILURE: 'GET_TAXONS_FAILURE',
    GET_TAXONS_ATTRIBUTES_REQUEST: 'GET_TAXONS_ATTRIBUTES_REQUEST',
    GET_TAXONS_ATTRIBUTES_SUCCESS: 'GET_TAXONS_ATTRIBUTES_SUCCESS',
    GET_TAXONS_ATTRIBUTES_FAILURE: 'GET_TAXONS_ATTRIBUTES_FAILURE',
    GET_TAXONS_SIZES_REQUEST: 'GET_TAXONS_SIZES_REQUEST',
    GET_TAXONS_SIZES_SUCCESS: 'GET_TAXONS_SIZES_SUCCESS',
    GET_TAXONS_SIZES_FAILURE: 'GET_TAXONS_SIZES_FAILURE',
    GET_ATTRIBUTE_VALUES_REQUEST: 'GET_ATTRIBUTE_VALUES_REQUEST',
    GET_ATTRIBUTE_VALUES_SUCCESS: 'GET_ATTRIBUTE_VALUES_SUCCESS',
    GET_ATTRIBUTE_VALUES_FAILURE: 'GET_ATTRIBUTE_VALUES_FAILURE'
};
var GET_TAXONS_REQUEST = function() {
    return {
        type: ACTIONS.GET_TAXONS_REQUEST
    };
};
var GET_TAXONS_SUCCESS = function(taxons, locale) {
    return {
        type: ACTIONS.GET_TAXONS_SUCCESS,
        taxons: taxons,
        locale: locale
    };
};
var GET_TAXONS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_TAXONS_FAILURE,
        err: err
    };
};
function getTaxons() {
    var locale = (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .getLocale */ .Kd)();
    return function(dispatch, getState) {
        // check if locale is different from locale in redux. if not, return
        var state = getState();
        if (state.taxons.locale === locale) {
            return;
        }
        dispatch(GET_TAXONS_REQUEST());
        return _services_taxons__WEBPACK_IMPORTED_MODULE_0__/* .getTaxons */ .xI().then(function(response) {
            return dispatch(GET_TAXONS_SUCCESS(response, locale));
        }, function(err) {
            return dispatch(GET_TAXONS_FAILURE(err));
        });
    };
}
var GET_TAXONS_ATTRIBUTES_REQUEST = function() {
    return {
        type: ACTIONS.GET_TAXONS_ATTRIBUTES_REQUEST
    };
};
var GET_TAXONS_ATTRIBUTES_SUCCESS = function(attributes, slug) {
    return {
        type: ACTIONS.GET_TAXONS_ATTRIBUTES_SUCCESS,
        attributes: attributes,
        slug: slug
    };
};
var GET_TAXONS_ATTRIBUTES_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_TAXONS_ATTRIBUTES_FAILURE,
        err: err
    };
};
function getTaxonsAttributes(taxonSlug) {
    return function(dispatch) {
        dispatch(GET_TAXONS_ATTRIBUTES_REQUEST());
        return _services_taxons__WEBPACK_IMPORTED_MODULE_0__/* .getTaxonsAttributes */ .xY(taxonSlug).then(function(response) {
            return dispatch(GET_TAXONS_ATTRIBUTES_SUCCESS(response, taxonSlug));
        }, function(err) {
            return dispatch(GET_TAXONS_ATTRIBUTES_FAILURE(err));
        });
    };
}
var GET_TAXONS_SIZES_REQUEST = function() {
    return {
        type: ACTIONS.GET_TAXONS_SIZES_REQUEST
    };
};
var GET_TAXONS_SIZES_SUCCESS = function(sizes, code) {
    return {
        type: ACTIONS.GET_TAXONS_SIZES_SUCCESS,
        sizes: sizes,
        code: code
    };
};
var GET_TAXONS_SIZES_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_TAXONS_SIZES_FAILURE,
        err: err
    };
};
function getTaxonsSizes(taxonCode) {
    return function(dispatch) {
        dispatch(GET_TAXONS_SIZES_REQUEST());
        return _services_taxons__WEBPACK_IMPORTED_MODULE_0__/* .getTaxonsSizes */ .JG(taxonCode).then(function(response) {
            return dispatch(GET_TAXONS_SIZES_SUCCESS(response, taxonCode));
        }, function(err) {
            return dispatch(GET_TAXONS_SIZES_FAILURE(err));
        });
    };
}
var GET_ATTRIBUTE_VALUES_REQUEST = function(attributeCode) {
    return {
        type: ACTIONS.GET_ATTRIBUTE_VALUES_REQUEST,
        attributeCode: attributeCode
    };
};
var GET_ATTRIBUTE_VALUES_SUCCESS = function(attributeCode, values, locale) {
    return {
        type: ACTIONS.GET_ATTRIBUTE_VALUES_SUCCESS,
        attributeCode: attributeCode,
        values: values,
        locale: locale
    };
};
var GET_ATTRIBUTE_VALUES_FAILURE = function(attributeCode, err) {
    return {
        type: ACTIONS.GET_ATTRIBUTE_VALUES_FAILURE,
        attributeCode: attributeCode,
        err: err
    };
};
function getAttributeValues(attributeCode) {
    var locale = (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .getLocale */ .Kd)();
    return function(dispatch, getState) {
        var ref;
        // check if we already have values for this attribute and locale
        var state = getState();
        var existingValues = (ref = state.taxons.attributeValues) === null || ref === void 0 ? void 0 : ref[attributeCode];
        if (existingValues && existingValues.locale === locale) {
            return Promise.resolve(existingValues.values);
        }
        dispatch(GET_ATTRIBUTE_VALUES_REQUEST(attributeCode));
        return _services_taxons__WEBPACK_IMPORTED_MODULE_0__/* .getProductAttributeByCode */ .mo(attributeCode).then(function(response) {
            return dispatch(GET_ATTRIBUTE_VALUES_SUCCESS(attributeCode, response, locale));
        }, function(err) {
            return dispatch(GET_ATTRIBUTE_VALUES_FAILURE(attributeCode, err));
        });
    };
}


/***/ }),

/***/ 76809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aO": function() { return /* binding */ ACTIONS; },
/* harmony export */   "a$": function() { return /* binding */ registerUser; },
/* harmony export */   "A9": function() { return /* binding */ verifyUser; },
/* harmony export */   "pH": function() { return /* binding */ loginUser; },
/* harmony export */   "TX": function() { return /* binding */ logoutUser; },
/* harmony export */   "mQ": function() { return /* binding */ finishSessionCheck; },
/* harmony export */   "PR": function() { return /* binding */ getUser; },
/* harmony export */   "_W": function() { return /* binding */ putUser; },
/* harmony export */   "kR": function() { return /* binding */ putUserPassword; },
/* harmony export */   "uI": function() { return /* binding */ getUserOrders; },
/* harmony export */   "VY": function() { return /* binding */ getGuestUserOrders; },
/* harmony export */   "YK": function() { return /* binding */ getConfirmationOrder; },
/* harmony export */   "yS": function() { return /* binding */ getUserOrderByToken; },
/* harmony export */   "h8": function() { return /* binding */ deleteUser; },
/* harmony export */   "o9": function() { return /* binding */ forgetPassword; },
/* harmony export */   "W6": function() { return /* binding */ putResetPassword; },
/* harmony export */   "XN": function() { return /* binding */ putUserOrder; },
/* harmony export */   "SC": function() { return /* binding */ getUserCards; },
/* harmony export */   "Tr": function() { return /* binding */ postUserCards; },
/* harmony export */   "Eu": function() { return /* binding */ saveGhostUser; },
/* harmony export */   "iJ": function() { return /* binding */ deleteGhostUser; },
/* harmony export */   "n3": function() { return /* binding */ getUserBalance; }
/* harmony export */ });
/* unused harmony exports SAVE_USER_REQUEST, SAVE_USER_SUCCESS, SAVE_USER_FAILURE, saveUser, REGISTER_USER_REQUEST, REGISTER_USER_SUCCESS, REGISTER_USER_FAILURE, VERIFY_USER_REQUEST, VERIFY_USER_SUCCESS, VERIFY_USER_FAILURE, LOGIN_USER_REQUEST, LOGIN_USER_SUCCESS, LOGIN_USER_FAILURE, LOGOUT_USER_SUCCESS, GET_USER_REQUEST, GET_USER_SUCCESS, GET_USER_FAILURE, FINISH_SESSION_CHECK, PUT_USER_REQUEST, PUT_USER_SUCCESS, PUT_USER_FAILURE, PUT_USER_PASSWORD_REQUEST, PUT_USER_PASSWORD_SUCCESS, PUT_USER_PASSWORD_FAILURE, GET_USER_ORDERS_REQUEST, GET_USER_ORDERS_SUCCESS, GET_USER_ORDERS_FAILURE, GET_CONFIRMATION_ORDER_REQUEST, GET_CONFIRMATION_ORDER_SUCCESS, GET_CONFIRMATION_ORDER_FAILURE, GET_USER_ORDER_BY_TOKEN_REQUEST, GET_USER_ORDER_BY_TOKEN_SUCCESS, GET_USER_ORDER_BY_TOKEN_FAILURE, DELETE_USER_REQUEST, DELETE_USER_SUCCESS, FORGET_PASSWORD_REQUEST, FORGET_PASSWORD_SUCCESS, FORGET_PASSWORD_FAILURE, RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE, PUT_USER_ORDER_REQUEST, PUT_USER_ORDER_SUCCESS, PUT_USER_ORDER_FAILURE, GET_USER_CARDS_REQUEST, GET_USER_CARDS_SUCCESS, GET_USER_CARDS_FAILURE, POST_USER_CARD_REQUEST, POST_USER_CARD_SUCCESS, POST_USER_CARD_FAILURE, SAVE_GHOST_USER, DELETE_GHOST_USER, GET_USER_BALANCE_REQUEST, GET_USER_BALANCE_SUCCESS, GET_USER_BALANCE_FAILURE */
/* harmony import */ var _services_user__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18611);
/* harmony import */ var _datadog_browser_rum__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60507);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66026);



var ACTIONS = {
    SAVE_USER_REQUEST: 'SAVE_USER_REQUEST',
    SAVE_USER_SUCCESS: 'SAVE_USER_SUCCESS',
    SAVE_USER_FAILURE: 'SAVE_USER_FAILURE',
    REGISTER_USER_REQUEST: 'REGISTER_USER_REQUEST',
    REGISTER_USER_SUCCESS: 'REGISTER_USER_SUCCESS',
    REGISTER_USER_FAILURE: 'REGISTER_USER_FAILURE',
    VERIFY_USER_REQUEST: 'VERIFY_USER_REQUEST',
    VERIFY_USER_SUCCESS: 'VERIFY_USER_SUCCESS',
    VERIFY_USER_FAILURE: 'VERIFY_USER_FAILURE',
    LOGIN_USER_REQUEST: 'LOGIN_USER_REQUEST',
    LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
    LOGIN_USER_FAILURE: 'LOGIN_USER_FAILURE',
    LOGOUT_USER_SUCCESS: 'LOGOUT_USER_SUCCESS',
    GET_USER_REQUEST: 'GET_USER_REQUEST',
    GET_USER_SUCCESS: 'GET_USER_SUCCESS',
    GET_USER_FAILURE: 'GET_USER_FAILURE',
    FINISH_SESSION_CHECK: 'FINISH_SESSION_CHECK',
    PUT_USER_REQUEST: 'PUT_USER_REQUEST',
    PUT_USER_SUCCESS: 'PUT_USER_SUCCESS',
    PUT_USER_FAILURE: 'PUT_USER_FAILURE',
    PUT_USER_PASSWORD_REQUEST: 'PUT_USER_PASSWORD_REQUEST',
    PUT_USER_PASSWORD_SUCCESS: 'PUT_USER_PASSWORD_SUCCESS',
    PUT_USER_PASSWORD_FAILURE: 'PUT_USER_PASSWORD_FAILURE',
    GET_USER_ORDERS_REQUEST: 'GET_USER_ORDERS_REQUEST',
    GET_USER_ORDERS_SUCCESS: 'GET_USER_ORDERS_SUCCESS',
    GET_USER_ORDERS_FAILURE: 'GET_USER_ORDERS_FAILURE',
    GET_USER_ORDER_BY_TOKEN_REQUEST: 'GET_USER_ORDER_BY_TOKEN_REQUEST',
    GET_USER_ORDER_BY_TOKEN_SUCCESS: 'GET_USER_ORDER_BY_TOKEN_SUCCESS',
    GET_USER_ORDER_BY_TOKEN_FAILURE: 'GET_USER_ORDER_BY_TOKEN_FAILURE',
    GET_CONFIRMATION_ORDER_REQUEST: 'GET_CONFIRMATION_ORDER_REQUEST',
    GET_CONFIRMATION_ORDER_SUCCESS: 'GET_CONFIRMATION_ORDER_SUCCESS',
    GET_CONFIRMATION_ORDER_FAILURE: 'GET_CONFIRMATION_ORDER_FAILURE',
    DELETE_USER_REQUEST: 'DELETE_USER_REQUEST',
    DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
    FORGET_PASSWORD_REQUEST: 'FORGET_PASSWORD_REQUEST',
    FORGET_PASSWORD_SUCCESS: 'FORGET_PASSWORD_SUCCESS',
    FORGET_PASSWORD_FAILURE: 'FORGET_PASSWORD_FAILURE',
    RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
    RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',
    PUT_USER_ORDER_REQUEST: 'PUT_USER_ORDER_REQUEST',
    PUT_USER_ORDER_SUCCESS: 'PUT_USER_ORDER_SUCCESS',
    PUT_USER_ORDER_FAILURE: 'PUT_USER_ORDER_FAILURE',
    GET_USER_CARDS_REQUEST: 'GET_USER_CARDS_REQUEST',
    GET_USER_CARDS_SUCCESS: 'GET_USER_CARDS_SUCCESS',
    GET_USER_CARDS_FAILURE: 'GET_USER_CARDS_FAILURE',
    POST_USER_CARD_REQUEST: 'POST_USER_CARD_REQUEST',
    POST_USER_CARD_SUCCESS: 'POST_USER_CARD_SUCCESS',
    POST_USER_CARD_FAILURE: 'POST_USER_CARD_FAILURE',
    SAVE_GHOST_USER: 'SAVE_GHOST_USER',
    DELETE_GHOST_USER: 'DELETE_GHOST_USER',
    GET_USER_BALANCE_REQUEST: 'GET_USER_BALANCE_REQUEST',
    GET_USER_BALANCE_SUCCESS: 'GET_USER_BALANCE_SUCCESS',
    GET_USER_BALANCE_FAILURE: 'GET_USER_BALANCE_FAILURE'
};
var SAVE_USER_REQUEST = function() {
    return {
        type: ACTIONS.SAVE_USER_REQUEST
    };
};
var SAVE_USER_SUCCESS = function(email) {
    return {
        type: ACTIONS.SAVE_USER_SUCCESS,
        email: email
    };
};
var SAVE_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.SAVE_USER_FAILURE,
        err: err
    };
};
function saveUser(email) {
    return function(dispatch) {
        dispatch(SAVE_USER_REQUEST());
        dispatch(SAVE_USER_SUCCESS(email));
    };
}
var REGISTER_USER_REQUEST = function() {
    return {
        type: ACTIONS.REGISTER_USER_REQUEST
    };
};
var REGISTER_USER_SUCCESS = function(token) {
    return {
        type: ACTIONS.REGISTER_USER_SUCCESS,
        token: token
    };
};
var REGISTER_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.REGISTER_USER_FAILURE,
        err: err
    };
};
function registerUser(data) {
    return function(dispatch) {
        dispatch(REGISTER_USER_REQUEST());
        if (data.email) _datadog_browser_rum__WEBPACK_IMPORTED_MODULE_1__/* .datadogRum.setUserProperty */ .v.setUserProperty('email', data.email);
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .registerUser */ .a$(data).then(function(response) {
            return dispatch(REGISTER_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(REGISTER_USER_FAILURE(err));
        });
    };
}
var VERIFY_USER_REQUEST = function() {
    return {
        type: ACTIONS.VERIFY_USER_REQUEST
    };
};
var VERIFY_USER_SUCCESS = function(user) {
    return {
        type: ACTIONS.VERIFY_USER_SUCCESS,
        user: user
    };
};
var VERIFY_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.VERIFY_USER_FAILURE,
        err: err
    };
};
function verifyUser(data) {
    return function(dispatch) {
        dispatch(VERIFY_USER_REQUEST());
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .verifyUser */ .A9(data).then(function(response) {
            return dispatch(VERIFY_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(VERIFY_USER_FAILURE(err));
        });
    };
}
var LOGIN_USER_REQUEST = function() {
    return {
        type: ACTIONS.LOGIN_USER_REQUEST
    };
};
var LOGIN_USER_SUCCESS = function(token) {
    return {
        type: ACTIONS.LOGIN_USER_SUCCESS,
        token: token
    };
};
var LOGIN_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.LOGIN_USER_FAILURE,
        err: err
    };
};
function loginUser(data) {
    return function(dispatch) {
        dispatch(LOGIN_USER_REQUEST());
        if (data.email) _datadog_browser_rum__WEBPACK_IMPORTED_MODULE_1__/* .datadogRum.setUserProperty */ .v.setUserProperty('email', data.email);
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .loginUser */ .pH(data).then(function(response) {
            return dispatch(LOGIN_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(LOGIN_USER_FAILURE(err));
        });
    };
}
var LOGOUT_USER_SUCCESS = function() {
    return {
        type: ACTIONS.LOGOUT_USER_SUCCESS
    };
};
function logoutUser() {
    return function(dispatch) {
        localStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .LOCAL_STORAGE_KEYS.TOKEN */ .dA.TOKEN);
        dispatch(LOGOUT_USER_SUCCESS());
    };
}
var GET_USER_REQUEST = function() {
    return {
        type: ACTIONS.GET_USER_REQUEST
    };
};
var GET_USER_SUCCESS = function(user) {
    if (user.email) _datadog_browser_rum__WEBPACK_IMPORTED_MODULE_1__/* .datadogRum.setUserProperty */ .v.setUserProperty('email', user.email);
    return {
        type: ACTIONS.GET_USER_SUCCESS,
        user: user
    };
};
var GET_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_USER_FAILURE,
        err: err
    };
};
var FINISH_SESSION_CHECK = function() {
    return {
        type: ACTIONS.FINISH_SESSION_CHECK
    };
};
function finishSessionCheck() {
    return function(dispatch) {
        dispatch(FINISH_SESSION_CHECK());
    };
}
function getUser() {
    return function(dispatch) {
        dispatch(GET_USER_REQUEST());
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .getUser */ .PR().then(function(response) {
            return dispatch(GET_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_USER_FAILURE(err));
        });
    };
}
var PUT_USER_REQUEST = function() {
    return {
        type: ACTIONS.PUT_USER_REQUEST
    };
};
var PUT_USER_SUCCESS = function(user) {
    return {
        type: ACTIONS.PUT_USER_SUCCESS,
        user: user
    };
};
var PUT_USER_FAILURE = function(err) {
    return {
        type: ACTIONS.PUT_USER_FAILURE,
        err: err
    };
};
function putUser(data) {
    return function(dispatch) {
        dispatch(PUT_USER_REQUEST());
        if (data.email) _datadog_browser_rum__WEBPACK_IMPORTED_MODULE_1__/* .datadogRum.setUserProperty */ .v.setUserProperty('email', data.email);
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .putUser */ ._W(data).then(function(response) {
            return dispatch(PUT_USER_SUCCESS(response));
        }, function(err) {
            return dispatch(PUT_USER_FAILURE(err));
        });
    };
}
var PUT_USER_PASSWORD_REQUEST = function() {
    return {
        type: ACTIONS.PUT_USER_PASSWORD_REQUEST
    };
};
var PUT_USER_PASSWORD_SUCCESS = function(user) {
    return {
        type: ACTIONS.PUT_USER_PASSWORD_SUCCESS,
        user: user
    };
};
var PUT_USER_PASSWORD_FAILURE = function(err) {
    return {
        type: ACTIONS.PUT_USER_PASSWORD_FAILURE,
        err: err
    };
};
function putUserPassword(data) {
    return function(dispatch) {
        dispatch(PUT_USER_PASSWORD_REQUEST());
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .putUserPassword */ .kR(data).then(function(response) {
            return dispatch(PUT_USER_PASSWORD_SUCCESS(response));
        }, function(err) {
            return dispatch(PUT_USER_PASSWORD_FAILURE(err));
        });
    };
}
var GET_USER_ORDERS_REQUEST = function() {
    return {
        type: ACTIONS.GET_USER_ORDERS_REQUEST
    };
};
var GET_USER_ORDERS_SUCCESS = function(orders) {
    return {
        type: ACTIONS.GET_USER_ORDERS_SUCCESS,
        orders: orders
    };
};
var GET_USER_ORDERS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_USER_ORDERS_FAILURE,
        err: err
    };
};
function getUserOrders() {
    return function(dispatch) {
        dispatch(GET_USER_ORDERS_REQUEST());
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .getUserOrders */ .uI().then(function(response) {
            return dispatch(GET_USER_ORDERS_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_USER_ORDERS_FAILURE(err));
        });
    };
}
var getGuestUserOrders = function(cartToken, email) {
    return function(dispatch) {
        dispatch(GET_USER_ORDERS_REQUEST());
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .getGuestUserOrders */ .VY(cartToken, email).then(function(response) {
            dispatch(GET_USER_ORDERS_SUCCESS([
                response
            ]));
        }, function(err) {
            dispatch(GET_USER_ORDERS_FAILURE(err));
        });
    };
};
var GET_CONFIRMATION_ORDER_REQUEST = function() {
    return {
        type: ACTIONS.GET_CONFIRMATION_ORDER_REQUEST
    };
};
var GET_CONFIRMATION_ORDER_SUCCESS = function(order) {
    return {
        type: ACTIONS.GET_CONFIRMATION_ORDER_SUCCESS,
        order: order
    };
};
var GET_CONFIRMATION_ORDER_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_CONFIRMATION_ORDER_FAILURE,
        err: err
    };
};
/**
 * Récupère la commande qui vient d'être passée sur la page de confirmation,
 * par token + email, via GET /shop-api/order/{token}/email/{email}.
 * Fonctionne aussi bien pour un user connecté que pour un invité (ghost user),
 * et stocke le résultat dans un champ dédié `confirmationOrder` pour ne pas
 * polluer `orders` (utilisé par la page compte).
 */ var getConfirmationOrder = function(token, email) {
    return function(dispatch) {
        dispatch(GET_CONFIRMATION_ORDER_REQUEST());
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .getGuestUserOrders */ .VY(token, email).then(function(response) {
            return dispatch(GET_CONFIRMATION_ORDER_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_CONFIRMATION_ORDER_FAILURE(err));
        });
    };
};
var GET_USER_ORDER_BY_TOKEN_REQUEST = function() {
    return {
        type: ACTIONS.GET_USER_ORDER_BY_TOKEN_REQUEST
    };
};
var GET_USER_ORDER_BY_TOKEN_SUCCESS = function(orders) {
    return {
        type: ACTIONS.GET_USER_ORDER_BY_TOKEN_SUCCESS,
        orders: orders
    };
};
var GET_USER_ORDER_BY_TOKEN_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_USER_ORDER_BY_TOKEN_FAILURE,
        err: err
    };
};
function getUserOrderByToken(token) {
    return function(dispatch) {
        dispatch(GET_USER_ORDER_BY_TOKEN_REQUEST());
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .getUserOrderByToken */ .yS(token).then(function(response) {
            return dispatch(GET_USER_ORDER_BY_TOKEN_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_USER_ORDER_BY_TOKEN_FAILURE(err));
        });
    };
}
var DELETE_USER_REQUEST = function() {
    return {
        type: ACTIONS.DELETE_USER_REQUEST
    };
};
var DELETE_USER_SUCCESS = function() {
    return {
        type: ACTIONS.DELETE_USER_SUCCESS
    };
};
function deleteUser() {
    return function(dispatch) {
        dispatch(DELETE_USER_SUCCESS());
    };
}
var FORGET_PASSWORD_REQUEST = function() {
    return {
        type: ACTIONS.FORGET_PASSWORD_REQUEST
    };
};
var FORGET_PASSWORD_SUCCESS = function(response) {
    return {
        type: ACTIONS.FORGET_PASSWORD_SUCCESS,
        response: response
    };
};
var FORGET_PASSWORD_FAILURE = function(err) {
    return {
        type: ACTIONS.FORGET_PASSWORD_FAILURE,
        err: err
    };
};
function forgetPassword(email) {
    return function(dispatch) {
        dispatch(FORGET_PASSWORD_REQUEST());
        _datadog_browser_rum__WEBPACK_IMPORTED_MODULE_1__/* .datadogRum.setUserProperty */ .v.setUserProperty('email', email);
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .forgetPassword */ .o9(email).then(function(response) {
            return dispatch(FORGET_PASSWORD_SUCCESS(response));
        }, function(err) {
            return dispatch(FORGET_PASSWORD_FAILURE(err));
        });
    };
}
var RESET_PASSWORD_REQUEST = function() {
    return {
        type: ACTIONS.RESET_PASSWORD_REQUEST
    };
};
var RESET_PASSWORD_SUCCESS = function(response) {
    return {
        type: ACTIONS.RESET_PASSWORD_SUCCESS,
        response: response
    };
};
var RESET_PASSWORD_FAILURE = function(err) {
    return {
        type: ACTIONS.RESET_PASSWORD_FAILURE,
        err: err
    };
};
function putResetPassword(data, token) {
    return function(dispatch) {
        dispatch(RESET_PASSWORD_REQUEST());
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .putResetPassword */ .W6(data, token).then(function(response) {
            return dispatch(RESET_PASSWORD_SUCCESS(response));
        }, function(err) {
            return dispatch(RESET_PASSWORD_FAILURE(err));
        });
    };
}
var PUT_USER_ORDER_REQUEST = function() {
    return {
        type: ACTIONS.PUT_USER_ORDER_REQUEST
    };
};
var PUT_USER_ORDER_SUCCESS = function(response) {
    return {
        type: ACTIONS.PUT_USER_ORDER_SUCCESS,
        response: response
    };
};
var PUT_USER_ORDER_FAILURE = function(err) {
    return {
        type: ACTIONS.PUT_USER_ORDER_FAILURE,
        err: err
    };
};
function putUserOrder(tokenValue) {
    return function(dispatch) {
        dispatch(PUT_USER_ORDER_REQUEST());
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .putUserOrder */ .XN(tokenValue).then(function(response) {
            return dispatch(PUT_USER_ORDER_SUCCESS(response));
        }, function(err) {
            return dispatch(PUT_USER_ORDER_FAILURE(err));
        });
    };
}
var GET_USER_CARDS_REQUEST = function() {
    return {
        type: ACTIONS.GET_USER_CARDS_REQUEST
    };
};
var GET_USER_CARDS_SUCCESS = function(cards) {
    return {
        type: ACTIONS.GET_USER_CARDS_SUCCESS,
        cards: cards
    };
};
var GET_USER_CARDS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_USER_CARDS_FAILURE,
        err: err
    };
};
function getUserCards() {
    return function(dispatch) {
        dispatch(GET_USER_CARDS_REQUEST());
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .getUserCards */ .SC().then(function(response) {
            return dispatch(GET_USER_CARDS_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_USER_CARDS_FAILURE(err));
        });
    };
}
var POST_USER_CARD_REQUEST = function() {
    return {
        type: ACTIONS.POST_USER_CARD_REQUEST
    };
};
var POST_USER_CARD_SUCCESS = function(cards) {
    return {
        type: ACTIONS.POST_USER_CARD_SUCCESS,
        cards: cards
    };
};
var POST_USER_CARD_FAILURE = function(err) {
    return {
        type: ACTIONS.POST_USER_CARD_FAILURE,
        err: err
    };
};
function postUserCards(data) {
    return function(dispatch) {
        dispatch(POST_USER_CARD_REQUEST());
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .postUserCards */ .Tr(data).then(function(response) {
            return dispatch(POST_USER_CARD_SUCCESS(response));
        }, function(err) {
            return dispatch(POST_USER_CARD_FAILURE(err));
        });
    };
}
var SAVE_GHOST_USER = function(ghostUserData) {
    return {
        type: ACTIONS.SAVE_GHOST_USER,
        ghostUserData: ghostUserData
    };
};
function saveGhostUser(data) {
    return function(dispatch) {
        dispatch(SAVE_GHOST_USER(data));
    };
}
var DELETE_GHOST_USER = function() {
    return {
        type: ACTIONS.DELETE_GHOST_USER
    };
};
function deleteGhostUser() {
    return function(dispatch) {
        dispatch(DELETE_GHOST_USER());
    };
}
var GET_USER_BALANCE_REQUEST = function() {
    return {
        type: ACTIONS.GET_USER_BALANCE_REQUEST
    };
};
var GET_USER_BALANCE_SUCCESS = function(balance) {
    return {
        type: ACTIONS.GET_USER_BALANCE_SUCCESS,
        balance: balance
    };
};
var GET_USER_BALANCE_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_USER_BALANCE_FAILURE,
        err: err
    };
};
function getUserBalance() {
    return function(dispatch) {
        dispatch(GET_USER_BALANCE_REQUEST());
        return _services_user__WEBPACK_IMPORTED_MODULE_0__/* .getUserBalance */ .n3().then(function(response) {
            return dispatch(GET_USER_BALANCE_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_USER_BALANCE_FAILURE(err));
        });
    };
}


/***/ }),

/***/ 94624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aO": function() { return /* binding */ ACTIONS; },
  "s3": function() { return /* binding */ wishList_addToWishList; },
  "GK": function() { return /* binding */ wishList_checkWishListExistence; },
  "KA": function() { return /* binding */ wishList_getWishList; },
  "AW": function() { return /* binding */ wishList_removeFromWishList; },
  "Mw": function() { return /* binding */ resetWishList; }
});

// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/wishList.ts




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var getWishList = function() {
    return axiosWrapper({
        method: EMethods.get,
        url: ERequestUrl.wishlist
    });
};
var addToWishList = function(code) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.wishlist */.KU.wishlist,
        headers: _objectSpread({
            'Content-Type': 'application/json'
        }, (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))),
        data: {
            code: code
        }
    });
};
var removeFromWishList = function(code) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.delete */.YZ["delete"],
        url: requests/* ERequestUrl.wishlist */.KU.wishlist,
        headers: _objectSpread({
            'Content-Type': 'application/json'
        }, (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))),
        uid: code
    });
};
var checkWishListExistence = function(productIds) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.wishlist */.KU.wishlist,
        uid: 'check',
        headers: _objectSpread({
            'Content-Type': 'application/json'
        }, (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE))),
        data: {
            productIds: productIds
        }
    });
};

// EXTERNAL MODULE: ./redux/services/products.ts
var products = __webpack_require__(83260);
;// CONCATENATED MODULE: ./redux/actions/wishList.ts


var ACTIONS = {
    GET_WISH_LIST_REQUEST: 'GET_WISH_LIST_REQUEST',
    GET_WISH_LIST_SUCCESS: 'GET_WISH_LIST_SUCCESS',
    GET_WISH_LIST_FAILURE: 'GET_WISH_LIST_FAILURE',
    ADD_TO_WISH_LIST_REQUEST: 'ADD_TO_WISH_LIST_REQUEST',
    ADD_TO_WISH_LIST_SUCCESS: 'ADD_TO_WISH_LIST_SUCCESS',
    ADD_TO_WISH_LIST_FAILURE: 'ADD_TO_WISH_LIST_FAILURE',
    REMOVE_FROM_WISH_LIST_REQUEST: 'REMOVE_FROM_WISH_LIST_REQUEST',
    REMOVE_FROM_WISH_LIST_SUCCESS: 'REMOVE_FROM_WISH_LIST_SUCCESS',
    REMOVE_FROM_WISH_LIST_FAILURE: 'REMOVE_FROM_WISH_LIST_FAILURE',
    RESET_WISH_LIST: 'RESET_WISH_LIST',
    CHECK_WISH_LIST_EXISTENCE: 'CHECK_WISH_LIST_EXISTENCE',
    CHECK_WISH_LIST_EXISTENCE_SUCCESS: 'CHECK_WISH_LIST_EXISTENCE_SUCCESS',
    CHECK_WISH_LIST_EXISTENCE_FAILURE: 'CHECK_WISH_LIST_EXISTENCE_FAILURE'
};
var RESET_WISH_LIST = function() {
    return {
        type: ACTIONS.RESET_WISH_LIST
    };
};
var GET_WISH_LIST_REQUEST = function() {
    return {
        type: ACTIONS.GET_WISH_LIST_REQUEST
    };
};
var GET_WISH_LIST_SUCCESS = function(products) {
    return {
        type: ACTIONS.GET_WISH_LIST_SUCCESS,
        products: products
    };
};
var GET_WISH_LIST_FAILURE = function(error) {
    return {
        type: ACTIONS.GET_WISH_LIST_FAILURE,
        error: error
    };
};
var ADD_TO_WISH_LIST_REQUEST = function() {
    return {
        type: ACTIONS.ADD_TO_WISH_LIST_REQUEST
    };
};
var ADD_TO_WISH_LIST_SUCCESS = function(id) {
    return {
        type: ACTIONS.ADD_TO_WISH_LIST_SUCCESS,
        id: id
    };
};
var ADD_TO_WISH_LIST_FAILURE = function(error) {
    return {
        type: ACTIONS.ADD_TO_WISH_LIST_FAILURE,
        error: error
    };
};
var REMOVE_FROM_WISH_LIST_REQUEST = function() {
    return {
        type: ACTIONS.REMOVE_FROM_WISH_LIST_REQUEST
    };
};
var REMOVE_FROM_WISH_LIST_SUCCESS = function(id) {
    return {
        type: ACTIONS.REMOVE_FROM_WISH_LIST_SUCCESS,
        id: id
    };
};
var REMOVE_FROM_WISH_LIST_FAILURE = function(error) {
    return {
        type: ACTIONS.REMOVE_FROM_WISH_LIST_FAILURE,
        error: error
    };
};
var CHECK_WISH_LIST_EXISTENCE = function() {
    return {
        type: ACTIONS.CHECK_WISH_LIST_EXISTENCE
    };
};
var CHECK_WISH_LIST_EXISTENCE_SUCCESS = function(productIds) {
    return {
        type: ACTIONS.CHECK_WISH_LIST_EXISTENCE_SUCCESS,
        productIds: productIds
    };
};
var CHECK_WISH_LIST_EXISTENCE_FAILURE = function(error) {
    return {
        type: ACTIONS.CHECK_WISH_LIST_EXISTENCE_FAILURE,
        error: error
    };
};
var wishList_getWishList = function(page, limit, locale) {
    return function(dispatch) {
        dispatch(GET_WISH_LIST_REQUEST());
        return (0,products/* getWishListProducts */.mb)(page, limit, locale).then(function(products) {
            return dispatch(GET_WISH_LIST_SUCCESS(products));
        }).catch(function(error) {
            return dispatch(GET_WISH_LIST_FAILURE(error));
        });
    };
};
var wishList_addToWishList = function(product) {
    return function(dispatch) {
        dispatch(ADD_TO_WISH_LIST_REQUEST());
        return addToWishList(product.code).then(function() {
            return dispatch(ADD_TO_WISH_LIST_SUCCESS(product.id));
        }).catch(function(error) {
            return dispatch(ADD_TO_WISH_LIST_FAILURE(error));
        });
    };
};
var wishList_removeFromWishList = function(product) {
    return function(dispatch) {
        dispatch(REMOVE_FROM_WISH_LIST_REQUEST());
        return removeFromWishList(product.code).then(function() {
            return dispatch(REMOVE_FROM_WISH_LIST_SUCCESS(product.id));
        }).catch(function(error) {
            return dispatch(REMOVE_FROM_WISH_LIST_FAILURE(error));
        });
    };
};
var resetWishList = function() {
    return function(dispatch) {
        dispatch(RESET_WISH_LIST());
    };
};
var wishList_checkWishListExistence = function(productIds1) {
    return function(dispatch) {
        dispatch(CHECK_WISH_LIST_EXISTENCE());
        return checkWishListExistence(productIds1).then(function(productIds) {
            return dispatch(CHECK_WISH_LIST_EXISTENCE_SUCCESS(productIds));
        }).catch(function(error) {
            return dispatch(CHECK_WISH_LIST_EXISTENCE_FAILURE(error));
        });
    };
};


/***/ }),

/***/ 52404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ PackAdapter; }
});

;// CONCATENATED MODULE: ./redux/adapter/products/productVariantAdapter.tsx
var ProductVariantAdapter = function(variant) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var productVariant = {
        code: variant === null || variant === void 0 ? void 0 : variant.code,
        name: variant === null || variant === void 0 ? void 0 : variant.name,
        sku: variant === null || variant === void 0 ? void 0 : variant.sku,
        price: {
            current: variant === null || variant === void 0 ? void 0 : (ref = variant.channelPricings) === null || ref === void 0 ? void 0 : ref.WEB.price
        },
        purchase: variant === null || variant === void 0 ? void 0 : (ref1 = variant.channelPricings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.WEB) === null || ref2 === void 0 ? void 0 : ref2.purchase,
        purchasePrice: variant === null || variant === void 0 ? void 0 : (ref3 = variant.channelPricings) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.WEB) === null || ref4 === void 0 ? void 0 : ref4.purchaseprice,
        maxStock: variant === null || variant === void 0 ? void 0 : variant.maxStock,
        size: variant === null || variant === void 0 ? void 0 : (ref5 = variant.newSize) === null || ref5 === void 0 ? void 0 : ref5.name
    };
    if (variant === null || variant === void 0 ? void 0 : variant.optionValues[0]) {
        var ref6, ref7, ref8;
        productVariant.axis = [
            (ref6 = variant === null || variant === void 0 ? void 0 : variant.optionValues[0]) === null || ref6 === void 0 ? void 0 : ref6.code
        ];
        productVariant.nameAxis = Object.defineProperty({}, (ref7 = variant === null || variant === void 0 ? void 0 : variant.optionValues[0]) === null || ref7 === void 0 ? void 0 : ref7.code, {
            value: (ref8 = variant === null || variant === void 0 ? void 0 : variant.optionValues[0]) === null || ref8 === void 0 ? void 0 : ref8.code
        });
    }
    return productVariant;
};

;// CONCATENATED MODULE: ./redux/adapter/packs/associatedProductAdapter.tsx

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AssociatedProductAdapter = function(product) {
    return {
        id: product === null || product === void 0 ? void 0 : product.id,
        name: product === null || product === void 0 ? void 0 : product.name,
        slug: product === null || product === void 0 ? void 0 : product.slug,
        code: product === null || product === void 0 ? void 0 : product.code,
        images: product === null || product === void 0 ? void 0 : product.images,
        description: product === null || product === void 0 ? void 0 : product.description,
        shortDescription: product === null || product === void 0 ? void 0 : product.shortDescription,
        averageRating: product === null || product === void 0 ? void 0 : product.averageRating,
        associations: product === null || product === void 0 ? void 0 : product.associations,
        enabled: product === null || product === void 0 ? void 0 : product.enabled,
        isSimpleProduct: product === null || product === void 0 ? void 0 : product.isSimpleProduct,
        variants: convertArrayToObject(product === null || product === void 0 ? void 0 : product.variants.map(function(variant) {
            return ProductVariantAdapter(variant);
        }), 'code')
    };
};
var convertArrayToObject = function(array, key) {
    var initialValue = {};
    return array.reduce(function(obj, item) {
        return _objectSpread({}, obj, _defineProperty({}, item[key], item));
    }, initialValue);
};

;// CONCATENATED MODULE: ./redux/adapter/packs/packAssociationAdapter.tsx

var PackAssociationAdapter = function(association) {
    var ref;
    return {
        products: association === null || association === void 0 ? void 0 : (ref = association.associatedProducts) === null || ref === void 0 ? void 0 : ref.map(function(associatedProduct) {
            return AssociatedProductAdapter(associatedProduct);
        })
    };
};

;// CONCATENATED MODULE: ./redux/adapter/packs/packAdapter.tsx

var PackAdapter = function(pack) {
    var ref, ref1;
    return {
        id: pack === null || pack === void 0 ? void 0 : pack.id,
        name: pack === null || pack === void 0 ? void 0 : pack.name,
        code: pack === null || pack === void 0 ? void 0 : pack.code,
        description: pack === null || pack === void 0 ? void 0 : pack.description,
        images: pack === null || pack === void 0 ? void 0 : pack.images,
        packProducts: pack === null || pack === void 0 ? void 0 : pack.packProducts,
        slug: pack === null || pack === void 0 ? void 0 : pack.slug,
        productsAssociations: (pack === null || pack === void 0 ? void 0 : (ref = pack.associations) === null || ref === void 0 ? void 0 : ref.length) > 0 ? pack === null || pack === void 0 ? void 0 : (ref1 = pack.associations) === null || ref1 === void 0 ? void 0 : ref1.filter(function(association) {
            return association && Object.keys(association).includes('associatedProducts');
        }).map(function(associatedProduct) {
            return PackAssociationAdapter(associatedProduct);
        }) : []
    };
};


/***/ }),

/***/ 12664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UZ": function() { return /* binding */ axiosRMSWrapper; },
  "ZP": function() { return /* binding */ api; },
  "Kd": function() { return /* binding */ getLocale; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/path-browserify/index.js
var path_browserify = __webpack_require__(1864);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js + 1 modules
var i18next = __webpack_require__(3745);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-logs/esm/entries/main.js + 16 modules
var main = __webpack_require__(67020);
// EXTERNAL MODULE: ./node_modules/is-retry-allowed/index.js
var is_retry_allowed = __webpack_require__(29367);
;// CONCATENATED MODULE: ./node_modules/axios-retry/dist/esm/index.js

const namespace = 'axios-retry';
function isNetworkError(error) {
    const CODE_EXCLUDE_LIST = ['ERR_CANCELED', 'ECONNABORTED'];
    if (error.response) {
        return false;
    }
    if (!error.code) {
        return false;
    }
    // Prevents retrying timed out & cancelled requests
    if (CODE_EXCLUDE_LIST.includes(error.code)) {
        return false;
    }
    // Prevents retrying unsafe errors
    return is_retry_allowed(error);
}
const SAFE_HTTP_METHODS = ['get', 'head', 'options'];
const IDEMPOTENT_HTTP_METHODS = SAFE_HTTP_METHODS.concat(['put', 'delete']);
function isRetryableError(error) {
    return (error.code !== 'ECONNABORTED' &&
        (!error.response || (error.response.status >= 500 && error.response.status <= 599)));
}
function isSafeRequestError(error) {
    if (!error.config?.method) {
        // Cannot determine if the request can be retried
        return false;
    }
    return isRetryableError(error) && SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function isIdempotentRequestError(error) {
    if (!error.config?.method) {
        // Cannot determine if the request can be retried
        return false;
    }
    return isRetryableError(error) && IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function isNetworkOrIdempotentRequestError(error) {
    return isNetworkError(error) || isIdempotentRequestError(error);
}
function noDelay() {
    return 0;
}
function exponentialDelay(retryNumber = 0, _error = undefined, delayFactor = 100) {
    const delay = 2 ** retryNumber * delayFactor;
    const randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
    return delay + randomSum;
}
const DEFAULT_OPTIONS = {
    retries: 3,
    retryCondition: isNetworkOrIdempotentRequestError,
    retryDelay: noDelay,
    shouldResetTimeout: false,
    onRetry: () => { }
};
function getRequestOptions(config, defaultOptions) {
    return { ...DEFAULT_OPTIONS, ...defaultOptions, ...config[namespace] };
}
function setCurrentState(config, defaultOptions) {
    const currentState = getRequestOptions(config, defaultOptions || {});
    currentState.retryCount = currentState.retryCount || 0;
    currentState.lastRequestTime = currentState.lastRequestTime || Date.now();
    config[namespace] = currentState;
    return currentState;
}
function fixConfig(axiosInstance, config) {
    // @ts-ignore
    if (axiosInstance.defaults.agent === config.agent) {
        // @ts-ignore
        delete config.agent;
    }
    if (axiosInstance.defaults.httpAgent === config.httpAgent) {
        delete config.httpAgent;
    }
    if (axiosInstance.defaults.httpsAgent === config.httpsAgent) {
        delete config.httpsAgent;
    }
}
async function shouldRetry(currentState, error) {
    const { retries, retryCondition } = currentState;
    const shouldRetryOrPromise = (currentState.retryCount || 0) < retries && retryCondition(error);
    // This could be a promise
    if (typeof shouldRetryOrPromise === 'object') {
        try {
            const shouldRetryPromiseResult = await shouldRetryOrPromise;
            // keep return true unless shouldRetryPromiseResult return false for compatibility
            return shouldRetryPromiseResult !== false;
        }
        catch (_err) {
            return false;
        }
    }
    return shouldRetryOrPromise;
}
const axiosRetry = (axiosInstance, defaultOptions) => {
    const requestInterceptorId = axiosInstance.interceptors.request.use((config) => {
        setCurrentState(config, defaultOptions);
        return config;
    });
    const responseInterceptorId = axiosInstance.interceptors.response.use(null, async (error) => {
        const { config } = error;
        // If we have no information to retry the request
        if (!config) {
            return Promise.reject(error);
        }
        const currentState = setCurrentState(config, defaultOptions);
        if (await shouldRetry(currentState, error)) {
            currentState.retryCount += 1;
            const { retryDelay, shouldResetTimeout, onRetry } = currentState;
            const delay = retryDelay(currentState.retryCount, error);
            // Axios fails merging this configuration to the default configuration because it has an issue
            // with circular structures: https://github.com/mzabriskie/axios/issues/370
            fixConfig(axiosInstance, config);
            if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
                const lastRequestDuration = Date.now() - currentState.lastRequestTime;
                const timeout = config.timeout - lastRequestDuration - delay;
                if (timeout <= 0) {
                    return Promise.reject(error);
                }
                config.timeout = timeout;
            }
            config.transformRequest = [(data) => data];
            await onRetry(currentState.retryCount, error, config);
            return new Promise((resolve) => {
                setTimeout(() => resolve(axiosInstance(config)), delay);
            });
        }
        return Promise.reject(error);
    });
    return { requestInterceptorId, responseInterceptorId };
};
// Compatibility with CommonJS
axiosRetry.isNetworkError = isNetworkError;
axiosRetry.isSafeRequestError = isSafeRequestError;
axiosRetry.isIdempotentRequestError = isIdempotentRequestError;
axiosRetry.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
axiosRetry.exponentialDelay = exponentialDelay;
axiosRetry.isRetryableError = isRetryableError;
/* harmony default export */ var esm = (axiosRetry);

;// CONCATENATED MODULE: ./redux/helpers/api.ts
/* provided dependency */ var process = __webpack_require__(34155);






function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var prismicLocales = "fr-fr" || 0;
var apiDomain = "https://millet-operator-staging-admin.lizee.io/" || 0;
var RMS_API = "https://api-staging.lizee.io" || 0;
var RMS_PUBLIC_API_TOKEN = "pCiqzNuJxd3BLGSwa2ohRqsxB2k6GD9B" || 0;
axios_default().interceptors.request.use(function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(config) {
        var retry, proxyRequestData;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    retry = config['axios-retry'];
                    if (!(retry && retry.retryCount === 3)) {
                        _ctx.next = 5;
                        break;
                    }
                    proxyRequestData = {
                        data: config.data,
                        method: config.method,
                        headers: config.headers,
                        auth: config.auth,
                        url: config.url,
                        params: config.params,
                        // allows cookies to be sent
                        withCredentials: true
                    };
                    main/* datadogLogs.logger.info */.fy.logger.info('Retrying request through nextjs proxy endpoint', proxyRequestData);
                    return _ctx.abrupt("return", _objectSpread({}, config, {
                        method: 'POST',
                        url: '/api/proxy',
                        data: JSON.stringify(proxyRequestData)
                    }));
                case 5:
                    return _ctx.abrupt("return", config);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(config) {
        return _ref.apply(this, arguments);
    };
}(), function(err) {
    // Request failed to be sent (!!!)
    main/* datadogLogs.logger.error */.fy.logger.error('Request failed to be sent', err, err);
    return Promise.reject(err);
});
axios_default().interceptors.response.use(undefined, function(err) {
    var ref, ref1, ref2, ref3;
    // Only log if the retry attempts have been exhausted
    if (axios_default().isAxiosError(err) && (err === null || err === void 0 ? void 0 : (ref = err.config) === null || ref === void 0 ? void 0 : (ref1 = ref.url) === null || ref1 === void 0 ? void 0 : ref1.includes('api/proxy')) && (err === null || err === void 0 ? void 0 : (ref2 = err.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2['axios-retry']) === null || ref3 === void 0 ? void 0 : ref3.retryCount) === 3) {
        main/* datadogLogs.logger.error */.fy.logger.error('Response failed', err, err);
    }
    return Promise.reject(err);
});
esm((axios_default()), {
    retries: 3,
    retryDelay: esm.exponentialDelay,
    onRetry: function(retryCount, error, config) {
        main/* datadogLogs.logger.info */.fy.logger.info('Retrying request', {
            retryCount: retryCount,
            config: config
        }, error);
    },
    retryCondition: function(error) {
        return error.code === 'ERR_NETWORK';
    }
});
var getLocale = function(customLocale) {
    var ref;
    var selectedLocale = (ref = customLocale !== null && customLocale !== void 0 ? customLocale : i18next/* default.language */.Z.language) !== null && ref !== void 0 ? ref : process.env.DEFAULT_LOCALE;
    var locale = prismicLocales.split(',').find(function(loc) {
        return loc.startsWith(selectedLocale);
    });
    if (!locale) {
        return selectedLocale;
    }
    return "".concat(selectedLocale, "_").concat(locale.substring(3, 5).toUpperCase());
};
var axiosWrapper = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var method, _origin, origin, url, headers, data, uid, params, customLocale, _isV2, isV2, _hasLocale, hasLocale, syliusLocale, apiResChar, baseUrl, fullUrl, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    method = param.method, _origin = param.origin, origin = _origin === void 0 ? apiDomain : _origin, url = param.url, headers = param.headers, data = param.data, uid = param.uid, params = param.params, customLocale = param.customLocale, _isV2 = param.isV2, isV2 = _isV2 === void 0 ? false : _isV2, _hasLocale = param.hasLocale, hasLocale = _hasLocale === void 0 ? true : _hasLocale;
                    syliusLocale = getLocale(customLocale);
                    apiResChar = '';
                    if (isV2) {
                        apiResChar = '&';
                    } else {
                        apiResChar = '?';
                    }
                    baseUrl = origin.endsWith('/') ? origin : "".concat(origin, "/");
                    fullUrl = "".concat(baseUrl).concat(path_browserify_default().join(url, uid || ''));
                    if (hasLocale) {
                        fullUrl = fullUrl + "".concat(apiResChar, "locale=").concat(syliusLocale);
                    }
                    try {
                        // This version of datadog only runs in the browser, on server it's looking for `document`
                        // Find a way to log requests made from server with dd-trace
                        // Next.js has issues with dd-trace because it requiers Node.JS APIs
                        // Possible workout: https://github.com/vercel/next.js/discussions/16600#discussioncomment-5003698
                        main/* datadogLogs.logger.info */.fy.logger.info('Request to sylius', {
                            method: method,
                            origin_data: data,
                            params: params,
                            url: fullUrl
                        });
                    // eslint-disable-next-line no-empty
                    } catch (e) {}
                    _ctx.next = 10;
                    return axios_default()({
                        method: method,
                        url: fullUrl,
                        headers: _objectSpread({}, headers),
                        params: params,
                        data: data
                    });
                case 10:
                    response = _ctx.sent;
                    try {
                        main/* datadogLogs.logger.info */.fy.logger.info('Response from sylius', {
                            method: method,
                            origin_data: data,
                            params: params,
                            response_data: response.data,
                            status: response.status,
                            url: fullUrl
                        });
                    // eslint-disable-next-line no-empty
                    } catch (e1) {}
                    return _ctx.abrupt("return", response.data.data ? response.data.data : response.data);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function axiosWrapper(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var api = (axiosWrapper);
var axiosRMSWrapper = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var method, url, headers, params, uid, data, domain, baseUrl, fullUrl, locale, dataWithLocale, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    method = param.method, url = param.url, headers = param.headers, params = param.params, uid = param.uid, data = param.data;
                    domain = RMS_API;
                    baseUrl = domain.endsWith('/api') ? "".concat(domain, "/") : "".concat(domain, "/api/");
                    fullUrl = "".concat(baseUrl).concat(path_browserify_default().join(url, uid || ''));
                    locale = getLocale();
                    dataWithLocale = _objectSpread({}, data, {
                        locale: locale
                    });
                    main/* datadogLogs.logger.info */.fy.logger.info('Request to RMS', {
                        origin_data: dataWithLocale,
                        url: fullUrl,
                        method: method,
                        params: params
                    });
                    _ctx.next = 9;
                    return axios_default()({
                        method: method,
                        url: fullUrl,
                        headers: _objectSpread({
                            'x-api-key': RMS_PUBLIC_API_TOKEN,
                            'Content-Type': 'application/json'
                        }, headers),
                        params: params,
                        data: dataWithLocale
                    });
                case 9:
                    response = _ctx.sent;
                    main/* datadogLogs.logger.info */.fy.logger.info('Response from RMS', {
                        method: method,
                        origin_data: dataWithLocale,
                        response_data: response.data,
                        status_code: response.status,
                        params: params,
                        url: fullUrl
                    });
                    return _ctx.abrupt("return", response.data.data ? response.data.data : response.data);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function axiosRMSWrapper(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 20031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YZ": function() { return /* binding */ EMethods; },
/* harmony export */   "KU": function() { return /* binding */ ERequestUrl; },
/* harmony export */   "jo": function() { return /* binding */ RMSRequestUrl; },
/* harmony export */   "bU": function() { return /* binding */ NextApiRequestUrl; }
/* harmony export */ });
var EMethods;
(function(EMethods) {
    EMethods["post"] = "post";
    EMethods["get"] = "get";
    EMethods["delete"] = "delete";
    EMethods["put"] = "put";
    EMethods["patch"] = "patch";
})(EMethods || (EMethods = {}));
var ERequestUrl;
(function(ERequestUrl) {
    ERequestUrl["root"] = 'shop-api/';
    ERequestUrl["rootV2"] = 'api/v2';
    ERequestUrl["products"] = 'shop-api/products';
    ERequestUrl["register"] = 'shop-api/register';
    ERequestUrl["login"] = 'shop-api/login';
    ERequestUrl["refreshToken"] = 'ciam/token/refresh';
    ERequestUrl["getCurrentRefreshToken"] = 'ciam/token/refreshed/current';
    ERequestUrl["productsByTaxonSlug"] = 'shop-api/taxon-products/by-slug/';
    ERequestUrl["taxons"] = 'shop-api/taxons/';
    ERequestUrl["userInfo"] = 'shop-api/me';
    ERequestUrl["verifyUser"] = 'shop-api/verify-account';
    ERequestUrl["address"] = 'shop-api/address-book/';
    ERequestUrl["return"] = 'shop-api/shipments/return';
    ERequestUrl["userOrders"] = 'shop-api/orders';
    ERequestUrl["guestUserOrders"] = 'shop-api/order';
    ERequestUrl["createCart"] = 'shop-api/carts';
    ERequestUrl["promotions"] = 'shop-api/promotions';
    ERequestUrl["forgetPassword"] = 'shop-api/request-password-reset';
    ERequestUrl["resetPassword"] = 'shop-api/password-reset';
    ERequestUrl["checkout"] = 'shop-api/checkout/';
    ERequestUrl["pointsRelais"] = 'https://ws.chronopost.fr/recherchebt-ws-cxf/PointRelaisServiceWS/rechercheBtParCodeproduitEtCodepostalEtDate?codePostal=';
    ERequestUrl["stripe"] = 'shop-api/payment';
    ERequestUrl["taxonPack"] = 'shop-api/taxon-packs';
    ERequestUrl["packs"] = 'shop-api/packs/taxon/';
    ERequestUrl["productsLatest"] = 'shop-api/product-latest/';
    ERequestUrl["reviews"] = 'shop-api/reviews';
    ERequestUrl["countries"] = 'api/v2/shop/countries?enabled=true';
    ERequestUrl["warehouseOrder"] = 'shop-api/warehouse/orders';
    ERequestUrl["contractCSUB"] = 'api/v2/shop/classic-subscription-contracts';
    ERequestUrl["contractSUB"] = 'api/v2/shop/pay-as-you-go-subscription-contracts';
    ERequestUrl["apiGouvFr"] = 'https://calendrier.api.gouv.fr/jours-feries/metropole';
    ERequestUrl["cards"] = 'shop-api/cards';
    ERequestUrl["token"] = 'shop-api/users/token';
    ERequestUrl["atlanticLogin"] = 'shop-api/atlantic/login';
    ERequestUrl["takeBackRef"] = 'shop-api/product/sticker-reference/';
    ERequestUrl["takeBackProduct"] = 'shop-api/product/';
    ERequestUrl["payment"] = 'shop-api/payment/';
    ERequestUrl["paths"] = 'shop-api/products-packs-slugs';
    ERequestUrl["taxonAttributes"] = 'shop-api/taxon-attributes/';
    ERequestUrl["taxonSizes"] = 'shop-api/taxon/';
    ERequestUrl["productAttributeByCode"] = 'shop-api/product-attribute-by-code';
    ERequestUrl["balance"] = 'shop-api/payment-method/balance';
    ERequestUrl["invoice"] = 'shop-api/orders/';
    ERequestUrl["postTakeBackInfo"] = 'shop-api/second-hand/take-back';
    ERequestUrl["shipments"] = 'shop-api/shipments';
    ERequestUrl["wishlist"] = 'shop-api/wishlist';
})(ERequestUrl || (ERequestUrl = {}));
var RMSRequestUrl;
(function(RMSRequestUrl) {
    RMSRequestUrl["prismic"] = 'prismic';
    RMSRequestUrl["stock"] = 'stock';
    RMSRequestUrl["uniqueProductStock"] = 'stock/unique-products';
    RMSRequestUrl["pickingPlace"] = 'parcelshops';
    RMSRequestUrl["resetStock"] = 'fixtures/reset?accessToken=WrNiWhwhiyx2i8sl74mb1wLMRTxTtjG9';
    RMSRequestUrl["productAvailability"] = 'stock/variant-unavailability';
    RMSRequestUrl["takeBackStock"] = 'stock/second-hand';
    RMSRequestUrl["stockAlert"] = 'stock/alert';
    RMSRequestUrl["userTakeBackProducts"] = 'second-hand/requests';
    RMSRequestUrl["rightOfWithdrawal"] = 'orders';
    RMSRequestUrl["productsSearch"] = 'products/search';
    RMSRequestUrl["productReturningReasons"] = 'product-returning-raisons/';
    RMSRequestUrl["customReturn"] = 'shipments/custom-return';
    RMSRequestUrl["fileSignedUrl"] = 'file/signed-url-upload';
    RMSRequestUrl["file"] = 'file';
    RMSRequestUrl["reservations"] = 'reservations';
    RMSRequestUrl["renters"] = 'renters';
    RMSRequestUrl["fgasCapacityCertificates"] = 'fgas-capacity-certificates';
    RMSRequestUrl["contactRequests"] = 'contact-requests';
})(RMSRequestUrl || (RMSRequestUrl = {}));
var NextApiRequestUrl;
(function(NextApiRequestUrl) {
    NextApiRequestUrl["filterProducts"] = '/api/filterProducts';
})(NextApiRequestUrl || (NextApiRequestUrl = {}));


/***/ }),

/***/ 63593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DL": function() { return /* binding */ AddressType; }
/* harmony export */ });
/* unused harmony export initialState */
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AddressType;
(function(AddressType) {
    AddressType["AREA"] = 'area';
})(AddressType || (AddressType = {}));
var initialAddressState = {
    search: undefined,
    payload: undefined,
    input: undefined,
    isValid: false,
    isPanelOpen: false
};
var initialState = {
    billing: _objectSpread({}, initialAddressState),
    shipping: _objectSpread({}, initialAddressState)
};
var inputAddressReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case 'SAVE_PAYLOAD_ADDRESS':
            return _objectSpread({}, state, _defineProperty({}, action.addressType, _objectSpread({}, state[action.addressType], {
                payload: action.payload,
                isValid: action.isValid
            })));
        case 'SAVE_SEARCH_ADDRESS':
            return _objectSpread({}, state, _defineProperty({}, action.addressType, _objectSpread({}, state[action.addressType], {
                search: action.search
            })));
        case 'SAVE_INPUT_ADDRESS':
            return _objectSpread({}, state, _defineProperty({}, action.addressType, _objectSpread({}, state[action.addressType], {
                isPanelOpen: action.isPanelOpen,
                input: action.input
            })));
        case 'RESET_INPUT_ADDRESS':
            return _objectSpread({}, state, _defineProperty({}, action.addressType, initialState[action.addressType]));
        default:
            return state;
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (inputAddressReducer);


/***/ }),

/***/ 10049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Om": function() { return /* binding */ getCheckout; },
/* harmony export */   "LY": function() { return /* binding */ createCheckoutAdress; },
/* harmony export */   "kO": function() { return /* binding */ putOrderReference; },
/* harmony export */   "ek": function() { return /* binding */ getCheckoutShippingMethods; },
/* harmony export */   "l9": function() { return /* binding */ createCheckoutShipping; },
/* harmony export */   "dG": function() { return /* binding */ createCheckoutPayment; },
/* harmony export */   "PA": function() { return /* binding */ getLastUsedBillingAddress; }
/* harmony export */ });
/* unused harmony export postCheckout */
/* harmony import */ var _helpers_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12664);
/* harmony import */ var _helpers_requests__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20031);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16502);



var getCheckout = function(token) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .ERequestUrl.checkout */ .KU.checkout,
        uid: token
    });
};
var createCheckoutAdress = function(token, item) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .EMethods.put */ .YZ.put,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .ERequestUrl.checkout */ .KU.checkout,
        uid: "".concat(token, "/address"),
        data: item
    });
};
var putOrderReference = function(token, additionalReference) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .EMethods.put */ .YZ.put,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .ERequestUrl.createCart */ .KU.createCart,
        uid: "".concat(token, "/reference"),
        data: {
            additionalReference: additionalReference
        }
    });
};
var getCheckoutShippingMethods = function(token) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .ERequestUrl.checkout */ .KU.checkout,
        uid: "".concat(token, "/shipping")
    });
};
var createCheckoutShipping = function(token, method) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .EMethods.put */ .YZ.put,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .ERequestUrl.checkout */ .KU.checkout,
        uid: "".concat(token, "/shipping/0"),
        data: {
            method: method
        }
    });
};
var createCheckoutPayment = function(token) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .EMethods.put */ .YZ.put,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .ERequestUrl.checkout */ .KU.checkout,
        uid: "".concat(token, "/payment/0"),
        data: {
            method: 'bank_transfer'
        }
    });
};
var postCheckout = function(token, data) {
    return axiosWrapper({
        method: EMethods.post,
        url: ERequestUrl.stripe,
        data: data,
        uid: "".concat(token, "/execute")
    });
};
var getLastUsedBillingAddress = function() {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_1__/* .ERequestUrl.shipments */ .KU.shipments,
        uid: 'last-billing-address',
        headers: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__/* .apiHeaders */ .pW)(localStorage.getItem('connexion-type'))
    });
};


/***/ }),

/***/ 83260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R2": function() { return /* binding */ getProductsByTaxonsSlug; },
/* harmony export */   "mb": function() { return /* binding */ getWishListProducts; },
/* harmony export */   "cs": function() { return /* binding */ getProductsBySlug; },
/* harmony export */   "lO": function() { return /* binding */ getLatestProducts; },
/* harmony export */   "K5": function() { return /* binding */ getStock; },
/* harmony export */   "BA": function() { return /* binding */ getUniqueProductStock; },
/* harmony export */   "Gz": function() { return /* binding */ postStockAlert; },
/* harmony export */   "eI": function() { return /* binding */ getProductVariantAvailability; },
/* harmony export */   "ft": function() { return /* binding */ filterProducts; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12664);
/* harmony import */ var _helpers_requests__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20031);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16502);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66026);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var authHeaders = function() {
    return _objectSpread({}, (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE)));
};
var getProductsByTaxonsSlug = function(slug, limit, page, attributes, search, locale, isSecondHand, sort) {
    var data = {
        limit: limit,
        page: page,
        locale: locale,
        sort: sort,
        isSecondHand: isSecondHand
    };
    if (attributes) {
        data['filters'] = attributes;
    }
    if (slug) data['slug'] = slug;
    if (search) data['search'] = search;
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .axiosRMSWrapper */ .UZ)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.post */ .YZ.post,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .RMSRequestUrl.productsSearch */ .jo.productsSearch,
        headers: _objectSpread({
            'Content-Type': 'application/json'
        }, (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE))),
        data: data
    });
};
var getWishListProducts = function(page, limit, locale) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .axiosRMSWrapper */ .UZ)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.post */ .YZ.post,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .RMSRequestUrl.productsSearch */ .jo.productsSearch,
        headers: _objectSpread({
            'Content-Type': 'application/json'
        }, (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE))),
        data: {
            page: page,
            limit: limit,
            wishlistOnly: true,
            locale: locale
        }
    });
};
var getProductsBySlug = function(slug, customLocale) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.products */ .KU.products,
        uid: "/by-code/".concat(slug),
        customLocale: customLocale
    });
};
var getLatestProducts = function() {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.productsLatest */ .KU.productsLatest
    });
};
var getStock = function(data, warehouseId) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .axiosRMSWrapper */ .UZ)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .RMSRequestUrl.stock */ .jo.stock,
        headers: authHeaders(),
        params: _objectSpread({}, data, {
            warehouseId: warehouseId
        })
    });
};
var getUniqueProductStock = function(puids) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .axiosRMSWrapper */ .UZ)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .RMSRequestUrl.uniqueProductStock */ .jo.uniqueProductStock,
        headers: authHeaders(),
        params: {
            puids: puids
        }
    });
};
var postStockAlert = function(data) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .axiosRMSWrapper */ .UZ)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.post */ .YZ.post,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .RMSRequestUrl.stockAlert */ .jo.stockAlert,
        data: data
    });
};
var getProductVariantAvailability = function(lizeeSku) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .axiosRMSWrapper */ .UZ)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .RMSRequestUrl.productAvailability */ .jo.productAvailability,
        params: {
            lizeeSKU: lizeeSku,
            quantity: 1
        }
    });
};
var filterProducts = function(query, page, limit, locale) {
    return axios__WEBPACK_IMPORTED_MODULE_0___default().get(_helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .NextApiRequestUrl.filterProducts */ .bU.filterProducts, {
        params: {
            query: query,
            limit: limit,
            page: page,
            locale: locale
        }
    }).then(function(res) {
        return res.data;
    });
};


/***/ }),

/***/ 71371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OO": function() { return /* binding */ SwiklyLanguage; },
/* harmony export */   "ZU": function() { return /* binding */ getSwiklyCautionStatus; },
/* harmony export */   "Xl": function() { return /* binding */ createSwiklyCaution; }
/* harmony export */ });
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var SwiklyLanguage;
(function(SwiklyLanguage) {
    SwiklyLanguage["FR"] = 'fr';
    SwiklyLanguage["EN"] = 'en';
    SwiklyLanguage["ES"] = 'es';
    SwiklyLanguage["IT"] = 'it';
    SwiklyLanguage["NL"] = 'nl';
    SwiklyLanguage["DE"] = 'de';
})(SwiklyLanguage || (SwiklyLanguage = {}));
// --- Frontend Service Functions ---
/**
 * Get the status of a Swikly caution by its ID
 * @param swiklyId - The Swikly request ID
 * @returns Promise with the request details including deposit status
 */ var getSwiklyCautionStatus = function() {
    var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(swiklyId) {
        var response;
        return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().get("/api/swikly/".concat(swiklyId));
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSwiklyCautionStatus(swiklyId) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Create a new Swikly caution (deposit)
 * @param data - The caution creation payload
 * @returns Promise with the created request details
 */ var createSwiklyCaution = function() {
    var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
        var response;
        return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_1___default().post('/api/swikly/create', data);
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    } // Note: Reclaim and cancel endpoints were removed as they are not currently used
     // If needed in the future, they can be re-implemented with proper UI components
    ));
    return function createSwiklyCaution(data) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 50173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xI": function() { return /* binding */ getTaxons; },
/* harmony export */   "xY": function() { return /* binding */ getTaxonsAttributes; },
/* harmony export */   "JG": function() { return /* binding */ getTaxonsSizes; },
/* harmony export */   "mo": function() { return /* binding */ getProductAttributeByCode; },
/* harmony export */   "OD": function() { return /* binding */ getLocalesTaxons; }
/* harmony export */ });
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12664);
/* harmony import */ var _helpers_requests__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20031);



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var getTaxons = function(customLocale) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.taxons */ .KU.taxons,
        customLocale: customLocale
    });
};
var getTaxonsAttributes = function(taxonSlug) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.taxonAttributes */ .KU.taxonAttributes,
        uid: taxonSlug
    });
};
var getTaxonsSizes = function(taxonCode) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.taxonSizes */ .KU.taxonSizes,
        uid: taxonCode + '/sizes'
    });
};
var getProductAttributeByCode = function(attributeCode, customLocale) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.productAttributeByCode */ .KU.productAttributeByCode,
        params: {
            code: attributeCode
        },
        customLocale: customLocale
    });
};
var getLocalesTaxons = function() {
    var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(locales) {
        var taxonsMap, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, locale, ref, taxons;
        return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    taxonsMap = {};
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _ctx.prev = 2;
                    _iterator = locales[Symbol.iterator]();
                case 4:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                        _ctx.next = 14;
                        break;
                    }
                    locale = _step.value;
                    ;
                    _ctx.next = 9;
                    return getTaxons(locale);
                case 9:
                    taxons = _ctx.sent;
                    taxonsMap[locale] = (taxons === null || taxons === void 0 ? void 0 : (ref = taxons[0]) === null || ref === void 0 ? void 0 : ref.children) || [];
                case 11:
                    _iteratorNormalCompletion = true;
                    _ctx.next = 4;
                    break;
                case 14:
                    _ctx.next = 20;
                    break;
                case 16:
                    _ctx.prev = 16;
                    _ctx.t0 = _ctx["catch"](2);
                    _didIteratorError = true;
                    _iteratorError = _ctx.t0;
                case 20:
                    _ctx.prev = 20;
                    _ctx.prev = 21;
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                case 23:
                    _ctx.prev = 23;
                    if (!_didIteratorError) {
                        _ctx.next = 26;
                        break;
                    }
                    throw _iteratorError;
                case 26:
                    return _ctx.finish(23);
                case 27:
                    return _ctx.finish(20);
                case 28:
                    return _ctx.abrupt("return", taxonsMap);
                case 29:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                16,
                20,
                28
            ],
            [
                21,
                ,
                23,
                27
            ]
        ]);
    }));
    return function getLocalesTaxons(locales) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 18611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a$": function() { return /* binding */ registerUser; },
/* harmony export */   "A9": function() { return /* binding */ verifyUser; },
/* harmony export */   "pH": function() { return /* binding */ loginUser; },
/* harmony export */   "g$": function() { return /* binding */ refreshToken; },
/* harmony export */   "xt": function() { return /* binding */ getCurrentRefreshToken; },
/* harmony export */   "PR": function() { return /* binding */ getUser; },
/* harmony export */   "uI": function() { return /* binding */ getUserOrders; },
/* harmony export */   "VY": function() { return /* binding */ getGuestUserOrders; },
/* harmony export */   "yS": function() { return /* binding */ getUserOrderByToken; },
/* harmony export */   "_W": function() { return /* binding */ putUser; },
/* harmony export */   "kR": function() { return /* binding */ putUserPassword; },
/* harmony export */   "o9": function() { return /* binding */ forgetPassword; },
/* harmony export */   "W6": function() { return /* binding */ putResetPassword; },
/* harmony export */   "XN": function() { return /* binding */ putUserOrder; },
/* harmony export */   "SC": function() { return /* binding */ getUserCards; },
/* harmony export */   "Tr": function() { return /* binding */ postUserCards; },
/* harmony export */   "n3": function() { return /* binding */ getUserBalance; }
/* harmony export */ });
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16502);
/* harmony import */ var _helpers_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12664);
/* harmony import */ var _helpers_requests__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20031);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66026);




var registerUser = function(data) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.post */ .YZ.post,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.register */ .KU.register,
        data: data
    });
};
var verifyUser = function(token) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.verifyUser */ .KU.verifyUser,
        params: {
            token: token
        }
    });
};
var loginUser = function(data) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.post */ .YZ.post,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.login */ .KU.login,
        data: data
    });
};
var refreshToken = function() {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.refreshToken */ .KU.refreshToken,
        headers: {
            'Content-Type': 'application/json',
            'Refresh-Token': localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.REFRESH_TOKEN */ .dA.REFRESH_TOKEN),
            'Login-Method': localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.LOGIN_METHOD */ .dA.LOGIN_METHOD)
        }
    });
};
var getCurrentRefreshToken = function() {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.getCurrentRefreshToken */ .KU.getCurrentRefreshToken,
        headers: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE))
    });
};
var getUser = function() {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.userInfo */ .KU.userInfo,
        headers: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE))
    });
};
var getUserOrders = function() {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.userOrders */ .KU.userOrders,
        headers: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE))
    });
};
// TODO: add email to the request
var getGuestUserOrders = function(cartToken, email) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.guestUserOrders */ .KU.guestUserOrders,
        uid: "".concat(cartToken, "/email/").concat(email)
    });
};
var getUserOrderByToken = function(token) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.userOrders */ .KU.userOrders,
        headers: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE)),
        uid: token
    });
};
var putUser = function(data) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.put */ .YZ.put,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.userInfo */ .KU.userInfo,
        headers: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE)),
        data: data
    });
};
var putUserPassword = function(data) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.put */ .YZ.put,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.userInfo */ .KU.userInfo,
        uid: '/change-password',
        headers: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE)),
        data: data
    });
};
var forgetPassword = function(email) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.put */ .YZ.put,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.forgetPassword */ .KU.forgetPassword,
        data: {
            email: email
        }
    });
};
var putResetPassword = function(data, token) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.put */ .YZ.put,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.resetPassword */ .KU.resetPassword,
        uid: token,
        data: {
            password: data
        }
    });
};
var putUserOrder = function(tokenValue) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.put */ .YZ.put,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.userOrders */ .KU.userOrders,
        uid: "".concat(tokenValue, "/cancel"),
        headers: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE))
    });
};
var getUserCards = function() {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.cards */ .KU.cards,
        headers: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE))
    });
};
var postUserCards = function(data) {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.post */ .YZ.post,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.cards */ .KU.cards,
        data: data,
        headers: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE))
    });
};
var getUserBalance = function() {
    return (0,_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
        method: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .EMethods.get */ .YZ.get,
        url: _helpers_requests__WEBPACK_IMPORTED_MODULE_2__/* .ERequestUrl.balance */ .KU.balance,
        headers: (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .apiHeaders */ .pW)(localStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOCAL_STORAGE_KEYS.CONNEXION_TYPE */ .dA.CONNEXION_TYPE))
    });
};


/***/ }),

/***/ 24827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1795);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16502);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var bodyFont = 'GT Pressura, sans-serif';
var headingFont = 'GT Pressura Mono, sans-serif';
var white = '#fff';
var black = '#13100D';
var primaryMain = black;
var red = '#E40421';
var grey = '#606060';
var greyLight = '#F3F3F3';
var blue = '#0C85D1';
var green = '#91AC5E';
//const yellow = '#EFCF4B'
//const orange = '#D4833A'
var imp = '!important';
var f14 = "14px";
var f15 = "15px";
var f16 = "16px";
var f18 = "18px";
var f22 = "22px";
var f24 = "24px";
var f35 = "35px";
var f55 = "55px";
var body = {
    fontSize: f14,
    fontWeight: 400,
    lineHeight: 1.5,
    '@media (min-width: 1024px)': {
        fontSize: f16
    }
};
var customSelect = {
    fontSize: "14px ".concat(imp),
    borderRadius: "6px ".concat(imp),
    border: "1px solid ".concat(greyLight, " ").concat(imp),
    padding: "7px 10px ".concat(imp),
    background: "".concat(greyLight, " ").concat(imp),
    '&:focus': {
        outline: "none ".concat(imp)
    }
};
var theme = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    themeFont: {
        main: bodyFont
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 480,
            md: 768,
            lg: 1024,
            xl: 1440
        }
    },
    typography: {
        fontFamily: "".concat(bodyFont, ", sans-serif"),
        h1: _objectSpread({}, (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .heading */ .nP)(f35, f55, 700, 700, headingFont, headingFont, false), {
            textAlign: "center"
        }),
        h2: _objectSpread({}, (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .heading */ .nP)(f35, f24, 600, 700, headingFont, headingFont, false)),
        h3: _objectSpread({}, (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .heading */ .nP)(f24, f24, 600, 600, headingFont, headingFont, false)),
        h4: _objectSpread({}, (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .heading */ .nP)(f22, f22, 700, 700, headingFont, headingFont, false)),
        h5: _objectSpread({}, (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .heading */ .nP)(f14, f14, 600, 600, headingFont, headingFont, false)),
        h6: _objectSpread({}, (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__/* .heading */ .nP)(f18, f18, 400, 400, headingFont, headingFont, false)),
        body1: _objectSpread({}, body),
        body2: _objectSpread({}, body),
        caption: {
            fontSize: f15
        },
        button: {
            fontSize: f14,
            lineHeight: 1,
            fontWeight: 600,
            fontFamily: bodyFont,
            '@media (min-width: 1024px)': {
                fontSize: f16
            }
        }
    },
    palette: {
        common: {
            black: black,
            white: white
        },
        background: {
            default: white,
            paper: white
        },
        primary: {
            main: primaryMain
        },
        secondary: {
            main: primaryMain
        },
        success: {
            main: green
        },
        error: {
            main: red
        },
        warning: {
            main: '#FF8333'
        },
        divider: '#f0f0f0',
        primaryTransparent: {
            main: primaryMain,
            light: greyLight
        },
        secondaryTransparent: {
            main: primaryMain,
            light: greyLight
        },
        ternary: {
            main: blue,
            light: '#F1FAFF'
        },
        accent: {
            main: primaryMain
        }
    },
    sizes: {
        headerHeight: 60,
        headerHeightTransparent: 90,
        logoWidth: 110,
        logoHeight: 30,
        footerBG: 168,
        basketWidth: 340,
        basketWidthLG: 440
    },
    extraColors: {
        grey: grey,
        greyLight: greyLight,
        greyMedium: '#C0BCC6',
        greyText: grey
    },
    shadows: [
        'none',
        'none',
        'none',
        'none',
        'none',
        'none',
        '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
        '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
        '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
        '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
        '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
        '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
        '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
        '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
        '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
        '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
        '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
        '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
        '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
        '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
        '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
        '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
        '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
        '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
        '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)', 
    ],
    spacing: 8,
    shape: {
        borderRadius: 0
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '.banner': {
                    '&>.MuiTypography-h5': {
                        fontFamily: "".concat(bodyFont, " ").concat(imp)
                    }
                },
                '.header': {
                    '&>.MuiContainer-root': {
                        paddingRight: '0',
                        '@media (min-width: 1440px)': {
                            maxWidth: '100%'
                        }
                    },
                    '&__logo': {
                        height: "50px ".concat(imp)
                    },
                    '&__layout': {
                        height: "80px ".concat(imp)
                    },
                    '&__icons': {
                        '& .MuiButtonBase-root': {
                            fontSize: "".concat(f16, " ").concat(imp)
                        },
                        '& .MuiSvgIcon-root': {
                            fill: black
                        }
                    },
                    '& .menu': {
                        '&--primary': {
                            '& .menu__list--primary': {
                                '& .menu__item': {
                                    '&:after': {
                                        content: 'none'
                                    }
                                }
                            }
                        },
                        '&__list': {
                            gap: "16px ".concat(imp)
                        }
                    },
                    '& .basket': {
                        backgroundColor: "".concat(blue, " ").concat(imp),
                        marginLeft: '2rem',
                        height: '100%',
                        width: '5rem',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    },
                    '&__cta--instore--choice': {
                        color: "".concat(black, " ").concat(imp)
                    }
                },
                '.cart-badge': {
                    borderRadius: "10px ".concat(imp)
                },
                '.shop__planner': {
                    '@media (max-width: 480px)': {
                        marginTop: "-100px ".concat(imp)
                    }
                },
                '.shipping-infos': {
                    '@media (max-width: 768px)': {
                        paddingTop: "10px ".concat(imp)
                    }
                },
                '.select': _objectSpread({}, customSelect),
                '.faq__icon--svg, .account__icon--svg': {
                    display: "inherit ".concat(imp),
                    color: "".concat(black, " ").concat(imp),
                    '&>span': {
                        '&>svg': {
                            fontSize: "21px ".concat(imp)
                        }
                    }
                },
                '.hero__home': {
                    minHeight: "inherit ".concat(imp),
                    height: "60vh ".concat(imp),
                    '& .daterange': {
                        border: '0!important'
                    },
                    '& .title': {
                        fontSize: "36px ".concat(imp),
                        textAlign: "left ".concat(imp)
                    },
                    '& .tagline': {
                        textAlign: "left ".concat(imp),
                        fontFamily: "".concat(bodyFont, " ").concat(imp)
                    }
                },
                '.daterange': {
                    border: "1px solid ".concat(black, " !important")
                },
                '.hero__title': {
                    fontSize: "55px ".concat(imp),
                    '@media (max-width: 480px)': {
                        marginTop: "32px ".concat(imp)
                    },
                    '@media (max-width: 768px)': {
                        fontSize: "35px ".concat(imp)
                    }
                },
                '.discover': {
                    '&__card, &__shadow': {
                        display: 'flex',
                        flexDirection: 'column-reverse'
                    },
                    '&__title': {
                        position: "absolute ".concat(imp),
                        zIndex: "2 ".concat(imp),
                        marginLeft: "3px ".concat(imp),
                        textAlign: "left ".concat(imp),
                        color: "".concat(white, " ").concat(imp),
                        padding: "8px 0 ".concat(imp),
                        fontSize: "23px ".concat(imp),
                        backgroundColor: "transparent ".concat(imp)
                    }
                },
                '.section-discover': {
                    '& .MuiContainer-root': {
                        maxWidth: "inherit ".concat(imp)
                    },
                    '&__subtitle': {
                        fontSize: "40px ".concat(imp)
                    }
                },
                '.discover-product': {
                    '&__content': {
                        position: "absolute ".concat(imp),
                        zIndex: "2 ".concat(imp),
                        marginLeft: "8px ".concat(imp),
                        textAlign: "left ".concat(imp),
                        color: "".concat(white, " ").concat(imp),
                        padding: "8px 0 ".concat(imp),
                        backgroundColor: "transparent ".concat(imp)
                    },
                    '&__title': {
                        color: "".concat(white, " ").concat(imp),
                        fontSize: "23px ".concat(imp),
                        '@media (max-width: 768px)': {
                            fontSize: "20px ".concat(imp)
                        }
                    }
                },
                '.section-hiw ': {
                    backgroundColor: "".concat(greyLight, " ").concat(imp),
                    '@media (max-width: 768px)': {
                        maxWidth: "80% ".concat(imp),
                        margin: "auto ".concat(imp)
                    },
                    '& .MuiContainer-root': {
                        paddingLeft: "0 ".concat(imp),
                        paddingRight: "0 ".concat(imp),
                        maxWidth: "1360px ".concat(imp)
                    },
                    '& .MuiGrid-grid-md-4': {
                        '@media (min-width: 768px)': {
                            flexBasis: "".concat(100 / 4, "% ").concat(imp),
                            maxWidth: "".concat(100 / 4, "% ").concat(imp)
                        }
                    },
                    '&__title': {}
                },
                '.section-hiw__title': {
                    '&.MuiTypography-h2': {
                        '@media (min-width: 1024px)': {
                            fontSize: "55px ".concat(imp)
                        }
                    }
                },
                '.hiw': {
                    '&__icon': {
                        '&>img': {
                            width: "85px ".concat(imp)
                        }
                    },
                    '&__title': {
                        fontSize: "32px ".concat(imp)
                    },
                    '&__desc': {
                        fontSize: "16px ".concat(imp),
                        '@media (max-width: 768px)': {
                            fontSize: "14px ".concat(imp)
                        }
                    }
                },
                '.productCard': {
                    '&__title': {
                        fontFamily: "".concat(bodyFont, " ").concat(imp),
                        paddingLeft: "18px ".concat(imp),
                        paddingRight: "28px ".concat(imp)
                    },
                    '&__cta': {
                        color: "".concat(white, " !important")
                    },
                    backgroundColor: "#F4F4F4 ".concat(imp)
                },
                '.packCard-title': {
                    '&__availability__pack-expedition-mixte': {
                        display: "none ".concat(imp)
                    },
                    '&__price__pack-expedition-mixte': {
                        display: "none ".concat(imp)
                    }
                },
                '.pack-product': {
                    backgroundColor: "#F4F4F4 ".concat(imp)
                },
                '.section-discover__footer': {
                    marginTop: "40px ".concat(imp),
                    marginBottom: "40px ".concat(imp)
                },
                '.faq': {
                    '&__item': {
                        marginBottom: '0!important',
                        '&:last-child': {
                            marginBottom: '32px !important',
                            '@media (min-width: 1024px)': {
                                marginBottom: '64px !important'
                            }
                        }
                    },
                    '&__question': {
                        fontSize: '16px !important',
                        borderBottomColor: "".concat(grey, " !important"),
                        marginBottom: '0!important',
                        '&[aria-expanded=true]': {}
                    },
                    '&__btn': {
                        border: '0!important'
                    },
                    '&__answer': {},
                    '&-content': {
                        maxWidth: '1024px !important',
                        '@media (min-width: 1024px)': {
                            paddingBottom: '50px !important'
                        }
                    },
                    '&-page': {
                        background: '#F4F4F4 !important',
                        '&__cat': {
                            textTransform: 'none!important',
                            '@media (min-width: 1024px)': {
                                margin: '50px 0 !important'
                            }
                        }
                    }
                },
                '.product': {
                    '&__head': {
                        flexDirection: "column ".concat(imp),
                        alignItems: "flex-start ".concat(imp)
                    },
                    '&__title': {
                        fontSize: "30px ".concat(imp)
                    },
                    '&__price': {
                        fontSize: "25px ".concat(imp)
                    }
                },
                '.pack': {
                    '&__head': {
                        flexDirection: "column ".concat(imp),
                        alignItems: "flex-start ".concat(imp)
                    },
                    '&__title': {
                        fontSize: "30px ".concat(imp)
                    },
                    '&__price': {
                        fontSize: "25px ".concat(imp),
                        '&__pack-expedition-mixte': {
                            display: 'none'
                        }
                    },
                    '&__unavailable__pack-expedition-mixte': {
                        display: 'none'
                    }
                },
                '.commonInformations__pack-expedition-mixte': {
                    display: "none ".concat(imp)
                },
                '.quantitySelector': {
                    '&__btn': {
                        '&--minus': {
                            '& .MuiButton-label': {
                                color: "".concat(primaryMain, " ").concat(imp)
                            }
                        }
                    }
                },
                '.react-datepicker-wrapper': {
                    '& .MuiButton-label': {
                        color: "".concat(primaryMain, " ").concat(imp)
                    }
                },
                '.product__bottom-item': {
                    fontSize: "inherit ".concat(imp)
                },
                '.page__container': {
                    '&> h1': {}
                },
                '.warning-adress_cta': {
                    color: "".concat(black, " ").concat(imp)
                },
                '.footer__bottomRow2': {
                    marginTop: "-20px ".concat(imp)
                },
                '.reset__button': {
                    color: "".concat(black, " ").concat(imp)
                }
            }
        },
        MuiButton: {
            root: {
                padding: '15px 45px',
                borderRadius: 0,
                fontWeight: 400,
                textTransform: 'none'
            },
            label: {
            },
            sizeSmall: {
                padding: '4px 16px',
                lineHeight: 1.6,
                fontSize: f16
            },
            sizeLarge: {
                padding: '12px 45px',
                fontSize: f16
            },
            contained: {
                boxShadow: 'none',
                '&:hover, &:focus, &:active, &.selected': {
                    boxShadow: 'none'
                }
            },
            outlined: {
                padding: '12px 45px'
            },
            outlinedSizeLarge: {
                padding: '12px 45px'
            },
            outlinedSizeSmall: {
                padding: '4px 16px',
                lineHeight: 1.6
            }
        },
        MuiPaper: {
            root: {
                boxShadow: '0px 0px 15px rgba(46, 46, 46, 0.1)'
            },
            rounded: {
                borderRadius: 0
            }
        },
        MuiSelect: {
            root: {
                color: black
            },
            selectMenu: {
                '&:focus': {
                    background: '#fff'
                }
            }
        },
        MuiChip: {
            root: {
                borderRadius: 0,
                fontSize: 15,
                fontWeight: 700,
                color: '#000',
                backgroundColor: 'transparent',
                height: 25,
                padding: 0
            },
            label: {
                padding: 0
            },
            sizeSmall: {
                height: 22,
                fontSize: f15,
                fontWeight: 400
            },
            labelSmall: {
                paddingLeft: f15,
                paddingRight: 10
            },
            colorPrimary: {
                color: primaryMain,
                backgroundColor: 'transparent'
            },
            colorSecondary: {
                color: primaryMain,
                backgroundColor: 'transparent'
            }
        }
    }
});
/* harmony default export */ __webpack_exports__["default"] = (theme);


/***/ }),

/***/ 88039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gB": function() { return /* binding */ GAEvent; },
/* harmony export */   "tz": function() { return /* binding */ GTMEvent; },
/* harmony export */   "pJ": function() { return /* binding */ SecondHandCondition; }
/* harmony export */ });
var GAEvent;
(function(GAEvent) {
    GAEvent["ADD_TO_CART"] = 'add_to_cart';
    GAEvent["REMOVE_FROM_CART"] = 'remove_from_cart';
    GAEvent["BEGIN_CHECKOUT"] = 'begin_checkout';
    GAEvent["PURCHASE"] = 'purchase';
    GAEvent["PAGE_VIEW"] = 'page_view';
    GAEvent["VIEW_ITEM"] = 'view_item';
})(GAEvent || (GAEvent = {}));
var GTMEvent;
(function(GTMEvent) {
    GTMEvent["ADD_PAYMENT_INFO"] = 'add_payment_info';
    GTMEvent["PURCHASE"] = 'purchase';
    GTMEvent["ADD_TO_CART"] = 'add_to_cart';
    GTMEvent["REMOVE_FROM_CART"] = 'remove_from_cart';
    GTMEvent["BEGIN_CHECKOUT"] = 'begin_checkout';
    GTMEvent["PAGE_VIEW"] = 'page_view';
    GTMEvent["VIEW_ITEM"] = 'view_item';
})(GTMEvent || (GTMEvent = {}));
var SecondHandCondition;
(function(SecondHandCondition) {
    SecondHandCondition["PERFECT_CONDITION"] = 'perfectCondition';
    SecondHandCondition["VERY_GOOD_CONDITION"] = 'veryGoodCondition';
    SecondHandCondition["GOOD_CONDITION"] = 'goodCondition';
})(SecondHandCondition || (SecondHandCondition = {}));


/***/ }),

/***/ 66026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ store; },
/* harmony export */   "ZG": function() { return /* binding */ disableRegister; },
/* harmony export */   "Mk": function() { return /* binding */ isB2BRegistrationEnabled; },
/* harmony export */   "eM": function() { return /* binding */ DEBUG; },
/* harmony export */   "Tr": function() { return /* binding */ isDateToDate; },
/* harmony export */   "Lz": function() { return /* binding */ isFlex; },
/* harmony export */   "q5": function() { return /* binding */ isClassicSub; },
/* harmony export */   "Nn": function() { return /* binding */ isSubscription; },
/* harmony export */   "tP": function() { return /* binding */ isB2B; },
/* harmony export */   "QG": function() { return /* binding */ isDisplayBasketProductAvailableQuantity; },
/* harmony export */   "ZO": function() { return /* binding */ enableCustomerAccountId; },
/* harmony export */   "zf": function() { return /* binding */ SAVED_START_DATE; },
/* harmony export */   "mG": function() { return /* binding */ SAVED_END_DATE; },
/* harmony export */   "L0": function() { return /* binding */ enableHalfDay; },
/* harmony export */   "Iu": function() { return /* binding */ DATADOG_KEY; },
/* harmony export */   "HB": function() { return /* binding */ PRICE_WITHOUT_DISCOUNT; },
/* harmony export */   "Qn": function() { return /* binding */ DISCOUNTED_PRICE_ONLY; },
/* harmony export */   "B8": function() { return /* binding */ DISCOUNTED_PRICE_WITH_DETAILS; },
/* harmony export */   "H2": function() { return /* binding */ isLoginSSO; },
/* harmony export */   "yf": function() { return /* binding */ isSSO; },
/* harmony export */   "y": function() { return /* binding */ isThermorSSO; },
/* harmony export */   "oy": function() { return /* binding */ RMSDateFormat; },
/* harmony export */   "cl": function() { return /* binding */ SyliusDateFormat; },
/* harmony export */   "wU": function() { return /* binding */ byPassPayment; },
/* harmony export */   "X9": function() { return /* binding */ byPassPassword; },
/* harmony export */   "_$": function() { return /* binding */ ORDER_ITEM_TYPE; },
/* harmony export */   "sP": function() { return /* binding */ BY_PASS_TYPE; },
/* harmony export */   "KZ": function() { return /* binding */ currentVersion; },
/* harmony export */   "G7": function() { return /* binding */ isSecondHandOnly; },
/* harmony export */   "eZ": function() { return /* binding */ ORDER_STATE; },
/* harmony export */   "OV": function() { return /* binding */ PAYMENT_ACCORDION; },
/* harmony export */   "dA": function() { return /* binding */ LOCAL_STORAGE_KEYS; },
/* harmony export */   "$X": function() { return /* binding */ SECOND_HAND_TAXON_SLUGS; },
/* harmony export */   "Q0": function() { return /* binding */ NEW_BUT_REPAIRED_TAXON_SLUG; },
/* harmony export */   "T1": function() { return /* binding */ GuideDesTaillesPageTitle; },
/* harmony export */   "Hv": function() { return /* binding */ swiklyDepositPercentage; },
/* harmony export */   "QB": function() { return /* binding */ show2ndHandWarehouseImagesFirst; },
/* harmony export */   "t7": function() { return /* binding */ simplifiedTakeBack; },
/* harmony export */   "jf": function() { return /* binding */ takeBackSelectedProduct; },
/* harmony export */   "yD": function() { return /* binding */ enableSearchFilterValuesFor; },
/* harmony export */   "r4": function() { return /* binding */ displayTtcAndHtPrice; },
/* harmony export */   "lL": function() { return /* binding */ customWarehouse; },
/* harmony export */   "wK": function() { return /* binding */ disableSecondHandSizeAndCondition; },
/* harmony export */   "FB": function() { return /* binding */ hidePricingOnGhostUser; },
/* harmony export */   "Qv": function() { return /* binding */ hideSecondHandSizes; },
/* harmony export */   "o5": function() { return /* binding */ professionalAccountOnly; },
/* harmony export */   "Ko": function() { return /* binding */ upcomingLocales; },
/* harmony export */   "Uo": function() { return /* binding */ hideBasketDeposit; },
/* harmony export */   "Wf": function() { return /* binding */ minimumCartItemsNotReached; },
/* harmony export */   "Hw": function() { return /* binding */ disableQualityFilter; },
/* harmony export */   "D$": function() { return /* binding */ FLAT_TOP_FILTER_ATTRIBUTE_CODES; },
/* harmony export */   "f8": function() { return /* binding */ isWireTransferEnabled; },
/* harmony export */   "o6": function() { return /* binding */ enableProductCardReservation; },
/* harmony export */   "yY": function() { return /* binding */ canChangeAccountInformation; },
/* harmony export */   "Gq": function() { return /* binding */ flipedAddressFields; },
/* harmony export */   "rr": function() { return /* binding */ ssoLogoutRedirectUrl; },
/* harmony export */   "P$": function() { return /* binding */ ssoErrorRedirectUrl; },
/* harmony export */   "N6": function() { return /* binding */ shopProductFullImage; },
/* harmony export */   "ae": function() { return /* binding */ imageFixInProductDetail; },
/* harmony export */   "l3": function() { return /* binding */ isOrderReferenceStepEnabled; },
/* harmony export */   "Aq": function() { return /* binding */ isShippingCompanyEnabled; }
/* harmony export */ });
/* unused harmony exports minSubDuration, secondHandCarrierId, SWIKLY_API_BASE_URL */
/* provided dependency */ var process = __webpack_require__(34155);
var ref, ref1;
var store = "millet";
var disableRegister = process.env.DISABLE_REGISTER;
var isB2BRegistrationEnabled = process.env.B2B_REGISTRATION_ENABLED === 'true';
var DEBUG = '/confirmation?debug=true';
var isDateToDate = "date_to_date" === 'date_to_date';
var isFlex = "date_to_date" === 'subscription';
var isClassicSub = "date_to_date" === 'classic_subscription';
var isSubscription = isFlex || isClassicSub;
var isB2B = process.env.B2B_ENABLED === 'true';
var isDisplayBasketProductAvailableQuantity = process.env.DISPLAY_BASKET_PRODUCT_AVAILABLE_QUANTITY === 'true';
var enableCustomerAccountId = process.env.ENABLE_CUSTOMER_ACCOUNT_ID === 'true';
var SAVED_START_DATE = 'savedStartDate';
var SAVED_END_DATE = 'savedEndDate';
var enableHalfDay = process.env.ENABLE_HALF_DAY === 'true';
var DATADOG_KEY = 'pube26c9972b5d28d5ea349653bf9915589';
var PRICE_WITHOUT_DISCOUNT = 'price without discount';
var DISCOUNTED_PRICE_ONLY = 'discounted price only';
var DISCOUNTED_PRICE_WITH_DETAILS = 'discounted price with details';
var minSubDuration = process.env.BRAND_MIN_SUB_DAYS;
var isLoginSSO = process.env.SSO_LOGIN;
var isSSO = process.env.SSO_TYPE !== undefined;
/** Facturation gérée par le compte SSO Thermor : ne pas l’écraser via les PUT checkout. */ var isThermorSSO = process.env.SSO_TYPE === 'thermor';
var RMSDateFormat = 'YYYY-MM-DD';
var SyliusDateFormat = 'DD/MM/YYYY';
var byPassPayment =  true ? true : 0;
var byPassPassword = "millettest";
var ORDER_ITEM_TYPE = {
    RENTAL: 'RENTAL',
    PURCHASE: 'PURCHASE',
    TRYING: 'TRYING',
    SECOND_HAND: 'SECOND_HAND',
    MIXED: 'MIXED'
};
var BY_PASS_TYPE = {
    CUSTOMER: 'CUSTOMER',
    OPERATOR: 'OPERATOR'
};
var currentVersion = "1.0.2";
var secondHandCarrierId = process.env.CARRIER_ID;
var isSecondHandOnly = process.env.IS_SECOND_HAND_ONLY;
var ORDER_STATE;
(function(ORDER_STATE) {
    ORDER_STATE["CANCELLED"] = 'cancelled';
    ORDER_STATE["COMING"] = 'coming';
    ORDER_STATE["RETURN"] = 'return';
    ORDER_STATE["FINISHED"] = 'finished';
})(ORDER_STATE || (ORDER_STATE = {}));
var PAYMENT_ACCORDION;
(function(PAYMENT_ACCORDION) {
    PAYMENT_ACCORDION["CARD"] = 'card';
    PAYMENT_ACCORDION["PAYPAL"] = 'paypal';
})(PAYMENT_ACCORDION || (PAYMENT_ACCORDION = {}));
var LOCAL_STORAGE_KEYS = {
    CONNEXION_TYPE: 'connexion-type',
    TOKEN: 'TOKEN',
    REFRESH_TOKEN: 'REFRESH_TOKEN',
    TOKEN_EXPIRE_AT: 'TOKEN_EXPIRE_AT',
    LOGIN_METHOD: 'LOGIN_METHOD',
    SSO_STATE: 'SSO_STATE',
    USER_TYPE: 'user-type'
};
var SECOND_HAND_TAXON_SLUGS = [
    'second-hand',
    'seconde-main',
    'zwiter-hand',
    'b-ware',
    'Sale', 
];
var NEW_BUT_REPAIRED_TAXON_SLUG = 'b-ware';
var GuideDesTaillesPageTitle = 'guide des tailles';
var swiklyDepositPercentage = process.env.SWIKLY_DEPOSIT_PERCENTAGE;
var SWIKLY_API_BASE_URL = process.env.SWIKLY_API_URL || ( false ? 0 : 'https://api.sandbox.swikly.com/v1');
var show2ndHandWarehouseImagesFirst = process.env.SHOW_2ND_HAND_WAREHOUSE_IMAGES_FIRST === 'true';
var simplifiedTakeBack = process.env.SIMPLIFIED_TAKE_BACK === 'true';
var takeBackSelectedProduct = process.env.TAKE_BACK_SELECTED_PRODUCT;
var enableSearchFilterValuesFor = ((ref = process.env.ENABLE_SEARCH_FILTER_VALUES_FOR) === null || ref === void 0 ? void 0 : ref.split(',').map(function(item) {
    return item.toUpperCase();
})) || [];
var displayTtcAndHtPrice = process.env.DISPLAY_TTC_PRICE === 'true';
var _CUSTOM_WAREHOUSE;
var customWarehouse = (_CUSTOM_WAREHOUSE = process.env.CUSTOM_WAREHOUSE) !== null && _CUSTOM_WAREHOUSE !== void 0 ? _CUSTOM_WAREHOUSE : null;
var disableSecondHandSizeAndCondition = process.env.DISABLE_SECOND_HAND_SIZE_AND_CONDITION === 'true';
var hidePricingOnGhostUser = process.env.HIDE_PRICING_ON_GHOST_USER === 'true';
var hideSecondHandSizes = process.env.HIDE_SECOND_HAND_SIZES === 'true';
var professionalAccountOnly = process.env.PROFESSIONAL_ACCOUNT_ONLY === 'true';
var upcomingLocales = ((ref1 = process.env.UPCOMING_LOCALES) === null || ref1 === void 0 ? void 0 : ref1.split(',')) || [];
var hideBasketDeposit = process.env.HIDE_BASKET_DEPOSIT === 'true';
var minimumCartItemsNotReached = 'MINIMUM_CART_ITEMS_NOT_REACHED';
var disableQualityFilter = process.env.DISABLE_QUALITY_FILTER === 'true';
/**
 * Vaude only : codes de l'attribut SELECT (« Auswahl ») à sortir du dropdown de
 * filtres pour l'afficher en checkboxes à plat, sous les catégories et au-dessus
 * du premier filtre. Voir components/Filters/FilterDrawer.tsx.
 */ var FLAT_TOP_FILTER_ATTRIBUTE_CODES =  false ? 0 : [];
var isWireTransferEnabled = process.env.IS_WIRE_TRANSFER_ENABLED === 'true';
var enableProductCardReservation = process.env.ENABLE_PRODUCT_CARD_RESERVATION === 'true';
var canChangeAccountInformation = process.env.CAN_CHANGE_ACCOUNT_INFORMATION !== 'false';
var flipedAddressFields = process.env.FLIPPED_ADDRESS_FIELDS === 'true';
var ssoLogoutRedirectUrl = process.env.SSO_LOGOUT_REDIRECT_URL;
var ssoErrorRedirectUrl = process.env.SSO_ERROR_REDIRECT_URL;
var shopProductFullImage = process.env.SHOP_PRODUCT_FULL_IMAGE === 'true';
var imageFixInProductDetail = process.env.IMAGE_FIX_IN_PRODUCT_DETAIL === 'true';
/** Étape de checkout "Référence personnalisée" (B2B, ex. Groupe Atlantic) intercalée entre Livraison et Paiement. */ var isOrderReferenceStepEnabled = process.env.ENABLE_ORDER_REFERENCE_STEP === 'true';
/** Champ "Raison sociale" (company) sur le formulaire d'adresse de livraison (B2B, ex. Groupe Atlantic). */ var isShippingCompanyEnabled = process.env.ENABLE_SHIPPING_COMPANY === 'true';


/***/ }),

/***/ 65809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LP": function() { return /* binding */ isChalhoub; },
/* harmony export */   "o9": function() { return /* binding */ clearItemVariantFromGAParamsIfNotChalhoub; },
/* harmony export */   "ap": function() { return /* binding */ tracker; },
/* harmony export */   "RL": function() { return /* binding */ handleGACartEventWithSingleProduct; },
/* harmony export */   "oA": function() { return /* binding */ hangleGACartEventWithMultipleProducts; },
/* harmony export */   "Kx": function() { return /* binding */ safeDataLayerPush; },
/* harmony export */   "$6": function() { return /* binding */ handleGTMAddToCart; },
/* harmony export */   "yo": function() { return /* binding */ getPaymentInfoGtmData; },
/* harmony export */   "hO": function() { return /* binding */ getViewItemGtmData; },
/* harmony export */   "MI": function() { return /* binding */ getCheckoutGtmData; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _typings_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88039);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66026);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16502);
/* harmony import */ var process__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34155);
/* harmony import */ var process__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(process__WEBPACK_IMPORTED_MODULE_4__);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var isChalhoub = "millet" === 'chalhoub';
var clearItemVariantFromGAParamsIfNotChalhoub = function(gaParams) {
    var paramsCopy = _objectSpread({}, gaParams);
    if (!isChalhoub) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = paramsCopy.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                delete item['item_variant'];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return paramsCopy;
};
var tracker = function(eventName, params) {
    if (process__WEBPACK_IMPORTED_MODULE_4__.env.NEXT_PUBLIC_GA_ID && "object" !== 'undefined' && !!window.gtag) {
        window.gtag('event', eventName, params);
        return true;
    }
    return false;
};
function handleGACartEventWithSingleProduct(cartItem, productInCart, gaEvent, puid) {
    var quantity = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1;
    var currency = cartItem.currency;
    var product = productInCart.product, units = productInCart.units, withTryingOn = productInCart.withTryingOn;
    var price = 0;
    if (_constants__WEBPACK_IMPORTED_MODULE_2__/* .isSecondHandOnly */ .G7) {
        price = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(units.find(function(unit) {
            return unit.puid === puid;
        }).price);
    } else if (_constants__WEBPACK_IMPORTED_MODULE_2__/* .isDateToDate */ .Tr) {
        if (withTryingOn) {
            price = product.variants[0].tryingOnPrice;
        } else {
            var startLeasingDate = cartItem.startLeasingDate, endLeasingDate = cartItem.endLeasingDate;
            var numberOfDays = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(endLeasingDate, 'DD/MM/YYYY').diff(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(startLeasingDate, 'DD/MM/YYYY'), 'day') + 1;
            var priceByDay = product.variants[0].price.current;
            price = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(priceByDay * numberOfDays);
        }
    }
    var firstVariant = Object.values(product.variants)[0];
    var _obj;
    var gaParams = {
        currency: currency,
        value: price * quantity,
        items: [
            (_obj = {}, _defineProperty(_obj, 'item_name', product.name), _defineProperty(_obj, 'item_id', isChalhoub ? firstVariant.sku : product.code), _defineProperty(_obj, 'item_variant', isChalhoub && firstVariant.code), _defineProperty(_obj, "price", price), _defineProperty(_obj, "quantity", quantity), _obj), 
        ]
    };
    var cleanGAParams = clearItemVariantFromGAParamsIfNotChalhoub(gaParams);
    tracker(gaEvent, cleanGAParams);
}
function hangleGACartEventWithMultipleProducts(gaEvent, cartItem) {
    var totals = cartItem.totals, currency = cartItem.currency, items = cartItem.items;
    var totalPrice = _constants__WEBPACK_IMPORTED_MODULE_2__/* .isSubscription */ .Nn ? (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(totals.totalWithCart) : (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(totals.total);
    var gaParams = {
        currency: currency,
        value: totalPrice,
        items: items.map(function(param) {
            var product = param.product, quantity = param.quantity, total = param.total;
            var firstVariant = Object.values(product.variants)[0];
            var _obj;
            return _obj = {}, _defineProperty(_obj, 'item_name', product.name), _defineProperty(_obj, 'item_id', isChalhoub ? firstVariant.sku : product.code), _defineProperty(_obj, 'item_variant', isChalhoub && firstVariant.code), _defineProperty(_obj, "price", (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(total)), _defineProperty(_obj, "quantity", quantity), _obj;
        })
    };
    var cleanGAParams = clearItemVariantFromGAParamsIfNotChalhoub(gaParams);
    tracker(gaEvent, cleanGAParams);
}
var safeDataLayerPush = function(data) {
    try {
        if (!(window === null || window === void 0 ? void 0 : window.dataLayer)) {
            window.dataLayer = [];
        }
        window.dataLayer.push(data);
        if (false) {}
    } catch (error) {
        console.error('DataLayer push failed:', error);
    }
};
var handleGTMAddToCart = function(cartItem, productInCart, event, quantity) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var product = productInCart.product;
    var currency = cartItem.currency;
    var firstVariant = Object.values(product.variants)[0];
    safeDataLayerPush({
        event: event,
        ecommerce: {
            value: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(productInCart === null || productInCart === void 0 ? void 0 : productInCart.total) * (productInCart === null || productInCart === void 0 ? void 0 : productInCart.quantity),
            items: [
                {
                    affiliation: productInCart === null || productInCart === void 0 ? void 0 : (ref = productInCart.product) === null || ref === void 0 ? void 0 : ref.channelCode,
                    coupon: cartItem === null || cartItem === void 0 ? void 0 : cartItem.couponCode,
                    discount: (productInCart === null || productInCart === void 0 ? void 0 : productInCart.total) && (productInCart === null || productInCart === void 0 ? void 0 : productInCart.totalWithoutPromotion) ? (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)((productInCart === null || productInCart === void 0 ? void 0 : productInCart.totalWithoutPromotion) - (productInCart === null || productInCart === void 0 ? void 0 : productInCart.total)) : 0,
                    price: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.price.current),
                    currency: currency,
                    quantity: quantity || (productInCart === null || productInCart === void 0 ? void 0 : productInCart.quantity),
                    item_id: (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku) || (productInCart === null || productInCart === void 0 ? void 0 : (ref1 = productInCart.product) === null || ref1 === void 0 ? void 0 : ref1.code),
                    item_name: productInCart === null || productInCart === void 0 ? void 0 : (ref2 = productInCart.product) === null || ref2 === void 0 ? void 0 : ref2.name,
                    item_category: productInCart === null || productInCart === void 0 ? void 0 : (ref3 = productInCart.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.taxons) === null || ref4 === void 0 ? void 0 : ref4.main,
                    item_list_id: productInCart === null || productInCart === void 0 ? void 0 : (ref5 = productInCart.product) === null || ref5 === void 0 ? void 0 : ref5.slug,
                    item_list_name: productInCart === null || productInCart === void 0 ? void 0 : (ref6 = productInCart.product) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.taxons) === null || ref7 === void 0 ? void 0 : ref7.main,
                    item_variant: firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.name
                }, 
            ]
        }
    });
};
var getPaymentInfoGtmData = function(cart, coupon, paymentType) {
    var ref19, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    return {
        event: _typings_base__WEBPACK_IMPORTED_MODULE_1__/* .GTMEvent.ADD_PAYMENT_INFO */ .tz.ADD_PAYMENT_INFO,
        ecommerce: {
            transaction_id: cart === null || cart === void 0 ? void 0 : (ref19 = cart.item) === null || ref19 === void 0 ? void 0 : ref19.tokenValue,
            value: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(cart === null || cart === void 0 ? void 0 : (ref8 = cart.item) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.totals) === null || ref9 === void 0 ? void 0 : ref9.total),
            coupon: coupon,
            tax: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(cart === null || cart === void 0 ? void 0 : (ref10 = cart.item) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.totals) === null || ref11 === void 0 ? void 0 : ref11.taxes),
            shipping: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(cart === null || cart === void 0 ? void 0 : (ref12 = cart.item) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.totals) === null || ref13 === void 0 ? void 0 : ref13.shipping),
            discount: -(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(cart === null || cart === void 0 ? void 0 : (ref14 = cart.item) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.totals) === null || ref15 === void 0 ? void 0 : ref15.promotion),
            payment_type: paymentType,
            items: cart.item.items.map(function(param) {
                var product = param.product, quantity = param.quantity, total = param.total, totalWithoutPromotion = param.totalWithoutPromotion;
                var ref, ref16, ref17, ref18;
                var firstVariant = Object.values(product === null || product === void 0 ? void 0 : product.variants)[0];
                return {
                    affiliation: product === null || product === void 0 ? void 0 : product.channelCode,
                    coupon: cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.couponCode,
                    discount: total && totalWithoutPromotion ? (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(totalWithoutPromotion - total) : 0,
                    price: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(total),
                    currency: cart === null || cart === void 0 ? void 0 : (ref16 = cart.item) === null || ref16 === void 0 ? void 0 : ref16.currency,
                    quantity: quantity,
                    item_id: (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku) || (product === null || product === void 0 ? void 0 : product.code),
                    item_name: product === null || product === void 0 ? void 0 : product.name,
                    item_category: product === null || product === void 0 ? void 0 : (ref17 = product.taxons) === null || ref17 === void 0 ? void 0 : ref17.main,
                    item_list_id: product === null || product === void 0 ? void 0 : product.slug,
                    item_list_name: product === null || product === void 0 ? void 0 : (ref18 = product.taxons) === null || ref18 === void 0 ? void 0 : ref18.main,
                    item_variant: firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.name
                };
            })
        }
    };
};
var getViewItemGtmData = function(quantity, product, firstVariant) {
    var ref, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29;
    return {
        event: _typings_base__WEBPACK_IMPORTED_MODULE_1__/* .GTMEvent.VIEW_ITEM */ .tz.VIEW_ITEM,
        ecommerce: {
            value: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)((firstVariant === null || firstVariant === void 0 ? void 0 : (ref = firstVariant.price) === null || ref === void 0 ? void 0 : ref.current) || 0),
            items: [
                {
                    affiliation: product === null || product === void 0 ? void 0 : (ref20 = product.item) === null || ref20 === void 0 ? void 0 : ref20.channelCode,
                    price: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(firstVariant === null || firstVariant === void 0 ? void 0 : (ref21 = firstVariant.price) === null || ref21 === void 0 ? void 0 : ref21.current),
                    currency: firstVariant === null || firstVariant === void 0 ? void 0 : (ref22 = firstVariant.price) === null || ref22 === void 0 ? void 0 : ref22.currency,
                    quantity: quantity,
                    item_id: (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku) || (product === null || product === void 0 ? void 0 : (ref23 = product.item) === null || ref23 === void 0 ? void 0 : ref23.code),
                    item_name: product === null || product === void 0 ? void 0 : (ref24 = product.item) === null || ref24 === void 0 ? void 0 : ref24.name,
                    item_category: product === null || product === void 0 ? void 0 : (ref25 = product.item) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.taxons) === null || ref26 === void 0 ? void 0 : ref26.main,
                    item_list_id: product === null || product === void 0 ? void 0 : (ref27 = product.item) === null || ref27 === void 0 ? void 0 : ref27.slug,
                    item_list_name: product === null || product === void 0 ? void 0 : (ref28 = product.item) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.taxons) === null || ref29 === void 0 ? void 0 : ref29.main,
                    item_variant: firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.name
                }, 
            ]
        }
    };
};
var getCheckoutGtmData = function(cart) {
    var ref39, ref30, ref31, ref32, ref33, ref34, ref35;
    return {
        event: _typings_base__WEBPACK_IMPORTED_MODULE_1__/* .GTMEvent.BEGIN_CHECKOUT */ .tz.BEGIN_CHECKOUT,
        ecommerce: {
            value: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(cart === null || cart === void 0 ? void 0 : (ref39 = cart.item) === null || ref39 === void 0 ? void 0 : (ref30 = ref39.totals) === null || ref30 === void 0 ? void 0 : ref30.items),
            coupon: cart === null || cart === void 0 ? void 0 : (ref31 = cart.item) === null || ref31 === void 0 ? void 0 : ref31.couponCode,
            discount: -(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(cart === null || cart === void 0 ? void 0 : (ref32 = cart.item) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.totals) === null || ref33 === void 0 ? void 0 : ref33.promotion),
            items: cart === null || cart === void 0 ? void 0 : (ref34 = cart.item) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.items) === null || ref35 === void 0 ? void 0 : ref35.map(function(param) {
                var product = param.product, quantity = param.quantity, total = param.total, totalWithoutPromotion = param.totalWithoutPromotion;
                var ref, ref36, ref37, ref38;
                var firstVariant = Object.values(product === null || product === void 0 ? void 0 : product.variants)[0];
                return {
                    affiliation: product === null || product === void 0 ? void 0 : product.channelCode,
                    coupon: cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.couponCode,
                    discount: total && totalWithoutPromotion ? (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(totalWithoutPromotion - total) : 0,
                    price: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .numberToPrice */ .e8)(total),
                    currency: cart === null || cart === void 0 ? void 0 : (ref36 = cart.item) === null || ref36 === void 0 ? void 0 : ref36.currency,
                    quantity: quantity,
                    item_id: (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku) || (product === null || product === void 0 ? void 0 : product.code),
                    item_name: product === null || product === void 0 ? void 0 : product.name,
                    item_category: product === null || product === void 0 ? void 0 : (ref37 = product.taxons) === null || ref37 === void 0 ? void 0 : ref37.main,
                    item_list_id: product === null || product === void 0 ? void 0 : product.slug,
                    item_list_name: product === null || product === void 0 ? void 0 : (ref38 = product.taxons) === null || ref38 === void 0 ? void 0 : ref38.main,
                    item_variant: firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.name
                };
            })
        }
    };
};


/***/ }),

/***/ 16502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HN": function() { return /* binding */ TRANSITION_TIMEOUT; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "cx": function() { return /* binding */ scrollToDiv; },
/* harmony export */   "vQ": function() { return /* binding */ setFullLocale; },
/* harmony export */   "fK": function() { return /* binding */ transformLocale; },
/* harmony export */   "ES": function() { return /* binding */ getSkus; },
/* harmony export */   "HF": function() { return /* binding */ checkProductAvailability; },
/* harmony export */   "LY": function() { return /* binding */ checkStockQuantity; },
/* harmony export */   "qe": function() { return /* binding */ checkStockQuantityByItemType; },
/* harmony export */   "uW": function() { return /* binding */ arrayUnique; },
/* harmony export */   "_Z": function() { return /* binding */ downloadInvoice; },
/* harmony export */   "l_": function() { return /* binding */ downloadURI; },
/* harmony export */   "e8": function() { return /* binding */ numberToPrice; },
/* harmony export */   "YF": function() { return /* binding */ columnGridLayout; },
/* harmony export */   "Zd": function() { return /* binding */ columnLayout; },
/* harmony export */   "nq": function() { return /* binding */ columnSpacing; },
/* harmony export */   "pm": function() { return /* binding */ thumbnailRatio; },
/* harmony export */   "rI": function() { return /* binding */ getProductImageKitSettings; },
/* harmony export */   "HC": function() { return /* binding */ checkTryOutError; },
/* harmony export */   "hQ": function() { return /* binding */ calcPackMinPrice; },
/* harmony export */   "pW": function() { return /* binding */ apiHeaders; },
/* harmony export */   "FL": function() { return /* binding */ calculTotalWithBuyAbleProducts; },
/* harmony export */   "nP": function() { return /* binding */ heading; },
/* harmony export */   "q7": function() { return /* binding */ menuPosition; },
/* harmony export */   "BC": function() { return /* binding */ logoPosition; },
/* harmony export */   "Id": function() { return /* binding */ findCurrentPlan; },
/* harmony export */   "jt": function() { return /* binding */ getProductTaxonPromotion; },
/* harmony export */   "mo": function() { return /* binding */ isPurchasedItem; },
/* harmony export */   "gY": function() { return /* binding */ btnOptions; },
/* harmony export */   "Lx": function() { return /* binding */ findIfSlugExist; },
/* harmony export */   "fg": function() { return /* binding */ translateUrlSlugs; },
/* harmony export */   "OC": function() { return /* binding */ productLowestPrice; },
/* harmony export */   "cy": function() { return /* binding */ secondHandCarrierIdByCountry; }
/* harmony export */ });
/* unused harmony exports parseHTML, validXMLPath */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66026);
/* harmony import */ var _typings_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88039);
/* provided dependency */ var process = __webpack_require__(34155);


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var TRANSITION_TIMEOUT = 250;
function truncateString(string, length, isHtmlDescription) {
    if (!isHtmlDescription) {
        string = parseHTML(string);
    }
    if (string.length <= length) {
        return string;
    }
    return string.slice(0, length) + '...';
}
function parseHTML(HtmlString) {
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = HtmlString;
    tempDiv.remove();
    return tempDiv.innerText || '';
}
var scrollToDiv = function(nodeId) {
    var ref;
    (ref = document.getElementById("".concat(nodeId))) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
        behavior: 'smooth'
    });
};
var setFullLocale = function(locale) {
    var fullLocale = '';
    "fr-fr".split(',').map(function(pLocale) {
        if (locale === pLocale.substring(0, 2)) {
            fullLocale = pLocale;
        }
    });
    return fullLocale;
};
var transformLocale = function(locale) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '_';
    var ref = _slicedToArray(locale.split('-'), 2), language = ref[0], country = ref[1];
    return "".concat(language.toLowerCase()).concat(separator).concat(country.toUpperCase());
};
var getSkus = function(products) {
    var ref3, ref1;
    var SKUArray = [];
    if ((products === null || products === void 0 ? void 0 : (ref3 = products.items) === null || ref3 === void 0 ? void 0 : (ref1 = ref3.items) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
        var ref2;
        (ref2 = products.items.items) === null || ref2 === void 0 ? void 0 : ref2.map(function(product) {
            Object.keys(product.variants).map(function(variantKey) {
                if (product.variants[variantKey].sku !== '') {
                    SKUArray.push(product.variants[variantKey].sku);
                }
            });
        });
    } else if (typeof (products === null || products === void 0 ? void 0 : products.name) !== 'undefined') {
        Object.keys(products.variants).map(function(variantKey) {
            if (products.variants[variantKey].sku !== '') {
                SKUArray.push(products.variants[variantKey].sku);
            }
        });
        if (products === null || products === void 0 ? void 0 : products.associations) {
            Object.keys(products === null || products === void 0 ? void 0 : products.associations).map(function(association) {
                products.associations[association].map(function(pa) {
                    Object.keys(pa.variants).map(function(pav) {
                        SKUArray.push(pa.variants[pav].sku);
                    });
                });
            });
        }
    } else if ((products === null || products === void 0 ? void 0 : products.length) > 0) {
        products === null || products === void 0 ? void 0 : products.map(function(product) {
            var ref;
            if (product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.variants) {
                Object.keys(product.product.variants).forEach(function(variantKey) {
                    if (product.product.variants[variantKey].sku !== '') {
                        SKUArray.push(product.product.variants[variantKey].sku);
                    }
                });
            } else if (product === null || product === void 0 ? void 0 : product.variants) {
                Object.keys(product.variants).forEach(function(variantKey) {
                    if (product.variants[variantKey].sku !== '') {
                        SKUArray.push(product.variants[variantKey].sku);
                    }
                });
            } else {
                product === null || product === void 0 ? void 0 : product.map(function(item) {
                    Object.keys(item.variants).forEach(function(variantKey) {
                        if (item.variants[variantKey].sku !== '') {
                            SKUArray.push(item.variants[variantKey].sku);
                        }
                    });
                });
            }
        });
    }
    return SKUArray;
};
var checkProductAvailability = function(stock, product) {
    var ref5;
    var available = false;
    var secondHandAvailable = false;
    var secondHandImage = [];
    if ((stock === null || stock === void 0 ? void 0 : (ref5 = stock.stock) === null || ref5 === void 0 ? void 0 : ref5.length) > 0) {
        Object.keys(product === null || product === void 0 ? void 0 : product.variants).forEach(function(variant) {
            var ref, ref4;
            var sku = stock.stockMap.get(product.variants[variant].sku);
            sku === null || sku === void 0 ? void 0 : (ref = sku.secondHand) === null || ref === void 0 ? void 0 : ref.forEach(function(condition) {
                if (!condition.quality) {
                    return;
                }
                var validQualities = Object.values(_typings_base__WEBPACK_IMPORTED_MODULE_1__/* .SecondHandCondition */ .pJ);
                if (validQualities.includes(condition.quality)) {
                    var _secondHandImage;
                    (_secondHandImage = secondHandImage).push.apply(_secondHandImage, _toConsumableArray(condition.images));
                }
            });
            if (typeof sku !== 'undefined' && sku.quantity !== 0) {
                available = true;
            }
            var allSecondHandQuantities = sku === null || sku === void 0 ? void 0 : (ref4 = sku.secondHand) === null || ref4 === void 0 ? void 0 : ref4.reduce(function(acc, curr) {
                return acc + curr.quantity + (curr.reservedCount || 0);
            }, 0);
            if (typeof sku !== 'undefined' && sku.secondHand && sku.secondHand.length > 0 && allSecondHandQuantities > 0) {
                secondHandAvailable = true;
            }
        });
    }
    return {
        available: available,
        secondHandAvailable: secondHandAvailable,
        secondHandImage: secondHandImage
    };
};
var checkStockQuantity = function(stock1, variant, stockType) {
    if (stockType === 'basket') {
        var ref;
        if ((stock1 === null || stock1 === void 0 ? void 0 : (ref = stock1.stockBasket) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var exist = stock1.stockBasket.find(function(stock) {
                return stock.lizeeSKU === (variant === null || variant === void 0 ? void 0 : variant.sku);
            });
            if (exist) {
                return exist.quantity;
            } else {
                return 0;
            }
        }
    } else {
        var ref6;
        if ((stock1 === null || stock1 === void 0 ? void 0 : (ref6 = stock1.stock) === null || ref6 === void 0 ? void 0 : ref6.length) > 0) {
            var exist1 = stock1.stock.find(function(stock) {
                return stock.lizeeSKU === (variant === null || variant === void 0 ? void 0 : variant.sku);
            });
            if (exist1) {
                return exist1.quantity;
            } else {
                return 0;
            }
        }
    }
};
var checkStockQuantityByItemType = function(stock2, variant, itemType, stockType) {
    var stockSource = stockType === 'basket' ? stock2.stockBasket : stock2.stock;
    if ((stockSource === null || stockSource === void 0 ? void 0 : stockSource.length) > 0) {
        var exist = stockSource.find(function(stock) {
            return stock.lizeeSKU === (variant === null || variant === void 0 ? void 0 : variant.sku);
        });
        if (exist) {
            if (itemType === 'SECOND_HAND' && exist.secondHand && exist.secondHand.length > 0) {
                return exist.secondHand.reduce(function(acc, curr) {
                    return acc + curr.quantity + (curr.reservedCount || 0);
                }, 0);
            } else if (itemType === 'RENTAL') {
                return exist.quantity || 0;
            }
            return exist.quantity || 0;
        } else {
            return 0;
        }
    }
};
var arrayUnique = function(array) {
    return Array.from(new Set(array));
};
var downloadInvoice = function(url) {
    var a = document.createElement('a');
    a.href = url;
    a.setAttribute('download', 'file');
    a.setAttribute('title', 'T\xe9lecharger votre facture dans un nouvel onglet');
    a.setAttribute('target', '_blank');
    a.click();
};
var downloadURI = function(url, filename) {
    fetch(url).then(function(t) {
        return t.blob().then(function(b) {
            var a = document.createElement('a');
            a.href = URL.createObjectURL(b);
            a.setAttribute('download', filename);
            a.click();
        });
    });
};
// Because we get prices in cents from Sylius
var numberToPrice = function(amount, amountNotDivided) {
    var amountValue = '';
    amountNotDivided ? amountValue = amount.toFixed(2).replace(/\.00$/, '') : amountValue = (amount / 100).toFixed(2).replace(/\.00$/, '');
    return parseFloat(amountValue);
};
// Prismic Selects fields Options utils
var columnGridLayout = function(layout) {
    var columnLeft;
    var columnRight;
    switch(layout){
        case '1/2 - 1/2':
            columnLeft = {
                xs: 12,
                lg: 6
            };
            columnRight = {
                xs: 12,
                lg: 6
            };
            break;
        case '1/3 - 2/3':
            columnLeft = {
                xs: 12,
                lg: 5
            };
            columnRight = {
                xs: 12,
                lg: 7
            };
            break;
        default:
            columnLeft = {
                xs: 12,
                lg: 7
            };
            columnRight = {
                xs: 12,
                lg: 5
            };
            break;
    }
    return {
        columnLeft: columnLeft,
        columnRight: columnRight
    };
};
var columnLayout = function(columns) {
    var gridItemWidth;
    switch(columns){
        case '3':
            gridItemWidth = 4;
            break;
        case '4':
            gridItemWidth = 3;
            break;
        case '6':
            gridItemWidth = 2;
            break;
        default:
            gridItemWidth = '20%';
            break;
    }
    return gridItemWidth;
};
var columnSpacing = function(spacing) {
    var gridSpacing;
    switch(spacing){
        case 'Small':
            gridSpacing = 1;
            break;
        case 'Medium':
            gridSpacing = 3;
            break;
        case 'Large':
            gridSpacing = 6;
            break;
        default:
            gridSpacing = 0;
            break;
    }
    return gridSpacing;
};
var thumbnailRatio = function(thumbRatio) {
    var aspectRatio;
    switch(thumbRatio){
        case 'Portrait':
            aspectRatio = 'ar-3-4';
            break;
        case 'Landscape 4:3':
            aspectRatio = 'ar-4-3';
            break;
        case 'Landscape 16:9':
            aspectRatio = 'ar-16-9';
            break;
        case 'Taller portrait 2:3':
            aspectRatio = 'ar-2-3';
            break;
        case 'Phone screen 9:16':
            aspectRatio = 'ar-9-16';
            break;
        default:
            aspectRatio = 'ar-1-1';
            break;
    }
    return aspectRatio;
};
var getProductImageKitSettings = function(width, aspectRatio) {
    var quality = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 75;
    var ar = (aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.startsWith('ar-')) ? aspectRatio.substring(3) : aspectRatio;
    return _objectSpread({
        quality: quality,
        width: width
    }, _constants__WEBPACK_IMPORTED_MODULE_0__/* .shopProductFullImage */ .N6 || !ar ? {} : {
        ar: ar
    });
};
var checkTryOutError = function(cart) {
    var ref, ref7, ref8, ref9;
    var globalQuantRented = 0;
    var globalQuantTryOut = 0;
    (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref7 = ref.items) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 && (cart === null || cart === void 0 ? void 0 : (ref8 = cart.item) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.items) === null || ref9 === void 0 ? void 0 : ref9.map(function(item) {
        if (!(item === null || item === void 0 ? void 0 : item.withTryingOn)) {
            globalQuantRented += item.quantity;
        } else {
            globalQuantTryOut += item.quantity;
        }
    }));
    if (globalQuantRented >= globalQuantTryOut) {
        return false;
    } else return true;
};
var calcPackMinPrice = function(products) {
    var minPrice = 0;
    var priceArray = [];
    //pack?.packProducts?.map((product) => {
    products === null || products === void 0 ? void 0 : products.map(function(product) {
        var _Math;
        var ref;
        var priceVariant = [];
        var productQty = (product === null || product === void 0 ? void 0 : product.packProductQuantity) ? product === null || product === void 0 ? void 0 : product.packProductQuantity : 1;
        product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.variants.map(function(variant) {
            // TODO need work here to not put channel in raw
            if (variant.channelPricings.FASHION_WEB) {
                priceVariant.push(variant.channelPricings.FASHION_WEB.price * productQty);
            } else if (variant.channelPricings.WEB) {
                priceVariant.push(variant.channelPricings.WEB.price * productQty);
            } else {
                priceVariant.push(variant.channelPricings.WEB1.price * productQty);
            }
        });
        priceArray.push((_Math = Math).min.apply(_Math, _toConsumableArray(priceVariant)));
    });
    minPrice = priceArray.reduce(function(a, b) {
        return a + b;
    }, 0);
    return minPrice;
};
var apiHeaders = function(connexionType, isV2) {
    var headers = {
        Authorization: "BEARER ".concat( true && (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .LOCAL_STORAGE_KEYS.TOKEN */ .dA.TOKEN)))
    };
    if (connexionType !== null) {
        headers['Authorization-Type'] = connexionType;
    }
    if (isV2 || connexionType !== null) {
        headers['Accept'] = 'application/json';
    }
    return headers;
};
var calculTotalWithBuyAbleProducts = function(cart, isBuyAbleProducts) {
    var ref18, ref10;
    var total;
    if (!(cart === null || cart === void 0 ? void 0 : (ref18 = cart.item) === null || ref18 === void 0 ? void 0 : (ref10 = ref18.totals) === null || ref10 === void 0 ? void 0 : ref10.totalSecondHand)) {
        total = cart.item.totals.totalItemWithoutPromotion + cart.item.totals.promotion;
    } else {
        var ref11, ref12;
        total = cart.item.totals.totalItemWithoutPromotion + cart.item.totals.promotion - (cart === null || cart === void 0 ? void 0 : (ref11 = cart.item) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.totals) === null || ref12 === void 0 ? void 0 : ref12.totalSecondHand);
    }
    if (!isBuyAbleProducts) {
        var ref13, ref14;
        cart === null || cart === void 0 ? void 0 : (ref13 = cart.item) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.items) === null || ref14 === void 0 ? void 0 : ref14.map(function(product) {
            var ref;
            if (product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.variants[0].purchase) {
                var ref17;
                total -= (product === null || product === void 0 ? void 0 : (ref17 = product.product) === null || ref17 === void 0 ? void 0 : ref17.variants[0].purchasePrice) * product.quantity;
            }
        });
    } else {
        var ref15, ref16;
        cart === null || cart === void 0 ? void 0 : (ref15 = cart.item) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.items) === null || ref16 === void 0 ? void 0 : ref16.map(function(product) {
            var ref;
            if (!(product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.variants[0].purchase)) {
                total -= product === null || product === void 0 ? void 0 : product.total;
            }
        });
    }
    return total;
};
// Func Heading to handle font settings easily
var heading = function(fontSizeMobile, fontSizeDesktop, fontWeightMobile, fontWeightDesktop, fontFamilyMobile, fontFamilyDesktop) {
    var isImportant = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
    return {
        fontWeight: isImportant ? "".concat(fontWeightMobile, " !important") : fontWeightMobile,
        fontFamily: isImportant ? "".concat(fontFamilyMobile, " !important") : fontFamilyMobile,
        fontSize: isImportant ? "".concat(fontSizeMobile, " !important") : fontSizeMobile,
        '& strong,& b': {
            fontWeight: isImportant ? "".concat(fontWeightMobile, " !important") : fontWeightMobile
        },
        '@media (min-width: 1024px)': {
            fontWeight: isImportant ? "".concat(fontWeightDesktop, " !important") : fontWeightDesktop,
            fontFamily: isImportant ? "".concat(fontFamilyDesktop, " !important") : fontFamilyDesktop,
            fontSize: isImportant ? "".concat(fontSizeDesktop, " !important") : fontSizeDesktop,
            '& strong,& b': {
                fontWeight: isImportant ? "".concat(fontWeightDesktop, " !important") : fontWeightDesktop
            }
        }
    };
};
var menuPosition = function(position) {
    var menuPosition1;
    switch(position){
        case 'Left':
            menuPosition1 = 'Left';
            break;
        case 'Right':
            menuPosition1 = 'Right';
            break;
        case 'Center':
            menuPosition1 = 'Center';
            break;
        default:
            menuPosition1 = 'No menu';
            break;
    }
    return menuPosition1;
};
var logoPosition = function(position) {
    var menuPosition2;
    switch(position){
        case 'Center':
            menuPosition2 = 'Center';
            break;
        case 'Right':
            menuPosition2 = 'Right';
            break;
        default:
            menuPosition2 = 'Left';
            break;
    }
    return menuPosition2;
};
var findCurrentPlan = function(promotions, qty, price) {
    var ref;
    // Filter plans of coupon based promotions
    var plans = promotions === null || promotions === void 0 ? void 0 : (ref = promotions.items) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return !item.coupon_based;
    });
    plans === null || plans === void 0 ? void 0 : plans.map(function(plan) {
        if (qty >= plan.rules[0].configuration.from && qty <= plan.rules[0].configuration.to) {
            price = plan.actions[0].configuration[Object.keys(promotions.items[0].actions[0].configuration)[0]].amount;
        }
    });
    return price;
};
var getProductTaxonPromotion = function(promotions, productTaxons) {
    var ref20;
    if (!(promotions === null || promotions === void 0 ? void 0 : promotions.items) || !productTaxons) return null;
    var allProductTaxons = ((ref20 = productTaxons.all) === null || ref20 === void 0 ? void 0 : ref20.length) ? productTaxons.all : [
        productTaxons.main
    ].concat(_toConsumableArray(productTaxons.others || [])).filter(Boolean);
    if (allProductTaxons.length === 0) return null;
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = promotions.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var promo = _step2.value;
            if (promo.coupon_based) continue;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                var _loop1 = function(_iterator1, _step1) {
                    var action = _step1.value;
                    var channelKeys = Object.keys(action.configuration || {});
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        var _loop = function(_iterator, _step) {
                            var key = _step.value;
                            var ref, ref19;
                            var channelConfig = action.configuration[key];
                            if (typeof channelConfig !== 'object' || channelConfig === null) return "continue";
                            var taxonsFilter = (ref = channelConfig.filters) === null || ref === void 0 ? void 0 : (ref19 = ref.taxons_filter) === null || ref19 === void 0 ? void 0 : ref19.taxons;
                            if (!taxonsFilter || taxonsFilter.length === 0) return "continue";
                            var hasMatch = allProductTaxons.some(function(taxon) {
                                return taxonsFilter.some(function(filterTaxon) {
                                    return filterTaxon.toLowerCase() === taxon.toLowerCase();
                                });
                            });
                            if (hasMatch && channelConfig.percentage) {
                                return {
                                    v: channelConfig.percentage * 100
                                };
                            }
                        };
                        for(var _iterator = channelKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _ret = _loop(_iterator, _step);
                            if (_ret === "continue") continue;
                            if (_typeof(_ret) === "object") return {
                                v: _ret.v
                            };
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
                for(var _iterator1 = (promo.actions || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _ret1 = _loop1(_iterator1, _step1);
                    if (_typeof(_ret1) === "object") return _ret1.v;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return null;
};
var validXMLPath = function(el) {
    // We need to replace some characters in order to have XML valid file
    var cleanPath = el.replace(/ /g, '%20').replace(/&/g, '&amp;').replace(/'/g, '&apos;').replace(/"/g, '&quot;').replace(/>/g, '&gt;').replace(/</g, '&lt;');
    return cleanPath;
};
var isPurchasedItem = function(item) {
    return (item === null || item === void 0 ? void 0 : item.type) === _constants__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_ITEM_TYPE.PURCHASE */ ._$.PURCHASE;
};
var btnOptions = function(option) {
    var btnOption;
    switch(option){
        case 'Above':
            btnOption = 'Above';
            break;
        case 'Both':
            btnOption = 'Both';
            break;
        default:
            btnOption = 'Below';
            break;
    }
    return btnOption;
};
var findIfSlugExist = function(taxons, slugs) {
    var ref23, ref21;
    if (!(slugs === null || slugs === void 0 ? void 0 : slugs.length)) return false;
    var firstSlug = slugs[0].toLowerCase();
    var remainingSlugs = slugs.slice(1);
    if ((taxons === null || taxons === void 0 ? void 0 : (ref23 = taxons.code) === null || ref23 === void 0 ? void 0 : ref23.toLowerCase()) === firstSlug) {
        if (remainingSlugs.length === 0) return true;
        return findIfSlugExist(taxons, remainingSlugs);
    }
    var currentTaxon = taxons === null || taxons === void 0 ? void 0 : (ref21 = taxons.children) === null || ref21 === void 0 ? void 0 : ref21.find(function(child) {
        var ref, ref22;
        return ((ref = child.slug) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === firstSlug || ((ref22 = child.code) === null || ref22 === void 0 ? void 0 : ref22.toLowerCase()) === firstSlug;
    });
    if (currentTaxon === undefined) return false;
    if (remainingSlugs.length === 0) return true;
    return findIfSlugExist(currentTaxon, remainingSlugs);
};
/**
 * recursively find the currentTaxon by slug === taxon.slug then replace the slug with the targetTaxon.slug in the url
 * @param url
 * @param slugs
 * @param currentTaxons
 * @param targetTaxons
 * @returns string
 */ var translateUrlSlugs = function(url, slugs, currentTaxons, targetTaxons) {
    if (!slugs || slugs.length === 0 || !currentTaxons || !targetTaxons || currentTaxons.length === 0 || targetTaxons.length === 0) return url;
    var currentSlug = slugs[0];
    var currentTaxon = currentTaxons.find(function(taxon) {
        return (taxon === null || taxon === void 0 ? void 0 : taxon.slug) === currentSlug;
    });
    var targetTaxon = targetTaxons.find(function(taxon) {
        return (taxon === null || taxon === void 0 ? void 0 : taxon.code) === (currentTaxon === null || currentTaxon === void 0 ? void 0 : currentTaxon.code);
    });
    var newUrl = url.replace(currentSlug, targetTaxon === null || targetTaxon === void 0 ? void 0 : targetTaxon.slug);
    slugs.shift();
    if (slugs.length === 0) return newUrl;
    return translateUrlSlugs(newUrl, slugs, currentTaxon.children, targetTaxon.children);
};
var productLowestPrice = function(product1, takeBackLP) {
    var takeBackMinPriceArray = [];
    Object.values(product1 === null || product1 === void 0 ? void 0 : product1.variants).forEach(function(variant) {
        var ref24;
        var currentVariant = takeBackLP === null || takeBackLP === void 0 ? void 0 : (ref24 = takeBackLP.takeBackStock) === null || ref24 === void 0 ? void 0 : ref24.find(function(stock) {
            return (stock === null || stock === void 0 ? void 0 : stock.lizeeSKU) === variant.sku;
        });
        if ((currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.productsByQuality.length) > 0) {
            currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.productsByQuality.forEach(function(product) {
                var ref;
                var quality = product.quality || _typings_base__WEBPACK_IMPORTED_MODULE_1__/* .SecondHandCondition.PERFECT_CONDITION */ .pJ.PERFECT_CONDITION;
                if (variant === null || variant === void 0 ? void 0 : (ref = variant.resalePrice) === null || ref === void 0 ? void 0 : ref[quality]) {
                    takeBackMinPriceArray.push({
                        price: variant.resalePrice[quality],
                        taxIncludedInPrice: variant.taxIncludedInPrice,
                        taxRate: variant.taxRate
                    });
                }
            });
        }
    });
    return takeBackMinPriceArray;
};
function secondHandCarrierIdByCountry(country) {
    if (process.env.CARRIER_ID_EUROPE) {
        return country === 'FR' ? process.env.CARRIER_ID : process.env.CARRIER_ID_EUROPE;
    } else {
        return process.env.CARRIER_ID;
    }
}


/***/ }),

/***/ 25066:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 18698:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 72821:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(34155);
(function(){"use strict";var e={977:function(e){function assertPath(e){if(typeof e!=="string"){throw new TypeError("Path must be a string. Received "+JSON.stringify(e))}}function normalizeStringPosix(e,r){var t="";var i=0;var n=-1;var a=0;var f;for(var l=0;l<=e.length;++l){if(l<e.length)f=e.charCodeAt(l);else if(f===47)break;else f=47;if(f===47){if(n===l-1||a===1){}else if(n!==l-1&&a===2){if(t.length<2||i!==2||t.charCodeAt(t.length-1)!==46||t.charCodeAt(t.length-2)!==46){if(t.length>2){var s=t.lastIndexOf("/");if(s!==t.length-1){if(s===-1){t="";i=0}else{t=t.slice(0,s);i=t.length-1-t.lastIndexOf("/")}n=l;a=0;continue}}else if(t.length===2||t.length===1){t="";i=0;n=l;a=0;continue}}if(r){if(t.length>0)t+="/..";else t="..";i=2}}else{if(t.length>0)t+="/"+e.slice(n+1,l);else t=e.slice(n+1,l);i=l-n-1}n=l;a=0}else if(f===46&&a!==-1){++a}else{a=-1}}return t}function _format(e,r){var t=r.dir||r.root;var i=r.base||(r.name||"")+(r.ext||"");if(!t){return i}if(t===r.root){return t+i}return t+e+i}var r={resolve:function resolve(){var e="";var r=false;var t;for(var i=arguments.length-1;i>=-1&&!r;i--){var n;if(i>=0)n=arguments[i];else{if(t===undefined)t=process.cwd();n=t}assertPath(n);if(n.length===0){continue}e=n+"/"+e;r=n.charCodeAt(0)===47}e=normalizeStringPosix(e,!r);if(r){if(e.length>0)return"/"+e;else return"/"}else if(e.length>0){return e}else{return"."}},normalize:function normalize(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0)===47;var t=e.charCodeAt(e.length-1)===47;e=normalizeStringPosix(e,!r);if(e.length===0&&!r)e=".";if(e.length>0&&t)e+="/";if(r)return"/"+e;return e},isAbsolute:function isAbsolute(e){assertPath(e);return e.length>0&&e.charCodeAt(0)===47},join:function join(){if(arguments.length===0)return".";var e;for(var t=0;t<arguments.length;++t){var i=arguments[t];assertPath(i);if(i.length>0){if(e===undefined)e=i;else e+="/"+i}}if(e===undefined)return".";return r.normalize(e)},relative:function relative(e,t){assertPath(e);assertPath(t);if(e===t)return"";e=r.resolve(e);t=r.resolve(t);if(e===t)return"";var i=1;for(;i<e.length;++i){if(e.charCodeAt(i)!==47)break}var n=e.length;var a=n-i;var f=1;for(;f<t.length;++f){if(t.charCodeAt(f)!==47)break}var l=t.length;var s=l-f;var o=a<s?a:s;var u=-1;var h=0;for(;h<=o;++h){if(h===o){if(s>o){if(t.charCodeAt(f+h)===47){return t.slice(f+h+1)}else if(h===0){return t.slice(f+h)}}else if(a>o){if(e.charCodeAt(i+h)===47){u=h}else if(h===0){u=0}}break}var c=e.charCodeAt(i+h);var v=t.charCodeAt(f+h);if(c!==v)break;else if(c===47)u=h}var g="";for(h=i+u+1;h<=n;++h){if(h===n||e.charCodeAt(h)===47){if(g.length===0)g+="..";else g+="/.."}}if(g.length>0)return g+t.slice(f+u);else{f+=u;if(t.charCodeAt(f)===47)++f;return t.slice(f)}},_makeLong:function _makeLong(e){return e},dirname:function dirname(e){assertPath(e);if(e.length===0)return".";var r=e.charCodeAt(0);var t=r===47;var i=-1;var n=true;for(var a=e.length-1;a>=1;--a){r=e.charCodeAt(a);if(r===47){if(!n){i=a;break}}else{n=false}}if(i===-1)return t?"/":".";if(t&&i===1)return"//";return e.slice(0,i)},basename:function basename(e,r){if(r!==undefined&&typeof r!=="string")throw new TypeError('"ext" argument must be a string');assertPath(e);var t=0;var i=-1;var n=true;var a;if(r!==undefined&&r.length>0&&r.length<=e.length){if(r.length===e.length&&r===e)return"";var f=r.length-1;var l=-1;for(a=e.length-1;a>=0;--a){var s=e.charCodeAt(a);if(s===47){if(!n){t=a+1;break}}else{if(l===-1){n=false;l=a+1}if(f>=0){if(s===r.charCodeAt(f)){if(--f===-1){i=a}}else{f=-1;i=l}}}}if(t===i)i=l;else if(i===-1)i=e.length;return e.slice(t,i)}else{for(a=e.length-1;a>=0;--a){if(e.charCodeAt(a)===47){if(!n){t=a+1;break}}else if(i===-1){n=false;i=a+1}}if(i===-1)return"";return e.slice(t,i)}},extname:function extname(e){assertPath(e);var r=-1;var t=0;var i=-1;var n=true;var a=0;for(var f=e.length-1;f>=0;--f){var l=e.charCodeAt(f);if(l===47){if(!n){t=f+1;break}continue}if(i===-1){n=false;i=f+1}if(l===46){if(r===-1)r=f;else if(a!==1)a=1}else if(r!==-1){a=-1}}if(r===-1||i===-1||a===0||a===1&&r===i-1&&r===t+1){return""}return e.slice(r,i)},format:function format(e){if(e===null||typeof e!=="object"){throw new TypeError('The "pathObject" argument must be of type Object. Received type '+typeof e)}return _format("/",e)},parse:function parse(e){assertPath(e);var r={root:"",dir:"",base:"",ext:"",name:""};if(e.length===0)return r;var t=e.charCodeAt(0);var i=t===47;var n;if(i){r.root="/";n=1}else{n=0}var a=-1;var f=0;var l=-1;var s=true;var o=e.length-1;var u=0;for(;o>=n;--o){t=e.charCodeAt(o);if(t===47){if(!s){f=o+1;break}continue}if(l===-1){s=false;l=o+1}if(t===46){if(a===-1)a=o;else if(u!==1)u=1}else if(a!==-1){u=-1}}if(a===-1||l===-1||u===0||u===1&&a===l-1&&a===f+1){if(l!==-1){if(f===0&&i)r.base=r.name=e.slice(1,l);else r.base=r.name=e.slice(f,l)}}else{if(f===0&&i){r.name=e.slice(1,a);r.base=e.slice(1,l)}else{r.name=e.slice(f,a);r.base=e.slice(f,l)}r.ext=e.slice(a,l)}if(f>0)r.dir=e.slice(0,f-1);else if(i)r.dir="/";return r},sep:"/",delimiter:":",win32:null,posix:null};r.posix=r;e.exports=r}};var r={};function __nccwpck_require__(t){var i=r[t];if(i!==undefined){return i.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(977);module.exports=t})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ }),

/***/ 73400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wT": function() { return /* binding */ SnackbarProvider; },
/* harmony export */   "Ds": function() { return /* binding */ useSnackbar; }
/* harmony export */ });
/* unused harmony exports SnackbarContent, withSnackbar */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core_Slide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82285);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1591);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85160);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_Collapse__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66037);
/* harmony import */ var _material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62087);
/* harmony import */ var _material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52795);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__);










function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SnackbarContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext();

var allClasses = {
  mui: {
    root: {},
    anchorOriginTopCenter: {},
    anchorOriginBottomCenter: {},
    anchorOriginTopRight: {},
    anchorOriginBottomRight: {},
    anchorOriginTopLeft: {},
    anchorOriginBottomLeft: {}
  },
  container: {
    containerRoot: {},
    containerAnchorOriginTopCenter: {},
    containerAnchorOriginBottomCenter: {},
    containerAnchorOriginTopRight: {},
    containerAnchorOriginBottomRight: {},
    containerAnchorOriginTopLeft: {},
    containerAnchorOriginBottomLeft: {}
  }
};
var MESSAGES = {
  NO_PERSIST_ALL: 'WARNING - notistack: Reached maxSnack while all enqueued snackbars have \'persist\' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented.'
};
var SNACKBAR_INDENTS = {
  view: {
    "default": 20,
    dense: 4
  },
  snackbar: {
    "default": 6,
    dense: 2
  }
};
var DEFAULTS = {
  maxSnack: 3,
  dense: false,
  hideIconVariant: false,
  variant: 'default',
  autoHideDuration: 5000,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  TransitionComponent: _material_ui_core_Slide__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  transitionDuration: {
    enter: 225,
    exit: 195
  }
};
var capitalise = function capitalise(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
};
var originKeyExtractor = function originKeyExtractor(anchor) {
  return "" + capitalise(anchor.vertical) + capitalise(anchor.horizontal);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */

var omitContainerKeys = function omitContainerKeys(classes) {
  return (// @ts-ignore
    Object.keys(classes).filter(function (key) {
      return !allClasses.container[key];
    }).reduce(function (obj, key) {
      var _extends2;

      return _extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
    }, {})
  );
};
var REASONS = {
  TIMEOUT: 'timeout',
  CLICKAWAY: 'clickaway',
  MAXSNACK: 'maxsnack',
  INSTRUCTED: 'instructed'
};
/** Tranforms classes name */

var transformer = {
  toContainerAnchorOrigin: function toContainerAnchorOrigin(origin) {
    return "containerAnchorOrigin" + origin;
  },
  toAnchorOrigin: function toAnchorOrigin(_ref) {
    var vertical = _ref.vertical,
        horizontal = _ref.horizontal;
    return "anchorOrigin" + capitalise(vertical) + capitalise(horizontal);
  },
  toVariant: function toVariant(variant) {
    return "variant" + capitalise(variant);
  }
};
var isDefined = function isDefined(value) {
  return !!value || value === 0;
};

var numberOrNull = function numberOrNull(numberish) {
  return typeof numberish === 'number' || numberish === null;
}; // @ts-ignore


var merge = function merge(options, props, defaults) {
  return function (name) {
    if (name === 'autoHideDuration') {
      if (numberOrNull(options.autoHideDuration)) return options.autoHideDuration;
      if (numberOrNull(props.autoHideDuration)) return props.autoHideDuration;
      return DEFAULTS.autoHideDuration;
    }

    return options[name] || props[name] || defaults[name];
  };
};
function objectMerge(options, props, defaults) {
  if (options === void 0) {
    options = {};
  }

  if (props === void 0) {
    props = {};
  }

  if (defaults === void 0) {
    defaults = {};
  }

  return _extends({}, defaults, {}, props, {}, options);
}

var styles = function styles(theme) {
  var _root;

  return (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    root: (_root = {
      display: 'flex',
      flexWrap: 'wrap',
      flexGrow: 1
    }, _root[theme.breakpoints.up('sm')] = {
      flexGrow: 'initial',
      minWidth: 288
    }, _root)
  });
};

var SnackbarContent = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var classes = _ref.classes,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["classes", "className"]);

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", Object.assign({
    ref: ref,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className)
  }, props));
});
var SnackbarContent$1 = /*#__PURE__*/(0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles)(SnackbarContent);

var DIRECTION = {
  right: 'left',
  left: 'right',
  bottom: 'up',
  top: 'down'
};
var getTransitionDirection = function getTransitionDirection(anchorOrigin) {
  if (anchorOrigin.horizontal !== 'center') {
    return DIRECTION[anchorOrigin.horizontal];
  }

  return DIRECTION[anchorOrigin.vertical];
};

var CheckIcon = function CheckIcon(props) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, Object.assign({}, props), react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
  }));
};

var WarningIcon = function WarningIcon(props) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, Object.assign({}, props), react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
  }));
};

var ErrorIcon = function ErrorIcon(props) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, Object.assign({}, props), react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
  }));
};

var InfoIcon = function InfoIcon(props) {
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core_SvgIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, Object.assign({}, props), react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
  }));
};

var iconStyles = {
  fontSize: 20,
  marginInlineEnd: 8
};
var defaultIconVariants = {
  "default": undefined,
  success: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(CheckIcon, {
    style: iconStyles
  }),
  warning: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(WarningIcon, {
    style: iconStyles
  }),
  error: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ErrorIcon, {
    style: iconStyles
  }),
  info: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(InfoIcon, {
    style: iconStyles
  })
};

/**
 * @link https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/createChainedFunction.js
 */
function createChainedFunction(funcs, extraArg) {
  return funcs.reduce(function (acc, func) {
    if (func == null) return acc;

    if (false) {}

    return function chainedFunction() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var argums = [].concat(args);

      if (extraArg && argums.indexOf(extraArg) === -1) {
        argums.push(extraArg);
      }

      acc.apply(this, argums);
      func.apply(this, argums);
    };
  }, function () {});
}

/**
 * @link https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/useEventCallback.js
 */
var useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
function useEventCallback(fn) {
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    return (ref.current).apply(void 0, arguments);
  }, []);
}

var Snackbar = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
  var children = props.children,
      autoHideDuration = props.autoHideDuration,
      ClickAwayListenerProps = props.ClickAwayListenerProps,
      _props$disableWindowB = props.disableWindowBlurListener,
      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
      onClose = props.onClose,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      open = props.open,
      resumeHideDuration = props.resumeHideDuration,
      other = _objectWithoutPropertiesLoose(props, ["children", "autoHideDuration", "ClickAwayListenerProps", "disableWindowBlurListener", "onClose", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration"]);

  var timerAutoHide = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var handleClose = useEventCallback(function () {
    if (onClose) {
      onClose.apply(void 0, arguments);
    }
  });
  var setAutoHideTimer = useEventCallback(function (autoHideDurationParam) {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }

    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(function () {
      handleClose(null, REASONS.TIMEOUT);
    }, autoHideDurationParam);
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }

    return function () {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, autoHideDuration, setAutoHideTimer]);
  /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */

  var handlePause = function handlePause() {
    clearTimeout(timerAutoHide.current);
  };
  /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */


  var handleResume = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);

  var handleMouseEnter = function handleMouseEnter(event) {
    if (onMouseEnter) {
      onMouseEnter(event);
    }

    handlePause();
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    handleResume();
  };

  var handleClickAway = function handleClickAway(event) {
    if (onClose) {
      onClose(event, REASONS.CLICKAWAY);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return function () {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }

    return undefined;
  }, [disableWindowBlurListener, handleResume, open]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, _extends({
    onClickAway: handleClickAway
  }, ClickAwayListenerProps), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", _extends({
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: ref
  }, other), children));
});

var styles$1 = function styles(theme) {
  // @ts-ignore
  var mode = theme.palette.mode || theme.palette.type;
  var backgroundColor = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_9__/* .emphasize */ ._4)(theme.palette.background["default"], mode === 'light' ? 0.8 : 0.98);
  return (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_extends({}, allClasses.mui, {
    contentRoot: _extends({}, theme.typography.body2, {
      backgroundColor: backgroundColor,
      color: theme.palette.getContrastText(backgroundColor),
      alignItems: 'center',
      padding: '6px 16px',
      borderRadius: '4px',
      boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)'
    }),
    lessPadding: {
      paddingLeft: 8 * 2.5
    },
    variantSuccess: {
      backgroundColor: '#43a047',
      color: '#fff'
    },
    variantError: {
      backgroundColor: '#d32f2f',
      color: '#fff'
    },
    variantInfo: {
      backgroundColor: '#2196f3',
      color: '#fff'
    },
    variantWarning: {
      backgroundColor: '#ff9800',
      color: '#fff'
    },
    message: {
      display: 'flex',
      alignItems: 'center',
      padding: '8px 0'
    },
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: -8
    },
    wrappedRoot: {
      position: 'relative',
      transform: 'translateX(0)',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  }));
};

var SnackbarItem = function SnackbarItem(_ref) {
  var classes = _ref.classes,
      props = _objectWithoutPropertiesLoose(_ref, ["classes"]);

  var timeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      collapsed = _useState[0],
      setCollapsed = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return function () {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, []);
  var handleClose = createChainedFunction([props.snack.onClose, props.onClose], props.snack.key);

  var handleEntered = function handleEntered() {
    if (props.snack.requestClose) {
      handleClose(null, REASONS.INSTRCUTED);
    }
  };

  var handleExitedScreen = function handleExitedScreen() {
    timeout.current = setTimeout(function () {
      setCollapsed(!collapsed);
    }, 125);
  };

  var style = props.style,
      otherAriaAttributes = props.ariaAttributes,
      otherClassName = props.className,
      hideIconVariant = props.hideIconVariant,
      iconVariant = props.iconVariant,
      snack = props.snack,
      otherAction = props.action,
      otherContent = props.content,
      otherTranComponent = props.TransitionComponent,
      otherTranProps = props.TransitionProps,
      otherTranDuration = props.transitionDuration,
      other = _objectWithoutPropertiesLoose(props, ["style", "dense", "ariaAttributes", "className", "hideIconVariant", "iconVariant", "snack", "action", "content", "TransitionComponent", "TransitionProps", "transitionDuration", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting"]);

  var key = snack.key,
      open = snack.open,
      singleClassName = snack.className,
      variant = snack.variant,
      singleContent = snack.content,
      singleAction = snack.action,
      singleAriaAttributes = snack.ariaAttributes,
      anchorOrigin = snack.anchorOrigin,
      snackMessage = snack.message,
      singleTranComponent = snack.TransitionComponent,
      singleTranProps = snack.TransitionProps,
      singleTranDuration = snack.transitionDuration,
      singleSnackProps = _objectWithoutPropertiesLoose(snack, ["persist", "key", "open", "entered", "requestClose", "className", "variant", "content", "action", "ariaAttributes", "anchorOrigin", "message", "TransitionComponent", "TransitionProps", "transitionDuration", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting"]);

  var icon = _extends({}, defaultIconVariants, {}, iconVariant)[variant];

  var ariaAttributes = _extends({
    'aria-describedby': 'notistack-snackbar'
  }, objectMerge(singleAriaAttributes, otherAriaAttributes));

  var TransitionComponent = singleTranComponent || otherTranComponent || DEFAULTS.TransitionComponent;
  var transitionDuration = objectMerge(singleTranDuration, otherTranDuration, DEFAULTS.transitionDuration);

  var transitionProps = _extends({
    direction: getTransitionDirection(anchorOrigin)
  }, objectMerge(singleTranProps, otherTranProps));

  var action = singleAction || otherAction;

  if (typeof action === 'function') {
    action = action(key);
  }

  var content = singleContent || otherContent;

  if (typeof content === 'function') {
    content = content(key, snack.message);
  }

  var callbacks = ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].reduce(function (acc, cbName) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[cbName] = createChainedFunction([props.snack[cbName], props[cbName]], props.snack.key), _extends2));
  }, {});
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core_Collapse__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    unmountOnExit: true,
    timeout: 175,
    "in": collapsed,
    onExited: callbacks.onExited
  }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(Snackbar, Object.assign({}, other, singleSnackProps, {
    open: open,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, classes.wrappedRoot, classes[transformer.toAnchorOrigin(anchorOrigin)]),
    onClose: handleClose
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement(TransitionComponent, Object.assign({
    appear: true,
    "in": open,
    timeout: transitionDuration
  }, transitionProps, {
    onExit: callbacks.onExit,
    onExiting: callbacks.onExiting,
    onExited: handleExitedScreen,
    onEnter: callbacks.onEnter,
    onEntering: callbacks.onEntering,
    // order matters. first callbacks.onEntered to set entered: true,
    // then handleEntered to check if there's a request for closing
    onEntered: createChainedFunction([callbacks.onEntered, handleEntered])
  }), content || react__WEBPACK_IMPORTED_MODULE_0__.createElement(SnackbarContent$1, Object.assign({}, ariaAttributes, {
    role: "alert",
    style: style,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.contentRoot, classes[transformer.toVariant(variant)], otherClassName, singleClassName, !hideIconVariant && icon && classes.lessPadding)
  }), react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    id: ariaAttributes['aria-describedby'],
    className: classes.message
  }, !hideIconVariant ? icon : null, snackMessage), action && react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classes.action
  }, action)))));
};

var SnackbarItem$1 = /*#__PURE__*/(0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles$1)(SnackbarItem);

var collapse = {
  // Material-UI 4.12.x and above uses MuiCollapse-root; earlier versions use
  // Mui-Collapse-container.  https://github.com/mui-org/material-ui/pull/24084
  container: '& > .MuiCollapse-container, & > .MuiCollapse-root',
  wrapper: '& > .MuiCollapse-container > .MuiCollapse-wrapper, & > .MuiCollapse-root > .MuiCollapse-wrapper'
};
var xsWidthMargin = 16;
var useStyle = /*#__PURE__*/(0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function (theme) {
  var _root, _rootDense, _left, _right, _center;

  return {
    root: (_root = {
      boxSizing: 'border-box',
      display: 'flex',
      maxHeight: '100%',
      position: 'fixed',
      zIndex: theme.zIndex.snackbar,
      height: 'auto',
      width: 'auto',
      transition: 'top 300ms ease 0ms, right 300ms ease 0ms, bottom 300ms ease 0ms, left 300ms ease 0ms, margin 300ms ease 0ms, max-width 300ms ease 0ms',
      // container itself is invisible and should not block clicks, clicks should be passed to its children
      pointerEvents: 'none'
    }, _root[collapse.container] = {
      pointerEvents: 'all'
    }, _root[collapse.wrapper] = {
      padding: SNACKBAR_INDENTS.snackbar["default"] + "px 0px",
      transition: 'padding 300ms ease 0ms'
    }, _root.maxWidth = "calc(100% - " + SNACKBAR_INDENTS.view["default"] * 2 + "px)", _root[theme.breakpoints.down('xs')] = {
      width: '100%',
      maxWidth: "calc(100% - " + xsWidthMargin * 2 + "px)"
    }, _root),
    rootDense: (_rootDense = {}, _rootDense[collapse.wrapper] = {
      padding: SNACKBAR_INDENTS.snackbar.dense + "px 0px"
    }, _rootDense),
    top: {
      top: SNACKBAR_INDENTS.view["default"] - SNACKBAR_INDENTS.snackbar["default"],
      flexDirection: 'column'
    },
    bottom: {
      bottom: SNACKBAR_INDENTS.view["default"] - SNACKBAR_INDENTS.snackbar["default"],
      flexDirection: 'column-reverse'
    },
    left: (_left = {
      left: SNACKBAR_INDENTS.view["default"]
    }, _left[theme.breakpoints.up('sm')] = {
      alignItems: 'flex-start'
    }, _left[theme.breakpoints.down('xs')] = {
      left: xsWidthMargin + "px"
    }, _left),
    right: (_right = {
      right: SNACKBAR_INDENTS.view["default"]
    }, _right[theme.breakpoints.up('sm')] = {
      alignItems: 'flex-end'
    }, _right[theme.breakpoints.down('xs')] = {
      right: xsWidthMargin + "px"
    }, _right),
    center: (_center = {
      left: '50%',
      transform: 'translateX(-50%)'
    }, _center[theme.breakpoints.up('sm')] = {
      alignItems: 'center'
    }, _center)
  };
});

var SnackbarContainer = function SnackbarContainer(props) {
  var classes = useStyle();

  var className = props.className,
      anchorOrigin = props.anchorOrigin,
      dense = props.dense,
      other = _objectWithoutPropertiesLoose(props, ["className", "anchorOrigin", "dense"]);

  var combinedClassname = (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes[anchorOrigin.vertical], classes[anchorOrigin.horizontal], classes.root, // root should come after others to override maxWidth
  className, dense && classes.rootDense);
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", Object.assign({
    className: combinedClassname
  }, other));
};

var SnackbarContainer$1 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(SnackbarContainer);

/* eslint-disable */
var __DEV__ = (/* unused pure expression or super */ null && ("production" !== 'production'));

var warning = (function (message) {
  if (!__DEV__) return;

  if (typeof console !== 'undefined') {
    console.error(message);
  }

  try {
    throw new Error(message);
  } catch (x) {}
});

var SnackbarProvider = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SnackbarProvider, _Component);

  function SnackbarProvider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */

    _this.enqueueSnackbar = function (message, opts) {
      if (opts === void 0) {
        opts = {};
      }

      var _opts = opts,
          key = _opts.key,
          preventDuplicate = _opts.preventDuplicate,
          options = _objectWithoutPropertiesLoose(_opts, ["key", "preventDuplicate"]);

      var hasSpecifiedKey = isDefined(key);
      var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
      var merger = merge(options, _this.props, DEFAULTS);

      var snack = _extends({
        key: id
      }, options, {
        message: message,
        open: true,
        entered: false,
        requestClose: false,
        variant: merger('variant'),
        anchorOrigin: merger('anchorOrigin'),
        autoHideDuration: merger('autoHideDuration')
      });

      if (options.persist) {
        snack.autoHideDuration = undefined;
      }

      _this.setState(function (state) {
        if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
          var compareFunction = function compareFunction(item) {
            return hasSpecifiedKey ? item.key === key : item.message === message;
          };

          var inQueue = state.queue.findIndex(compareFunction) > -1;
          var inView = state.snacks.findIndex(compareFunction) > -1;

          if (inQueue || inView) {
            return state;
          }
        }

        return _this.handleDisplaySnack(_extends({}, state, {
          queue: [].concat(state.queue, [snack])
        }));
      });

      return id;
    };
    /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */


    _this.handleDisplaySnack = function (state) {
      var snacks = state.snacks;

      if (snacks.length >= _this.maxSnack) {
        return _this.handleDismissOldest(state);
      }

      return _this.processQueue(state);
    };
    /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */


    _this.processQueue = function (state) {
      var queue = state.queue,
          snacks = state.snacks;

      if (queue.length > 0) {
        return _extends({}, state, {
          snacks: [].concat(snacks, [queue[0]]),
          queue: queue.slice(1, queue.length)
        });
      }

      return state;
    };
    /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */


    _this.handleDismissOldest = function (state) {
      if (state.snacks.some(function (item) {
        return !item.open || item.requestClose;
      })) {
        return state;
      }

      var popped = false;
      var ignore = false;
      var persistentCount = state.snacks.reduce(function (acc, current) {
        return acc + (current.open && current.persist ? 1 : 0);
      }, 0);

      if (persistentCount === _this.maxSnack) {
         false ? 0 : void 0;
        ignore = true;
      }

      var snacks = state.snacks.map(function (item) {
        if (!popped && (!item.persist || ignore)) {
          popped = true;

          if (!item.entered) {
            return _extends({}, item, {
              requestClose: true
            });
          }

          if (item.onClose) item.onClose(null, REASONS.MAXSNACK, item.key);
          if (_this.props.onClose) _this.props.onClose(null, REASONS.MAXSNACK, item.key);
          return _extends({}, item, {
            open: false
          });
        }

        return _extends({}, item);
      });
      return _extends({}, state, {
        snacks: snacks
      });
    };
    /**
     * Set the entered state of the snackbar with the given key.
     */


    _this.handleEnteredSnack = function (node, isAppearing, key) {
      if (!isDefined(key)) {
        throw new Error('handleEnteredSnack Cannot be called with undefined key');
      }

      _this.setState(function (_ref) {
        var snacks = _ref.snacks;
        return {
          snacks: snacks.map(function (item) {
            return item.key === key ? _extends({}, item, {
              entered: true
            }) : _extends({}, item);
          })
        };
      });
    };
    /**
     * Hide a snackbar after its timeout.
     */


    _this.handleCloseSnack = function (event, reason, key) {
      // should not use createChainedFunction for onClose.
      // because this.closeSnackbar called this function
      if (_this.props.onClose) {
        _this.props.onClose(event, reason, key);
      }

      if (reason === REASONS.CLICKAWAY) return;
      var shouldCloseAll = key === undefined;

      _this.setState(function (_ref2) {
        var snacks = _ref2.snacks,
            queue = _ref2.queue;
        return {
          snacks: snacks.map(function (item) {
            if (!shouldCloseAll && item.key !== key) {
              return _extends({}, item);
            }

            return item.entered ? _extends({}, item, {
              open: false
            }) : _extends({}, item, {
              requestClose: true
            });
          }),
          queue: queue.filter(function (item) {
            return item.key !== key;
          })
        };
      });
    };
    /**
     * Close snackbar with the given key
     */


    _this.closeSnackbar = function (key) {
      // call individual snackbar onClose callback passed through options parameter
      var toBeClosed = _this.state.snacks.find(function (item) {
        return item.key === key;
      });

      if (isDefined(key) && toBeClosed && toBeClosed.onClose) {
        toBeClosed.onClose(null, REASONS.INSTRUCTED, key);
      }

      _this.handleCloseSnack(null, REASONS.INSTRUCTED, key);
    };
    /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */
    // @ts-ignore


    _this.handleExitedSnack = function (event, key1, key2) {
      var key = key1 || key2;

      if (!isDefined(key)) {
        throw new Error('handleExitedSnack Cannot be called with undefined key');
      }

      _this.setState(function (state) {
        var newState = _this.processQueue(_extends({}, state, {
          snacks: state.snacks.filter(function (item) {
            return item.key !== key;
          })
        }));

        if (newState.queue.length === 0) {
          return newState;
        }

        return _this.handleDismissOldest(newState);
      });
    };

    _this.state = {
      snacks: [],
      queue: [],
      contextValue: {
        enqueueSnackbar: _this.enqueueSnackbar,
        closeSnackbar: _this.closeSnackbar
      }
    };
    return _this;
  }

  var _proto = SnackbarProvider.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var contextValue = this.state.contextValue;

    var _this$props = this.props,
        iconVariant = _this$props.iconVariant,
        _this$props$dense = _this$props.dense,
        dense = _this$props$dense === void 0 ? DEFAULTS.dense : _this$props$dense,
        _this$props$hideIconV = _this$props.hideIconVariant,
        hideIconVariant = _this$props$hideIconV === void 0 ? DEFAULTS.hideIconVariant : _this$props$hideIconV,
        domRoot = _this$props.domRoot,
        children = _this$props.children,
        _this$props$classes = _this$props.classes,
        classes = _this$props$classes === void 0 ? {} : _this$props$classes,
        props = _objectWithoutPropertiesLoose(_this$props, ["maxSnack", "preventDuplicate", "variant", "anchorOrigin", "iconVariant", "dense", "hideIconVariant", "domRoot", "children", "classes"]);

    var categ = this.state.snacks.reduce(function (acc, current) {
      var _extends2;

      var category = originKeyExtractor(current.anchorOrigin);
      var existingOfCategory = acc[category] || [];
      return _extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [current]), _extends2));
    }, {});
    var snackbars = Object.keys(categ).map(function (origin) {
      var snacks = categ[origin];
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(SnackbarContainer$1, {
        key: origin,
        dense: dense,
        anchorOrigin: snacks[0].anchorOrigin,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.containerRoot, classes[transformer.toContainerAnchorOrigin(origin)])
      }, snacks.map(function (snack) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(SnackbarItem$1, Object.assign({}, props, {
          key: snack.key,
          snack: snack,
          dense: dense,
          iconVariant: iconVariant,
          hideIconVariant: hideIconVariant,
          classes: omitContainerKeys(classes),
          onClose: _this2.handleCloseSnack,
          onExited: createChainedFunction([_this2.handleExitedSnack, _this2.props.onExited]),
          onEntered: createChainedFunction([_this2.handleEnteredSnack, _this2.props.onEntered])
        }));
      }));
    });
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(SnackbarContext.Provider, {
      value: contextValue
    }, children, domRoot ? (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(snackbars, domRoot) : snackbars);
  };

  _createClass(SnackbarProvider, [{
    key: "maxSnack",
    get: function get() {
      return this.props.maxSnack || DEFAULTS.maxSnack;
    }
  }]);

  return SnackbarProvider;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;

var getFunctionName = function getFunctionName(fn) {
  var match = ("" + fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
};
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */


var getFunctionComponentName = function getFunctionComponentName(Component, fallback) {
  if (fallback === void 0) {
    fallback = '';
  }

  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
};

var getWrappedName = function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
};
/** 
 * From react-is
 * @link https://github.com/facebook/react/blob/master/packages/shared/ReactSymbols.js
 */


var ForwardRef = function ForwardRef() {
  var symbolFor = typeof Symbol === 'function' && Symbol["for"];
  return symbolFor ? symbolFor('react.forward_ref') : 0xead0;
};
/**
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


var getDisplayName = (function (Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (typeof Component === 'object') {
    switch (Component.$$typeof) {
      case ForwardRef():
        return getWrappedName(Component, Component.render, 'ForwardRef');

      default:
        return undefined;
    }
  }

  return undefined;
});

var withSnackbar = function withSnackbar(Component) {
  var WrappedComponent = React__default.forwardRef(function (props, ref) {
    return React__default.createElement(SnackbarContext.Consumer, null, function (context) {
      return React__default.createElement(Component, _extends({}, props, {
        ref: ref,
        enqueueSnackbar: context.enqueueSnackbar,
        closeSnackbar: context.closeSnackbar
      }));
    });
  });

  if (false) {}

  hoistNonReactStatics(WrappedComponent, Component);
  return WrappedComponent;
};

var useSnackbar = (function () {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SnackbarContext);
});


//# sourceMappingURL=notistack.esm.js.map


/***/ }),

/***/ 34155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 9198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(67294),__webpack_require__(45697),__webpack_require__(94184),__webpack_require__(61334),__webpack_require__(99869),__webpack_require__(2032),__webpack_require__(34618),__webpack_require__(10617),__webpack_require__(75411),__webpack_require__(50735),__webpack_require__(3992),__webpack_require__(80090),__webpack_require__(86326),__webpack_require__(6064),__webpack_require__(98743),__webpack_require__(71001),__webpack_require__(19031),__webpack_require__(26029),__webpack_require__(27229),__webpack_require__(95896),__webpack_require__(98041),__webpack_require__(15365),__webpack_require__(85554),__webpack_require__(73964),__webpack_require__(30850),__webpack_require__(11414),__webpack_require__(8785),__webpack_require__(25233),__webpack_require__(37170),__webpack_require__(61093),__webpack_require__(96499),__webpack_require__(7195),__webpack_require__(22730),__webpack_require__(26423),__webpack_require__(30143),__webpack_require__(76655),__webpack_require__(86590),__webpack_require__(84329),__webpack_require__(79538),__webpack_require__(25985),__webpack_require__(60017),__webpack_require__(6025),__webpack_require__(59783),__webpack_require__(69500),__webpack_require__(56755),__webpack_require__(3301),__webpack_require__(7472),__webpack_require__(13170),__webpack_require__(16220),__webpack_require__(38597),__webpack_require__(80193),__webpack_require__(99522),__webpack_require__(8049),__webpack_require__(41042),__webpack_require__(60231),__webpack_require__(12002),__webpack_require__(71343),__webpack_require__(61941),__webpack_require__(67352),__webpack_require__(58949),__webpack_require__(37004),__webpack_require__(73935)):0}(this,(function(e,t,r,a,n,o,s,i,p,l,d,c,u,f,h,m,y,v,D,w,k,g,b,C,S,_,M,P,E,N,O,Y,x,T,I,L,F,R,q,A,W,B,j,H,K,Q,V,U,$,z,G,J,X,Z,ee,te,re,ae,ne,oe,se,ie,pe){"use strict";function le(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var de=le(t),ce=le(a),ue=le(n),fe=le(o),he=le(s),me=le(i),ye=le(p),ve=le(l),De=le(d),we=le(c),ke=le(u),ge=le(m),be=le(y),Ce=le(v),Se=le(D),_e=le(w),Me=le(k),Pe=le(g),Ee=le(b),Ne=le(C),Oe=le(S),Ye=le(_),xe=le(M),Te=le(P),Ie=le(E),Le=le(N),Fe=le(O),Re=le(Y),qe=le(x),Ae=le(T),We=le(I),Be=le(L),je=le(F),He=le(R),Ke=le(q),Qe=le(W),Ve=le(B),Ue=le(j),$e=le(H),ze=le(K),Ge=le(Q),Je=le(V),Xe=le(z),Ze=le(G),et=le(J),tt=le(X),rt=le(Z),at=le(ee),nt=le(te),ot=le(re),st=le(ae),it=le(ne),pt=le(oe),lt=le(se),dt=le(pe);function ct(e){return(ct="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ut(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function ft(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}function ht(e,t,r){return t&&ft(e.prototype,t),r&&ft(e,r),e}function mt(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function yt(){return(yt=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var a in r)Object.prototype.hasOwnProperty.call(r,a)&&(e[a]=r[a])}return e}).apply(this,arguments)}function vt(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,a)}return r}function Dt(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?vt(Object(r),!0).forEach((function(t){mt(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):vt(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function wt(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&gt(e,t)}function kt(e){return(kt=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function gt(e,t){return(gt=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function bt(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Ct(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?bt(e):t}function St(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=kt(e);if(t){var n=kt(this).constructor;r=Reflect.construct(a,arguments,n)}else r=a.apply(this,arguments);return Ct(this,r)}}function _t(e){return function(e){if(Array.isArray(e))return Mt(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return Mt(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return Mt(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Mt(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,a=new Array(t);r<t;r++)a[r]=e[r];return a}function Pt(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function Et(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}var Nt={p:Et,P:function(e,t){var r,a=e.match(/(P+)(p+)?/),n=a[1],o=a[2];if(!o)return Pt(e,t);switch(n){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;case"PPPP":default:r=t.dateTime({width:"full"})}return r.replace("{{date}}",Pt(n,t)).replace("{{time}}",Et(o,t))}},Ot=12,Yt=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function xt(e){var t=e?"string"==typeof e||e instanceof String?pt.default(e):st.default(e):new Date;return It(t)?t:null}function Tt(e,t,r,a){var n=null,o=Jt(r)||Jt(Gt()),s=!0;return Array.isArray(t)?(t.forEach((function(t){var r=it.default(e,t,new Date,{locale:o});a&&(s=It(r)&&e===he.default(r,t,{awareOfUnicodeTokens:!0})),It(r)&&s&&(n=r)})),n):(n=it.default(e,t,new Date,{locale:o}),a?s=It(n)&&e===he.default(n,t,{awareOfUnicodeTokens:!0}):It(n)||(t=t.match(Yt).map((function(e){var t=e[0];return"p"===t||"P"===t?o?(0,Nt[t])(e,o.formatLong):t:e})).join(""),e.length>0&&(n=it.default(e,t.slice(0,e.length),new Date)),It(n)||(n=new Date(e))),It(n)&&s?n:null)}function It(e){return fe.default(e)&&at.default(e,new Date("1/1/1000"))}function Lt(e,t,r){if("en"===r)return he.default(e,t,{awareOfUnicodeTokens:!0});var a=Jt(r);return r&&!a&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!a&&Gt()&&Jt(Gt())&&(a=Jt(Gt())),he.default(e,t,{locale:a||null,awareOfUnicodeTokens:!0})}function Ft(e,t){var r=t.hour,a=void 0===r?0:r,n=t.minute,o=void 0===n?0:n,s=t.second,i=void 0===s?0:s;return Re.default(Fe.default(Le.default(e,i),o),a)}function Rt(e,t){var r=t&&Jt(t)||Gt()&&Jt(Gt());return Oe.default(e,r?{locale:r}:null)}function qt(e,t){return Lt(e,"ddd",t)}function At(e){return Ve.default(e)}function Wt(e,t){var r=Jt(t||Gt());return Ue.default(e,{locale:r})}function Bt(e){return $e.default(e)}function jt(e){return Ge.default(e)}function Ht(e){return ze.default(e)}function Kt(e,t){return e&&t?tt.default(e,t):!e&&!t}function Qt(e,t){return e&&t?et.default(e,t):!e&&!t}function Vt(e,t){return e&&t?rt.default(e,t):!e&&!t}function Ut(e,t){return e&&t?Ze.default(e,t):!e&&!t}function $t(e,t){return e&&t?Xe.default(e,t):!e&&!t}function zt(e,t,r){var a,n=Ve.default(t),o=Je.default(r);try{a=ot.default(e,{start:n,end:o})}catch(e){a=!1}return a}function Gt(){return("undefined"!=typeof window?window:__webpack_require__.g).__localeId__}function Jt(e){if("string"==typeof e){var t="undefined"!=typeof window?window:__webpack_require__.g;return t.__localeData__?t.__localeData__[e]:null}return e}function Xt(e,t){return Lt(qe.default(xt(),e),"LLLL",t)}function Zt(e,t){return Lt(qe.default(xt(),e),"LLL",t)}function er(e,t){return Lt(Ae.default(xt(),e),"QQQ",t)}function tr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return pr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Ut(e,t)}))||o&&!o.some((function(t){return Ut(e,t)}))||s&&!s(xt(e))||!1}function rr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates;return r&&r.some((function(t){return Ut(e,t)}))||!1}function ar(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return pr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Qt(e,t)}))||o&&!o.some((function(t){return Qt(e,t)}))||s&&!s(xt(e))||!1}function nr(e,t,r,a){var n=Te.default(e),o=Ye.default(e),s=Te.default(t),i=Ye.default(t),p=Te.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function or(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return pr(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Vt(e,t)}))||o&&!o.some((function(t){return Vt(e,t)}))||s&&!s(xt(e))||!1}function sr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=new Date(e,0,1);return pr(n,{minDate:r,maxDate:a})||!1}function ir(e,t,r,a){var n=Te.default(e),o=xe.default(e),s=Te.default(t),i=xe.default(t),p=Te.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function pr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate;return r&&He.default(e,r)<0||a&&He.default(e,a)>0}function lr(e,t){return t.some((function(t){return Pe.default(t)===Pe.default(e)&&Me.default(t)===Me.default(e)}))}function dr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,a=t.includeTimes,n=t.filterTime;return r&&lr(e,r)||a&&!lr(e,a)||n&&!n(e)||!1}function cr(e,t){var r=t.minTime,a=t.maxTime;if(!r||!a)throw new Error("Both minTime and maxTime props required");var n,o=xt(),s=Re.default(Fe.default(o,Me.default(e)),Pe.default(e)),i=Re.default(Fe.default(o,Me.default(r)),Pe.default(r)),p=Re.default(Fe.default(o,Me.default(a)),Pe.default(a));try{n=!ot.default(s,{start:i,end:p})}catch(e){n=!1}return n}function ur(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Ce.default(e,1);return r&&Ke.default(r,n)>0||a&&a.every((function(e){return Ke.default(e,n)>0}))||!1}function fr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=we.default(e,1);return r&&Ke.default(n,r)>0||a&&a.every((function(e){return Ke.default(n,e)>0}))||!1}function hr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Se.default(e,1);return r&&Qe.default(r,n)>0||a&&a.every((function(e){return Qe.default(e,n)>0}))||!1}function mr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=ke.default(e,1);return r&&Qe.default(n,r)>0||a&&a.every((function(e){return Qe.default(n,e)>0}))||!1}function yr(e){var t=e.minDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return He.default(e,t)>=0}));return Be.default(a)}return r?Be.default(r):t}function vr(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return He.default(e,t)<=0}));return je.default(a)}return r?je.default(r):t}function Dr(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,a=0,n=e.length;a<n;a++){var o=e[a];if(ue.default(o)){var s=Lt(o,"MM.dd.yyyy"),i=r.get(s)||[];i.includes(t)||(i.push(t),r.set(s,i))}else if("object"===ct(o)){var p=Object.keys(o),l=p[0],d=o[p[0]];if("string"==typeof l&&d.constructor===Array)for(var c=0,u=d.length;c<u;c++){var f=Lt(d[c],"MM.dd.yyyy"),h=r.get(f)||[];h.includes(l)||(h.push(l),r.set(f,h))}}}return r}function wr(e,t,r,a,n){for(var o=n.length,s=[],i=0;i<o;i++){var p=me.default(ye.default(e,Pe.default(n[i])),Me.default(n[i])),l=me.default(e,(r+1)*a);at.default(p,t)&&nt.default(p,l)&&s.push(n[i])}return s}function kr(e){return e<10?"0".concat(e):"".concat(e)}function gr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Ot,r=Math.ceil(Te.default(e)/t)*t,a=r-(t-1);return{startPeriod:a,endPeriod:r}}function br(e,t,r,a){for(var n=[],o=0;o<2*t+1;o++){var s=e+t-o,i=!0;r&&(i=Te.default(r)<=s),a&&i&&(i=Te.default(a)>=s),i&&n.push(s)}return n}var Cr=function(e){wt(r,e);var t=St(r);function r(e){var a;ut(this,r),mt(bt(a=t.call(this,e)),"renderOptions",(function(){var e=a.props.year,t=a.state.yearsList.map((function(t){return de.default.createElement("div",{className:e===t?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:t,onClick:a.onChange.bind(bt(a),t)},e===t?de.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)})),r=a.props.minDate?Te.default(a.props.minDate):null,n=a.props.maxDate?Te.default(a.props.maxDate):null;return n&&a.state.yearsList.find((function(e){return e===n}))||t.unshift(de.default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:a.incrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),r&&a.state.yearsList.find((function(e){return e===r}))||t.push(de.default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:a.decrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t})),mt(bt(a),"onChange",(function(e){a.props.onChange(e)})),mt(bt(a),"handleClickOutside",(function(){a.props.onCancel()})),mt(bt(a),"shiftYears",(function(e){var t=a.state.yearsList.map((function(t){return t+e}));a.setState({yearsList:t})})),mt(bt(a),"incrementYears",(function(){return a.shiftYears(1)})),mt(bt(a),"decrementYears",(function(){return a.shiftYears(-1)}));var n=e.yearDropdownItemNumber,o=e.scrollableYearDropdown,s=n||(o?10:5);return a.state={yearsList:br(a.props.year,s,a.props.minDate,a.props.maxDate)},a}return ht(r,[{key:"render",value:function(){var e=ce.default({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),r}(de.default.Component),Sr=lt.default(Cr),_r=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),mt(bt(e),"renderSelectOptions",(function(){for(var t=e.props.minDate?Te.default(e.props.minDate):1900,r=e.props.maxDate?Te.default(e.props.maxDate):2100,a=[],n=t;n<=r;n++)a.push(de.default.createElement("option",{key:n,value:n},n));return a})),mt(bt(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),mt(bt(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),mt(bt(e),"renderReadView",(function(t){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),mt(bt(e),"renderDropdown",(function(){return de.default.createElement(Sr,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),mt(bt(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),mt(bt(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t)})),mt(bt(e),"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t)}))})),mt(bt(e),"handleYearChange",(function(t,r){e.onSelect(t,r),e.setOpen()})),mt(bt(e),"onSelect",(function(t,r){e.props.onSelect&&e.props.onSelect(t,r)})),mt(bt(e),"setOpen",(function(){e.props.setOpen&&e.props.setOpen(!0)})),e}return ht(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Mr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"renderOptions",(function(){return e.props.monthNames.map((function(t,r){return de.default.createElement("div",{className:e.props.month===r?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:t,onClick:e.onChange.bind(bt(e),r)},e.props.month===r?de.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",t)}))})),mt(bt(e),"onChange",(function(t){return e.props.onChange(t)})),mt(bt(e),"handleClickOutside",(function(){return e.props.onCancel()})),e}return ht(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}(de.default.Component),Pr=lt.default(Mr),Er=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),mt(bt(e),"renderSelectOptions",(function(e){return e.map((function(e,t){return de.default.createElement("option",{key:t,value:t},e)}))})),mt(bt(e),"renderSelectMode",(function(t){return de.default.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(t))})),mt(bt(e),"renderReadView",(function(t,r){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},de.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[e.props.month]))})),mt(bt(e),"renderDropdown",(function(t){return de.default.createElement(Pr,{key:"dropdown",month:e.props.month,monthNames:t,onChange:e.onChange,onCancel:e.toggleDropdown})})),mt(bt(e),"renderScrollMode",(function(t){var r=e.state.dropdownVisible,a=[e.renderReadView(!r,t)];return r&&a.unshift(e.renderDropdown(t)),a})),mt(bt(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t)})),mt(bt(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return ht(r,[{key:"render",value:function(){var e,t=this,r=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Zt(e,t.props.locale)}:function(e){return Xt(e,t.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(r);break;case"select":e=this.renderSelectMode(r)}return de.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component);function Nr(e,t){for(var r=[],a=Bt(e),n=Bt(t);!at.default(a,n);)r.push(xt(a)),a=we.default(a,1);return r}var Or=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"renderOptions",(function(){return a.state.monthYearsList.map((function(e){var t=Ie.default(e),r=Kt(a.props.date,e)&&Qt(a.props.date,e);return de.default.createElement("div",{className:r?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:t,onClick:a.onChange.bind(bt(a),t)},r?de.default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Lt(e,a.props.dateFormat,a.props.locale))}))})),mt(bt(a),"onChange",(function(e){return a.props.onChange(e)})),mt(bt(a),"handleClickOutside",(function(){a.props.onCancel()})),a.state={monthYearsList:Nr(a.props.minDate,a.props.maxDate)},a}return ht(r,[{key:"render",value:function(){var e=ce.default({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),r}(de.default.Component),Yr=lt.default(Or),xr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:!1}),mt(bt(e),"renderSelectOptions",(function(){for(var t=Bt(e.props.minDate),r=Bt(e.props.maxDate),a=[];!at.default(t,r);){var n=Ie.default(t);a.push(de.default.createElement("option",{key:n,value:n},Lt(t,e.props.dateFormat,e.props.locale))),t=we.default(t,1)}return a})),mt(bt(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),mt(bt(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:Ie.default(Bt(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),mt(bt(e),"renderReadView",(function(t){var r=Lt(e.props.date,e.props.dateFormat,e.props.locale);return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))})),mt(bt(e),"renderDropdown",(function(){return de.default.createElement(Yr,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown,locale:e.props.locale})})),mt(bt(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),mt(bt(e),"onChange",(function(t){e.toggleDropdown();var r=xt(parseInt(t));Kt(e.props.date,r)&&Qt(e.props.date,r)||e.props.onChange(r)})),mt(bt(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return ht(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return de.default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Tr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"dayEl",de.default.createRef()),mt(bt(e),"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t)})),mt(bt(e),"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t)})),mt(bt(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),mt(bt(e),"isSameDay",(function(t){return Ut(e.props.day,t)})),mt(bt(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!e.isSameDay(e.props.selected)&&e.isSameDay(e.props.preSelection)})),mt(bt(e),"isDisabled",(function(){return tr(e.props.day,e.props)})),mt(bt(e),"isExcluded",(function(){return rr(e.props.day,e.props)})),mt(bt(e),"getHighLightedClass",(function(t){var r=e.props,a=r.day,n=r.highlightDates;if(!n)return!1;var o=Lt(a,"MM.dd.yyyy");return n.get(o)})),mt(bt(e),"isInRange",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&zt(r,a,n)})),mt(bt(e),"isInSelectingRange",(function(){var t=e.props,r=t.day,a=t.selectsStart,n=t.selectsEnd,o=t.selectsRange,s=t.selectingDate,i=t.startDate,p=t.endDate;return!(!(a||n||o)||!s||e.isDisabled())&&(a&&p&&(nt.default(s,p)||$t(s,p))?zt(r,s,p):(n&&i&&(at.default(s,i)||$t(s,i))||!(!o||!i||p||!at.default(s,i)&&!$t(s,i)))&&zt(r,i,s))})),mt(bt(e),"isSelectingRangeStart",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,a=t.selectingDate,n=t.startDate;return Ut(r,t.selectsStart?a:n)})),mt(bt(e),"isSelectingRangeEnd",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,a=t.selectingDate,n=t.endDate;return Ut(r,t.selectsEnd?a:n)})),mt(bt(e),"isRangeStart",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Ut(a,r)})),mt(bt(e),"isRangeEnd",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return!(!a||!n)&&Ut(n,r)})),mt(bt(e),"isWeekend",(function(){var t=Ee.default(e.props.day);return 0===t||6===t})),mt(bt(e),"isOutsideMonth",(function(){return void 0!==e.props.month&&e.props.month!==Ye.default(e.props.day)})),mt(bt(e),"getClassNames",(function(t){var r=e.props.dayClassName?e.props.dayClassName(t):void 0;return ce.default("react-datepicker__day",r,"react-datepicker__day--"+qt(e.props.day),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSameDay(e.props.selected),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isSameDay(xt()),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isOutsideMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"))})),mt(bt(e),"getAriaLabel",(function(){var t=e.props,r=t.day,a=t.ariaLabelPrefixWhenEnabled,n=void 0===a?"Choose":a,o=t.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,i=e.isDisabled()||e.isExcluded()?s:n;return"".concat(i," ").concat(Lt(r,"PPPP"))})),mt(bt(e),"getTabIndex",(function(t,r){var a=t||e.props.selected,n=r||e.props.preSelection;return e.isKeyboardSelected()||e.isSameDay(a)&&Ut(n,a)?0:-1})),mt(bt(e),"handleFocusDay",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===e.getTabIndex()&&!t.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),e.props.inline&&!e.props.shouldFocusDayInline&&(r=!1),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(r=!0)),r&&e.dayEl.current.focus({preventScroll:!0})})),mt(bt(e),"renderDayContents",(function(){if(e.isOutsideMonth()){if(e.props.monthShowsDuplicateDaysEnd&&Ne.default(e.props.day)<10)return null;if(e.props.monthShowsDuplicateDaysStart&&Ne.default(e.props.day)>20)return null}return e.props.renderDayContents?e.props.renderDayContents(Ne.default(e.props.day),e.props.day):Ne.default(e.props.day)})),mt(bt(e),"render",(function(){return de.default.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.handleMouseEnter,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"button","aria-disabled":e.isDisabled()},e.renderDayContents())})),e}return ht(r,[{key:"componentDidMount",value:function(){this.handleFocusDay()}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e)}}]),r}(de.default.Component),Ir=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t)})),e}return ht(r,[{key:"render",value:function(){var e=this.props,t=e.weekNumber,r=e.ariaLabelPrefix,a=void 0===r?"week ":r,n={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!e.onClick};return de.default.createElement("div",{className:ce.default(n),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick},t)}}]),r}(de.default.Component),Lr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r)})),mt(bt(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),mt(bt(e),"handleWeekClick",(function(t,r,a){"function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,r,a),e.props.shouldCloseOnSelect&&e.props.setOpen(!1)})),mt(bt(e),"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):Rt(t)})),mt(bt(e),"renderDays",(function(){var t=Wt(e.props.day,e.props.locale),r=[],a=e.formatWeekNumber(t);if(e.props.showWeekNumber){var n=e.props.onWeekSelect?e.handleWeekClick.bind(bt(e),t,a):void 0;r.push(de.default.createElement(Ir,{key:"W",weekNumber:a,onClick:n,ariaLabelPrefix:e.props.ariaLabelPrefix}))}return r.concat([0,1,2,3,4,5,6].map((function(r){var a=ve.default(t,r);return de.default.createElement(Tr,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:a.valueOf(),day:a,month:e.props.month,onClick:e.handleDayClick.bind(bt(e),a),onMouseEnter:e.handleDayMouseEnter.bind(bt(e),a),minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})})))})),e}return ht(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),r}(de.default.Component),Fr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"MONTH_REFS",_t(Array(12)).map((function(){return de.default.createRef()}))),mt(bt(e),"isDisabled",(function(t){return tr(t,e.props)})),mt(bt(e),"isExcluded",(function(t){return rr(t,e.props)})),mt(bt(e),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r,e.props.orderInDisplay)})),mt(bt(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),mt(bt(e),"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave()})),mt(bt(e),"isRangeStartMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Qt(qe.default(a,t),n)})),mt(bt(e),"isRangeStartQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Vt(Ae.default(a,t),n)})),mt(bt(e),"isRangeEndMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Qt(qe.default(a,t),o)})),mt(bt(e),"isRangeEndQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return!(!n||!o)&&Vt(Ae.default(a,t),o)})),mt(bt(e),"isWeekInMonth",(function(t){var r=e.props.day,a=ve.default(t,6);return Qt(t,r)||Qt(a,r)})),mt(bt(e),"renderWeeks",(function(){for(var t=[],r=e.props.fixedHeight,a=Wt(Bt(e.props.day),e.props.locale),n=0,o=!1;t.push(de.default.createElement(Lr,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:n,day:a,month:Ye.default(e.props.day),onDayClick:e.handleDayClick,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,showWeekNumber:e.props.showWeekNumbers,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})),!o;){n++,a=De.default(a,1);var s=r&&n>=6,i=!r&&!e.isWeekInMonth(a);if(s||i){if(!e.props.peekNextMonth)break;o=!0}}return t})),mt(bt(e),"onMonthClick",(function(t,r){e.handleDayClick(Bt(qe.default(e.props.day,r)),t)})),mt(bt(e),"handleMonthNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.MONTH_REFS[t].current&&e.MONTH_REFS[t].current.focus())})),mt(bt(e),"onMonthKeyDown",(function(t,r){var a=t.key;if(!e.props.disabledKeyboardNavigation)switch(a){case"Enter":e.onMonthClick(t,r),e.props.setPreSelection(e.props.selected);break;case"ArrowRight":e.handleMonthNavigation(11===r?0:r+1,we.default(e.props.preSelection,1));break;case"ArrowLeft":e.handleMonthNavigation(0===r?11:r-1,Ce.default(e.props.preSelection,1))}})),mt(bt(e),"onQuarterClick",(function(t,r){e.handleDayClick(Ht(Ae.default(e.props.day,r)),t)})),mt(bt(e),"getMonthClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,l=r.preSelection,d=r.monthClassName,c=d?d(a):void 0;return ce.default("react-datepicker__month-text","react-datepicker__month-".concat(t),c,{"react-datepicker__month--disabled":(i||p)&&ar(qe.default(a,t),e.props),"react-datepicker__month--selected":Ye.default(a)===t&&Te.default(a)===Te.default(s),"react-datepicker__month-text--keyboard-selected":Ye.default(l)===t,"react-datepicker__month--in-range":nr(n,o,t,a),"react-datepicker__month--range-start":e.isRangeStartMonth(t),"react-datepicker__month--range-end":e.isRangeEndMonth(t)})})),mt(bt(e),"getTabIndex",(function(t){var r=Ye.default(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),mt(bt(e),"getAriaLabel",(function(t){var r=e.props,a=r.ariaLabelPrefix,n=void 0===a?"Choose":a,o=r.disabledDayAriaLabelPrefix,s=void 0===o?"Not available":o,i=r.day,p=qe.default(i,t),l=e.isDisabled(p)||e.isExcluded(p)?s:n;return"".concat(l," ").concat(Lt(p,"MMMM yyyy"))})),mt(bt(e),"getQuarterClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate;return ce.default("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter--disabled":(i||p)&&or(Ae.default(a,t),e.props),"react-datepicker__quarter--selected":xe.default(a)===t&&Te.default(a)===Te.default(s),"react-datepicker__quarter--in-range":ir(n,o,t,a),"react-datepicker__quarter--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter--range-end":e.isRangeEndQuarter(t)})})),mt(bt(e),"renderMonths",(function(){var t=e.props,r=t.showFullMonthYearPicker,a=t.showTwoColumnMonthYearPicker,n=t.showFourColumnMonthYearPicker,o=t.locale;return(n?[[0,1,2,3],[4,5,6,7],[8,9,10,11]]:a?[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]]:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]]).map((function(t,a){return de.default.createElement("div",{className:"react-datepicker__month-wrapper",key:a},t.map((function(t,a){return de.default.createElement("div",{ref:e.MONTH_REFS[t],key:a,onClick:function(r){e.onMonthClick(r,t)},onKeyDown:function(r){e.onMonthKeyDown(r,t)},tabIndex:e.getTabIndex(t),className:e.getMonthClassNames(t),role:"button","aria-label":e.getAriaLabel(t)},r?Xt(t,o):Zt(t,o))})))}))})),mt(bt(e),"renderQuarters",(function(){return de.default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(t,r){return de.default.createElement("div",{key:r,onClick:function(r){e.onQuarterClick(r,t)},className:e.getQuarterClassNames(t)},er(t,e.props.locale))})))})),mt(bt(e),"getClassNames",(function(){var t=e.props;t.day;var r=t.selectingDate,a=t.selectsStart,n=t.selectsEnd,o=t.showMonthYearPicker,s=t.showQuarterYearPicker;return ce.default("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(a||n)},{"react-datepicker__monthPicker":o},{"react-datepicker__quarterPicker":s})})),e}return ht(r,[{key:"render",value:function(){var e=this.props,t=e.showMonthYearPicker,r=e.showQuarterYearPicker,a=e.day,n=e.ariaLabelPrefix,o=void 0===n?"month ":n;return de.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(o," ").concat(Lt(a,"yyyy-MM"))},t?this.renderMonths():r?this.renderQuarters():this.renderWeeks())}}]),r}(de.default.Component),Rr=function(e){wt(r,e);var t=St(r);function r(){var e;ut(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return mt(bt(e=t.call.apply(t,[this].concat(n))),"state",{height:null}),mt(bt(e),"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&cr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&dr(t,e.props)||e.props.onChange(t)})),mt(bt(e),"liClasses",(function(t,r,a){var n=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t,r,a):void 0];return e.props.selected&&r===Pe.default(t)&&a===Me.default(t)&&n.push("react-datepicker__time-list-item--selected"),((e.props.minTime||e.props.maxTime)&&cr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&dr(t,e.props))&&n.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(60*Pe.default(t)+Me.default(t))%e.props.intervals!=0&&n.push("react-datepicker__time-list-item--injected"),n.join(" ")})),mt(bt(e),"renderTimes",(function(){for(var t=[],r=e.props.format?e.props.format:"p",a=e.props.intervals,n=At(xt(e.props.selected)),o=1440/a,s=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),i=e.props.selected||e.props.openToDate||xt(),p=Pe.default(i),l=Me.default(i),d=Re.default(Fe.default(n,l),p),c=0;c<o;c++){var u=me.default(n,c*a);if(t.push(u),s){var f=wr(n,u,c,a,s);t=t.concat(f)}}return t.map((function(t,a){return de.default.createElement("li",{key:a,onClick:e.handleClick.bind(bt(e),t),className:e.liClasses(t,p,l),ref:function(r){(nt.default(t,d)||$t(t,d))&&(e.centerLi=r)},tabIndex:"0"},Lt(t,r,e.props.locale))}))})),e}return ht(r,[{key:"componentDidMount",value:function(){this.list.scrollTop=r.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,t=this.state.height;return de.default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(t){e.header=t}},de.default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),de.default.createElement("div",{className:"react-datepicker__time"},de.default.createElement("div",{className:"react-datepicker__time-box"},de.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:t?{height:t}:{},tabIndex:"0"},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}(de.default.Component);mt(Rr,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var qr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"handleYearClick",(function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t)})),mt(bt(a),"isSameDay",(function(e,t){return Ut(e,t)})),mt(bt(a),"isKeyboardSelected",(function(e){var t=jt(We.default(a.props.date,e));return!a.props.disabledKeyboardNavigation&&!a.props.inline&&!Ut(t,jt(a.props.selected))&&Ut(t,jt(a.props.preSelection))})),mt(bt(a),"onYearClick",(function(e,t){var r=a.props.date;a.handleYearClick(jt(We.default(r,t)),e)})),mt(bt(a),"getYearClassNames",(function(e){var t=a.props,r=t.minDate,n=t.maxDate,o=t.selected;return ce.default("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===Te.default(o),"react-datepicker__year-text--disabled":(r||n)&&sr(e,a.props),"react-datepicker__year-text--keyboard-selected":a.isKeyboardSelected(e),"react-datepicker__year-text--today":e===Te.default(xt())})})),a}return ht(r,[{key:"render",value:function(){for(var e=this,t=[],r=this.props,a=gr(r.date,r.yearItemNumber),n=a.startPeriod,o=a.endPeriod,s=function(r){t.push(de.default.createElement("div",{onClick:function(t){e.onYearClick(t,r)},className:e.getYearClassNames(r),key:r},r))},i=n;i<=o;i++)s(i);return de.default.createElement("div",{className:"react-datepicker__year"},de.default.createElement("div",{className:"react-datepicker__year-wrapper"},t))}}]),r}(de.default.Component),Ar=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"onTimeChange",(function(e){a.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),a.props.onChange(t)})),mt(bt(a),"renderTimeInput",(function(){var e=a.state.time,t=a.props,r=t.date,n=t.timeString,o=t.customTimeInput;return o?de.default.cloneElement(o,{date:r,value:e,onChange:a.onTimeChange}):de.default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){a.onTimeChange(e.target.value||n)}})})),a.state={time:a.props.timeString},a}return ht(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__input-time-container"},de.default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),de.default.createElement("div",{className:"react-datepicker-time__input-container"},de.default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),r}(de.default.Component);function Wr(e){var t=e.className,r=e.children,a=e.showPopperArrow,n=e.arrowProps,o=void 0===n?{}:n;return de.default.createElement("div",{className:t},a&&de.default.createElement("div",yt({className:"react-datepicker__triangle"},o)),r)}var Br=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],jr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"handleClickOutside",(function(e){a.props.onClickOutside(e)})),mt(bt(a),"setClickOutsideRef",(function(){return a.containerRef.current})),mt(bt(a),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return Br.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&a.props.onDropdownFocus()})),mt(bt(a),"getDateInView",(function(){var e=a.props,t=e.preSelection,r=e.selected,n=e.openToDate,o=yr(a.props),s=vr(a.props),i=xt(),p=n||r||t;return p||(o&&nt.default(i,o)?o:s&&at.default(i,s)?s:i)})),mt(bt(a),"increaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:we.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),mt(bt(a),"decreaseMonth",(function(){a.setState((function(e){var t=e.date;return{date:Ce.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}))})),mt(bt(a),"handleDayClick",(function(e,t,r){a.props.onSelect(e,t,r),a.props.setPreSelection&&a.props.setPreSelection(e)})),mt(bt(a),"handleDayMouseEnter",(function(e){a.setState({selectingDate:e}),a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e)})),mt(bt(a),"handleMonthMouseLeave",(function(){a.setState({selectingDate:null}),a.props.onMonthMouseLeave&&a.props.onMonthMouseLeave()})),mt(bt(a),"handleYearChange",(function(e){a.props.onYearChange&&a.props.onYearChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),mt(bt(a),"handleMonthChange",(function(e){a.props.onMonthChange&&a.props.onMonthChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e)})),mt(bt(a),"handleMonthYearChange",(function(e){a.handleYearChange(e),a.handleMonthChange(e)})),mt(bt(a),"changeYear",(function(e){a.setState((function(t){var r=t.date;return{date:We.default(r,e)}}),(function(){return a.handleYearChange(a.state.date)}))})),mt(bt(a),"changeMonth",(function(e){a.setState((function(t){var r=t.date;return{date:qe.default(r,e)}}),(function(){return a.handleMonthChange(a.state.date)}))})),mt(bt(a),"changeMonthYear",(function(e){a.setState((function(t){var r=t.date;return{date:We.default(qe.default(r,Ye.default(e)),Te.default(e))}}),(function(){return a.handleMonthYearChange(a.state.date)}))})),mt(bt(a),"header",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=Wt(e,a.props.locale),r=[];return a.props.showWeekNumbers&&r.push(de.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},a.props.weekLabel||"#")),r.concat([0,1,2,3,4,5,6].map((function(e){var r=ve.default(t,e),n=a.formatWeekday(r,a.props.locale),o=a.props.weekDayClassName?a.props.weekDayClassName(r):void 0;return de.default.createElement("div",{key:e,className:ce.default("react-datepicker__day-name",o)},n)})))})),mt(bt(a),"formatWeekday",(function(e,t){return a.props.formatWeekDay?function(e,t,r){return t(Lt(e,"EEEE",r))}(e,a.props.formatWeekDay,t):a.props.useWeekdaysShort?function(e,t){return Lt(e,"EEE",t)}(e,t):function(e,t){return Lt(e,"EEEEEE",t)}(e,t)})),mt(bt(a),"decreaseYear",(function(){a.setState((function(e){var t=e.date;return{date:Se.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),mt(bt(a),"renderPreviousButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=hr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.yearItemNumber,n=void 0===a?Ot:a,o=gr(jt(Se.default(e,n)),n).endPeriod,s=r&&Te.default(r);return s&&s>o||!1}(a.state.date,a.props);break;default:e=ur(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--previous"],r=a.decreaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.decreaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--previous--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.previousMonthAriaLabel,i=void 0===s?"Previous Month":s,p=o.previousYearAriaLabel,l=void 0===p?"Previous Year":p;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,"aria-label":n?l:i},n?a.props.previousYearButtonLabel:a.props.previousMonthButtonLabel)}}})),mt(bt(a),"increaseYear",(function(){a.setState((function(e){var t=e.date;return{date:ke.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}))})),mt(bt(a),"renderNextButton",(function(){if(!a.props.renderCustomHeader){var e;switch(!0){case a.props.showMonthYearPicker:e=mr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.yearItemNumber,n=void 0===a?Ot:a,o=gr(ke.default(e,n),n).startPeriod,s=r&&Te.default(r);return s&&s<o||!1}(a.state.date,a.props);break;default:e=fr(a.state.date,a.props)}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--next"];a.props.showTimeSelect&&t.push("react-datepicker__navigation--next--with-time"),a.props.todayButton&&t.push("react-datepicker__navigation--next--with-today-button");var r=a.increaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.increaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--next--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.nextMonthAriaLabel,i=void 0===s?"Next Month":s,p=o.nextYearAriaLabel,l=void 0===p?"Next Year":p;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,"aria-label":n?l:i},n?a.props.nextYearButtonLabel:a.props.nextMonthButtonLabel)}}})),mt(bt(a),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=["react-datepicker__current-month"];return a.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),a.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),a.props.showMonthYearDropdown&&t.push("react-datepicker__current-month--hasMonthYearDropdown"),de.default.createElement("div",{className:t.join(" ")},Lt(e,a.props.dateFormat,a.props.locale))})),mt(bt(a),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showYearDropdown&&!e)return de.default.createElement(_r,{adjustDateOnChange:a.props.adjustDateOnChange,date:a.state.date,onSelect:a.props.onSelect,setOpen:a.props.setOpen,dropdownMode:a.props.dropdownMode,onChange:a.changeYear,minDate:a.props.minDate,maxDate:a.props.maxDate,year:Te.default(a.state.date),scrollableYearDropdown:a.props.scrollableYearDropdown,yearDropdownItemNumber:a.props.yearDropdownItemNumber})})),mt(bt(a),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthDropdown&&!e)return de.default.createElement(Er,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,onChange:a.changeMonth,month:Ye.default(a.state.date),useShortMonthInDropdown:a.props.useShortMonthInDropdown})})),mt(bt(a),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthYearDropdown&&!e)return de.default.createElement(xr,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,dateFormat:a.props.dateFormat,onChange:a.changeMonthYear,minDate:a.props.minDate,maxDate:a.props.maxDate,date:a.state.date,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown})})),mt(bt(a),"renderTodayButton",(function(){if(a.props.todayButton&&!a.props.showTimeSelectOnly)return de.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return a.props.onSelect(Ve.default(xt()),e)}},a.props.todayButton)})),mt(bt(a),"renderDefaultHeader",(function(e){var t=e.monthDate,r=e.i;return de.default.createElement("div",{className:"react-datepicker__header ".concat(a.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},a.renderCurrentMonth(t),de.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),onFocus:a.handleDropdownFocus},a.renderMonthDropdown(0!==r),a.renderMonthYearDropdown(0!==r),a.renderYearDropdown(0!==r)),de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),mt(bt(a),"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.monthDate,r=e.i;if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return null;var n=ur(a.state.date,a.props),o=fr(a.state.date,a.props),s=hr(a.state.date,a.props),i=mr(a.state.date,a.props),p=!a.props.showMonthYearPicker&&!a.props.showQuarterYearPicker&&!a.props.showYearPicker;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:a.props.onDropdownFocus},a.props.renderCustomHeader(Dt(Dt({},a.state),{},{customHeaderCount:r,changeMonth:a.changeMonth,changeYear:a.changeYear,decreaseMonth:a.decreaseMonth,increaseMonth:a.increaseMonth,decreaseYear:a.decreaseYear,increaseYear:a.increaseYear,prevMonthButtonDisabled:n,nextMonthButtonDisabled:o,prevYearButtonDisabled:s,nextYearButtonDisabled:i})),p&&de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),mt(bt(a),"renderYearHeader",(function(){var e=a.state.date,t=a.props,r=t.showYearPicker,n=gr(e,t.yearItemNumber),o=n.startPeriod,s=n.endPeriod;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},r?"".concat(o," - ").concat(s):Te.default(e))})),mt(bt(a),"renderHeader",(function(e){switch(!0){case void 0!==a.props.renderCustomHeader:return a.renderCustomHeader(e);case a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker:return a.renderYearHeader(e);default:return a.renderDefaultHeader(e)}})),mt(bt(a),"renderMonths",(function(){if(!a.props.showTimeSelectOnly&&!a.props.showYearPicker){for(var e=[],t=a.props.showPreviousMonths?a.props.monthsShown-1:0,r=Ce.default(a.state.date,t),n=0;n<a.props.monthsShown;++n){var o=n-a.props.monthSelectedIn,s=we.default(r,o),i="month-".concat(n),p=n<a.props.monthsShown-1,l=n>0;e.push(de.default.createElement("div",{key:i,ref:function(e){a.monthContainer=e},className:"react-datepicker__month-container"},a.renderHeader({monthDate:s,i:n}),de.default.createElement(Fr,{chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,onChange:a.changeMonthYear,day:s,dayClassName:a.props.dayClassName,monthClassName:a.props.monthClassName,onDayClick:a.handleDayClick,handleOnKeyDown:a.props.handleOnKeyDown,onDayMouseEnter:a.handleDayMouseEnter,onMouseLeave:a.handleMonthMouseLeave,onWeekSelect:a.props.onWeekSelect,orderInDisplay:n,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,highlightDates:a.props.highlightDates,selectingDate:a.state.selectingDate,includeDates:a.props.includeDates,inline:a.props.inline,shouldFocusDayInline:a.props.shouldFocusDayInline,fixedHeight:a.props.fixedHeight,filterDate:a.props.filterDate,preSelection:a.props.preSelection,setPreSelection:a.props.setPreSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,showWeekNumbers:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,peekNextMonth:a.props.peekNextMonth,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,renderDayContents:a.props.renderDayContents,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,isInputFocused:a.props.isInputFocused,containerRef:a.containerRef,monthShowsDuplicateDaysEnd:p,monthShowsDuplicateDaysStart:l})))}return e}})),mt(bt(a),"renderYears",(function(){if(!a.props.showTimeSelectOnly)return a.props.showYearPicker?de.default.createElement("div",{className:"react-datepicker__year--container"},a.renderHeader(),de.default.createElement(qr,yt({onDayClick:a.handleDayClick,date:a.state.date},a.props))):void 0})),mt(bt(a),"renderTimeSection",(function(){if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return de.default.createElement(Rr,{selected:a.props.selected,openToDate:a.props.openToDate,onChange:a.props.onTimeChange,timeClassName:a.props.timeClassName,format:a.props.timeFormat,includeTimes:a.props.includeTimes,intervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,todayButton:a.props.todayButton,showMonthDropdown:a.props.showMonthDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,monthRef:a.state.monthContainer,injectTimes:a.props.injectTimes,locale:a.props.locale,showTimeSelectOnly:a.props.showTimeSelectOnly})})),mt(bt(a),"renderInputTimeSection",(function(){var e=new Date(a.props.selected),t=It(e)&&Boolean(a.props.selected)?"".concat(kr(e.getHours()),":").concat(kr(e.getMinutes())):"";if(a.props.showTimeInput)return de.default.createElement(Ar,{date:e,timeString:t,timeInputLabel:a.props.timeInputLabel,onChange:a.props.onTimeChange,customTimeInput:a.props.customTimeInput})})),a.containerRef=de.default.createRef(),a.state={date:a.getDateInView(),selectingDate:null,monthContainer:null},a}return ht(r,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!Ut(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!Ut(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate})}},{key:"render",value:function(){var e=this.props.container||Wr;return de.default.createElement("div",{ref:this.containerRef},de.default.createElement(e,{className:ce.default("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}],[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:Ot}}}]),r}(de.default.Component),Hr=function(e){return!e.disabled&&-1!==e.tabIndex},Kr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"getTabChildren",(function(){return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(Hr)})),mt(bt(a),"handleFocusStart",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[t.length-1].focus()})),mt(bt(a),"handleFocusEnd",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[0].focus()})),a.tabLoopRef=de.default.createRef(),a}return ht(r,[{key:"render",value:function(){return this.props.enableTabLoop?de.default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},de.default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,de.default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}]),r}(de.default.Component),Qr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),(a=t.call(this,e)).el=document.createElement("div"),a}return ht(r,[{key:"componentDidMount",value:function(){this.portalRoot=document.getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),document.body.appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el)}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el)}},{key:"render",value:function(){return dt.default.createPortal(this.props.children,this.el)}}]),r}(de.default.Component),Vr=function(e){wt(r,e);var t=St(r);function r(){return ut(this,r),t.apply(this,arguments)}return ht(r,[{key:"render",value:function(){var e,t=this.props,r=t.className,a=t.wrapperClassName,n=t.hidePopper,o=t.popperComponent,s=t.popperModifiers,i=t.popperPlacement,p=t.popperProps,l=t.targetComponent,d=t.enableTabLoop,c=t.popperOnKeyDown,u=t.portalId;if(!n){var f=ce.default("react-datepicker-popper",r);e=de.default.createElement(ie.Popper,yt({modifiers:s,placement:i},p),(function(e){var t=e.ref,r=e.style,a=e.placement,n=e.arrowProps;return de.default.createElement(Kr,{enableTabLoop:d},de.default.createElement("div",{ref:t,style:r,className:f,"data-placement":a,onKeyDown:c},de.default.cloneElement(o,{arrowProps:n})))}))}this.props.popperContainer&&(e=de.default.createElement(this.props.popperContainer,{},e)),u&&!n&&(e=de.default.createElement(Qr,{portalId:u},e));var h=ce.default("react-datepicker-wrapper",a);return de.default.createElement(ie.Manager,{className:"react-datepicker-manager"},de.default.createElement(ie.Reference,null,(function(e){var t=e.ref;return de.default.createElement("div",{ref:t,className:h},l)})),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),r}(de.default.Component),Ur="react-datepicker-ignore-onclickoutside",$r=lt.default(jr);var zr="Date input not valid.",Gr=function(e){wt(r,e);var t=St(r);function r(e){var a;return ut(this,r),mt(bt(a=t.call(this,e)),"getPreSelection",(function(){return a.props.openToDate?a.props.openToDate:a.props.selectsEnd&&a.props.startDate?a.props.startDate:a.props.selectsStart&&a.props.endDate?a.props.endDate:xt()})),mt(bt(a),"calcInitialState",(function(){var e=a.getPreSelection(),t=yr(a.props),r=vr(a.props),n=t&&nt.default(e,t)?t:r&&at.default(e,r)?r:e;return{open:a.props.startOpen||!1,preventFocus:!1,preSelection:a.props.selected?a.props.selected:n,highlightDates:Dr(a.props.highlightDates),focused:!1,shouldFocusDayInline:!1}})),mt(bt(a),"clearPreventFocusTimeout",(function(){a.preventFocusTimeout&&clearTimeout(a.preventFocusTimeout)})),mt(bt(a),"setFocus",(function(){a.input&&a.input.focus&&a.input.focus({preventScroll:!0})})),mt(bt(a),"setBlur",(function(){a.input&&a.input.blur&&a.input.blur(),a.cancelFocusInput()})),mt(bt(a),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];a.setState({open:e,preSelection:e&&a.state.open?a.state.preSelection:a.calcInitialState().preSelection,lastPreSelectChange:Xr},(function(){e||a.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&a.setBlur(),a.setState({inputValue:null})}))}))})),mt(bt(a),"inputOk",(function(){return ue.default(a.state.preSelection)})),mt(bt(a),"isCalendarOpen",(function(){return void 0===a.props.open?a.state.open&&!a.props.disabled&&!a.props.readOnly:a.props.open})),mt(bt(a),"handleFocus",(function(e){a.state.preventFocus||(a.props.onFocus(e),a.props.preventOpenOnFocus||a.props.readOnly||a.setOpen(!0)),a.setState({focused:!0})})),mt(bt(a),"cancelFocusInput",(function(){clearTimeout(a.inputFocusTimeout),a.inputFocusTimeout=null})),mt(bt(a),"deferFocusInput",(function(){a.cancelFocusInput(),a.inputFocusTimeout=setTimeout((function(){return a.setFocus()}),1)})),mt(bt(a),"handleDropdownFocus",(function(){a.cancelFocusInput()})),mt(bt(a),"handleBlur",(function(e){(!a.state.open||a.props.withPortal||a.props.showTimeInput)&&a.props.onBlur(e),a.setState({focused:!1})})),mt(bt(a),"handleCalendarClickOutside",(function(e){a.props.inline||a.setOpen(!1),a.props.onClickOutside(e),a.props.withPortal&&e.preventDefault()})),mt(bt(a),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!a.props.onChangeRaw||(a.props.onChangeRaw.apply(bt(a),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){a.setState({inputValue:n.target.value,lastPreSelectChange:Jr});var o=Tt(n.target.value,a.props.dateFormat,a.props.locale,a.props.strictParsing);!o&&n.target.value||a.setSelected(o,n,!0)}})),mt(bt(a),"handleSelect",(function(e,t,r){a.setState({preventFocus:!0},(function(){return a.preventFocusTimeout=setTimeout((function(){return a.setState({preventFocus:!1})}),50),a.preventFocusTimeout})),a.props.onChangeRaw&&a.props.onChangeRaw(t),a.setSelected(e,t,!1,r),!a.props.shouldCloseOnSelect||a.props.showTimeSelect?a.setPreSelection(e):a.props.inline||a.setOpen(!1)})),mt(bt(a),"setSelected",(function(e,t,r,n){var o=e;if(null===o||!tr(o,a.props)){var s=a.props,i=s.onChange,p=s.selectsRange,l=s.startDate,d=s.endDate;if(!$t(a.props.selected,o)||a.props.allowSameDay||p)if(null!==o&&(!a.props.selected||r&&(a.props.showTimeSelect||a.props.showTimeSelectOnly||a.props.showTimeInput)||(o=Ft(o,{hour:Pe.default(a.props.selected),minute:Me.default(a.props.selected),second:_e.default(a.props.selected)})),a.props.inline||a.setState({preSelection:o}),a.props.focusSelectedMonth||a.setState({monthSelectedIn:n})),p){var c=l&&!d,u=l&&d;!l&&!d?i([o,null],t):c&&(nt.default(o,l)?i([o,null],t):i([l,o],t)),u&&i([o,null],t)}else i(o,t);r||(a.props.onSelect(o,t),a.setState({inputValue:null}))}})),mt(bt(a),"setPreSelection",(function(e){var t=void 0!==a.props.minDate,r=void 0!==a.props.maxDate,n=!0;e&&(t&&r?n=zt(e,a.props.minDate,a.props.maxDate):t?n=at.default(e,a.props.minDate):r&&(n=nt.default(e,a.props.maxDate))),n&&a.setState({preSelection:e})})),mt(bt(a),"handleTimeChange",(function(e){var t=Ft(a.props.selected?a.props.selected:a.getPreSelection(),{hour:Pe.default(e),minute:Me.default(e)});a.setState({preSelection:t}),a.props.onChange(t),a.props.shouldCloseOnSelect&&a.setOpen(!1),a.props.showTimeInput&&a.setOpen(!0),a.setState({inputValue:null})})),mt(bt(a),"onInputClick",(function(){a.props.disabled||a.props.readOnly||a.setOpen(!0),a.props.onInputClick()})),mt(bt(a),"onInputKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key;if(a.state.open||a.props.inline||a.props.preventOpenOnFocus){if(a.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=a.calendar.componentNode&&a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus({preventScroll:!0}))}var n=xt(a.state.preSelection);"Enter"===t?(e.preventDefault(),a.inputOk()&&a.state.lastPreSelectChange===Xr?(a.handleSelect(n,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(n)):a.setOpen(!1)):"Escape"===t&&(e.preventDefault(),a.setOpen(!1)),a.inputOk()||a.props.onInputError({code:1,msg:zr})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||a.onInputClick()})),mt(bt(a),"onDayKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key,r=xt(a.state.preSelection);if("Enter"===t)e.preventDefault(),a.handleSelect(r,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(r);else if("Escape"===t)e.preventDefault(),a.setOpen(!1),a.inputOk()||a.props.onInputError({code:1,msg:zr});else if(!a.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=ge.default(r,1);break;case"ArrowRight":n=ve.default(r,1);break;case"ArrowUp":n=be.default(r,1);break;case"ArrowDown":n=De.default(r,1);break;case"PageUp":n=Ce.default(r,1);break;case"PageDown":n=we.default(r,1);break;case"Home":n=Se.default(r,1);break;case"End":n=ke.default(r,1)}if(!n)return void(a.props.onInputError&&a.props.onInputError({code:1,msg:zr}));if(e.preventDefault(),a.setState({lastPreSelectChange:Xr}),a.props.adjustDateOnChange&&a.setSelected(n),a.setPreSelection(n),a.props.inline){var o=Ye.default(r),s=Ye.default(n),i=Te.default(r),p=Te.default(n);o!==s||i!==p?a.setState({shouldFocusDayInline:!0}):a.setState({shouldFocusDayInline:!1})}}})),mt(bt(a),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),a.setState({preventFocus:!0},(function(){a.setOpen(!1),setTimeout((function(){a.setFocus(),a.setState({preventFocus:!1})}))})))})),mt(bt(a),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),a.props.onChange(null,e),a.setState({inputValue:null})})),mt(bt(a),"clear",(function(){a.onClearClick()})),mt(bt(a),"onScroll",(function(e){"boolean"==typeof a.props.closeOnScroll&&a.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||a.setOpen(!1):"function"==typeof a.props.closeOnScroll&&a.props.closeOnScroll(e)&&a.setOpen(!1)})),mt(bt(a),"renderCalendar",(function(){return a.props.inline||a.isCalendarOpen()?de.default.createElement($r,{ref:function(e){a.calendar=e},locale:a.props.locale,chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,adjustDateOnChange:a.props.adjustDateOnChange,setOpen:a.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,dateFormat:a.props.dateFormatCalendar,useWeekdaysShort:a.props.useWeekdaysShort,formatWeekDay:a.props.formatWeekDay,dropdownMode:a.props.dropdownMode,selected:a.props.selected,preSelection:a.state.preSelection,onSelect:a.handleSelect,onWeekSelect:a.props.onWeekSelect,openToDate:a.props.openToDate,minDate:a.props.minDate,maxDate:a.props.maxDate,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,startDate:a.props.startDate,endDate:a.props.endDate,excludeDates:a.props.excludeDates,filterDate:a.props.filterDate,onClickOutside:a.handleCalendarClickOutside,formatWeekNumber:a.props.formatWeekNumber,highlightDates:a.state.highlightDates,includeDates:a.props.includeDates,includeTimes:a.props.includeTimes,injectTimes:a.props.injectTimes,inline:a.props.inline,shouldFocusDayInline:a.state.shouldFocusDayInline,peekNextMonth:a.props.peekNextMonth,showMonthDropdown:a.props.showMonthDropdown,showPreviousMonths:a.props.showPreviousMonths,useShortMonthInDropdown:a.props.useShortMonthInDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showWeekNumbers:a.props.showWeekNumbers,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,forceShowMonthNavigation:a.props.forceShowMonthNavigation,showDisabledMonthNavigation:a.props.showDisabledMonthNavigation,scrollableYearDropdown:a.props.scrollableYearDropdown,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown,todayButton:a.props.todayButton,weekLabel:a.props.weekLabel,outsideClickIgnoreClass:Ur,fixedHeight:a.props.fixedHeight,monthsShown:a.props.monthsShown,monthSelectedIn:a.state.monthSelectedIn,onDropdownFocus:a.handleDropdownFocus,onMonthChange:a.props.onMonthChange,onYearChange:a.props.onYearChange,dayClassName:a.props.dayClassName,weekDayClassName:a.props.weekDayClassName,monthClassName:a.props.monthClassName,timeClassName:a.props.timeClassName,showTimeSelect:a.props.showTimeSelect,showTimeSelectOnly:a.props.showTimeSelectOnly,onTimeChange:a.handleTimeChange,timeFormat:a.props.timeFormat,timeIntervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,className:a.props.calendarClassName,container:a.props.calendarContainer,yearItemNumber:a.props.yearItemNumber,yearDropdownItemNumber:a.props.yearDropdownItemNumber,previousMonthButtonLabel:a.props.previousMonthButtonLabel,nextMonthButtonLabel:a.props.nextMonthButtonLabel,previousYearButtonLabel:a.props.previousYearButtonLabel,nextYearButtonLabel:a.props.nextYearButtonLabel,timeInputLabel:a.props.timeInputLabel,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderCustomHeader:a.props.renderCustomHeader,popperProps:a.props.popperProps,renderDayContents:a.props.renderDayContents,onDayMouseEnter:a.props.onDayMouseEnter,onMonthMouseLeave:a.props.onMonthMouseLeave,showTimeInput:a.props.showTimeInput,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showPopperArrow:a.props.showPopperArrow,excludeScrollbar:a.props.excludeScrollbar,handleOnKeyDown:a.onDayKeyDown,isInputFocused:a.state.focused,customTimeInput:a.props.customTimeInput,setPreSelection:a.setPreSelection},a.props.children):null})),mt(bt(a),"renderDateInput",(function(){var e,t,r,n,o,s=ce.default(a.props.className,mt({},Ur,a.state.open)),i=a.props.customInput||de.default.createElement("input",{type:"text"}),p=a.props.customInputRef||"ref",l="string"==typeof a.props.value?a.props.value:"string"==typeof a.state.inputValue?a.state.inputValue:(t=a.props.selected,r=a.props,n=r.dateFormat,o=r.locale,t&&Lt(t,Array.isArray(n)?n[0]:n,o)||"");return de.default.cloneElement(i,(mt(e={},p,(function(e){a.input=e})),mt(e,"value",l),mt(e,"onBlur",a.handleBlur),mt(e,"onChange",a.handleChange),mt(e,"onClick",a.onInputClick),mt(e,"onFocus",a.handleFocus),mt(e,"onKeyDown",a.onInputKeyDown),mt(e,"id",a.props.id),mt(e,"name",a.props.name),mt(e,"autoFocus",a.props.autoFocus),mt(e,"placeholder",a.props.placeholderText),mt(e,"disabled",a.props.disabled),mt(e,"autoComplete",a.props.autoComplete),mt(e,"className",ce.default(i.props.className,s)),mt(e,"title",a.props.title),mt(e,"readOnly",a.props.readOnly),mt(e,"required",a.props.required),mt(e,"tabIndex",a.props.tabIndex),mt(e,"aria-describedby",a.props.ariaDescribedBy),mt(e,"aria-invalid",a.props.ariaInvalid),mt(e,"aria-labelledby",a.props.ariaLabelledBy),mt(e,"aria-required",a.props.ariaRequired),e))})),mt(bt(a),"renderClearButton",(function(){var e=a.props,t=e.isClearable,r=e.selected,n=e.clearButtonTitle,o=e.ariaLabelClose,s=void 0===o?"Close":o;return t&&null!=r?de.default.createElement("button",{type:"button",className:"react-datepicker__close-icon","aria-label":s,onClick:a.onClearClick,title:n,tabIndex:-1}):null})),a.state=a.calcInitialState(),a}return ht(r,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0)}},{key:"componentDidUpdate",value:function(e,t){var r,a;e.inline&&(r=e.selected,a=this.props.selected,r&&a?Ye.default(r)!==Ye.default(a)||Te.default(r)!==Te.default(a):r!==a)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:Dr(this.props.highlightDates)}),t.focused||$t(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0)}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?de.default.createElement("div",null,this.props.inline?null:de.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?de.default.createElement("div",{className:"react-datepicker__portal"},e):null):de.default.createElement(Vr,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,popperModifiers:this.props.popperModifiers,targetComponent:de.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}],[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:Ot,renderDayContents:function(e){return e},focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null}}}]),r}(de.default.Component),Jr="input",Xr="navigate";e.CalendarContainer=Wr,e.default=Gr,e.getDefaultLocale=Gt,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:__webpack_require__.g;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:__webpack_require__.g).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));


/***/ }),

/***/ 94895:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addLeadingZeros;

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

module.exports = exports.default;

/***/ }),

/***/ 34160:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = assign;

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

module.exports = exports.default;

/***/ }),

/***/ 97923:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(92394));

var _index2 = _interopRequireDefault(__webpack_require__(49730));

var _index3 = _interopRequireDefault(__webpack_require__(23122));

var _index4 = _interopRequireDefault(__webpack_require__(25184));

var _index5 = _interopRequireDefault(__webpack_require__(83623));

var _index6 = _interopRequireDefault(__webpack_require__(26950));

var _index7 = _interopRequireDefault(__webpack_require__(94895));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return _index.default.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = (0, _index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return (0, _index7.default)(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return (0, _index7.default)(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = (0, _index4.default)(date); // Padding

    return (0, _index7.default)(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return (0, _index7.default)(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return (0, _index7.default)(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return (0, _index7.default)(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return _index.default.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return (0, _index7.default)(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = (0, _index5.default)(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return (0, _index7.default)(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = (0, _index3.default)(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return (0, _index7.default)(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return _index.default.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = (0, _index2.default)(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return (0, _index7.default)(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return (0, _index7.default)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return (0, _index7.default)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return (0, _index7.default)(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return _index.default.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return _index.default.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return (0, _index7.default)(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return (0, _index7.default)(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return _index.default.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return _index.default.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return _index.default.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return (0, _index7.default)(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return (0, _index7.default)(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + (0, _index7.default)(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + (0, _index7.default)(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = (0, _index7.default)(Math.floor(absOffset / 60), 2);
  var minutes = (0, _index7.default)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 92394:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(94895));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return (0, _index.default)(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return (0, _index.default)(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return (0, _index.default)(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return (0, _index.default)(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return (0, _index.default)(fractionalSeconds, token.length);
  }
};
var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 19597:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var _default = longFormatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 2632:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getTimezoneOffsetInMilliseconds;
var MILLISECONDS_IN_MINUTE = 60000;

function getDateMillisecondsPart(date) {
  return date.getTime() % MILLISECONDS_IN_MINUTE;
}
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */


function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
  date.setSeconds(0, 0);
  var hasNegativeUTCOffset = baseTimezoneOffset > 0;
  var millisecondsPartOfTimezoneOffset = hasNegativeUTCOffset ? (MILLISECONDS_IN_MINUTE + getDateMillisecondsPart(date)) % MILLISECONDS_IN_MINUTE : getDateMillisecondsPart(date);
  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}

module.exports = exports.default;

/***/ }),

/***/ 49730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCDayOfYear;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

module.exports = exports.default;

/***/ }),

/***/ 23122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCISOWeek;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(9318));

var _index3 = _interopRequireDefault(__webpack_require__(74822));

var _index4 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

module.exports = exports.default;

/***/ }),

/***/ 25184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCISOWeekYear;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(9318));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeekYear(dirtyDate) {
  (0, _index3.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

module.exports = exports.default;

/***/ }),

/***/ 83623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCWeek;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(63164));

var _index3 = _interopRequireDefault(__webpack_require__(78631));

var _index4 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

module.exports = exports.default;

/***/ }),

/***/ 26950:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCWeekYear;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(63164));

var _index4 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeekYear(dirtyDate, dirtyOptions) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

module.exports = exports.default;

/***/ }),

/***/ 75336:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];

function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}

function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}

function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

/***/ }),

/***/ 52828:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = requiredArgs;

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

module.exports = exports.default;

/***/ }),

/***/ 40369:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setUTCDay;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  (0, _index3.default)(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0, _index2.default)(dirtyDate);
  var day = (0, _index.default)(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 20297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setUTCISODay;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISODay(dirtyDate, dirtyDay) {
  (0, _index3.default)(2, arguments);
  var day = (0, _index.default)(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = (0, _index2.default)(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 81142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setUTCISOWeek;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(23122));

var _index4 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  (0, _index4.default)(2, arguments);
  var date = (0, _index2.default)(dirtyDate);
  var isoWeek = (0, _index.default)(dirtyISOWeek);
  var diff = (0, _index3.default)(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 89607:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setUTCWeek;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(83623));

var _index4 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCWeek(dirtyDate, dirtyWeek, options) {
  (0, _index4.default)(2, arguments);
  var date = (0, _index2.default)(dirtyDate);
  var week = (0, _index.default)(dirtyWeek);
  var diff = (0, _index3.default)(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 9318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCISOWeek;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeek(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var weekStartsOn = 1;
  var date = (0, _index.default)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 74822:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCISOWeekYear;

var _index = _interopRequireDefault(__webpack_require__(25184));

var _index2 = _interopRequireDefault(__webpack_require__(9318));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeekYear(dirtyDate) {
  (0, _index3.default)(1, arguments);
  var year = (0, _index.default)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0, _index2.default)(fourthOfJanuary);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 63164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCWeek;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeek(dirtyDate, dirtyOptions) {
  (0, _index3.default)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0, _index2.default)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 78631:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCWeekYear;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(26950));

var _index3 = _interopRequireDefault(__webpack_require__(63164));

var _index4 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  (0, _index4.default)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate);
  var year = (0, _index2.default)(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0, _index3.default)(firstWeek, dirtyOptions);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 22328:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toInteger;

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

module.exports = exports.default;

/***/ }),

/***/ 75411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addDays;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var date = (0, _index2.default)(dirtyDate);
  var amount = (0, _index.default)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 10617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addHours;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(10894));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

module.exports = exports.default;

/***/ }),

/***/ 10894:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addMilliseconds;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var timestamp = (0, _index2.default)(dirtyDate).getTime();
  var amount = (0, _index.default)(dirtyAmount);
  return new Date(timestamp + amount);
}

module.exports = exports.default;

/***/ }),

/***/ 34618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addMinutes;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(10894));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

module.exports = exports.default;

/***/ }),

/***/ 3992:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addMonths;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var date = (0, _index2.default)(dirtyDate);
  var amount = (0, _index.default)(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 1, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

module.exports = exports.default;

/***/ }),

/***/ 50735:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addWeeks;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(75411));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  var days = amount * 7;
  return (0, _index2.default)(dirtyDate, days);
}

module.exports = exports.default;

/***/ }),

/***/ 80090:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addYears;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(3992));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  return (0, _index2.default)(dirtyDate, amount * 12);
}

module.exports = exports.default;

/***/ }),

/***/ 86590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = differenceInCalendarDays;

var _index = _interopRequireDefault(__webpack_require__(2632));

var _index2 = _interopRequireDefault(__webpack_require__(60017));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * var result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0, _index3.default)(2, arguments);
  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
  var startOfDayRight = (0, _index2.default)(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

module.exports = exports.default;

/***/ }),

/***/ 84329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = differenceInCalendarMonths;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  (0, _index2.default)(2, arguments);
  var dateLeft = (0, _index.default)(dirtyDateLeft);
  var dateRight = (0, _index.default)(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

module.exports = exports.default;

/***/ }),

/***/ 79538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = differenceInCalendarWeeks;

var _index = _interopRequireDefault(__webpack_require__(6025));

var _index2 = _interopRequireDefault(__webpack_require__(2632));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */

function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  (0, _index3.default)(2, arguments);
  var startOfWeekLeft = (0, _index.default)(dirtyDateLeft, dirtyOptions);
  var startOfWeekRight = (0, _index.default)(dirtyDateRight, dirtyOptions);
  var timestampLeft = startOfWeekLeft.getTime() - (0, _index2.default)(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - (0, _index2.default)(startOfWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

module.exports = exports.default;

/***/ }),

/***/ 25985:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = differenceInCalendarYears;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  (0, _index2.default)(2, arguments);
  var dateLeft = (0, _index.default)(dirtyDateLeft);
  var dateRight = (0, _index.default)(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

module.exports = exports.default;

/***/ }),

/***/ 3301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = endOfDay;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 13170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = endOfMonth;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 7472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = endOfWeek;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(22328));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, dirtyOptions) {
  (0, _index3.default)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0, _index.default)(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 2032:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = format;

var _index = _interopRequireDefault(__webpack_require__(99869));

var _index2 = _interopRequireDefault(__webpack_require__(52357));

var _index3 = _interopRequireDefault(__webpack_require__(8719));

var _index4 = _interopRequireDefault(__webpack_require__(71343));

var _index5 = _interopRequireDefault(__webpack_require__(97923));

var _index6 = _interopRequireDefault(__webpack_require__(19597));

var _index7 = _interopRequireDefault(__webpack_require__(2632));

var _index8 = __webpack_require__(75336);

var _index9 = _interopRequireDefault(__webpack_require__(22328));

var _index10 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  (0, _index10.default)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || _index2.default;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index9.default)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index9.default)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = (0, _index4.default)(dirtyDate);

  if (!(0, _index.default)(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = (0, _index7.default)(originalDate);
  var utcDate = (0, _index3.default)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = _index6.default[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = _index5.default[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && (0, _index8.isProtectedWeekYearToken)(substring)) {
        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && (0, _index8.isProtectedDayOfYearToken)(substring)) {
        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

module.exports = exports.default;

/***/ }),

/***/ 85554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getDate;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

module.exports = exports.default;

/***/ }),

/***/ 15365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getDay;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var day = date.getDay();
  return day;
}

module.exports = exports.default;

/***/ }),

/***/ 9383:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getDaysInMonth;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

module.exports = exports.default;

/***/ }),

/***/ 98041:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getHours;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var hours = date.getHours();
  return hours;
}

module.exports = exports.default;

/***/ }),

/***/ 73964:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getISOWeek;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(79038));

var _index3 = _interopRequireDefault(__webpack_require__(5016));

var _index4 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */

function getISOWeek(dirtyDate) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

module.exports = exports.default;

/***/ }),

/***/ 36105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getISOWeekYear;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(79038));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `getISOYear` to `getISOWeekYear`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(dirtyDate) {
  (0, _index3.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

module.exports = exports.default;

/***/ }),

/***/ 95896:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getMinutes;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

module.exports = exports.default;

/***/ }),

/***/ 30850:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getMonth;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var month = date.getMonth();
  return month;
}

module.exports = exports.default;

/***/ }),

/***/ 11414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getQuarter;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

module.exports = exports.default;

/***/ }),

/***/ 27229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getSeconds;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

module.exports = exports.default;

/***/ }),

/***/ 25233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getTime;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

module.exports = exports.default;

/***/ }),

/***/ 8785:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getYear;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var year = date.getFullYear();
  return year;
}

module.exports = exports.default;

/***/ }),

/***/ 41042:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isAfter;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  (0, _index2.default)(2, arguments);
  var date = (0, _index.default)(dirtyDate);
  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

module.exports = exports.default;

/***/ }),

/***/ 60231:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isBefore;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  (0, _index2.default)(2, arguments);
  var date = (0, _index.default)(dirtyDate);
  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

module.exports = exports.default;

/***/ }),

/***/ 61334:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isDate;

var _index = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * var result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * var result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * var result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * var result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0, _index.default)(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

module.exports = exports.default;

/***/ }),

/***/ 16220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isEqual;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual(dirtyLeftDate, dirtyRightDate) {
  (0, _index2.default)(2, arguments);
  var dateLeft = (0, _index.default)(dirtyLeftDate);
  var dateRight = (0, _index.default)(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

module.exports = exports.default;

/***/ }),

/***/ 38597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isSameDay;

var _index = _interopRequireDefault(__webpack_require__(60017));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0, _index2.default)(2, arguments);
  var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
  var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

module.exports = exports.default;

/***/ }),

/***/ 80193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isSameMonth;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  (0, _index2.default)(2, arguments);
  var dateLeft = (0, _index.default)(dirtyDateLeft);
  var dateRight = (0, _index.default)(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

module.exports = exports.default;

/***/ }),

/***/ 8049:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isSameQuarter;

var _index = _interopRequireDefault(__webpack_require__(69500));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 */
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  (0, _index2.default)(2, arguments);
  var dateLeftStartOfQuarter = (0, _index.default)(dirtyDateLeft);
  var dateRightStartOfQuarter = (0, _index.default)(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

module.exports = exports.default;

/***/ }),

/***/ 99522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isSameYear;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  (0, _index2.default)(2, arguments);
  var dateLeft = (0, _index.default)(dirtyDateLeft);
  var dateRight = (0, _index.default)(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

module.exports = exports.default;

/***/ }),

/***/ 99869:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isValid;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  return !isNaN(date);
}

module.exports = exports.default;

/***/ }),

/***/ 12002:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isWithinInterval;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   isWithinRange(
 *     new Date(2014, 0, 3),
 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   isWithinInterval(
 *     new Date(2014, 0, 3),
 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, dirtyInterval) {
  (0, _index2.default)(2, arguments);
  var interval = dirtyInterval || {};
  var time = (0, _index.default)(dirtyDate).getTime();
  var startTime = (0, _index.default)(interval.start).getTime();
  var endTime = (0, _index.default)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

module.exports = exports.default;

/***/ }),

/***/ 73288:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildFormatLongFn;

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

module.exports = exports.default;

/***/ }),

/***/ 33872:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildLocalizeFn;

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

module.exports = exports.default;

/***/ }),

/***/ 61788:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildMatchFn;

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = findIndex(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
}

module.exports = exports.default;

/***/ }),

/***/ 15483:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildMatchPatternFn;

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

module.exports = exports.default;

/***/ }),

/***/ 14920:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = formatDistance;
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

module.exports = exports.default;

/***/ }),

/***/ 26228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(73288));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0, _index.default)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0, _index.default)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0, _index.default)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var _default = formatLong;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 43078:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = formatRelative;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

module.exports = exports.default;

/***/ }),

/***/ 85890:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(33872));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: (0, _index.default)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0, _index.default)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: (0, _index.default)({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: (0, _index.default)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0, _index.default)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var _default = localize;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 1765:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(15483));

var _index2 = _interopRequireDefault(__webpack_require__(61788));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: (0, _index.default)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: (0, _index2.default)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0, _index2.default)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: (0, _index2.default)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0, _index2.default)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0, _index2.default)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var _default = match;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 52357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(14920));

var _index2 = _interopRequireDefault(__webpack_require__(26228));

var _index3 = _interopRequireDefault(__webpack_require__(43078));

var _index4 = _interopRequireDefault(__webpack_require__(85890));

var _index5 = _interopRequireDefault(__webpack_require__(1765));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _index.default,
  formatLong: _index2.default,
  formatRelative: _index3.default,
  localize: _index4.default,
  match: _index5.default,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var _default = locale;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 76655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = max;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - `max` function now accepts an array of dates rather than spread arguments.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   var date1 = new Date(1989, 6, 10)
 *   var date2 = new Date(1987, 1, 11)
 *   var maxDate = max(date1, date2)
 *
 *   // v2.0.0 onward:
 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
 *   var maxDate = max(dates)
 *   ```
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max(dirtyDatesArray) {
  (0, _index2.default)(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0, _index.default)(dirtyDate);

    if (result === undefined || result < currentDate || isNaN(currentDate)) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

module.exports = exports.default;

/***/ }),

/***/ 30143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = min;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name min
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - `min` function now accepts an array of dates rather than spread arguments.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   var date1 = new Date(1989, 6, 10)
 *   var date2 = new Date(1987, 1, 11)
 *   var minDate = min(date1, date2)
 *
 *   // v2.0.0 onward:
 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
 *   var minDate = min(dates)
 *   ```
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min(dirtyDatesArray) {
  (0, _index2.default)(1, arguments);
  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = (0, _index.default)(dirtyDate);

    if (result === undefined || result > currentDate || isNaN(currentDate)) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

module.exports = exports.default;

/***/ }),

/***/ 61219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(26950));

var _index2 = _interopRequireDefault(__webpack_require__(40369));

var _index3 = _interopRequireDefault(__webpack_require__(20297));

var _index4 = _interopRequireDefault(__webpack_require__(81142));

var _index5 = _interopRequireDefault(__webpack_require__(89607));

var _index6 = _interopRequireDefault(__webpack_require__(9318));

var _index7 = _interopRequireDefault(__webpack_require__(63164));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = (0, _index.default)(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return (0, _index7.default)(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return (0, _index7.default)(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return (0, _index6.default)(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return (0, _index7.default)((0, _index5.default)(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return (0, _index6.default)((0, _index4.default)(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = (0, _index2.default)(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = (0, _index2.default)(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = (0, _index2.default)(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = (0, _index3.default)(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};
var _default = parsers;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 61941:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = parse;

var _index = _interopRequireDefault(__webpack_require__(52357));

var _index2 = _interopRequireDefault(__webpack_require__(8719));

var _index3 = _interopRequireDefault(__webpack_require__(71343));

var _index4 = _interopRequireDefault(__webpack_require__(34160));

var _index5 = _interopRequireDefault(__webpack_require__(19597));

var _index6 = _interopRequireDefault(__webpack_require__(2632));

var _index7 = __webpack_require__(75336);

var _index8 = _interopRequireDefault(__webpack_require__(22328));

var _index9 = _interopRequireDefault(__webpack_require__(61219));

var _index10 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward (toDate no longer accepts a string)
 *   toDate(1392098430000) // Unix to timestamp
 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  (0, _index10.default)(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale = options.locale || _index.default;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index8.default)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index8.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index8.default)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index8.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return (0, _index3.default)(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale // If timezone isn't specified, it will be set to the system timezone

  };
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = _index5.default[firstCharacter];
      return longFormatter(substring, locale.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && (0, _index7.isProtectedWeekYearToken)(token)) {
      (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
    }

    if (!options.useAdditionalDayOfYearTokens && (0, _index7.isProtectedDayOfYearToken)(token)) {
      (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
    }

    var firstCharacter = token[0];
    var parser = _index9.default[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        subPriority: parser.subPriority || 0,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = (0, _index3.default)(dirtyReferenceDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      (0, _index4.default)(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

module.exports = exports.default;

/***/ }),

/***/ 67352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = parseISO;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  (0, _index2.default)(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _index.default)(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (isNaN(date) || !date) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time) || time === null) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate(), dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    result.setFullYear(dirtyDate.getUTCFullYear());
    return result;
  }

  return new Date(timestamp + time + offset);
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: null
  };
  var year = captures[1] && parseInt(captures[1]);
  var century = captures[2] && parseInt(captures[2]);
  return {
    year: century == null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return null;
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return null;
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return null; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

module.exports = exports.default;

/***/ }),

/***/ 96499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setHours;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours(dirtyDate, dirtyHours) {
  (0, _index3.default)(2, arguments);
  var date = (0, _index2.default)(dirtyDate);
  var hours = (0, _index.default)(dirtyHours);
  date.setHours(hours);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 61093:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setMinutes;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes(dirtyDate, dirtyMinutes) {
  (0, _index3.default)(2, arguments);
  var date = (0, _index2.default)(dirtyDate);
  var minutes = (0, _index.default)(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 7195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setMonth;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(9383));

var _index4 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(dirtyDate, dirtyMonth) {
  (0, _index4.default)(2, arguments);
  var date = (0, _index2.default)(dirtyDate);
  var month = (0, _index.default)(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 22730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setQuarter;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(7195));

var _index4 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter(dirtyDate, dirtyQuarter) {
  (0, _index4.default)(2, arguments);
  var date = (0, _index2.default)(dirtyDate);
  var quarter = (0, _index.default)(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return (0, _index3.default)(date, date.getMonth() + diff * 3);
}

module.exports = exports.default;

/***/ }),

/***/ 37170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setSeconds;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds(dirtyDate, dirtySeconds) {
  (0, _index3.default)(2, arguments);
  var date = (0, _index2.default)(dirtyDate);
  var seconds = (0, _index.default)(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 26423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = setYear;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(71343));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(dirtyDate, dirtyYear) {
  (0, _index3.default)(2, arguments);
  var date = (0, _index2.default)(dirtyDate);
  var year = (0, _index.default)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date)) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 60017:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfDay;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 79038:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfISOWeek;

var _index = _interopRequireDefault(__webpack_require__(6025));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(dirtyDate) {
  (0, _index2.default)(1, arguments);
  return (0, _index.default)(dirtyDate, {
    weekStartsOn: 1
  });
}

module.exports = exports.default;

/***/ }),

/***/ 5016:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfISOWeekYear;

var _index = _interopRequireDefault(__webpack_require__(36105));

var _index2 = _interopRequireDefault(__webpack_require__(79038));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(dirtyDate) {
  (0, _index3.default)(1, arguments);
  var year = (0, _index.default)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = (0, _index2.default)(fourthOfJanuary);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 59783:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfMonth;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 69500:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfQuarter;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 6025:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfWeek;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(22328));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(dirtyDate, dirtyOptions) {
  (0, _index3.default)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0, _index.default)(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 56755:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfYear;

var _index = _interopRequireDefault(__webpack_require__(71343));

var _index2 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var cleanDate = (0, _index.default)(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

module.exports = exports.default;

/***/ }),

/***/ 98743:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = subDays;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(75411));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  return (0, _index2.default)(dirtyDate, -amount);
}

module.exports = exports.default;

/***/ }),

/***/ 6064:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = subHours;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(10617));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  return (0, _index2.default)(dirtyDate, -amount);
}

module.exports = exports.default;

/***/ }),

/***/ 8719:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = subMilliseconds;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(10894));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  return (0, _index2.default)(dirtyDate, -amount);
}

module.exports = exports.default;

/***/ }),

/***/ 86326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = subMinutes;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(34618));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  return (0, _index2.default)(dirtyDate, -amount);
}

module.exports = exports.default;

/***/ }),

/***/ 19031:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = subMonths;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(3992));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  return (0, _index2.default)(dirtyDate, -amount);
}

module.exports = exports.default;

/***/ }),

/***/ 71001:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = subWeeks;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(50735));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  return (0, _index2.default)(dirtyDate, -amount);
}

module.exports = exports.default;

/***/ }),

/***/ 26029:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = subYears;

var _index = _interopRequireDefault(__webpack_require__(22328));

var _index2 = _interopRequireDefault(__webpack_require__(80090));

var _index3 = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  return (0, _index2.default)(dirtyDate, -amount);
}

module.exports = exports.default;

/***/ }),

/***/ 71343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toDate;

var _index = _interopRequireDefault(__webpack_require__(52828));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0, _index.default)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

module.exports = exports.default;

/***/ }),

/***/ 57715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OO": function() { return /* binding */ I18nContext; },
  "zv": function() { return /* binding */ ReportNamespaces; },
  "JP": function() { return /* binding */ getDefaults; },
  "nI": function() { return /* binding */ getI18n; },
  "Db": function() { return /* binding */ initReactI18next; }
});

// UNUSED EXPORTS: composeInitialProps, getInitialProps, setDefaults, setI18n

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/context.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
var i18nInstance;
var I18nContext = (0,react.createContext)();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    (0,classCallCheck/* default */.Z)(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  (0,createClass/* default */.Z)(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}

/***/ }),

/***/ 46871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 58949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IGNORE_CLASS_NAME": function() { return /* binding */ IGNORE_CLASS_NAME; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode)(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(WrappedComponent, props);
    };

    return onClickOutside;
  }(react__WEBPACK_IMPORTED_MODULE_0__.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);


/***/ }),

/***/ 37004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Manager": function() { return /* reexport */ Manager; },
  "Popper": function() { return /* reexport */ Popper_Popper; },
  "Reference": function() { return /* reexport */ Reference; },
  "placements": function() { return /* reexport */ Popper_placements; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/popper.js/dist/esm/popper.js
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var popper_defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, popper_defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), popper_defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return popper_defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return popper_defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: popper_defineProperty({}, side, reference[side]),
      end: popper_defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : __webpack_require__.g).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ var popper = (Popper);
//# sourceMappingURL=popper.js.map

// EXTERNAL MODULE: ./node_modules/create-react-context/lib/index.js
var lib = __webpack_require__(53443);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Manager.js





var ManagerReferenceNodeContext = lib_default()();
var ManagerReferenceNodeSetterContext = lib_default()();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "referenceNode", void 0);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return react.createElement(ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, react.createElement(ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(react.Component);


;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/utils.js
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Popper.js









var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "state", {
      data: undefined,
      placement: undefined
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "popperInstance", void 0);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "popperNode", null);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "arrowNode", null);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      setRef(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: (0,esm_extends/* default */.Z)({}, _this.props.modifiers, {
          arrow: (0,esm_extends/* default */.Z)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : (0,esm_extends/* default */.Z)({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = (0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new popper(referenceElement, popperNode, _this.getOptions());
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || this.props.modifiers !== prevProps.modifiers) {
      // develop only check that modifiers isn't being updated needlessly
      if (false) {}

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return unwrapArray(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(react.Component);

(0,defineProperty/* default */.Z)(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var Popper_placements = popper.placements;

function Popper_Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["referenceElement"]);

  return react.createElement(ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
    return react.createElement(InnerPopper, (0,esm_extends/* default */.Z)({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}
// EXTERNAL MODULE: ./node_modules/warning/warning.js
var warning = __webpack_require__(42473);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/Reference.js









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "refHandler", function (node) {
      setRef(_this.props.innerRef, node);
      safeInvoke(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
  };

  _proto.render = function render() {
    warning_default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return unwrapArray(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(react.Component);

function Reference(props) {
  return react.createElement(ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
    return react.createElement(InnerReference, (0,esm_extends/* default */.Z)({
      setReferenceNode: setReferenceNode
    }, props));
  });
}
;// CONCATENATED MODULE: ./node_modules/react-popper/lib/esm/index.js
// Public components



 // Public types

/***/ }),

/***/ 36456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zt": function() { return /* reexport */ components_Provider; },
  "$j": function() { return /* reexport */ connect; },
  "I0": function() { return /* reexport */ useDispatch; },
  "v9": function() { return /* reexport */ useSelector; }
});

// UNUSED EXPORTS: ReactReduxContext, batch, connectAdvanced, createDispatchHook, createSelectorHook, createStoreHook, shallowEqual, useStore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

var ReactReduxContext = /*#__PURE__*/react.createContext(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();


;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js





function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react.useMemo)(function () {
    var subscription = new Subscription(store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react.useMemo)(function () {
    return store.getState();
  }, [store]);
  (0,react.useEffect)(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {}

/* harmony default export */ var components_Provider = (Provider);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/react-is/index.js
var react_is = __webpack_require__(72973);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js







 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  if (false) { var customStoreWarningMessage; }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {}

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = (0,esm_extends/* default */.Z)({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? react.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = (0,react.useMemo)(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ["reactReduxForwardedRef"]);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = (0,react.useMemo)(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && (0,react_is.isContextConsumer)( /*#__PURE__*/react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = (0,react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = (0,react.useMemo)(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = (0,react.useMemo)(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new Subscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = (0,react.useMemo)(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0,esm_extends/* default */.Z)({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = (0,react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = (0,react.useRef)();
      var lastWrapperProps = (0,react.useRef)(wrapperProps);
      var childPropsFromStoreUpdate = (0,react.useRef)();
      var renderIsScheduled = (0,react.useRef)(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = (0,react.useMemo)(function () {
        return /*#__PURE__*/react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = (0,react.useMemo)(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? react.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = react.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/react.createElement(Connect, (0,esm_extends/* default */.Z)({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics_cjs_default()(forwarded, WrappedComponent);
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return (0,redux/* bindActionCreators */.DE)(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {}

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, (0,esm_extends/* default */.Z)({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect = (/*#__PURE__*/createConnect());
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext_useReduxContext() {
  var contextValue = (0,react.useContext)(ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useStore = context === ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = (0,react.useReducer)(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = (0,react.useMemo)(function () {
    return new Subscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = (0,react.useRef)();
  var latestSelector = (0,react.useRef)();
  var latestStoreState = (0,react.useRef)();
  var latestSelectedState = (0,react.useRef)();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      selectedState = selector(storeState);
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newSelectedState = latestSelector.current(store.getState());

        if (equalityFn(newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = newSelectedState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js
/* eslint-disable import/no-unresolved */

;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js










setBatch(react_dom.unstable_batchedUpdates);


/***/ }),

/***/ 88359:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}__webpack_unused_export__=l;__webpack_unused_export__=m;__webpack_unused_export__=k;__webpack_unused_export__=h;__webpack_unused_export__=c;__webpack_unused_export__=n;__webpack_unused_export__=e;__webpack_unused_export__=t;__webpack_unused_export__=r;__webpack_unused_export__=d;
__webpack_unused_export__=g;__webpack_unused_export__=f;__webpack_unused_export__=p;__webpack_unused_export__=function(a){return A(a)||z(a)===l};__webpack_unused_export__=A;exports.isContextConsumer=function(a){return z(a)===k};__webpack_unused_export__=function(a){return z(a)===h};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};__webpack_unused_export__=function(a){return z(a)===n};__webpack_unused_export__=function(a){return z(a)===e};__webpack_unused_export__=function(a){return z(a)===t};
__webpack_unused_export__=function(a){return z(a)===r};__webpack_unused_export__=function(a){return z(a)===d};__webpack_unused_export__=function(a){return z(a)===g};__webpack_unused_export__=function(a){return z(a)===f};__webpack_unused_export__=function(a){return z(a)===p};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};__webpack_unused_export__=z;


/***/ }),

/***/ 72973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(88359);
} else {}


/***/ }),

/***/ 98885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: ENTERED, ENTERING, EXITED, EXITING, UNMOUNTED

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/Transition.js








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react.cloneElement(react.Children.only(children), childProps))
    );
  };

  return Transition;
}(react.Component);

Transition.contextType = TransitionGroupContext/* default */.Z;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);

/***/ }),

/***/ 220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));

/***/ }),

/***/ 28500:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var compose = (__webpack_require__(14890)/* .compose */ .qC);

__webpack_unused_export__ = true;
exports.Uo = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

__webpack_unused_export__ = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),

/***/ 14890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "md": function() { return /* binding */ applyMiddleware; },
/* harmony export */   "DE": function() { return /* binding */ bindActionCreators; },
/* harmony export */   "UY": function() { return /* binding */ combineReducers; },
/* harmony export */   "qC": function() { return /* binding */ compose; },
/* harmony export */   "MT": function() { return /* binding */ createStore; }
/* harmony export */ });
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var symbol_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98123);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[symbol_observable__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[symbol_observable__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {}




/***/ }),

/***/ 98123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es; }
});

;// CONCATENATED MODULE: ./node_modules/symbol-observable/es/ponyfill.js
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

;// CONCATENATED MODULE: ./node_modules/symbol-observable/es/index.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof __webpack_require__.g !== 'undefined') {
  root = __webpack_require__.g;
} else if (true) {
  root = module;
} else {}

var result = symbolObservablePonyfill(root);
/* harmony default export */ var es = (result);


/***/ }),

/***/ 86257:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright 2023 Google LLC
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.YouTubeEmbed = exports.GoogleMapsEmbed = exports.GoogleAnalytics = void 0;
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     https://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var google_analytics_1 = __webpack_require__(53494);
Object.defineProperty(exports, "GoogleAnalytics", ({ enumerable: true, get: function () { return google_analytics_1.GoogleAnalytics; } }));
var google_maps_embed_1 = __webpack_require__(34248);
Object.defineProperty(exports, "GoogleMapsEmbed", ({ enumerable: true, get: function () { return google_maps_embed_1.GoogleMapsEmbed; } }));
var youtube_embed_1 = __webpack_require__(92239);
Object.defineProperty(exports, "YouTubeEmbed", ({ enumerable: true, get: function () { return youtube_embed_1.YouTubeEmbed; } }));


/***/ }),

/***/ 53494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright 2023 Google LLC
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GoogleAnalytics = void 0;
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     https://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const data_json_1 = __importDefault(__webpack_require__(89426));
const utils_1 = __webpack_require__(17058);
const GoogleAnalytics = (_a) => {
    var args = __rest(_a, []);
    return (0, utils_1.formatData)(data_json_1.default, args);
};
exports.GoogleAnalytics = GoogleAnalytics;


/***/ }),

/***/ 34248:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright 2023 Google LLC
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GoogleMapsEmbed = void 0;
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     https://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const data_json_1 = __importDefault(__webpack_require__(27395));
const utils_1 = __webpack_require__(17058);
const GoogleMapsEmbed = (_a) => {
    var args = __rest(_a, []);
    return (0, utils_1.formatData)(data_json_1.default, args);
};
exports.GoogleMapsEmbed = GoogleMapsEmbed;


/***/ }),

/***/ 92239:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright 2023 Google LLC
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.YouTubeEmbed = void 0;
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     https://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const data_json_1 = __importDefault(__webpack_require__(88420));
const utils_1 = __webpack_require__(17058);
const YouTubeEmbed = (_a) => {
    var args = __rest(_a, []);
    return (0, utils_1.formatData)(data_json_1.default, args);
};
exports.YouTubeEmbed = YouTubeEmbed;


/***/ }),

/***/ 17058:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formatData = exports.createHtml = exports.formatUrl = void 0;
function filterArgs(args, selectedArgs, inverse = false) {
    if (!selectedArgs)
        return {};
    return Object.keys(args)
        .filter((key) => inverse ? !selectedArgs.includes(key) : selectedArgs.includes(key))
        .reduce((obj, key) => {
        obj[key] = args[key];
        return obj;
    }, {});
}
// Add all required search params with user inputs as values
function formatUrl(url, params, args, slug) {
    const newUrl = slug && Object.keys(slug).length > 0
        ? new URL(Object.values(slug)[0], url) // If there's a user inputted param for the URL slug, replace the default existing slug or include it
        : new URL(url);
    if (params && args) {
        params.forEach((param) => {
            if (args[param])
                newUrl.searchParams.set(param, args[param]);
        });
    }
    return newUrl.toString();
}
exports.formatUrl = formatUrl;
// Construct HTML element and include all default attributes and user-inputted attributes
function createHtml(element, attributes, htmlAttrArgs, urlQueryParamArgs, slugParamArg) {
    var _a;
    if (!attributes)
        return `<${element}></${element}>`;
    const formattedAttributes = ((_a = attributes.src) === null || _a === void 0 ? void 0 : _a.url)
        ? Object.assign(Object.assign({}, attributes), { src: formatUrl(attributes.src.url, attributes.src.params, urlQueryParamArgs, slugParamArg) }) : attributes;
    const htmlAttributes = Object.keys(Object.assign(Object.assign({}, formattedAttributes), htmlAttrArgs)).reduce((acc, name) => {
        const userVal = htmlAttrArgs === null || htmlAttrArgs === void 0 ? void 0 : htmlAttrArgs[name];
        const defaultVal = formattedAttributes[name];
        const finalVal = userVal !== null && userVal !== void 0 ? userVal : defaultVal; // overwrite
        const attrString = finalVal === true ? name : `${name}="${finalVal}"`;
        return finalVal ? acc + ` ${attrString}` : acc;
    }, '');
    return `<${element}${htmlAttributes}></${element}>`;
}
exports.createHtml = createHtml;
// Format JSON by including all default and user-required parameters
function formatData(data, args) {
    var _a, _b, _c, _d, _e;
    const allScriptParams = (_a = data.scripts) === null || _a === void 0 ? void 0 : _a.reduce((acc, script) => [
        ...acc,
        ...(Array.isArray(script.params) ? script.params : []),
    ], []);
    // First, find all input arguments that map to parameters passed to script URLs
    const scriptUrlParamInputs = filterArgs(args, allScriptParams);
    // Second, find all input arguments that map to parameters passed to the HTML src attribute
    const htmlUrlParamInputs = filterArgs(args, (_c = (_b = data.html) === null || _b === void 0 ? void 0 : _b.attributes.src) === null || _c === void 0 ? void 0 : _c.params);
    // Third, find the input argument that maps to the slug parameter passed to the HTML src attribute if present
    const htmlSlugParamInput = filterArgs(args, [
        (_e = (_d = data.html) === null || _d === void 0 ? void 0 : _d.attributes.src) === null || _e === void 0 ? void 0 : _e.slugParam,
    ]);
    // Lastly, all remaining arguments are forwarded as separate HTML attributes
    const htmlAttrInputs = filterArgs(args, [
        ...Object.keys(scriptUrlParamInputs),
        ...Object.keys(htmlUrlParamInputs),
        ...Object.keys(htmlSlugParamInput),
    ], true);
    return Object.assign(Object.assign({}, data), { 
        // Pass any custom attributes to HTML content
        html: data.html
            ? createHtml(data.html.element, data.html.attributes, htmlAttrInputs, htmlUrlParamInputs, htmlSlugParamInput)
            : null, 
        // Pass any required query params with user values for relevant scripts
        scripts: data.scripts
            ? data.scripts.map((script) => (Object.assign(Object.assign({}, script), { url: formatUrl(script.url, script.params, scriptUrlParamInputs) })))
            : null });
}
exports.formatData = formatData;


/***/ }),

/***/ 68217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/** @license React vundefined
 * use-subscription.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(96086),g=__webpack_require__(67294);
exports.useSubscription=function(a){var c=a.getCurrentValue,d=a.subscribe,b=g.useState(function(){return{getCurrentValue:c,subscribe:d,value:c()}});a=b[0];var f=b[1];b=a.value;if(a.getCurrentValue!==c||a.subscribe!==d)b=c(),f({getCurrentValue:c,subscribe:d,value:b});g.useDebugValue(b);g.useEffect(function(){function b(){if(!a){var b=c();f(function(a){return a.getCurrentValue!==c||a.subscribe!==d||a.value===b?a:e({},a,{value:b})})}}var a=!1,h=d(b);b();return function(){a=!0;h()}},[c,d]);return b};


/***/ }),

/***/ 67161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(68217);
} else {}


/***/ }),

/***/ 42473:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 34001:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./de/texts.json": 28843,
	"./en/texts.json": 60573,
	"./es/texts.json": 60061,
	"./fr/texts.json": 22910,
	"./it/texts.json": 70328,
	"./nl/texts.json": 49441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34001;

/***/ }),

/***/ 64836:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 75263:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(62634)["default"]);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 62634:
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 30907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 83878:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 61120:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 60136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 94578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 59199:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ 25267:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ 45987:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 82963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 97685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}

/***/ }),

/***/ 74902:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(59199);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 40181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 73897:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pR": function() { return /* binding */ cookie; },
  "eI": function() { return /* binding */ createClient; },
  "lx": function() { return /* binding */ predicate; }
});

// UNUSED EXPORTS: Client, ForbiddenError, NotFoundError, ParsingError, Predicates, PrismicError, buildQueryURL, getEndpoint, getGraphQLEndpoint, getRepositoryEndpoint, getRepositoryName, isRepositoryEndpoint, isRepositoryName, predicates

;// CONCATENATED MODULE: ./node_modules/@prismicio/types/dist/value/link.js
const LinkType = {
  Any: "Any",
  Document: "Document",
  Media: "Media",
  Web: "Web"
};

//# sourceMappingURL=link.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/helpers/dist/documentToLinkField.js

const documentToLinkField = (prismicDocument) => {
  var _a;
  return {
    link_type: LinkType.Document,
    id: prismicDocument.id,
    uid: prismicDocument.uid ?? void 0,
    type: prismicDocument.type,
    tags: prismicDocument.tags,
    lang: prismicDocument.lang,
    url: prismicDocument.url ?? void 0,
    slug: (_a = prismicDocument.slugs) == null ? void 0 : _a[0],
    // The REST API does not include a `data` property if the data
    // object is empty.
    //
    // A presence check for `prismicDocument.data` is done to
    // support partial documents. While `documentToLinkField` is
    // not typed to accept partial documents, passing a partial
    // document can happen in untyped projects.
    ...prismicDocument.data && Object.keys(prismicDocument.data).length > 0 ? { data: prismicDocument.data } : {}
  };
};

//# sourceMappingURL=documentToLinkField.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/helpers/dist/asLink.js


const asLink = (linkFieldOrDocument, linkResolver) => {
  if (!linkFieldOrDocument) {
    return null;
  }
  const linkField = (
    // prettier-ignore
    // @ts-expect-error - Bug in TypeScript 4.9: https://github.com/microsoft/TypeScript/issues/51501
    // TODO: Remove the `prettier-ignore` comment when this bug is fixed.
    "link_type" in linkFieldOrDocument ? linkFieldOrDocument : documentToLinkField(linkFieldOrDocument)
  );
  switch (linkField.link_type) {
    case LinkType.Media:
    case LinkType.Web:
      return "url" in linkField ? linkField.url : null;
    case LinkType.Document: {
      if ("id" in linkField && linkResolver) {
        const resolvedURL = linkResolver(linkField);
        if (resolvedURL != null) {
          return resolvedURL;
        }
      }
      if ("url" in linkField && linkField.url) {
        return linkField.url;
      }
      return null;
    }
    case LinkType.Any:
    default:
      return null;
  }
};

//# sourceMappingURL=asLink.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/client/dist/index.js


const isRepositoryName = (input) => {
  return /^[a-zA-Z0-9][-a-zA-Z0-9]{2,}[a-zA-Z0-9]$/.test(input);
};

class PrismicError extends Error {
  constructor(message = "An invalid API response was returned", url, response) {
    super(message);
    this.url = url;
    this.response = response;
  }
}

const getRepositoryEndpoint = (repositoryName) => {
  if (isRepositoryName(repositoryName)) {
    return `https://${repositoryName}.cdn.prismic.io/api/v2`;
  } else {
    throw new PrismicError(
      `An invalid Prismic repository name was given: ${repositoryName}`,
      void 0,
      void 0
    );
  }
};

const getRepositoryName = (repositoryEndpoint) => {
  try {
    return new URL(repositoryEndpoint).hostname.split(".")[0];
  } catch (e) {
    throw new PrismicError(
      `An invalid Prismic Rest API V2 endpoint was provided: ${repositoryEndpoint}`,
      void 0,
      void 0
    );
  }
};

const getGraphQLEndpoint = (repositoryName) => {
  if (isRepositoryName(repositoryName)) {
    return `https://${repositoryName}.cdn.prismic.io/graphql`;
  } else {
    throw new PrismicError(
      `An invalid Prismic repository name was given: ${repositoryName}`,
      void 0,
      void 0
    );
  }
};

const isRepositoryEndpoint = (input) => {
  try {
    new URL(input);
    return true;
  } catch (e) {
    return false;
  }
};

const castArray = (a) => Array.isArray(a) ? a : [a];

const RENAMED_PARAMS = {
  accessToken: "access_token"
};
const castOrderingToString = (ordering) => typeof ordering === "string" ? ordering : [
  ordering.field,
  ordering.direction === "desc" ? ordering.direction : void 0
].filter(Boolean).join(" ");
const buildQueryURL = (endpoint, args) => {
  var _a;
  const { predicates, ...params } = args;
  const url = new URL(`documents/search`, `${endpoint}/`);
  if (predicates) {
    for (const predicate of castArray(predicates)) {
      url.searchParams.append("q", `[${predicate}]`);
    }
  }
  for (const k in params) {
    const name = (_a = RENAMED_PARAMS[k]) != null ? _a : k;
    let value = params[k];
    if (name === "orderings") {
      const scopedValue = params[name];
      if (scopedValue != null) {
        const v = castArray(scopedValue).map((ordering) => castOrderingToString(ordering)).join(",");
        value = `[${v}]`;
      }
    } else if (name === "routes") {
      if (typeof params[name] === "object") {
        value = JSON.stringify(castArray(params[name]));
      }
    }
    if (value != null) {
      url.searchParams.set(name, castArray(value).join(","));
    }
  }
  return url.toString();
};

const appendPredicates = (objWithPredicates = {}, predicates) => {
  return {
    ...objWithPredicates,
    predicates: [
      ...objWithPredicates.predicates || [],
      ...castArray(predicates)
    ]
  };
};

const castThunk = (a) => typeof a === "function" ? a : () => a;

const findRef = (refs, predicate) => {
  const ref = refs.find((ref2) => predicate(ref2));
  if (!ref) {
    throw new PrismicError("Ref could not be found.", void 0, void 0);
  }
  return ref;
};

const findMasterRef = (refs) => {
  return findRef(refs, (ref) => ref.isMasterRef);
};

const findRefByID = (refs, id) => {
  return findRef(refs, (ref) => ref.id === id);
};

const findRefByLabel = (refs, label) => {
  return findRef(refs, (ref) => ref.label === label);
};

const preview = "io.prismic.preview";

var cookie = /*#__PURE__*/Object.freeze({
	__proto__: null,
	preview: preview
});

const readValue = (value) => {
  return value.replace(/%3B/g, ";");
};
const getPreviewCookie = (cookieJar) => {
  const cookies = cookieJar.split("; ");
  let value;
  for (const cookie of cookies) {
    const parts = cookie.split("=");
    const name = readValue(parts[0]).replace(/%3D/g, "=");
    if (name === preview) {
      value = readValue(parts.slice(1).join("="));
      continue;
    }
  }
  return value;
};

const minifyGraphQLQuery = (query) => {
  return query.replace(
    /(\n| )*( |{|})(\n| )*/gm,
    (_chars, _spaces, brackets) => brackets
  );
};

class ForbiddenError extends PrismicError {
}

class NotFoundError extends PrismicError {
}

class ParsingError extends PrismicError {
}

const formatValue = (value) => {
  if (Array.isArray(value)) {
    return `[${value.map(formatValue).join(", ")}]`;
  }
  if (typeof value === "string") {
    return `"${value}"`;
  }
  if (value instanceof Date) {
    return `${value.getTime()}`;
  }
  return `${value}`;
};
const pathWithArgsPredicate = (name) => {
  const fn = (path, ...args) => {
    const formattedArgs = args.map(formatValue).join(", ");
    const joiner = path && args.length ? ", " : "";
    return `[${name}(${path}${joiner}${formattedArgs})]`;
  };
  return fn;
};
const pathPredicate = (name) => {
  const predicateFn = pathWithArgsPredicate(name);
  const fn = (path) => {
    return predicateFn(path);
  };
  return fn;
};
const argsPredicate = (name) => {
  const predicateFn = pathWithArgsPredicate(name);
  const fn = (...args) => {
    return predicateFn("", ...args);
  };
  return fn;
};
const predicate = {
  at: pathWithArgsPredicate("at"),
  not: pathWithArgsPredicate("not"),
  any: pathWithArgsPredicate(
    "any"
  ),
  in: pathWithArgsPredicate("in"),
  fulltext: pathWithArgsPredicate("fulltext"),
  has: pathPredicate("has"),
  missing: pathPredicate("missing"),
  similar: argsPredicate("similar"),
  geopointNear: pathWithArgsPredicate("geopoint.near"),
  numberLessThan: pathWithArgsPredicate("number.lt"),
  numberGreaterThan: pathWithArgsPredicate("number.gt"),
  numberInRange: pathWithArgsPredicate(
    "number.inRange"
  ),
  dateAfter: pathWithArgsPredicate("date.after"),
  dateBefore: pathWithArgsPredicate("date.before"),
  dateBetween: pathWithArgsPredicate("date.between"),
  dateDayOfMonth: pathWithArgsPredicate("date.day-of-month"),
  dateDayOfMonthAfter: pathWithArgsPredicate(
    "date.day-of-month-after"
  ),
  dateDayOfMonthBefore: pathWithArgsPredicate(
    "date.day-of-month-before"
  ),
  dateDayOfWeek: pathWithArgsPredicate("date.day-of-week"),
  dateDayOfWeekAfter: pathWithArgsPredicate(
    "date.day-of-week-after"
  ),
  dateDayOfWeekBefore: pathWithArgsPredicate(
    "date.day-of-week-before"
  ),
  dateMonth: pathWithArgsPredicate("date.month"),
  dateMonthAfter: pathWithArgsPredicate("date.month-after"),
  dateMonthBefore: pathWithArgsPredicate("date.month-before"),
  dateYear: pathWithArgsPredicate("date.year"),
  dateHour: pathWithArgsPredicate("date.hour"),
  dateHourAfter: pathWithArgsPredicate("date.hour-after"),
  dateHourBefore: pathWithArgsPredicate("date.hour-before")
};

const MAX_PAGE_SIZE = 100;
const REPOSITORY_CACHE_TTL = 5e3;
const GET_ALL_QUERY_DELAY = 500;
const typePredicate = (documentType) => predicate.at("document.type", documentType);
const everyTagPredicate = (tags) => predicate.at("document.tags", castArray(tags));
const someTagsPredicate = (tags) => predicate.any("document.tags", castArray(tags));
const createClient = (repositoryNameOrEndpoint, options) => new Client(repositoryNameOrEndpoint, options);
class Client {
  constructor(repositoryNameOrEndpoint, options = {}) {
    this.refState = {
      mode: "Master" /* Master */,
      autoPreviewsEnabled: true
    };
    this.cachedRepositoryExpiration = 0;
    this.graphqlFetch = this.graphQLFetch.bind(this);
    if (isRepositoryEndpoint(repositoryNameOrEndpoint)) {
      if (false) {}
      this.endpoint = repositoryNameOrEndpoint;
    } else {
      this.endpoint = getRepositoryEndpoint(repositoryNameOrEndpoint);
    }
    this.accessToken = options.accessToken;
    this.routes = options.routes;
    this.brokenRoute = options.brokenRoute;
    this.defaultParams = options.defaultParams;
    if (options.ref) {
      this.queryContentFromRef(options.ref);
    }
    if (typeof options.fetch === "function") {
      this.fetchFn = options.fetch;
    } else if (typeof globalThis.fetch === "function") {
      this.fetchFn = globalThis.fetch;
    } else {
      throw new PrismicError(
        "A valid fetch implementation was not provided. In environments where fetch is not available (including Node.js), a fetch implementation must be provided via a polyfill or the `fetch` option.",
        void 0,
        void 0
      );
    }
    if (this.fetchFn === globalThis.fetch) {
      this.fetchFn = this.fetchFn.bind(globalThis);
    }
    this.graphQLFetch = this.graphQLFetch.bind(this);
  }
  enableAutoPreviews() {
    this.refState.autoPreviewsEnabled = true;
  }
  enableAutoPreviewsFromReq(req) {
    this.refState.httpRequest = req;
    this.refState.autoPreviewsEnabled = true;
  }
  disableAutoPreviews() {
    this.refState.autoPreviewsEnabled = false;
  }
  async query(predicates, params) {
    const url = await this.buildQueryURL({ ...params, predicates });
    return await this.fetch(url, params);
  }
  async get(params) {
    const url = await this.buildQueryURL(params);
    return await this.fetch(url, params);
  }
  async getFirst(params) {
    var _a, _b;
    const actualParams = { ...params };
    if (!(params && params.page) && !(params == null ? void 0 : params.pageSize)) {
      actualParams.pageSize = (_b = (_a = this.defaultParams) == null ? void 0 : _a.pageSize) != null ? _b : 1;
    }
    const url = await this.buildQueryURL(actualParams);
    const result = await this.fetch(url, params);
    const firstResult = result.results[0];
    if (firstResult) {
      return firstResult;
    }
    throw new PrismicError("No documents were returned", url, void 0);
  }
  async dangerouslyGetAll(params = {}) {
    var _a;
    const { limit = Infinity, ...actualParams } = params;
    const resolvedParams = {
      ...actualParams,
      pageSize: Math.min(
        limit,
        actualParams.pageSize || ((_a = this.defaultParams) == null ? void 0 : _a.pageSize) || MAX_PAGE_SIZE
      )
    };
    const documents = [];
    let latestResult;
    while ((!latestResult || latestResult.next_page) && documents.length < limit) {
      const page = latestResult ? latestResult.page + 1 : void 0;
      latestResult = await this.get({ ...resolvedParams, page });
      documents.push(...latestResult.results);
      if (latestResult.next_page) {
        await new Promise((res) => setTimeout(res, GET_ALL_QUERY_DELAY));
      }
    }
    return documents.slice(0, limit);
  }
  async getByID(id, params) {
    return await this.getFirst(
      appendPredicates(params, predicate.at("document.id", id))
    );
  }
  async getByIDs(ids, params) {
    return await this.get(
      appendPredicates(params, predicate.in("document.id", ids))
    );
  }
  async getAllByIDs(ids, params) {
    return await this.dangerouslyGetAll(
      appendPredicates(params, predicate.in("document.id", ids))
    );
  }
  async getByUID(documentType, uid, params) {
    return await this.getFirst(
      appendPredicates(params, [
        typePredicate(documentType),
        predicate.at(`my.${documentType}.uid`, uid)
      ])
    );
  }
  async getByUIDs(documentType, uids, params) {
    return await this.get(
      appendPredicates(params, [
        typePredicate(documentType),
        predicate.in(`my.${documentType}.uid`, uids)
      ])
    );
  }
  async getAllByUIDs(documentType, uids, params) {
    return await this.dangerouslyGetAll(
      appendPredicates(params, [
        typePredicate(documentType),
        predicate.in(`my.${documentType}.uid`, uids)
      ])
    );
  }
  async getSingle(documentType, params) {
    return await this.getFirst(
      appendPredicates(params, typePredicate(documentType))
    );
  }
  async getByType(documentType, params) {
    return await this.get(
      appendPredicates(params, typePredicate(documentType))
    );
  }
  async getAllByType(documentType, params) {
    return await this.dangerouslyGetAll(appendPredicates(params, typePredicate(documentType)));
  }
  async getByTag(tag, params) {
    return await this.get(
      appendPredicates(params, someTagsPredicate(tag))
    );
  }
  async getAllByTag(tag, params) {
    return await this.dangerouslyGetAll(
      appendPredicates(params, someTagsPredicate(tag))
    );
  }
  async getByEveryTag(tags, params) {
    return await this.get(
      appendPredicates(params, everyTagPredicate(tags))
    );
  }
  async getAllByEveryTag(tags, params) {
    return await this.dangerouslyGetAll(
      appendPredicates(params, everyTagPredicate(tags))
    );
  }
  async getBySomeTags(tags, params) {
    return await this.get(
      appendPredicates(params, someTagsPredicate(tags))
    );
  }
  async getAllBySomeTags(tags, params) {
    return await this.dangerouslyGetAll(
      appendPredicates(params, someTagsPredicate(tags))
    );
  }
  async getRepository(params) {
    const url = new URL(this.endpoint);
    if (this.accessToken) {
      url.searchParams.set("access_token", this.accessToken);
    }
    return await this.fetch(url.toString(), params);
  }
  async getRefs(params) {
    const repository = await this.getRepository(params);
    return repository.refs;
  }
  async getRefByID(id, params) {
    const refs = await this.getRefs(params);
    return findRefByID(refs, id);
  }
  async getRefByLabel(label, params) {
    const refs = await this.getRefs(params);
    return findRefByLabel(refs, label);
  }
  async getMasterRef(params) {
    const refs = await this.getRefs(params);
    return findMasterRef(refs);
  }
  async getReleases(params) {
    const refs = await this.getRefs(params);
    return refs.filter((ref) => !ref.isMasterRef);
  }
  async getReleaseByID(id, params) {
    const releases = await this.getReleases(params);
    return findRefByID(releases, id);
  }
  async getReleaseByLabel(label, params) {
    const releases = await this.getReleases(params);
    return findRefByLabel(releases, label);
  }
  async getTags(params) {
    try {
      const tagsForm = await this.getCachedRepositoryForm("tags", params);
      const url = new URL(tagsForm.action);
      if (this.accessToken) {
        url.searchParams.set("access_token", this.accessToken);
      }
      return await this.fetch(url.toString(), params);
    } catch (e) {
      const repository = await this.getRepository(params);
      return repository.tags;
    }
  }
  async buildQueryURL({
    signal,
    ...params
  } = {}) {
    const ref = params.ref || await this.getResolvedRefString();
    const integrationFieldsRef = params.integrationFieldsRef || (await this.getCachedRepository({ signal })).integrationFieldsRef || void 0;
    return buildQueryURL(this.endpoint, {
      ...this.defaultParams,
      ...params,
      ref,
      integrationFieldsRef,
      routes: params.routes || this.routes,
      brokenRoute: params.brokenRoute || this.brokenRoute,
      accessToken: params.accessToken || this.accessToken
    });
  }
  async resolvePreviewURL(args) {
    var _a, _b;
    let documentID = args.documentID;
    let previewToken = args.previewToken;
    if (typeof globalThis.location !== "undefined") {
      const searchParams = new URLSearchParams(globalThis.location.search);
      documentID = documentID || searchParams.get("documentId");
      previewToken = previewToken || searchParams.get("token");
    } else if (this.refState.httpRequest) {
      if ("query" in this.refState.httpRequest) {
        documentID = documentID || ((_a = this.refState.httpRequest.query) == null ? void 0 : _a.documentId);
        previewToken = previewToken || ((_b = this.refState.httpRequest.query) == null ? void 0 : _b.token);
      } else if ("url" in this.refState.httpRequest && this.refState.httpRequest.url) {
        const searchParams = new URL(this.refState.httpRequest.url).searchParams;
        documentID = documentID || searchParams.get("documentId");
        previewToken = previewToken || searchParams.get("token");
      }
    }
    if (documentID != null && previewToken != null) {
      const document = await this.getByID(documentID, {
        signal: args.signal,
        ref: previewToken,
        lang: "*"
      });
      const url = asLink(document, args.linkResolver);
      if (typeof url === "string") {
        return url;
      }
    }
    return args.defaultURL;
  }
  queryLatestContent() {
    this.refState.mode = "Master" /* Master */;
  }
  queryContentFromReleaseByID(releaseID) {
    this.refState = {
      ...this.refState,
      mode: "ReleaseID" /* ReleaseID */,
      releaseID
    };
  }
  queryContentFromReleaseByLabel(releaseLabel) {
    this.refState = {
      ...this.refState,
      mode: "ReleaseLabel" /* ReleaseLabel */,
      releaseLabel
    };
  }
  queryContentFromRef(ref) {
    this.refState = {
      ...this.refState,
      mode: "Manual" /* Manual */,
      ref
    };
  }
  async graphQLFetch(input, init) {
    const cachedRepository = await this.getCachedRepository();
    const ref = await this.getResolvedRefString();
    const unsanitizedHeaders = {
      "Prismic-ref": ref,
      Authorization: this.accessToken ? `Token ${this.accessToken}` : "",
      ...init ? init.headers : {}
    };
    if (cachedRepository.integrationFieldsRef) {
      unsanitizedHeaders["Prismic-integration-field-ref"] = cachedRepository.integrationFieldsRef;
    }
    const headers = {};
    for (const key in unsanitizedHeaders) {
      if (unsanitizedHeaders[key]) {
        headers[key.toLowerCase()] = unsanitizedHeaders[key];
      }
    }
    const url = new URL(
      input
    );
    url.searchParams.set("ref", ref);
    const query = url.searchParams.get("query");
    if (query) {
      url.searchParams.set(
        "query",
        minifyGraphQLQuery(query)
      );
    }
    return await this.fetchFn(url.toString(), {
      ...init,
      headers
    });
  }
  async getCachedRepository(params) {
    if (!this.cachedRepository || Date.now() >= this.cachedRepositoryExpiration) {
      this.cachedRepositoryExpiration = Date.now() + REPOSITORY_CACHE_TTL;
      this.cachedRepository = await this.getRepository(params);
    }
    return this.cachedRepository;
  }
  async getCachedRepositoryForm(name, params) {
    const cachedRepository = await this.getCachedRepository(params);
    const form = cachedRepository.forms[name];
    if (!form) {
      throw new PrismicError(
        `Form with name "${name}" could not be found`,
        void 0,
        void 0
      );
    }
    return form;
  }
  async getResolvedRefString(params) {
    var _a, _b;
    if (this.refState.autoPreviewsEnabled) {
      let previewRef;
      let cookieJar;
      if ((_a = this.refState.httpRequest) == null ? void 0 : _a.headers) {
        if ("get" in this.refState.httpRequest.headers && typeof this.refState.httpRequest.headers.get === "function") {
          cookieJar = this.refState.httpRequest.headers.get("cookie");
        } else if ("cookie" in this.refState.httpRequest.headers) {
          cookieJar = this.refState.httpRequest.headers.cookie;
        }
      } else if ((_b = globalThis.document) == null ? void 0 : _b.cookie) {
        cookieJar = globalThis.document.cookie;
      }
      if (cookieJar) {
        previewRef = getPreviewCookie(cookieJar);
      }
      if (previewRef) {
        return previewRef;
      }
    }
    const cachedRepository = await this.getCachedRepository(params);
    const refModeType = this.refState.mode;
    if (refModeType === "ReleaseID" /* ReleaseID */) {
      return findRefByID(cachedRepository.refs, this.refState.releaseID).ref;
    } else if (refModeType === "ReleaseLabel" /* ReleaseLabel */) {
      return findRefByLabel(cachedRepository.refs, this.refState.releaseLabel).ref;
    } else if (refModeType === "Manual" /* Manual */) {
      const res = await castThunk(this.refState.ref)();
      if (typeof res === "string") {
        return res;
      }
    }
    return findMasterRef(cachedRepository.refs).ref;
  }
  async fetch(url, params = {}) {
    const res = await this.fetchFn(url, {
      signal: params.signal
    });
    let json;
    try {
      json = await res.json();
    } catch (e) {
      if (res.status === 404) {
        throw new NotFoundError(
          `Prismic repository not found. Check that "${this.endpoint}" is pointing to the correct repository.`,
          url,
          void 0
        );
      } else {
        throw new PrismicError(void 0, url, void 0);
      }
    }
    switch (res.status) {
      case 200: {
        return json;
      }
      case 400: {
        throw new ParsingError(json.message, url, json);
      }
      case 401:
      case 403: {
        throw new ForbiddenError(
          "error" in json ? json.error : json.message,
          url,
          json
        );
      }
    }
    throw new PrismicError(void 0, url, json);
  }
}

const getEndpoint = (/* unused pure expression or super */ null && (getRepositoryEndpoint));
const predicates = (/* unused pure expression or super */ null && (predicate));
const Predicates = (/* unused pure expression or super */ null && (predicate));


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 89426:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"id":"google-analytics","description":"Install a Google Analytics tag on your website","website":"https://analytics.google.com/analytics/web/","scripts":[{"url":"https://www.googletagmanager.com/gtag/js","params":["id"],"strategy":"worker","location":"head","action":"append"},{"code":"window.dataLayer=window.dataLayer||[];window.gtag=function gtag(){window.dataLayer.push(arguments);};gtag(\'js\',new Date());gtag(\'config\',\'${args.id}\')","strategy":"worker","location":"head","action":"append"}]}');

/***/ }),

/***/ 27395:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"id":"google-maps-embed","description":"Embed a Google Maps embed on your webpage","website":"https://developers.google.com/maps/documentation/embed/get-started","html":{"element":"iframe","attributes":{"loading":"lazy","src":{"url":"https://www.google.com/maps/embed/v1/place","slugParam":"mode","params":["key","q","center","zoom","maptype","language","region"]},"referrerpolicy":"no-referrer-when-downgrade","frameborder":"0","style":"border:0","allowfullscreen":true,"width":null,"height":null}}}');

/***/ }),

/***/ 88420:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"id":"youtube-embed","description":"Embed a YouTube embed on your webpage.","website":"https://github.com/paulirish/lite-youtube-embed","html":{"element":"lite-youtube","attributes":{"videoid":null,"playlabel":null}},"stylesheets":["https://cdn.jsdelivr.net/gh/paulirish/lite-youtube-embed@master/src/lite-yt-embed.css"],"scripts":[{"url":"https://cdn.jsdelivr.net/gh/paulirish/lite-youtube-embed@master/src/lite-yt-embed.js","strategy":"idle","location":"head","action":"append"}]}');

/***/ }),

/***/ 28843:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"404":{"title":"404 - Seite nicht gefunden","cta":"Zurück zur Hauptseite"},"account":{"herotitle":"Mein Konto","title_login":"Greifen Sie auf mein Konto zu","subtitle":"Melden Sie sich mit Ihrer E-Mail-Adresse an","successfull_register":"Herzliche Glückwünsche ! Wenn Ihr Konto erstellt wurde, erhalten Sie eine Bestätigungs-E-Mail.","login_email":"Email","login_password":"Passwort","forget_password_link":"Passwort vergessen ?","guest_link":"Weiter als Gast","error_login":"Ihre E-Mail-Adresse oder Ihr Passwort stimmen nicht überein. Versuchen Sie es erneut","login_button":"Einloggen","login_to_see_price":"Melden Sie sich an, um unsere Preise einzusehen und zu bestellen","register_link":"Kein Account? Jetzt registrieren","title":"Jetzt registrieren","login_title":"Kennungen","gender_label":"Höflichkeit","gender_female":"Frau","gender_male":"Herr","firstname":"Vorname","lastname":"Nachname","email":"Email","phone":"Telefon","vatnumber":"Steuernummer","company":"Firma","password":"Passwort","repeat_password":"Bestätige dein Passwort","address_required":"Bitte geben Sie eine Lieferadresse ein","address_title":"Adresse","address":"Adresse","postal_code":"Postleitzahl","country":"Land","town":"Stadt","register_button":"Erstelle mein Konto und fahre fort","login_link":"Haben Sie bereits ein Konto? Einloggen","password_error":"Ihre Passwörter sind nicht gleich","title_data":"Bleib ruhig","text_data":"Ihre Daten sind geschützt","forget_title":"Passwort vergessen","forget_subtitle":"Sie erhalten eine E-Mail, um ein neues Passwort zu erstellen","button_recup":"Eine E-Mail senden","to_login_link":"Verbindung zurückgeben","button_continue_as":"Weiter als","disconnect_button":"Ausloggen","guest_link1":"Weiter als Gast","info_link":"Meine Information","hi":"Hallo","paragraph1":"Hier finden Sie Ihr Dashboard. Sie können Ihre aktuellen Bestellungen verfolgen und die Rückgabe der eingegangenen Bestellungen verwalten.","log_out_button":"Ausloggen","block_title":"Häufig gestellte Fragen","date":"Kommen auf","leasing_date_from":"Vermietung vom","leasing_date_to":"bis","return":"Zurück zu einem Relaispunkt","returned_at":"Geliefert am ","command":"Best.-Nr.","manage_shippment":"Verwalten Sie meine Lieferung","manage_shippment_sentence":"Um Ihre Bestellung zu verfolgen, zu ändern oder zu stornieren","follow_my_package":"Folgen Sie meinem Paket","no_command":"Keine Bestellungen für den Moment!","go_to_shop":"Zum Laden gehen","back_link":"Rückkehr","title_information":"Meine Daten","cancel_subscription":"Abonnement kündigen","cancel_subscription_title":"Wie kann ich mein Abonnement kündigen?","cancel_subscription_button":"Ich habe verstanden!","cancel_subscription_paragraph":"Das Kündigen ist ganz einfach! Schicken Sie einfach alle Artikel zurück, die sich noch in Ihrem Besitz befinden. Sobald wir die Artikel in unserem Lager erhalten haben, wird Ihr Abonnement automatisch gekündigt. Die Rechnung für den letzten Monat des Abonnements wird anteilig berechnet.","your_infos":"Ihre Informationen","modification_successfull":"Ihre Daten wurden geändert","error_happend":"Ein Fehler ist aufgetreten. Versuch es noch einmal!","mail_used":"Diese E-Mail-Adresse wird bereits verwendet","error_disabled":"Dein Konto ist nicht aktiviert","info_button":"Ändere meine Informationen","password_modif_succes":"das Passwort wurde erfolgreich geändert","password_button":"ändere mein Passwort","adress_title":"Ihre Lieferadresse","address_button":"Ändere meine Adresse","link_name":"Wie es funktioniert?","slides_title":"Meine Rückkehr in drei Schritten","verify_title":"Kontobestätigung läuft","confirm_account":{"title":"Ihr Konto wurde validiert","cta_shop":"Jetzt mieten","cta_account":"Mein Konto anzeigen","error":"Fehler, Umleitung zum Empfang"},"password_reset":{"title":"Aktualisieren Sie Ihr Passwort","description":"Bitte füllen Sie das Formular mit Ihrem neuen Passwort aus.","error":"Fehler, Die Anfrage war nicht erfolgreich","success":"Wenn Ihre Passwortänderung berücksichtigt wurde, werden Sie zur Anmeldeseite weitergeleitet."},"newsletter":"Abonnieren Sie den Newsletter","email_send":"E-Mail gesendet","continue":"mach weiter","text":"Text","actual_password":"Jetziges Passwort","new_password":"Neues Passwort","error_phone":"Bitte geben Sie eine richtige Telefonnummer ein.","next":"Nächster","cancelled":"storniert","desc_info":"* Durch die Eingabe Ihrer E-Mail-Adresse erklären Sie sich damit einverstanden, unsere Neuigkeiten, unsere kommerziellen Angebote und Einladungen zu unseren privaten Verkäufen zu erhalten und akzeptieren unsere Datenschutzbestimmungen.","email_not_send":"Die E-Mail-Adresse ist nicht in der Datenbank. Versuchen Sie es mit einer anderen E-Mail-Adresse.","address_button_create":"Meine Lieferadresse hinzufügen","warning":{"text":"Bitte beachten Sie, dass Sie keine registrierte Adresse haben, bitte geben Sie eine Adresse in Ihren Daten an","cta":"Meine Adresse hinzufügen"},"street_number":"Nr.","search_address":{"helper_add":"Um Ihre Lieferadresse hinzuzufügen, geben Sie Ihre Adresse in das Feld unten ein.","helper_change":"Um Ihre Lieferadresse zu ändern, geben Sie Ihre Adresse in das Feld unten ein."},"password_strength_error":"Ihr Passwort muss enthalten: mindestens 10 Zeichen, einen Großbuchstaben, einen Kleinbuchstaben, ein Sonderzeichen und eine Zahl.","address_details":"Zusätzliche Adresse (Gebäude, Stockwerk, Code etc.)","address_area":"Wohnung, Stockwerk, Gebäude, etc.","confirm_return":{"title":"Ihre Produktrückgabe wurde berücksichtigt","cta_shop":"Jetzt mieten","cta_account":"Mein Konto ansehen","error":"Fehler, Weiterleitung zu meinem Konto","rdv":"Termin"},"review_placeholder":"Bitte wählen Sie eine Antwort aus der Liste","register_disable":"Die Registrierung für unseren Mietservice ist leider nicht mehr möglich.","cancel_order":{"cta_modal":"cancelar mi pedido\\n","modal_title":"Meine Bestellung stornieren","modal_warn":"Möchten Sie die Bestellung wirklich stornieren?","modal_cta":"abbrechen"},"buy":"Kaufen","order_download_invoice":"Laden Sie Ihre Rechnung herunter","order_download_invoice_error":"Beim Herunterladen ist ein Fehler aufgetreten","payment_method":{"title":"Zahlungsmittel","subtitle":"Registrierte Zahlungsmethode:","card":"Karte ","ending_by":"endet mit ","cta_replace":"Zahlungsmethode ersetzen","modal_title":"Zahlungsmethode ersetzen","modal_description":"Bitte beachten Sie, dass Sie durch die Änderung Ihrer Zahlungsmethode Ihre bisherige Zahlungsmethode löschen.","modal_cta":"Ersetzen","modal_error":"Technischer Fehler. Bitte versuchen Sie es später erneut.","modal_success":"Ihre Zahlungsmethode wurde geändert"},"dkt_login":"Mit deinem Decathlon-Konto","information_validation":{"main_title":"Ihr Konto wurde erstellt !","subtitle":"Überprüfung von Informationen","description":"Im Rahmen der Nutzung unseres Vermietungsportals benötigen wir folgende Angaben: ","confirmation_button":"Bestätigen Sie meine Informationen"},"sso_login":{"dkt":"Mit deinem Decathlon-Konto","cultura":"Mit Ihrem Cultura-Konto","ciam":"Mit Azure AD CIAM"},"external_account_text":"Meine Daten in meinem Kundenkonto ändern","take_back_date":"Datum","order_list_title":"Meine Bestellungen","take_back_list_title":"Bestelldatum","order_details_open":"Meine Bestellung verwalten","order_second_hand_details":"Meine gebrauchten Artikel verwalten","order_details_manage_cancel":"Stornieren","order_details_generate":"Erstellen Sie den Retourenschein","order_details_download":"Klicken Sie hier, um Ihren Rücksendeschein herunterzuladen","return_label_unavailable":"Ihr Rücksendeetikett ist noch nicht verfügbar. Es wird verfügbar sein, sobald Ihre Bestellung versendet wurde.","product_returned":"Dieser Artikel wurde zurückgegeben","wish_list_link":"Meine Wunschliste","returning_reason_label":"Rücksendegrund","returning_reason_placeholder":"Wählen Sie einen Rücksendegrund","returning_reason_comment_label":"Zusätzlicher Kommentar","returning_reason_comment_placeholder":"Bitte geben Sie zusätzliche Details zu Ihrem Rücksendegrund an"},"orders":{"error":"Ein Fehler ist aufgetreten. Versuchen Sie es erneut!","confirm_return":{"title":"Wollen Sie wirklich einen Rücksendeschein für Ihre Auswahl erstellen?","cta":"Rücksendeschein erstellen","cancel":"Stornieren","reason":"Rücksendegrund","reason_placeholder":"Bitte geben Sie die Rücksendegrund ein"}},"banner":{"text":"Covid-19: Wir garantieren eine regelmäßige Reinigung und Desinfektion aller Produkte"},"basket":{"kit_price":"Dein Kit","duration":"Ihr Abonnement","for_short":"zum","assurance":"Versicherung","free":"Frei","reduction":"Rabatt","total":"GESAMT","delete_basket":"Korb entfernen","continue":"Fortsetzen","product":"Artikel","return_date":"Rückflugdatum","whenever_you_want":"Wann du willst","sub_engagement":"Einmonatige Verpflichtung","current_subscription":"Mein aktuelles Abonnement","check_on_account":"Siehe auf meinem Konto","to_pay_this_month":"Diesen Monat bezahlen","newarticles":"Für Ihre neuen Artikel aus","to":"beim","error_stock":"Ein Produkt ist nicht mehr in ausreichender Menge verfügbar","shipping":"Lieferung","products":"Produkte","error_basket":"Ihr aktuelles Abonnement und die Anzahl der ausgewählten Produkte erlauben es Ihnen nicht, Ihre Bestellung fortzusetzen","total_without_shipping":"Gesamt ohne Lieferung","total_weight":"Gesamtgewicht","try_out":"Passend zu","error_tryout":"Sie müssen mindestens so viele Zimmer zu vermieten haben, wie es Zimmer zum Ausprobieren gibt","total_with_subscription":"Gesamt","total_without_subscription":"Gesamt","showDetails":"Lieferdetails anzeigen","hideDetails":"Lieferdetails ausblenden","rentTotal":"Vermietung","buyTotal":"Kaufen","months":"Monate","withoutShipping":"(ohne Versand)","engagement":"Abonnement ohne Verpflichtung.","debit":"Am Ende des Monats eingesammelt.","continue_shop":"Mit dem Einkaufen fortfahren","empty":"Dein Warenkorb ist noch leer","drawer":{"title":"Warenkorb","close":"Schließen"},"reduction_text_explication":"Fügen Sie Ihren Promo-Code an der Kasse hinzu","gift_card_text":"gift_card_text","gift_card_explanation":"gift_card_explanation","deposit":"Kaution","deposit_explanation":"Der Betrag wird nach Rückgabe der Produkte zurückgezahlt","remainingInStock":"Reste in Lager: {{count}}","b2b_shipping_costs_link":"Versandkosten nach Menge","total_without_shipping_excl_vat":"Gesamt HT","delivery_fees_excl_vat":"Lieferkosten HT","vat":"MwSt"},"confirmation":{"email":"Email","text":"Covid-19: Wir garantieren eine regelmäßige Reinigung und Desinfektion aller Produkte","title_complements":"Erforschen Sie weiter","desc_complements":"Mit diesem Rabattcode!","codetext":"Mit dem Code erhalten Sie 5% Rabatt auf diese Produkte","codename":"LIZEECODE","title":"Bestellübersicht","articles_return":"Artikel, bei denen ich zurückkehren muss","generate_vouchers":"Generieren Sie den Rückgabeschein","articles_to_send":"Die Artikel, die ich rund um die erhalten werde","account_cta":"Zugriff auf mein Konto","to_return":"zurückgeben","order_number":"Bestellnummer"},"emails":{"browser_link":"Öffnen Sie diese E-Mail im Browser","signature":"John Doe,\\nvom Vermietungsteam der Marke Lizee","bottom_section_title":"Ihre Rückkehr","bottom_section_content":"Wie organisieren Sie Ihre Rückkehr? Es ist einfach, folgen Sie der Anleitung.","footer":"Die Brand-Teams wünschen Ihnen einen schönen Tag!","copyright":"In Übereinstimmung mit dem Gesetz \\"Informatique et Libertés\\" vom 6. Januar 1978 können Sie jederzeit verlangen, auf personenbezogene Daten zuzugreifen, diese zu korrigieren oder zu löschen oder sich ihrer Behandlung durch Brand zu widersetzen.\\nDiese E-Mail ist eine Bestätigung des Eingangs Ihrer Bestellung und bestätigt den Mietvertrag. Eine E-Mail zur Bestätigung der Ausgabe Ihrer Artikel wird in Kürze an Sie gesendet.","order_confirm_title":"Vielen Dank für Ihre Bestellung!","order_confirm_main_text":"Wir haben Ihre Bestellung Nr. XXXXXX erhalten. Es wird so schnell wie möglich versendet und kommt je nach gewählter Versandart an einem Relaispunkt / bei Ihnen zu Hause oder bei Ihnen zu Hause an.","order_confirm_cta_text":"Folge uns!","order_summary_title":"Bestellübersicht","order_id_text":"Bestellnummer:","order_start_subscription_date":"Startdatum des Abonnements","order_renting_start":"Mietbeginn","order_renting_end":"Rückflugdatum","order_renting_duration":"Standortdauer","order_shipping":"Lieferadresse:","order_shipping_method":"Hauslieferung","order_products":"Produktliste","order_paid_text":"Bezahlt","order_tax_text":"20% MwSt. Inbegriffen","order_pay_method":"Zahlungsmethode","order_pay_method_desc":"Kreditkarte endet mit"},"faq":{"subtitle":"Melden Sie sich mit meiner E-Mail-Adresse an","title":"Jetzt registrieren"},"funnel":{"email":"Email","phone":"Telefon","address":"Adresse","postal_code":"Postleitzahl","country":"Land","free":"Frei","return_button":"Rückkehr","delivery_title":"1. Lieferung","delivery_description":"Sie erhalten Ihr Paket X Tage im Voraus. ","delivered_on":"Geliefert am ","return_before":"Vorher zurückkommen","return_title":"2. Zurück","home_delivery":"Hauslieferung","change_my_address":"Ändere meine Adresse","shop_delivery":"Zustellung an die Paketstelle","choose":"Wählen","next1":"Nächster","titleform":"Geben Sie Ihre Zahlungsinformationen ein","pay":"Zahlen","first_name":"Vorname","last_name":"Nachname","city":"Stadt","next":"Nächster","create_account_link":"Ein Konto erstellen","continue_with_account":"Fahren Sie mit dem Konto fort","information":"Information","shipping":"Lieferung","step":"Schritt","coupon_title":"Haben Sie einen Gutscheincode?","coupon_cta":"Anwenden","coupon_applied":"Dieser Promo-Code wird angewendet:","coupon_success":"Dieser Gutscheincode ist gültig","coupon_error":"Haben Sie einen Gutscheincode?","no_shipping_available":"no_shipping_available","payment":{"title":"Titel","success":"Erfolg","progress":"Fortschritt","cgu":"cgu","retractation_agreement":"Ich erkenne ausdrücklich an, dass ich auf mein Widerrufsrecht verzichte, da mein Mietbeginn vor Ablauf der 14-tägigen Widerrufsfrist erfolgt.","custom_cgu_link":"Zugriff auf CGLs","payment_accordion":{"card_title":"Sichere Zahlung per Kreditkarte","card_tagline":"Zahlung garantiert durch Stripe™. Akzeptierte Karten","paypal_title":"Paypal"},"caution_info":"Vor der Zahlung müssen Sie die Kaution für Ihre Artikel bezahlen.","caution_explanation":"Diese Kaution wird nach Rückgabe der Produkte in gutem Zustand erstattet.","caution_button":"Kaution bezahlen","pay_caution":"Kaution bezahlen","caution_paid":"Kaution erfolgreich bezahlt! Sie können jetzt mit der Zahlung fortfahren.","caution_expired":"Die Kaution ist abgelaufen. Bitte erstellen Sie eine neue Kaution.","caution_error":"Beim Verarbeiten der Kaution ist ein Fehler aufgetreten.","caution_creation_error":"Kaution konnte nicht erstellt werden. Bitte versuchen Sie es erneut.","caution_token_mismatch":"Ungültige Kaution für diese Bestellung. Bitte versuchen Sie es erneut.","processing_caution":"Kaution wird verarbeitet...","swikly_deposit_description":"Sicherheitskaution für Mietartikel","errors":{"stock":"Ein Produkt in Ihrem Warenkorb ist nicht mehr verfügbar","stock_error_intro":"Die folgenden Produkte sind nicht mehr in ausreichender Menge verfügbar:","stock_error_footer":"Bitte aktualisieren Sie Ihren Warenkorb, bevor Sie mit der Zahlung fortfahren.","availability_check_failed":"Die Verfügbarkeitsprüfung ist aus technischen Gründen fehlgeschlagen. Bitte versuchen Sie es in Kürze erneut.","default":"Die Karte wurde aus einem unbekannten Grund abgelehnt. Wenden Sie sich für weitere Informationen an den Kartenaussteller","expired_card":"Die Kreditkarte ist abgelaufen. Sie müssen eine andere Zahlungsmethode verwenden.","email":"Ungültige E-Mail-Adresse.","insufficient_funds":"Die Kreditkarte ist nicht ausreichend gedeckt, um den Kauf zu tätigen. Sie müssen eine andere Zahlungsmethode verwenden.","lost_card":"Die Zahlung wurde abgelehnt, weil die Kreditkarte für verloren erklärt wurde. Wenden Sie sich für weitere Informationen an den Kartenaussteller","stolen_card":"Die Zahlung wurde abgelehnt, weil die Kreditkarte als gestohlen gemeldet wurde. Wenden Sie sich für weitere Informationen an den Kartenaussteller","incorrect_cvc":"Der CVC-Code ist falsch. Sie müssen es erneut mit dem richtigen CVC versuchen.","processing_error":"Bei der Verarbeitung der Kreditkarte ist ein Fehler aufgetreten. Sie müssen die Zahlung erneut versuchen. Wenn es immer noch nicht behandelt werden kann, versuchen Sie es später erneut.","code_operator_label":"Bitte geben Sie Ihren Validierungscode ein","code_operator_placeholder":"Beispiel: 12345","operator_button_validation":"Bestätige deine Bestellung","wrong_code_operator":"Der eingegebene Code ist ungültig"},"error":"Ein Fehler ist aufgetreten"},"invalid_tel":"Bitte geben Sie eine richtige Telefonnummer ein.","coupon_label":"Gutscheincode","your_rental_from":"Ihre Anmietung von","your_rental_to":"zu","show_cart":"Warenkorb anzeigen","hide_cart":"Warenkorb ausblenden","toBeDetermined":"Noch zu bestimmen"},"general":{"home":"Home","selection":"Die gesamte Auswahl","return":"Zurück zu einem Relaispunkt","baseline":"Vermietung. Speichern. Genießen","footer_tagline":"Vom Verkauf bis zur Vermietung","footer_top_baseline":"Eine Schadensversicherung ist inbegriffen","footer_top_link_label":"Alle Produkte anzeigen","contact_us_button":"Kontaktiere uns","cgl":"Allgemeine Mietbedingungen","policy":"Datenschutz-Bestimmungen","small_text_under_calendar":"Je mehr Sie mieten, desto weniger zahlen Sie!","start_button":"Start","confirm_button":"Bestätigen","delivered":"Geliefert am oder vor","meta_description":"Hier ist das Meta Desc","meta_title":"Hier ist ein Titel","meta_url":"http://whitelabel.lizee.io/","you_save":"Du sparst","my_account":"Mein Konto","FAQ":"FAQ","add_a_title":"Es ist ein Titel","add_a_description":"Dies ist eine Beschreibung","add_a_subtitle":"Dies ist ein Untertitel","add_a_text":"Text hinzufügen","from":"Von","month":"Monat","day":"Tag","stock_texts":{"few_products_left":"Mehr als ein paar Produkte!","back_soon":"Bald zurück","in_stock":"Auf Lager"},"search_address":{"cta":"Forschen","incomplete":"Die eingegebene Adresse ist nicht vollständig. Geben Sie Ihre Adresse mit Straße, Ort und Postleitzahl an.","no_results":"Keine Adresse in unserer Datenbank gefunden. Bitte geben Sie eine andere Adresse ein.","excluded":"Die Zustellung wird für diese Adresse nicht unterstützt.","invalid_country":"Die Lieferung wird für dieses Land nicht unterstützt.","label":"Finden Sie Ihre Lieferadresse","same_address":"Liefer- und Rechnungsadresse sind gleich","label_billing":"Finden Sie Ihre Rechnungsadresse","placeholder":"Beispiel: 15 rue de mailand Paris","change_delivery_point":"bearbeiten","postcode_missing":"Bitte geben Sie eine Postleitzahl ein"},"search_bar":{"input_label":"Suche nach einem Produkt","input_placeholder":"Suche nach einem Produkt","button_label":"Suche nach einem Produkt"},"previous_button":"Vorherige","sizes":"Größen","month_short":"Monat_kurz","day_short":"/T","copyright":"Urheberrechte ©","card_number":"Kartennummer","expiry_date":"Verfallsdatum","cvc_code":"CVC Code","morning":"Morgen","afternoon":"Nachmittag","evening":"Abend","fullDay":"Ganzer Tag","flex_price_information":"Preise basieren auf einem 30-Tage-Monat","month_without_space":"/Monat","handle_cookies":"Cookies verwalten","days_plural":"Tage","day_singular":"Tag","delivery_point":"Ergebnisse in der Nähe von: ","menu":{"close":"Nah dran"},"main_menu":{"item":"Hauptmenü","subitem":"Untermenü"},"holder_name":"Name des Besitzers","unit":"/ Einheit","unit_short":"/u","change_language_modal_title":"Sprache ändern","change_language_modal_text":"Seien Sie vorsichtig, Sie sind dabei, die Sprache zu ändern. Wenn Sie Artikel in Ihrem Warenkorb haben, geht Ihr Warenkorb verloren.","change_language_modal_cancel_text":"abbrechen","change_language_modal_validation_text":"Sprache ändern","no_mixed_basket":{"second_hand_product_in_basket_title":"In Ihrem Warenkorb befindet sich ein gebrauchter Artikel","rental_product_in_basket_title":"In Ihrem Warenkorb befindet sich eine Miete","second_hand_product_in_basket_text":"Sie können nicht gleichzeitig eine Bestellung für einen Miet- und einen Gebrauchtartikel aufgeben. Wenn Sie einen Mietartikel aufgeben möchten, müssen Sie eine weitere Bestellung aufgeben oder den Gebrauchtartikel aus Ihrem Warenkorb entfernen.","rental_product_in_basket_text":"Sie können nicht gleichzeitig eine Bestellung mit einem Miet- und einem Gebrauchtartikel aufgeben. Wenn Sie einen Gebrauchtartikel kaufen möchten, müssen Sie eine weitere Bestellung ohne Mietartikel aufgeben oder den Mietartikel aus Ihrem Warenkorb entfernen."},"vat":{"included":"Brutto","excluded":"Netto"}},"homepage":{"maintitle":"Vermietung. Speichern. Genießen. ","descriptiontext":"Mieten Sie unsere Produkte auf Anfrage. ","cta_pack_label":"Siehe die Packungen","titlehowitworks":"Wie es funktioniert ?","deschowitworks1":"Buchen Sie Ihr Kit online und erhalten Sie es zu Hause oder an einem Abholpunkt Ihrer Wahl in Frankreich. Das Kit ist 2 Tage vor Ihrer Abreise verfügbar und Sie haben 2 Tage Zeit, es nach dem Ende Ihrer Wanderung zurückzugeben. ","deschowitworks2":"Bonus?\\nSie können Ihr Kit von Ihrem Trekkingstandort zurückgeben. Geben Sie Ihr Paket mit Ihrem in Ihrem Paket enthaltenen Rücksendeetikett an einem beliebigen Chronopost-Relaispunkt auf dem französischen Festland ab. / Sie können Ihr Kit von Ihrem Wanderort zurückgeben. Das Rücksendeetikett ist in Ihrem Paket enthalten und Sie können Ihr Kit an jedem Chronopost-Punkt in Frankreich abgeben. ","titletestimonials":"Sie haben es versucht ","section_title_savings":"Je länger Sie mieten, desto weniger zahlen Sie: ","link_label_savings":"Beginnen Sie zu mieten","start_savings_text":"Sie mieten für","end_savings_text":"du sparst","buy_savings_text":"Wenn du kaufst","rent_savings_text":"Wenn Sie mieten","saving_mentions":"* Betrag basierend auf den Durchschnittspreisen unserer Produkte","featured_product_title":"Ein Beispiel mit unserem Lieblingsprodukt:","featured_product_name":"Grüner und blauer 20L Rucksack","featured_product_link_label":"Optionen erkunden","title_commitment":"Wusstest du ?","description_commitment":"Ihre Wahl wird sich positiv auf den Planeten auswirken: Wenn Sie mit Lizee mieten, sparen Sie durchschnittlich 350 g CO2 pro Produkt!","section_title_community":"Ihre Ersparnisse bei der Vermietung:","title_community":"Unsere Mieterkunden haben bereits gespart: ","amount_community":"35.000 €","subtitle_universe1":"Titel der Taxa-Produkte","paragraph_universe1":"Beschreibung für Taxa-Packs","subtitle_universe2":"Titel der Taxa-Packs","paragraph_universe2":"Beschreibung für Taxa-Packs","categorie":"Sylius Taxon","rent":"Alquilar","partner":"Partner"},"instagramwall":{"title":"Jetzt registrieren","desc":"Teile deine Erinnerungen mit #Lizee ","buttontext":"Folge uns !"},"packs":{"from":"Von","month":"Monat","buttontext":"Folge uns !","header_title":"Packungen","herotitle":"Entdecken Sie unsere Rucksäcke ","titlepacks":"Packungen für Sie entworfen","packsparagraph":"Wählen Sie aus den unten stehenden Paketen oder erstellen Sie Ihre eigenen! ","shipping_description":"Kostenlose Lieferung nach Hause ab einem Bestellwert von 30 €!","pack_to_shop_button":"Erstellen Sie Ihren Rucksack","fake_pack_title":"Erstellen Sie Ihr eigenes Paket","fake_pack_button":"Weitere Produkte anzeigen","select":"zur Auswahl","title_size_modale":"Wählen Sie die Größe aus, um sie Ihrem Warenkorb hinzuzufügen:","victim_of_success":"Opfer seines eigenen Erfolgs","link_to_single":"Siehe das Paket"},"page":{"title":"Titelblatt","content":"Inhaltsseite. Lorem ipsum dolor sitzen amet consectetur adipisicing elit. Corrupti animi iure iusto ex explicabo aspernatur Commodi Voluptatum, Laudantium voluptatem corporis."},"sso":{"errors":{"41000083":"The account used is not a professional account.","default":"An unexpected error occurred."}},"privacy":{"title":"Jetzt registrieren","wysiwyg":"Letzte Aktualisierung: 12. März 2020\\n","showCookie":"Cookies verwalten"},"products_to_buy":{"products_category":"Produkte zu kaufen","buy_button":"Kaufen","see_more":"Finde mehr heraus"},"rental_terms":{"title":"Jetzt registrieren","wysiwyg":"Letzte Aktualisierung: 12. März 2020\\n"},"shop":{"choose":"Wählen","header_title":"Packungen","herotitle":"Entdecken Sie unsere Rucksäcke ","title_size_modale":"Wählen Sie die Größe aus, um sie Ihrem Warenkorb hinzuzufügen:","victim_of_success":"Opfer seines eigenen Erfolgs","titleshop":"Mieten Sie aus der besten Auswahl","shopdescription":"Wählen Sie Ihre Favoriten! ","shippingdescription":"Kostenlose Lieferung nach Hause ab einem Bestellwert von 30 €!","shop_to_packs_button":"Siehe die Packungen","filter":"Filter","filter_by_taxons":"Nach Kategorien filtern","filter_apply":"Filter anwenden","availableOnly":"Nur verfügbare Produkte anzeigen","classic_sub":{"our_rates":"Unsere skalierbaren Pakete","adjustable_rate":"Ihr Paket passt sich Ihrer Auswahl an.","articles":"Artikel","maximum":"maximun","article":"Artikel"},"filters":"Filter","pack_size_modal_cta_add":"In den Warenkorb legen","pack_size_modal_cta_return":"Zurück zu den Packungen","filters_dropdown_label":"Wählen Sie","max_item_in_cart":"Maximales Produkt pro Warenkorb erreicht","prev":"Vorherige","next":"Folge","no_stock_available":"Keine Produkte in dieser Kategorie verfügbar.","search_not_found":"Kein Produkt entspricht dieser Suche","filters_modale_title":"filter_modale_title","autocomplete_search_placeholder":"Suche {{attributeName}}...","autocomplete_no_results":"Keine Ergebnisse gefunden","autocomplete_no_values":"Keine Werte verfügbar","autocomplete_loading":"Laden...","autocomplete_load_more":"Mehr laden","close_button":"close_button","categories_title":"Kategorien_Titel","apply_button":"apply_button","accordion_shop_title":"akkordeon_shop_titel","and":"und","price_min_label":"Min","price_max_label":"Max","sort":"Sortieren","filter_and_sort":"Filtern & sortieren","filter_title_in_drawer":"Filtern","sort_by_price_asc":"Preis aufsteigend","sort_by_price_desc":"Preis absteigend","sort_by_date_asc":"Älteste zuerst","sort_by_date_desc":"Neueste zuerst","error_loading_products":"Ein Fehler ist aufgetreten, während die Produkte geladen wurden. Bitte versuchen Sie es später erneut.","shipping_costs":{"number_of_articles":"Anzahl der Artikel","round_trip_cost":"Hin- und Rückfahrtkosten","title":"Versandkosten im schlimmsten Fall (Inkl. Versicherung)"}},"single_product":{"choose_button":"Wählen","associations_title":"Das könnte Sie auch interessieren:","try_out_button":"Versuchen zu:","try_out_tooltip":"Pro gemietetem Zimmer kann nur ein Zimmer ausprobiert werden","buy_button":"Kaufen","choose_button_tooltip":"Wählen Sie eine Größe aus, um sie in den Warenkorb zu legen","display_total_rental_price":"Gesamtmietpreis","availability_checker":{"modal_close":"Nah dran","text":"Dieser Artikel ist an diesen Daten nicht verfügbar.","link":"Siehe Verfügbarkeit","modal_title":"Verfügbarkeit prüfen","modal_description":"Der Artikel ist nicht verfügbar, wenn die Daten durchgestrichen sind"}},"statements":{"bottom_sentence":"Je mehr Sie reisen, desto mehr sparen Sie!","link":"Mehr Informationen"},"subscription_order":{"change_cta":"Bearbeiten","cancel_cta":"Abbrechen","rate":"Pauschale","handle_return_cta":"Verwalten Sie die Rücksendung meiner Artikel","my_subscription":"Mein Abonnement :","taken_every":"Jedem genommen","of_the_month":"des Monats","per_month":"Pro Monat","articles_max":"max Artikel","select_all_and_stop":"Wählen Sie alle aus und beenden Sie mein Abonnement","generate_the_return_slip":"Generieren Sie den Rückgabeschein","continue":"Fortsetzen","size":"Schnitt :","month":"Monat","bottom_sentence":"Ein Rückschein ist am Ende der Bestellung erhältlich. Alles über Retouren","funnel":{"current_subscription":" haben Sie bereits ein aktuelles Abonnement.","subtitle":"Sie können Ihre alten Artikel zurückgeben, um Ihr Abonnement anzupassen. Wenn Sie Ihre Artikel behalten möchten, fahren Sie mit dem nächsten Schritt fort.","skip_step":"überspringe diesen Schritt"},"returned_product_title":"Produkte, die diesen Monat zurückgegeben wurden","returned_product_desc":"Diese Produkte wurden empfangen und werden bei Ihrer nächsten Zahlung endgültig aus Ihrem Bereich entfernt.","canceled_order_title":"Stornierte Bestellungen","canceled_order_desc":"cancelled_order_desc","refunded_order_title":"Zurückerstattete Bestellungen","refunded_order_desc":"erstattete_bestellung_desc","sub_finished":{"title":"Abo beendet!","desc":"Wir sind traurig, Sie gehen zu sehen. Ihre letzte Abbuchung wird nach Rückgabe der Artikel für den laufenden Monat anteilig verrechnet."},"returned_date":"Zurückgekehrt am","link_download_return":"Klicken Sie hier, um Ihren Rücksendeschein herunterzuladen","invoice_this_month":"Ihre Rechnung in diesem Monat:","invoice_explanation":"Wir berechnen den Rechnungsbetrag jeden Monat nach dem Anteil der im laufenden Monat gemieteten und zurückgegebenen Produkte","subscription_start_date":"Ihr Abonnement beginnt am:","subscription_date_explanation":"Ihr Abonnement beginnt 5 Tage nach dem Datum Ihrer ersten Bestellung. Dieses Datum berücksichtigt die Vorbereitungszeiten für Ihre Bestellung und die Lieferzeiten.\\n Ab dem Start des Abonnements wird Ihnen monatlich zum Jahrestag in Rechnung gestellt. Der Produktrückgabeservice steht Ihnen nach dem Start Ihres Abonnements zur Verfügung.","bought_product_title":"Gekaufte Produkte:","bought_product_desc":"gekauftes_Produkt_desc","product_not_eligible_for_return":"Produkt kann nicht zurückgegeben werden","tooltip_product_not_eligible_for_return":"Rückgabe ab dem Datum des Abonnements möglich"},"customer_survey":{"main_title":"Zufriedenheitsumfrage","subtitle":"Helfen Sie uns, unsere Dienstleistungen zu verbessern","let_a_message":"Eine Nachricht ?","satisfaction":"Befriedigung","dropdown_title":"Rückgabestatus","notes":"Anmerkungen","observation":"Eine Beobachtung ?","message":"Deine Nachricht","send":"senden","contact_title":"Kontakttitel","error_fields":"Fehlerfelder","desc_contact":"Hinterlassen Sie uns eine Nachricht!"},"snackbar_message":{"add":"Das Produkt liegt jetzt in","delete":"Das Produkt liegt jetzt nicht mehr in","remove":"Das Produkt liegt jetzt nicht mehr in","add_multiple":"Die Produkte liegen jetzt in","limit":"Du hast die maximale Anzahl an Produkten in einer Bestellung erreicht.","rental_range_selected_is_blocked":"El período de alquiler seleccionado no está disponible. Por favor, elija otro período de alquiler.","cart":"deinem Warenkorb","max":"Für dieses Produkt ist die gewählte Menge leider aktuell nicht auf Lager.","add_tryout":"Das Produkt wurde zur Montage hinzugefügt.","profilUpdated":"Ihre Informationen wurden erfolgreich aktualisiert."},"instore":{"modale_title":"Wählen Sie Ihren Shop","modale_shop_name":"Name des Ladens","modale_informations":"Information","modale_choose_shop":"Wähle ein Geschäft","modale_details":"Kontaktdetails","modale_choose_button":"Wählen","modale_address":"Die Anschrift :","modale_phone":"Telefon:","change_store_title":"Shop wechseln","change_store_paragraph":"Seien Sie vorsichtig, Sie sind dabei, das Geschäft zu wechseln. Wenn Sie Artikel in Ihrem Warenkorb haben, geht Ihr Warenkorb verloren.","cancel_button":"abbrechen","change_store_button":"Shop wechseln","header_change_store":"Shop wechseln","product_not_available":"Produkt in diesem Shop nicht verfügbar","paragraph":"Sie können einen anderen Shop auswählen, um dessen Verfügbarkeit zu überprüfen. Sie müssen Ihre Bestellung im neu ausgewählten Store abholen. Dadurch wird Ihr aktueller Warenkorb geleert.","change_store_cta":"Shop wechseln","no_store_available":"Für diese Postleitzahl ist kein Geschäft verfügbar","search_input_placeholder":"Beispiel: 33","search_input_label":"Geben Sie den Anfang einer Postleitzahl ein","search":"Forschen","appointments_page_title":"Sie möchten einen Termin vereinbaren für:","appointment_page_pickup_link_label":"Eine Auszahlung in Geschäften","appointment_page_return_link_label":"Eine Rückkehr zum Laden","account_page_return_link_label":"Kehren Sie zu Ihrem Geschäft zurück","pack_not_available":"Pack In diesem Shop nicht erhältlich"},"pack_single":{"choose":"Packung in den Warenkorb legen","sold_out":"Paket nicht verfügbar","pack_content_title":"In diesem Paket enthaltene Artikel:"},"takeBack":{"title":"Verkaufe einen Artikel","meta_title":"Programm zur Rücknahme von Artikeln","required_field":"* Benötigte Felder","text":"Füllen Sie unser Formular aus, um Ihr Kaufangebot zu erhalten. Eine Frage zur Bedienung?","step_1":"Ihr Artikel","step_2":"Unser Angebot","step_3":"Bestätigung","step_edit_parcel_number":"Ändern Sie die Paketnummer","parcel_number_label":"Wie viele Pakete möchten Sie senden?","positive_response_to_preliminary_questions":"Ja","negative_response_to_preliminary_questions":"Nö","condition_question":"Guter Zustand?","error_message":"Leider nehmen wir diese Art von Artikeln nicht an","next_step_button":"Nächster Schritt","reference_number_label":"Artikelreferenz","reference_number_placeholder":"Referenz auf dem Etikett vorhanden","reference_number_link":"Wo finde ich die Referenz meines Artikels?","reference_number_text":"Sie finden die Referenz an der auf dem Bild angegebenen Stelle","select":"Wähle einen Wert","close_modal":"Nah dran","waiting_price_text":"Wir schätzen den Verkaufspreis Ihres Artikels. Warten Sie mal.","offer_announcement_text":"Unter Berücksichtigung der gemachten Angaben unterbreiten wir Ihnen gerne ein Rücknahmeangebot in Höhe von:","price_explication":"* Dieser Betrag wird nach Überprüfung des Artikels durch unsere Teams endgültig.","accept_offer_button":"Nehmen Sie unser Angebot an","login_text":"Sie müssen eingeloggt sein, um unser Angebot zu erhalten","register_text":"Sie müssen ein Konto erstellen, um unser Angebot zu erhalten","confirmation_text":"Herzlichen Glückwunsch!.\\nDas Preisangebot wurde Ihnen per E-Mail zugesandt! ","take_back_location_title":"Wählen Sie die Site aus, auf der die Wiederherstellung angewendet werden soll:","take_back_country_title":"In welchem Land möchten Sie Ihren Gutschein einlösen?","reference_check_button":"Forschen","reference_error":"Falsche Referenz","take_back_menu":"Weiterverkaufen","state_title":"Bundesland","state_1":"Perfekter Zustand","state_2":"Sehr guter Zustand","state_3":"Guter Zustand","previous_step":"Vorheriger Schritt","select_label_size":"Schneiden","select_label_state":"Bundesland","refused_state":"Nicht aufgeführt","faq_title":"Häufig gestellte Fragen","reference":"Bezug","add_product":"Artikel hinzufügen","confirmation_title":"Vielen Dank!","address_check_required":"Bitte überprüfen Sie Ihre Lieferadresse","confirm_address_button":"Bestätigen Sie die Adresse","voucher_printing_button":"Drucken Sie den Lieferschein aus","your_order_confirmation":"Ihre Auftragsnummer","label":"Etikett","states_explanation_link":"Wie wähle ich den Staat?","item":"Art.-Nr.","question_title":"Wie ist der Zustand Ihres Zimmers?","take_back_location_desc":"Wählen Sie jetzt die Art des Gutscheins, den Sie erhalten möchten. Achtung, nach der Auswahl können Sie den gewünschten Gutscheintyp nicht mehr ändern.​","step_2_error":"Beim Verarbeiten der Anfrage ist ein Fehler aufgetreten. Versuch es noch einmal","total":"Gesamt","status_label":"Status","accepted_status":"Akzeptiert","refused_status":"Sich weigern","in_progress_status":"Im Gange","command":"Übernahme Nr.","price_start":"Preis ab","tab_label_secondhand":"Gebraucht","tab_label_rental":"Zu mieten","state_label":"state_label","second_hand_label":"second_hand_label","original_price":"Original Preis","take_back_command":"Best.-Nr:","take_back_description":"take_back_description","take_back_states_information_modal_title":"Definition von Staaten","take_back_stock_alert_text":"Ihre Größe ist nicht verfügbar ?","take_back_stock_alert_link":"Erstellen Sie eine Benachrichtigung","take_back_stock_alert_modal_title":"Erstellen Sie eine Benachrichtigung","take_back_stock_alert_modal_text":"Erhalten Sie eine E-Mail-Benachrichtigung, sobald Ihre Größe wieder verfügbar ist","take_back_stock_alert_modal_size_label":"Artikelgröße wählen:"},"search_page":{"title":"Suchergebnisse für: {{ search }} ({{ length }})"},"wishlist":{"title":"Meine Wunschliste","empty":"Ihre Wunschliste ist leer","button":"Zum Warenkorb hinzufügen"},"size_guide_page":{"span_title":"Größenratgeber","size_guide":"🎀 Größenratgeber","question":"Wussten Sie, dass 9 von 10 Frauen ihre tatsächliche BH-Größe nicht kennen? Entdecken Sie Ihre endlich mit unserem einfachen und präzisen Rechner. Für alle unsere Modelle ohne Bügel sowie für Slips empfehlen wir, Ihre gewohnte Größe zu wählen.","measure_your_back_circumference":"1. Miss deinen Unterbrustumfang","not_tight":"Nicht eng","slightly_tight":"Etwas eng","very_tight":"Sehr eng","measure_your_bust":"2. Miss deinen Brustumfang","standing_up_straight":"Aufrecht stehen","leaning_forward":"Nach vorne beugen","lying_on_your_back":"Auf dem Rücken liegend","calculate_size":"Meine Größe berechnen","error_size_not_found":"Keine Größe für diese Maße gefunden","bra_size":"Deine BH-Größe ist "},"reservations":{"title":"Meine Reservierungen","header_tooltip":"Meine Reservierungen","info_banner":"Produkte werden nach Ablauf automatisch wieder zum Verkauf angeboten.","empty_text":"Sie haben keine aktiven Reservierungen.","cta_shop":"Produkte ansehen","product_label":"Produkt","expires_on":"Läuft ab am","buy_now":"Jetzt kaufen","release":"Reservierung freigeben","reserve_cta":"{{days}} Werktage reservieren","confirm_title":"Reservierung bestätigen","confirm_body":"Sie sind dabei, dieses Produkt für {{days}} Werktage zu reservieren. Es wird für andere Kunden nicht mehr verfügbar sein.","confirm_expiration":"Ablaufdatum","confirm_cta":"Reservierung bestätigen","confirm_cancel":"Abbrechen","confirm_error":"Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.","confirm_error_conflict":"Dieses Produkt wurde bereits reserviert","reservations_product_already_reserved":"Dieses Produkt ist für Sie reserviert, finden Sie es in Meine Reservierungen"},"cancel_contract":{"button_label":"Meinen Vertrag kündigen","title":"Widerruf / Stornierung","intro":"Möchten Sie Ihre Bestellung stornieren oder ein Produkt zurückgeben? Füllen Sie dieses Formular aus und unser Team kümmert sich um Ihre Anfrage.","type_label":"Ihre Anfrage","type_cancellation":"Meine Bestellung stornieren","type_return":"Ein Produkt zurückgeben","order_reference_label":"Bestellnummer","email_label":"E-Mail","message_label":"Nachricht (optional)","submit_button":"Anfrage senden","required_fields":"* Pflichtfelder","error_order_reference":"Bitte geben Sie Ihre Bestellnummer ein.","error_email":"Bitte geben Sie eine gültige E-Mail-Adresse ein.","error_generic":"Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Angaben und versuchen Sie es erneut.","success_title":"Ihre Anfrage wurde entgegengenommen","success_message":"Sie erhalten eine Bestätigungs-E-Mail. Unser Team meldet sich in Kürze bei Ihnen.","close_button":"Schließen"}}');

/***/ }),

/***/ 60573:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"404":{"title":"404 - Page not found","cta":"Back to home page"},"account":{"herotitle":"My account","title_login":"Access my account","subtitle":"Log in with your email address","successfull_register":"Congratulations ! Your account has been created, you will receive a validation email.","login_email":"E-mail","login_password":"Password","forget_password_link":"Forgot your password ?","guest_link":"Continue as a guest","error_login":"Your email address or password does not match. Try Again","login_button":"Log in","login_to_see_price":"Log in to view our prices and place an order","register_link":"No account? Register now","title":"Register now","login_title":"Identifiers","firstname":"First name","lastname":"Last name","email":"E-mail","phone":"Phone","vatnumber":"VAT number","company":"Company","password":"Password","repeat_password":"Repeat password","address_required":"please enter a delivery address","address_title":"Address","address":"Address","postal_code":"Postal code","country":"Country","town":"City","register_button":"Create my account and continue","login_link":"Do you already have an account? To log in","password_error":"Your passwords are not the same","title_data":"Stay calm","text_data":"Your data is protected","forget_title":"Forgot your password","forget_subtitle":"You will receive an email to create a new password","button_recup":"Send an email","to_login_link":"Return connection","button_continue_as":"Continue as","disconnect_button":"Sign out","guest_link1":"Continue as a guest","info_link":"my info","hi":"Hello","paragraph1":"Find your dashboard here. You can track your current orders and manage the return of orders received.","log_out_button":"Sign out","block_title":"Frequently asked Questions","date":"Coming on","leasing_date_from":"Rental from","leasing_date_to":"to","return":"To return to a relay point before","returned_at":"Delivered on ","command":"Order no.","manage_shippment":"Manage my delivery","manage_shippment_sentence":"To track, modify or cancel your order","follow_my_package":"Follow my package","no_command":"No orders for the moment!","go_to_shop":"Go to Shop","back_link":"Return","title_information":"My data","cancel_subscription":"Cancel my subscription","cancel_subscription_title":"How can I cancel my subscription?","cancel_subscription_button":"Got it !","cancel_subscription_paragraph":"To cancel, nothing could be easier! Simply return all items still in your possession. Once we receive the items in our warehouse, your subscription will be automatically cancelled. The invoice for the last month of your subscription will be prorated","your_infos":"Your informations","modification_successfull":"Your information has been modified","error_happend":"An error has occurred. Try again!","mail_used":"This email address is already in use","error_disabled":"Your account is not activated","info_button":"Change my information","password_modif_succes":"Password changed successfully","password_button":"change my password","adress_title":"your delivery adress","address_button":"Change my address","link_name":"How it works?","slides_title":"My return in three steps","verify_title":"Account verification in progress","confirm_account":{"title":"Your account has been validated","cta_shop":"Rent now","cta_account":"View my account","error":"Error, redirection to reception"},"password_reset":{"title":"Update your password","description":"Please complete the form with your new password.","error":"Error, The request was unsuccessful","success":"Your password change has been taken into account, you will be redirected to the login page."},"newsletter":"Subscribe to the newsletter","email_send":"Email sent","continue":"keep on going","text":"text","actual_password":"Current password","new_password":"New password","error_phone":"error_phone","next":"next","cancelled":"Cancelled order","desc_info":"* By entering your email address, you agree to receive our news, our commercial offers, and invitations to our private sales and accept our privacy policy.","email_not_send":"The email address is not in the database. Try with a different email address.","address_button_create":"Add my delivery address","warning":{"text":"Please note, you do not have a registered address, please provide an address in your information","cta":"Add my address"},"street_number":"No.","search_address":{"helper_add":"To add your delivery address, enter your address in the field below.","helper_change":"To change your delivery address, enter your address in the field below."},"password_strength_error":"Your password must contain: at least 10 characters, one uppercase, one lowercase, one special character and one number.","address_details":"Additional address (Building, Floor, Code etc.)","address_area":"Area","confirm_return":{"title":"Your product return has been taken into account","cta_shop":"Rent now","cta_account":"View my account","error":"Error, redirect to my account","rdv":"appointment"},"review_placeholder":"Please choose an answer from the list","register_disable":"We\'re sorry, registration for our rental service is no longer available.","cancel_order":{"cta_modal":"Cancel my order\\n","modal_title":"Cancel my order","modal_warn":"Are you sure you want to cancel the order?","modal_cta":"to cancel"},"buy":"To buy","payment_method":{"title":"Means of payment","subtitle":"Registered payment method:","card":"Map ","ending_by":"ending with ","cta_replace":"Replace payment method","modal_title":"Replace payment method","modal_description":"Please note that by changing your payment method you will delete your previous payment method.","modal_cta":"To replace","modal_error":"Technical error. Please try again later.","modal_success":"Your payment method has been changed"},"dkt_login":"With your Decathlon account","information_validation":{"main_title":"Your account has been created !","subtitle":"Verification of information","description":"As part of the use of our rental site, we need the following information: ","confirmation_button":"Validate my information"},"sso_login":{"dkt":"With your Decathlon account","cultura":"With your Cultura account","ciam":"WITH YOUR VIRGIN MEGASTORE ACCOUNT"},"external_account_text":"Modify my information on my customer account","take_back_date":"Date","order_list_title":"My orders","take_back_list_title":"My covers","order_details_generate":"Generate return label","order_details_download":"Click here to download your return slip","return_label_unavailable":"Your return label is not yet available. It will be accessible once your order has been shipped.","product_returned":"This item has been returned","area_address":{"label_address_details":"Address","placeholder_address_details":"Neighborhood, Street, Home number","label_city":"City","placeholder_city":"Please enter your city","label_area":"Area","placeholder_area":"Please enter your area"},"wish_list_link":"My wish list","returning_reason_label":"Return reason","returning_reason_placeholder":"Select a return reason","returning_reason_comment_label":"Additional comment","returning_reason_comment_placeholder":"Please provide additional details about your return reason","account_type":"Account type","personal_account":"Personal account","b2b_account":"Business account","shop_code":"Shop code","siret":"SIRET (no spaces)","company_name":"Company name","is_customer":"I am a customer","customer_account_id":"Customer account number"},"orders":{"error":"An error has occurred. Try again!","confirm_return":{"title":"Do you really want to generate a return slip for your selection?","cta":"Generate return slip","cancel":"Cancel","reason":"Return reason","reason_placeholder":"Please enter the return reason"}},"banner":{"text":"Covid-19: We guarantee regular cleaning and disinfection of all products"},"basket":{"kit_price":"Your kit","duration":"Your subscription","for_short":"for","assurance":"Insurance","free":"Free","reduction":"Discount","total":"TOTAL","delete_basket":"Remove basket","continue":"Continue","product":"product","return_date":"Return date","whenever_you_want":"When you want","sub_engagement":"One month commitment","current_subscription":"My current subscription","check_on_account":"See on my account","to_pay_this_month":"To pay this month","newarticles":"For your new articles from","to":"at","error_stock":"A product is no longer available in sufficient quantity","shipping":"Delivery","products":"products","error_basket":"Your current subscription and the number of products selected do not allow you to continue your order","total_without_shipping":"Total without delivery","total_weight":"Total weight","try_out":"Fitting","error_tryout":"You must have at least as many rooms to rent as there are rooms to try","total_with_subscription":"Total","total_without_subscription":"Total","showDetails":"View delivery details","hideDetails":"Hide delivery details","rentTotal":"Rental","buyTotal":"Purchase","months":"months","withoutShipping":"(excluding delivery)","engagement":"Subscription without commitment.","debit":"Collected at the end of the month.","continue_shop":"Continue shopping","empty":"your basket is empty","drawer":{"title":"Basket","close":"Close"},"reduction_text_explication":"Add your promo code at checkout","gift_card_text":"gift_card_text","gift_card_explanation":"gift_card_explanation","deposit":"Deposit","deposit_explanation":"The amount will be refunded after the products are returned","remainingInStock":"Remaining in stock: {{count}}","b2b_shipping_costs_link":"Shipping costs by quantity","total_without_shipping_excl_vat":"Total Gross","delivery_fees_excl_vat":"Delivery fees HT","vat":"VAT"},"confirmation":{"email":"E-mail","text":"Covid-19: We guarantee regular cleaning and disinfection of all products","title_complements":"Keep exploring","desc_complements":"With this discount code!","codetext":"Enjoy 5% discount on these products with the code","codename":"LIZEECODE","title":"Order summary","articles_return":"Items I need to return by","generate_vouchers":"Generate the return slip","articles_to_send":"The items that I will receive around the","account_cta":"access my account","to_return":"to_return","order_number":"Order n°"},"emails":{"browser_link":"Open this email in the browser","signature":"John Doe,\\nfrom the Lizee brand rental team","bottom_section_title":"Your return","bottom_section_content":"How to organize your return? it\'s easy, follow the guide.","footer":"The Brand teams wish you a good day!","copyright":"In accordance with the law \\"Informatique et Libertés\\" of January 6, 1978, you can at any time ask to access, rectify or delete personal information concerning you or oppose their treatment by Brand.\\nThis email is an acknowledgment of receipt of your order and confirms the rental contract. An email confirming the edition of your articles will be sent to you shortly.","order_confirm_title":"Thank you for your order!","order_confirm_main_text":"We have received your order n ° XXXXXX. It will be shipped as soon as possible and will arrive at a relay point / at your home or at your home depending on the delivery method chosen.","order_confirm_cta_text":"Follow us!","order_summary_title":"Order Summary","order_id_text":"Order number:","order_start_subscription_date":"Subscription start date","order_renting_start":"Rental start date","order_renting_end":"Return date","order_renting_duration":"Location duration","order_shipping":"Delivery address:","order_shipping_method":"Home delivery","order_products":"Products List","order_paid_text":"Paid","order_tax_text":"20% VAT included","order_pay_method":"Payment method","order_pay_method_desc":"Credit card ending with"},"faq":{"subtitle":"Log in with my email address","title":"Register now"},"funnel":{"email":"E-mail","phone":"Phone","address":"Address","postal_code":"Postal code","country":"Country","free":"Free","return_button":"Return","delivery_title":"1. Delivery","delivery_description":"You will receive your package X days in advance. ","delivered_on":"Delivered on ","return_before":"To come back before","return_title":"2. Return","home_delivery":"Home delivery","change_my_address":"Change my address","shop_delivery":"Delivery to the parcel point","choose":"To choose","next1":"Next","titleform":"Enter your payment information","pay":"Pay","first_name":"First name","last_name":"Last name","city":"City","next":"Next","create_account_link":"Create an account","continue_with_account":"Continue with the account","information":"Information","shipping":"Delivery","step":"step","coupon_title":"Do you have a promo code?","coupon_cta":"Apply","coupon_applied":"This promo code is applied:","coupon_success":"This promo code is valid","coupon_error":"Do you have a promo code?","no_shipping_available":"no_shipping_available","payment":{"title":"title","success":"success","progress":"progress","cgu":"cgu","retractation_agreement":"I expressly acknowledge that I waive my right of withdrawal since my rental begins before the expiry of the 14-day withdrawal period.","custom_cgu_link":"Access to CGLs","payment_accordion":{"card_title":"Secure payment by credit card","card_tagline":"Payment insured by Stripe™. Cards accepted","paypal_title":"Paypal"},"caution_info":"Before proceeding with payment, you must pay the deposit for your items.","caution_explanation":"This deposit will be refunded after returning the products in good condition.","caution_button":"Pay Deposit","pay_caution":"Pay Deposit","caution_paid":"Deposit paid successfully! You can now proceed with payment.","caution_expired":"The deposit has expired. Please create a new deposit.","caution_error":"An error occurred while processing the deposit.","caution_creation_error":"Unable to create deposit. Please try again.","caution_token_mismatch":"Invalid deposit for this order. Please try again.","processing_caution":"Processing deposit...","swikly_deposit_description":"Security deposit for rental items","wire_transfer_button":"Pay later with a wire transfer","errors":{"stock":"A product in your cart is no longer available","stock_error_intro":"The following products are no longer available in sufficient quantity:","stock_error_footer":"Please update your cart before proceeding with payment.","availability_check_failed":"Availability could not be verified due to a temporary technical issue. Please try again in a moment.","default":"The card was declined for an unknown reason. Contact the card issuer for more information","expired_card":"The credit card has expired. You must use another payment method.","email":"Invalid email address.","insufficient_funds":"The credit card does not have sufficient funds to make the purchase. You must use another payment method.","lost_card":"The payment was refused because the credit card was declared lost. Contact the card issuer for more information","stolen_card":"The payment was declined because the credit card was reported stolen. Contact the card issuer for more information","incorrect_cvc":"The CVC code is wrong. You must try again with the correct CVC.","processing_error":"An error occurred while processing the credit card. You must retry the payment. If it still can\'t be treated, try again later.","code_operator_label":"Please enter your validation code","code_operator_placeholder":"Eg: 12345","operator_button_validation":"Confirm your order","wrong_code_operator":"The entered code is not valid","minimum_cart_items":"Minimum cart items not reached"},"error":"An error has occurred"},"invalid_tel":"Please provide a valid phone number","coupon_label":"Promo code","your_rental_from":"Your rental of","your_rental_to":"to","show_cart":"Show cart","hide_cart":"Hide cart","toBeDetermined":"To be determined"},"general":{"home":"Home","selection":"All the selection","return":"To return to a relay point before","baseline":"Rental. To save. Enjoy","footer_tagline":"From sale to rental","footer_top_baseline":"Damage insurance is included","footer_top_link_label":"View all products","contact_us_button":"Contact us","cgl":"General rental conditions","policy":"Privacy Policy","small_text_under_calendar":"The more you rent, the less you pay!","start_button":"Start","confirm_button":"To confirm","delivered":"Delivered on or before","meta_description":"Here is the meta desc","meta_title":"Here is a title","meta_url":"http://whitelabel.lizee.io/","you_save":"You save","my_account":"My account","FAQ":"Faq","add_a_title":"it\'s a title","add_a_description":"this is a description","add_a_subtitle":"this is a subtitle","add_a_text":"add text","from":"Of","month":" / month","day":" / day","stock_texts":{"few_products_left":"More than a few products!","back_soon":"Back soon","in_stock":"In stock"},"search_address":{"cta":"To research","incomplete":"The address entered is not complete. Specify your address with a street, a city and a postal code.","no_results":"No address found in our database. Please enter another address.","excluded":"Delivery is not supported for this address.","invalid_country":"Delivery is not supported for this country.","label":"Find your delivery address","same_address":"Billing and delivery addresses are the same","label_billing":"Find your billing address","placeholder":"Example: 15 rue de milan Paris","change_delivery_point":"edit","postcode_missing":"Please enter a postal code"},"search_bar":{"input_label":"Search for a product","input_placeholder":"Search for a product","button_label":"Search for a product"},"previous_button":"Previous","sizes":"Select your size","month_short":" / m","day_short":" / d","copyright":"Powered by Lizee","card_number":"Card number","expiry_date":"Expiration date","cvc_code":"CVC code","morning":"Morning","afternoon":"Afternoon","evening":"Evening","fullDay":"Whole day","flex_price_information":"Pricing based on a 30 day month","month_without_space":"/month","handle_cookies":"Manage cookies","days_plural":"days","day_singular":"day","delivery_point":"Results near: ","menu":{"close":"Close"},"main_menu":{"item":"Main Menu","subitem":"Submenu"},"holder_name":"Owner\'s name","unit":"/ unit","unit_short":"/u","change_language_modal_title":"Change language","change_language_modal_text":"Be careful, you are about to change languages. If you have items in your cart, your cart will be lost.","change_language_modal_cancel_text":"to cancel","change_language_modal_validation_text":"Change language","no_mixed_basket":{"second_hand_product_in_basket_title":"There is a second-hand item in your basket","rental_product_in_basket_title":"There is a rental in your basket","second_hand_product_in_basket_text":"You cannot place an order with both a rental and a second-hand item. If you wish to make a rental, then you must place another order or remove the second-hand item from your basket.","rental_product_in_basket_text":"You cannot place an order with both a rental and a second-hand item. If you wish to purchase a second-hand item, then you must place another order without a rental or remove the rental from your cart."},"vat":{"included":"Incl. VAT","excluded":"Excl. VAT"}},"homepage":{"maintitle":"Rental. To save. Enjoy. ","descriptiontext":"Rent our products on request. ","cta_pack_label":"See the packs","titlehowitworks":"How it works ?","deschowitworks1":"Book your kit online and receive it at home or at a pick-up point of your choice in France. The kit will be available 2 days before your departure and you have 2 days to return it after the end of your trek. ","deschowitworks2":"Bonus?\\nYou can return your kit from your trekking location. Using your return label included in your package, drop off your package at any Chronopost relay point in mainland France. / You can return your kit from your hiking location. The return label is included in your package and you can drop off your kit at any Chronopost point in France. ","titletestimonials":"They tried it ","section_title_savings":"The longer you rent, the less you pay: ","link_label_savings":"Start renting","start_savings_text":"You rent for","end_savings_text":"you save","buy_savings_text":"If you buy","rent_savings_text":"If you are renting","saving_mentions":"* Amount based on the average prices of our products","featured_product_title":"An example with our favorite product:","featured_product_name":"Green and blue 20L backpack","featured_product_link_label":"Explore options","title_commitment":"Did you know ?","description_commitment":"Your choice will have a positive impact on the planet: renting with Lizee saves an average of 350g of CO2 per product!","section_title_community":"Your savings with the rental:","title_community":"Our tenant customers have already saved: ","amount_community":"€ 35,000","subtitle_universe1":"Title of taxa products","paragraph_universe1":"Desc for taxa packs","subtitle_universe2":"Title of taxa packs","paragraph_universe2":"Desc for taxa packs","categorie":"Sylius Taxon","rent":"Alquilar","partner":"partner"},"instagramwall":{"title":"Register now","desc":"Share your memories with #Lizee ","buttontext":"Follow us !"},"packs":{"from":"Of","month":"month","buttontext":"Follow us !","header_title":"Packs","herotitle":"Discover our packs ","titlepacks":"Packs designed for you","packsparagraph":"Choose from the packs below or create your own! ","shipping_description":"Free home delivery on orders of € 30 or more!","pack_to_shop_button":"Create your pack","fake_pack_title":"Create your own pack","fake_pack_button":"See more products","select":"Select your size","title_size_modale":"Select the size to add it to your basket:","victim_of_success":"Victim of his own success","link_to_single":"See the package"},"page":{"title":"Title page","content":"Content page. Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti animi iure iusto ex explicabo aspernatur commodi voluptatum, laudantium voluptatem corporis."},"sso":{"errors":{"41000083":"The account used is not a professional account.","default":"An unexpected error occurred."}},"privacy":{"title":"Register now","wysiwyg":"Last updated: March 12, 2020\\n","showCookie":"Managing cookies"},"products_to_buy":{"products_category":"Products to buy","buy_button":"Buy","see_more":"Find out more"},"rental_terms":{"title":"Register now","wysiwyg":"Last updated: March 12, 2020\\n"},"shop":{"choose":"To choose","header_title":"Packs","herotitle":"Discover our packs ","title_size_modale":"Select the size to add it to your basket:","victim_of_success":"Victim of his own success","titleshop":"Rent from the best selection","shopdescription":"Choose your favorites! ","shippingdescription":"Free home delivery on orders of € 30 or more!","shop_to_packs_button":"See the packs","filter":"Filters","filter_by_taxons":"Filter by categories","filter_apply":"Apply filters","availableOnly":"See only available products","classic_sub":{"our_rates":"Our scalable packages","adjustable_rate":"Your package adjusts according to your selection.","articles":"articles","maximum":"maximun","article":"article"},"filters":"filters","pack_size_modal_cta_add":"Add to cart","pack_size_modal_cta_return":"Back to the packs","filters_dropdown_label":"Select","max_item_in_cart":"Maximum product per basket reached","prev":"Previous page","next":"Next page","no_stock_available":"No products available in this category.","search_not_found":"No product matches this search","filters_modale_title":"filters_modale_title","autocomplete_search_placeholder":"Search {{attributeName}}...","autocomplete_no_results":"No results found","autocomplete_no_values":"No values available","autocomplete_loading":"Loading...","autocomplete_load_more":"Load more","close_button":"close_button","categories_title":"categories_title","apply_button":"apply_button","accordion_shop_title":"accordion_shop_title","and":"and","price_min_label":"Min","price_max_label":"Max","sort":"Sort","filter_and_sort":"Filter & sort","filter_title_in_drawer":"Filter","sort_by_price_asc":"Price ascending","sort_by_price_desc":"Price descending","sort_by_date_asc":"Oldest First","sort_by_date_desc":"Newest First","error_loading_products":"An error occurred while loading products. Please try again later.","shipping_costs":{"number_of_articles":"Number of articles","round_trip_cost":"Round-trip cost","title":"Worst case shipping costs (Incl. Insurance)"}},"single_product":{"choose_button":"To choose","associations_title":"You may also be interested in this:","try_out_button":"Try for:","try_out_tooltip":"You can only try one room per rented room","buy_button":"To buy","choose_button_tooltip":"Select a size to add to cart","display_total_rental_price":"total rental price","availability_checker":{"modal_close":"Close","text":"This item is unavailable on these dates.","link":"See availability","modal_title":"Check availability","modal_description":"The article is not available when the dates are crossed out"}},"statements":{"bottom_sentence":"The more you travel, the more you save!","link":"More information"},"subscription_order":{"change_cta":"Edit","cancel_cta":"To cancel","rate":"Flat rate","handle_return_cta":"Manage the return of my items","my_subscription":"My subscription :","taken_every":"Taken every","of_the_month":"of the month","per_month":"Per month","articles_max":"max items","select_all_and_stop":"Select all and stop my subscription","generate_the_return_slip":"Generate the return slip","continue":"Continue","my_new_subscription":"My new subscription","size":"Cut :","month":"month","bottom_sentence":"A return slip will be available at the end of the order. All about returns","funnel":{"current_subscription":" , you already have a current subscription.","subtitle":"You can return your old items to adjust your subscription. If you want to keep your items, go to the next step.","skip_step":"skip this step"},"returned_product_title":"Products returned this month","returned_product_desc":"These products have been received and will be permanently removed from your space on your next payment.","canceled_order_title":"Canceled orders","canceled_order_desc":"canceled_order_desc","refunded_order_title":"Refunded orders","refunded_order_desc":"refunded_order_desc","sub_finished":{"title":"Subscription ended!","desc":"We are sad to see you go. Your last debit will be prorated for the current month once the items are returned."},"returned_date":"Returned on","link_download_return":"Click here to download your return slip","invoice_this_month":"Your bill this month:","invoice_explanation":"We calculate the amount invoiced each month according to the pro-rata of the products rented and returned in the current month","subscription_start_date":"Your subscription starts on:","subscription_date_explanation":"Your subscription starts 5 days after the date of your first order. This date takes into account the preparation times for your order and the delivery times.\\n From the start of the subscription, you will be billed monthly, on the anniversary date. The product return service will be available after you start your subscription.","bought_product_title":"Products purchased:","bought_product_desc":"bought_product_desc","product_not_eligible_for_return":"Product not eligible for return","tooltip_product_not_eligible_for_return":"Return possible from the date of subscription"},"customer_survey":{"main_title":"Satisfaction survey","subtitle":"Help us improve our services","let_a_message":"A message ?","satisfaction":"Satisfaction","dropdown_title":"Return state","notes":"Notes","observation":"An observation ?","message":"Message","send":"Send","contact_title":"Contact","error_fields":"Please complete the required fields","desc_contact":"Leave us a message !"},"snackbar_message":{"add":"The product has been added to","delete":"The product has been removed from","remove":"One product has been removed from","add_multiple":"The products have been added to","limit":"You have reached the maximum number of products in a subscription","rental_range_selected_is_blocked":"The selected rental range is not available. Please choose another rental range.","cart":"your cart","max":"There is no more stock on this product for the chosen quantity","add_tryout":"The product has been added for fitting","profilUpdated":"Your information has been updated successfully"},"instore":{"modale_title":"Choose your store","modale_shop_name":"Name of the shop","modale_informations":"Information","modale_choose_shop":"Choose a store","modale_details":"Contact details","modale_choose_button":"To choose","modale_address":"Address :","modale_phone":"Telephone :","change_store_title":"Change store","change_store_paragraph":"Be careful, you are about to change stores. If you have items in your shopping cart, your shopping cart will be lost.","cancel_button":"to cancel","change_store_button":"Change store","header_change_store":"Change store","product_not_available":"Product Unavailable in this store","paragraph":"You can choose another store to check its availability. You will have to pick up your order in the new selected store. This will have the effect of emptying your current basket.","change_store_cta":"Change store","no_store_available":"There is no store available for this postal code","search_input_placeholder":"Example: 33","search_input_label":"Enter the beginning of a postal code","search":"To research","appointments_page_title":"You wish to make an appointment for:","appointment_page_pickup_link_label":"A withdrawal in stores","appointment_page_return_link_label":"A return to store","account_page_return_link_label":"Return to your store","pack_not_available":"Pack Not available in this store"},"pack_single":{"choose":"Add pack to cart","sold_out":"Pack not available","pack_content_title":"Items included in this pack:"},"takeBack":{"title":"Sell an item","meta_title":"Item take-back program","required_field":"* Required fields","text":"Fill out our form to get your purchase offer. A question about operation?","step_1":"Your item","step_2":"Our offer","step_3":"Confirmation","step_edit_parcel_number":"Edit the parcel number","parcel_number_label":"How many parcels do you want to send?","positive_response_to_preliminary_questions":"Yes","negative_response_to_preliminary_questions":"No","condition_question":"Good condition?","error_message":"Unfortunately, we do not accept this type of article","next_step_button":"Next step","reference_number_label":"Article reference","reference_number_placeholder":"Reference present on the label","reference_number_link":"Where to find the reference of my article","reference_number_text":"You will find the reference at the place indicated on the image","select":"Select a value","close_modal":"Close","waiting_price_text":"We estimate the selling price of your item. Please wait.","offer_announcement_text":"Taking into account the information provided, we are happy to offer you a take-back offer amounting to:","price_explication":"* This amount will be final after verification of the article by our teams.","accept_offer_button":"Accept our offer","login_text":"You must be logged in to receive our offer","register_text":"You must create an account to receive our offer","confirmation_text":"Congratulation !.\\nThe price offer has been sent to you by email! ","take_back_location_title":"Choose the site where to apply the recovery:","reference_check_button":"To research","reference_error":"Wrong reference","take_back_menu":"Resell","state_title":"State","state_1":"Perfect condition","state_2":"Very good condition","state_3":"Good condition","previous_step":"Previous step","select_label_size":"Cut","select_label_state":"State","refused_state":"Not included","faq_title":"Frequently asked Questions","reference":"Reference","add_product":"Add item","confirmation_title":"Thanks!","address_check_required":"Please check your delivery address","confirm_address_button":"Confirm the address","voucher_printing_button":"Print the dispatch note","your_order_confirmation":"Your order number","label":"Label","states_explanation_link":"How to choose the state?","item":"Item No.","question_title":"What is the condition of your room?","take_back_location_desc":"​Choose now the type of voucher you wish to receive. Attention, once chosen you will not be able to modify the type of voucher desired.​​","step_2_error":"An error occurred while processing the request. Try Again","total":"Total","status_label":"Status","accepted_status":"Accepted","refused_status":"Refuse","in_progress_status":"In progress","command":"Takeover No.","price_start":"price_start","tab_label_secondhand":"Secondhand","tab_label_rental":"To rent","state_label":"state_label","second_hand_label":"second_hand_label","original_price":"Original price","take_back_command":"Order n°","take_back_description":"take_back_description","prevent_adding_differents_types_to_cart":"It is not possible to rent and purchase the same product simultaneously","take_back_states_information_modal_title":"Definition of states"},"search_page":{"title":"Search result for : {{ search }} ({{ length }})"},"wishlist":{"title":"My Wish List","empty":"Your wish list is empty","button":"Add to wishlist"},"size_guide_page":{"span_title":"Size Guide","size_guide":"🎀 Size Guide","question":"Did you know that 9 out of 10 women don’t know their real bra size? Finally discover yours with our simple and accurate calculator. For all our wireless models as well as briefs, we recommend choosing your usual size.","measure_your_back_circumference":"1. Measure your underbust","not_tight":"Not tight","slightly_tight":"Slightly tight","very_tight":"Very tight","measure_your_bust":"2. Measure your bust","standing_up_straight":"Standing up straight","leaning_forward":"Leaning forward","lying_on_your_back":"Lying on your back","calculate_size":"Calculate my size","error_size_not_found":"Size not found for this measurement","bra_size":"Your bra size is "},"reservations":{"title":"My reservations","header_tooltip":"My reservations","info_banner":"Products are automatically put back on sale when the reservation expires.","empty_text":"You have no active reservations.","cta_shop":"Browse products","product_label":"Product","expires_on":"Expires on","buy_now":"Buy now","release":"Release reservation","reserve_cta":"Reserve {{days}} business days","confirm_title":"Confirm reservation","confirm_body":"You are about to reserve this product for {{days}} business days. It will no longer be available for other customers.","confirm_expiration":"Expiration date","confirm_cta":"Confirm reservation","confirm_cancel":"Cancel","confirm_error":"An error occurred. Please try again later.","confirm_error_conflict":"This product has already been reserved","reservations_product_already_reserved":"This product is reserved for you, find it in My Reservations"},"cancel_contract":{"button_label":"Cancel my contract","title":"Withdrawal / cancellation","intro":"Would you like to cancel your order or return a product? Fill in this form and our team will handle your request.","type_label":"Your request","type_cancellation":"Cancel my order","type_return":"Return a product","order_reference_label":"Order number","email_label":"Email","message_label":"Message (optional)","submit_button":"Send my request","required_fields":"* Required fields","error_order_reference":"Please enter your order number.","error_email":"Please enter a valid email address.","error_generic":"Something went wrong. Please check your details and try again.","success_title":"Your request has been received","success_message":"You will receive a confirmation email. Our team will get back to you shortly.","close_button":"Close"}}');

/***/ }),

/***/ 60061:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"404":{"title":"404 - Página no encontrada","cta":"Volver a la página de inicio"},"account":{"herotitle":"Mi cuenta","title_login":"Acceder a mi cuenta","subtitle":"Inicie sesión con su dirección de correo electrónico","successfull_register":"Felicidades ! Su cuenta ha sido creada, recibirá un correo electrónico de validación.","login_email":"Correo electrónico","login_password":"Contraseña","forget_password_link":"Contraseña olvidada ?","guest_link":"Continuar como invitado","error_login":"Su dirección de correo electrónico o contraseña no coinciden. Intentar otra vez","login_button":"Iniciar sesión","login_to_see_price":"Inicia sesión para consultar nuestros precios y hacer un pedido","register_link":"¿No tienes cuenta? Inscribirse","title":"Inscribirse","login_title":"Identificadores","firstname":"Nombre","lastname":"Apellido","email":"Correo electrónico","phone":"Teléfono","vatnumber":"Número de IVA","company":"Empresa","password":"Contraseña","repeat_password":"repite la contraseña","address_required":"ingrese una dirección de entrega","address_title":"Dirección","address":"Dirección","postal_code":"Código postal","country":"País","town":"Ciudad","register_button":"Crea mi cuenta y continúa","login_link":"Ya tienes una cuenta? Conectarse","password_error":"Tus contraseñas no son las mismas","title_data":"Estate tranquilo","text_data":"Tus datos estan protegidos","forget_title":"contraseña olvidada","forget_subtitle":"Recibirás un correo electrónico para crear una nueva contraseña.","button_recup":"Enviar un correo electrónico","to_login_link":"Conexión de retorno","button_continue_as":"Continuar como","disconnect_button":"Desconectarse","guest_link1":"Continuar como invitado","info_link":"Mi información","hi":"Buenos dias","paragraph1":"Encuentra tu panel aquí. Puede realizar un seguimiento de sus pedidos actuales y gestionar la devolución de los pedidos recibidos.","log_out_button":"Desconectarse","block_title":"Preguntas frecuentes","date":"Viniendo en","leasing_date_from":"Alquiler del","leasing_date_to":"al","return":"Para volver a un punto de relevo antes","returned_at":"Entregado en ","command":"N º de pedido.","manage_shippment":"Gestionar mi entrega","manage_shippment_sentence":"Para rastrear, modificar o cancelar su pedido","follow_my_package":"Sigue mi paquete","no_command":"¡Sin pedidos por el momento!","go_to_shop":"Ir a la tienda","back_link":"Volver","title_information":"Mis datos","cancel_subscription":"Cancelar mi suscripción","cancel_subscription_title":"¿Cómo cancelo mi suscripción?","cancel_subscription_button":"¡Ya entiendo!","cancel_subscription_paragraph":"Es fácil darse de baja. Simplemente devuelva todos los artículos que aún tenga. Una vez que recibamos los artículos en nuestro almacén, su suscripción se cancelará automáticamente. La factura correspondiente al último mes de suscripción se calculará de forma prorrateada","your_infos":"Vuestras informaciones","modification_successfull":"Tu información ha sido modificada","error_happend":"Se ha producido un error. ¡Intentar otra vez!","mail_used":"Esta dirección de correo electrónico ya está en uso","error_disabled":"Su cuenta no está activada","info_button":"Cambiar mi informacion","password_modif_succes":"Contraseña cambiada con éxito","password_button":"cambiar mi contraseña","adress_title":"su dirección de entrega","address_button":"Cambiar mi direccion","link_name":"¿Como funciona?","slides_title":"Mi regreso en tres pasos","verify_title":"Verificación de cuenta en curso","confirm_account":{"title":"Tu cuenta ha sido validada","cta_shop":"Alquile ahora","cta_account":"Ver mi cuenta","error":"Error, redireccionamiento a recepción"},"password_reset":{"title":"Actualiza tu contraseña","description":"Complete el formulario con su nueva contraseña.","error":"Error, la solicitud no se realizó correctamente","success":"Se ha tenido en cuenta su cambio de contraseña, será redirigido a la página de inicio de sesión."},"newsletter":"Suscríbete al boletín","email_send":"Email enviado","continue":"continúa","text":"texto","actual_password":"actual_password","new_password":"nueva contraseña","error_phone":"error_phone","next":"Siguiente","cancelled":"Pedido cancelado","desc_info":"* Al ingresar su dirección de correo electrónico, acepta recibir nuestras novedades, nuestras ofertas comerciales e invitaciones a nuestras ventas privadas y acepta nuestra política de privacidad.","email_not_send":"La dirección de correo electrónico no está en la base de datos. Pruebe con una dirección de correo electrónico diferente.","address_button_create":"Agregar mi dirección de entrega","warning":{"text":"Tenga en cuenta que no tiene una dirección registrada, proporcione una dirección en su información","cta":"Agregar mi direccion"},"street_number":"No.","search_address":{"helper_add":"Para agregar su dirección de entrega, ingrese su dirección en el campo a continuación.","helper_change":"Para cambiar su dirección de entrega, ingrese su dirección en el campo a continuación."},"password_strength_error":"Su contraseña debe contener: al menos 10 caracteres, una mayúscula, una minúscula, un carácter especial y un número.","address_details":"Dirección adicional (edificio, piso, código, etc.)","address_area":"Área","confirm_return":{"title":"Se ha tenido en cuenta su devolución de producto","cta_shop":"Alquilar ahora","cta_account":"Ver mi cuenta","error":"Error, redirigir a mi cuenta","rdv":"cita"},"review_placeholder":"Elija una respuesta de la lista","register_disable":"Lo sentimos, el registro para nuestro servicio de alquiler ya no está disponible.","cancel_order":{"cta_modal":"cancelar mi pedido","modal_title":"cancelar mi pedido","modal_warn":"¿Está seguro de que desea cancelar el pedido?","modal_cta":"anular"},"buy":"Comprar","payment_method":{"title":"Medios de pago","subtitle":"Método de pago registrado:","card":"Mapa ","ending_by":"terminando con ","cta_replace":"Reemplazar método de pago","modal_title":"Reemplazar método de pago","modal_description":"Tenga en cuenta que al cambiar su método de pago, eliminará su método de pago anterior.","modal_cta":"Reemplazar","modal_error":"Error tecnico. Por favor, inténtelo de nuevo más tarde.","modal_success":"Su método de pago ha sido cambiado","caution_info":"Antes de proceder con el pago, debe pagar el depósito por sus artículos.","caution_explanation":"Este depósito será reembolsado después de devolver los productos en buen estado.","caution_button":"Pagar depósito","pay_caution":"Pagar depósito","caution_paid":"¡Depósito pagado con éxito! Ahora puede proceder con el pago.","caution_expired":"El depósito ha expirado. Cree un nuevo depósito.","caution_error":"Se produjo un error al procesar el depósito.","caution_creation_error":"No se pudo crear el depósito. Inténtalo de nuevo.","processing_caution":"Procesando depósito...","swikly_deposit_description":"Depósito de seguridad para artículos alquilados","errors":{"stock":"Un producto en su carrito ya no está disponible","default":"La tarjeta fue rechazada por un motivo desconocido. Póngase en contacto con el emisor de la tarjeta para obtener más información.","expired_card":"La tarjeta de crédito ha caducado. Debe utilizar otro método de pago.","email":"Dirección de correo electrónico no válida.","insufficient_funds":"La tarjeta de crédito no tiene fondos suficientes para realizar la compra. Debe utilizar otro método de pago.","lost_card":"El pago fue rechazado porque la tarjeta de crédito fue declarada extraviada. Póngase en contacto con el emisor de la tarjeta para obtener más información.","stolen_card":"El pago fue rechazado porque la tarjeta de crédito fue reportada como robada. Póngase en contacto con el emisor de la tarjeta para obtener más información.","incorrect_cvc":"El código CVC es incorrecto. Debe intentarlo de nuevo con el CVC correcto.","processing_error":"Ocurrió un error al procesar la tarjeta de crédito. Debes reintentar el pago. Si aún no se puede tratar, vuelva a intentarlo más tarde.","code_operator_label":"Por favor ingrese su código de validación","code_operator_placeholder":"Por ejemplo: 12345","operator_button_validation":"confirma tu orden","wrong_code_operator":"El código introducido no es válido"},"error":"Se ha producido un error"},"dkt_login":"Con tu cuenta Decathlon","information_validation":{"main_title":"Tu cuenta ha sido creada !","subtitle":"Verificación de la información","description":"Como parte del uso de nuestro sitio de alquiler, necesitamos la siguiente información: ","confirmation_button":"Validar mi información"},"sso_login":{"dkt":"Con tu cuenta Decathlon","cultura":"Con tu cuenta Cultura","ciam":"Con Azure AD CIAM"},"external_account_text":"Modificar mis datos en mi cuenta de cliente","take_back_date":"Fecha","order_list_title":"Mis pedidos","take_back_list_title":"mis portadas","order_details_generate":"Generar el bono de retorno","order_details_download":"Haga clic aquí para descargar su etiqueta de devolución","return_label_unavailable":"Su bono de retorno aún no está disponible. Estará accesible una vez que su pedido haya sido enviado.","wish_list_link":"Mi lista de deseos","returning_reason_label":"Motivo de devolución","returning_reason_placeholder":"Seleccione un motivo de devolución","returning_reason_comment_label":"Comentario adicional","returning_reason_comment_placeholder":"Por favor, proporcione detalles adicionales sobre su motivo de devolución","account_type":"Tipo de cuenta","personal_account":"Cuenta personal","b2b_account":"Cuenta empresarial","shop_code":"Código de tienda","siret":"SIRET (sin espacios)","company_name":"Nombre de la empresa","is_customer":"Soy cliente","customer_account_id":"Número de cuenta"},"orders":{"error":"Se ha producido un error. Intente de nuevo!","confirm_return":{"title":"¿Quieres realmente generar un bono de devolución para tu selección?","cta":"Generar bono de devolución","cancel":"Cancelar","reason":"Razón de devolución","reason_placeholder":"Por favor, ingrese la razón de devolución"}},"banner":{"text":"Covid-19: Garantizamos la limpieza y desinfección periódicas de todos los productos."},"basket":{"kit_price":"Tu kit","duration":"Su suscripción","for_short":"para","assurance":"Seguro","free":"Libre","reduction":"entrega","total":"TOTAL","delete_basket":"Quitar de la cesta","continue":"seguir","product":"artículos","return_date":"Fecha de vuelta","whenever_you_want":"Cuando quieras","sub_engagement":"Compromiso de un mes","current_subscription":"Mi suscripción actual","check_on_account":"Ver en mi cuenta","to_pay_this_month":"Pagar este mes","newarticles":"Para sus nuevos artículos de","to":"a","error_stock":"Un producto ya no está disponible en cantidad suficiente","shipping":"Entrega","products":"productos","error_basket":"Su suscripción actual y el número de productos seleccionados no le permiten continuar con su pedido","total_without_shipping":"Total sin entrega","total_weight":"Peso total","try_out":"Adecuado","error_tryout":"Debes tener al menos tantas habitaciones para alquilar como habitaciones para probar","total_with_subscription":"Total","total_without_subscription":"Total","showDetails":"Ver detalles de entrega","hideDetails":"Ocultar detalles de entrega","rentTotal":"Alquiler","buyTotal":"Compra","months":"meses","withoutShipping":"(sin incluir la entrega)","engagement":"Suscripción sin compromiso.","debit":"Recogida a final de mes.","continue_shop":"Seguir comprando","empty":"Su cesta está vacía","drawer":{"title":"Cesta","close":"Cerca"},"reduction_text_explication":"reducción_texto_explicación","gift_card_text":"texto_tarjeta_regalo","gift_card_explanation":"explicación_tarjeta_regalo","deposit":"Depósito","deposit_explanation":"El importe se devolverá después de devolver los productos","remainingInStock":"Reste en stock: {{count}}","b2b_shipping_costs_link":"Costos de envío por cantidad","total_without_shipping_excl_vat":"Total HT","delivery_fees_excl_vat":"Costos de entrega HT","vat":"IVA"},"confirmation":{"email":"Correo electrónico","text":"Covid-19: Garantizamos la limpieza y desinfección periódicas de todos los productos.","title_complements":"Seguir explorando","desc_complements":"¡Con este código de descuento!","codetext":"Disfruta de un 5% de descuento en estos productos con el código","codename":"LIZEECODE","title":"Resumen de pedido","articles_return":"Artículos que necesito devolver","generate_vouchers":"Generar el resguardo de devolución","articles_to_send":"Los artículos que recibiré alrededor del","account_cta":"Acceder a mi cuenta","to_return":"regresar","order_number":"Número de orden"},"emails":{"browser_link":"Abra este correo electrónico en el navegador","signature":"John Doe,\\ndel equipo de alquiler de la marca Lizee","bottom_section_title":"Su regreso","bottom_section_content":"¿Cómo organizar tu regreso? es fácil, sigue la guía.","footer":"¡Los equipos de la marca te desean un buen día!","copyright":"De acuerdo con la ley \\"Informatique et Libertés\\" del 6 de enero de 1978, en cualquier momento puede solicitar acceder, rectificar o eliminar la información personal que le concierne u oponerse a su tratamiento por parte de Brand.\\nEste correo electrónico es un acuse de recibo de su pedido y confirma el contrato de alquiler. En breve se le enviará un correo electrónico confirmando la edición de sus artículos.","order_confirm_title":"¡Gracias por su orden!","order_confirm_main_text":"Hemos recibido su pedido n ° XXXXXX. Se enviará lo antes posible y llegará a un punto de retransmisión / en su domicilio o en su domicilio según el método de entrega elegido.","order_confirm_cta_text":"¡Síganos!","order_summary_title":"Resumen de la orden","order_id_text":"Número de orden:","order_start_subscription_date":"Fecha de inicio de la suscripción","order_renting_start":"Fecha de inicio del alquiler","order_renting_end":"Fecha de vuelta","order_renting_duration":"Duración de la ubicación","order_shipping":"Dirección de entrega:","order_shipping_method":"Entrega a domicilio","order_products":"Lista de productos","order_paid_text":"Pagado","order_tax_text":"20% IVA incluido","order_pay_method":"Método de pago","order_pay_method_desc":"Tarjeta de crédito que termina en"},"faq":{"subtitle":"Iniciar sesión con mi dirección de correo electrónico","title":"Inscribirse"},"funnel":{"email":"Correo electrónico","phone":"Teléfono","address":"Dirección","postal_code":"Código postal","country":"País","free":"Libre","return_button":"Volver","delivery_title":"1. Entrega","delivery_description":"Recibirás tu paquete con X días de antelación. ","delivered_on":"Entregado en ","return_before":"Para volver antes","return_title":"2. Regreso","home_delivery":"Entrega a domicilio","change_my_address":"Cambiar mi direccion","shop_delivery":"Entrega al punto de paquetería","choose":"Elegir","next1":"Próximo","titleform":"Ingrese su información de pago","pay":"Paga","first_name":"Nombre","last_name":"Apellido","city":"Ciudad","next":"Próximo","create_account_link":"Crear una cuenta","continue_with_account":"Continuar con la cuenta","information":"Información","shipping":"Entrega","step":"paso","coupon_title":"¿Tienes un código de promoción?","coupon_cta":"Aplicar","coupon_applied":"Este código de promoción se aplica:","coupon_success":"Este código promocional es válido","coupon_error":"¿Tienes un código de promoción?","no_shipping_available":"no_envío_disponible","payment":{"title":"título","success":"éxito","progress":"Progreso","cgu":"cgu","retractation_agreement":"Reconozco expresamente que renuncio a mi derecho de desistimiento ya que mi alquiler comienza antes de la expiración del período de desistimiento de 14 días.","custom_cgu_link":"Acceso a CGL","payment_accordion":{"card_title":"Pago seguro con tarjeta de crédito","card_tagline":"Pago asegurado por Stripe™. Tarjetas aceptadas","paypal_title":"Paypal"},"caution_info":"Antes de proceder con el pago, debe pagar el depósito por sus artículos.","caution_explanation":"Este depósito será reembolsado después de devolver los productos en buen estado.","caution_button":"Pagar depósito","pay_caution":"Pagar depósito","caution_paid":"¡Depósito pagado con éxito! Ahora puede proceder con el pago.","caution_expired":"El depósito ha expirado. Cree un nuevo depósito.","caution_error":"Se produjo un error al procesar el depósito.","caution_creation_error":"No se pudo crear el depósito. Inténtalo de nuevo.","caution_token_mismatch":"Depósito inválido para este pedido. Inténtalo de nuevo.","processing_caution":"Procesando depósito...","swikly_deposit_description":"Depósito de seguridad para artículos alquilados","errors":{"stock":"Un producto en su carrito ya no está disponible","stock_error_intro":"Los siguientes productos ya no están disponibles en cantidad suficiente:","stock_error_footer":"Por favor, actualice su carrito antes de proceder con el pago.","availability_check_failed":"No se ha podido comprobar la disponibilidad por un problema técnico temporal. Inténtelo de nuevo en unos momentos.","default":"La tarjeta fue rechazada por un motivo desconocido. Póngase en contacto con el emisor de la tarjeta para obtener más información.","expired_card":"La tarjeta de crédito ha caducado. Debe utilizar otro método de pago.","email":"Dirección de correo electrónico no válida.","insufficient_funds":"La tarjeta de crédito no tiene fondos suficientes para realizar la compra. Debe utilizar otro método de pago.","lost_card":"El pago fue rechazado porque la tarjeta de crédito fue declarada extraviada. Póngase en contacto con el emisor de la tarjeta para obtener más información.","stolen_card":"El pago fue rechazado porque la tarjeta de crédito fue reportada como robada. Póngase en contacto con el emisor de la tarjeta para obtener más información.","incorrect_cvc":"El código CVC es incorrecto. Debe intentarlo de nuevo con el CVC correcto.","processing_error":"Ocurrió un error al procesar la tarjeta de crédito. Debes reintentar el pago. Si aún no se puede tratar, vuelva a intentarlo más tarde.","code_operator_label":"Por favor ingrese su código de validación","code_operator_placeholder":"Por ejemplo: 12345","operator_button_validation":"confirma tu orden","wrong_code_operator":"El código introducido no es válido","minimum_cart_items":"No se ha alcanzado el número mínimo de artículos en el carrito"},"error":"Se ha producido un error"},"invalid_tel":"teléfono_inválido","coupon_label":"Código promocional","your_rental_from":"Tu alquiler de","your_rental_to":"a","show_cart":"Mostrar carrito","hide_cart":"Ocultar carrito","toBeDetermined":"Por determinar"},"general":{"home":"Casa","selection":"Toda la selección","return":"Para volver a un punto de relevo antes","baseline":"Alquiler. Ahorrar. Disfrutar","footer_tagline":"De la venta al alquiler","footer_top_baseline":"El seguro de daños está incluido.","footer_top_link_label":"Ver todos los productos","contact_us_button":"Contáctenos","cgl":"Condiciones generales de alquiler","policy":"política de confidencialidad","small_text_under_calendar":"¡Cuanto más alquila, menos paga!","start_button":"Inicio","confirm_button":"Confirmar","delivered":"Entregado el o antes","meta_description":"Aquí está la meta desc","meta_title":"Aquí hay un título","meta_url":"http://whitelabel.lizee.io/","you_save":"Ahorras","my_account":"Mi cuenta","FAQ":"Preguntas más frecuentes","add_a_title":"es un titulo","add_a_description":"esta es una descripción","add_a_subtitle":"esto es un subtítulo","add_a_text":"añadir texto","from":"De","month":"mes","day":"día","stock_texts":{"few_products_left":"¡Más que unos pocos productos!","back_soon":"Vuelva pronto","in_stock":"En stock"},"search_address":{"cta":"Buscar","incomplete":"La dirección ingresada no está completa. Especifique su dirección con una calle, una ciudad y un código postal.","no_results":"No se ha encontrado ninguna dirección en nuestra base de datos. Ingrese otra dirección.","excluded":"La entrega no es compatible con esta dirección.","invalid_country":"La entrega no es compatible con este país.","label":"Encuentra tu dirección de entrega","same_address":"La dirección de entrega y la dirección de facturación son las mismas","label_billing":"Encuentra tu dirección de facturación","placeholder":"Ejemplo: 15 rue de milan Paris","change_delivery_point":"Editar"},"search_bar":{"input_label":"Buscar un producto","input_placeholder":"Buscar un producto","button_label":"Buscar un producto"},"previous_button":"Anterior","sizes":"Tallas","month_short":"mes_corto","day_short":"día_corto","copyright":"derechos de autor","card_number":"número de tarjeta","expiry_date":"Fecha de caducidad","cvc_code":"CVC","morning":"Mañana","afternoon":"Tarde","evening":"Anochecer","fullDay":"Todo el dia","flex_price_information":"Precios basados en un mes de 30 días","month_without_space":"/mes","handle_cookies":"Administrar cookies","days_plural":"dias","day_singular":"día","delivery_point":"Resultados cerca de: ","menu":{"close":"Cerca"},"main_menu":{"item":"Menú principal","subitem":"Submenú"},"holder_name":"Nombre del dueño","unit":"/ unidad","unit_short":"/u","change_language_modal_title":"Cambiar idioma","change_language_modal_text":"Tenga cuidado, está a punto de cambiar de idioma. Si tiene artículos en su carrito, su carrito se perderá.","change_language_modal_cancel_text":"anular","change_language_modal_validation_text":"Cambiar idioma","vat":{"included":"c/IVA","excluded":"s/IVA"}},"homepage":{"maintitle":"Alquiler. Ahorrar. Disfrutar. ","descriptiontext":"Alquile nuestros productos bajo pedido. ","cta_pack_label":"Ver los packs","titlehowitworks":"Como funciona ?","deschowitworks1":"Reserve su kit en línea y recíbalo en casa o en un punto de recogida de su elección en Francia. El kit estará disponible 2 días antes de su salida y tiene 2 días para devolverlo después del final de su caminata. ","deschowitworks2":"¿Prima?\\nPuede devolver su kit desde su lugar de trekking. Utilizando la etiqueta de devolución incluida en su paquete, deje su paquete en cualquier punto de retransmisión de Chronopost en Francia continental. / Puede devolver su equipo desde su lugar de senderismo. La etiqueta de devolución está incluida en su paquete y puede dejar su kit en cualquier punto Chronopost en Francia. ","titletestimonials":"Lo intentaron ","section_title_savings":"Cuanto más tiempo alquila, menos paga: ","link_label_savings":"Empiece a alquilar","start_savings_text":"Tu alquilas por","end_savings_text":"ahorras","buy_savings_text":"Si tú compras","rent_savings_text":"Si estas alquilando","saving_mentions":"* Monto basado en los precios promedio de nuestros productos","featured_product_title":"Un ejemplo con nuestro producto favorito:","featured_product_name":"Mochila verde y azul 20L","featured_product_link_label":"Explore las opciones","title_commitment":"Sabías ?","description_commitment":"Tu elección tendrá un impacto positivo en el planeta: ¡alquilar con Lizee ahorra una media de 350g de CO2 por producto!","section_title_community":"Tus ahorros con el alquiler:","title_community":"Nuestros clientes inquilinos ya han ahorrado: ","amount_community":"35 000 €","subtitle_universe1":"Título de los productos taxonómicos","paragraph_universe1":"Desc para paquetes de taxones","subtitle_universe2":"Título de los paquetes de taxones","paragraph_universe2":"Desc para paquetes de taxones","categorie":"Sylius Taxón","rent":"Alquilar","partner":"pareja"},"instagramwall":{"title":"Inscribirse","desc":"Comparte tus recuerdos con #Lizee ","buttontext":"Síganos !"},"packs":{"from":"De","month":"mes","buttontext":"Síganos !","header_title":"Packs","herotitle":"Descubra nuestros packs ","titlepacks":"Packs diseñados para ti","packsparagraph":"¡Elija entre los paquetes a continuación o cree el suyo propio! ","shipping_description":"Envío a domicilio gratuito en pedidos superiores a 30 €!","pack_to_shop_button":"Crea tu paquete","fake_pack_title":"Crea tu propio paquete","fake_pack_button":"Ver más productos","select":"para seleccionar","title_size_modale":"Seleccione el tamaño para agregarlo a su carrito:","victim_of_success":"Víctima de su propio éxito","link_to_single":"ver el paquete"},"page":{"title":"Pagina del titulo","content":"Pagina de contenido. Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti animi iure iusto ex explicabo aspernatur commodi voluptatum, laudantium voluptatem corporis."},"sso":{"errors":{"41000083":"The account used is not a professional account.","default":"An unexpected error occurred."}},"privacy":{"title":"Inscribirse","wysiwyg":"Última actualización: 12 de marzo de 2020\\n","showCookie":"Gestión de las cookies"},"products_to_buy":{"products_category":"Productos para comprar","buy_button":"Comprar","see_more":"Más información"},"rental_terms":{"title":"Inscribirse","wysiwyg":"Última actualización: 12 de marzo de 2020\\n"},"shop":{"choose":"Elegir","header_title":"Packs","herotitle":"Descubra nuestros packs ","title_size_modale":"Seleccione el tamaño para agregarlo a su carrito:","victim_of_success":"Víctima de su propio éxito","titleshop":"Alquile de la mejor selección","shopdescription":"¡Elige tus favoritos! ","shippingdescription":"Envío a domicilio gratuito en pedidos superiores a 30 €!","shop_to_packs_button":"Ver los packs","filter":"Filtros","filter_by_taxons":"Filtrar por categorías","filter_apply":"Aplicar filtros","availableOnly":"Ver solo productos disponibles","classic_sub":{"our_rates":"Nuestros paquetes escalables","adjustable_rate":"Su paquete se ajusta según su selección.","articles":"artículos","maximum":"máximo","article":"artículo"},"filters":"filtros","pack_size_modal_cta_add":"Añadir a la cesta","pack_size_modal_cta_return":"Volver a las mochilas","filters_dropdown_label":"Seleccione","max_item_in_cart":"Producto máximo por cesta alcanzado","prev":"Anterior","next":"Próximo","no_stock_available":"No hay productos disponibles en esta categoría.","search_not_found":"No se encontraron productos","filters_modale_title":"filtros_modale_title","autocomplete_search_placeholder":"Buscar {{attributeName}}...","autocomplete_no_results":"No se encontraron resultados","autocomplete_no_values":"No hay valores disponibles","autocomplete_loading":"Cargando...","autocomplete_load_more":"Cargar más","close_button":"cerrar_boton","categories_title":"categorías_título","apply_button":"botón_aplicar","accordion_shop_title":"acordeón_tienda_título","and":"y","price_min_label":"Mín","price_max_label":"Máx","sort":"Ordenar","filter_and_sort":"Filtrar y ordenar","filter_title_in_drawer":"Filtrar","sort_by_price_asc":"Precio ascendente","sort_by_price_desc":"Precio descendente","sort_by_date_asc":"Más antiguos","sort_by_date_desc":"Más recientes","error_loading_products":"Ocurrió un error al cargar los productos. Por favor, inténtelo de nuevo más tarde.","shipping_costs":{"number_of_articles":"Número de artículos","round_trip_cost":"Costo de ida y vuelta","title":"Costos de envío en el peor caso (Incl. Seguro)"}},"single_product":{"choose_button":"Elegir","associations_title":"También puede interesarle esto:","try_out_button":"Probar:","try_out_tooltip":"Solo puede probar una habitación por habitación alquilada","buy_button":"Comprar","choose_button_tooltip":"Seleccione un tamaño para agregar al carrito","display_total_rental_price":"precio total de alquiler","availability_checker":{"modal_close":"Cerca","text":"Este artículo no está disponible en estas fechas.","link":"Ver disponibilidad","modal_title":"Consultar disponibilidad","modal_description":"El artículo no está disponible cuando las fechas están tachadas"}},"statements":{"bottom_sentence":"¡Cuanto más viaje, más ahorrará!","link":"Más información"},"subscription_order":{"change_cta":"Editar","cancel_cta":"anular","rate":"Tarifa plana","handle_return_cta":"Gestionar la devolución de mis artículos","my_subscription":"Mi suscripción :","taken_every":"Tomado cada","of_the_month":"del mes","per_month":"Por mes","articles_max":"elementos máximos","select_all_and_stop":"Seleccionar todo y detener mi suscripción","generate_the_return_slip":"Generar el resguardo de devolución","continue":"seguir","size":"Tamaño :","month":"mes","bottom_sentence":"Un comprobante de devolución estará disponible al final del pedido. Todo sobre devoluciones","funnel":{"current_subscription":" , ya tiene una suscripción actual.","subtitle":"Puedes devolver tus artículos antiguos para ajustar tu suscripción. Si quieres conservar tus artículos, ve al siguiente paso.","skip_step":"omita este paso"},"returned_product_title":"Productos devueltos este mes","returned_product_desc":"Estos productos se han recibido y se eliminarán permanentemente de su espacio en su próximo pago.","canceled_order_title":"Pedidos cancelados","canceled_order_desc":"cancelado_pedido_desc","refunded_order_title":"Pedidos reembolsados","refunded_order_desc":"desc_pedido_reembolsado","sub_finished":{"title":"¡Suscripción finalizada!","desc":"Estamos tristes de verte partir. Su último débito se prorrateará para el mes actual una vez que se devuelvan los artículos."},"returned_date":"Regresó el","link_download_return":"Haga clic aquí para descargar su comprobante de devolución","invoice_this_month":"Tu factura de este mes:","invoice_explanation":"Calculamos el importe facturado cada mes según el prorrateo de los productos alquilados y devueltos en el mes actual.","subscription_start_date":"Su suscripción comienza el:","subscription_date_explanation":"Su suscripción comienza 5 días después de la fecha de su primer pedido. Esta fecha tiene en cuenta los tiempos de preparación de su pedido y los tiempos de entrega.\\n Desde el inicio de la suscripción, se le facturará mensualmente, en la fecha de aniversario. El servicio de devolución de productos estará disponible después de que inicie su suscripción.","bought_product_title":"Productos comprados:","bought_product_desc":"comprado_producto_desc","product_not_eligible_for_return":"Producto no apto para devolución","tooltip_product_not_eligible_for_return":"Devolución posible a partir de la fecha de suscripción"},"customer_survey":{"main_title":"Encuesta de satisfacción","subtitle":"Ayúdanos a mejorar nuestros servicios","let_a_message":"Un mensaje ?","satisfaction":"Satisfacción","dropdown_title":"Estado de retorno","notes":"Notas","observation":"Un comentario ?","message":"mensaje","send":"enviar","contact_title":"contact_title","error_fields":"campos_error","desc_contact":"¡Déjanos un mensaje!"},"snackbar_message":{"add":"Artículo añadido a","delete":"Artículo eliminado de","remove":"Artículo eliminado de","add_multiple":"Los productos se han añadido a","limit":"Ha alcanzado el número máximo de productos en una suscripción","rental_range_selected_is_blocked":"El período de alquiler seleccionado no está disponible. Por favor, elija otro período de alquiler.","cart":"la cesta","max":"La cantidad solicitada supera el stock disponible","add_tryout":"El producto ha sido agregado para su instalación.","profilUpdated":"Su información ha sido actualizada correctamente"},"instore":{"modale_title":"Elige tu tienda","modale_shop_name":"Nombre de la tienda","modale_informations":"Información","modale_choose_shop":"Elige una tienda","modale_details":"Detalles de contacto","modale_choose_button":"Elegir","modale_address":"Dirección :","modale_phone":"Teléfono :","change_store_title":"Cambiar de tienda","change_store_paragraph":"Cuidado, estás a punto de cambiar de tienda. Si tiene artículos en su carrito de compras, su carrito de compras se perderá.","cancel_button":"anular","change_store_button":"Cambiar de tienda","header_change_store":"Cambiar de tienda","product_not_available":"Producto no disponible en esta tienda","paragraph":"Puedes elegir otra tienda para comprobar su disponibilidad. Tendrás que recoger tu pedido en la nueva tienda seleccionada. Esto tendrá el efecto de vaciar su cesta actual.","change_store_cta":"Cambiar de tienda","no_store_available":"No hay ninguna tienda disponible para este código postal","search_input_placeholder":"Ejemplo: 33","search_input_label":"Ingrese el comienzo de un código postal","search":"Buscar","appointments_page_title":"Desea hacer una cita para:","appointment_page_pickup_link_label":"Una retirada en tiendas","appointment_page_return_link_label":"Una vuelta a la tienda","account_page_return_link_label":"Regresar a tu tienda","pack_not_available":"Pack No disponible en esta tienda"},"pack_single":{"choose":"Añadir paquete al carrito","sold_out":"Paquete no disponible","pack_content_title":"Artículos incluidos en este paquete:"},"takeBack":{"title":"Vender un artículo","meta_title":"Programa de devolución de artículos","required_field":"* Campos obligatorios","text":"Rellena nuestro formulario para recibir tu oferta de compra. Una pregunta sobre el funcionamiento?","step_1":"Tu objeto","step_2":"Nuestra oferta","step_3":"Confirmación","step_edit_parcel_number":"Editar el número de paquetes","parcel_number_label":"¿Cuántos paquetes desea enviar?","positive_response_to_preliminary_questions":"Sí","negative_response_to_preliminary_questions":"No","condition_question":"¿Buen estado?","error_message":"Lamentablemente, no aceptamos este tipo de artículo.","next_step_button":"Etapa siguiente","reference_number_label":"Referencia del artículo","reference_number_placeholder":"Referencia presente en la etiqueta","reference_number_link":"Dónde encontrar la referencia de mi artículo","reference_number_text":"Encontrarás la referencia en el lugar indicado en la imagen","select":"Seleccione un valor","close_modal":"Cerca","waiting_price_text":"Estimamos el precio de venta de su artículo. Espere por favor.","offer_announcement_text":"Teniendo en cuenta la información proporcionada, nos complace ofrecerle una oferta de devolución por valor de:","price_explication":"* Este importe será definitivo tras la verificación del artículo por parte de nuestros equipos.","accept_offer_button":"Acepta nuestra oferta","login_text":"Debes estar registrado para recibir nuestra oferta","register_text":"Debes crear una cuenta para recibir nuestra oferta","confirmation_text":"¡Enhorabuena!.\\n¡La oferta de precio le ha sido enviada por correo electrónico! ","take_back_location_title":"Elija el sitio donde aplicar la recuperación:","take_back_country_title":"¿En qué país le gustaría utilizar su bono?\\n","reference_check_button":"Buscar","reference_error":"referencia incorrecta","take_back_menu":"Revender","state_title":"Estado","state_1":"Perfecta condicion","state_2":"Muy buena condicion","state_3":"Buen estado","previous_step":"Paso anterior","select_label_size":"Tamaño","select_label_state":"Estado","refused_state":"No incluido","faq_title":"Preguntas frecuentes","reference":"Referencia","add_product":"Añadir artículo","confirmation_title":"¡Gracias!","address_check_required":"Por favor, verifique su dirección de entrega","confirm_address_button":"Confirmar dirección","voucher_printing_button":"Imprime la nota de despacho","your_order_confirmation":"Su número de orden","label":"Etiqueta","states_explanation_link":"¿Cómo elegir el estado?","item":"Artículo No.","question_title":"¿Cuál es el estado de su habitación?","take_back_location_desc":"Elige ahora el tipo de bono que deseas recibir. Atención, una vez elegido no podrá modificar el tipo de bono deseado.​​","step_2_error":"Ocurrió un error al procesar la solicitud. Intentar otra vez","total":"Total","status_label":"Estado","accepted_status":"Aceptado","refused_status":"Rechazar","in_progress_status":"En curso","command":"Toma de control No.","price_start":"precio_inicio","tab_label_secondhand":"tab_label_segundamano","tab_label_rental":"tab_label_rental","state_label":"etiqueta_estado","second_hand_label":"etiqueta_de_segunda_mano","original_price":"Precio original","take_back_command":"Take_back_command","take_back_description":"take_back_description"},"search_page":{"title":"Resultados de la búsqueda para : {{ search }} ({{ length }})"},"wishlist":{"title":"Mi lista de deseos","empty":"Tu lista de deseos está vacía","button":"Añadir a la lista de deseos"},"size_guide_page":{"span_title":"Guía de tallas","size_guide":"🎀 Guía de tallas","question":"¿Sabías que 9 de cada 10 mujeres no conocen su verdadera talla de sujetador? Descubre la tuya gracias a nuestro sencillo y preciso calculador. Para todos nuestros modelos sin aros, así como para las braguitas, te recomendamos elegir tu talla habitual.","measure_your_back_circumference":"1. Mide tu contorno debajo del busto","not_tight":"No ajustado","slightly_tight":"Ligeramente ajustado","very_tight":"Muy ajustado","measure_your_bust":"2. Mide tu busto","standing_up_straight":"De pie recta","leaning_forward":"Inclinándote hacia adelante","lying_on_your_back":"Acostada boca arriba","calculate_size":"Calcular mi talla","error_size_not_found":"Talla no encontrada para estas medidas","bra_size":"Tu talla de sujetador es "},"reservations":{"title":"Mis reservas","header_tooltip":"Mis reservas","info_banner":"Los productos se ponen en venta automáticamente cuando la reserva expira.","empty_text":"No tienes ninguna reserva activa.","cta_shop":"Ver productos","product_label":"Producto","expires_on":"Expira el","buy_now":"Comprar ahora","release":"Liberar reserva","reserve_cta":"Reservar {{days}} días laborables","confirm_title":"Confirmar reserva","confirm_body":"Estás a punto de reservar este producto durante {{days}} días hábiles. Ya no estará disponible para otros clientes.","confirm_expiration":"Fecha de expiración","confirm_cta":"Confirmar reserva","confirm_cancel":"Cancelar","confirm_error":"Se produjo un error. Inténtelo de nuevo más tarde.","confirm_error_conflict":"Este producto ya ha sido reservado","reservations_product_already_reserved":"Este producto está reservado para usted, encuéntrelo en Mis Reservas"},"cancel_contract":{"button_label":"Cancelar mi contrato","title":"Retractación / cancelación","intro":"¿Desea cancelar su pedido o devolver un producto? Rellene este formulario y nuestro equipo gestionará su solicitud.","type_label":"Su solicitud","type_cancellation":"Cancelar mi pedido","type_return":"Devolver un producto","order_reference_label":"Número de pedido","email_label":"Correo electrónico","message_label":"Mensaje (opcional)","submit_button":"Enviar mi solicitud","required_fields":"* Campos obligatorios","error_order_reference":"Introduzca su número de pedido.","error_email":"Introduzca una dirección de correo electrónico válida.","error_generic":"Se ha producido un error. Compruebe sus datos e inténtelo de nuevo.","success_title":"Su solicitud se ha registrado correctamente","success_message":"Recibirá un correo de confirmación. Nuestro equipo se pondrá en contacto con usted en breve.","close_button":"Cerrar"}}');

/***/ }),

/***/ 22910:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"404":{"title":"404 - Page introuvable","cta":"Retour à l\'accueil"},"account":{"herotitle":"Mon Compte","title_login":"Accéder à mon Compte","subtitle":"Connectez-vous avec votre adresse e-mail","successfull_register":"Toutes nos félicitations ! Votre compte a été créé, vous recevrez un mail de validation.","login_email":"Email","login_password":"Mot de passe","forget_password_link":"Mot de passe oublié ?","guest_link":"Continuer en tant qu\'invité","error_login":"Votre adresse e-mail ou votre mot de passe ne correspond pas. Veuillez réessayer","login_button":"S\'identifier","login_to_see_price":"Connectez-vous pour consulter nos prix et commander","register_link":"Pas de compte ? S\'inscrire","title":"S\'inscrire","login_title":"Identifiants","gender_label":"Civilité","gender_female":"Mme","gender_male":"M","firstname":"Prénom","lastname":"Nom","email":"Email","phone":"Téléphone","vatnumber":"Numéro de TVA","company":"Raison sociale","password":"Mot de passe","repeat_password":"Répéter le mot de passe","address_required":"veuillez renseigner une adresse de livraison","address_title":"Adresse","address":"Adresse","postal_code":"Code postal","country":"Pays","town":"Ville","register_button":"Créer mon compte et continuer","login_link":"Avez-vous déjà un compte? Se connecter","password_error":"Vos mots de passe ne sont pas les mêmes","title_data":"Reste calme","email_format_incorrect":"Le format de votre adresse email n\'est pas valide","text_data":"Vos données sont protégées","forget_title":"Mot de passe oublié","forget_subtitle":"Vous recevrez un e-mail pour créer un nouveau mot de passe","button_recup":"Envoyer un mail","to_login_link":"Retour connexion","button_continue_as":"Continuez comme","disconnect_button":"Se déconnecter","guest_link1":"Continuer en tant qu\'invité","info_link":"mes infos","hi":"Bonjour","paragraph1":"Retrouvez ici votre tableau de bord. Vous pouvez suivre vos commandes en cours et gérer le retour des commandes reçues.","log_out_button":"Se déconnecter","block_title":"Questions Fréquentes","date":"A venir le","leasing_date_from":"Location du","leasing_date_to":"au","return":"A retourner en point relais avant le","returned_at":"Rendue le ","command":"Commande n °","manage_shippment":"Gérer ma livraison","manage_shippment_sentence":"Pour suivre, modifier ou annuler votre commande","follow_my_package":"Suivre mon colis","no_command":"Pas de commandes pour l\'instant!","go_to_shop":"Aller au Shop","back_link":"Revenir","title_information":"Mes données","cancel_subscription":"Annuler mon abonnement","cancel_subscription_title":"Comment résilier mon abonnement ?","cancel_subscription_button":"J\'ai compris !","cancel_subscription_paragraph":"Pour résilier, rien de plus simple ! Il vous suffit de retourner tous les articles encore en votre possession. Une fois que nous recevrons les articles dans notre entrepôt, votre abonnement sera automatiquement résilié. La facture du dernier mois d\'abonnement sera calculée au prorata","your_infos":"Vos informations","modification_successfull":"Vos infos ont été modifiées","error_happend":"Une erreur est survenue. Réessayez !","mail_used":"Cette adresse email est déjà utilisée","error_disabled":"Votre compte n\'est pas activé","info_button":"Changer mes informations","password_modif_succes":"Mot de passe modifié avec succès","password_button":"Changer mon mot de passe","adress_title":"Votre adresse de livraison","address_button":"Changer mon adresse","link_name":"Comment ca marche?","slides_title":"Mon retour en trois étapes","verify_title":"Vérification du compte en cours","confirm_account":{"title":"Votre compte a bien été validé","cta_shop":"Louer dès maintenant","cta_account":"Voir mon compte","error":"Erreur, redirection vers l\'accueil"},"password_reset":{"title":"Mettre à jour votre mot de passe","description":"Veuillez remplir le formulaire avec votre nouveau mot de passe.","error":"Erreur, La requête n\'a pas abouti","success":"Votre modification de mot de passe a bien été pris en compte, vous allez être redirigé vers la page de connexion."},"newsletter":"S\'inscrire à la newsletter","email_send":"Email envoyé","continue":"Continuer","text":"Après votre inscription, un email vous sera envoyé pour valider votre compte","actual_password":"Mot de passe actuel","new_password":"Nouveau mot de passe","error_phone":"Le numéro de téléphone n\'est pas valide. Réessayez !","next":"Continuer","cancelled":"Commande annulée","desc_info":"*En renseignant votre adresse email, vous acceptez de recevoir nos actualités, nos offres commerciales, et invitations à nos ventes privées et acceptez notre politique de confidentialité.","email_not_send":"L\'adresse mail n\'est pas dans la base de données. Essayez avec une autre adresse email.","address_button_create":"Ajouter mon adresse de livraison","warning":{"text":"Attention, vous n\'avez pas d\'adresse enregistrée, merci de fournir une adresse dans vos informations","cta":"Ajouter mon adresse"},"street_number":"N°","search_address":{"helper_add":"Pour ajouter votre adresse de livraison, saisissez votre adresse dans le champ ci dessous.","helper_change":"Pour changer votre adresse de livraison, saisissez votre adresse dans le champ ci dessous."},"password_strength_error":"Votre mot de passe doit contenir : au minimum 10 caractères, une majuscule, une minuscule, un caractère spécial et un chiffre.","address_details":"Complément d\'addresse (Bâtiment, Étage, Code etc.)","address_area":"Région","confirm_return":{"title":"Votre retour de produit à bien été pris en compte","cta_shop":"Louer dès maintenant","cta_account":"Voir mon compte","error":"Erreur, redirection vers mon compte","rdv":"Vous allez être redirigé vers la page de prise de rendez-vous"},"review_placeholder":"Merci de choisir une réponse dans la liste","register_disable":"Nous sommes désolés, l\'inscription à notre service de location n\'est plus disponible.","cancel_order":{"cta_modal":"Annuler ma commande","modal_title":"Annuler ma commande","modal_warn":"Êtes-vous certain de vouloir annuler la commande?","modal_cta":"Valider"},"buy":"Acheter","order_download_invoice":"Télécharger votre facture","order_download_invoice_error":"Une erreur est survenue lors du téléchargement","payment_method":{"title":"Moyen de paiement","subtitle":"Moyen de paiement enregistré :","card":"Carte ","ending_by":" se terminant par ","cta_replace":"Remplacer le moyen de paiment","modal_title":"Remplacer le moyen de paiment","modal_description":"Attention, en changeant de moyen de paiement vous allez supprimer votre moyen de paiement précédent.","modal_cta":"Remplacer","modal_error":"Erreur technique. Veuillez essayer ultérieurement.","modal_success":"Votre moyen de paiement a été modifié"},"dkt_login":"Avec votre compte Decathlon","information_validation":{"main_title":"Votre compte à bien été créé !","subtitle":"Vérification des informations","description":"Dans le cadre de l\'utilisation de notre site de location, nous avons besoin des informations suivantes : ","confirmation_button":"Valider mes informations"},"sso_login":{"dkt":"Avec votre compte Decathlon","cultura":"Avec votre compte Cultura","ciam":"Avec votre compte Virgin"},"external_account_text":"Modifier mes informations sur mon compte client","take_back_date":"Date","order_list_title":"Mes commandes","take_back_list_title":"Mes reprises","order_details_open":"Gérer ma commande","order_second_hand_details":"Gérer mes articles de seconde main","order_details_close":"Retour","order_details_manage":"Gérer le retour de mes articles","order_details_manage_cancel":"Annuler","order_details_generate":"Générer le bon retour","order_details_download":"Cliquez ici pour télécharger votre bordereau de retour","return_label_unavailable":"Votre bon de retour n\'est pas encore disponible. Il sera accessible une fois votre commande expédiée.","order_take_back_withdrawal_text":"Vous ne pouvez pas retourner votre commande, soit vous n\'avez pas reçu cette dernière soit vous avez dépassé le délai légal de retractation","product_returned":"Cet article a été retourné","area_address":{"label_address_details":"Adresse","placeholder_address_details":"Adresse détaillée","label_city":"Ville","placeholder_city":"Veuillez renseigner votre ville","label_area":"Region","placeholder_area":"Veuillez renseigner votre region"},"wish_list_link":"Ma liste de souhaits","returning_reason_label":"Motif de retour","returning_reason_placeholder":"Sélectionnez un motif de retour","returning_reason_comment_label":"Commentaire supplémentaire","returning_reason_comment_placeholder":"Veuillez fournir des détails supplémentaires sur votre motif de retour","account_type":"Type de compte","personal_account":"Compte personnel","b2b_account":"Compte professionnel","shop_code":"Code boutique","siret":"SIRET (sans espace)","error_siret":"Le SIRET doit contenir exactement 14 chiffres","company_name":"Nom de la société","is_customer":"Je suis client","customer_account_id":"Numéro de compte"},"orders":{"error":"Une erreur est survenue. Réessayez !","confirm_return":{"title":"Voulez-vous vraiment générer un bon de retour pour votre sélection ?","cta":"Générer le bon de retour","cancel":"Annuler","reason":"Raison du retour","reason_placeholder":"Veuillez renseigner la raison du retour"}},"banner":{"text":"Covid-19: Nous garantissons un nettoyage et une désinfection réguliers de tous les produits"},"basket":{"kit_price":"Votre kit","duration":"Votre abonnement","for_short":"pour","assurance":"Assurance","free":"Gratuit","reduction":"Réduction","total":"TOTAL","delete_basket":"Supprimer le panier","continue":"Continuer","product":"article","return_date":"Date de retour","whenever_you_want":"Quand tu veux","sub_engagement":"Engagement d\'un mois","current_subscription":"Mon abonnement actuel","check_on_account":"Voir sur mon compte","to_pay_this_month":"A payer ce mois-ci","newarticles":"Pour vos nouveaux articles de","to":"à","error_stock":"Un produit n\'est plus disponible en quantité suffisante","shipping":"Livraison","products":"articles","error_basket":"Votre abonnement actuel et le nombre de produits sélectionnés ne permettent pas de poursuivre votre commande","total_without_shipping":"Total sans livraison","total_weight":"Poids total","try_out":"Essayage","error_tryout":"Vous devez avoir au moins autant de pièces à louer que de pièces à essayer","total_with_subscription":"Total","total_without_subscription":"Total","showDetails":"Afficher les détails","hideDetails":"Masquer les détails","rentTotal":"Location","buyTotal":"Achat","months":"Mois","withoutShipping":"(hors livraison)","engagement":"Abonnement sans engagement.","debit":"Prélevé à la fin du mois.","continue_shop":"Continuez vos achats","empty":"Votre panier est vide","drawer":{"title":"Panier","close":"Fermer"},"reduction_text_explication":"Ajouter votre code promo à l\'étape du paiement","gift_card_text":"Solde carte cadeau disponible :","gift_card_explanation":"Le montant sera débité en priorité sur votre carte cadeau","deposit":"Caution","deposit_explanation":"Le montant sera reversé après retour des produits","remainingInStock":"Reste en stock: {{count}}","b2b_shipping_costs_link":"Frais de livraison par quantité","total_without_shipping_excl_vat":"Total HT","delivery_fees_excl_vat":"Frais de livraison HT","vat":"TVA"},"confirmation":{"email":"Email","text":"Covid-19: Nous garantissons un nettoyage et une désinfection réguliers de tous les produits","title_complements":"Continuez à explorer","desc_complements":"Avec ce code de réduction!","codetext":"Profitez de 5% de réduction sur ces produits avec le code","codename":"LIZEECODE","title":"Récapitulatif de commande","articles_return":"Les articles que je dois renvoyer avant le","generate_vouchers":"Générer le bon de retour","voucher_confirmation_message":"Générer le bon de retour mettra fin à votre abonnement, ainsi vous devrez retourner vos produits. Êtes-vous sûr de vouloir générer un bon de retour pour votre sélection ?","cancel":"Annuler","confirm":"Valider","articles_to_send":"Les articles que je vais recevoir autour du","account_cta":"Accéder à mon compte","to_return":"A renvoyer au magasin :","order_number":"Commande numéro :"},"emails":{"browser_link":"Ouvrez cet e-mail dans le navigateur","signature":"John Doe,\\nde l\'équipe location de la marque Lizee","bottom_section_title":"Votre retour","bottom_section_content":"Comment organiser votre retour? c\'est facile, suivez le guide.","footer":"Les équipes Marque vous souhaitez une bonne journée!","copyright":"Conformément à la loi «informatique et libertés» du 6 janvier 1978, vous pouvez à tout moment demander à accéder, faire rectifier ou supprimer les informations personnelles vous concernant ou vous opposer à leur traitement par Marque.\\nCet email est un accusé de réception de votre commande et vaut confirmation du contrat de location. Un email confirmant l\'édition de vos articles vous sera envoyé prochainement.","order_confirm_title":"Merci pour votre commande!","order_confirm_main_text":"Nous avons bien reçu votre commande n ° XXXXXX. Elle sera expédiée dès que possible et arrivera en point relais / chez vous ou à votre domicile selon le mode de livraison choisi.","order_confirm_cta_text":"Suivez nous!","order_summary_title":"Récapitulatif de la commande","order_id_text":"Numéro de commande:","order_start_subscription_date":"Date de début d\'abonnement","order_renting_start":"Date de début de location","order_renting_end":"Date de retour","order_renting_duration":"Durée de location","order_shipping":"Adresse de livraison:","order_shipping_method":"Livraison à domicile","order_products":"Liste des produits","order_paid_text":"Payé","order_tax_text":"20% de TVA inclus","order_pay_method":"Moyent de paiement","order_pay_method_desc":"Carte Bancaire finissant par"},"faq":{"subtitle":"Connectez-vous avec mon adresse e-mail","title":"Foire aux questions"},"funnel":{"email":"Email","phone":"Téléphone","address":"Adresse","postal_code":"code postal","country":"Pays","free":"Gratuit","return_button":"Revenir","delivery_title":"1. Livraison","delivery_description":"Vous recevrez votre colis X jours à l\'avance. ","delivered_on":"Remis le ","return_before":"Pour revenir avant","return_title":"2. Retour","home_delivery":"Livraison à domicile","change_my_address":"Changer mon adresse","shop_delivery":"Livraison au point colis","choose":"Choisir","next1":"Prochain","titleform":"Entrez vos informations de paiement","pay":"Payer","first_name":"Prénom","last_name":"Nom","city":"Ville","next":"Prochain","create_account_link":"Créer un compte","continue_with_account":"Continuer avec le compte","information":"Information","shipping":"Livraison","step":"étape","coupon_title":"Vous avez un code promo ?","coupon_cta":"Appliquer","coupon_applied":"Ce code promo est appliqué :","coupon_success":"Ce code promo est valide","coupon_error":"Vous avez un code promo ?","no_shipping_available":"Malheureusement, aucune solution de transport n\'est disponible pour cette commande !","payment":{"title":"Paiement","success":"Paiement accepté","progress":"Paiement en cours, merci de patienter","cgu":"Accepter les CGV","retractation_agreement":"Je reconnais expressément renoncer à mon droit de rétractation puisque ma location débute avant l\'expiration du délai de rétractation de 14 jours.","custom_cgu_link":"Accéder aux CGL","payment_accordion":{"card_title":"Paiement sécurisé par Carte Bleue","card_tagline":"Paiement assurée par Stripe™. Cartes acceptées","paypal_title":"Paypal"},"caution_info":"Avant de procéder au paiement, vous devez régler la caution pour vos articles.","caution_explanation":"Cette caution sera remboursée après retour des produits en bon état.","caution_button":"Payer la caution","pay_caution":"Payer la caution","caution_paid":"Caution payée avec succès ! Vous pouvez maintenant procéder au paiement.","caution_expired":"La caution a expiré. Veuillez créer une nouvelle caution.","caution_error":"Une erreur est survenue lors du traitement de la caution.","caution_creation_error":"Impossible de créer la caution. Veuillez réessayer.","caution_token_mismatch":"Caution invalide pour cette commande. Veuillez réessayer.","swikly_deposit_description":"Caution de sécurité pour les articles loués","processing_caution":"Traitement de la caution en cours...","wire_transfer_button":"Payer plus tard par virement bancaire","errors":{"stock":"Un produit dans votre panier n\'est plus disponible","stock_error_intro":"Les produits suivants ne sont plus disponibles en quantité suffisante :","stock_error_footer":"Veuillez mettre à jour votre panier avant de procéder au paiement.","availability_check_failed":"La vérification de disponibilité n\'a pas pu aboutir (problème technique temporaire). Veuillez réessayer dans un instant.","default":"La carte a été refusée pour une raison inconnue. Contactez l\'émetteur de la carte pour en savoir plus","expired_card":"La carte bancaire a expiré. Vous devez utiliser un autre moyen de paiement.","email":"Adresse e-mail invalide.","insufficient_funds":"La carte bancaire ne dispose pas de fonds suffisants pour effectuer l\'achat. Vous devez utiliser un autre moyen de paiement.","lost_card":"Le paiement a été refusé, car la carte bancaire a été déclarée perdue. Contactez l\'émetteur de la carte pour en savoir plus","stolen_card":"Le paiement a été refusé, car la carte bancaire a été déclarée volée. Contactez l\'émetteur de la carte pour en savoir plus","incorrect_cvc":"Le code CVC est erroné. Vous devez réessayer avec le bon CVC.","processing_error":"Une erreur s\'est produite lors du traitement de la carte bancaire. Vous devez retenter le paiement. S\'il ne peut toujours pas être traité, réessayez plus tard.","code_operator_label":"Veuillez renseigner votre code de validation","code_operator_placeholder":"Ex: 12345","operator_button_validation":"Confirmer votre commande","wrong_code_operator":"Le code renseigné n\'est pas valide","minimum_cart_items":"Le nombre minimum d\'articles dans le panier n\'est pas atteint"},"error":"Une erreur est survenue"},"invalid_tel":"Veuillez fournir un numéro de téléphone valide","coupon_label":"Code Promo","your_rental_from":"Votre location du","your_rental_to":"au","show_cart":"Afficher le Panier","hide_cart":"Masquer le panier","toBeDetermined":"À déterminer"},"general":{"home":"Accueil","selection":"Toute la sélection","return":"A retourner en point relais avant le","baseline":"Louez. Économisez. Faites vous plaisir !","footer_tagline":"De la vente à la location","footer_top_baseline":"L\'assurance dommages est incluse","footer_top_link_label":"Voir tous les produits","contact_us_button":"Nous contacter","cgl":"Conditions générales de locations","policy":"Politique de confidentialité","small_text_under_calendar":"Plus vous louez, moins vous payez!","start_button":"Louer","confirm_button":"Confirmer","delivered":"Livré le ou avant","meta_description":"Voici la méta desc","meta_title":"Voici un titre","meta_url":"http://whitelabel.lizee.io/","you_save":"Vous économisez","my_account":"Mon compte","my_basket":"Mon panier","FAQ":"FAQ","add_a_title":"c\'est un titre","add_a_description":"c\'est une description","add_a_subtitle":"ceci est un sous-titre","add_a_text":"ajouter un texte","from":"De","month":" / mois","day":" / jour","stock_texts":{"few_products_left":"Plus que quelques produits !","back_soon":"Bientôt de retour","in_stock":"En stock"},"search_address":{"cta":"Rechercher","incomplete":"Pas d\'adresse trouvé dans notre base de données. Merci de saisir une autre adresse.","no_results":"Pas d\'adresse trouvé dans notre base de données. Merci de saisir une autre adresse.","excluded":"La livraison n\'est pas prise en charge pour cette adresse.","invalid_country":"La livraison n\'est pas prise en charge pour ce pays.","label":"Recherchez votre adresse de livraison","same_address":"L\'adresse de livraison et l\'adresse de facturation sont les mêmes","label_billing":"Recherchez votre adresse de facturation","placeholder":"Exemple: 15 rue de milan Paris","change_delivery_point":"modifier","postcode_missing":"Veuillez renseigner un code postal"},"search_bar":{"input_label":"Rechercher un article","input_placeholder":"Rechercher un article","button_label":"Rechercher un article"},"previous_button":"Précédent","sizes":"Tailles","month_short":" / m","day_short":" / j","copyright":"Propulsé par Lizee","card_number":"Numéro de carte","expiry_date":"Date d\'expiration","cvc_code":"Code CVC","morning":"Matinée","afternoon":"Après-midi","evening":"Soirée","fullDay":"Journée entière","flex_price_information":"Prix basé sur un mois de 30 jours","month_without_space":"/mois","handle_cookies":"Gérer les cookies","days_plural":"jours","day_singular":"jour","delivery_point":"Resultats à proximité de : ","menu":{"close":"Fermer"},"main_menu":{"item":"Menu principal","subitem":"Sous-menu"},"holder_name":"Nom du propriétaire","unit":" / unité","unit_short":" / u","change_language_modal_title":"Changer de langue","change_language_modal_text":"Attention, vous vous apprêtez à changer de langue. Si vous avez des articles dans votre panier, votre panier sera perdu.","change_language_modal_cancel_text":"Annuler","change_language_modal_validation_text":"Changer de langue","no_mixed_basket":{"second_hand_product_in_basket_title":"Il y a un article de seconde main dans votre panier","rental_product_in_basket_title":"Il y a une location dans votre panier","second_hand_product_in_basket_text":"Vous ne pouvez pas réaliser de commande avec à la fois une location et un article de seconde main.\\nSi vous souhaitez effectuer une location, alors il faut passer une autre commande ou retirer l\'article de seconde main de votre panier.","rental_product_in_basket_text":"Vous ne pouvez pas réaliser de commande avec à la fois une location et un article de seconde main.\\nSi vous souhaitez acheter un article de seconde main, alors il faut passer une autre commande sans location ou retirer la location de votre panier."},"vat":{"included":"TTC","excluded":"HT"}},"homepage":{"maintitle":"Louez. Économisez. Faites vous plaisir !","descriptiontext":"Louez nos produits sur demande. ","cta_pack_label":"Voir les packs","titlehowitworks":"Comment ça marche ?","deschowitworks1":"Réservez votre kit en ligne et recevez-le à domicile ou dans un point de retrait de votre choix en France. Le kit sera disponible 2 jours avant votre départ et vous avez 2 jours pour le rendre après la fin de votre trek. ","deschowitworks2":"Prime ?\\nVous pouvez renvoyer votre kit depuis votre lieu de trek. Grâce à votre étiquette retour incluse dans votre colis, déposez votre colis dans n\'importe quel point relais Chronopost en France Métropolitaine. / Vous pouvez retourner votre kit depuis votre lieu de randonnée. L\'étiquette de retour est incluse dans votre colis et vous pouvez déposer votre kit dans n\'importe quel point Chronopost en France. ","titletestimonials":"Ils l\'ont essayé ","section_title_savings":"Plus vous louez longtemps, moins vous payez: ","link_label_savings":"Commencer à louer","start_savings_text":"Vous louez pour","end_savings_text":"vous économisez","buy_savings_text":"Si vous achetez","rent_savings_text":"Si vous louez","saving_mentions":"* Montant basé sur les prix moyens de nos produits","featured_product_title":"Un exemple avec notre produit préféré:","featured_product_name":"Sac à dos vert et bleu 20L","featured_product_link_label":"Explorer les options","title_commitment":"Le saviez-vous ?","description_commitment":"Votre choix aura un impact positif sur la planète: louer avec Lizee permet d\'économiser en moyenne 350g de CO2 par produit!","section_title_community":"Vos économies avec la location:","title_community":"Nos clients locataires ont déjà économisé: ","amount_community":"35 000 €","subtitle_universe1":"Titre des produits de taxons","paragraph_universe1":"Desc pour les packs de taxons","subtitle_universe2":"Titre des packs de taxons","paragraph_universe2":"Desc pour les packs de taxons","categorie":"Taxon Sylius","rent":"Alquilar","partner":"Partenaire"},"instagramwall":{"title":"S\'inscrire","desc":"Partagez vos souvenirs avec #Lizee ","buttontext":"Suivez nous !"},"packs":{"from":"De","month":"mois","buttontext":"Suivez nous !","header_title":"Packs","herotitle":"Découvrez nos packs ","titlepacks":"Des packs conçus pour vous","packsparagraph":"Choisissez parmi les packs ci-dessous ou créez le vôtre! ","shipping_description":"Livraison à domicile gratuite sur les commandes de 30 € et plus!","pack_to_shop_button":"Créez votre pack","fake_pack_title":"Créez votre propre pack","fake_pack_button":"Voir plus de produits","select":"Sélectionner","title_size_modale":"Sélectionnez la taille pour l\'ajouter à votre panier:","victim_of_success":"Victime de son succès","link_to_single":"Voir le pack"},"page":{"title":"Page title","content":"Page content. Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti animi iure iusto ex explicabo aspernatur commodi voluptatum, laudantium voluptatem corporis."},"sso":{"errors":{"41000083":"Le compte utilisé n\'est pas un compte professionnel.","default":"Une erreur inattendue est survenue."}},"privacy":{"title":"S\'inscrire","wysiwyg":"Dernière mise à jour: 12 mars 2020\\n","showCookie":"Gérer les cookies"},"products_to_buy":{"products_category":"Produits à acheter","buy_button":"Acheter","see_more":"En savoir plus"},"rental_terms":{"title":"S\'inscrire","wysiwyg":"Dernière mise à jour: 12 mars 2020\\n"},"shop":{"choose":"Choisir","header_title":"Packs","herotitle":"Découvrez nos packs ","title_size_modale":"Sélectionnez la taille pour l\'ajouter à votre panier:","victim_of_success":"Victime de son succès","titleshop":"Louez parmi la meilleure sélection","shopdescription":"Choisissez vos favoris! ","shippingdescription":"Livraison à domicile gratuite sur les commandes de 30 € et plus!","shop_to_packs_button":"Voir les packs","filter":"Filtres","filter_by_taxons":"Filtrer par catégories","filter_by":"Filtrer par :","filter_price":"Prix :","states":"États","price_fork":"Sélectionnez votre fourchette de prix","between":"Entre","and":"et","price_min_label":"Min","price_max_label":"Max","return":"Retour","availableOnly":"Voir uniquement les produits disponibles","classic_sub":{"our_rates":"Nos Forfaits évolutifs","adjustable_rate":"Votre forfait s\'ajuste en fonction de votre sélection.","articles":"articles","maximum":"maximun","article":"article"},"filters":"Filtres par tailles","pack_size_modal_cta_add":"Ajouter au panier","pack_size_modal_cta_return":"Retour aux packs","filters_dropdown_label":"Sélectionner","max_item_in_cart":"Maximum de produit par panier atteint","prev":"Précédent","next":"Suivant","no_stock_available":"Aucun produit disponible dans cette catégorie.","search_not_found":"Aucun produit ne correspond à cette recherche.","filters_modale_title":"Filtrer","autocomplete_search_placeholder":"Rechercher {{attributeName}}...","autocomplete_no_results":"Aucun résultat trouvé","autocomplete_no_values":"Aucune valeur disponible","autocomplete_loading":"Chargement...","autocomplete_load_more":"Charger plus","close_button":"Fermer","categories_title":"Catégories","apply_button":"Appliquer","reset_button":"Réinitialiser","load_more_button":"Charger plus de produits","you_have_seen":"Vous avez vu ","articles_on":"articles sur ","accordion_shop_title":"En savoir plus","sort":"Trier","filter_and_sort":"Filtrer & Trier","filter_title_in_drawer":"Filtrer","sort_by_price_asc":"Prix croissant","sort_by_price_desc":"Prix décroissant","sort_by_date_asc":"Plus anciens","sort_by_date_desc":"Plus récents","error_loading_products":"Une erreur est survenue lors du chargement des produits. Veuillez réessayer plus tard.","shipping_costs":{"number_of_articles":"Nombre d\'articles","round_trip_cost":"Coût aller-retour","title":"Frais de livraison pire cas (Incl. Assurance)"}},"single_product":{"choose_button":"Choisir","associations_title":"Cela peut aussi vous intéresser :","try_out_button":"Essayer pour :","try_out_tooltip":"Vous ne pouvez essayer qu\'une  pièce par pièce louée","buy_button":"Acheter","choose_button_tooltip":"Sélectionnez une taille pour ajouter au panier","display_total_rental_price":"prix total de la location","availability_checker":{"modal_close":"Fermer","text":"Cet article est indisponible à ces dates.","link":"Voir la disponibilité","modal_title":"Vérifier la disponibilité","modal_description":"L\'article n\'est pas disponible lorsque les dates sont barrées"},"backInStock":{"stock_alert_title":"Ce produit n\'est plus en stock","stock_alert_title_pack":"Ce pack n\'est plus en stock","stock_alert_text":"Pour être alerté(e) de son retour, renseignez votre email ci-dessous :","stock_alert_input_placeholder":"votre@mail.com","stock_alert_button":"M\'avertir","stock_alert_mail_error":"Votre adresse mail n\'est pas au bon format. Merci de vérifier","stock_alert_validation_message":"Merci pour l\'intérêt que vous portez à ce produit. Vous serez notifié par mail dès qu\'il sera de nouveau disponible","stock_alert_validation_fail":"Un problème est intervenu sur le serveur, veuillez réessayer plus tard","stock_alert_already_fail":"Vous avez déjà renseigné ce mail pour cet article"}},"statements":{"bottom_sentence":"Plus vous voyagez, plus vous économisez!","link":"Plus d\'information"},"subscription_order":{"change_cta":"Modifier","cancel_cta":"Annuler","rate":"Forfait","handle_return_cta":"Gérer le retour de mes articles","my_subscription":"Mon abonnement :","taken_every":"Prélevé tous les","of_the_month":"du mois","per_month":"Par mois","articles_max":"articles max","select_all_and_stop":"Tout sélectionner et stopper mon abonnement","generate_the_return_slip":"Générer le bon de retour","continue":"Continuer","my_new_subscription":"Mon nouvel abonnement","size":"Taille :","month":"month","bottom_sentence":"Un bon de retour sera disponible à la fin de la commande. Tout savoir sur les retours","funnel":{"current_subscription":" , vous avez déjà un abonnement en cours.","subtitle":"Vous pouvez retourner vos anciens articles pour ajuster votre abonnement.Si vous souhaitez conserver vos articles, passez à l\'étape suivante.","skip_step":"Passer cette étape"},"returned_product_title":"Produits retournés ce mois ci","returned_product_desc":"Ces produits ont été réceptionnés et seront définitivement retirés de votre espace à votre prochain paiement.","canceled_order_title":"Commandes annulées","canceled_order_desc":"Retrouvez vos commandes annulées","refunded_order_title":"Commandes remboursées","refunded_order_desc":"Retrouvez vos commandes remboursées","sub_finished":{"title":"Abonnement terminé !","desc":"Nous sommes triste de vous voir partir. Votre dernier prélevement sera adapté au prorata du mois en cours une fois les articles retournés."},"returned_date":"Retourné le","link_download_return":"Cliquez ici pour télécharger votre bordereau de retour","invoice_this_month":"Votre facture ce mois-ci :","invoice_explanation":"Nous calculons le montant facturé chaque mois en fonction du pro-rata des produits loués et retournés dans le mois en cours","subscription_start_date":"Votre abonnement commence le :","subscription_date_explanation":"Votre abonnement débute 5 jours après la date de votre première commande. Cette date tient compte des délais de préparation de votre commande et des délais de livraison. \\n À compter du démarrage de l\'abonnement, vous serez facturée chaque mois, à date d\'anniversaire. Le service de retour de produits sera disponible après le démarrage de votre abonnement.","bought_product_title":"Produits achetés :","bought_product_desc":" ","product_not_eligible_for_return":"Produit non éligible au retour","tooltip_product_not_eligible_for_return":"Retour possible à partir de la date d\'abonnement"},"customer_survey":{"main_title":"Enquête de satisfaction","subtitle":"Aidez nous a améliorer nos services","let_a_message":"Un message ?","satisfaction":"Satisfaction","dropdown_title":"Etat retour","notes":"Notes","observation":"Une remarque ?","message":"Message","send":"Envoyer","contact_title":"Nous contacter","error_fields":"Merci de compléter les champs requis","desc_contact":"Laissez nous un message !"},"snackbar_message":{"add":"Le produit a bien été ajouté dans","delete":"Le produit a été supprimé de","remove":"Un produit a été retiré de","add_multiple":"Les produits ont bien été ajoutés à","limit":"Vous avez atteint le nombre maximum de produits autorisés","rental_range_selected_is_blocked":"La période de location sélectionnée n\'est pas disponible. Veuillez choisir une autre période de location.","cart":"votre panier","max":"Il n\'y a plus de stock suffisant sur ce produit pour la quantité choisie","add_tryout":"Le produit à bien été ajouté pour essayage","profilUpdated":"Vos informations ont bien été mises à jour"},"instore":{"modale_title":"Choisissez votre magasin","modale_shop_name":"Nom du magasin","modale_informations":"Informations","modale_choose_shop":"Choisir un magasin","modale_details":"Coordonnées","modale_choose_button":"Choisir","modale_address":"Adresse :","modale_phone":"Téléphone :","change_store_title":"Changer de magasin","change_store_paragraph":"Attention, vous vous apprêtez à changer de magasin. Si vous avez des articles dans votre panier, votre panier sera perdu.","cancel_button":"Annuler","change_store_button":"Changer de magasin","header_change_store":"Changer de magasin","product_not_available":"Produit Indisponible dans ce magasin","paragraph":"Vous pouvez choisir un autre magasin pour vérifier sa disponibilité.\\u2028Il faudra récuperer votre commande dans le nouveau magasin selectionné. Cela aura pour effet de vider votre panier en cours.","change_store_cta":"Changer de magasin","no_store_available":"Il n\'y a pas de magasin disponible pour ce code postal","search_input_placeholder":"Exemple: 33","search_input_label":"Saisissez le début d\'un code postal","search":"Rechercher","appointments_page_title":"Vous souhaitez prendre rendez-vous pour:","appointment_page_pickup_link_label":"Un retrait en magasin","appointment_page_return_link_label":"Un retour en magasin","account_page_return_link_label":"Retournez dans votre magasin","pack_not_available":"Pack Indisponible dans ce magasin"},"pack_single":{"choose":"Ajouter le pack au panier","sold_out":"Pack non disponible","pack_content_title":"Articles inclus dans ce pack:"},"takeBack":{"title":"Vendre un article","meta_title":"Programme de reprise d\'articles","required_field":"* Champs obligatoires","text":"Remplissez notre formulaire pour obtenir votre offre d\'achat. Une question sur le fonctionnement?","step_1":"Votre article","step_2":"Notre offre","step_3":"Confirmation","step_edit_parcel_number":"Modifier le numéro de colis","parcel_number_label":"Combien de colis souhaitez vous envoyer ?","positive_response_to_preliminary_questions":"Oui","negative_response_to_preliminary_questions":"Non","condition_question":"Bon état général?","error_message":"Malheureusement, nous n\'acceptons pas ce type d\'article","next_step_button":"Étape suivante","reference_number_label":"Référence de l\'article","reference_number_placeholder":"Référence présente sur l\'étiquette","reference_number_link":"Où trouver la référence de mon article","reference_number_text":"Vous trouverez la réference à l\'endroit indiqué sur l\'image","select":"Sélectionnez une valeur","close_modal":"Fermer","waiting_price_text":"Nous estimons le prix de vente de votre article. Merci de patienter.","offer_announcement_text":"En tenant compte des informations fournies, nous sommes heureux de vous proposer une offre de reprise s\'élevant à:","price_explication":"* Ce montant sera définitif après vérification de l\'article par nos équipes.","accept_offer_button":"Accepter notre offre","login_text":"Vous devez être connecté pour recevoir notre offre","register_text":"Vous devez créer un compte pour recevoir notre offre","confirmation_text":"Félicitations !. \\nL\'offre de prix vous a été envoyée par mail ! ","take_back_location_title":"Choisissez le site où appliquer la reprise :","take_back_country_title":"Dans quel pays souhaitez-vous utiliser votre bon d\'achat ?","reference_check_button":"Rechercher","reference_error":"Mauvaise référence","take_back_menu":"Revendre","state_title":"Etat","state_1":"Parfaite condition","state_2":"Très bonne condition","state_3":"Bonne condition","previous_step":"Étape précédente","select_label_size":"Taille","select_label_state":"État","refused_state":"Non repris","faq_title":"Questions Fréquentes","reference":"Référence","add_product":"Ajouter un article","confirmation_title":"Merci!","address_check_required":"veuillez vérifier votre adresse de livraison","confirm_address_button":"Confirmer l\'adresse","voucher_printing_button":"Imprimer le bordereau d\'envoi","your_order_confirmation":"Votre commande numéro","label":"Etiquette","states_explanation_link":"Comment choisir l\'état ?","item":"Article n°","price_start":"À partir de","tab_label_secondhand":"Disponible à l\'achat","tab_label_rental":"En location","question_title":"Quel est l\'état de votre pièce ?","take_back_location_desc":"​Choisissez dès maintenant le type de bon d\'achat que vous souhaitez recevoir. Attention, une fois choisi vous ne pourrez plus modifier le type de bon d\'achat souhaité. ​​","step_2_error":"Une erreur est survenue lors du traitement de la demande. Veuillez réessayer","total":"Total","status_label":"Statut","accepted_status":"Accepté","refused_status":"Refusé","in_progress_status":"En cours","command":"Reprise n °","state_label":"État","second_hand_label":"Seconde Main","original_price":"Prix d\'origine","take_back_command":"Commande n°","take_back_description":"Commentaire spécifique à cette pièce :","take_back_estimated_price":"Valeur estimée :","take_back_states_information_modal_title":"Définition des états","take_back_stock_alert_text":"Votre taille n\'est pas disponible ?","take_back_stock_alert_link":"Créez une alerte","take_back_stock_alert_modal_title":"Créer une alerte","take_back_stock_alert_modal_text":"Recevez une alerte par e-mail dès que votre taille sera de nouveau disponible","take_back_stock_alert_modal_size_label":"Choisissez la taille de l\'article:"},"skiText":{"title":"Configurez votre matériel :","weight_label":"Poids (kg)","size_label":"Taille (cm)","age_label":"Age","level_label":"Niveaux","firstname":"Prénom","shoes_size_commitment":"Je m\'engage à faire le réglage de mes chaussures sur mon ski de manière autonome et prend sa responsabilité","button_text":"Choisir","take_back_estimated_price":"Valeur estimée :","prevent_adding_differents_types_to_cart":"Il n\'est pas possible de louer et d\'acheter simultanément le même produit"},"search_page":{"title":"Résultat de recherche pour : {{ search }} ({{ length }})"},"wishlist":{"title":"Ma liste de souhaits","empty":"Votre liste de souhaits est vide","button":"Ajouter à ma liste de souhaits"},"size_guide_page":{"span_title":"Guide des tailles","size_guide":"🎀 Guide des tailles","question":"Saviez-vous que 9 femmes sur 10 ne connaissent pas leur vraie taille de soutien-gorge ? Découvrez enfin la vôtre grâce à notre calculateur simple et précis. Pour tous nos modèles sans armature ainsi que pour les bas, nous vous conseillons de choisir votre taille habituelle.","measure_your_back_circumference":"1. Mesure ton tour de dos","not_tight":"Pas serrée","slightly_tight":"Un peu serrée","very_tight":"Très serrée","measure_your_bust":"2. Mesure ton tour de poitrine","standing_up_straight":"Debout bien droite","leaning_forward":"Penchée en avant","lying_on_your_back":"Allongée sur le dos","calculate_size":"Calculer ma taille","error_size_not_found":"Aucune taille trouvée pour vos mesures","bra_size":"Votre taille de soutien-gorge"},"reservations":{"title":"Mes réservations","header_tooltip":"Mes réservations","info_banner":"Les produits sont remis en vente automatiquement à l\'expiration.","empty_text":"Vous n\'avez aucune réservation en cours.","cta_shop":"Voir les produits","product_label":"Produit","expires_on":"Expire le","buy_now":"Acheter maintenant","release":"Libérer la réservation","reserve_cta":"Réserver {{days}} jours ouvrés","confirm_title":"Confirmer la réservation","confirm_body":"Vous êtes sur le point de réserver ce produit pendant {{days}} jours ouvrés. Il ne sera plus disponible pour les autres clients.","confirm_expiration":"Date d\'expiration","confirm_cta":"Confirmer la réservation","confirm_cancel":"Annuler","confirm_error":"Une erreur est survenue. Veuillez réessayer plus tard.","confirm_error_conflict":"Ce produit a été déjà reservé","reservations_product_already_reserved":"Ce produit est réservé pour vous, retrouvez le dans Mes Réservations"},"productPage":{"label_reference":"Référence étiquette"},"cancel_contract":{"button_label":"Annuler mon contrat","title":"Rétractation / annulation","intro":"Vous souhaitez annuler votre commande ou retourner un produit ? Remplissez ce formulaire et notre équipe traite votre demande.","type_label":"Votre demande","type_cancellation":"Annuler ma commande","type_return":"Retourner un produit","order_reference_label":"Numéro de commande","email_label":"Email","message_label":"Message (facultatif)","submit_button":"Envoyer ma demande","required_fields":"* Champs obligatoires","error_order_reference":"Veuillez renseigner votre numéro de commande.","error_email":"Veuillez saisir une adresse email valide.","error_generic":"Une erreur est survenue. Veuillez vérifier vos informations et réessayer.","success_title":"Votre demande a bien été prise en compte","success_message":"Vous allez recevoir un email de confirmation. Notre équipe reviendra vers vous rapidement.","close_button":"Fermer"}}');

/***/ }),

/***/ 70328:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"404":{"title":"404 pagina non trovata","cta":"Torna alla home page"},"account":{"herotitle":"Il mio account","title_login":"Accedi al mio account","subtitle":"Accedi con il tuo indirizzo email","successfull_register":"Congratulazioni! Il tuo account è stato creato, riceverai un\'e-mail di convalida.","login_email":"E-mail","login_password":"Parola d\'ordine","forget_password_link":"Hai dimenticato la password?","guest_link":"Continua come ospite","error_login":"Il tuo indirizzo email o la tua password non corrispondono. riprova","login_button":"Login","login_to_see_price":"Accedi per consultare i nostri prezzi e ordinare","register_link":"Nessun conto? Iscriviti ora","title":"Iscriviti ora","login_title":"Identificatori","firstname":"Nome","lastname":"cognome","email":"E-mail","phone":"Telefono","vatnumber":"Partita IVA","company":"Azienda","password":"Parola d\'ordine","repeat_password":"Ripeti la password","address_required":"si prega di inserire un indirizzo di consegna","address_title":"Indirizzo","address":"Indirizzo","postal_code":"Cap","country":"Paese","town":"Città","register_button":"Crea il mio account e continua","login_link":"Hai già un account? Per accedere","password_error":"Le tue password non sono le stesse","title_data":"stai calmo","text_data":"I tuoi dati sono protetti","forget_title":"Hai dimenticato la password","forget_subtitle":"Riceverai un\'e-mail per creare una nuova password","button_recup":"Invia un\'e-mail","to_login_link":"Collegamento di ritorno","button_continue_as":"continua come","disconnect_button":"disconnessione","guest_link1":"Continua come ospite","info_link":"le mie informazioni","hi":"Ciao","paragraph1":"Trova la tua dashboard qui. Puoi tracciare i tuoi ordini correnti e gestire la restituzione degli ordini ricevuti.","log_out_button":"disconnessione","block_title":"Domande frequenti","date":"sta arrivando","leasing_date_from":"Noleggio dal","leasing_date_to":"al","return":"Per tornare a un punto di inoltro prima","returned_at":"Consegnato il ","command":"Numero d\'ordine.","manage_shippment":"Gestisci la mia consegna","manage_shippment_sentence":"Per tracciare, modificare o annullare il tuo ordine","follow_my_package":"Segui il mio pacchetto","no_command":"Nessun ordine per il momento!","go_to_shop":"Vai a fare la spesa","back_link":"Ritorno","title_information":"I miei dati","cancel_subscription":"Annulla l\'abbonamento","cancel_subscription_title":"Come si annulla l\'abbonamento?","cancel_subscription_button":"Ho capito!","cancel_subscription_paragraph":"Annullare è facile! È sufficiente restituire tutti gli articoli ancora in possesso. Una volta ricevuti gli articoli nel nostro magazzino, l\'abbonamento verrà automaticamente annullato. La fattura per l\'ultimo mese di abbonamento sarà calcolata su base proporzionale.","your_infos":"La tua informazione","modification_successfull":"Le tue informazioni sono state modificate","error_happend":"C\'è stato un errore. Riprova!","mail_used":"Questo indirizzo e-mail è già in uso","error_disabled":"il tuo account non è attivato","info_button":"Modifica le mie informazioni","password_modif_succes":"password cambiata con successo","password_button":"cambia la mia password","adress_title":"il tuo indirizzo di consegna","address_button":"Cambia il mio indirizzo","link_name":"Come funziona?","slides_title":"Il mio ritorno in tre passi","verify_title":"Verifica dell\'account in corso","confirm_account":{"title":"Il tuo account è stato convalidato","cta_shop":"Affitta ora","cta_account":"Visualizza il mio account","error":"Errore, reindirizza per ricevere"},"password_reset":{"title":"Aggiorna la tua password","description":"Si prega di compilare il modulo con la nuova password.","error":"Errore, la richiesta non è andata a buon fine","success":"La tua modifica della password è stata presa in considerazione, verrai reindirizzato alla pagina di accesso."},"newsletter":"Iscriviti alla newsletter","email_send":"E-mail inviata","continue":"continua","text":"testo","actual_password":"Password attuale","new_password":"nuova password","error_phone":"errore_telefono","next":"prossimo","cancelled":"Ordine annullato","desc_info":"* Inserendo il tuo indirizzo email, accetti di ricevere le nostre notizie, le nostre offerte commerciali e gli inviti alle nostre vendite private e accetti la nostra politica sulla privacy.","email_not_send":"L\'indirizzo email non è nel database. Prova con un indirizzo email diverso.","address_button_create":"Aggiungi il mio indirizzo di consegna","warning":{"text":"Si prega di notare che non si dispone di un indirizzo registrato, si prega di fornire un indirizzo nelle informazioni","cta":"Aggiungi il mio indirizzo"},"street_number":"No.","search_address":{"helper_add":"Per aggiungere il tuo indirizzo di consegna, inserisci il tuo indirizzo nel campo sottostante.","helper_change":"Per modificare l\'indirizzo di consegna, inserisci il tuo indirizzo nel campo sottostante."},"password_strength_error":"La tua password deve contenere: almeno 10 caratteri, uno maiuscolo, uno minuscolo, un carattere speciale e un numero.","address_details":"Indirizzo aggiuntivo (Edificio, Piano, Codice ecc.)","address_area":"Area","confirm_return":{"title":"Il tuo reso del prodotto è stato preso in considerazione","cta_shop":"Affitta ora","cta_account":"Visualizza il mio account","error":"Errore, reindirizza al mio account","rdv":"appuntamento"},"review_placeholder":"Si prega di scegliere una risposta dall\'elenco","register_disable":"Siamo spiacenti, la registrazione al nostro servizio di noleggio non è più disponibile.","cancel_order":{"cta_modal":"Annulla il mio ordine\\n","modal_title":"Annulla il mio ordine","modal_warn":"Sei sicuro di voler annullare l\'ordine?","modal_cta":"per cancellare"},"buy":"Comprare","payment_method":{"title":"Metodi di pagamento","subtitle":"Metodo di pagamento registrato:","card":"Carta geografica ","ending_by":"termina con ","cta_replace":"Sostituisci metodo di pagamento","modal_title":"Sostituisci metodo di pagamento","modal_description":"Tieni presente che modificando il metodo di pagamento eliminerai il metodo di pagamento precedente.","modal_cta":"Rimpiazzare","modal_error":"Errore tecnico. Per favore riprova più tardi.","modal_success":"Il tuo metodo di pagamento è stato modificato"},"dkt_login":"Con il tuo account Decathlon","information_validation":{"main_title":"Il tuo account è stato creato!","subtitle":"Verifica delle informazioni","description":"Come parte dell\'utilizzo del nostro sito di noleggio, abbiamo bisogno delle seguenti informazioni: ","confirmation_button":"Convalida le mie informazioni"},"sso_login":{"dkt":"Con il tuo account Decathlon","cultura":"Con il tuo account Cultura","ciam":"Con Azure AD CIAM"},"external_account_text":"Modifica le mie informazioni sul mio account cliente","take_back_date":"Data","order_list_title":"I miei ordini","take_back_list_title":"Le mie copertine","order_details_generate":"Genera l\'etichetta di reso","order_details_download":"Clicca qui per scaricare la tua etichetta di reso","return_label_unavailable":"La tua etichetta di reso non è ancora disponibile. Sarà accessibile una volta spedito il tuo ordine.","wish_list_link":"La mia lista dei desideri","returning_reason_label":"Motivo del reso","returning_reason_placeholder":"Seleziona un motivo del reso","returning_reason_comment_label":"Commento aggiuntivo","returning_reason_comment_placeholder":"Fornisci dettagli aggiuntivi sul motivo del reso"},"orders":{"error":"Si è verificato un errore. Riprova!","confirm_return":{"title":"Voulez-vous vraiment générer un bon de retour pour votre sélection ?","cta":"Générer le bon de retour","cancel":"Annuler","reason":"Raison du retour","reason_placeholder":"Veuillez renseigner la raison du retour"}},"banner":{"text":"Covid-19: Garantiamo pulizia e disinfezione regolare di tutti i prodotti"},"basket":{"kit_price":"Il tuo kit","duration":"Il tuo abbonamento","for_short":"per","assurance":"Assicurazione","free":"Gratuito","reduction":"sconto","total":"TOTALE","delete_basket":"Rimuovi il basket","continue":"continua","product":"Oggetti","return_date":"Data di ritorno","whenever_you_want":"Quando vuoi","sub_engagement":"Impegno di un mese","current_subscription":"Il mio attuale abbonamento","check_on_account":"Vedi sul mio conto","to_pay_this_month":"Per pagare questo mese","newarticles":"Per i tuoi nuovi articoli da","to":"fatto","error_stock":"Un prodotto non è più disponibile in quantità sufficiente","shipping":"Consegna","products":"prodotti","error_basket":"Il tuo attuale abbonamento e il numero di prodotti selezionati non ti consentono di continuare l\'ordine","total_without_shipping":"Totale senza consegna","total_weight":"Peso totale","try_out":"Adattamento","error_tryout":"Devi avere almeno tante stanze da affittare quante sono le stanze da provare","total_with_subscription":"Totale","total_without_subscription":"Totale","showDetails":"Visualizza i dettagli di consegna","hideDetails":"Nascondi i dettagli di consegna","rentTotal":"Noleggio","buyTotal":"Acquista","months":"mesi","withoutShipping":"(spedizione esclusa)","engagement":"Abbonamento senza impegno.","debit":"Raccolte a fine mese.","continue_shop":"Continua a fare acquisti","empty":"Il tuo cestino è vuoto","drawer":{"title":"Cestino","close":"Chiudere"},"reduction_text_explication":"Aggiungi il tuo codice promozionale nella fase di pagamento","gift_card_text":"gift_card_text","gift_card_explanation":"gift_card_explanation","deposit":"Deposito","deposit_explanation":"Il montante sarà restituito dopo il ritorno dei prodotti","remainingInStock":"Resto in magazzino: {{count}}","b2b_shipping_costs_link":"Costi di spedizione per quantità","total_without_shipping_excl_vat":"Totale HT","delivery_fees_excl_vat":"Costi di consegna HT","vat":"IVA"},"confirmation":{"email":"E-mail","text":"Covid-19: Garantiamo pulizia e disinfezione regolare di tutti i prodotti","title_complements":"Continua ad esplorare","desc_complements":"Con questo codice sconto!","codetext":"Approfitta del 5% di sconto su questi prodotti con il codice","codename":"LIZEECODE","title":"Riepilogo ordine","articles_return":"Articoli entro cui devo restituire","generate_vouchers":"Genera la ricevuta di ritorno","articles_to_send":"Gli articoli che riceverò intorno al","account_cta":"accedi al mio account","to_return":"ritornare","order_number":"numero d\'ordine"},"emails":{"browser_link":"Apri questa email nel browser","signature":"John Doe,\\ndal team di noleggio del marchio Lizee","bottom_section_title":"Il tuo ritorno","bottom_section_content":"Come organizzare il tuo ritorno? è facile, segui la guida.","footer":"I team del Brand ti augurano una buona giornata!","copyright":"In conformità con la legge \\"Informatique et Libertés\\" del 6 gennaio 1978, puoi in qualsiasi momento chiedere l\'accesso, la rettifica o la cancellazione dei dati personali che ti riguardano o opporti al loro trattamento da parte di Brand.\\nQuesta e-mail è una conferma di ricezione del tuo ordine e conferma il contratto di noleggio. A breve ti verrà inviata un\'e-mail di conferma dell\'edizione dei tuoi articoli.","order_confirm_title":"Grazie per il vostro ordine!","order_confirm_main_text":"Abbiamo ricevuto il tuo ordine n. XXXXXX. Sarà spedito il prima possibile e arriverà in un punto di ritrasmissione/a casa tua o a casa tua a seconda del metodo di consegna scelto.","order_confirm_cta_text":"Seguici!","order_summary_title":"Riepilogo ordine","order_id_text":"Numero d\'ordine:","order_start_subscription_date":"Data di inizio abbonamento","order_renting_start":"Data di inizio del noleggio","order_renting_end":"Data di ritorno","order_renting_duration":"Durata del noleggio","order_shipping":"Indirizzo di consegna:","order_shipping_method":"Consegna a domicilio","order_products":"Elenco prodotti","order_paid_text":"Pagato","order_tax_text":"20% IVA inclusa","order_pay_method":"metodo di pagamento","order_pay_method_desc":"Carta di credito che termina con"},"faq":{"subtitle":"Accedi con il mio indirizzo email","title":"Iscriviti ora"},"funnel":{"email":"E-mail","phone":"Telefono","address":"Indirizzo","postal_code":"Cap","country":"Paese","free":"Gratuito","return_button":"Ritorno","delivery_title":"1. Consegna","delivery_description":"Riceverai il tuo pacco con X giorni di anticipo. ","delivered_on":"Consegnato il ","return_before":"Per tornare prima","return_title":"2. Ritorno","home_delivery":"Consegna a domicilio","change_my_address":"Cambia il mio indirizzo","shop_delivery":"Consegna al punto pacchi","choose":"Scegliere","next1":"Prossimo","titleform":"Inserisci i tuoi dati di pagamento","pay":"Paga","first_name":"Nome","last_name":"cognome","city":"Città","next":"Prossimo","create_account_link":"Creare un account","continue_with_account":"Continua con l\'account","information":"Informazione","shipping":"Consegna","step":"passi","coupon_title":"Hai un codice promozionale?","coupon_cta":"Applicare","coupon_applied":"Questo codice promozionale viene applicato:","coupon_success":"Questo codice promozionale è valido","coupon_error":"Hai un codice promozionale?","no_shipping_available":"no_spedizione_disponibile","payment":{"title":"titolo","success":"successo","progress":"progresso","cgu":"cgu","retractation_agreement":"Riconosco espressamente di rinunciare al mio diritto di recesso poiché il mio noleggio inizia prima della scadenza del periodo di recesso di 14 giorni.","custom_cgu_link":"Accesso ai CGL","payment_accordion":{"card_title":"Pagamento sicuro con Carta di credito","card_tagline":"Pagamento assicurato da Stripe™. Carte accettate","paypal_title":"Paypal"},"caution_info":"Prima di procedere con il pagamento, devi pagare la cauzione per i tuoi articoli.","caution_explanation":"Questa cauzione sarà rimborsata dopo la restituzione dei prodotti in buone condizioni.","caution_button":"Paga la cauzione","pay_caution":"Paga la cauzione","caution_paid":"Cauzione pagata con successo! Ora puoi procedere con il pagamento.","caution_expired":"La cauzione è scaduta. Crea una nuova cauzione.","caution_error":"Si è verificato un errore durante l\'elaborazione della cauzione.","caution_creation_error":"Impossibile creare la cauzione. Riprova.","caution_token_mismatch":"Cauzione non valida per questo ordine. Riprova.","processing_caution":"Elaborazione della cauzione in corso...","swikly_deposit_description":"Deposito cauzionale per articoli a noleggio","errors":{"stock":"Un prodotto nel carrello non è più disponibile","stock_error_intro":"I seguenti prodotti non sono più disponibili in quantità sufficiente:","stock_error_footer":"Aggiorna il carrello prima di procedere con il pagamento.","availability_check_failed":"Non è stato possibile verificare la disponibilità per un problema tecnico temporaneo. Riprova tra poco.","default":"La carta è stata rifiutata per un motivo sconosciuto. Contattare l\'emittente della carta per ulteriori informazioni","expired_card":"La carta di credito è scaduta. Devi utilizzare un altro metodo di pagamento.","email":"Indirizzo email non valido.","insufficient_funds":"La carta di credito non ha fondi sufficienti per effettuare l\'acquisto. Devi utilizzare un altro metodo di pagamento.","lost_card":"Il pagamento è stato rifiutato perché la carta di credito è stata dichiarata smarrita. Contattare l\'emittente della carta per ulteriori informazioni","stolen_card":"Il pagamento è stato rifiutato perché è stato denunciato il furto della carta di credito. Contattare l\'emittente della carta per ulteriori informazioni","incorrect_cvc":"Il codice CVC è errato. Devi riprovare con il CVC corretto.","processing_error":"Si è verificato un errore durante l\'elaborazione della carta di credito. Devi riprovare il pagamento. Se ancora non può essere curato, riprova più tardi.","code_operator_label":"Inserisci il tuo codice di convalida","code_operator_placeholder":"Ad esempio: 12345","operator_button_validation":"Conferma il tuo ordine","wrong_code_operator":"il codice inserito non è valido"},"error":"C\'è stato un errore"},"invalid_tel":"Si prega di fornire un numero di telefono valido","coupon_label":"Codice coupon","your_rental_from":"Il tuo noleggio di","your_rental_to":"a","show_cart":"Mostra carrello","hide_cart":"Nascondi carrello","toBeDetermined":"Da determinare"},"general":{"home":"Home","selection":"Tutte le selezioni","return":"Per tornare a un punto di inoltro prima","baseline":"Noleggio. Salvare. Divertiti","footer_tagline":"Dalla vendita al noleggio","footer_top_baseline":"L\'assicurazione contro i danni è inclusa","footer_top_link_label":"Guarda tutti i prodotti","contact_us_button":"Contattaci","cgl":"Condizioni generali di noleggio","policy":"politica sulla riservatezza","small_text_under_calendar":"Più noleggi, meno paghi!","start_button":"Inizio","confirm_button":"Per confermare","delivered":"Consegnato il o prima","meta_description":"Ecco il meta desc","meta_title":"Ecco un titolo","meta_url":"http://whitelabel.lizee.io/","you_save":"Risparmi","my_account":"Il mio account","FAQ":"Domande frequenti","add_a_title":"è un titolo","add_a_description":"questa è una descrizione","add_a_subtitle":"questo è un sottotitolo","add_a_text":"Aggiungi testo","from":"Di","month":"/ mese","day":"/ giorno","stock_texts":{"few_products_left":"Più di pochi prodotti!","back_soon":"Torno presto","in_stock":"disponibile"},"search_address":{"cta":"Ricercare","incomplete":"L\'indirizzo inserito non è completo. Specifica il tuo indirizzo con una via, una città e un codice postale.","no_results":"Nessun indirizzo trovato nel nostro database. Si prega di inserire un altro indirizzo.","excluded":"La consegna non è supportata per questo indirizzo.","invalid_country":"La consegna non è supportata per questo paese.","label":"Trova il tuo indirizzo di consegna","same_address":"L\'indirizzo di consegna e l\'indirizzo di fatturazione sono lo stesso","label_billing":"Trova il tuo indirizzo di fatturazione","placeholder":"Esempio: 15 rue de milano Parigi","change_delivery_point":"modificare","postcode_missing":"Il codice postale è obbligatorio"},"search_bar":{"input_label":"Cerca un prodotto","input_placeholder":"Cerca un prodotto","button_label":"Cerca un prodotto"},"previous_button":"Precedente","sizes":"Seleziona la tua taglia","month_short":"/ m","day_short":"/d","copyright":"Alimentato da Lizee","card_number":"Numero di carta","expiry_date":"Data di scadenza","cvc_code":"Codice HVAC","morning":"Mattina","afternoon":"Pomeriggio","evening":"Sera","fullDay":"Giorno intero","flex_price_information":"Prezzo basato su un mese di 30 giorni","month_without_space":"/mese","handle_cookies":"Gestisci i cookie","days_plural":"giorni","day_singular":"giorno","delivery_point":"Risultati vicino a: ","menu":{"close":"Chiudere"},"main_menu":{"item":"Menu principale","subitem":"Sottomenu"},"holder_name":"Il nome del proprietario","unit":"/ unità","unit_short":"/u","change_language_modal_title":"Cambia lingua","change_language_modal_text":"Attenzione, stai per cambiare lingua. Se hai articoli nel tuo carrello, il tuo carrello andrà perso.","change_language_modal_cancel_text":"per cancellare","change_language_modal_validation_text":"Cambia lingua","vat":{"included":"IVA incl.","excluded":"IVA escl."}},"homepage":{"maintitle":"Noleggio. Salvare. Divertiti. ","descriptiontext":"Noleggia i nostri prodotti su richiesta. ","cta_pack_label":"Vedi i pacchi","titlehowitworks":"Come funziona?","deschowitworks1":"Prenota il tuo kit online e ricevilo a casa o in un punto di ritiro a tua scelta in Francia. Il kit sarà disponibile 2 giorni prima della tua partenza e avrai 2 giorni di tempo per restituirlo dopo la fine del tuo trekking. ","deschowitworks2":"Bonus?\\nPuoi restituire il tuo kit dal tuo luogo di trekking. Utilizzando l\'etichetta di reso inclusa nel pacco, riconsegna il pacco in qualsiasi punto di ritrovo Chronopost nella Francia continentale. / Puoi restituire il tuo kit dal tuo luogo di escursione. L\'etichetta di reso è inclusa nel pacco e puoi consegnare il tuo kit in qualsiasi punto Chronopost in Francia. ","titletestimonials":"Ci hanno provato ","section_title_savings":"Più a lungo noleggi, meno paghi: ","link_label_savings":"Inizia a noleggiare","start_savings_text":"Si affitta per","end_savings_text":"risparmi","buy_savings_text":"Se compri","rent_savings_text":"Se stai affittando","saving_mentions":"* Importo basato sui prezzi medi dei nostri prodotti","featured_product_title":"Un esempio con il nostro prodotto preferito:","featured_product_name":"Zaino 20L verde e blu","featured_product_link_label":"esplorare le opzioni","title_commitment":"Lo sapevate?","description_commitment":"La tua scelta avrà un impatto positivo sul pianeta: noleggiando con Lizee si risparmia in media 350g di CO2 per prodotto!","section_title_community":"I tuoi risparmi con il noleggio:","title_community":"I nostri clienti inquilini hanno già risparmiato: ","amount_community":"35.000€","subtitle_universe1":"Titolo dei prodotti taxa","paragraph_universe1":"Desc per i pacchetti di taxa","subtitle_universe2":"Titolo dei pacchetti di taxa","paragraph_universe2":"Desc per i pacchetti di taxa","categorie":"Silius Taxon","rent":"Alquilar","partner":"compagno"},"instagramwall":{"title":"Iscriviti ora","desc":"Condividi i tuoi ricordi con #Lizee ","buttontext":"Seguici!"},"packs":{"from":"Di","month":"mese","buttontext":"Seguici!","header_title":"Pacchi","herotitle":"Scopri i nostri pack ","titlepacks":"Confezioni pensate per te","packsparagraph":"Scegli tra i pacchetti qui sotto o creane uno tuo! ","shipping_description":"Consegna a domicilio gratuita per ordini a partire da 30€!","pack_to_shop_button":"Crea il tuo pacco","fake_pack_title":"Crea il tuo pacchetto","fake_pack_button":"Vedi più prodotti","select":"Seleziona la tua taglia","title_size_modale":"Seleziona la taglia per aggiungerla al carrello:","victim_of_success":"vittima del proprio successo","link_to_single":"Vedi il pacchetto"},"page":{"title":"Pagina del titolo","content":"Pagina dei contenuti. Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti animi iure iusto ex explicabo aspernatur commodi voluptatum, laudantium voluptatem corporis."},"sso":{"errors":{"41000083":"The account used is not a professional account.","default":"An unexpected error occurred."}},"privacy":{"title":"Iscriviti ora","wysiwyg":"Ultimo aggiornamento: 12 marzo 2020\\n","showCookie":"gestione dei cookie"},"products_to_buy":{"products_category":"Prodotti da acquistare","buy_button":"Acquistare","see_more":"Scopri di più"},"rental_terms":{"title":"Iscriviti ora","wysiwyg":"Ultimo aggiornamento: 12 marzo 2020\\n"},"shop":{"choose":"Scegliere","header_title":"Pacchi","herotitle":"Scopri i nostri pack ","title_size_modale":"Seleziona la taglia per aggiungerla al carrello:","victim_of_success":"vittima del proprio successo","titleshop":"Affitta dalla migliore selezione","shopdescription":"Scegli i tuoi preferiti! ","shippingdescription":"Consegna a domicilio gratuita per ordini a partire da 30€!","shop_to_packs_button":"Vedi i pacchi","filter":"Filtri","filter_by_taxons":"Filtra per categorie","filter_apply":"Applicare filtri","availableOnly":"Vedi solo i prodotti disponibili","classic_sub":{"our_rates":"I nostri pacchetti scalabili","adjustable_rate":"Il tuo pacchetto si adatta in base alla tua selezione.","articles":"Oggetti","maximum":"massimo","article":"articolo"},"filters":"filtri","pack_size_modal_cta_add":"Aggiungi al carrello","pack_size_modal_cta_return":"Torna ai pacchi","filters_dropdown_label":"Selezionare","max_item_in_cart":"Prodotto massimo per carrello raggiunto","prev":"Pagina precedente","next":"Pagina successiva","no_stock_available":"Nessun prodotto disponibile in questa categoria.","search_not_found":"Nessun prodotto corrisponde a questa ricerca","filters_modale_title":"filter_modale_title","autocomplete_search_placeholder":"Cerca {{attributeName}}...","autocomplete_no_results":"Nessun risultato trovato","autocomplete_no_values":"Nessun valore disponibile","autocomplete_loading":"Caricamento...","autocomplete_load_more":"Carica di più","close_button":"close_button","categories_title":"categorie_titolo","apply_button":"pulsante_applica","accordion_shop_title":"accordion_shop_title","and":"e le","price_min_label":"Min","price_max_label":"Max","sort":"Ordina","filter_and_sort":"Filtra e ordina","filter_title_in_drawer":"Filtra","sort_by_price_asc":"Prezzo crescente","sort_by_price_desc":"Prezzo decrescente","sort_by_date_asc":"Più vecchi","sort_by_date_desc":"Più recenti","error_loading_products":"Si è verificato un errore durante il caricamento dei prodotti. Per favore, riprova più tardi.","shipping_costs":{"number_of_articles":"Numero di articoli","round_trip_cost":"Costo di andata e ritorno","title":"Costi di spedizione nel caso peggiore (Incl. Assicurazione)"}},"single_product":{"choose_button":"Scegliere","associations_title":"Potrebbe interessarti anche questo:","try_out_button":"Prova per:","try_out_tooltip":"Puoi provare solo una camera per camera affittata","buy_button":"Comprare","choose_button_tooltip":"Seleziona una taglia da aggiungere al carrello","display_total_rental_price":"prezzo totale del noleggio","availability_checker":{"modal_close":"Chiudere","text":"Questo articolo non è disponibile in queste date.","link":"Vedi disponibilità","modal_title":"Verificare la disponibilità","modal_description":"L\'articolo non è disponibile quando le date sono barrate"}},"statements":{"bottom_sentence":"Più viaggi, più risparmi!","link":"Maggiori informazioni"},"subscription_order":{"change_cta":"Modificare","cancel_cta":"Per cancellare","rate":"Tasso fisso","handle_return_cta":"Gestisci il reso dei miei articoli","my_subscription":"Il mio abbonamento:","taken_every":"Preso ogni","of_the_month":"del mese","per_month":"al mese","articles_max":"articoli massimi","select_all_and_stop":"Seleziona tutto e interrompi il mio abbonamento","generate_the_return_slip":"Genera la ricevuta di ritorno","continue":"continua","size":"Tagliare:","month":"mese","bottom_sentence":"Una ricevuta di ritorno sarà disponibile al termine dell\'ordine. Tutto sui ritorni","funnel":{"current_subscription":" , hai già un abbonamento in corso.","subtitle":"Puoi restituire i tuoi vecchi articoli per modificare il tuo abbonamento. Se desideri conservare i tuoi articoli, vai al passaggio successivo.","skip_step":"salta questo passaggio"},"returned_product_title":"Prodotti restituiti questo mese","returned_product_desc":"Questi prodotti sono stati ricevuti e verranno rimossi definitivamente dal tuo spazio al prossimo pagamento.","canceled_order_title":"Ordini annullati","canceled_order_desc":"cancel_order_desc","refunded_order_title":"Ordini rimborsati","refunded_order_desc":"rimborso_ordine_desc","sub_finished":{"title":"Abbonamento terminato!","desc":"Siamo dispiaciuti di vederti andare. Il tuo ultimo addebito sarà ripartito proporzionalmente per il mese corrente una volta che gli articoli saranno stati restituiti."},"returned_date":"Ritornato","link_download_return":"Clicca qui per scaricare la ricevuta di ritorno","invoice_this_month":"La tua fattura questo mese:","invoice_explanation":"Calcoliamo l\'importo fatturato mensilmente in proporzione ai prodotti noleggiati e restituiti nel mese corrente","subscription_start_date":"Il tuo abbonamento inizia il:","subscription_date_explanation":"Il tuo abbonamento inizia 5 giorni dopo la data del tuo primo ordine. Questa data tiene conto dei tempi di preparazione del tuo ordine e dei tempi di consegna.\\n Dall\'inizio dell\'abbonamento, ti verrà addebitato mensilmente, alla data dell\'anniversario. Il servizio di restituzione del prodotto sarà disponibile dopo l\'inizio dell\'abbonamento.","bought_product_title":"Prodotti acquistati:","bought_product_desc":"comprato_prodotto_desc","product_not_eligible_for_return":"Prodotto non idoneo per la restituzione","tooltip_product_not_eligible_for_return":"Restituzione possibile dalla data di sottoscrizione"},"customer_survey":{"main_title":"Indagini sulla soddisfazione","subtitle":"Aiutaci a migliorare i nostri servizi","let_a_message":"Per messaggiare?","satisfaction":"Soddisfazione","dropdown_title":"Stato di ritorno","notes":"Giudizi","observation":"Un\'osservazione?","message":"Messaggio","send":"Inviare","contact_title":"Contatto","error_fields":"Si prega di compilare i campi richiesti","desc_contact":"Lasciaci un messaggio!"},"snackbar_message":{"add":"Il prodotto è stato aggiunto a","delete":"Il prodotto è stato rimosso da","remove":"Un prodotto è stato rimosso da","add_multiple":"I prodotti sono stati aggiunti","limit":"Hai raggiunto il numero massimo di prodotti in un abbonamento","rental_range_selected_is_blocked":"Il periodo di noleggio selezionato non è disponibile. Si prega di scegliere un altro periodo di noleggio.","cart":"Il tuo carrello","max":"Non ci sono più scorte su questo prodotto per la quantità scelta","add_tryout":"Il prodotto è stato aggiunto per il montaggio","profilUpdated":"Le tue informazioni sono state aggiornate con successo"},"instore":{"modale_title":"Scegli il tuo negozio","modale_shop_name":"Nome del negozio","modale_informations":"Informazione","modale_choose_shop":"Scegli un negozio","modale_details":"Dettagli del contatto","modale_choose_button":"Scegliere","modale_address":"Indirizzo:","modale_phone":"Telefono:","change_store_title":"Cambia negozio","change_store_paragraph":"Fai attenzione, stai per cambiare negozio. Se hai articoli nel tuo carrello, il tuo carrello andrà perso.","cancel_button":"per cancellare","change_store_button":"Cambia negozio","header_change_store":"Cambia negozio","product_not_available":"Prodotto non disponibile in questo negozio","paragraph":"Puoi scegliere un altro negozio per verificarne la disponibilità. Dovrai ritirare il tuo ordine nel nuovo negozio selezionato. Questo avrà l\'effetto di svuotare il tuo carrello corrente.","change_store_cta":"Cambia negozio","no_store_available":"Nessun negozio disponibile per questo codice postale","search_input_placeholder":"Esempio: 33","search_input_label":"Immettere l\'inizio di un codice postale","search":"Ricercare","appointments_page_title":"Desideri fissare un appuntamento per:","appointment_page_pickup_link_label":"Un ritiro nei negozi","appointment_page_return_link_label":"Un ritorno in negozio","account_page_return_link_label":"Ritorna al tuo negozio","pack_not_available":"Confezione Non disponibile in questo negozio"},"pack_single":{"choose":"Aggiungi il pacco al carrello","sold_out":"Confezione non disponibile","pack_content_title":"Articoli inclusi in questo pacchetto:"},"takeBack":{"title":"Vendi un oggetto","meta_title":"Programma di ritiro dell\'oggetto","required_field":"* Campi richiesti","text":"Compila il nostro modulo per ricevere la tua offerta di acquisto. Una domanda sul funzionamento?","step_1":"Tuo oggetto","step_2":"La nostra offerta","step_3":"Conferma","step_edit_parcel_number":"Modifica il numero di pacchi","parcel_number_label":"Quanti pacchi vuoi inviare?","positive_response_to_preliminary_questions":"sì","negative_response_to_preliminary_questions":"Boo","condition_question":"Buone condizioni?","error_message":"Purtroppo non accettiamo questo tipo di articolo","next_step_button":"Passo successivo","reference_number_label":"Articolo di riferimento","reference_number_placeholder":"Riferimento presente in etichetta","reference_number_link":"Dove trovare il riferimento del mio articolo","reference_number_text":"Troverai il riferimento nel luogo indicato nell\'immagine","select":"Seleziona un valore","close_modal":"Chiudere","waiting_price_text":"Stimiamo il prezzo di vendita del tuo articolo. Attendere prego.","offer_announcement_text":"Tenendo conto delle informazioni fornite, siamo lieti di proporvi un\'offerta di ritiro pari a:","price_explication":"* Questo importo sarà definitivo dopo la verifica dell\'articolo da parte dei nostri team.","accept_offer_button":"Accetta la nostra offerta","login_text":"Devi essere loggato per ricevere la nostra offerta","register_text":"Devi creare un account per ricevere la nostra offerta","confirmation_text":"Congratulazioni!.\\nL\'offerta di prezzo ti è stata inviata via e-mail! ","take_back_location_title":"Scegli il sito dove applicare il recupero:","take_back_country_title":"In quale Paese vorresti utilizzare il tuo voucher?","reference_check_button":"Ricercare","reference_error":"Riferimento errato","take_back_menu":"Rivendere","state_title":"Stato","state_1":"Perfetto","state_2":"Ottime condizioni","state_3":"Buone condizioni","previous_step":"Passo precedente","select_label_size":"Formato","select_label_state":"Stato","refused_state":"Non incluso","faq_title":"Domande frequenti","reference":"Riferimento","add_product":"Aggiungi articolo","confirmation_title":"Grazie!","address_check_required":"Controlla il tuo indirizzo di consegna","confirm_address_button":"Conferma l\'indirizzo","voucher_printing_button":"Stampa la nota di spedizione","your_order_confirmation":"Il tuo numero d\'ordine","label":"Etichetta","states_explanation_link":"Come scegliere lo stato?","item":"Oggetto numero.","question_title":"In che condizioni è la tua stanza?","take_back_location_desc":"​Scegli ora il tipo di voucher che desideri ricevere. Attenzione, una volta scelto non potrai modificare il tipo di voucher desiderato.​​","step_2_error":"Si è verificato un errore durante l\'elaborazione della richiesta. Riprova","total":"Totale","status_label":"Stato","accepted_status":"Accettato","refused_status":"Rifiutare","in_progress_status":"In corso","command":"Acquisizione n.","price_start":"prezzo_inizio","tab_label_secondhand":"tab_label_secondhand","tab_label_rental":"tab_label_noleggio","state_label":"etichetta_stato","second_hand_label":"etichetta_di_seconda_mano","original_price":"Prezzo originale","take_back_command":"take_back_command","take_back_description":"take_back_description"},"search_page":{"title":"Risultati della ricerca per : {{ search }} ({{ length }})"},"wishlist":{"title":"La mia lista dei desideri","empty":"La tua lista dei desideri è vuota","button":"Aggiungi alla lista dei desideri"},"size_guide_page":{"span_title":"Guida alle taglie","size_guide":"🎀 Guida alle taglie","question":"Sapevi che 9 donne su 10 non conoscono la loro vera taglia di reggiseno? Scopri finalmente la tua grazie al nostro calcolatore semplice e preciso. Per tutti i nostri modelli senza ferretto e per gli slip, ti consigliamo di scegliere la tua solita taglia.","measure_your_back_circumference":"1. Misura sotto il seno","not_tight":"Non stretto","slightly_tight":"Leggermente stretto","very_tight":"Molto stretto","measure_your_bust":"2. Misura il busto","standing_up_straight":"In piedi dritta","leaning_forward":"Piegata in avanti","lying_on_your_back":"Sdraiata sulla schiena","calculate_size":"Calcola la mia taglia","error_size_not_found":"Taglia non trovata per queste misure","bra_size":"La tua taglia di reggiseno è "},"reservations":{"title":"Le mie prenotazioni","header_tooltip":"Le mie prenotazioni","info_banner":"I prodotti vengono rimessi in vendita automaticamente alla scadenza.","empty_text":"Non hai prenotazioni attive.","cta_shop":"Vedi i prodotti","product_label":"Prodotto","expires_on":"Scade il","buy_now":"Acquista ora","release":"Rilascia prenotazione","reserve_cta":"Prenota {{days}} giorni lavorativi","confirm_title":"Conferma prenotazione","confirm_body":"Stai per prenotare questo prodotto per {{days}} giorni lavorativi. Non sarà più disponibile per gli altri clienti.","confirm_expiration":"Data di scadenza","confirm_cta":"Conferma prenotazione","confirm_cancel":"Annulla","confirm_error":"Si è verificato un errore. Riprova più tardi.","confirm_error_conflict":"Questo prodotto è già stato riservato","reservations_product_already_reserved":"Questo prodotto è riservato per te, trovalo in Le Mie Prenotazioni"},"cancel_contract":{"button_label":"Annulla il mio contratto","title":"Recesso / annullamento","intro":"Desideri annullare il tuo ordine o restituire un prodotto? Compila questo modulo e il nostro team gestirà la tua richiesta.","type_label":"La tua richiesta","type_cancellation":"Annulla il mio ordine","type_return":"Restituire un prodotto","order_reference_label":"Numero d\'ordine","email_label":"Email","message_label":"Messaggio (facoltativo)","submit_button":"Invia la mia richiesta","required_fields":"* Campi obbligatori","error_order_reference":"Inserisci il tuo numero d\'ordine.","error_email":"Inserisci un indirizzo email valido.","error_generic":"Si è verificato un errore. Controlla i tuoi dati e riprova.","success_title":"La tua richiesta è stata presa in carico","success_message":"Riceverai un\'email di conferma. Il nostro team ti ricontatterà a breve.","close_button":"Chiudi"}}');

/***/ }),

/***/ 49441:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"404":{"title":"404 - Page not found","cta":"Back to home page"},"account":{"herotitle":"Mijn account","title_login":"Toegang tot mijn account","subtitle":"Log in met uw e-mailadres","successfull_register":"Gefeliciteerd! Uw account is aangemaakt, u ontvangt een validatie-e-mail.","login_email":"E-mail","login_password":"Wachtwoord","forget_password_link":"Uw wachtwoord vergeten ?","guest_link":"Ga verder als gast","error_login":"Uw e-mailadres of wachtwoord komt niet overeen. Probeer het opnieuw","login_button":"herkennen","login_to_see_price":"Log in om onze prijzen te bekijken en te bestellen","register_link":"Geen account? Registreer nu","title":"Registreer nu","login_title":"ID\'s","firstname":"Voornaam","lastname":"Achternaam","email":"E-mail","phone":"Telefoon","vatnumber":"BTW nummer","company":"Bedrijf","password":"Wachtwoord","repeat_password":"herhaal wachtwoord","address_required":"voer een afleveradres in","address_title":"Adres","address":"Adres","postal_code":"Postcode","country":"Land","town":"stad","register_button":"Maak mijn account aan en ga verder","login_link":"Heeft u al een account? Inloggen","password_error":"Uw wachtwoorden zijn niet hetzelfde","title_data":"Blijf kalm","text_data":"Uw gegevens zijn beschermd","forget_title":"Uw wachtwoord vergeten","forget_subtitle":"U ontvangt een e-mail om een nieuw wachtwoord aan te maken","button_recup":"Stuur een email","to_login_link":"Retour verbinding","button_continue_as":"Ga verder als","disconnect_button":"Afmelden","guest_link1":"Ga verder als gast","info_link":"mijn informatie","hi":"Hallo","paragraph1":"Vind hier uw dashboard. U kunt uw huidige bestellingen volgen en de retourzending van ontvangen bestellingen beheren.","log_out_button":"Afmelden","block_title":"Veel Gestelde Vragen","date":"Komt op","leasing_date_from":"Verhuur van","leasing_date_to":"tot","return":"Om terug te keren naar een eerder relaispunt","returned_at":"Afgeleverd op ","command":"Bestelnr.","manage_shippment":"Beheer mijn levering","manage_shippment_sentence":"Om uw bestelling te volgen, te wijzigen of te annuleren","follow_my_package":"Volg mijn pakket","no_command":"Momenteel geen bestellingen!","go_to_shop":"Ga naar winkel","back_link":"Terugkomen","title_information":"Mijn data","cancel_subscription":"Abonnement annuleren","your_infos":"Uw gegevens","modification_successfull":"Uw gegevens zijn gewijzigd","error_happend":"Er is een fout opgetreden. Probeer het opnieuw!","mail_used":"Dit e-mail adres is al in gebruik","error_disabled":"je account is niet geactiveerd","info_button":"Verander mijn gegevens","password_modif_succes":"wachtwoord succesvol veranderd","password_button":"verander mijn wachtwoord","adress_title":"uw bezorgadres","address_button":"Verander mijn adres","link_name":"Hoe het werkt?","slides_title":"Mijn terugkeer in drie stappen","verify_title":"Accountverificatie wordt uitgevoerd","confirm_account":{"title":"Uw account is gevalideerd","cta_shop":"Huur nu","cta_account":"Bekijk mijn account","error":"Fout, omleiding naar receptie"},"password_reset":{"title":"Update uw wachtwoord","description":"Vul het formulier in met uw nieuwe wachtwoord.","error":"Fout. Het verzoek is mislukt","success":"Er is rekening gehouden met uw wachtwoordwijziging, u wordt doorgestuurd naar de inlogpagina."},"newsletter":"Schrijf je in op de nieuwsbrief","email_send":"Email verzonden","continue":"ga door","text":"tekst","actual_password":"actual_password","new_password":"nieuw paswoord","error_phone":"error_phone","next":"De volgende","cancelled":"Geannuleerde bestelling","desc_info":"* Door uw e-mailadres in te voeren, gaat u akkoord met het ontvangen van ons nieuws, onze commerciële aanbiedingen en uitnodigingen voor onze privéverkopen en accepteert u ons privacybeleid.","email_not_send":"Het e-mailadres staat niet in de database. Probeer het met een ander e-mailadres.","address_button_create":"Mijn afleveradres toevoegen","warning":{"text":"Let op, u heeft geen geregistreerd adres, geef een adres op in uw gegevens","cta":"Mijn adres toevoegen"},"street_number":"Nr.","search_address":{"helper_add":"Om uw afleveradres toe te voegen, voert u uw adres in het onderstaande veld in.","helper_change":"Om je afleveradres te wijzigen, vul je je adres in het onderstaande veld in."},"password_strength_error":"Uw wachtwoord moet het volgende bevatten: minimaal 10 tekens, één hoofdletter, één kleine letter, één speciaal teken en één cijfer.","address_details":"Extra adres (gebouw, verdieping, code etc.)","address_area":"Gebied","confirm_return":{"title":"Er is rekening gehouden met uw productretour","cta_shop":"Huur nu","cta_account":"Bekijk mijn account","error":"Fout, doorverwijzen naar mijn account","rdv":"afspraak"},"review_placeholder":"Kies een antwoord uit de lijst","register_disable":"Het spijt ons, registratie voor onze verhuurservice is niet langer beschikbaar.","cancel_order":{"cta_modal":"Meine Bestellung stornieren\\n","modal_title":"Annuleer mijn bestelling","modal_warn":"Weet je zeker dat je de bestelling wilt annuleren?","modal_cta":"annuleren"},"buy":"kopen","payment_method":{"title":"Betaalmiddelen","subtitle":"Geregistreerde betaalmethode:","card":"Kaart ","ending_by":"eindigend met ","cta_replace":"Betaalmethode vervangen","modal_title":"Betaalmethode vervangen","modal_description":"Houd er rekening mee dat door uw betalingsmethode te wijzigen, u uw vorige betalingsmethode verwijdert.","modal_cta":"Vervangen","modal_error":"Technische fout. Probeer het later opnieuw.","modal_success":"Uw betaalmethode is gewijzigd"},"dkt_login":"Met je Decathlon-account","information_validation":{"main_title":"Je account is aangemaakt !","subtitle":"Verificatie van informatie","description":"Als onderdeel van het gebruik van onze verhuursite hebben we de volgende informatie nodig: ","confirmation_button":"Valideer mijn gegevens"},"sso_login":{"dkt":"Met je Decathlon-account","cultura":"Met je Cultura-account","ciam":"Met Azure AD CIAM"},"external_account_text":"Mijn gegevens op mijn klantaccount wijzigen","take_back_date":"Datum","order_list_title":"Mijn bestellingen","take_back_list_title":"Mijn covers","order_details_generate":"Retouretiket genereren","order_details_download":"Klik hier om uw retouretiket te downloaden","return_label_unavailable":"Uw retouretiket is nog niet beschikbaar. Het wordt beschikbaar zodra uw bestelling is verzonden.","wish_list_link":"Mijn wenslijst","returning_reason_label":"Retourreden","returning_reason_placeholder":"Selecteer een retourreden","returning_reason_comment_label":"Aanvullende opmerking","returning_reason_comment_placeholder":"Geef aanvullende details over uw retourreden"},"orders":{"error":"Er is een fout opgetreden. Probeer het opnieuw!","confirm_return":{"title":"Wilt u echt een retourbon voor uw selectie genereren?","cta":"Genereer retourbon","cancel":"Annuleren","reason":"Retourreden","reason_placeholder":"Voer de retourreden in"}},"banner":{"text":"Covid-19: We garanderen een regelmatige reiniging en desinfectie van alle producten"},"basket":{"kit_price":"Uw kit","duration":"Uw abonnement","for_short":"voor","assurance":"Verzekering","free":"Vrije","reduction":"levering","total":"TOTAAL","delete_basket":"Verwijder de mand","continue":"doorgaan","product":"Lidwoord","return_date":"Retourdatum","whenever_you_want":"Wanneer je wilt","sub_engagement":"Een maandverplichting","current_subscription":"Mijn huidige abonnement","check_on_account":"Zie op mijn rekening","to_pay_this_month":"Om deze maand te betalen","newarticles":"Voor uw nieuwe artikelen van","to":"Bij","error_stock":"Een product is niet meer in voldoende hoeveelheid beschikbaar","shipping":"Levering","products":"producten","error_basket":"Uw huidige abonnement en het aantal geselecteerde producten staan niet toe dat u uw bestelling voortzet","total_without_shipping":"Totaal zonder levering","total_weight":"Totaal gewicht","try_out":"Fitting","error_tryout":"Je moet minstens zoveel kamers te huur hebben als er kamers zijn om te proberen","total_with_subscription":"Totaal","total_without_subscription":"Totaal","showDetails":"Leveringsdetails bekijken","hideDetails":"Verberg details van levering","rentTotal":"Verhuur","buyTotal":"aankoop","months":"maanden","withoutShipping":"(exclusief bezorging)","engagement":"Abonnement zonder verplichting.","debit":"Eind van de maand opgehaald.","continue_shop":"Blijf winkelen","empty":"Jouw mandje is leeg","drawer":{"title":"Winkelmand","close":"Sluiten"},"reduction_text_explication":"reduction_text_explanation","gift_card_text":"gift_card_text","gift_card_explanation":"gift_card_explanation","deposit":"Deposit","deposit_explanation":"The amount will be refunded after the products are returned","remainingInStock":"Resterend in voorraad: {{count}}","b2b_shipping_costs_link":"Verzendkosten per hoeveelheid","total_without_shipping_excl_vat":"Totaal HT","delivery_fees_excl_vat":"Verzendkosten HT","vat":"BTW"},"confirmation":{"email":"E-mail","text":"Covid-19: We garanderen een regelmatige reiniging en desinfectie van alle producten","title_complements":"Blijf ontdekken","desc_complements":"Met deze kortingscode!","codetext":"Geniet van 5% korting op deze producten met de code","codename":"LIZEECODE","title":"Overzicht van de bestelling","articles_return":"Artikelen die ik moet retourneren","generate_vouchers":"Genereer het retourformulier","articles_to_send":"De items die ik rond de","account_cta":"toegang tot mijn account","to_return":"terugbrengen","order_number":"bestelnummer"},"emails":{"browser_link":"Open deze e-mail in de browser","signature":"John Doe,\\nvan het verhuurteam van het merk Lizee","bottom_section_title":"Uw terugkeer","bottom_section_content":"Hoe organiseer je je retourzending? het is gemakkelijk, volg de gids.","footer":"De Brand-teams wensen u een fijne dag!","copyright":"In overeenstemming met de wet \\"Informatique et Libertés\\" van 6 januari 1978, kunt u op elk moment vragen om toegang te krijgen tot uw persoonlijke informatie, deze te corrigeren of te verwijderen of u te verzetten tegen de behandeling ervan door Brand.\\nDeze e-mail is een ontvangstbevestiging van uw bestelling en bevestigt het huurcontract. Binnenkort ontvangt u een e-mail ter bevestiging van de editie van uw artikelen.","order_confirm_title":"Bedankt voor je bestelling!","order_confirm_main_text":"We hebben uw bestelling nr. XXXXXX ontvangen. Het wordt zo snel mogelijk verzonden en komt aan op een afhaalpunt / bij u thuis of bij u thuis, afhankelijk van de gekozen bezorgmethode.","order_confirm_cta_text":"Volg ons!","order_summary_title":"overzicht van de bestelling","order_id_text":"Ordernummer:","order_start_subscription_date":"Startdatum abonnement","order_renting_start":"Startdatum verhuur","order_renting_end":"Retourdatum","order_renting_duration":"Locatie duur","order_shipping":"Bezorgadres:","order_shipping_method":"Levering aan huis","order_products":"Productenlijst","order_paid_text":"Betaald","order_tax_text":"Inclusief 20% BTW","order_pay_method":"Betalingsmiddel","order_pay_method_desc":"Creditcard die eindigt op"},"faq":{"subtitle":"Log in met mijn e-mailadres","title":"Registreer nu"},"funnel":{"email":"E-mail","phone":"Telefoon","address":"Adres","postal_code":"Postcode","country":"Land","free":"Vrije","return_button":"Terugkomen","delivery_title":"1. Levering","delivery_description":"U ontvangt uw pakket X dagen van tevoren. ","delivered_on":"Afgeleverd op ","return_before":"Om eerder terug te komen","return_title":"2. Keer terug","home_delivery":"Levering aan huis","change_my_address":"Verander mijn adres","shop_delivery":"Levering aan het pakketpunt","choose":"Kiezen","next1":"De volgende","titleform":"Voer uw betalingsgegevens in","pay":"Betalen","first_name":"Voornaam","last_name":"Achternaam","city":"stad","next":"De volgende","create_account_link":"Account aanmaken","continue_with_account":"Ga verder met het account","information":"Informatie","shipping":"Levering","step":"stap","coupon_title":"Heb je een promotie code?","coupon_cta":"Van toepassing zijn","coupon_applied":"Deze promotiecode wordt toegepast:","coupon_success":"Deze promotiecode is geldig","coupon_error":"Heb je een promotie code?","no_shipping_available":"no_shipping_available","payment":{"title":"titel","success":"succes","progress":"vooruitgang","cgu":"cgu","retractation_agreement":"Ik erken uitdrukkelijk dat ik afstand doe van mijn herroepingsrecht aangezien mijn huur begint vóór het verstrijken van de herroepingstermijn van 14 dagen.","custom_cgu_link":"Toegang tot CGL\'s","payment_accordion":{"card_title":"Veilige betaling met creditcard","card_tagline":"Betaling verzekerd door Stripe™. Geaccepteerde kaarten","paypal_title":"Paypal"},"caution_info":"Voordat u verdergaat met de betaling, moet u de borg voor uw artikelen betalen.","caution_explanation":"Deze borg wordt terugbetaald na terugkeer van de producten in goede staat.","caution_button":"Borg betalen","pay_caution":"Borg betalen","caution_paid":"Borg succesvol betaald! U kunt nu doorgaan met de betaling.","caution_expired":"De borg is verlopen. Maak een nieuwe borg aan.","caution_error":"Er is een fout opgetreden bij het verwerken van de borg.","caution_creation_error":"Kan geen borg aanmaken. Probeer het opnieuw.","caution_token_mismatch":"Ongeldige borg voor deze bestelling. Probeer het opnieuw.","processing_caution":"Borg wordt verwerkt...","swikly_deposit_description":"Veiligheidsborg voor gehuurde artikelen","errors":{"stock":"Een product in uw winkelwagen is niet langer beschikbaar","stock_error_intro":"De volgende producten zijn niet meer beschikbaar in voldoende hoeveelheid:","stock_error_footer":"Werk uw winkelwagen bij voordat u verdergaat met de betaling.","availability_check_failed":"De beschikbaarheidscontrole is om technische redenen mislukt. Probeer het over een ogenblik opnieuw.","default":"De kaart is om onbekende reden geweigerd. Neem contact op met de kaartuitgever voor meer informatie","expired_card":"De creditcard is verlopen. U moet een andere betaalmethode gebruiken.","email":"Ongeldig e-mailadres.","insufficient_funds":"De creditcard heeft onvoldoende saldo om de aankoop te doen. U moet een andere betaalmethode gebruiken.","lost_card":"De betaling werd geweigerd omdat de creditcard als verloren werd verklaard. Neem contact op met de kaartuitgever voor meer informatie","stolen_card":"De betaling werd geweigerd omdat de creditcard als gestolen was opgegeven. Neem contact op met de kaartuitgever voor meer informatie","incorrect_cvc":"De CVC-code is onjuist. U moet het opnieuw proberen met de juiste CVC.","processing_error":"Er is een fout opgetreden tijdens het verwerken van de creditcard. U moet de betaling opnieuw proberen. Als het nog steeds niet kan worden behandeld, probeer het dan later opnieuw.","code_operator_label":"Voer uw validatiecode in","code_operator_placeholder":"Bijv.: 12345","operator_button_validation":"bevestig je bestelling","wrong_code_operator":"de ingevoerde code is niet geldig"},"error":"er is een fout opgetreden"},"invalid_tel":"Geef een geldig telefoonnummer","coupon_label":"Promotiecode","your_rental_from":"Uw huur van","your_rental_to":"tot","show_cart":"Toon winkelwagen","hide_cart":"Winkelwagen verbergen","toBeDetermined":"Nog te bepalen"},"general":{"home":"Huis","selection":"Alle selectie","return":"Om terug te keren naar een eerder relaispunt","baseline":"Verhuur. Redden. Genieten","footer_tagline":"Van verkoop tot verhuur","footer_top_baseline":"Schadeverzekering is inbegrepen","footer_top_link_label":"Bekijk alle producten","contact_us_button":"Neem contact op","cgl":"Algemene huurvoorwaarden","policy":"Privacybeleid","small_text_under_calendar":"Hoe meer u huurt, hoe minder u betaalt!","start_button":"Begin","confirm_button":"Bevestigen","delivered":"Geleverd op of eerder","meta_description":"Hier is de meta desc","meta_title":"Hier is een titel","meta_url":"http://whitelabel.lizee.io/","you_save":"Jij spaart","my_account":"mijn account","FAQ":"FAQ","add_a_title":"het is een titel","add_a_description":"dit is een omschrijving","add_a_subtitle":"dit is een ondertitel","add_a_text":"Voeg tekst toe","from":"Van","month":"maand","day":"dag","stock_texts":{"few_products_left":"Meer dan een paar producten!","back_soon":"Snel terug","in_stock":"Op voorraad"},"search_address":{"cta":"Zoeken","incomplete":"Het ingevulde adres is niet compleet. Geef uw adres op met een straat, een stad en een postcode.","no_results":"Geen adres gevonden in onze database. Voer een ander adres in.","excluded":"Levering wordt niet ondersteund voor dit adres.","invalid_country":"Levering wordt niet ondersteund voor dit land.","label":"Vind je afleveradres","same_address":"Aflever- en facturatieadressen zijn hetzelfde","label_billing":"Vind je facturatieadres","placeholder":"Voorbeeld: 15 rue de milan Paris","change_delivery_point":"Bewerken","postcode_missing":"Voer een postcode in"},"search_bar":{"input_label":"Zoeken naar een product","input_placeholder":"Zoeken naar een product","button_label":"Zoeken naar een product"},"previous_button":"vorig","sizes":"Maten","month_short":"maand_kort","day_short":"day_short","copyright":"auteursrechten","card_number":"Kaartnummer","expiry_date":"Vervaldatum","cvc_code":"CVC-code","morning":"Ochtend","afternoon":"Namiddag","evening":"Avond","fullDay":"Hele dag","flex_price_information":"Prijzen gebaseerd op een maand van 30 dagen","month_without_space":"/maand","handle_cookies":"Cookies beheren","days_plural":"dagen","day_singular":"dag","delivery_point":"Resultaten dichtbij: ","menu":{"close":"Dichtbij"},"main_menu":{"item":"Hoofdmenu","subitem":"submenu"},"holder_name":"Eigenaars naam","unit":"/ eenheid","unit_short":"/u","change_language_modal_title":"Taal wijzigen","change_language_modal_text":"Pas op, u staat op het punt om van taal te veranderen. Als u artikelen in uw winkelwagen heeft, is uw winkelwagen verloren.","change_language_modal_cancel_text":"annuleren","change_language_modal_validation_text":"Taal wijzigen","vat":{"included":"incl. btw","excluded":"ex. btw"}},"homepage":{"maintitle":"Verhuur. Redden. Genieten. ","descriptiontext":"Huur onze producten op aanvraag. ","cta_pack_label":"Bekijk de pakketten","titlehowitworks":"Hoe het werkt ?","deschowitworks1":"Boek je kit online en ontvang hem thuis of bij een ophaalpunt naar keuze in Frankrijk. Het pakket is 2 dagen voor vertrek beschikbaar en je hebt 2 dagen om het terug te brengen na het einde van je trektocht. ","deschowitworks2":"Bonus?\\nJe kunt je uitrusting terugbrengen vanaf je trekkinglocatie. Gebruik uw retouretiket dat bij uw pakket is inbegrepen en geef uw pakket af bij elk Chronopost-afhaalpunt op het vasteland van Frankrijk. / U kunt uw uitrusting terugbrengen vanaf uw wandellocatie. Het retouretiket is bij uw pakket inbegrepen en u kunt uw kit op elk Chronopost-punt in Frankrijk afgeven. ","titletestimonials":"Ze hebben het geprobeerd ","section_title_savings":"Hoe langer u huurt, hoe minder u betaalt: ","link_label_savings":"Begin met huren","start_savings_text":"U huurt voor","end_savings_text":"jij spaart","buy_savings_text":"Als je koopt","rent_savings_text":"Als u huurt","saving_mentions":"* Bedrag gebaseerd op de gemiddelde prijzen van onze producten","featured_product_title":"Een voorbeeld met ons favoriete product:","featured_product_name":"Groene en blauwe 20L rugzak","featured_product_link_label":"Ontdek opties","title_commitment":"Wist je dat ?","description_commitment":"Uw keuze heeft een positieve impact op de planeet: huren bij Lizee bespaart gemiddeld 350g CO2 per product!","section_title_community":"Uw besparing met de verhuur:","title_community":"Onze huurdersklanten hebben al bespaard: ","amount_community":"€ 35.000","subtitle_universe1":"Titel van taxaproducten","paragraph_universe1":"Desc voor taxapakketten","subtitle_universe2":"Titel van taxapakketten","paragraph_universe2":"Desc voor taxapakketten","categorie":"Sylius Taxon","rent":"Alquilar","partner":"partner"},"instagramwall":{"title":"Registreer nu","desc":"Deel uw herinneringen met #Lizee ","buttontext":"Volg ons !"},"packs":{"from":"Van","month":"maand","buttontext":"Volg ons !","header_title":"Verpakkingen","herotitle":"Ontdek onze packs ","titlepacks":"Packs voor jou ontworpen","packsparagraph":"Kies uit de onderstaande pakketten of maak je eigen pakket! ","shipping_description":"Gratis thuisbezorgd bij bestellingen van € 30 of meer!","pack_to_shop_button":"Creëer je pakket","fake_pack_title":"Creëer je eigen pakket","fake_pack_button":"Bekijk meer producten","select":"selecteren","title_size_modale":"Selecteer de maat om deze aan je winkelmandje toe te voegen:","victim_of_success":"Slachtoffer van zijn eigen succes","link_to_single":"Zie het pakket"},"page":{"title":"Titelpagina","content":"Inhoudsopgave. Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti animi iure iusto ex explicabo aspernatur commodi voluptatum, laudantium voluptatem corporis."},"sso":{"errors":{"41000083":"The account used is not a professional account.","default":"An unexpected error occurred."}},"privacy":{"title":"Registreer nu","wysiwyg":"Laatst bijgewerkt: 12 maart 2020\\n","showCookie":"Cookies beheren"},"products_to_buy":{"products_category":"Producten om te kopen","buy_button":"kopen","see_more":"Meer informatie gebruiksaanwijzing"},"rental_terms":{"title":"Registreer nu","wysiwyg":"Laatst bijgewerkt: 12 maart 2020\\n"},"shop":{"choose":"Kiezen","header_title":"Verpakkingen","herotitle":"Ontdek onze packs ","title_size_modale":"Selecteer de maat om deze aan je winkelmandje toe te voegen:","victim_of_success":"Slachtoffer van zijn eigen succes","titleshop":"Huur bij de beste selectie","shopdescription":"Kies je favorieten! ","shippingdescription":"Gratis thuisbezorgd bij bestellingen van € 30 of meer!","shop_to_packs_button":"Bekijk de pakketten","filter":"Filters","filter_by_taxons":"Filter op categorieën","filter_apply":"Filters toepassen","availableOnly":"Bekijk alleen beschikbare producten","classic_sub":{"our_rates":"Onze schaalbare pakketten","adjustable_rate":"Uw pakket past zich aan uw keuze aan.","articles":"Lidwoord","maximum":"maximun","article":"artikel"},"filters":"filters","pack_size_modal_cta_add":"Toevoegen aan mandje","pack_size_modal_cta_return":"Terug naar de pakjes","filters_dropdown_label":"kies","max_item_in_cart":"Maximaal product per mand bereikt","prev":"vorig","next":"Volgend op","no_stock_available":"Geen producten beschikbaar in deze categorie.","search_not_found":"Geen producten gevonden","filters_modale_title":"filters_modale_title","autocomplete_search_placeholder":"Zoek {{attributeName}}...","autocomplete_no_results":"Geen resultaten gevonden","autocomplete_no_values":"Geen waarden beschikbaar","autocomplete_loading":"Laden...","autocomplete_load_more":"Meer laden","close_button":"close_button","categories_title":"categorieën_titel","apply_button":"toepassen_knop","accordion_shop_title":"accordeon_shop_title","and":"en","price_min_label":"Min","price_max_label":"Max","sort":"Sorteren","filter_and_sort":"Filteren & sorteren","filter_title_in_drawer":"Filteren","sort_by_price_asc":"Prijs oplopend","sort_by_price_desc":"Prijs aflopend","sort_by_date_asc":"Oudste eerst","sort_by_date_desc":"Nieuwste eerst","error_loading_products":"Er is een fout opgetreden bij het laden van de producten. Probeer het later opnieuw.","shipping_costs":{"number_of_articles":"Aantal artikelen","round_trip_cost":"Heen- en terugreis kosten","title":"Verzendkosten in het slechtste geval (Incl. Verzekering)"}},"single_product":{"choose_button":"Kiezen","associations_title":"Dit zal je misschien ook interesseren:","try_out_button":"Proberen voor:","try_out_tooltip":"Je kunt maar één kamer per gehuurde kamer proberen","buy_button":"Kopen","choose_button_tooltip":"Selecteer een maat om toe te voegen aan winkelwagen","display_total_rental_price":"totale huurprijs","availability_checker":{"modal_close":"sluiten","text":"Dit artikel is niet beschikbaar op deze data.","link":"Beschikbaarheid bekijken","modal_title":"Beschikbaarheid controleren","modal_description":"Het artikel is niet beschikbaar als de data zijn doorgestreept"}},"statements":{"bottom_sentence":"Hoe meer u reist, hoe meer u bespaart!","link":"Meer informatie"},"subscription_order":{"change_cta":"Bewerken","cancel_cta":"Annuleren","rate":"Vast bedrag","handle_return_cta":"Beheer de retourzending van mijn artikelen","my_subscription":"Mijn abonnement:","taken_every":"Elke genomen","of_the_month":"van de maand","per_month":"Per maand","articles_max":"max items","select_all_and_stop":"Selecteer alles en stop mijn abonnement","generate_the_return_slip":"Genereer het retourformulier","continue":"doorgaan","size":"Knippen:","month":"maand","bottom_sentence":"Aan het einde van de bestelling is een retourbon beschikbaar. Alles over retouren","funnel":{"current_subscription":" , je hebt al een lopend abonnement.","subtitle":"U kunt uw oude items retourneren om uw abonnement aan te passen. Als u uw items wilt behouden, gaat u naar de volgende stap.","skip_step":"sla deze stap over"},"returned_product_title":"Producten geretourneerd deze maand","returned_product_desc":"Deze producten zijn ontvangen en worden bij uw volgende betaling permanent uit uw ruimte verwijderd.","canceled_order_title":"Geannuleerde bestellingen","canceled_order_desc":"cancel_order_desc","refunded_order_title":"Terugbetaalde bestellingen","refunded_order_desc":"refunded_order_desc","sub_finished":{"title":"Abonnement beëindigd!","desc":"We vinden het jammer je te zien gaan. Zodra de artikelen zijn geretourneerd, wordt uw laatste afschrijving voor de huidige maand naar rato berekend."},"returned_date":"Geretourneerd op","link_download_return":"Klik hier om uw retourbon te downloaden","invoice_this_month":"Uw rekening deze maand:","invoice_explanation":"We berekenen het bedrag dat elke maand wordt gefactureerd volgens het pro-rata van de gehuurde en geretourneerde producten in de lopende maand","subscription_start_date":"Je abonnement gaat in op:","subscription_date_explanation":"Je abonnement begint 5 dagen na de datum van je eerste bestelling. Deze datum houdt rekening met de voorbereidingstijden van uw bestelling en de levertijden.\\n Vanaf de start van het abonnement wordt u maandelijks gefactureerd, op de verjaardagsdatum. De productretourservice is beschikbaar nadat u uw abonnement hebt gestart.","bought_product_title":"Gekochte producten:","bought_product_desc":"gekocht_product_desc","product_not_eligible_for_return":"Product komt niet in aanmerking voor retournering","tooltip_product_not_eligible_for_return":"Retourneren mogelijk vanaf de datum van inschrijving"},"customer_survey":{"main_title":"Tevredenheidsonderzoek","subtitle":"Help ons onze diensten te verbeteren","let_a_message":"Een bericht ?","satisfaction":"Tevredenheid","dropdown_title":"Return staat","notes":"Opmerkingen","observation":"Een observatie?","message":"bericht","send":"sturen","contact_title":"Contact Titel","error_fields":"error_fields","desc_contact":"Laat een bericht achter!"},"snackbar_message":{"add":"Het product is toegevoegd aan","delete":"Het product is verwijderd uit","remove":"Eén product werd verwijderd uit","add_multiple":"De producten zijn toegevoegd aan","limit":"U hebt het maximaal aantal producten in uw abonnement bereikt","rental_range_selected_is_blocked":"De geselecteerde huurperiode is niet beschikbaar. Kies alstublieft een andere huurperiode.","cart":"uw mand","max":"Er is geen voorraad meer van dit product voor de gekozen hoeveelheid","add_tryout":"Het product is toegevoegd om te passen","profilUpdated":"Uw informatie is succesvol bijgewerkt"},"instore":{"modale_title":"Kies je winkel","modale_shop_name":"Naam van de winkel","modale_informations":"Informatie","modale_choose_shop":"Kies een winkel","modale_details":"Contact details","modale_choose_button":"Kiezen","modale_address":"Adres :","modale_phone":"Telefoon :","change_store_title":"Van winkel veranderen","change_store_paragraph":"Wees voorzichtig, je staat op het punt om van winkel te veranderen. Als u artikelen in uw winkelwagen heeft, gaat uw winkelwagen verloren.","cancel_button":"annuleren","change_store_button":"Van winkel veranderen","header_change_store":"Van winkel veranderen","product_not_available":"Product niet beschikbaar in deze winkel","paragraph":"U kunt een andere winkel kiezen om de beschikbaarheid te controleren. U dient uw bestelling op te halen in de nieuw geselecteerde winkel. Hierdoor wordt uw huidige winkelmandje leeggemaakt.","change_store_cta":"Van winkel veranderen","no_store_available":"Er is geen winkel beschikbaar voor deze postcode","search_input_placeholder":"Voorbeeld: 33","search_input_label":"Voer het begin van een postcode in","search":"Zoeken","appointments_page_title":"U wilt een afspraak maken voor:","appointment_page_pickup_link_label":"Een opname in winkels","appointment_page_return_link_label":"Een terugkeer naar de winkel","account_page_return_link_label":"Keer terug naar je winkel","pack_not_available":"Pakket Niet beschikbaar in deze winkel"},"pack_single":{"choose":"Pak toevoegen aan winkelwagen","sold_out":"Pakket niet beschikbaar","pack_content_title":"Items in dit pakket:"},"takeBack":{"title":"Verkoop een item","meta_title":"Artikelterugnameprogramma","required_field":"* Verplichte velden","text":"Vul ons formulier in om uw aankoopaanbieding te ontvangen. Een vraag over de bediening?","step_1":"Uw artikel","step_2":"Onze aanbieding","step_3":"Bevestiging","step_edit_parcel_number":"Wijzig het pakketnummer","parcel_number_label":"Hoeveel pakketten wilt u verzenden?","positive_response_to_preliminary_questions":"Ja","negative_response_to_preliminary_questions":"Neen","condition_question":"Goede conditie?","error_message":"Helaas accepteren we dit type artikel niet","next_step_button":"Volgende stap","reference_number_label":"Artikelreferentie","reference_number_placeholder":"Referentie aanwezig op het etiket","reference_number_link":"Waar vind je de referentie van mijn artikel","reference_number_text":"U vindt de referentie op de plaats aangegeven op de afbeelding","select":"Selecteer een waarde","close_modal":"sluiten","waiting_price_text":"Wij schatten de verkoopprijs van uw artikel. Even geduld aub.","offer_announcement_text":"Rekening houdend met de verstrekte informatie, bieden wij u graag een terugnameaanbieding aan ter waarde van:","price_explication":"* Dit bedrag is definitief na verificatie van het artikel door onze teams.","accept_offer_button":"Accepteer ons aanbod","login_text":"U moet ingelogd zijn om onze aanbieding te ontvangen","register_text":"U moet een account aanmaken om onze aanbieding te ontvangen","confirmation_text":"Gefeliciteerd!.\\nDe prijsofferte is per e-mail naar u verzonden! ","take_back_location_title":"Kies de site waar u het herstel wilt toepassen:","take_back_country_title":"In which country would you like to use your voucher?","reference_check_button":"Zoeken","reference_error":"Verkeerde referentie","take_back_menu":"doorverkopen","state_title":"Staat","state_1":"Perfecte staat","state_2":"Heel goede staat","state_3":"Goede conditie","previous_step":"Vorige stap","select_label_size":"Snee","select_label_state":"Staat","refused_state":"Niet inbegrepen","faq_title":"Veel Gestelde Vragen","reference":"Referentie","add_product":"Voeg item toe","confirmation_title":"Bedankt!","address_check_required":"Controleer uw afleveradres","confirm_address_button":"Bevestig het adres","voucher_printing_button":"Print de verzendnota","your_order_confirmation":"Uw bestellingsnummer","label":"Label","states_explanation_link":"Hoe de staat kiezen?","item":"Item nr.","question_title":"Hoe is de staat van je kamer?","take_back_location_desc":"Kies nu het type voucher dat je wilt ontvangen. Let op, eenmaal gekozen kunt u het gewenste type voucher niet meer wijzigen.​​","step_2_error":"Er is een fout opgetreden tijdens het verwerken van het verzoek. Probeer het nog eens","total":"Totaal","status_label":"Toestand","accepted_status":"Geaccepteerd","refused_status":"Weigeren","in_progress_status":"Bezig","command":"Overname nr.","price_start":"prijs_begin","tab_label_secondhand":"tab_label_tweedehands","tab_label_rental":"tab_label_huur","state_label":"staat_label","second_hand_label":"tweedehands_label","original_price":"Originele prijs","take_back_command":"take_back_commando","take_back_description":"take_back_description"},"search_page":{"title":"Zoekresultaat voor : {{ search }} ({{ length }})"},"wishlist":{"title":"Mijn wenslijst","empty":"Uw wenslijst is leeg","button":"Toevoegen aan mijn wenslijst"},"size_guide_page":{"span_title":"Maattabel","size_guide":"🎀 Maattabel","question":"Wist je dat 9 van de 10 vrouwen hun echte bh-maat niet kennen? Ontdek eindelijk die van jou met onze eenvoudige en nauwkeurige calculator. Voor al onze modellen zonder beugel en voor slips adviseren wij je je gebruikelijke maat te kiezen.","measure_your_back_circumference":"1. Meet je onderborstomtrek","not_tight":"Niet strak","slightly_tight":"Licht strak","very_tight":"Erg strak","measure_your_bust":"2. Meet je borstomvang","standing_up_straight":"Rechtop staand","leaning_forward":"Voorover buigend","lying_on_your_back":"Liggend op je rug","calculate_size":"Bereken mijn maat","error_size_not_found":"Geen maat gevonden voor deze metingen","bra_size":"Je bh-maat is "},"reservations":{"title":"Mijn reserveringen","header_tooltip":"Mijn reserveringen","info_banner":"Producten worden automatisch weer te koop aangeboden wanneer de reservering verloopt.","empty_text":"Je hebt geen actieve reserveringen.","cta_shop":"Producten bekijken","product_label":"Product","expires_on":"Verloopt op","buy_now":"Nu kopen","release":"Reservering vrijgeven","reserve_cta":"{{days}} werkdagen reserveren","confirm_title":"Reservering bevestigen","confirm_body":"Je staat op het punt dit product voor {{days}} werkdagen te reserveren. Het zal niet meer beschikbaar zijn voor andere klanten.","confirm_expiration":"Vervaldatum","confirm_cta":"Reservering bevestigen","confirm_cancel":"Annuleren","confirm_error":"Er is een fout opgetreden. Probeer het later opnieuw.","confirm_error_conflict":"Dit product is al gereserveerd","reservations_product_already_reserved":"Dit product is voor u gereserveerd, vind het in Mijn Reserveringen"},"cancel_contract":{"button_label":"Mijn contract opzeggen","title":"Herroeping / annulering","intro":"Wilt u uw bestelling annuleren of een product retourneren? Vul dit formulier in en ons team behandelt uw verzoek.","type_label":"Uw verzoek","type_cancellation":"Mijn bestelling annuleren","type_return":"Een product retourneren","order_reference_label":"Bestelnummer","email_label":"E-mail","message_label":"Bericht (optioneel)","submit_button":"Mijn verzoek versturen","required_fields":"* Verplichte velden","error_order_reference":"Voer uw bestelnummer in.","error_email":"Voer een geldig e-mailadres in.","error_generic":"Er is iets misgegaan. Controleer uw gegevens en probeer het opnieuw.","success_title":"Uw verzoek is ontvangen","success_message":"U ontvangt een bevestigingsmail. Ons team neemt binnenkort contact met u op.","close_button":"Sluiten"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [49774,40179], function() { return __webpack_exec__(76363), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);